webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regex = exports.ref = exports.len = exports.req = exports.withParams = undefined;

var _withParams = __webpack_require__(246);

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.withParams = _withParams2.default;

// "required" core, used in almost every validator to allow empty values

var req = exports.req = function req(value) {
  if (Array.isArray(value)) return !!value.length;
  if (value === undefined || value === null || value === false) {
    return false;
  }

  if (typeof value === 'object') {
    for (var _ in value) {
      return true;
    }return false;
  }

  return !!String(value).length;
};

// get length in type-agnostic way
var len = exports.len = function len(value) {
  if (Array.isArray(value)) return value.length;
  if (typeof value === 'object') {
    return Object.keys(value).length;
  }
  return String(value).length;
};

// resolve referenced value
var ref = exports.ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

// regex based validator template
var regex = exports.regex = function regex(type, expr) {
  return (0, _withParams2.default)({ type: type }, function (value) {
    return !req(value) || expr.test(value);
  });
};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(41)('wks');
var uid = __webpack_require__(28);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(53);
var isBuffer = __webpack_require__(190);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapGetters; });
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["b"] = (index_esm);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(15)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(6);
var ctx = __webpack_require__(23);
var hide = __webpack_require__(12);
var has = __webpack_require__(11);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var createDesc = __webpack_require__(25);
module.exports = __webpack_require__(9) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(56);
var toPrimitive = __webpack_require__(43);
var dP = Object.defineProperty;

exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(57);
var defined = __webpack_require__(35);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(61);
var enumBugKeys = __webpack_require__(37);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(141), __esModule: true };

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(22);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(14).f;
var has = __webpack_require__(11);
var TAG = __webpack_require__(4)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(35);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * @name JavaScript/NodeJS Merge v1.2.1
 * @author yeikos
 * @repository https://github.com/yeikos/js.merge

 * Copyright 2014 yeikos - MIT license
 * https://raw.github.com/yeikos/js.merge/master/LICENSE
 */

;(function(isNode) {

	/**
	 * Merge one or more objects 
	 * @param bool? clone
	 * @param mixed,... arguments
	 * @return object
	 */

	var Public = function(clone) {

		return merge(clone === true, false, arguments);

	}, publicName = 'merge';

	/**
	 * Merge two or more objects recursively 
	 * @param bool? clone
	 * @param mixed,... arguments
	 * @return object
	 */

	Public.recursive = function(clone) {

		return merge(clone === true, true, arguments);

	};

	/**
	 * Clone the input removing any reference
	 * @param mixed input
	 * @return mixed
	 */

	Public.clone = function(input) {

		var output = input,
			type = typeOf(input),
			index, size;

		if (type === 'array') {

			output = [];
			size = input.length;

			for (index=0;index<size;++index)

				output[index] = Public.clone(input[index]);

		} else if (type === 'object') {

			output = {};

			for (index in input)

				output[index] = Public.clone(input[index]);

		}

		return output;

	};

	/**
	 * Merge two objects recursively
	 * @param mixed input
	 * @param mixed extend
	 * @return mixed
	 */

	function merge_recursive(base, extend) {

		if (typeOf(base) !== 'object')

			return extend;

		for (var key in extend) {

			if (typeOf(base[key]) === 'object' && typeOf(extend[key]) === 'object') {

				base[key] = merge_recursive(base[key], extend[key]);

			} else {

				base[key] = extend[key];

			}

		}

		return base;

	}

	/**
	 * Merge two or more objects
	 * @param bool clone
	 * @param bool recursive
	 * @param array argv
	 * @return object
	 */

	function merge(clone, recursive, argv) {

		var result = argv[0],
			size = argv.length;

		if (clone || typeOf(result) !== 'object')

			result = {};

		for (var index=0;index<size;++index) {

			var item = argv[index],

				type = typeOf(item);

			if (type !== 'object') continue;

			for (var key in item) {

				if (key === '__proto__') continue;

				var sitem = clone ? Public.clone(item[key]) : item[key];

				if (recursive) {

					result[key] = merge_recursive(result[key], sitem);

				} else {

					result[key] = sitem;

				}

			}

		}

		return result;

	}

	/**
	 * Get type of variable
	 * @param mixed input
	 * @return string
	 *
	 * @see http://jsperf.com/typeofvar
	 */

	function typeOf(input) {

		return ({}).toString.call(input).slice(8, -1).toLowerCase();

	}

	if (isNode) {

		module.exports = Public;

	} else {

		window[publicName] = Public;

	}

})(typeof module === 'object' && module && typeof module.exports === 'object' && module.exports);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(273)(module)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(202);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        id: { type: String, default: null },
        name: { type: String, required: true },
        label: { type: String, default: null },
        placeholder: { type: String, default: null },
        required: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        errors: { type: [String, Object, Array], default: null }
    },
    data: function data() {
        return {
            masker: false,
            value: null,
            activeKeyCode: 0,
            localErrors: null
        };
    },
    computed: {
        fieldErrors: function fieldErrors() {
            return this.errors || this.localErrors;
        }
    },
    methods: {
        handleInput: function handleInput(event) {
            return this.inputEvent(this.createEvent(event, 'input'));
        },
        handleBlur: function handleBlur(event) {
            return this.blurEvent(this.createEvent(event, 'blur'));
        },
        handleFocus: function handleFocus(event) {
            return this.focusEvent(this.createEvent(event, 'focus'));
        },
        inputEvent: function inputEvent(event) {
            this.value = event.target.value;
            this.emitEvent('input', event);
        },
        blurEvent: function blurEvent(event) {
            this.emitEvent('blur', event);
        },
        focusEvent: function focusEvent(event) {
            this.emitEvent('focus', event);
        },
        createEvent: function createEvent(event, type) {
            var overrideValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return {
                type: type,
                target: {
                    id: event.target.id,
                    name: event.target.name,
                    value: overrideValue ? overrideValue : event.target.value
                }
            };
        },
        emitEvent: function emitEvent(type, payload) {
            if (type === 'input') this.$emit('input', payload.target.value);

            this.$emit('event', { type: type, field: this.name, payload: payload });
        }
    }
};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32), __webpack_require__(204).setImmediate))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(5);
var normalizeHeaderName = __webpack_require__(108);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(49);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(49);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(22);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(41)('keys');
var uid = __webpack_require__(28);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(6);
var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(19) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(13);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(6);
var LIBRARY = __webpack_require__(19);
var wksExt = __webpack_require__(45);
var defineProperty = __webpack_require__(14).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(4);


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Errors = exports.Form = exports.VuexForms = undefined;

var _Form = __webpack_require__(247);

var _Form2 = _interopRequireDefault(_Form);

var _Errors = __webpack_require__(72);

var _Errors2 = _interopRequireDefault(_Errors);

var _VuexText = __webpack_require__(252);

var _VuexText2 = _interopRequireDefault(_VuexText);

var _VuexCheckbox = __webpack_require__(249);

var _VuexCheckbox2 = _interopRequireDefault(_VuexCheckbox);

var _VuexRadio = __webpack_require__(250);

var _VuexRadio2 = _interopRequireDefault(_VuexRadio);

var _VuexSelect = __webpack_require__(251);

var _VuexSelect2 = _interopRequireDefault(_VuexSelect);

var _InputSyncDirective = __webpack_require__(248);

var _InputSyncDirective2 = _interopRequireDefault(_InputSyncDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VuexForms = {
    install: function install(Vue, options) {
        Vue.component('vuex-text', _VuexText2.default);
        Vue.component('vuex-checkbox', _VuexCheckbox2.default);
        Vue.component('vuex-radio', _VuexRadio2.default);
        Vue.component('vuex-select', _VuexSelect2.default);
        Vue.directive('input-sync', _InputSyncDirective2.default);
    }
};

exports.VuexForms = VuexForms;
exports.Form = _Form2.default;
exports.Errors = _Errors2.default;
exports.default = VuexForms;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(94);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var settle = __webpack_require__(100);
var buildURL = __webpack_require__(103);
var parseHeaders = __webpack_require__(109);
var isURLSameOrigin = __webpack_require__(107);
var createError = __webpack_require__(52);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(102);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(105);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(99);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(17);
var TAG = __webpack_require__(4)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(9) && !__webpack_require__(15)(function () {
  return Object.defineProperty(__webpack_require__(36)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(17);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(19);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(64);
var hide = __webpack_require__(12);
var Iterators = __webpack_require__(18);
var $iterCreate = __webpack_require__(153);
var setToStringTag = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(162);
var ITERATOR = __webpack_require__(4)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(8);
var dPs = __webpack_require__(159);
var enumBugKeys = __webpack_require__(37);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(36)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(55).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(61);
var hiddenKeys = __webpack_require__(37).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(11);
var toIObject = __webpack_require__(16);
var arrayIndexOf = __webpack_require__(146)(false);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var isObject = __webpack_require__(13);
var newPromiseCapability = __webpack_require__(38);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(22);
var SPECIES = __webpack_require__(4)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(23);
var invoke = __webpack_require__(149);
var html = __webpack_require__(55);
var cel = __webpack_require__(36);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(17)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(42);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {



/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(166)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(58)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(170);
var global = __webpack_require__(3);
var hide = __webpack_require__(12);
var Iterators = __webpack_require__(18);
var TO_STRING_TAG = __webpack_require__(4)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.pushParams = pushParams;
exports.popParams = popParams;
exports.withParams = withParams;

var stack = [];

// exported for tests
var target = exports.target = null;
var _setTarget = exports._setTarget = function _setTarget(x) {
  exports.target = target = x;
};

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }
  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;
  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }
    newTarget.$sub.push(lastTarget);
  }
  return lastTarget;
}

function addParams(params) {
  if (typeof params === 'object' && !Array.isArray(params)) {
    exports.target = target = _extends({}, target, params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();
    try {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (typeof paramsOrClosure === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }
  return withParamsClosure(paramsOrClosure);
}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Errors = function () {
    function Errors() {
        _classCallCheck(this, Errors);

        this.bag = {};
    }

    _createClass(Errors, [{
        key: "get",
        value: function get(field) {
            return this.bag.hasOwnProperty(field) ? this.bag[field] : null;
        }
    }, {
        key: "has",
        value: function has(field) {
            return this.bag.hasOwnProperty(field);
        }
    }, {
        key: "any",
        value: function any() {
            return Object.keys(this.bag).length > 0;
        }
    }, {
        key: "all",
        value: function all() {
            var errors = {};
            for (var field in this.bag) {
                if (this.bag.hasOwnProperty(field)) {
                    errors[field] = this.bag[field];
                }
            }

            return errors;
        }
    }, {
        key: "record",
        value: function record(errors) {
            if (errors.length < 1) return;

            var newErrors = {};

            for (var error in this.bag) {
                newErrors[error] = this.bag[error];
            }

            for (var field in errors) {
                newErrors[field] = errors[field];
            }

            this.bag = newErrors;
        }
    }, {
        key: "clear",
        value: function clear(field) {
            if (field) {
                var newErrors = {};
                for (var error in this.bag) {
                    if (this.bag.hasOwnProperty(error) && field !== error) {
                        newErrors[error] = this.bag[error];
                    }
                }
                this.bag = newErrors;
            } else {
                this.bag = {};
            }
        }
    }]);

    return Errors;
}();

exports.default = Errors;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _merge = __webpack_require__(29);

var _merge2 = _interopRequireDefault(_merge);

var _vuexField = __webpack_require__(31);

var _vuexField2 = _interopRequireDefault(_vuexField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _merge2.default.recursive(true, _vuexField2.default, {
        props: {
            options: { type: [String, Object, Array], default: function _default() {
                    return [];
                } },
            option_name: { type: String, default: 'name' },
            option_value: { type: String, default: 'value' },
            multiple: { type: Boolean, default: false }
        },
        methods: {
            checkSelected: function checkSelected(value) {
                if (!this.multiple && this.value === value) return true;
                if (this.multiple && this.value !== null && value.length) return this.value.indexOf(value) !== -1;
            },
            handleInput: function handleInput(event) {
                var values = null;
                if (this.multiple && event.target.selectedOptions) {
                    values = [];
                    for (var x = 0; x < event.target.selectedOptions.length; x++) {
                        values.push(event.target.selectedOptions[x].value);
                    }
                }
                return this.inputEvent(this.createEvent(event, 'input', values));
            },
            inputEvent: function inputEvent(event) {
                this.value = event.target.value;
                this.emitEvent('input', event);
            }
        }
    });
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _merge = __webpack_require__(29);

var _merge2 = _interopRequireDefault(_merge);

var _vuexField = __webpack_require__(31);

var _vuexField2 = _interopRequireDefault(_vuexField);

var _Masker = __webpack_require__(253);

var _Masker2 = _interopRequireDefault(_Masker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _merge2.default.recursive(true, _vuexField2.default, {
        props: {
            type: {
                type: String,
                default: 'text',
                validator: function validator(value) {
                    return ['text', 'textarea', 'tel', 'number', 'email', 'password', 'url', 'date'].indexOf(value) !== -1;
                }
            },
            mask: { type: [Boolean, String], default: false },
            saveMask: { type: [Boolean, String], default: false }
        },
        beforeMount: function beforeMount() {
            this.masker = new _Masker2.default();
        },

        methods: {
            hasMask: function hasMask() {
                return this.mask !== false && ['number', 'password'].indexOf(this.type.toLowerCase()) === -1;
            },
            applyMask: function applyMask(value) {
                if (this.activeKeyCode !== 8 && this.activeKeyCode !== 46) {
                    value = this.masker.applyMask(value, this.mask);
                }

                this.$refs.input.value = value;

                this.masker.updateCaretPosition(this.$refs.input, this.activeKeyCode);

                return value;
            },
            applySaveMask: function applySaveMask(value) {
                if (this.saveMask === false) {
                    value = this.masker.removeMask(value, this.mask);
                } else if (this.saveMask !== true) {
                    value = this.masker.applyMask(value, this.saveMask);
                }
                return value;
            },
            handleKeyDown: function handleKeyDown(e) {
                if (this.hasMask()) {
                    this.activeKeyCode = e.keyCode || e.charCode;

                    this.masker.readCaretPosition(this.$refs.input);
                }
            },
            inputEvent: function inputEvent(event) {
                var value = event.target.value;
                if (this.hasMask()) {
                    value = this.applyMask(value);

                    event.target.value = this.applySaveMask(value);
                }

                this.value = value;
                this.emitEvent('input', event);
            },
            blurEvent: function blurEvent(event) {
                if (this.hasMask()) event.target.value = this.applySaveMask(event.target.value);
                this.emitEvent('blur', event);
            },
            focusEvent: function focusEvent(event) {
                if (this.hasMask()) event.target.value = this.applySaveMask(event.target.value);
                this.emitEvent('focus', event);
            }
        }
    });
};

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(140), __esModule: true };

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(184)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var bind = __webpack_require__(53);
var Axios = __webpack_require__(96);
var defaults = __webpack_require__(34);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(50);
axios.CancelToken = __webpack_require__(95);
axios.isCancel = __webpack_require__(51);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(110);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(50);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(34);
var utils = __webpack_require__(5);
var InterceptorManager = __webpack_require__(97);
var dispatchRequest = __webpack_require__(98);
var isAbsoluteURL = __webpack_require__(106);
var combineURLs = __webpack_require__(104);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var transformData = __webpack_require__(101);
var isCancel = __webpack_require__(51);
var defaults = __webpack_require__(34);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(52);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(139), __esModule: true };

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(142), __esModule: true };

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(143), __esModule: true };

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(135);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(134);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(137)
var ieee754 = __webpack_require__(189)
var isArray = __webpack_require__(191)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171);
module.exports = __webpack_require__(6).Object.assign;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(172);
module.exports = __webpack_require__(6).Object.keys;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68);
__webpack_require__(69);
__webpack_require__(70);
__webpack_require__(173);
__webpack_require__(175);
__webpack_require__(176);
module.exports = __webpack_require__(6).Promise;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(174);
__webpack_require__(68);
__webpack_require__(177);
__webpack_require__(178);
module.exports = __webpack_require__(6).Symbol;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69);
__webpack_require__(70);
module.exports = __webpack_require__(45).f('iterator');


/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(16);
var toLength = __webpack_require__(67);
var toAbsoluteIndex = __webpack_require__(167);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(20);
var gOPS = __webpack_require__(39);
var pIE = __webpack_require__(24);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(23);
var call = __webpack_require__(152);
var isArrayIter = __webpack_require__(150);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(67);
var getIterFn = __webpack_require__(169);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(18);
var ITERATOR = __webpack_require__(4)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(17);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(59);
var descriptor = __webpack_require__(25);
var setToStringTag = __webpack_require__(26);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(12)(IteratorPrototype, __webpack_require__(4)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(4)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(28)('meta');
var isObject = __webpack_require__(13);
var has = __webpack_require__(11);
var setDesc = __webpack_require__(14).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(15)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(66).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(17)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(9);
var getKeys = __webpack_require__(20);
var gOPS = __webpack_require__(39);
var pIE = __webpack_require__(24);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(57);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(15)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var anObject = __webpack_require__(8);
var getKeys = __webpack_require__(20);

module.exports = __webpack_require__(9) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(24);
var createDesc = __webpack_require__(25);
var toIObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(43);
var has = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(56);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(9) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(16);
var gOPN = __webpack_require__(60).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(11);
var toObject = __webpack_require__(27);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(10);
var core = __webpack_require__(6);
var fails = __webpack_require__(15);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(12);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var core = __webpack_require__(6);
var dP = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(9);
var SPECIES = __webpack_require__(4)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(42);
var defined = __webpack_require__(35);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(42);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(54);
var ITERATOR = __webpack_require__(4)('iterator');
var Iterators = __webpack_require__(18);
module.exports = __webpack_require__(6).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(144);
var step = __webpack_require__(155);
var Iterators = __webpack_require__(18);
var toIObject = __webpack_require__(16);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(58)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(10);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(158) });


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(27);
var $keys = __webpack_require__(20);

__webpack_require__(163)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(19);
var global = __webpack_require__(3);
var ctx = __webpack_require__(23);
var classof = __webpack_require__(54);
var $export = __webpack_require__(10);
var isObject = __webpack_require__(13);
var aFunction = __webpack_require__(22);
var anInstance = __webpack_require__(145);
var forOf = __webpack_require__(148);
var speciesConstructor = __webpack_require__(65);
var task = __webpack_require__(66).set;
var microtask = __webpack_require__(157)();
var newPromiseCapabilityModule = __webpack_require__(38);
var perform = __webpack_require__(62);
var userAgent = __webpack_require__(168);
var promiseResolve = __webpack_require__(63);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(4)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(164)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(26)($Promise, PROMISE);
__webpack_require__(165)(PROMISE);
Wrapper = __webpack_require__(6)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(154)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(9);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(64);
var META = __webpack_require__(156).KEY;
var $fails = __webpack_require__(15);
var shared = __webpack_require__(41);
var setToStringTag = __webpack_require__(26);
var uid = __webpack_require__(28);
var wks = __webpack_require__(4);
var wksExt = __webpack_require__(45);
var wksDefine = __webpack_require__(44);
var enumKeys = __webpack_require__(147);
var isArray = __webpack_require__(151);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(13);
var toObject = __webpack_require__(27);
var toIObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(43);
var createDesc = __webpack_require__(25);
var _create = __webpack_require__(59);
var gOPNExt = __webpack_require__(161);
var $GOPD = __webpack_require__(160);
var $GOPS = __webpack_require__(39);
var $DP = __webpack_require__(14);
var $keys = __webpack_require__(20);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(60).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(24).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(19)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(12)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(10);
var core = __webpack_require__(6);
var global = __webpack_require__(3);
var speciesConstructor = __webpack_require__(65);
var promiseResolve = __webpack_require__(63);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(10);
var newPromiseCapability = __webpack_require__(38);
var perform = __webpack_require__(62);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('asyncIterator');


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44)('observable');


/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 191 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/**
 * Secure random string generator with custom alphabet.
 *
 * Alphabet must contain 256 symbols or less. Otherwise, the generator
 * will not be secure.
 *
 * @param {generator} random The random bytes generator.
 * @param {string} alphabet Symbols to be used in new random string.
 * @param {size} size The number of symbols in new random string.
 *
 * @return {string} Random string.
 *
 * @example
 * const format = require('nanoid/format')
 *
 * function random (size) {
 *   const result = []
 *   for (let i = 0; i < size; i++) {
 *     result.push(randomByte())
 *   }
 *   return result
 * }
 *
 * format(random, "abcdef", 5) //=> "fbaef"
 *
 * @name format
 * @function
 */
module.exports = function (random, alphabet, size) {
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  var step = Math.ceil(1.6 * mask * size / alphabet.length)
  size = +size

  var id = ''
  while (true) {
    var bytes = random(step)
    for (var i = 0; i < step; i++) {
      var byte = bytes[i] & mask
      if (alphabet[byte]) {
        id += alphabet[byte]
        if (id.length === size) return id
      }
    }
  }
}

/**
 * @callback generator
 * @param {number} bytes The number of bytes to generate.
 * @return {number[]} Random bytes.
 */


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {!function(root, factory) {
     true ? module.exports = factory() : "function" == typeof define && define.amd ? define("paypal", [], factory) : "object" == typeof exports ? exports.paypal = factory() : root.paypal = factory();
}("undefined" != typeof self ? self : this, function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.l = !0, module.exports;
        }
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        }, __webpack_require__.r = function(exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        }, __webpack_require__.t = function(value, mode) {
            if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
            if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
            var ns = Object.create(null);
            if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            }), 2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function(key) {
                return value[key];
            }.bind(null, key));
            return ns;
        }, __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return {}.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 58);
    }([ function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var _CONTEXT_TYPE, _LANG_TO_DEFAULT_COUN, _LOCALE, BUTTON_STYLE_OPTIONS = {
            LABEL: "label",
            SIZE: "size",
            SHAPE: "shape",
            COLOR: "color",
            LAYOUT: "layout",
            MAXBUTTONS: "maxbuttons",
            FUNDINGICONS: "fundingicons",
            BRANDING: "branding",
            TAGLINE: "tagline",
            HEIGHT: "height",
            INSTALLMENTPERIOD: "installmentperiod"
        }, BUTTON_LABEL = {
            PAYPAL: "paypal",
            CHECKOUT: "checkout",
            PAY: "pay",
            CREDIT: "credit",
            CARD: "card",
            BUYNOW: "buynow",
            INSTALLMENT: "installment",
            VENMO: "venmo",
            ITAU: "itau",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            ZIMPLER: "zimpler"
        }, BUTTON_COLOR = {
            GOLD: "gold",
            BLUE: "blue",
            SILVER: "silver",
            BLACK: "black",
            DARKBLUE: "darkblue",
            WHITE: "white",
            TRANSPARENT: "transparent"
        }, BUTTON_LOGO_COLOR = {
            BLUE: "blue",
            WHITE: "white",
            BLACK: "black",
            ANY: "any"
        }, BUTTON_SIZE = {
            TINY: "tiny",
            SMALL: "small",
            MEDIUM: "medium",
            LARGE: "large",
            HUGE: "huge",
            RESPONSIVE: "responsive"
        }, BUTTON_TAGLINE_COLOR = {
            BLACK: "black",
            BLUE: "blue"
        }, BUTTON_SHAPE = {
            PILL: "pill",
            RECT: "rect"
        }, BUTTON_BRANDING = {
            BRANDED: "branded",
            UNBRANDED: "unbranded"
        }, BUTTON_LAYOUT = {
            HORIZONTAL: "horizontal",
            VERTICAL: "vertical"
        }, BUTTON_NUMBER = {
            SINGLE: "single",
            MULTIPLE: "multiple"
        }, BUTTON_LOGO = {
            PP: "pp",
            PAYPAL: "paypal",
            VENMO: "venmo",
            ITAU: "itau",
            CREDIT: "credit",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            ZIMPLER: "zimpler"
        }, CHECKOUT_OVERLAY_COLOR = {
            BLACK: "black",
            WHITE: "white"
        }, FUNDING = {
            PAYPAL: "paypal",
            VENMO: "venmo",
            ITAU: "itau",
            CREDIT: "credit",
            CARD: "card",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            ZIMPLER: "zimpler"
        }, CARD = {
            VISA: "visa",
            MASTERCARD: "mastercard",
            AMEX: "amex",
            DISCOVER: "discover",
            SWITCH: "switch",
            MAESTRO: "maestro",
            HIPER: "hiper",
            ELO: "elo",
            JCB: "jcb",
            CUP: "cup",
            COFINOGA: "cofinoga",
            COFIDIS: "cofidis",
            CETELEM: "cetelem",
            CBNATIONALE: "cbnationale"
        }, FUNDING_ELIGIBILITY_REASON = {
            PRIMARY: "The funding source is the primary source",
            NOT_ENABLED: "The funding source is not currently enabled for use",
            SECONDARY_DISALLOWED: "The funding source is disallowed as a secondary button",
            OPT_OUT: "The funding source was disallowed in funding.disallowed",
            OPT_IN: "The funding source was allowed in funding.allowed",
            DISALLOWED_COUNTRY: "The funding source is not enabled for the current locale",
            DEFAULT_COUNTRY: "The funding source is enabled by default for the current locale",
            DEFAULT: "The funding source is enabled by default for all users",
            REMEMBERED: "The funding source was remembered for the current user",
            NEED_OPT_IN: "The funding source needs to be allowed in funding.allowed",
            COMMIT_NOT_SET: "The funding source is not enabled when commit is not set as true"
        }, CARD_PRIORITY = [ CARD.VISA, CARD.MASTERCARD, CARD.AMEX, CARD.DISCOVER, CARD.SWITCH, CARD.MAESTRO, CARD.HIPER, CARD.ELO, CARD.JCB, CARD.CUP, CARD.COFINOGA, CARD.COFIDIS, CARD.CETELEM, CARD.CBNATIONALE ], ENV = {
            LOCAL: "local",
            STAGE: "stage",
            SANDBOX: "sandbox",
            PRODUCTION: "production",
            TEST: "test",
            DEMO: "demo"
        }, USERS = {
            ALL: "all",
            REMEMBERED: "remembered"
        }, SOURCE = {
            MANUAL: "manual",
            BUTTON_FACTORY: "button_factory"
        }, LOG_LEVEL = {
            DEBUG: "debug",
            INFO: "info",
            WARN: "warn",
            ERROR: "error"
        }, PAYMENT_TYPE = {
            EC_TOKEN: "ec_token",
            BA_TOKEN: "ba_token",
            PAY_ID: "pay_id"
        }, ATTRIBUTE = {
            BUTTON: "data-button",
            FUNDING_SOURCE: "data-funding-source",
            CARD: "data-card",
            VERSION: "data-version",
            LAYOUT: "data-layout",
            SIZE: "data-size"
        }, PLATFORM = {
            DESKTOP: "desktop",
            MOBILE: "mobile"
        }, FPTI = {
            KEY: {
                FEED: "feed_name",
                STATE: "state_name",
                TRANSITION: "transition_name",
                BUTTON_TYPE: "button_type",
                SESSION_UID: "page_session_id",
                BUTTON_SESSION_UID: "button_session_id",
                TOKEN: "token",
                CONTEXT_ID: "context_id",
                CONTEXT_TYPE: "context_type",
                REFERER: "referer_url",
                PAY_ID: "pay_id",
                SELLER_ID: "seller_id",
                DATA_SOURCE: "serverside_data_source",
                BUTTON_SOURCE: "button_source",
                ERROR_CODE: "ext_error_code",
                ERROR_DESC: "ext_error_desc",
                PAGE_LOAD_TIME: "page_load_time",
                EXPERIMENT_NAME: "pxp_exp_id",
                TREATMENT_NAME: "pxp_trtmnt_id",
                TRANSITION_TIME: "transition_time",
                FUNDING_LIST: "eligible_payment_methods",
                FUNDING_COUNT: "eligible_payment_count",
                CHOSEN_FUNDING: "selected_payment_method",
                BUTTON_LAYOUT: "button_layout",
                BUTTON_COLOR: "button_color",
                BUTTON_SIZE: "button_size",
                BUTTON_SHAPE: "button_shape",
                BUTTON_LABEL: "button_label",
                BUTTON_WIDTH: "button_width",
                VERSION: "checkoutjs_version",
                MAX_BUTTONS: "max_buttons",
                FUNDING_REMEMBERED: "funding_remembered"
            },
            BUTTON_TYPE: {
                IFRAME: "iframe",
                HTML: "html",
                CUSTOM: "custom"
            },
            DATA_SOURCE: {
                CHECKOUT: "checkout"
            },
            CONTEXT_TYPE: (_CONTEXT_TYPE = {
                BUTTON_SESSION_ID: "button_session_id"
            }, _CONTEXT_TYPE[PAYMENT_TYPE.PAY_ID] = "Pay-ID", _CONTEXT_TYPE[PAYMENT_TYPE.EC_TOKEN] = "EC-Token", 
            _CONTEXT_TYPE[PAYMENT_TYPE.BA_TOKEN] = "EC-Token", _CONTEXT_TYPE),
            FEED: {
                CHECKOUTJS: "checkoutjs"
            },
            STATE: {
                LOAD: "checkoutjs_load",
                BUTTON: "checkoutjs_button",
                CHECKOUT: "checkoutjs_checkout",
                PPTM: "checkoutjs_pptm"
            },
            TRANSITION: {
                SCRIPT_LOAD: "process_script_load",
                BUTTON_RENDER: "process_button_render",
                BUTTON_LOAD: "process_button_load",
                BUTTON_CLICK: "process_button_click",
                BUTTON_RENDER_INTRANET_MODE: "process_button_render_intranet_mode",
                BUTTON_CLICK_INTRANET_MODE: "process_button_click_intranet_mode",
                CREATE_PAYMENT: "process_create_payment",
                RECIEVE_PAYMENT: "process_recieve_payment",
                CHECKOUT_INIT: "process_checkout_init",
                CHECKOUT_AUTHORIZE: "process_checkout_authorize",
                CHECKOUT_SHIPPING_CHANGE: "process_checkout_shipping_change",
                CHECKOUT_CANCEL: "process_checkout_cancel",
                CHECKOUT_ERROR: "process_checkout_error",
                EXTERNAL_EXPERIMENT: "process_external_experiment",
                EXTERNAL_EXPERIMENT_COMPLETE: "process_external_experiment_complete",
                PPTM_LOAD: "process_pptm_load",
                PPTM_LOADED: "process_pptm_loaded"
            }
        }, COUNTRY = {
            AD: "AD",
            AE: "AE",
            AG: "AG",
            AI: "AI",
            AL: "AL",
            AM: "AM",
            AN: "AN",
            AO: "AO",
            AR: "AR",
            AT: "AT",
            AU: "AU",
            AW: "AW",
            AZ: "AZ",
            BA: "BA",
            BB: "BB",
            BE: "BE",
            BF: "BF",
            BG: "BG",
            BH: "BH",
            BI: "BI",
            BJ: "BJ",
            BM: "BM",
            BN: "BN",
            BO: "BO",
            BR: "BR",
            BS: "BS",
            BT: "BT",
            BW: "BW",
            BY: "BY",
            BZ: "BZ",
            C2: "C2",
            CA: "CA",
            CD: "CD",
            CG: "CG",
            CH: "CH",
            CI: "CI",
            CK: "CK",
            CL: "CL",
            CM: "CM",
            CN: "CN",
            CO: "CO",
            CR: "CR",
            CV: "CV",
            CY: "CY",
            CZ: "CZ",
            DE: "DE",
            DJ: "DJ",
            DK: "DK",
            DM: "DM",
            DO: "DO",
            DZ: "DZ",
            EC: "EC",
            EE: "EE",
            EG: "EG",
            ER: "ER",
            ES: "ES",
            ET: "ET",
            FI: "FI",
            FJ: "FJ",
            FK: "FK",
            FM: "FM",
            FO: "FO",
            FR: "FR",
            GA: "GA",
            GB: "GB",
            GD: "GD",
            GE: "GE",
            GF: "GF",
            GI: "GI",
            GL: "GL",
            GM: "GM",
            GN: "GN",
            GP: "GP",
            GR: "GR",
            GT: "GT",
            GW: "GW",
            GY: "GY",
            HK: "HK",
            HN: "HN",
            HR: "HR",
            HU: "HU",
            ID: "ID",
            IE: "IE",
            IL: "IL",
            IN: "IN",
            IS: "IS",
            IT: "IT",
            JM: "JM",
            JO: "JO",
            JP: "JP",
            KE: "KE",
            KG: "KG",
            KH: "KH",
            KI: "KI",
            KM: "KM",
            KN: "KN",
            KR: "KR",
            KW: "KW",
            KY: "KY",
            KZ: "KZ",
            LA: "LA",
            LC: "LC",
            LI: "LI",
            LK: "LK",
            LS: "LS",
            LT: "LT",
            LU: "LU",
            LV: "LV",
            MA: "MA",
            MC: "MC",
            MD: "MD",
            ME: "ME",
            MG: "MG",
            MH: "MH",
            MK: "MK",
            ML: "ML",
            MN: "MN",
            MQ: "MQ",
            MR: "MR",
            MS: "MS",
            MT: "MT",
            MU: "MU",
            MV: "MV",
            MW: "MW",
            MX: "MX",
            MY: "MY",
            MZ: "MZ",
            NA: "NA",
            NC: "NC",
            NE: "NE",
            NF: "NF",
            NG: "NG",
            NI: "NI",
            NL: "NL",
            NO: "NO",
            NP: "NP",
            NR: "NR",
            NU: "NU",
            NZ: "NZ",
            OM: "OM",
            PA: "PA",
            PE: "PE",
            PF: "PF",
            PG: "PG",
            PH: "PH",
            PL: "PL",
            PM: "PM",
            PN: "PN",
            PT: "PT",
            PW: "PW",
            PY: "PY",
            QA: "QA",
            RE: "RE",
            RO: "RO",
            RS: "RS",
            RU: "RU",
            RW: "RW",
            SA: "SA",
            SB: "SB",
            SC: "SC",
            SE: "SE",
            SG: "SG",
            SH: "SH",
            SI: "SI",
            SJ: "SJ",
            SK: "SK",
            SL: "SL",
            SM: "SM",
            SN: "SN",
            SO: "SO",
            SR: "SR",
            ST: "ST",
            SV: "SV",
            SZ: "SZ",
            TC: "TC",
            TD: "TD",
            TG: "TG",
            TH: "TH",
            TJ: "TJ",
            TM: "TM",
            TN: "TN",
            TO: "TO",
            TR: "TR",
            TT: "TT",
            TV: "TV",
            TW: "TW",
            TZ: "TZ",
            UA: "UA",
            UG: "UG",
            US: "US",
            UY: "UY",
            VA: "VA",
            VC: "VC",
            VE: "VE",
            VG: "VG",
            VN: "VN",
            VU: "VU",
            WF: "WF",
            WS: "WS",
            YE: "YE",
            YT: "YT",
            ZA: "ZA",
            ZM: "ZM",
            ZW: "ZW"
        }, LANG = {
            AR: "ar",
            CS: "cs",
            DA: "da",
            DE: "de",
            EL: "el",
            EN: "en",
            ES: "es",
            FI: "fi",
            FR: "fr",
            HE: "he",
            HU: "hu",
            ID: "id",
            IT: "it",
            JA: "ja",
            KO: "ko",
            NL: "nl",
            NO: "no",
            PL: "pl",
            PT: "pt",
            RU: "ru",
            SK: "sk",
            SV: "sv",
            TH: "th",
            TR: "tr",
            ZH: "zh"
        }, LANG_TO_DEFAULT_COUNTRY = ((_LANG_TO_DEFAULT_COUN = {})[LANG.AR] = COUNTRY.SA, 
        _LANG_TO_DEFAULT_COUN[LANG.CS] = COUNTRY.CZ, _LANG_TO_DEFAULT_COUN[LANG.DA] = COUNTRY.DK, 
        _LANG_TO_DEFAULT_COUN[LANG.DE] = COUNTRY.DE, _LANG_TO_DEFAULT_COUN[LANG.EL] = COUNTRY.GR, 
        _LANG_TO_DEFAULT_COUN[LANG.EN] = COUNTRY.US, _LANG_TO_DEFAULT_COUN[LANG.ES] = COUNTRY.ES, 
        _LANG_TO_DEFAULT_COUN[LANG.FI] = COUNTRY.FI, _LANG_TO_DEFAULT_COUN[LANG.FR] = COUNTRY.FR, 
        _LANG_TO_DEFAULT_COUN[LANG.HE] = COUNTRY.IL, _LANG_TO_DEFAULT_COUN[LANG.HU] = COUNTRY.HU, 
        _LANG_TO_DEFAULT_COUN[LANG.ID] = COUNTRY.ID, _LANG_TO_DEFAULT_COUN[LANG.IT] = COUNTRY.IT, 
        _LANG_TO_DEFAULT_COUN[LANG.JA] = COUNTRY.JP, _LANG_TO_DEFAULT_COUN[LANG.KO] = COUNTRY.KR, 
        _LANG_TO_DEFAULT_COUN[LANG.NL] = COUNTRY.NL, _LANG_TO_DEFAULT_COUN[LANG.NO] = COUNTRY.NO, 
        _LANG_TO_DEFAULT_COUN[LANG.PL] = COUNTRY.PL, _LANG_TO_DEFAULT_COUN[LANG.PT] = COUNTRY.PT, 
        _LANG_TO_DEFAULT_COUN[LANG.RU] = COUNTRY.RU, _LANG_TO_DEFAULT_COUN[LANG.SK] = COUNTRY.SK, 
        _LANG_TO_DEFAULT_COUN[LANG.SV] = COUNTRY.SE, _LANG_TO_DEFAULT_COUN[LANG.TH] = COUNTRY.TH, 
        _LANG_TO_DEFAULT_COUN[LANG.TR] = COUNTRY.TR, _LANG_TO_DEFAULT_COUN[LANG.ZH] = COUNTRY.CN, 
        _LANG_TO_DEFAULT_COUN), ALLOWED_INSTALLMENT_COUNTRIES = [ COUNTRY.BR, COUNTRY.MX ], ALLOWED_INSTALLMENT_PERIOD = {
            BR: [ 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ],
            MX: [ 3, 6, 9, 12 ]
        }, LOCALE = ((_LOCALE = {})[COUNTRY.AD] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR ], _LOCALE[COUNTRY.AG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AL] = [ LANG.EN ], 
        _LOCALE[COUNTRY.AM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AR] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.AT] = [ LANG.DE, LANG.EN ], _LOCALE[COUNTRY.AU] = [ LANG.EN ], _LOCALE[COUNTRY.AW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BA] = [ LANG.EN ], 
        _LOCALE[COUNTRY.BB] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BE] = [ LANG.EN, LANG.NL, LANG.FR ], 
        _LOCALE[COUNTRY.BF] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BG] = [ LANG.EN ], 
        _LOCALE[COUNTRY.BH] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BI] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BJ] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BN] = [ LANG.EN ], _LOCALE[COUNTRY.BO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.BR] = [ LANG.PT, LANG.EN ], _LOCALE[COUNTRY.BS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BT] = [ LANG.EN ], _LOCALE[COUNTRY.BW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BY] = [ LANG.EN ], _LOCALE[COUNTRY.BZ] = [ LANG.EN, LANG.ES, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.C2] = [ LANG.ZH, LANG.EN ], _LOCALE[COUNTRY.CA] = [ LANG.EN, LANG.FR ], 
        _LOCALE[COUNTRY.CD] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.CG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.CH] = [ LANG.DE, LANG.FR, LANG.EN ], _LOCALE[COUNTRY.CI] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.CK] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.CL] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.CM] = [ LANG.FR, LANG.EN ], _LOCALE[COUNTRY.CN] = [ LANG.ZH ], _LOCALE[COUNTRY.CO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.CR] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.CV] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.CY] = [ LANG.EN ], _LOCALE[COUNTRY.CZ] = [ LANG.CS, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DE] = [ LANG.DE, LANG.EN ], _LOCALE[COUNTRY.DJ] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DK] = [ LANG.DA, LANG.EN ], _LOCALE[COUNTRY.DM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.DZ] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.EC] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.EE] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.EG] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ER] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ES] = [ LANG.ES, LANG.EN ], _LOCALE[COUNTRY.ET] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.FI] = [ LANG.FI, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.FK] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FM] = [ LANG.EN ], 
        _LOCALE[COUNTRY.FO] = [ LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FR] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.GA] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GB] = [ LANG.EN ], 
        _LOCALE[COUNTRY.GD] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GL] = [ LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GN] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GP] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GR] = [ LANG.EL, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GT] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.GW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GY] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.HK] = [ LANG.EN, LANG.ZH ], _LOCALE[COUNTRY.HN] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.HR] = [ LANG.EN ], _LOCALE[COUNTRY.HU] = [ LANG.HU, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ID] = [ LANG.ID, LANG.EN ], _LOCALE[COUNTRY.IE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.IL] = [ LANG.HE, LANG.EN ], _LOCALE[COUNTRY.IN] = [ LANG.EN ], _LOCALE[COUNTRY.IS] = [ LANG.EN ], 
        _LOCALE[COUNTRY.IT] = [ LANG.IT, LANG.EN ], _LOCALE[COUNTRY.JM] = [ LANG.EN, LANG.ES, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.JO] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.JP] = [ LANG.JA, LANG.EN ], 
        _LOCALE[COUNTRY.KE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KH] = [ LANG.EN ], _LOCALE[COUNTRY.KI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KM] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KR] = [ LANG.KO, LANG.EN ], _LOCALE[COUNTRY.KW] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KY] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LA] = [ LANG.EN ], _LOCALE[COUNTRY.LC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LK] = [ LANG.EN ], 
        _LOCALE[COUNTRY.LS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LT] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LU] = [ LANG.EN, LANG.DE, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LV] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MA] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MC] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.MD] = [ LANG.EN ], _LOCALE[COUNTRY.ME] = [ LANG.EN ], _LOCALE[COUNTRY.MG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MH] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MK] = [ LANG.EN ], 
        _LOCALE[COUNTRY.ML] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MN] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MQ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MT] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MV] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MX] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.MY] = [ LANG.EN ], _LOCALE[COUNTRY.MZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NE] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NG] = [ LANG.EN ], _LOCALE[COUNTRY.NI] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.NL] = [ LANG.NL, LANG.EN ], _LOCALE[COUNTRY.NO] = [ LANG.NO, LANG.EN ], 
        _LOCALE[COUNTRY.NP] = [ LANG.EN ], _LOCALE[COUNTRY.NR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.OM] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PA] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.PE] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.PF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.PG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PH] = [ LANG.EN ], 
        _LOCALE[COUNTRY.PL] = [ LANG.PL, LANG.EN ], _LOCALE[COUNTRY.PM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.PN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PT] = [ LANG.PT, LANG.EN ], 
        _LOCALE[COUNTRY.PW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PY] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.QA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR ], _LOCALE[COUNTRY.RE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.RO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.RS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.RU] = [ LANG.RU, LANG.EN ], _LOCALE[COUNTRY.RW] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SA] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SB] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SC] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SE] = [ LANG.SV, LANG.EN ], 
        _LOCALE[COUNTRY.SG] = [ LANG.EN ], _LOCALE[COUNTRY.SH] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SK] = [ LANG.SK, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SL] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SN] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ST] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SV] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.SZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TD] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TG] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TH] = [ LANG.TH, LANG.EN ], _LOCALE[COUNTRY.TJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TN] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TO] = [ LANG.EN ], _LOCALE[COUNTRY.TR] = [ LANG.TR, LANG.EN ], _LOCALE[COUNTRY.TT] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TV] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TW] = [ LANG.ZH, LANG.EN ], 
        _LOCALE[COUNTRY.TZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.UA] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.UG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.US] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.UY] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.VA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.VC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.VE] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.VG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.VN] = [ LANG.EN ], 
        _LOCALE[COUNTRY.VU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.WF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.WS] = [ LANG.EN ], _LOCALE[COUNTRY.YE] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.YT] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ZA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ZM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ZW] = [ LANG.EN ], 
        _LOCALE);
        __webpack_require__.d(__webpack_exports__, "m", function() {
            return BUTTON_STYLE_OPTIONS;
        }), __webpack_require__.d(__webpack_exports__, "f", function() {
            return BUTTON_LABEL;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return BUTTON_COLOR;
        }), __webpack_require__.d(__webpack_exports__, "i", function() {
            return BUTTON_LOGO_COLOR;
        }), __webpack_require__.d(__webpack_exports__, "l", function() {
            return BUTTON_SIZE;
        }), __webpack_require__.d(__webpack_exports__, "n", function() {
            return BUTTON_TAGLINE_COLOR;
        }), __webpack_require__.d(__webpack_exports__, "k", function() {
            return BUTTON_SHAPE;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return BUTTON_BRANDING;
        }), __webpack_require__.d(__webpack_exports__, "g", function() {
            return BUTTON_LAYOUT;
        }), __webpack_require__.d(__webpack_exports__, "j", function() {
            return BUTTON_NUMBER;
        }), __webpack_require__.d(__webpack_exports__, "h", function() {
            return BUTTON_LOGO;
        }), __webpack_require__.d(__webpack_exports__, "q", function() {
            return CHECKOUT_OVERLAY_COLOR;
        }), __webpack_require__.d(__webpack_exports__, "v", function() {
            return FUNDING;
        }), __webpack_require__.d(__webpack_exports__, "o", function() {
            return CARD;
        }), __webpack_require__.d(__webpack_exports__, "w", function() {
            return FUNDING_ELIGIBILITY_REASON;
        }), __webpack_require__.d(__webpack_exports__, "p", function() {
            return CARD_PRIORITY;
        }), __webpack_require__.d(__webpack_exports__, "u", function() {
            return FPTI;
        }), __webpack_require__.d(__webpack_exports__, "r", function() {
            return COUNTRY;
        }), __webpack_require__.d(__webpack_exports__, "x", function() {
            return LANG;
        }), __webpack_require__.d(__webpack_exports__, "y", function() {
            return LANG_TO_DEFAULT_COUNTRY;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return ALLOWED_INSTALLMENT_COUNTRIES;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return ALLOWED_INSTALLMENT_PERIOD;
        }), __webpack_require__.d(__webpack_exports__, "t", function() {
            return ENV;
        }), __webpack_require__.d(__webpack_exports__, "F", function() {
            return USERS;
        }), __webpack_require__.d(__webpack_exports__, "E", function() {
            return SOURCE;
        }), __webpack_require__.d(__webpack_exports__, "A", function() {
            return LOG_LEVEL;
        }), __webpack_require__.d(__webpack_exports__, "B", function() {
            return PAYMENT_TYPE;
        }), __webpack_require__.d(__webpack_exports__, "D", function() {
            return "xo-pptm";
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return ATTRIBUTE;
        }), __webpack_require__.d(__webpack_exports__, "C", function() {
            return PLATFORM;
        }), __webpack_require__.d(__webpack_exports__, "s", function() {
            return "default";
        }), __webpack_require__.d(__webpack_exports__, "z", function() {
            return LOCALE;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function utils_isPromise(item) {
            try {
                if (!item) return !1;
                if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                if ("undefined" != typeof window && window.Window && item instanceof window.Window) return !1;
                if ("undefined" != typeof window && window.constructor && item instanceof window.constructor) return !1;
                var _toString = {}.toString;
                if (_toString) {
                    var name = _toString.call(item);
                    if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                }
                if ("function" == typeof item.then) return !0;
            } catch (err) {
                return !1;
            }
            return !1;
        }
        var flushPromise, dispatchedErrors = [], possiblyUnhandledPromiseHandlers = [], activeCount = 0;
        function flushActive() {
            if (!activeCount && flushPromise) {
                var promise = flushPromise;
                flushPromise = null, promise.resolve();
            }
        }
        function startActive() {
            activeCount += 1;
        }
        function endActive() {
            activeCount -= 1, flushActive();
        }
        var promise_ZalgoPromise = function() {
            function ZalgoPromise(handler) {
                var _this = this;
                if (this.resolved = void 0, this.rejected = void 0, this.errorHandled = void 0, 
                this.value = void 0, this.error = void 0, this.handlers = void 0, this.dispatching = void 0, 
                this.stack = void 0, this.resolved = !1, this.rejected = !1, this.errorHandled = !1, 
                this.handlers = [], handler) {
                    var _result, _error, resolved = !1, rejected = !1, isAsync = !1;
                    startActive();
                    try {
                        handler(function(res) {
                            isAsync ? _this.resolve(res) : (resolved = !0, _result = res);
                        }, function(err) {
                            isAsync ? _this.reject(err) : (rejected = !0, _error = err);
                        });
                    } catch (err) {
                        return endActive(), void this.reject(err);
                    }
                    endActive(), isAsync = !0, resolved ? this.resolve(_result) : rejected && this.reject(_error);
                }
            }
            var _proto = ZalgoPromise.prototype;
            return _proto.resolve = function(result) {
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                return this.resolved = !0, this.value = result, this.dispatch(), this;
            }, _proto.reject = function(error) {
                var _this2 = this;
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                if (!error) {
                    var _err = error && "function" == typeof error.toString ? error.toString() : {}.toString.call(error);
                    error = new Error("Expected reject to be called with Error, got " + _err);
                }
                return this.rejected = !0, this.error = error, this.errorHandled || setTimeout(function() {
                    _this2.errorHandled || function(err, promise) {
                        if (-1 === dispatchedErrors.indexOf(err)) {
                            dispatchedErrors.push(err), setTimeout(function() {
                                throw err;
                            }, 1);
                            for (var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++) possiblyUnhandledPromiseHandlers[j](err, promise);
                        }
                    }(error, _this2);
                }, 1), this.dispatch(), this;
            }, _proto.asyncReject = function(error) {
                return this.errorHandled = !0, this.reject(error), this;
            }, _proto.dispatch = function() {
                var _this3 = this, resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                if (!this.dispatching && (resolved || rejected)) {
                    this.dispatching = !0, startActive();
                    for (var _loop = function(i) {
                        var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise, result = void 0;
                        if (resolved) try {
                            result = onSuccess ? onSuccess(_this3.value) : _this3.value;
                        } catch (err) {
                            return promise.reject(err), "continue";
                        } else if (rejected) {
                            if (!onError) return promise.reject(_this3.error), "continue";
                            try {
                                result = onError(_this3.error);
                            } catch (err) {
                                return promise.reject(err), "continue";
                            }
                        }
                        result instanceof ZalgoPromise && (result.resolved || result.rejected) ? (result.resolved ? promise.resolve(result.value) : promise.reject(result.error), 
                        result.errorHandled = !0) : utils_isPromise(result) ? result instanceof ZalgoPromise && (result.resolved || result.rejected) ? result.resolved ? promise.resolve(result.value) : promise.reject(result.error) : result.then(function(res) {
                            promise.resolve(res);
                        }, function(err) {
                            promise.reject(err);
                        }) : promise.resolve(result);
                    }, i = 0; i < handlers.length; i++) _loop(i);
                    handlers.length = 0, this.dispatching = !1, endActive();
                }
            }, _proto.then = function(onSuccess, onError) {
                if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                var promise = new ZalgoPromise();
                return this.handlers.push({
                    promise: promise,
                    onSuccess: onSuccess,
                    onError: onError
                }), this.errorHandled = !0, this.dispatch(), promise;
            }, _proto.catch = function(onError) {
                return this.then(void 0, onError);
            }, _proto.finally = function(onFinally) {
                if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                return this.then(function(result) {
                    return ZalgoPromise.try(onFinally).then(function() {
                        return result;
                    });
                }, function(err) {
                    return ZalgoPromise.try(onFinally).then(function() {
                        throw err;
                    });
                });
            }, _proto.timeout = function(time, err) {
                var _this4 = this;
                if (this.resolved || this.rejected) return this;
                var timeout = setTimeout(function() {
                    _this4.resolved || _this4.rejected || _this4.reject(err || new Error("Promise timed out after " + time + "ms"));
                }, time);
                return this.then(function(result) {
                    return clearTimeout(timeout), result;
                });
            }, _proto.toPromise = function() {
                if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                return Promise.resolve(this);
            }, ZalgoPromise.resolve = function(value) {
                return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise(function(resolve, reject) {
                    return value.then(resolve, reject);
                }) : new ZalgoPromise().resolve(value);
            }, ZalgoPromise.reject = function(error) {
                return new ZalgoPromise().reject(error);
            }, ZalgoPromise.asyncReject = function(error) {
                return new ZalgoPromise().asyncReject(error);
            }, ZalgoPromise.all = function(promises) {
                var promise = new ZalgoPromise(), count = promises.length, results = [];
                if (!count) return promise.resolve(results), promise;
                for (var _loop2 = function(i) {
                    var prom = promises[i];
                    if (prom instanceof ZalgoPromise) {
                        if (prom.resolved) return results[i] = prom.value, count -= 1, "continue";
                    } else if (!utils_isPromise(prom)) return results[i] = prom, count -= 1, "continue";
                    ZalgoPromise.resolve(prom).then(function(result) {
                        results[i] = result, 0 == (count -= 1) && promise.resolve(results);
                    }, function(err) {
                        promise.reject(err);
                    });
                }, i = 0; i < promises.length; i++) _loop2(i);
                return 0 === count && promise.resolve(results), promise;
            }, ZalgoPromise.hash = function(promises) {
                var result = {};
                return ZalgoPromise.all(Object.keys(promises).map(function(key) {
                    return ZalgoPromise.resolve(promises[key]).then(function(value) {
                        result[key] = value;
                    });
                })).then(function() {
                    return result;
                });
            }, ZalgoPromise.map = function(items, method) {
                return ZalgoPromise.all(items.map(method));
            }, ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                return function(handler) {
                    return possiblyUnhandledPromiseHandlers.push(handler), {
                        cancel: function() {
                            possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                        }
                    };
                }(handler);
            }, ZalgoPromise.try = function(method, context, args) {
                if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                var result;
                startActive();
                try {
                    result = method.apply(context, args || []);
                } catch (err) {
                    return endActive(), ZalgoPromise.reject(err);
                }
                return endActive(), ZalgoPromise.resolve(result);
            }, ZalgoPromise.delay = function(_delay) {
                return new ZalgoPromise(function(resolve) {
                    setTimeout(resolve, _delay);
                });
            }, ZalgoPromise.isPromise = function(value) {
                return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
            }, ZalgoPromise.flush = function() {
                return promise = flushPromise = flushPromise || new ZalgoPromise(), flushActive(), 
                promise;
                var promise;
            }, ZalgoPromise;
        }();
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return promise_ZalgoPromise;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var cross_domain_utils_src = __webpack_require__(7);
        function getUserAgent() {
            return window.navigator.mockUserAgent || window.navigator.userAgent;
        }
        function isDevice() {
            return !!getUserAgent().match(/Android|webOS|iPhone|iPad|iPod|bada|Symbian|Palm|CriOS|BlackBerry|IEMobile|WindowsMobile|Opera Mini/i);
        }
        function isOperaMini(ua) {
            return void 0 === ua && (ua = getUserAgent()), ua.indexOf("Opera Mini") > -1;
        }
        function isIos(ua) {
            return void 0 === ua && (ua = getUserAgent()), /iPhone|iPod|iPad/.test(ua);
        }
        function isIE() {
            return !!window.document.documentMode || !(!window.navigator || "string" != typeof window.navigator.userAgent || !/Edge|MSIE/i.test(window.navigator.userAgent));
        }
        function isIEIntranet() {
            if (!function() {
                if (!isIE()) return !1;
                if (window.navigator && "string" == typeof window.navigator.userAgent) {
                    if (/MSIE 11\.0/i.test(window.navigator.userAgent)) return !0;
                    if (/Trident/i.test(window.navigator.userAgent) && /rv:11\.0/i.test(window.navigator.userAgent)) return !0;
                }
                return !1;
            }()) return !1;
            if (window.document.documentMode) try {
                var status = window.status;
                return window.status = "testIntranetMode", "testIntranetMode" === window.status && (window.status = status, 
                !0);
            } catch (err) {
                return !1;
            }
            return !1;
        }
        function supportsPopups(ua) {
            return void 0 === ua && (ua = getUserAgent()), !(function(ua) {
                return void 0 === ua && (ua = getUserAgent()), !!isIos(ua) && (!!function(ua) {
                    return void 0 === ua && (ua = getUserAgent()), /\bGSA\b/.test(ua);
                }(ua) || /.+AppleWebKit(?!.*Safari)/.test(ua));
            }(ua) || function(ua) {
                return void 0 === ua && (ua = getUserAgent()), !!function(ua) {
                    return void 0 === ua && (ua = getUserAgent()), /Android/.test(ua);
                }(ua) && /Version\/[\d.]+/.test(ua) && !isOperaMini(ua);
            }(ua) || isOperaMini(ua) || function(ua) {
                return void 0 === ua && (ua = getUserAgent()), /FxiOS/i.test(ua);
            }(ua) || function(ua) {
                return void 0 === ua && (ua = getUserAgent()), /EdgiOS/i.test(ua);
            }(ua) || function(ua) {
                return void 0 === ua && (ua = getUserAgent()), -1 !== ua.indexOf("FBAN") || -1 !== ua.indexOf("FBAV");
            }(ua) || function(ua) {
                return void 0 === ua && (ua = getUserAgent()), /QQBrowser/.test(ua);
            }(ua) || (userAgent = getUserAgent(), /\belectron\b/i.test(userAgent)) || function() {
                var userAgent = getUserAgent();
                return /Macintosh.*AppleWebKit(?!.*Safari)/i.test(userAgent);
            }() || !Boolean(Object(cross_domain_utils_src.l)(Object(cross_domain_utils_src.n)(window) || window)) && (!0 === window.navigator.standalone || window.matchMedia("(display-mode: standalone)").matches));
            var userAgent;
        }
        var util = __webpack_require__(12), post_robot_src = __webpack_require__(13), client = __webpack_require__(4), config = __webpack_require__(3), constants = __webpack_require__(0), zalgo_promise_src = __webpack_require__(1);
        function isDocumentReady() {
            return Boolean(document.body) && "complete" === document.readyState;
        }
        var documentReady = new zalgo_promise_src.a(function(resolve) {
            if (isDocumentReady()) return resolve();
            var interval = setInterval(function() {
                if (isDocumentReady()) return clearInterval(interval), resolve();
            }, 10);
        });
        function loadScript(src, timeout, attrs) {
            return void 0 === timeout && (timeout = 0), void 0 === attrs && (attrs = {}), new zalgo_promise_src.a(function(resolve, reject) {
                var script = document.createElement("script");
                script.addEventListener("load", function() {
                    resolve();
                }), script.onreadystatechange = function() {
                    "complete" !== this.readyState && "loaded" !== this.readyState || resolve();
                };
                var scriptLoadError = new Error("script_loading_error");
                script.addEventListener("error", function() {
                    return reject(scriptLoadError);
                }), timeout && setTimeout(function() {
                    return reject(new Error("script_loading_timed_out"));
                }, timeout);
                for (var _i2 = 0, _Object$keys2 = Object.keys(attrs); _i2 < _Object$keys2.length; _i2++) {
                    var attr = _Object$keys2[_i2];
                    script.setAttribute(attr, attrs[attr]);
                }
                script.setAttribute("src", src), document.getElementsByTagName("head")[0].appendChild(script);
            });
        }
        function getElement(item) {
            if (item) {
                if (item instanceof HTMLElement) return item;
                if ("string" == typeof item) {
                    if (document.querySelector) {
                        var result = document.querySelector(item);
                        if (result) return result;
                    }
                    return document.getElementById(item);
                }
            }
        }
        function getElements(collection) {
            if (!collection) return [];
            if (collection instanceof HTMLElement || "string" == typeof collection) {
                var element = getElement(collection);
                return element ? [ element ] : [];
            }
            if (Array.isArray(collection) || collection instanceof NodeList || collection instanceof HTMLCollection) {
                for (var result = [], i = 0; i < collection.length; i++) {
                    var el = getElement(collection[i]);
                    el && result.push(el);
                }
                return result;
            }
            return [];
        }
        function onDocumentReady(method) {
            return documentReady.then(method);
        }
        documentReady.then(function() {
            if (document.body) return document.body;
            throw new Error("Document ready but document.body not present");
        });
        var parseQuery = Object(util.i)(function(queryString) {
            var params = {};
            if (!queryString) return params;
            if (-1 === queryString.indexOf("=")) return params;
            for (var _i4 = 0, _queryString$split2 = queryString.split("&"); _i4 < _queryString$split2.length; _i4++) {
                var pair = _queryString$split2[_i4];
                (pair = pair.split("="))[0] && pair[1] && (params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]));
            }
            return params;
        });
        function getQueryParam(name) {
            return parseQuery(window.location.search.slice(1))[name];
        }
        function urlWillRedirectPage(url) {
            return -1 === url.indexOf("#") || 0 !== url.indexOf("#") && url.split("#")[0] !== window.location.href.split("#")[0];
        }
        function extendUrl(url, params) {
            void 0 === params && (params = {});
            var hasHash = url.indexOf("#") > 0, _url$split = url.split("#"), serverUrl = _url$split[0], hash = _url$split[1];
            if (hash && !serverUrl) {
                var _ref = [ "#" + hash, "" ];
                serverUrl = _ref[0], hash = _ref[1];
            }
            var _serverUrl$split = serverUrl.split("?"), originalUrl = _serverUrl$split[0], originalQueryString = _serverUrl$split[1];
            if (originalQueryString) {
                var originalQuery = parseQuery(originalQueryString);
                for (var _key in originalQuery) params.hasOwnProperty(_key) || (params[_key] = originalQuery[_key]);
            }
            var newQueryString = Object.keys(params).filter(function(key) {
                return key && params[key];
            }).sort().map(function(key) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
            }).join("&"), newUrl = originalUrl;
            return newQueryString && (newUrl = newUrl + "?" + newQueryString), hasHash && (newUrl = newUrl + "#" + (hash || "")), 
            newUrl;
        }
        function redirect(win, url) {
            return void 0 === win && (win = window), new zalgo_promise_src.a(function(resolve) {
                Object(client.k)("redirect", {
                    url: url
                }), setTimeout(function() {
                    win.location = url, urlWillRedirectPage(url) || resolve();
                }, 1);
            });
        }
        function normalizeLocale(locale) {
            if (locale && locale.match(/^[a-z]{2}[-_][A-Z]{2}$/)) {
                var _locale$split = locale.split(/[-_]/), lang = _locale$split[0], country = _locale$split[1];
                if (constants.z[country] && -1 !== constants.z[country].indexOf(lang)) return {
                    country: country,
                    lang: lang
                };
            }
        }
        function normalizeLang(lang) {
            if (lang && lang.match(/^[a-z]{2}$/) && constants.y[lang]) return {
                country: constants.y[lang],
                lang: lang
            };
        }
        var getBrowserLocale = Object(util.i)(function() {
            for (var locales = function() {
                var nav = window.navigator, locales = nav.languages ? [].slice.apply(nav.languages) : [];
                return nav.language && locales.push(nav.language), nav.userLanguage && locales.push(nav.userLanguage), 
                locales;
            }(), _i6 = 0; _i6 < locales.length; _i6++) {
                var locale = locales[_i6], loc = normalizeLocale(locale);
                if (loc) return Object(client.k)("better_browser_locale_full"), loc;
                if (loc = normalizeLang(locale)) return Object(client.k)("better_browser_locale_lang"), 
                loc;
            }
            return config.a.defaultLocale;
        });
        function isElementVisible(el) {
            return Boolean(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        }
        var enablePerformance = Object(util.i)(function() {
            return Boolean(window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1e3 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0);
        });
        function getPageRenderTime() {
            return documentReady.then(function() {
                if (enablePerformance()) {
                    var timing = window.performance.timing;
                    return timing.connectEnd && timing.domInteractive ? timing.domInteractive - timing.connectEnd : void 0;
                }
            });
        }
        function getResourceLoadTime(url) {
            if (enablePerformance() && window.performance && "function" == typeof window.performance.getEntries) for (var entries = window.performance.getEntries(), i = 0; i < entries.length; i++) {
                var entry = entries[i];
                if (entry && entry.name === url && entry.duration && entry.duration >= 0 && entry.duration <= 6e4) return Math.floor(entry.duration);
            }
        }
        function allowIframe() {
            if (!supportsPopups()) return !0;
            var parentWindow = Object(cross_domain_utils_src.m)(window);
            if (parentWindow && Object(cross_domain_utils_src.u)(parentWindow)) return !0;
            var parentComponentWindow = window.xchild && window.xchild.getParentComponentWindow();
            return !(!parentComponentWindow || !Object(cross_domain_utils_src.u)(parentComponentWindow));
        }
        function isPayPalDomain() {
            return Boolean((window.location.protocol + "//" + window.location.host).match(config.a.paypal_domain_regex)) || "mock://www.paypal.com" === window.mockDomain;
        }
        var accessedStorage, LOCAL_STORAGE_KEY = "__paypal_storage__", SESSION_KEY = "__paypal_session__", GLOBAL_KEY = "__paypal_global__";
        function getStorageState(handler) {
            var storage, localStorageEnabled = Object(util.f)();
            if (accessedStorage && (storage = accessedStorage), !storage && localStorageEnabled) {
                var rawStorage = window.localStorage.getItem(LOCAL_STORAGE_KEY);
                rawStorage && (storage = JSON.parse(rawStorage));
            }
            storage || (storage = window[LOCAL_STORAGE_KEY]), storage || (storage = {
                id: Object(util.s)()
            }), storage.id || (storage.id = Object(util.s)()), accessedStorage = storage;
            var result = handler(storage);
            return localStorageEnabled ? window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storage)) : window[LOCAL_STORAGE_KEY] = storage, 
            accessedStorage = null, result;
        }
        function getSession(handler) {
            return getStorageState(function(storage) {
                var session = storage[SESSION_KEY], now = Date.now();
                return session && now - session.created > config.a.session_uid_lifetime && (session = null), 
                session || (session = {
                    guid: Object(util.s)(),
                    created: now
                }), storage[SESSION_KEY] = session, handler(session);
            });
        }
        function getSessionState(handler) {
            return getSession(function(session) {
                return session.state = session.state || {}, handler(session.state);
            });
        }
        function getSessionID() {
            var xprops = window.xprops;
            if (xprops && xprops.sessionID) return xprops.sessionID;
            var querySessionID = getQueryParam("sessionID");
            return isPayPalDomain() && querySessionID ? querySessionID : getSession(function(session) {
                return session.guid;
            });
        }
        function getButtonSessionID() {
            if (window.xprops && window.xprops.buttonSessionID) return window.xprops.buttonSessionID;
            var querySessionID = getQueryParam("buttonSessionID");
            return isPayPalDomain() && querySessionID ? querySessionID : void 0;
        }
        function getRefererDomain() {
            return window.xchild && window.xchild.getParentDomain ? window.xchild.getParentDomain() : window.location.host;
        }
        var setupProxyLogTransport = Object(util.k)(function() {
            Object(client.o)(function(name, win, originalMethod) {
                if (win && Object(cross_domain_utils_src.g)() === config.a.paypalDomain && !Object(cross_domain_utils_src.u)(win)) return win && Object(post_robot_src.send)(win, "proxy_log", {
                    originalMethod: originalMethod
                }).catch(util.j), originalMethod;
                var methods = [];
                return Object(post_robot_src.on)("proxy_log", {
                    domain: config.a.paypal_domain_regex
                }, function(_ref) {
                    methods.push(_ref.data.originalMethod);
                }), function() {
                    var _this = this, _arguments = arguments;
                    return (methods = methods.filter(function(method) {
                        return !Object(cross_domain_utils_src.y)(method.source);
                    })).length ? methods[methods.length - 1].apply(this, arguments).catch(function() {
                        return originalMethod.apply(_this, _arguments);
                    }) : originalMethod.apply(this, arguments);
                };
            }(0, Object(cross_domain_utils_src.m)(window), Object(client.i)()));
        });
        function initLogger() {
            setupProxyLogTransport(), Object(client.c)(function() {
                return {
                    referer: getRefererDomain(),
                    host: window.location.host,
                    path: window.location.pathname,
                    env: config.a.env,
                    country: config.a.locale.country,
                    lang: config.a.locale.lang,
                    uid: getSessionID(),
                    ver: "4.0.282"
                };
            }), Object(client.a)(function() {
                return {
                    "x-app-name": "checkoutjs"
                };
            }), Object(client.b)(function() {
                return {
                    state: config.a.state
                };
            }), Object(client.d)(function(payload) {
                var _ref;
                void 0 === payload && (payload = {});
                var contextType, contextID, sessionID = getSessionID(), paymentToken = function() {
                    if (window.root && window.root.token) return window.root.token;
                    if (isPayPalDomain()) {
                        var queryToken = getQueryParam("token");
                        if (queryToken) return queryToken;
                    }
                }(), buttonSessionID = payload[constants.u.KEY.BUTTON_SESSION_UID] || getButtonSessionID();
                return paymentToken ? (contextType = constants.u.CONTEXT_TYPE[constants.B.EC_TOKEN], 
                contextID = paymentToken) : buttonSessionID ? (contextType = constants.u.CONTEXT_TYPE.BUTTON_SESSION_ID, 
                contextID = buttonSessionID) : (contextType = payload[constants.u.KEY.CONTEXT_TYPE], 
                contextID = payload[constants.u.KEY.CONTEXT_ID]), (_ref = {})[constants.u.KEY.FEED] = constants.u.FEED.CHECKOUTJS, 
                _ref[constants.u.KEY.DATA_SOURCE] = constants.u.DATA_SOURCE.CHECKOUT, _ref[constants.u.KEY.CONTEXT_TYPE] = contextType, 
                _ref[constants.u.KEY.CONTEXT_ID] = contextID, _ref[constants.u.KEY.SELLER_ID] = config.a.merchantID, 
                _ref[constants.u.KEY.SESSION_UID] = sessionID, _ref[constants.u.KEY.BUTTON_SESSION_UID] = buttonSessionID, 
                _ref[constants.u.KEY.VERSION] = config.a.version, _ref[constants.u.KEY.TOKEN] = paymentToken, 
                _ref[constants.u.KEY.REFERER] = getRefererDomain(), _ref;
            }), window.location.protocol !== cross_domain_utils_src.a.FILE && Object(client.l)({
                uri: config.a.loggerUrl,
                heartbeat: !1,
                logPerformance: !1,
                prefix: "ppxo",
                logLevel: "warn"
            });
        }
        function setLogLevel(logLevel) {
            if (-1 === client.m.indexOf(logLevel)) throw new Error("Invalid logLevel: " + logLevel);
            config.a.logLevel = logLevel, client.e.logLevel = logLevel, post_robot_src.CONFIG.LOG_LEVEL = logLevel, 
            window.LOG_LEVEL = logLevel;
        }
        var bowserCache = {};
        function getBowser() {
            var userAgent = getUserAgent();
            if (bowserCache[userAgent]) return bowserCache[userAgent];
            delete __webpack_require__.c[36];
            var bowser = __webpack_require__(36);
            return bowserCache[userAgent] = bowser, bowser;
        }
        function getBrowser() {
            for (var bowser = getBowser(), _i2 = 0, _Object$keys2 = Object.keys(config.a.SUPPORTED_BROWSERS); _i2 < _Object$keys2.length; _i2++) {
                var browser = _Object$keys2[_i2];
                if (bowser[browser]) return {
                    browser: browser,
                    version: bowser.version
                };
            }
            return {};
        }
        var eligibilityResults = {};
        function isEligible() {
            if (isIEIntranet()) return !1;
            var userAgent = window.navigator.userAgent;
            if (userAgent && eligibilityResults.hasOwnProperty(userAgent)) return eligibilityResults[userAgent];
            var result = function() {
                if (isIEIntranet()) return !1;
                var bowser = getBowser(), _getBrowser = getBrowser(), browser = _getBrowser.browser, version = _getBrowser.version;
                return !browser || !version || -1 !== bowser.compareVersions([ version, config.a.SUPPORTED_BROWSERS[browser] ]);
            }();
            return eligibilityResults[userAgent] = result, result;
        }
        var checkRecognizedBrowser = Object(util.k)(function(state) {
            if (!getBrowser().browser) {
                var _getBowser = getBowser(), name = _getBowser.name, version = _getBowser.version, mobile = _getBowser.mobile, android = _getBowser.android, ios = _getBowser.ios;
                Object(client.k)("unrecognized_browser_" + state, {
                    name: name,
                    version: version,
                    mobile: mobile,
                    android: android,
                    ios: ios
                }), Object(client.h)();
            }
        });
        function logWarn(err) {
            if (window.console) {
                if (window.console.warn) return window.console.warn(err);
                if (window.console.log) return window.console.log(err);
            }
        }
        function checkForCommonErrors() {
            var mHttp, mContent;
            "[]" !== JSON.stringify([]) && (logWarn([].toJSON ? "Custom Array.prototype.toJSON is causing incorrect json serialization of arrays. This is likely to cause issues. Probable cause is Prototype.js" : "JSON.stringify is doing incorrect serialization of arrays. This is likely to cause issues."), 
            Object(client.q)("json_stringify_array_broken")), "{}" !== JSON.stringify({}) && (logWarn("JSON.stringify is doing incorrect serialization of objects. This is likely to cause issues."), 
            Object(client.q)("json_stringify_object_broken")), isIEIntranet() && Object(client.q)("ie_intranet_mode"), 
            !isIE() || (mHttp = window.document.querySelector('meta[http-equiv="X-UA-Compatible"]'), 
            mContent = window.document.querySelector('meta[content="IE=edge"]'), mHttp && mContent) || Object(client.q)("ie_meta_compatibility_header_missing", {
                message: 'Drop tag: <meta http-equiv="X-UA-Compatible" content="IE=edge">'
            }), 3 !== function(bar, baz, zomg) {}.bind({
                a: 1
            }).length && Object(client.q)("function_bind_arrity_overwritten"), window.opener && window.parent !== window && Object(client.q)("window_has_opener_and_parent"), 
            window.name && 0 === window.name.indexOf("__prerender") && Object(client.q)("prerender_running_checkoutjs");
            var context = {};
            (function() {
                return this;
            }).bind(context)() !== context && Object(client.q)("function_bind_broken"), window.Window && window.constructor && window.Window !== window.constructor && Object(client.q)("window_constructor_does_not_match_window"), 
            Object.assign && JSON.stringify({
                a: 1,
                b: 2,
                c: 3
            }) != JSON.stringify({
                a: 1,
                b: 2,
                c: 3
            }) && Object(client.q)("object_assign_broken");
        }
        var esm_extends = __webpack_require__(11), HEADERS = {
            CONTENT_TYPE: "content-type",
            ACCEPT: "accept"
        }, headerBuilders = [], corrids = [];
        function request(_ref) {
            var url = _ref.url, _ref$method = _ref.method, method = void 0 === _ref$method ? "get" : _ref$method, _ref$headers = _ref.headers, headers = void 0 === _ref$headers ? {} : _ref$headers, json = _ref.json, data = _ref.data, body = _ref.body, _ref$win = _ref.win, win = void 0 === _ref$win ? window : _ref$win, _ref$timeout = _ref.timeout, timeout = void 0 === _ref$timeout ? 0 : _ref$timeout;
            return "/demo/checkout/api/braintree/client-token/" === url ? zalgo_promise_src.a.resolve("eyJ2ZXJzaW9uIjoyLCJhdXRob3JpemF0aW9uRmluZ2VycHJpbnQiOiJjMDFhZmRkM2Y1OTJmNWVhNTNlMzE5MWQwYmIyMWVjYjM5NzNlZGM1MzkwNDZiMjJmNTA2ODEyNzIzZmRlMTJifGNsaWVudF9pZD1jbGllbnRfaWQkc2FuZGJveCQ0ZHByYmZjNnBoNTk1Y2NqXHUwMDI2Y3JlYXRlZF9hdD0yMDE3LTA0LTI2VDIzOjI2OjU5Ljg3OTA3ODYwNiswMDAwXHUwMDI2bWVyY2hhbnRfaWQ9M3cydHR2d2QyNDY1NDhoZCIsImNvbmZpZ1VybCI6Imh0dHBzOi8vYXBpLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb206NDQzL21lcmNoYW50cy8zdzJ0dHZ3ZDI0NjU0OGhkL2NsaWVudF9hcGkvdjEvY29uZmlndXJhdGlvbiIsImNoYWxsZW5nZXMiOltdLCJlbnZpcm9ubWVudCI6InNhbmRib3giLCJjbGllbnRBcGlVcmwiOiJodHRwczovL2FwaS5zYW5kYm94LmJyYWludHJlZWdhdGV3YXkuY29tOjQ0My9tZXJjaGFudHMvM3cydHR2d2QyNDY1NDhoZC9jbGllbnRfYXBpIiwiYXNzZXRzVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhdXRoVXJsIjoiaHR0cHM6Ly9hdXRoLnZlbm1vLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhbmFseXRpY3MiOnsidXJsIjoiaHR0cHM6Ly9jbGllbnQtYW5hbHl0aWNzLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20vM3cydHR2d2QyNDY1NDhoZCJ9LCJ0aHJlZURTZWN1cmVFbmFibGVkIjpmYWxzZSwicGF5cGFsRW5hYmxlZCI6dHJ1ZSwicGF5cGFsIjp7ImRpc3BsYXlOYW1lIjoiYmFyY28uMDMtZmFjaWxpdGF0b3JAZ21haWwuY29tIiwiY2xpZW50SWQiOiJBV3VZdnFnMGtaN2Y5S0V4TVpqZU53T3RjQV8yZVhnOWpMZy1QSnBGX0pnYk44M0YyVml5aEdnV2JCNDg4RGU3MFpucGRBZEI2TUNqekNqSyIsInByaXZhY3lVcmwiOiJodHRwczovL2V4YW1wbGUuY29tIiwidXNlckFncmVlbWVudFVybCI6Imh0dHBzOi8vZXhhbXBsZS5jb20iLCJiYXNlVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhc3NldHNVcmwiOiJodHRwczovL2NoZWNrb3V0LnBheXBhbC5jb20iLCJkaXJlY3RCYXNlVXJsIjpudWxsLCJhbGxvd0h0dHAiOnRydWUsImVudmlyb25tZW50Tm9OZXR3b3JrIjpmYWxzZSwiZW52aXJvbm1lbnQiOiJvZmZsaW5lIiwidW52ZXR0ZWRNZXJjaGFudCI6ZmFsc2UsImJyYWludHJlZUNsaWVudElkIjoibWFzdGVyY2xpZW50MyIsImJpbGxpbmdBZ3JlZW1lbnRzRW5hYmxlZCI6dHJ1ZSwibWVyY2hhbnRBY2NvdW50SWQiOiJVU0QiLCJjdXJyZW5jeUlzb0NvZGUiOiJVU0QifSwiY29pbmJhc2VFbmFibGVkIjpmYWxzZSwibWVyY2hhbnRJZCI6IjN3MnR0dndkMjQ2NTQ4aGQiLCJ2ZW5tbyI6Im9mZiJ9") : new zalgo_promise_src.a(function(resolve, reject) {
                if (json && data || json && body || data && json) throw new Error("Only options.json or options.data or options.body should be passed");
                for (var normalizedHeaders = {}, _i4 = 0, _Object$keys2 = Object.keys(headers); _i4 < _Object$keys2.length; _i4++) {
                    var _key2 = _Object$keys2[_i4];
                    normalizedHeaders[_key2.toLowerCase()] = headers[_key2];
                }
                json ? normalizedHeaders[HEADERS.CONTENT_TYPE] = normalizedHeaders[HEADERS.CONTENT_TYPE] || "application/json" : (data || body) && (normalizedHeaders[HEADERS.CONTENT_TYPE] = normalizedHeaders[HEADERS.CONTENT_TYPE] || "application/x-www-form-urlencoded; charset=utf-8"), 
                normalizedHeaders[HEADERS.ACCEPT] = normalizedHeaders[HEADERS.ACCEPT] || "application/json";
                for (var _i6 = 0; _i6 < headerBuilders.length; _i6++) for (var builtHeaders = (0, 
                headerBuilders[_i6])(), _i8 = 0, _Object$keys4 = Object.keys(builtHeaders); _i8 < _Object$keys4.length; _i8++) {
                    var _key3 = _Object$keys4[_i8];
                    normalizedHeaders[_key3.toLowerCase()] = builtHeaders[_key3];
                }
                var xhr = new win.XMLHttpRequest();
                for (var _key4 in xhr.addEventListener("load", function() {
                    var responseHeaders = function(rawHeaders) {
                        void 0 === rawHeaders && (rawHeaders = "");
                        for (var result = {}, _i2 = 0, _rawHeaders$trim$spli2 = rawHeaders.trim().split("\n"); _i2 < _rawHeaders$trim$spli2.length; _i2++) {
                            var _line$split = _rawHeaders$trim$spli2[_i2].split(":"), _key = _line$split[0], values = _line$split.slice(1);
                            result[_key.toLowerCase()] = values.join(":").trim();
                        }
                        return result;
                    }(this.getAllResponseHeaders()), corrID = responseHeaders["paypal-debug-id"] || "unknown";
                    if (responseHeaders["paypal-debug-id"] && corrids.push(responseHeaders["paypal-debug-id"]), 
                    !this.status) return reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: no response status code. Correlation id: " + corrID));
                    var contentType = responseHeaders["content-type"], isJSON = contentType && (0 === contentType.indexOf("application/json") || 0 === contentType.indexOf("text/json")), res = this.responseText;
                    try {
                        res = JSON.parse(this.responseText);
                    } catch (err) {
                        if (isJSON) return reject(new Error("Invalid json: " + this.responseText + ". Correlation id: " + corrID));
                    }
                    if (this.status >= 400) {
                        var message = "Request to " + method.toLowerCase() + " " + url + " failed with " + this.status + " error. Correlation id: " + corrID;
                        return res && ("object" == typeof res && null !== res && (res = JSON.stringify(res, null, 4)), 
                        message = message + "\n\n" + res + "\n"), reject(new Error(message));
                    }
                    return resolve(res);
                }, !1), xhr.addEventListener("error", function(evt) {
                    var corrID = this.getResponseHeader("paypal-debug-id");
                    reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: " + evt.toString() + ". Correlation id: " + corrID));
                }, !1), xhr.open(method, url, !0), normalizedHeaders) normalizedHeaders.hasOwnProperty(_key4) && xhr.setRequestHeader(_key4, normalizedHeaders[_key4]);
                json ? body = JSON.stringify(json) : data && (body = Object.keys(data).map(function(key) {
                    return encodeURIComponent(key) + "=" + (data ? encodeURIComponent(data[key]) : "");
                }).join("&")), xhr.timeout = timeout, xhr.ontimeout = function() {
                    reject(new Error("Request to " + method.toLowerCase() + " " + url + " has timed out"));
                }, xhr.send(body);
            });
        }
        Object(client.c)(function() {
            return {
                prev_corr_ids: corrids.join(",")
            };
        }), request.get = function(url, options) {
            return void 0 === options && (options = {}), request(Object(esm_extends.a)({
                method: "get",
                url: url
            }, options));
        }, request.post = function(url, data, options) {
            return void 0 === options && (options = {}), request(Object(esm_extends.a)({
                method: "post",
                url: url,
                data: data
            }, options));
        }, request.addHeaderBuilder = function(method) {
            headerBuilders.push(method);
        };
        var THROTTLE_GROUP = {
            TEST: "test",
            CONTROL: "control",
            THROTTLE: "throttle"
        };
        function getThrottle(name, sample) {
            var group, uid = getStorageState(function(storage) {
                return storage.id;
            }), throttle = function(name) {
                return getStorageState(function(storage) {
                    return storage.throttlePercentiles = storage.throttlePercentiles || {}, storage.throttlePercentiles[name] = storage.throttlePercentiles[name] || Math.floor(100 * Math.random()), 
                    storage.throttlePercentiles[name];
                });
            }(name), treatment = name + "_" + (group = throttle < sample ? THROTTLE_GROUP.TEST : sample >= 50 || sample <= throttle && throttle < 2 * sample ? THROTTLE_GROUP.CONTROL : THROTTLE_GROUP.THROTTLE), started = !1, forced = !1;
            try {
                window.localStorage && window.localStorage.getItem(name) && (forced = !0);
            } catch (err) {}
            return {
                isEnabled: function() {
                    return group === THROTTLE_GROUP.TEST || forced;
                },
                isDisabled: function() {
                    return group !== THROTTLE_GROUP.TEST && !forced;
                },
                getTreatment: function() {
                    return treatment;
                },
                log: function(checkpointName, payload) {
                    var _extends2;
                    if (void 0 === payload && (payload = {}), !started) return this;
                    var checkpoint = name + "_" + treatment + "_" + checkpointName;
                    return Object(client.k)(checkpoint, Object(esm_extends.a)({}, payload, {
                        expuid: uid
                    })), Object(client.p)(Object(esm_extends.a)(((_extends2 = {})[constants.u.KEY.EXPERIMENT_NAME] = name, 
                    _extends2[constants.u.KEY.TREATMENT_NAME] = treatment, _extends2), payload)), Object(client.h)(), 
                    this;
                },
                logStart: function(payload) {
                    return void 0 === payload && (payload = {}), started = !0, this.log("start", payload);
                },
                logComplete: function(payload) {
                    return void 0 === payload && (payload = {}), started ? this.log("complete", payload) : this;
                }
            };
        }
        function getReturnToken() {
            var token = Object(util.g)(window.location.href, /token=((EC-)?[A-Z0-9]+)/), payer = Object(util.g)(window.location.href, /PayerID=([A-Z0-9]+)/);
            if (token && payer) return token;
        }
        var getCurrentScript = Object(util.i)(function() {
            for (var scripts = [].slice.call(document.getElementsByTagName("script")), _i2 = 0; _i2 < scripts.length; _i2++) {
                var script = scripts[_i2];
                if (script.src && (script.src.replace(/^https?:/, "").split("?")[0] === config.a.scriptUrl || script.hasAttribute("data-paypal-checkout"))) return script;
                if (script.src && -1 !== script.src.indexOf("paypal.checkout.v4.js")) return script;
            }
            document.currentScript && Object(client.f)("current_script_not_recognized", {
                src: document.currentScript.src
            });
        });
        function getScriptVersion() {
            return "4.0.282";
        }
        function getCurrentScriptUrl() {
            var script = getCurrentScript();
            if (script && "string" == typeof script.src) {
                var scriptUrl = script.src;
                return 0 === scriptUrl.indexOf("http://www.paypalobjects.com") && (scriptUrl = scriptUrl.replace("http://", "https://")), 
                scriptUrl;
            }
            return "https://www.paypalobjects.com/api/checkout.4.0.282.js";
        }
        function getDomainSetting(name, def) {
            var hostname = window.xchild ? window.xchild.getParentDomain() : Object(cross_domain_utils_src.g)();
            if (config.a.domain_settings) for (var _i4 = 0, _Object$keys2 = Object.keys(config.a.domain_settings); _i4 < _Object$keys2.length; _i4++) {
                var domain = _Object$keys2[_i4];
                if (Object(util.b)(hostname, domain)) return config.a.domain_settings[domain][name];
            }
            return def;
        }
        var openMetaFrame = Object(util.i)(function(env) {
            return void 0 === env && (env = config.a.env), zalgo_promise_src.a.try(function() {
                if (isIEIntranet()) return {
                    iframeEligible: !1,
                    iframeEligibleReason: "ie_intranet",
                    rememberedFunding: []
                };
                var metaFrameUrl = config.a.metaFrameUrls[env], metaFrameDomain = config.a.paypalDomains[env];
                return zalgo_promise_src.a.try(function() {
                    if (!post_robot_src.bridge) throw new Error("Opening meta window without bridge support is not currently supported");
                    var metaListener = Object(post_robot_src.once)("meta", {
                        domain: metaFrameDomain
                    });
                    return post_robot_src.bridge.openBridge(extendUrl(metaFrameUrl, {
                        version: "4.0.282"
                    }), metaFrameDomain).then(function() {
                        return metaListener;
                    }).then(function(_ref) {
                        return _ref.data;
                    });
                });
            });
        });
        function getRememberedFunding(handler) {
            return void 0 === handler && (handler = util.e), getStorageState(function(storage) {
                return storage.rememberedFunding = storage.rememberedFunding || [], handler(storage.rememberedFunding);
            });
        }
        function hasRememberedFunding(source) {
            return !!getRememberedFunding(function(rememberedFunding) {
                return -1 !== rememberedFunding.indexOf(source);
            }) || !!getSessionState(function(session) {
                return session.recentlyCheckedRemembered;
            });
        }
        function getRememberedFundingPromises() {
            return handler = function(global) {
                return global.rememberFundingPromises = global.rememberFundingPromises || {}, global.rememberFundingPromises;
            }, window[GLOBAL_KEY] = window[GLOBAL_KEY] || {}, handler(window[GLOBAL_KEY]);
            var handler;
        }
        function getRememberedFundingPromise(source) {
            var promises = getRememberedFundingPromises(), promise = promises[source] = promises[source] || new zalgo_promise_src.a();
            return hasRememberedFunding(source) && promise.resolve(function(source) {
                if (getRememberedFunding(function(rememberedFunding) {
                    return -1 !== rememberedFunding.indexOf(source);
                })) return !0;
                if (getSessionState(function(session) {
                    return session.recentlyCheckedRemembered;
                })) return !1;
                throw new Error("Can not find remembered funding result");
            }(source)), promise;
        }
        function rememberFunding(sources) {
            getRememberedFunding(function(rememberedFunding) {
                for (var _i4 = 0; _i4 < sources.length; _i4++) {
                    var source = sources[_i4];
                    (source !== constants.v.VENMO || isDevice()) && -1 === rememberedFunding.indexOf(source) && rememberedFunding.push(source);
                }
                !function() {
                    for (var promises = getRememberedFundingPromises(), rememberedFunding = getRememberedFunding(function(sources) {
                        return sources;
                    }), _i2 = 0, _Object$keys2 = Object.keys(promises); _i2 < _Object$keys2.length; _i2++) {
                        var source = _Object$keys2[_i2];
                        promises[source].resolve(-1 !== rememberedFunding.indexOf(source));
                    }
                }();
            }), getSessionState(function(session) {
                session.recentlyCheckedRemembered = !0;
            });
        }
        function loadMeta() {
            return openMetaFrame().then(function(_ref) {
                rememberFunding(_ref.rememberedFunding || []);
            });
        }
        function isFundingRemembered(source) {
            return void 0 === source && (source = constants.v.PAYPAL), hasRememberedFunding(source) ? getRememberedFundingPromise(source) : loadMeta().then(function() {
                return getRememberedFundingPromise(source);
            });
        }
        function precacheRememberedFunding() {
            return getSessionState(function(session) {
                return session.recentlyCheckedRemembered;
            }) ? zalgo_promise_src.a.resolve() : loadMeta();
        }
        __webpack_require__(6), __webpack_require__.d(__webpack_exports__, "z", function() {
            return isDevice;
        }), __webpack_require__.d(__webpack_exports__, "F", function() {
            return isIos;
        }), __webpack_require__.d(__webpack_exports__, "D", function() {
            return isIE;
        }), __webpack_require__.d(__webpack_exports__, "E", function() {
            return isIEIntranet;
        }), __webpack_require__.d(__webpack_exports__, "W", function() {
            return supportsPopups;
        }), __webpack_require__.d(__webpack_exports__, "J", function() {
            return util.j;
        }), __webpack_require__.d(__webpack_exports__, "L", function() {
            return util.k;
        }), __webpack_require__.d(__webpack_exports__, "X", function() {
            return util.s;
        }), __webpack_require__.d(__webpack_exports__, "I", function() {
            return util.i;
        }), __webpack_require__.d(__webpack_exports__, "S", function() {
            return util.o;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return util.c;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return util.a;
        }), __webpack_require__.d(__webpack_exports__, "U", function() {
            return util.q;
        }), __webpack_require__.d(__webpack_exports__, "V", function() {
            return util.r;
        }), __webpack_require__.d(__webpack_exports__, "N", function() {
            return util.l;
        }), __webpack_require__.d(__webpack_exports__, "f", function() {
            return util.d;
        }), __webpack_require__.d(__webpack_exports__, "y", function() {
            return initLogger;
        }), __webpack_require__.d(__webpack_exports__, "T", function() {
            return setLogLevel;
        }), __webpack_require__.d(__webpack_exports__, "h", function() {
            return getBrowser;
        }), __webpack_require__.d(__webpack_exports__, "B", function() {
            return isEligible;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return checkRecognizedBrowser;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return checkForCommonErrors;
        }), __webpack_require__.d(__webpack_exports__, "H", function() {
            return loadScript;
        }), __webpack_require__.d(__webpack_exports__, "n", function() {
            return getElement;
        }), __webpack_require__.d(__webpack_exports__, "o", function() {
            return getElements;
        }), __webpack_require__.d(__webpack_exports__, "K", function() {
            return onDocumentReady;
        }), __webpack_require__.d(__webpack_exports__, "q", function() {
            return getQueryParam;
        }), __webpack_require__.d(__webpack_exports__, "Y", function() {
            return urlWillRedirectPage;
        }), __webpack_require__.d(__webpack_exports__, "g", function() {
            return extendUrl;
        }), __webpack_require__.d(__webpack_exports__, "P", function() {
            return redirect;
        }), __webpack_require__.d(__webpack_exports__, "i", function() {
            return getBrowserLocale;
        }), __webpack_require__.d(__webpack_exports__, "A", function() {
            return isElementVisible;
        }), __webpack_require__.d(__webpack_exports__, "p", function() {
            return getPageRenderTime;
        }), __webpack_require__.d(__webpack_exports__, "s", function() {
            return getResourceLoadTime;
        }), __webpack_require__.d(__webpack_exports__, "R", function() {
            return request;
        }), __webpack_require__.d(__webpack_exports__, "x", function() {
            return getThrottle;
        }), __webpack_require__.d(__webpack_exports__, "t", function() {
            return getReturnToken;
        }), __webpack_require__.d(__webpack_exports__, "w", function() {
            return getSessionState;
        }), __webpack_require__.d(__webpack_exports__, "v", function() {
            return getSessionID;
        }), __webpack_require__.d(__webpack_exports__, "j", function() {
            return getButtonSessionID;
        }), __webpack_require__.d(__webpack_exports__, "M", function() {
            return openMetaFrame;
        }), __webpack_require__.d(__webpack_exports__, "r", function() {
            return getRememberedFunding;
        }), __webpack_require__.d(__webpack_exports__, "Q", function() {
            return rememberFunding;
        }), __webpack_require__.d(__webpack_exports__, "C", function() {
            return isFundingRemembered;
        }), __webpack_require__.d(__webpack_exports__, "O", function() {
            return precacheRememberedFunding;
        }), __webpack_require__.d(__webpack_exports__, "k", function() {
            return getCurrentScript;
        }), __webpack_require__.d(__webpack_exports__, "u", function() {
            return getScriptVersion;
        }), __webpack_require__.d(__webpack_exports__, "l", function() {
            return getCurrentScriptUrl;
        }), __webpack_require__.d(__webpack_exports__, "m", function() {
            return getDomainSetting;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return allowIframe;
        }), __webpack_require__.d(__webpack_exports__, "G", function() {
            return isPayPalDomain;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var _altpayUris, _guestUris, _billingUris, _buttonUris, _inlinedCardFieldUris, _postBridgeUris, _legacyCheckoutUris, _buttonJSUrls, constants = __webpack_require__(0), config = {
            locales: constants.z,
            scriptUrl: "//www.paypalobjects.com/api/checkout.lib.js",
            paypal_domain_regex: /^(https?|mock):\/\/[a-zA-Z0-9_.-]+\.paypal\.com(:\d+)?$/,
            version: "4.0.282",
            cors: !0,
            env: "undefined" == typeof window || void 0 === window.location ? constants.t.PRODUCTION : -1 !== window.location.host.indexOf("localhost.paypal.com") ? constants.t.LOCAL : -1 !== window.location.host.indexOf("qa.paypal.com") ? constants.t.STAGE : -1 !== window.location.host.indexOf("sandbox.paypal.com") ? constants.t.SANDBOX : constants.t.PRODUCTION,
            state: "checkoutjs",
            locale: {
                country: constants.r.US,
                lang: constants.x.EN
            },
            stage: "msmaster",
            stageDomain: "qa.paypal.com",
            get stageUrl() {
                return config.stage + "." + config.stageDomain;
            },
            get apiStageUrl() {
                return config.apiStage + "." + config.stageDomain;
            },
            get localhostUrl() {
                return "http://localhost.paypal.com:" + config.ports.default;
            },
            set localhostUrl(val) {
                delete this.localhostUrl, this.localhostUrl = val;
            },
            merchantID: "",
            authCode: "",
            logLevel: "warn",
            throttles: {
                v4_mobile_device: 0
            },
            domain_settings: {
                "walmart.com": {
                    ie_full_page: !1,
                    allow_full_page_fallback: !0,
                    memoize_payment: !0,
                    force_bridge: !0,
                    log_authorize: !0
                },
                "ulta.com": {
                    disable_venmo: !0
                },
                "barnesandnoble.com": {
                    disable_venmo: !0
                },
                "bn.com": {
                    disable_venmo: !0
                },
                "agoratix.com": {
                    disable_venmo: !0
                },
                "tractorsupply.com": {
                    disable_venmo: !0
                },
                "etsy.com": {
                    ie_full_page: !1,
                    allow_full_page_fallback: !0,
                    memoize_payment: !0,
                    force_bridge: !0,
                    log_authorize: !0
                },
                "ticketmaster.com": {
                    disable_venmo: !0
                },
                "livenation.com": {
                    disable_venmo: !0
                },
                "frontgatetickets.com": {
                    disable_venmo: !0
                },
                "williams-sonoma.com": {
                    disable_venmo: !0
                },
                "westelm.com": {
                    disable_venmo: !0
                },
                "markandgraham.com": {
                    disable_venmo: !0
                },
                "potterybarn.com": {
                    disable_venmo: !0
                },
                "potterybarnkids.com": {
                    disable_venmo: !0
                },
                "pbteen.com": {
                    disable_venmo: !0
                },
                "beallsflorida.com": {
                    disable_venmo: !0
                },
                "therealreal.com": {
                    disable_venmo: !0
                },
                "liveaquaria.com": {
                    disable_venmo: !0
                },
                "drsfostersmith.com": {
                    disable_venmo: !0
                },
                "boxed.com": {
                    disable_venmo: !0
                },
                "bevisible.com": {
                    disable_venmo: !0
                },
                "moeller.org": {
                    disable_venmo: !0
                },
                "searshometownstores.com": {
                    disable_venmo: !0
                },
                "searshardwarestores.com": {
                    disable_venmo: !0
                },
                "searshomeapplianceshowroom.com": {
                    disable_venmo: !0
                },
                "barkshop.com": {
                    disable_venmo: !0
                },
                "vividseats.com": {
                    disable_venmo: !0
                },
                "getcargo.today": {
                    disable_venmo: !0
                },
                "smartdestinations.com": {
                    disable_venmo: !0
                },
                "philadelphiapass.com": {
                    disable_venmo: !0
                },
                "thesydneypass.com": {
                    disable_venmo: !0
                },
                "3secondlash.com": {
                    disable_venmo: !0
                },
                "newyorkpass.com": {
                    disable_venmo: !0
                },
                "dndbeyond.com": {
                    disable_venmo: !0
                },
                "app.zapbuy.it": {
                    disable_venmo: !0
                },
                "gamersaloon.com": {
                    disable_venmo: !0
                },
                "1800contacts.com": {
                    disable_venmo: !0
                },
                "shopchatters.ca": {
                    disable_venmo: !0
                },
                "shopguyswin.ca": {
                    disable_venmo: !0
                },
                "jjill.com": {
                    disable_venmo: !0
                },
                "qvc.com": {
                    disable_venmo: !0
                },
                "stelladot.com": {
                    disable_venmo: !0
                },
                "keepcollective.com": {
                    disable_venmo: !0
                },
                "everskin.com": {
                    disable_venmo: !0
                },
                "zulily.com": {
                    disable_venmo: !0
                },
                "freshly.com": {
                    disable_venmo: !0
                },
                "buypeticare.com": {
                    disable_venmo: !0
                },
                "getownzone.com": {
                    disable_venmo: !0
                },
                "uncommongoods.com": {
                    disable_venmo: !0
                },
                "onegold.com": {
                    disable_venmo: !0
                },
                "universitytees.com": {
                    disable_venmo: !0
                },
                "revolve.com": {
                    disable_venmo: !0
                },
                "functionofbeauty.com": {
                    disable_venmo: !0
                },
                "givebutter.com": {
                    disable_venmo: !0
                },
                "hausmart.com": {
                    disable_venmo: !0
                },
                "derbyjackpot.com": {
                    disable_venmo: !0
                },
                "ancestry.com": {
                    disable_venmo: !0
                },
                "boats.net": {
                    disable_venmo: !0
                },
                "partzilla.com": {
                    disable_venmo: !0
                },
                "firedog.com": {
                    disable_venmo: !0
                },
                "chick-fil-a.com": {
                    disable_venmo: !0
                },
                "roku.com": {
                    disable_venmo: !0
                },
                "barkbox.com": {
                    disable_venmo: !0
                },
                "neimanmarcus.com": {
                    disable_venmo: !0
                },
                "lastcall.com": {
                    disable_venmo: !0
                },
                "horchow.com": {
                    disable_venmo: !0
                },
                "bergdorfgoodman.com": {
                    disable_venmo: !0
                },
                "fwrd.com": {
                    disable_venmo: !0
                },
                "plunderdesign.com": {
                    disable_venmo: !0
                },
                "stitchfix.com": {
                    disable_venmo: !0
                },
                "revzilla.com": {
                    disable_venmo: !0
                },
                "cyclegear.com": {
                    disable_venmo: !0
                },
                "chegg.com": {
                    disable_venmo: !0
                },
                "youniqueproducts.com": {
                    disable_venmo: !0
                },
                "archives.com": {
                    disable_venmo: !0
                },
                "hautelook.com": {
                    disable_venmo: !0
                },
                "nordstromrack.com": {
                    disable_venmo: !0
                },
                "motherhoodcanada.ca": {
                    disable_venmo: !0
                },
                "atomtickets.com": {
                    disable_venmo: !0
                },
                "trademore.com": {
                    disable_venmo: !0
                },
                "lasheaseoffer.com": {
                    disable_venmo: !0
                },
                "rookie.paypalsixthman.com": {
                    disable_venmo: !0
                },
                "1800Contacts.com": {
                    disable_venmo: !0
                },
                "hulu.com": {
                    disable_venmo: !0
                },
                "grubhub.com": {
                    disable_venmo: !0
                },
                "eat24.com": {
                    disable_venmo: !0
                },
                "seamless.com": {
                    disable_venmo: !0
                },
                "freshfeetscrubber.com": {
                    disable_venmo: !0
                },
                "opensky.com": {
                    disable_venmo: !0
                },
                "dotandbo.com": {
                    disable_venmo: !0
                },
                "storenvy.com": {
                    disable_venmo: !0
                },
                "gemafina.com": {
                    disable_venmo: !0
                },
                "pickperfect.com": {
                    disable_venmo: !0
                },
                "55mulberry.com": {
                    disable_venmo: !0
                },
                "hollar.com": {
                    disable_venmo: !0
                },
                "bjs.com": {
                    disable_venmo: !0
                },
                "playsugarhouse.com": {
                    disable_venmo: !0
                },
                "lakeshorelearning.com": {
                    disable_venmo: !0
                },
                "llmhq.com": {
                    disable_venmo: !0
                },
                "gainful.com": {
                    disable_venmo: !0
                },
                "modaoperandi.com": {
                    disable_venmo: !0
                },
                "play.jackpocket.com": {
                    disable_venmo: !0
                }
            },
            creditTestDomains: [ "bluesuncorp.co.uk", "nationsphotolab.com", "plexusworldwide.com", "nshss.org", "bissell.com", "mobstub.com", "vuoriclothing.com", "tape4backup.com", "avivamiento.com", "rhododendron.org", "whiterabbitjapan.com", "atsracing.net", "thehilltopgallery.com", "weedtraqr.com", "worldpantry.com", "ciraconnect.com", "mymalls.com", "prowinch.com", "zodiacpoolsystems.com", "everlywell.com", "candlewarmers.com", "chop.edu", "incruises.com", "flikn.com", "didforsale.com", "mcc.org", "sygu.net", "merchbar.com", "eduinconline.com", "us.livebetterwith.com", "bakemeawish.com", "judolaunch.com", "eventcartel.com", "tapatalk.com", "telescope.com", "covenant.edu", "aquatruwater.com", "spingo.com", "usu.edu", "getcelerity.com", "brandless.com", "saberigniter.com", "euromodeltrains.com", "gofasttrader.com", "megamodzplanet.com", "draftanalyzer.com", "lovewithoutboundaries.com", "filterpop.com", "seekverify.com", "photoandgo.com", "sightseeingpass.com", "bigoanddukes.com", "thethirstyduck.com", "thebrushguys.com", "907delivery.com", "mauisails.com", "drive.net", "channelmax.net", "modernrebelco.com", "enchanteddiamonds.com", "ibabbleon.com", "fullgenomes.com", "conn-comp.com", "wingware.com", "paradigmgoods.com", "theneptunegroup.com", "kidzartworks.com", "unirealm.com", "ncfarmsinc.com", "oneofakindantiques.com", "servers4less.com", "stumpthespread.com", "marketwagon.com", "monsterhouseplans.com", "canterburychoral.org", "teacupnordic.org", "thethirstyduck.com", "medialoot.com", "theartistunion.com", "yourglamourzone.com", "breckstables.com", "mackephotography.com", "dsaj.org", "massluminosity.com", "tespa.org", "versatilearts.net", "yecup.org", "divinebusinessmanagement.com", "captivatebeautyservices.com", "class4me.com", "wcsonlineuniversity.com", "pvplive.com", "kyneteks.com", "rare-paper.com", "bpg.bpgsim.biz", "geodegallery.com", "way.com", "kringle.com", "talentedmrsalas.ph", "litcharts.com", "purpletreephotography.com", "apache.org", "neopackage.com", "globaldance.tv", "integral.studio", "airdoctorpro.com", "ivoryandiron.com", "yuengling.com", "averysbranchfarms.com", "amberreinink.com", "skinnymechocolate.com", "bmbl.net", "ncwatercolor.net", "astrograph.com", "localadventures.mx", "ripcurl.com", "worldfootbrakechallenge.com", "shespeakssales.com", "obrienguitars.com", "jadenikkolephoto.com", "americavoice.com", "cassiexie.com", "aamastateconvention.org", "rellesflorist.com", "passionnobby.com", "bodybyheidi.com", "roqos.com", "prijector.com", "maryswanson.net", "tsghobbies.com", "erinlaytonphotography.com", "darter.org", "fountainpenhospital.com", "myzestfullife.com", "pcog.org", "alisabethdesigns.com", "katiemathisphoto.com", "strictlybellaphotography.com", "maptools.com", "sites.google.com", "gallerr.com", "southfloridatrikke.com", "caviar.tv", "mintingmasters.com", "prospectorsguild.com", "inktale.com", "prettygirlgoods.com", "laceycahill.com", "daniellenowak.com", "t212.org", "scmsinc.com", "babypaloozanc.com", "tetrisonline.com", "grdd.net", "cdspg.info", "airshipapparel.com", "waft.com", "extendpets.com", "supplyhub.com", "hlbsusa.com", "jaderollerbeauty.com", "theparentingjunkie.com", "schagringas.com", "yourscribemate.com", "sportscollectibles.com", "thedivinenoise.com", "hometeamsonline.com", "trademarkpress.com", "destinationenglish.us", "jacquesflowers.com", "aliszhatchphotography.com", "rusticfoundry.com", "ahhhmassage.net", "frezzor.com", "mandelininc.com", "kayleejackson.com", "monkinstitute.org", "eddiebsbbq.com", "morningstarmediaservices.com", "kinevative.com", "orivet.com", "digitalprinthouse.net", "dynamicgenius.com", "allpartsusa.com", "flowersbydavid.net", "nwvoices.org", "leaptrade.com", "tulsaschoolpics.com", "alioth.io", "windowflair.com", "vitcom.net", "simplybeautifulfashions.com", "christinabenton.com", "fromthedaughter.com", "hometowngraphics.net", "fibanalysis.com", "creativejobscentral.com", "sandbox.gg", "jt-digitalmedia.com", "kodable.com", "birthingstone.com", "taranicholephoto.com", "hillyfieldsflorist.com", "charitynoelphoto.com", "auxdelicesfoods.com", "terilynnphotography.com", "folieadeuxevents.com", "karensfloral.com", "montgomerydiveclub.com", "rainbowplastics.com", "confettionthedancefloor.com", "vomozmedia.com", "neatmod.com", "getnaturafled.com", "callingpost.com", "iamfamily.org", "pedigreeonline.com", "typeboost.io", "in-n-outpetdoor.com", "nerdstockgc.com", "keiadmin.com", "createdbykaui.com", "aikophoto.com", "lonestar.ink", "stlfurs.com", "treasurelistings.com", "thecubicle.us", "redclaypaper.com", "blushhousemedia.com", "documentsanddesigns.com", "whitneyleighphotography.shootproof.com", "amaryllisday.com", "hermanproav.com", "felicemedia.com", "withloveplacenta.com", "store.brgadgets.co", "klowephoto.com", "spenceraustinconsulting.com", "sno-eagles.org", "dsatallahassee.org", "bakupages.com", "neswc.com", "josiebrooksphotography.com", "brisksale.com", "legalwhoosh.com", "jasmineeaster.com", "swatstudios.com", "facebook.com", "shakershell.com", "alexiswinslow.com", "mixeddimensions.com", "sweetpproductions.com", "lbeaphotography.com", "otlseatfillers.com", "jdtickets.com", "catholicar.com", "masque.com", "smalltownstudio.net", "goherbalife.com", "itzyourz.com", "magazinespeedloader.com", "dreammachines.io", "dallasdieteticalliance.org", "http:", "medair.org", "unbridledambition.com", "sarasprints.com", "wiperecord.com", "showmyrabbit.com", "cctrendsshop.com", "rachelalessandra.com", "otherworld-apothecary.com", "melissaannphoto.com", "girlceo.co", "seasidemexico.com", "telosid.com", "instin.com", "marinecorpsmustang.org", "lancityconnect.com", "hps1.org", "karenware.com", "livecurriculum.com", "spellingstars.com", "vektorfootball.com", "zaltv.com", "nebraskamayflower.org", "ethiopianspices.com", "immitranslate.com", "rafaelmagic.com.com", "bahc1.org", "newenamel.com", "bhchp.org", "buybulkamerica.com", "sourcepoint.com", "squarestripsports.com", "wix.com", "wilderootsphotography.com", "goodsalt.com", "systemongrid.com", "designmil.org", "freshtrendhq.com", "valisimofashions.com", "buyneatly.com", "getbeauty.us", "intellimidia.com" ],
            apmTestDomains: [ "agsm.it", "ls-felgendesign.de", "domecgo.com", "raffaeleinghilterra.it", "hills4me.com", "anastasis.it", "liberidallavoro.org", "lgancce.com", "fiat.com", "amnesty.de", "raftingcenter.it", "myrabona.it", "firabarcelona.com", "elidentsrl.it", "sprayplanet.es", "cutipol.pt", "newslist.it", "bamboomt2.eu", "gisa.net", "italialaser.org", "hydeofficialstore.com", "huber-verlag.de", "joomlacontenteditor.net", "kletterzentrum-innsbruck.at", "knobmusiciandesign.com", "shipstage.com", "whatsmonitor.com", "napoleonx.ai", "activitiesbookingsystem.com", "spider-slacklines.com", "sononato.it", "alpi4000.it", "penimaster.de", "sportbionier.com", "bioseme.it", "ilpaninotondo.it", "meyer-menue.de", "uni-heidelberg.de", "cameo.it", "pasteleriabuenavista.com", "wuv.de", "papacheck.de", "traderlink.com", "agcalabrese.it", "smatchfe.club", "sarastro-stauden.com", "vandenberg-berlin.com", "t-shirtprinting.it", "raftingrepublic.com", "cityspeeddating.at", "euroval.com", "albero-dellavita.it", "mediumelisa.it", "inkmaster.it", "run-healthy.com", "cna.it", "mufight2.com", "louvardgame.be", "pruefungsdoc.de", "europublishing.it", "edaiperiodici.it", "paypal-checkout.herokuapp.com", "day.it", "delinero.de", "unicocampania.it", "blumediterraneosas.com", "rustv.it", "geldverstehen.de", "skiclubfossoasd.it", "panorama-restaurant-stuttgart.de", "movember.com", "ombrellibolero.it", "devoto-oli.it", "el-teatro.de", "ittshop.com", "team-f.de", "ferien.events", "newnailssystem.com", "softwarevenere.com", "stikid.com", "evocoach.it", "caffepiansa.com", "epsoprep.com", "brickowl.com", "one28racing.com", "chogusto.com", "centrostudiliberale.it", "biotech-shop.nl", "knightonline-myko.net", "rad-germany.de", "damascus-store.com", "valkhair.nl", "tu-darmstadt.de", "lemediatv.fr", "mondoevacanze.it", "golfinthesun.org", "altinotravel.gr", "nsk.si", "humanhuman.com", "conento.com", "encuentratupsicologo.com", "onlainez.net", "bp-tools.de", "bestrongforkids.de", "cloudboxes.io", "creatone.de", "nethserver.com", "kulturstiftung-koelnerdom.de", "ixso.eu", "modulus.gr", "aerbrava.com", "allgrass.net", "artfloral.org", "studyclix.ie", "esthergarciaboutique.com", "abookforthat.com", "aurarium.ch", "tippevent.de", "musicspoon.io", "h10hotels.com", "frizzoshopping.com", "stargift.ro", "svojtka.sk", "salvadori.me", "sfmc.eu", "parsifalpark.it", "exilux.de", "brothausmoberg.com", "opificiografico.com", "lalibertadivolare.it", "airportfreewifi.it", "diemagnetisten.de", "shbook.it", "vallandry-sports.com", "crowdcoinage.com", "dresscodeboutique.fr", "talhita.it", "corticle.com", "anymator.de", "legalizer.it", "handmadefantasyworld.com", "1001-sushi-bordeaux.com", "elarconte.com", "sushiathome.pt", "associazionecest.it", "traduzioni-legalizzate.it", "janvas.com", "bluemeusb.nl", "lacala.es", "speironcompany.com", "flam-racing.fr", "1thebrand.com", "kidooland.com", "beneathmysins.com", "linelab.eu", "afroonatural.com", "azurewebsites.net", "munich-ski-shuttle.com", "euroservizi2012.it", "radiostim.com", "cbibikia.com", "nadur8k.com", "custom-hookah.de", "imexlicensing.com", "belts-parma.it", "generated4u.com", "pilarsantisteban.com", "consulenzeagroalimentari.it", "lavilladeipini.com", "burgershacklennep.de", "vmlens.com", "xoring.com", "moto4.it", "parospark.com", "commentme.com", "antoniodalessandro.it", "kinarecords.com", "bybus.pt", "parquecerdeira.com", "cineclaqueta.com", "saddolls.net", "mydamart.fr", "rfbnet.nl", "netsons.org", "rebrickable.com", "portodoavesso.com", "leobridge.net", "mikros.co", "bekinky.net", "pix4u.one", "smtperformances.fr", "siiturista.it", "gorrasbebe.es", "cbd-laden.at", "tobiaswaelde.de", "veneziaradiotv.it", "sopimuspohja.com", "cristianalopes.ddns.net", "saliyafoundation.de", "robertocosentino.it", "billy-white.de", "johndixt.it", "alexmas.cloud", "things-to-do-in-gran-canaria.com", "rroseselavy.it", "paradigmpalace.com", "chardez.be", "online-rechnungen.de", "vip-urlaub.de", "lyrau.com", "perfectiptv3006.000webhostapp.com", "seminarsincyprus.com", "snapandprint.com", "le-heron.net", "need4tech.gr", "eurolamps.eu", "paygety.ee", "gestionaliprosoft.it", "decoindustriel.fr", "acmo.corsica", "slovakforaday.com", "vhlave.sk", "hughmcgovernwriting.com", "nowgaming.fr", "divecentercorralejo.com", "mobile.de", "skebby.it" ],
            customCountry: !1,
            SUPPORTED_BROWSERS: {
                msie: "11",
                firefox: "30",
                chrome: "27",
                safari: "7",
                opera: "16",
                msedge: "12",
                samsungBrowser: "2.1",
                silk: "59.3",
                ucbrowser: "10.0.0.488",
                vivaldi: "1.91"
            },
            session_uid_lifetime: 3e5,
            _apiStage: "",
            get apiStage() {
                return config._apiStage || config.stage;
            },
            set apiStage(value) {
                config._apiStage = value;
            },
            ports: {
                default: 8e3,
                button: 8e3,
                checkout: 8e3,
                guest: 8001,
                altpay: 3e3
            },
            get paypalUrls() {
                var _ref;
                return (_ref = {})[constants.t.LOCAL] = config.localhostUrl, _ref[constants.t.STAGE] = "https://www." + config.stageUrl, 
                _ref[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", _ref[constants.t.PRODUCTION] = "https://www.paypal.com", 
                _ref[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref[constants.t.DEMO] = window.location.protocol + "//localhost.paypal.com:" + window.location.port, 
                _ref;
            },
            get paypalDomains() {
                var _ref2;
                return (_ref2 = {})[constants.t.LOCAL] = "http://localhost.paypal.com:8000", _ref2[constants.t.STAGE] = "https://www." + config.stageUrl, 
                _ref2[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", _ref2[constants.t.PRODUCTION] = "https://www.paypal.com", 
                _ref2[constants.t.TEST] = "mock://www.paypal.com", _ref2[constants.t.DEMO] = window.location.protocol + "//localhost.paypal.com:" + window.location.port, 
                _ref2;
            },
            get wwwApiUrls() {
                var _ref3;
                return (_ref3 = {})[constants.t.LOCAL] = "https://www." + config.stageUrl, _ref3[constants.t.STAGE] = "https://www." + config.stageUrl, 
                _ref3[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", _ref3[constants.t.PRODUCTION] = "https://www.paypal.com", 
                _ref3[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref3;
            },
            get corsApiUrls() {
                var _ref4;
                return (_ref4 = {})[constants.t.LOCAL] = "https://" + config.apiStageUrl + ":12326", 
                _ref4[constants.t.STAGE] = "https://" + config.apiStageUrl + ":12326", _ref4[constants.t.SANDBOX] = "https://cors.api.sandbox.paypal.com", 
                _ref4[constants.t.PRODUCTION] = "https://cors.api.paypal.com", _ref4[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref4;
            },
            get apiUrls() {
                var _ref5, domain = window.location.protocol + "//" + window.location.host, corsApiUrls = config.corsApiUrls, wwwApiUrls = config.wwwApiUrls;
                return (_ref5 = {})[constants.t.LOCAL] = domain === wwwApiUrls.local ? wwwApiUrls.local : corsApiUrls.local, 
                _ref5[constants.t.STAGE] = domain === wwwApiUrls.stage ? wwwApiUrls.stage : corsApiUrls.stage, 
                _ref5[constants.t.SANDBOX] = domain === wwwApiUrls.sandbox ? wwwApiUrls.sandbox : corsApiUrls.sandbox, 
                _ref5[constants.t.PRODUCTION] = domain === wwwApiUrls.production ? wwwApiUrls.production : corsApiUrls.production, 
                _ref5[constants.t.TEST] = domain === wwwApiUrls.test ? wwwApiUrls.test : corsApiUrls.test, 
                _ref5;
            },
            get checkoutUri() {
                return null;
            },
            set checkoutUri(val) {
                delete this.checkoutUri, this.checkoutUri = val;
            },
            get checkoutUris() {
                var _ref7, _ref6;
                return config.checkoutUri ? ((_ref6 = {})[constants.t.LOCAL] = config.checkoutUri, 
                _ref6[constants.t.STAGE] = config.checkoutUri, _ref6[constants.t.SANDBOX] = config.checkoutUri, 
                _ref6[constants.t.PRODUCTION] = config.checkoutUri, _ref6[constants.t.TEST] = config.checkoutUri, 
                _ref6[constants.t.DEMO] = config.checkoutUri, _ref6) : ((_ref7 = {})[constants.t.LOCAL] = "/webapps/hermes", 
                _ref7[constants.t.STAGE] = "/webapps/hermes", _ref7[constants.t.SANDBOX] = "/checkoutnow", 
                _ref7[constants.t.PRODUCTION] = "/checkoutnow", _ref7[constants.t.TEST] = "/base/test/windows/checkout/index.htm?checkouturl=true", 
                _ref7[constants.t.DEMO] = "/demo/dev/checkout.htm", _ref7);
            },
            altpayUris: (_altpayUris = {}, _altpayUris[constants.t.LOCAL] = "/latinumcheckout", 
            _altpayUris[constants.t.STAGE] = "/latinumcheckout", _altpayUris[constants.t.SANDBOX] = "/latinumcheckout", 
            _altpayUris[constants.t.PRODUCTION] = "/latinumcheckout", _altpayUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?checkouturl=true", 
            _altpayUris[constants.t.DEMO] = "/demo/dev/checkout.htm", _altpayUris),
            guestUris: (_guestUris = {}, _guestUris[constants.t.LOCAL] = "/webapps/xoonboarding", 
            _guestUris[constants.t.STAGE] = "/webapps/xoonboarding", _guestUris[constants.t.SANDBOX] = "/webapps/xoonboarding", 
            _guestUris[constants.t.PRODUCTION] = "/webapps/xoonboarding", _guestUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?guesturl=true", 
            _guestUris[constants.t.DEMO] = "/demo/dev/guest.htm", _guestUris),
            billingUris: (_billingUris = {}, _billingUris[constants.t.LOCAL] = "/webapps/hermes/agreements", 
            _billingUris[constants.t.STAGE] = "/webapps/hermes/agreements", _billingUris[constants.t.SANDBOX] = "/agreements/approve", 
            _billingUris[constants.t.PRODUCTION] = "/agreements/approve", _billingUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?billingurl=true", 
            _billingUris[constants.t.DEMO] = "/demo/dev/checkout.htm", _billingUris),
            buttonUris: (_buttonUris = {}, _buttonUris[constants.t.LOCAL] = "/webapps/hermes/button", 
            _buttonUris[constants.t.STAGE] = "/webapps/hermes/button", _buttonUris[constants.t.SANDBOX] = "/webapps/hermes/button", 
            _buttonUris[constants.t.PRODUCTION] = "/webapps/hermes/button", _buttonUris[constants.t.TEST] = "/base/test/windows/button/index.htm", 
            _buttonUris[constants.t.DEMO] = "/demo/dev/button.htm", _buttonUris),
            inlinedCardFieldUris: (_inlinedCardFieldUris = {}, _inlinedCardFieldUris[constants.t.LOCAL] = "/smart/card-fields", 
            _inlinedCardFieldUris[constants.t.STAGE] = "/smart/card-fields", _inlinedCardFieldUris[constants.t.SANDBOX] = "/smart/card-fields", 
            _inlinedCardFieldUris[constants.t.PRODUCTION] = "/smart/card-fields", _inlinedCardFieldUris[constants.t.TEST] = "/base/test/windows/card-fields/index.htm", 
            _inlinedCardFieldUris[constants.t.DEMO] = "/demo/dev/card.htm", _inlinedCardFieldUris),
            postBridgeUris: (_postBridgeUris = {}, _postBridgeUris[constants.t.LOCAL] = "/webapps/hermes/component-meta", 
            _postBridgeUris[constants.t.STAGE] = "/webapps/hermes/component-meta", _postBridgeUris[constants.t.SANDBOX] = "/webapps/hermes/component-meta", 
            _postBridgeUris[constants.t.PRODUCTION] = "/webapps/hermes/component-meta", _postBridgeUris[constants.t.TEST] = "/base/test/windows/component-meta/index.htm", 
            _postBridgeUris[constants.t.DEMO] = "/demo/dev/bridge.htm", _postBridgeUris),
            legacyCheckoutUris: (_legacyCheckoutUris = {}, _legacyCheckoutUris[constants.t.LOCAL] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.STAGE] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.SANDBOX] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.PRODUCTION] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.TEST] = "#fallback", _legacyCheckoutUris),
            buttonJSUrls: (_buttonJSUrls = {}, _buttonJSUrls[constants.t.LOCAL] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.STAGE] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.SANDBOX] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.PRODUCTION] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.TEST] = "/base/test/lib/button.js", _buttonJSUrls[constants.t.DEMO] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls),
            get buttonJSUrl() {
                return config.buttonJSUrls[config.env];
            },
            loginUri: "/signin/",
            hermesLoggerUri: "/webapps/hermes/api/logger",
            loggerUri: "/xoplatform/logger/api/logger",
            loggerThrottlePercentage: 1,
            pptmUri: "/tagmanager/pptm.js",
            get postBridgeUri() {
                return config.postBridgeUris[config.env] + "?xcomponent=1";
            },
            paymentStandardUri: "/webapps/xorouter?cmd=_s-xclick",
            authApiUri: "/v1/oauth2/token",
            paymentApiUri: "/v1/payments/payment",
            orderApiUri: "/v2/checkout/orders",
            billingApiUri: "/v1/billing-agreements/agreement-tokens",
            experienceApiUri: "/v1/payment-experience/web-profiles",
            trackingApiUri: "/v1/risk/transaction-contexts",
            get checkoutUrls() {
                var _ref8, paypalUrls = config.paypalUrls;
                return (_ref8 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.checkoutUris.local.replace(":" + config.ports.default, ":" + config.ports.checkout), 
                _ref8[constants.t.STAGE] = "" + paypalUrls.stage + config.checkoutUris.stage, _ref8[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.checkoutUris.sandbox, 
                _ref8[constants.t.PRODUCTION] = "" + paypalUrls.production + config.checkoutUris.production, 
                _ref8[constants.t.TEST] = "" + paypalUrls.test + config.checkoutUris.test, _ref8[constants.t.DEMO] = "" + paypalUrls.test + config.checkoutUris.demo, 
                _ref8;
            },
            get guestUrls() {
                var _ref9, paypalUrls = config.paypalUrls;
                return (_ref9 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.guest) + config.guestUris.local, 
                _ref9[constants.t.STAGE] = "" + paypalUrls.stage + config.guestUris.stage, _ref9[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.guestUris.sandbox, 
                _ref9[constants.t.PRODUCTION] = "" + paypalUrls.production + config.guestUris.production, 
                _ref9[constants.t.TEST] = "" + paypalUrls.test + config.guestUris.test, _ref9[constants.t.DEMO] = "" + paypalUrls.test + config.guestUris.demo, 
                _ref9;
            },
            get altpayUrls() {
                var _ref10, paypalUrls = config.paypalUrls;
                return (_ref10 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.altpay) + config.altpayUris.local, 
                _ref10[constants.t.STAGE] = "" + paypalUrls.stage + config.altpayUris.stage, _ref10[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.altpayUris.sandbox, 
                _ref10[constants.t.PRODUCTION] = "" + paypalUrls.production + config.altpayUris.production, 
                _ref10[constants.t.TEST] = "" + paypalUrls.test + config.altpayUris.test, _ref10[constants.t.DEMO] = "" + paypalUrls.test + config.altpayUris.demo, 
                _ref10;
            },
            get billingUrls() {
                var _ref11, paypalUrls = config.paypalUrls;
                return (_ref11 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.checkout) + config.billingUris.local, 
                _ref11[constants.t.STAGE] = "" + paypalUrls.stage + config.billingUris.stage, _ref11[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.billingUris.sandbox, 
                _ref11[constants.t.PRODUCTION] = "" + paypalUrls.production + config.billingUris.production, 
                _ref11[constants.t.TEST] = "" + paypalUrls.test + config.billingUris.test, _ref11[constants.t.DEMO] = "" + paypalUrls.test + config.billingUris.demo, 
                _ref11;
            },
            get buttonUrls() {
                var _ref12, paypalUrls = config.paypalUrls;
                return (_ref12 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.button) + config.buttonUris.local, 
                _ref12[constants.t.STAGE] = "" + paypalUrls.stage + config.buttonUris.stage, _ref12[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.buttonUris.sandbox, 
                _ref12[constants.t.PRODUCTION] = "" + paypalUrls.production + config.buttonUris.production, 
                _ref12[constants.t.TEST] = "" + paypalUrls.test + config.buttonUris.test, _ref12[constants.t.DEMO] = "" + paypalUrls.demo + config.buttonUris.demo, 
                _ref12;
            },
            get inlinedCardFieldUrls() {
                var _ref13, paypalUrls = config.paypalUrls;
                return (_ref13 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.button) + config.inlinedCardFieldUris.local, 
                _ref13[constants.t.STAGE] = "" + paypalUrls.stage + config.inlinedCardFieldUris.stage, 
                _ref13[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.inlinedCardFieldUris.sandbox, 
                _ref13[constants.t.PRODUCTION] = "" + paypalUrls.production + config.inlinedCardFieldUris.production, 
                _ref13[constants.t.TEST] = "" + paypalUrls.test + config.inlinedCardFieldUris.test, 
                _ref13[constants.t.DEMO] = "" + paypalUrls.demo + config.inlinedCardFieldUris.demo, 
                _ref13;
            },
            get loginUrls() {
                var _ref14, paypalUrls = config.paypalUrls;
                return (_ref14 = {})[constants.t.LOCAL] = "" + paypalUrls.stage + config.loginUri, 
                _ref14[constants.t.STAGE] = "" + paypalUrls.stage + config.loginUri, _ref14[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.loginUri, 
                _ref14[constants.t.PRODUCTION] = "" + paypalUrls.production + config.loginUri, _ref14[constants.t.TEST] = "" + paypalUrls.test + config.loginUri, 
                _ref14;
            },
            get paymentsStandardUrls() {
                var _ref15, paypalUrls = config.paypalUrls;
                return (_ref15 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.paymentStandardUri, 
                _ref15[constants.t.STAGE] = "" + paypalUrls.stage + config.paymentStandardUri, _ref15[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.paymentStandardUri, 
                _ref15[constants.t.PRODUCTION] = "" + paypalUrls.production + config.paymentStandardUri, 
                _ref15[constants.t.TEST] = "" + paypalUrls.test + config.paymentStandardUri, _ref15;
            },
            get metaFrameUrls() {
                var _ref16, paypalUrls = config.paypalUrls;
                return (_ref16 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.postBridgeUri + "&env=local", 
                _ref16[constants.t.STAGE] = "" + paypalUrls.stage + config.postBridgeUri + "&env=stage&stage=" + config.stage, 
                _ref16[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.postBridgeUri + "&env=sandbox", 
                _ref16[constants.t.PRODUCTION] = "" + paypalUrls.production + config.postBridgeUri + "&env=production", 
                _ref16[constants.t.TEST] = "" + paypalUrls.test + config.postBridgeUri + "&env=test", 
                _ref16[constants.t.DEMO] = "" + paypalUrls.demo + config.postBridgeUri + "&env=demo", 
                _ref16;
            },
            get legacyCheckoutUrls() {
                var _ref17, paypalUrls = config.paypalUrls;
                return (_ref17 = {})[constants.t.LOCAL] = "" + paypalUrls.stage + config.legacyCheckoutUris.local, 
                _ref17[constants.t.STAGE] = "" + paypalUrls.stage + config.legacyCheckoutUris.stage, 
                _ref17[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.legacyCheckoutUris.sandbox, 
                _ref17[constants.t.PRODUCTION] = "" + paypalUrls.production + config.legacyCheckoutUris.production, 
                _ref17[constants.t.TEST] = "" + paypalUrls.test + config.legacyCheckoutUris.test, 
                _ref17;
            },
            get authApiUrls() {
                var _ref18, apiUrls = config.apiUrls, authApiUri = config.authApiUri;
                return (_ref18 = {})[constants.t.LOCAL] = "" + apiUrls.local + authApiUri, _ref18[constants.t.STAGE] = "" + apiUrls.stage + authApiUri, 
                _ref18[constants.t.SANDBOX] = "" + apiUrls.sandbox + authApiUri, _ref18[constants.t.PRODUCTION] = "" + apiUrls.production + authApiUri, 
                _ref18[constants.t.TEST] = "" + apiUrls.test + authApiUri, _ref18;
            },
            get paymentApiUrls() {
                var _ref19, apiUrls = config.apiUrls, paymentApiUri = config.paymentApiUri;
                return (_ref19 = {})[constants.t.LOCAL] = "" + apiUrls.local + paymentApiUri, _ref19[constants.t.STAGE] = "" + apiUrls.stage + paymentApiUri, 
                _ref19[constants.t.SANDBOX] = "" + apiUrls.sandbox + paymentApiUri, _ref19[constants.t.PRODUCTION] = "" + apiUrls.production + paymentApiUri, 
                _ref19[constants.t.TEST] = "" + apiUrls.test + paymentApiUri, _ref19;
            },
            get orderApiUrls() {
                var _ref20, apiUrls = config.apiUrls, orderApiUri = config.orderApiUri;
                return (_ref20 = {})[constants.t.LOCAL] = "" + apiUrls.local + orderApiUri, _ref20[constants.t.STAGE] = "" + apiUrls.stage + orderApiUri, 
                _ref20[constants.t.SANDBOX] = "" + apiUrls.sandbox + orderApiUri, _ref20[constants.t.PRODUCTION] = "" + apiUrls.production + orderApiUri, 
                _ref20[constants.t.TEST] = "" + apiUrls.test + orderApiUri, _ref20;
            },
            get billingApiUrls() {
                var _ref21, apiUrls = config.apiUrls, billingApiUri = config.billingApiUri;
                return (_ref21 = {})[constants.t.LOCAL] = "" + apiUrls.local + billingApiUri, _ref21[constants.t.STAGE] = "" + apiUrls.stage + billingApiUri, 
                _ref21[constants.t.SANDBOX] = "" + apiUrls.sandbox + billingApiUri, _ref21[constants.t.PRODUCTION] = "" + apiUrls.production + billingApiUri, 
                _ref21[constants.t.TEST] = "" + apiUrls.test + billingApiUri, _ref21;
            },
            get experienceApiUrls() {
                var _ref22, apiUrls = config.apiUrls, experienceApiUri = config.experienceApiUri;
                return (_ref22 = {})[constants.t.LOCAL] = "" + apiUrls.local + experienceApiUri, 
                _ref22[constants.t.STAGE] = "" + apiUrls.stage + experienceApiUri, _ref22[constants.t.SANDBOX] = "" + apiUrls.sandbox + experienceApiUri, 
                _ref22[constants.t.PRODUCTION] = "" + apiUrls.production + experienceApiUri, _ref22[constants.t.TEST] = "" + apiUrls.test + experienceApiUri, 
                _ref22;
            },
            get trackingApiUrls() {
                var _ref23, apiUrls = config.apiUrls, trackingApiUri = config.trackingApiUri;
                return (_ref23 = {})[constants.t.LOCAL] = "" + apiUrls.local + trackingApiUri, _ref23[constants.t.STAGE] = "" + apiUrls.stage + trackingApiUri, 
                _ref23[constants.t.SANDBOX] = "" + apiUrls.sandbox + trackingApiUri, _ref23[constants.t.PRODUCTION] = "" + apiUrls.production + trackingApiUri, 
                _ref23[constants.t.TEST] = "" + apiUrls.test + trackingApiUri, _ref23;
            },
            _paypalUrl: "",
            get paypalUrl() {
                return this._paypalUrl || config.paypalUrls[config.env];
            },
            set paypalUrl(value) {
                this._paypalUrl = value;
            },
            get paypalDomain() {
                return config.paypalDomains[config.env];
            },
            get corsApiUrl() {
                return config.corsApiUrls[config.env];
            },
            get wwwApiUrl() {
                return config.wwwApiUrls[config.env];
            },
            get apiUrl() {
                var domain = window.location.protocol + "//" + window.location.host, wwwApiUrl = config.wwwApiUrl;
                return domain === wwwApiUrl ? wwwApiUrl : config.corsApiUrl;
            },
            get checkoutUrl() {
                return "" + config.paypalUrl + config.checkoutUris[config.env];
            },
            get billingUrl() {
                return "" + config.paypalUrl + config.billingUris[config.env];
            },
            get buttonUrl() {
                return "" + config.paypalUrl + config.buttonUris[config.env];
            },
            get legacyCheckoutUrl() {
                return config.legacyCheckoutUrls[config.env];
            },
            get postBridgeUrl() {
                return "" + config.paypalUrl + config.postBridgeUri;
            },
            get postBridgeDomain() {
                return "" + config.paypalDomain;
            },
            get loggerUrl() {
                var isTestExperiment = Math.random() < config.loggerThrottlePercentage;
                return "" + config.paypalUrl + (isTestExperiment ? config.loggerUri : config.hermesLoggerUri);
            },
            get pptmUrl() {
                return "" + config.paypalUrls[config.env] + config.pptmUri;
            },
            get authApiUrl() {
                return "" + config.apiUrl + config.authApiUri;
            },
            get paymentApiUrl() {
                return "" + config.apiUrl + config.paymentApiUri;
            },
            get orderApiUrl() {
                return "" + config.apiUrl + config.orderApiUri;
            },
            get billingApiUrl() {
                return "" + config.apiUrl + config.billingApiUri;
            },
            get experienceApiUrl() {
                return "" + config.apiUrl + config.experienceApiUri;
            },
            defaultLocale: {
                country: constants.r.US,
                lang: constants.x.EN
            }
        };
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return config;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject), __webpack_require__.d(interface_namespaceObject, "buffer", function() {
            return buffer;
        }), __webpack_require__.d(interface_namespaceObject, "tracking", function() {
            return tracking;
        }), __webpack_require__.d(interface_namespaceObject, "getTransport", function() {
            return getTransport;
        }), __webpack_require__.d(interface_namespaceObject, "setTransport", function() {
            return setTransport;
        }), __webpack_require__.d(interface_namespaceObject, "print", function() {
            return print;
        }), __webpack_require__.d(interface_namespaceObject, "immediateFlush", function() {
            return immediateFlush;
        }), __webpack_require__.d(interface_namespaceObject, "flush", function() {
            return _flush;
        }), __webpack_require__.d(interface_namespaceObject, "log", function() {
            return log;
        }), __webpack_require__.d(interface_namespaceObject, "prefix", function() {
            return prefix;
        }), __webpack_require__.d(interface_namespaceObject, "debug", function() {
            return debug;
        }), __webpack_require__.d(interface_namespaceObject, "info", function() {
            return info;
        }), __webpack_require__.d(interface_namespaceObject, "warn", function() {
            return warn;
        }), __webpack_require__.d(interface_namespaceObject, "error", function() {
            return error;
        }), __webpack_require__.d(interface_namespaceObject, "track", function() {
            return _track;
        }), __webpack_require__.d(interface_namespaceObject, "init", function() {
            return init;
        }), __webpack_require__.d(interface_namespaceObject, "startTransition", function() {
            return startTransition;
        }), __webpack_require__.d(interface_namespaceObject, "endTransition", function() {
            return endTransition;
        }), __webpack_require__.d(interface_namespaceObject, "transition", function() {
            return transition;
        }), __webpack_require__.d(interface_namespaceObject, "payloadBuilders", function() {
            return payloadBuilders;
        }), __webpack_require__.d(interface_namespaceObject, "metaBuilders", function() {
            return metaBuilders;
        }), __webpack_require__.d(interface_namespaceObject, "trackingBuilders", function() {
            return trackingBuilders;
        }), __webpack_require__.d(interface_namespaceObject, "headerBuilders", function() {
            return headerBuilders;
        }), __webpack_require__.d(interface_namespaceObject, "addPayloadBuilder", function() {
            return addPayloadBuilder;
        }), __webpack_require__.d(interface_namespaceObject, "addMetaBuilder", function() {
            return addMetaBuilder;
        }), __webpack_require__.d(interface_namespaceObject, "addTrackingBuilder", function() {
            return addTrackingBuilder;
        }), __webpack_require__.d(interface_namespaceObject, "addHeaderBuilder", function() {
            return addHeaderBuilder;
        }), __webpack_require__.d(interface_namespaceObject, "config", function() {
            return config;
        }), __webpack_require__.d(interface_namespaceObject, "logLevels", function() {
            return logLevels;
        });
        var src = __webpack_require__(1);
        function extend(dest, src, over) {
            for (var i in void 0 === over && (over = !0), dest = dest || {}, src = src || {}) src.hasOwnProperty(i) && (!over && dest.hasOwnProperty(i) || (dest[i] = src[i]));
            return dest;
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            });
        }
        var payloadBuilders = [], metaBuilders = [], trackingBuilders = [], headerBuilders = [];
        function addPayloadBuilder(builder) {
            payloadBuilders.push(builder);
        }
        function addMetaBuilder(builder) {
            metaBuilders.push(builder);
        }
        function addTrackingBuilder(builder) {
            trackingBuilders.push(builder);
        }
        function addHeaderBuilder(builder) {
            headerBuilders.push(builder);
        }
        var config = {
            uri: "",
            prefix: "",
            initial_state_name: "init",
            flushInterval: 6e5,
            debounceInterval: 10,
            sizeLimit: 300,
            silent: !1,
            heartbeat: !0,
            heartbeatConsoleLog: !0,
            heartbeatInterval: 5e3,
            heartbeatTooBusy: !1,
            heartbeatTooBusyThreshold: 1e4,
            logLevel: "warn",
            autoLog: [ "warn", "error" ],
            logUnload: !0,
            logPerformance: !0
        }, logLevels = [ "error", "warn", "info", "debug" ], buffer = [], tracking = [], logger_transport = function(headers, data, options) {
            return function(method, url, headers, data, _temp) {
                void 0 === headers && (headers = {}), void 0 === data && (data = {});
                var _ref$fireAndForget = (void 0 === options ? {} : options).fireAndForget, fireAndForget = void 0 !== _ref$fireAndForget && _ref$fireAndForget;
                return new src.a(function(resolve) {
                    var XRequest = window.XMLHttpRequest || window.ActiveXObject;
                    if (window.XDomainRequest && !function(url) {
                        var match = url.match(/https?:\/\/[^\/]+/);
                        return !match || match[0] === window.location.protocol + "//" + window.location.host;
                    }(url)) {
                        if (!function(url) {
                            return window.location.protocol === url.split("/")[0];
                        }(url)) return resolve();
                        XRequest = window.XDomainRequest;
                    }
                    var req = new XRequest("MSXML2.XMLHTTP.3.0");
                    if (req.open("post".toUpperCase(), url, !0), "function" == typeof req.setRequestHeader) for (var headerName in req.setRequestHeader("X-Requested-With", "XMLHttpRequest"), 
                    req.setRequestHeader("Content-type", "application/json"), headers) headers.hasOwnProperty(headerName) && req.setRequestHeader(headerName, headers[headerName]);
                    fireAndForget ? resolve() : req.onreadystatechange = function() {
                        req.readyState > 3 && resolve();
                    }, req.send(JSON.stringify(data).replace(/&/g, "%26"));
                });
            }(0, config.uri, headers, data);
        };
        function getTransport() {
            return logger_transport;
        }
        function setTransport(newTransport) {
            logger_transport = newTransport;
        }
        var loaded = !1;
        function print(level, event, payload) {
            if ("undefined" != typeof window && window.console && window.console.log) {
                if (!loaded) return setTimeout(function() {
                    return print(level, event, payload);
                }, 1);
                var logLevel = config.logLevel;
                if (window.LOG_LEVEL && (logLevel = window.LOG_LEVEL), !(logLevels.indexOf(level) > logLevels.indexOf(logLevel))) {
                    payload = payload || {};
                    var args = [ event ];
                    Boolean(window.document.documentMode) && (payload = JSON.stringify(payload)), args.push(payload), 
                    (payload.error || payload.warning) && args.push("\n\n", payload.error || payload.warning);
                    try {
                        window.console[level] && window.console[level].apply ? window.console[level].apply(window.console, args) : window.console.log && window.console.log.apply && window.console.log.apply(window.console, args);
                    } catch (err) {}
                }
            }
        }
        function immediateFlush(_temp) {
            var _ref$fireAndForget = (void 0 === _temp ? {} : _temp).fireAndForget, fireAndForget = void 0 !== _ref$fireAndForget && _ref$fireAndForget;
            if ("undefined" != typeof window && config.uri && (buffer.length || tracking.length)) {
                for (var meta = {}, _i2 = 0; _i2 < metaBuilders.length; _i2++) {
                    var builder = metaBuilders[_i2];
                    try {
                        extend(meta, builder(meta), !1);
                    } catch (err) {
                        console.error("Error in custom meta builder:", err.stack || err.toString());
                    }
                }
                for (var headers = {}, _i4 = 0; _i4 < headerBuilders.length; _i4++) {
                    var _builder = headerBuilders[_i4];
                    try {
                        extend(headers, _builder(headers), !1);
                    } catch (err) {
                        console.error("Error in custom header builder:", err.stack || err.toString());
                    }
                }
                var req = logger_transport(headers, {
                    events: buffer,
                    meta: meta,
                    tracking: tracking
                }, {
                    fireAndForget: fireAndForget
                });
                return buffer = [], tracking = [], req;
            }
        }
        setTimeout(function() {
            loaded = !0;
        }, 1);
        var method, interval, debounce, _flush = (method = immediateFlush, interval = config.debounceInterval, 
        debounce = {}, function() {
            var args = arguments;
            return debounce.timeout && (clearTimeout(debounce.timeout), delete debounce.timeout), 
            debounce.timeout = setTimeout(function() {
                var resolver = debounce.resolver, rejector = debounce.rejector;
                return delete debounce.promise, delete debounce.resolver, delete debounce.rejector, 
                delete debounce.timeout, src.a.resolve().then(function() {
                    return method.apply(null, args);
                }).then(resolver, rejector);
            }, interval), debounce.promise = debounce.promise || new src.a(function(resolver, rejector) {
                debounce.resolver = resolver, debounce.rejector = rejector;
            }), debounce.promise;
        });
        function enqueue(level, event, payload) {
            buffer.push({
                level: level,
                event: event,
                payload: payload
            }), config.autoLog.indexOf(level) > -1 && _flush();
        }
        function log(level, event, payload) {
            if ("undefined" != typeof window) {
                config.prefix && (event = config.prefix + "_" + event), "string" == typeof (payload = payload || {}) ? payload = {
                    message: payload
                } : payload instanceof Error && (payload = {
                    error: payload.stack || payload.toString()
                });
                try {
                    JSON.stringify(payload);
                } catch (err) {
                    return;
                }
                payload.timestamp = Date.now();
                for (var _i6 = 0; _i6 < payloadBuilders.length; _i6++) {
                    var builder = payloadBuilders[_i6];
                    try {
                        extend(payload, builder(payload), !1);
                    } catch (err) {
                        console.error("Error in custom payload builder:", err.stack || err.toString());
                    }
                }
                config.silent || print(level, event, payload), buffer.length === config.sizeLimit ? enqueue("info", "logger_max_buffer_length") : buffer.length < config.sizeLimit && enqueue(level, event, payload);
            }
        }
        function prefix(name) {
            return {
                debug: function(event, payload) {
                    return log("debug", name + "_" + event, payload);
                },
                info: function(event, payload) {
                    return log("info", name + "_" + event, payload);
                },
                warn: function(event, payload) {
                    return log("warn", name + "_" + event, payload);
                },
                error: function(event, payload) {
                    return log("error", name + "_" + event, payload);
                },
                track: function(payload) {
                    return _track(payload);
                },
                flush: function() {
                    return _flush();
                }
            };
        }
        function debug(event, payload) {
            return log("debug", event, payload);
        }
        function info(event, payload) {
            return log("info", event, payload);
        }
        function warn(event, payload) {
            return log("warn", event, payload);
        }
        function error(event, payload) {
            return log("error", event, payload);
        }
        function _track(payload) {
            if ("undefined" != typeof window && payload) {
                try {
                    JSON.stringify(payload);
                } catch (err) {
                    return;
                }
                for (var _i8 = 0; _i8 < trackingBuilders.length; _i8++) {
                    var builder = trackingBuilders[_i8];
                    try {
                        extend(payload, builder(payload), !1);
                    } catch (err) {
                        console.error("Error in custom tracking builder:", err.stack || err.toString());
                    }
                }
                print("debug", "tracking", payload), tracking.push(payload);
            }
        }
        var enablePerformance = window && window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1e3 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0;
        function now() {
            return enablePerformance ? performance.now() : Date.now();
        }
        function timer(startTime) {
            return {
                startTime: startTime = void 0 !== startTime ? startTime : now(),
                elapsed: function() {
                    return parseInt(now() - startTime, 10);
                },
                reset: function() {
                    startTime = now();
                }
            };
        }
        function reqStartElapsed() {
            if (enablePerformance) {
                var timing = window.performance.timing;
                return parseInt(timing.connectEnd - timing.navigationStart, 10);
            }
        }
        var clientTimer = timer(), reqTimer = timer(reqStartElapsed());
        var initiated = !1;
        function init(conf) {
            var time, heartBeatTimer, heartbeatCount;
            extend(config, conf || {}), initiated || (initiated = !0, config.logPerformance && function() {
                if (!enablePerformance) return info("no_performance_data");
                addPayloadBuilder(function() {
                    var payload = {};
                    return payload.client_elapsed = clientTimer.elapsed(), enablePerformance && (payload.req_elapsed = reqTimer.elapsed()), 
                    payload;
                }), new src.a(function(resolve) {
                    "undefined" != typeof document && "complete" === document.readyState && resolve(), 
                    window.addEventListener("load", resolve);
                }).then(function() {
                    var timing = {};
                    [ "connectEnd", "connectStart", "domComplete", "domContentLoadedEventEnd", "domContentLoadedEventStart", "domInteractive", "domLoading", "domainLookupEnd", "domainLookupStart", "fetchStart", "loadEventEnd", "loadEventStart", "navigationStart", "redirectEnd", "redirectStart", "requestStart", "responseEnd", "responseStart", "secureConnectionStart", "unloadEventEnd", "unloadEventStart" ].forEach(function(key) {
                        timing[key] = parseInt(window.performance.timing[key], 10) || 0;
                    });
                    var offset = timing.connectEnd - timing.navigationStart;
                    timing.connectEnd && Object.keys(timing).forEach(function(name) {
                        var time = timing[name];
                        time && info("timing_" + name, {
                            client_elapsed: parseInt(time - timing.connectEnd - (clientTimer.startTime - offset), 10),
                            req_elapsed: parseInt(time - timing.connectEnd, 10)
                        });
                    }), info("timing", timing), info("memory", window.performance.memory), info("navigation", window.performance.navigation), 
                    window.performance.getEntries && window.performance.getEntries().forEach(function(resource) {
                        [ "link", "script", "img", "css" ].indexOf(resource.initiatorType) > -1 && info(resource.initiatorType, resource);
                    });
                });
            }(), config.heartbeat && (heartBeatTimer = timer(), heartbeatCount = 0, time = config.heartbeatInterval, 
            function loop() {
                setTimeout(function() {
                    (function() {
                        if (!(config.heartbeatMaxThreshold && heartbeatCount > config.heartbeatMaxThreshold)) {
                            heartbeatCount += 1;
                            var elapsed = heartBeatTimer.elapsed(), lag = elapsed - config.heartbeatInterval, heartbeatPayload = {
                                count: heartbeatCount,
                                elapsed: elapsed
                            };
                            config.heartbeatTooBusy && (heartbeatPayload.lag = lag, lag >= config.heartbeatTooBusyThreshold && info("toobusy", heartbeatPayload)), 
                            info("heartbeat", heartbeatPayload);
                        }
                    })(), loop();
                }, time);
            }()), config.logUnload && (window.addEventListener("beforeunload", function() {
                info("window_beforeunload"), immediateFlush({
                    fireAndForget: !0
                });
            }), window.addEventListener("unload", function() {
                info("window_unload"), immediateFlush({
                    fireAndForget: !0
                });
            })), config.flushInterval && setInterval(_flush, config.flushInterval), window.beaverLogQueue && (window.beaverLogQueue.forEach(function(payload) {
                log(payload.level, payload.event, payload);
            }), delete window.beaverLogQueue));
        }
        var startTime, windowID = uniqueID(), pageID = uniqueID(), currentState = config.initial_state_name;
        function startTransition() {
            startTime = now();
        }
        function endTransition(toState) {
            startTime = startTime || reqStartElapsed();
            var elapsedTime, currentTime = now();
            void 0 !== startTime && (elapsedTime = parseInt(currentTime - startTime, 0));
            var transitionName = "transition_" + currentState + "_to_" + toState;
            info(transitionName, {
                duration: elapsedTime
            }), _track({
                transition: transitionName,
                transition_time: elapsedTime
            }), immediateFlush(), startTime = currentTime, currentState = toState, pageID = uniqueID();
        }
        function transition(toState) {
            startTransition(), endTransition(toState);
        }
        addPayloadBuilder(function() {
            return {
                windowID: windowID,
                pageID: pageID
            };
        }), addMetaBuilder(function() {
            return {
                state: "ui_" + currentState
            };
        }), __webpack_require__.d(__webpack_exports__, "i", function() {
            return getTransport;
        }), __webpack_require__.d(__webpack_exports__, "o", function() {
            return setTransport;
        }), __webpack_require__.d(__webpack_exports__, "j", function() {
            return immediateFlush;
        }), __webpack_require__.d(__webpack_exports__, "h", function() {
            return _flush;
        }), __webpack_require__.d(__webpack_exports__, "n", function() {
            return prefix;
        }), __webpack_require__.d(__webpack_exports__, "f", function() {
            return debug;
        }), __webpack_require__.d(__webpack_exports__, "k", function() {
            return info;
        }), __webpack_require__.d(__webpack_exports__, "q", function() {
            return warn;
        }), __webpack_require__.d(__webpack_exports__, "g", function() {
            return error;
        }), __webpack_require__.d(__webpack_exports__, "p", function() {
            return _track;
        }), __webpack_require__.d(__webpack_exports__, "l", function() {
            return init;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return addPayloadBuilder;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return addMetaBuilder;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return addTrackingBuilder;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return addHeaderBuilder;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return config;
        }), __webpack_require__.d(__webpack_exports__, "m", function() {
            return logLevels;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var esm_extends = __webpack_require__(11), src = __webpack_require__(7), zalgo_promise_src = __webpack_require__(1), cross_domain_safe_weakmap_src = __webpack_require__(17), error = __webpack_require__(22);
        function urlEncode(str) {
            return str.replace(/\?/g, "%3F").replace(/&/g, "%26").replace(/#/g, "%23").replace(/\+/g, "%2B");
        }
        function dasherizeToCamel(string) {
            return string.replace(/-([a-z])/g, function(g) {
                return g[1].toUpperCase();
            });
        }
        function extend(obj, source) {
            if (!source) return obj;
            for (var key in source) source.hasOwnProperty(key) && (obj[key] = source[key]);
            return obj;
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            });
        }
        function get(item, path, def) {
            if (!path) return def;
            for (var pathParts = path.split("."), i = 0; i < pathParts.length; i++) {
                if ("object" != typeof item || null === item) return def;
                item = item[pathParts[i]];
            }
            return void 0 === item ? def : item;
        }
        function replaceObject(item, replacers, fullKey) {
            if (void 0 === fullKey && (fullKey = ""), Array.isArray(item)) {
                var _ret = function() {
                    for (var length = item.length, result = [], _loop = function(i) {
                        Object.defineProperty(result, i, {
                            configurable: !0,
                            enumerable: !0,
                            get: function() {
                                var itemKey = fullKey ? fullKey + "." + i : "" + i, child = item[i], replacer = replacers[typeof child];
                                if (replacer) {
                                    var replaced = replacer(child, i, itemKey);
                                    if (void 0 !== replaced) return result[i] = replaced, result[i];
                                }
                                return "object" == typeof child && null !== child ? (result[i] = replaceObject(child, replacers, itemKey), 
                                result[i]) : (result[i] = child, result[i]);
                            },
                            set: function(value) {
                                delete result[i], result[i] = value;
                            }
                        });
                    }, i = 0; i < length; i++) _loop(i);
                    return {
                        v: result
                    };
                }();
                if ("object" == typeof _ret) return _ret.v;
            } else {
                if ("object" != typeof item || null === item) throw new Error("Pass an object or array");
                var _ret2 = function() {
                    var result = {}, _loop2 = function(key) {
                        if (!item.hasOwnProperty(key)) return "continue";
                        Object.defineProperty(result, key, {
                            configurable: !0,
                            enumerable: !0,
                            get: function() {
                                var itemKey = fullKey ? fullKey + "." + key : "" + key, child = item[key], replacer = replacers[typeof child];
                                if (replacer) {
                                    var replaced = replacer(child, key, itemKey);
                                    if (void 0 !== replaced) return result[key] = replaced, result[key];
                                }
                                return "object" == typeof child && null !== child ? (result[key] = replaceObject(child, replacers, itemKey), 
                                result[key]) : (result[key] = child, result[key]);
                            },
                            set: function(value) {
                                delete result[key], result[key] = value;
                            }
                        });
                    };
                    for (var key in item) _loop2(key);
                    return {
                        v: result
                    };
                }();
                if ("object" == typeof _ret2) return _ret2.v;
            }
        }
        function copyProp(source, target, name, def) {
            if (source.hasOwnProperty(name)) {
                var descriptor = Object.getOwnPropertyDescriptor(source, name);
                Object.defineProperty(target, name, descriptor);
            } else target[name] = def;
        }
        function dotify(obj, prefix, newobj) {
            for (var key in void 0 === prefix && (prefix = ""), void 0 === newobj && (newobj = {}), 
            prefix = prefix ? prefix + "." : prefix, obj) null != obj[key] && "function" != typeof obj[key] && (obj[key] && Array.isArray(obj[key]) && obj[key].length && obj[key].every(function(val) {
                return "object" != typeof val;
            }) ? newobj["" + prefix + key] = obj[key].join(",") : obj[key] && "object" == typeof obj[key] ? newobj = dotify(obj[key], "" + prefix + key, newobj) : newobj["" + prefix + key] = obj[key].toString());
            return newobj;
        }
        var objectIDs = new cross_domain_safe_weakmap_src.a();
        function getObjectID(obj) {
            if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
            var uid = objectIDs.get(obj);
            return uid || (uid = typeof obj + ":" + uniqueID(), objectIDs.set(obj, uid)), uid;
        }
        function stringify(item) {
            return "string" == typeof item ? item : item && "function" == typeof item.toString ? item.toString() : {}.toString.call(item);
        }
        function stringifyError(err) {
            if (err) {
                var stack = err.stack, message = err.message;
                if ("string" == typeof stack) return stack;
                if ("string" == typeof message) return message;
            }
            return stringify(err);
        }
        function eventEmitter() {
            var triggered = {}, handlers = {};
            return {
                on: function(eventName, handler) {
                    var handlerList = handlers[eventName] = handlers[eventName] || [];
                    handlerList.push(handler);
                    var cancelled = !1;
                    return {
                        cancel: function() {
                            cancelled || (cancelled = !0, handlerList.splice(handlerList.indexOf(handler), 1));
                        }
                    };
                },
                once: function(eventName, handler) {
                    var listener = this.on(eventName, function() {
                        listener.cancel(), handler();
                    });
                    return listener;
                },
                trigger: function(eventName) {
                    var handlerList = handlers[eventName];
                    if (handlerList) for (var _i3 = 0; _i3 < handlerList.length; _i3++) (0, handlerList[_i3])();
                },
                triggerOnce: function(eventName) {
                    triggered[eventName] || (triggered[eventName] = !0, this.trigger(eventName));
                }
            };
        }
        function noop() {}
        function once(method) {
            var result, called = !1;
            return function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                return called ? result : (called = !0, result = method.apply(this, arguments));
            };
        }
        function memoize(method) {
            var results = {};
            return function() {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
                var cacheKey;
                try {
                    cacheKey = JSON.stringify([].slice.call(arguments), function(key, val) {
                        return "function" == typeof val ? "zoid:memoize[" + getObjectID(val) + "]" : val;
                    });
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
                return results.hasOwnProperty(cacheKey) || (results[cacheKey] = method.apply(this, arguments)), 
                results[cacheKey];
            };
        }
        function debounce(method, time) {
            var timeout;
            return void 0 === time && (time = 100), function() {
                var _this = this, _arguments = arguments;
                clearTimeout(timeout), timeout = setTimeout(function() {
                    return method.apply(_this, _arguments);
                }, time);
            };
        }
        function serializeFunctions(obj) {
            return replaceObject(obj, {
                function: function() {
                    return {
                        __type__: "__function__"
                    };
                }
            });
        }
        function deserializeFunctions(obj, handler) {
            return replaceObject(obj, {
                object: function(value, key, fullKey) {
                    if (value && "__function__" === value.__type__) return function() {
                        return handler({
                            key: key,
                            fullKey: fullKey,
                            self: this,
                            args: arguments
                        });
                    };
                }
            });
        }
        function appendChild(container, child) {
            container.appendChild(child);
        }
        function getElementSafe(id) {
            if (id instanceof window.Element || null !== id && "object" == typeof id && 1 === id.nodeType && "object" == typeof id.style && "object" == typeof id.ownerDocument) return id;
            if ("string" == typeof id) {
                var element = document.getElementById(id);
                if (element) return element;
                if (document.querySelector && (element = document.querySelector(id)), element) return element;
            }
        }
        function getElement(id) {
            var element = getElementSafe(id);
            if (element) return element;
            throw new Error("Can not find element: " + stringify(id));
        }
        function isDocumentReady() {
            return "complete" === window.document.readyState;
        }
        function elementReady(id) {
            return new zalgo_promise_src.a(function(resolve, reject) {
                var name = stringify(id), el = getElementSafe(id);
                if (el) return resolve(el);
                if (isDocumentReady()) return reject(new Error("Document is ready and element " + name + " does not exist"));
                var interval = setInterval(function() {
                    return (el = getElementSafe(id)) ? (clearInterval(interval), resolve(el)) : isDocumentReady() ? (clearInterval(interval), 
                    reject(new Error("Document is ready and element " + name + " does not exist"))) : void 0;
                }, 10);
            });
        }
        function popup(url, options) {
            var win, err, params = Object.keys(options).map(function(key) {
                if (options[key]) return key + "=" + stringify(options[key]);
            }).filter(Boolean).join(",");
            try {
                win = window.open(url, options.name, params, !0);
            } catch (err) {
                throw new error.b("Can not open popup window - " + (err.stack || err.message));
            }
            if (Object(src.y)(win)) throw new error.b("Can not open popup window - blocked");
            return win;
        }
        function writeToWindow(win, html) {
            try {
                win.document.open(), win.document.write(html), win.document.close();
            } catch (err) {
                try {
                    win.location = "javascript: document.open(); document.write(" + JSON.stringify(html) + "); document.close();";
                } catch (err2) {}
            }
        }
        function writeElementToWindow(win, el) {
            var tag = el.tagName.toLowerCase();
            if ("html" !== tag) throw new Error("Expected element to be html, got " + tag);
            for (var documentElement = win.document.documentElement; documentElement.children && documentElement.children.length; ) documentElement.removeChild(documentElement.children[0]);
            for (;el.children.length; ) documentElement.appendChild(el.children[0]);
        }
        function setStyle(el, styleText, doc) {
            void 0 === doc && (doc = window.document), el.styleSheet ? el.styleSheet.cssText = styleText : el.appendChild(doc.createTextNode(styleText));
        }
        new zalgo_promise_src.a(function(resolve) {
            if ("complete" === window.document.readyState) return resolve(window.document);
            var interval = setInterval(function() {
                if ("complete" === window.document.readyState) return clearInterval(interval), resolve(window.document);
            }, 10);
        });
        var awaitFrameLoadPromises = new cross_domain_safe_weakmap_src.a();
        function awaitFrameLoad(frame) {
            if (awaitFrameLoadPromises.has(frame)) {
                var _promise = awaitFrameLoadPromises.get(frame);
                if (_promise) return _promise;
            }
            var promise = new zalgo_promise_src.a(function(resolve, reject) {
                frame.addEventListener("load", function() {
                    Object(src.z)(frame), resolve(frame);
                }), frame.addEventListener("error", function(err) {
                    frame.contentWindow ? resolve(frame) : reject(err);
                });
            });
            return awaitFrameLoadPromises.set(frame, promise), promise;
        }
        function awaitFrameWindow(frame) {
            return frame.contentWindow ? zalgo_promise_src.a.resolve(frame.contentWindow) : awaitFrameLoad(frame).then(function(loadedFrame) {
                if (!loadedFrame.contentWindow) throw new Error("Could not find window in iframe");
                return loadedFrame.contentWindow;
            });
        }
        function iframe(options, container) {
            void 0 === options && (options = {});
            var el = getElement(container), attributes = options.attributes || {}, style = options.style || {}, frame = function(tag, options, container) {
                void 0 === tag && (tag = "div"), void 0 === options && (options = {}), tag = tag.toLowerCase();
                var element = document.createElement(tag);
                if (options.style && extend(element.style, options.style), options.class && (element.className = options.class.join(" ")), 
                options.attributes) for (var _i2 = 0, _Object$keys2 = Object.keys(options.attributes); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    element.setAttribute(key, options.attributes[key]);
                }
                if (options.styleSheet && setStyle(element, options.styleSheet), options.html) {
                    if ("iframe" === tag) throw new Error("Iframe html can not be written unless container provided and iframe in DOM");
                    element.innerHTML = options.html;
                }
                return element;
            }("iframe", {
                attributes: Object(esm_extends.a)({
                    frameBorder: "0",
                    allowTransparency: "true"
                }, attributes),
                style: Object(esm_extends.a)({
                    backgroundColor: "transparent"
                }, style),
                html: options.html,
                class: options.class
            });
            return awaitFrameLoad(frame), el.appendChild(frame), (options.url || window.navigator.userAgent.match(/MSIE|Edge/i)) && frame.setAttribute("src", options.url || "about:blank"), 
            frame;
        }
        function addEventListener(obj, event, handler) {
            return obj.addEventListener(event, handler), {
                cancel: function() {
                    obj.removeEventListener(event, handler);
                }
            };
        }
        var parseQuery = memoize(function(queryString) {
            var params = {};
            if (!queryString) return params;
            if (-1 === queryString.indexOf("=")) throw new Error("Can not parse query string params: " + queryString);
            for (var _i4 = 0, _queryString$split2 = queryString.split("&"); _i4 < _queryString$split2.length; _i4++) {
                var pair = _queryString$split2[_i4];
                (pair = pair.split("="))[0] && pair[1] && (params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]));
            }
            return params;
        });
        function extendQuery(originalQuery, props) {
            return void 0 === props && (props = {}), props && Object.keys(props).length ? (void 0 === (obj = Object(esm_extends.a)({}, parseQuery(originalQuery), {}, props)) && (obj = {}), 
            Object.keys(obj).filter(function(key) {
                return "string" == typeof obj[key];
            }).map(function(key) {
                return urlEncode(key) + "=" + urlEncode(obj[key]);
            }).join("&")) : originalQuery;
            var obj;
        }
        function extendUrl(url, options) {
            void 0 === options && (options = {});
            var originalUrl, originalHash, query = options.query || {}, hash = options.hash || {}, _url$split = url.split("#");
            originalHash = _url$split[1];
            var _originalUrl$split = (originalUrl = _url$split[0]).split("?");
            originalUrl = _originalUrl$split[0];
            var queryString = extendQuery(_originalUrl$split[1], query), hashString = extendQuery(originalHash, hash);
            return queryString && (originalUrl = originalUrl + "?" + queryString), hashString && (originalUrl = originalUrl + "#" + hashString), 
            originalUrl;
        }
        function bindEvents(element, eventNames, handler) {
            handler = once(handler);
            for (var _i8 = 0; _i8 < eventNames.length; _i8++) element.addEventListener(eventNames[_i8], handler);
            return {
                cancel: once(function() {
                    for (var _i10 = 0; _i10 < eventNames.length; _i10++) element.removeEventListener(eventNames[_i10], handler);
                })
            };
        }
        var VENDOR_PREFIXES = [ "webkit", "moz", "ms", "o" ];
        function setVendorCSS(element, name, value) {
            element.style[name] = value;
            for (var string, capitalizedName = (string = name).charAt(0).toUpperCase() + string.slice(1).toLowerCase(), _i12 = 0; _i12 < VENDOR_PREFIXES.length; _i12++) element.style["" + VENDOR_PREFIXES[_i12] + capitalizedName] = value;
        }
        var CSSRule = window.CSSRule, KEYFRAMES_RULE = CSSRule.KEYFRAMES_RULE || CSSRule.WEBKIT_KEYFRAMES_RULE || CSSRule.MOZ_KEYFRAMES_RULE || CSSRule.O_KEYFRAMES_RULE || CSSRule.MS_KEYFRAMES_RULE, ANIMATION_START_EVENTS = [ "animationstart", "webkitAnimationStart", "oAnimationStart", "MSAnimationStart" ], ANIMATION_END_EVENTS = [ "animationend", "webkitAnimationEnd", "oAnimationEnd", "MSAnimationEnd" ];
        function animate(element, name, clean, timeout) {
            return void 0 === timeout && (timeout = 1e3), new zalgo_promise_src.a(function(resolve, reject) {
                var el = getElement(element);
                if (!el || !function(element, name) {
                    var stylesheets = el.ownerDocument.styleSheets;
                    try {
                        for (var i = 0; i < stylesheets.length; i++) {
                            var cssRules = stylesheets[i].cssRules;
                            if (cssRules) for (var j = 0; j < cssRules.length; j++) {
                                var cssRule = cssRules[j];
                                if (cssRule && cssRule.type === KEYFRAMES_RULE && cssRule.name === name) return !0;
                            }
                        }
                    } catch (err) {
                        return !1;
                    }
                    return !1;
                }(0, name)) return resolve();
                var startTimeout, endTimeout, startEvent, endEvent, hasStarted = !1;
                function cleanUp() {
                    setVendorCSS(el, "animationName", ""), clearTimeout(startTimeout), clearTimeout(endTimeout), 
                    startEvent.cancel(), endEvent.cancel();
                }
                startEvent = bindEvents(el, ANIMATION_START_EVENTS, function(event) {
                    event.target === el && event.animationName === name && (clearTimeout(startTimeout), 
                    event.stopPropagation(), startEvent.cancel(), hasStarted = !0, endTimeout = setTimeout(function() {
                        cleanUp(), resolve();
                    }, timeout));
                }), endEvent = bindEvents(el, ANIMATION_END_EVENTS, function(event) {
                    if (event.target === el && event.animationName === name) return cleanUp(), "string" == typeof event.animationName && event.animationName !== name ? reject("Expected animation name to be " + name + ", found " + event.animationName) : resolve();
                }), setVendorCSS(el, "animationName", name), startTimeout = setTimeout(function() {
                    if (!hasStarted) return cleanUp(), resolve();
                }, 200), clean && clean(cleanUp);
            });
        }
        var STYLE = {
            DISPLAY: {
                NONE: "none",
                BLOCK: "block"
            },
            VISIBILITY: {
                VISIBLE: "visible",
                HIDDEN: "hidden"
            },
            IMPORTANT: "important"
        };
        function showElement(element) {
            element.style.setProperty("display", "");
        }
        function hideElement(element) {
            element.style.setProperty("display", STYLE.DISPLAY.NONE, STYLE.IMPORTANT);
        }
        function destroyElement(element) {
            element.parentNode && element.parentNode.removeChild(element);
        }
        function showAndAnimate(element, name, clean) {
            var animation = animate(element, name, clean);
            return showElement(element), animation;
        }
        function animateAndHide(element, name, clean) {
            return animate(element, name, clean).then(function() {
                hideElement(element);
            });
        }
        function addClass(element, name) {
            element.classList ? element.classList.add(name) : -1 === element.className.split(/\s+/).indexOf(name) && (element.className += " " + name);
        }
        function removeClass(element, name) {
            element.classList ? element.classList.remove(name) : -1 !== element.className.split(/\s+/).indexOf(name) && (element.className = element.className.replace(name, ""));
        }
        function getCurrentScriptDir() {
            return console.warn("Do not use zoid.getCurrentScriptDir() in production -- browser support is limited"), 
            document.currentScript ? document.currentScript.src.split("/").slice(0, -1).join("/") : ".";
        }
        function isElementClosed(el) {
            return !el || !el.parentNode;
        }
        function watchElementForClose(element, handler) {
            var interval, method, timeout;
            return handler = once(handler), isElementClosed(element) ? handler() : (method = function() {
                isElementClosed(element) && (interval.cancel(), handler());
            }, 50, timeout = setTimeout(function runInterval() {
                timeout = setTimeout(runInterval, 50), method.call();
            }, 50), interval = {
                cancel: function() {
                    clearTimeout(timeout);
                }
            }), {
                cancel: function() {
                    interval && interval.cancel();
                }
            };
        }
        function prefetchPage(url) {
            return function(url) {
                return function(contentType, url) {
                    return new zalgo_promise_src.a(function(resolve, reject) {
                        var req = new window.XMLHttpRequest();
                        req.open("GET", url), req.setRequestHeader("Accept", "text/html"), req.send(null), 
                        req.onload = function() {
                            resolve(req.responseText);
                        }, req.onerror = function() {
                            return reject(new Error("prefetch failed"));
                        };
                    });
                }(0, url);
            }(url);
        }
        var JSX_EVENTS = {
            onClick: "click"
        };
        function fixScripts(el, doc) {
            void 0 === doc && (doc = window.document);
            for (var _i14 = 0, _querySelectorAll2 = function(el, selector) {
                return [].slice.call(el.querySelectorAll("script"));
            }(el); _i14 < _querySelectorAll2.length; _i14++) {
                var script = _querySelectorAll2[_i14], newScript = doc.createElement("script");
                newScript.text = script.textContent, script.parentNode.replaceChild(newScript, script);
            }
        }
        function jsxDom(name, props, content) {
            name = name.toLowerCase();
            var doc = this && this.createElement ? this : window.document, el = doc.createElement(name);
            for (var prop in props) prop in JSX_EVENTS ? el.addEventListener(JSX_EVENTS[prop], props[prop]) : "innerHTML" === prop ? (el.innerHTML = props[prop], 
            fixScripts(el, doc)) : el.setAttribute(prop, props[prop]);
            if ("style" === name) {
                if ("string" != typeof content) throw new TypeError("Expected " + name + " tag content to be string, got " + typeof content);
                if (arguments.length > 3) throw new Error("Expected only text content for " + name + " tag");
                setStyle(el, content, doc);
            } else if ("iframe" === name) {
                if (arguments.length > 3) throw new Error("Expected only single child node for iframe");
                el.addEventListener("load", function() {
                    var win = el.contentWindow;
                    if (!win) throw new Error("Expected frame to have contentWindow");
                    "string" == typeof content ? writeToWindow(win, content) : writeElementToWindow(win, content);
                });
            } else if ("script" === name) {
                if ("string" != typeof content) throw new TypeError("Expected " + name + " tag content to be string, got " + typeof content);
                if (arguments.length > 3) throw new Error("Expected only text content for " + name + " tag");
                el.text = content;
            } else for (var i = 2; i < arguments.length; i++) if ("string" == typeof arguments[i]) {
                var textNode = doc.createTextNode(arguments[i]);
                appendChild(el, textNode);
            } else appendChild(el, arguments[i]);
            return el;
        }
        function denodeify(method) {
            return function() {
                var self = this, args = [].slice.call(arguments);
                return args.length >= method.length ? zalgo_promise_src.a.resolve(method.apply(self, args)) : new zalgo_promise_src.a(function(resolve, reject) {
                    args.push(function(err, result) {
                        if (err && !(err instanceof Error)) throw new Error("Passed non-Error object in callback: [ " + err + " ] -- callbacks should either be called with callback(new Error(...)) or callback(null, result).");
                        return err ? reject(err) : resolve(result);
                    }), method.apply(self, args);
                });
            };
        }
        function promisify(method) {
            return function() {
                var _this = this, _arguments = arguments;
                return zalgo_promise_src.a.try(function() {
                    return method.apply(_this, _arguments);
                });
            };
        }
        function isPerc(str) {
            return "string" == typeof str && /^[0-9]+%$/.test(str);
        }
        function isPx(str) {
            return "string" == typeof str && /^[0-9]+px$/.test(str);
        }
        function toNum(val) {
            if ("number" == typeof val) return val;
            var match = val.match(/^([0-9]+)(px|%)$/);
            if (!match) throw new Error("Could not match css value from " + val);
            return parseInt(match[1], 10);
        }
        function toPx(val) {
            return toNum(val) + "px";
        }
        function toCSS(val) {
            return "number" == typeof val ? toPx(val) : isPerc(val) ? val : toPx(val);
        }
        function normalizeDimension(dim, max) {
            if ("number" == typeof dim) return dim;
            if (isPerc(dim)) return parseInt(max * toNum(dim) / 100, 10);
            if (isPx(dim)) return toNum(dim);
            throw new Error("Can not normalize dimension: " + dim);
        }
        function memoized(target, name, descriptor) {
            var method = descriptor.value;
            descriptor.value = function() {
                return this.__memoized__ = this.__memoized__ || {}, this.__memoized__.hasOwnProperty(name) || (this.__memoized__[name] = method.apply(this, arguments)), 
                this.__memoized__[name];
            }, descriptor.value.displayName = name + ":memoized";
        }
        var post_robot_src = __webpack_require__(13), client = __webpack_require__(4);
        function setLogLevel(logLevel) {
            if (-1 === client.m.indexOf(logLevel)) throw new Error("Invalid logLevel: " + logLevel);
            client.e.logLevel = logLevel, post_robot_src.CONFIG.LOG_LEVEL = logLevel, window.LOG_LEVEL = logLevel;
        }
        function info(name, event, payload) {
            void 0 === payload && (payload = {}), Object(client.k)("xc_" + name + "_" + event, payload);
        }
        function warn(name, event, payload) {
            void 0 === payload && (payload = {}), Object(client.q)("xc_" + name + "_" + event, payload);
        }
        function logger_error(name, event, payload) {
            void 0 === payload && (payload = {}), Object(client.g)("xc_" + name + "_" + event, payload);
        }
        var constants = __webpack_require__(8);
        function globalFor(win) {
            if (Object(src.u)(win)) return win[constants.__ZOID__] || (win[constants.__ZOID__] = {}), 
            win[constants.__ZOID__];
        }
        var global = function() {
            var global = globalFor(window);
            if (!global) throw new Error("Could not get local global");
            return global;
        }();
        __webpack_require__.d(__webpack_exports__, "d", function() {
            return appendChild;
        }), __webpack_require__.d(__webpack_exports__, "u", function() {
            return getElement;
        }), __webpack_require__.d(__webpack_exports__, "n", function() {
            return elementReady;
        }), __webpack_require__.d(__webpack_exports__, "I", function() {
            return popup;
        }), __webpack_require__.d(__webpack_exports__, "Y", function() {
            return writeToWindow;
        }), __webpack_require__.d(__webpack_exports__, "X", function() {
            return writeElementToWindow;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return awaitFrameLoad;
        }), __webpack_require__.d(__webpack_exports__, "f", function() {
            return awaitFrameWindow;
        }), __webpack_require__.d(__webpack_exports__, "y", function() {
            return iframe;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return addEventListener;
        }), __webpack_require__.d(__webpack_exports__, "r", function() {
            return extendUrl;
        }), __webpack_require__.d(__webpack_exports__, "Q", function() {
            return showElement;
        }), __webpack_require__.d(__webpack_exports__, "x", function() {
            return hideElement;
        }), __webpack_require__.d(__webpack_exports__, "l", function() {
            return destroyElement;
        }), __webpack_require__.d(__webpack_exports__, "P", function() {
            return showAndAnimate;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return animateAndHide;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return addClass;
        }), __webpack_require__.d(__webpack_exports__, "L", function() {
            return removeClass;
        }), __webpack_require__.d(__webpack_exports__, "t", function() {
            return getCurrentScriptDir;
        }), __webpack_require__.d(__webpack_exports__, "W", function() {
            return watchElementForClose;
        }), __webpack_require__.d(__webpack_exports__, "J", function() {
            return prefetchPage;
        }), __webpack_require__.d(__webpack_exports__, "C", function() {
            return jsxDom;
        }), __webpack_require__.d(__webpack_exports__, "F", function() {
            return noop;
        }), __webpack_require__.d(__webpack_exports__, "H", function() {
            return once;
        }), __webpack_require__.d(__webpack_exports__, "D", function() {
            return memoize;
        }), __webpack_require__.d(__webpack_exports__, "i", function() {
            return debounce;
        }), __webpack_require__.d(__webpack_exports__, "N", function() {
            return serializeFunctions;
        }), __webpack_require__.d(__webpack_exports__, "k", function() {
            return deserializeFunctions;
        }), __webpack_require__.d(__webpack_exports__, "j", function() {
            return denodeify;
        }), __webpack_require__.d(__webpack_exports__, "K", function() {
            return promisify;
        }), __webpack_require__.d(__webpack_exports__, "h", function() {
            return dasherizeToCamel;
        }), __webpack_require__.d(__webpack_exports__, "q", function() {
            return extend;
        }), __webpack_require__.d(__webpack_exports__, "U", function() {
            return uniqueID;
        }), __webpack_require__.d(__webpack_exports__, "s", function() {
            return get;
        }), __webpack_require__.d(__webpack_exports__, "M", function() {
            return replaceObject;
        }), __webpack_require__.d(__webpack_exports__, "g", function() {
            return copyProp;
        }), __webpack_require__.d(__webpack_exports__, "m", function() {
            return dotify;
        }), __webpack_require__.d(__webpack_exports__, "R", function() {
            return stringify;
        }), __webpack_require__.d(__webpack_exports__, "S", function() {
            return stringifyError;
        }), __webpack_require__.d(__webpack_exports__, "p", function() {
            return eventEmitter;
        }), __webpack_require__.d(__webpack_exports__, "A", function() {
            return isPerc;
        }), __webpack_require__.d(__webpack_exports__, "B", function() {
            return isPx;
        }), __webpack_require__.d(__webpack_exports__, "T", function() {
            return toCSS;
        }), __webpack_require__.d(__webpack_exports__, "G", function() {
            return normalizeDimension;
        }), __webpack_require__.d(__webpack_exports__, "E", function() {
            return memoized;
        }), __webpack_require__.d(__webpack_exports__, "O", function() {
            return setLogLevel;
        }), __webpack_require__.d(__webpack_exports__, "z", function() {
            return info;
        }), __webpack_require__.d(__webpack_exports__, "V", function() {
            return warn;
        }), __webpack_require__.d(__webpack_exports__, "o", function() {
            return logger_error;
        }), __webpack_require__.d(__webpack_exports__, "w", function() {
            return globalFor;
        }), __webpack_require__.d(__webpack_exports__, "v", function() {
            return global;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return jsxToHTML;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return jsxRender;
        });
        var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20), _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12);
        function htmlEncode(html) {
            return void 0 === html && (html = ""), html.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/\//g, "&#x2F;");
        }
        var JsxHTMLNode = function() {
            function JsxHTMLNode(name, props, children) {
                this.name = void 0, this.props = void 0, this.children = void 0, this.name = name, 
                this.props = props, this.children = children;
            }
            var _proto = JsxHTMLNode.prototype;
            return _proto.toString = function() {
                return "<" + this.name + (this.props ? " " : "") + (this.props ? this.propsToString() : "") + ">" + this.childrenToString() + "</" + this.name + ">";
            }, _proto.propsToString = function() {
                var props = this.props;
                return props ? Object.keys(props).filter(function(key) {
                    return "innerHTML" !== key && props && !1 !== props[key];
                }).map(function(key) {
                    return props && !0 === props[key] ? "" + htmlEncode(key) : props ? htmlEncode(key) + '="' + htmlEncode(props[key]) + '"' : "";
                }).join(" ") : "";
            }, _proto.childrenToString = function() {
                if (this.props && this.props.innerHTML) return this.props.innerHTML;
                if (!this.children) return "";
                var result = "";
                return function iterate(children) {
                    for (var _i2 = 0; _i2 < children.length; _i2++) {
                        var child = children[_i2];
                        null != child && (Array.isArray(child) ? iterate(child) : result += child instanceof JsxHTMLNode ? child.toString() : htmlEncode(child));
                    }
                }(this.children), result;
            }, JsxHTMLNode;
        }(), JsxHTMLNodeContainer = function(_JsxHTMLNode) {
            function JsxHTMLNodeContainer(children) {
                return _JsxHTMLNode.call(this, "", {}, children) || this;
            }
            return Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__.a)(JsxHTMLNodeContainer, _JsxHTMLNode), 
            JsxHTMLNodeContainer.prototype.toString = function() {
                return this.childrenToString();
            }, JsxHTMLNodeContainer;
        }(JsxHTMLNode);
        function jsxToHTML(name, props) {
            for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) children[_key - 2] = arguments[_key];
            return new JsxHTMLNode(name, props, children);
        }
        function jsxRender(template, renderers) {
            var nodes = Object(_util__WEBPACK_IMPORTED_MODULE_1__.n)(template, /\{\s*([a-z]+)(?::\s*([^} ]+))?\s*\}|([^${}]+)/g, function(match, type, value, text) {
                if (type) {
                    if (!renderers[type]) throw new Error("Can not render type: " + type);
                    return renderers[type](value);
                }
                return text && text.trim() && renderers.text ? /<br>/.test(text) ? renderers.break(text) : renderers.text(text) : text;
            });
            return new JsxHTMLNodeContainer(nodes);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function isRegex(item) {
            return "[object RegExp]" === {}.toString.call(item);
        }
        var PROTOCOL = {
            MOCK: "mock:",
            FILE: "file:",
            ABOUT: "about:"
        }, WILDCARD = "*", IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
        function isAboutProtocol(win) {
            return void 0 === win && (win = window), win.location.protocol === PROTOCOL.ABOUT;
        }
        function getParent(win) {
            if (void 0 === win && (win = window), win) try {
                if (win.parent && win.parent !== win) return win.parent;
            } catch (err) {}
        }
        function getOpener(win) {
            if (void 0 === win && (win = window), win && !getParent(win)) try {
                return win.opener;
            } catch (err) {}
        }
        function canReadFromWindow(win) {
            try {
                return !0;
            } catch (err) {}
            return !1;
        }
        function getActualDomain(win) {
            var location = (win = win || window).location;
            if (!location) throw new Error("Can not read window location");
            var protocol = location.protocol;
            if (!protocol) throw new Error("Can not read window protocol");
            if (protocol === PROTOCOL.FILE) return PROTOCOL.FILE + "//";
            if (protocol === PROTOCOL.ABOUT) {
                var parent = getParent(win);
                return parent && canReadFromWindow() ? getActualDomain(parent) : PROTOCOL.ABOUT + "//";
            }
            var host = location.host;
            if (!host) throw new Error("Can not read window host");
            return protocol + "//" + host;
        }
        function getDomain(win) {
            var domain = getActualDomain(win = win || window);
            return domain && win.mockDomain && 0 === win.mockDomain.indexOf(PROTOCOL.MOCK) ? win.mockDomain : domain;
        }
        function isActuallySameDomain(win) {
            try {
                if (win === window) return !0;
            } catch (err) {}
            try {
                var desc = Object.getOwnPropertyDescriptor(win, "location");
                if (desc && !1 === desc.enumerable) return !1;
            } catch (err) {}
            try {
                if (isAboutProtocol(win) && canReadFromWindow()) return !0;
            } catch (err) {}
            try {
                if (getActualDomain(win) === getActualDomain(window)) return !0;
            } catch (err) {}
            return !1;
        }
        function isSameDomain(win) {
            if (!isActuallySameDomain(win)) return !1;
            try {
                if (win === window) return !0;
                if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                if (getDomain(window) === getDomain(win)) return !0;
            } catch (err) {}
            return !1;
        }
        function isAncestorParent(parent, child) {
            if (!parent || !child) return !1;
            var childParent = getParent(child);
            return childParent ? childParent === parent : -1 !== function(win) {
                var result = [];
                try {
                    for (;win.parent !== win; ) result.push(win.parent), win = win.parent;
                } catch (err) {}
                return result;
            }(child).indexOf(parent);
        }
        function getFrames(win) {
            var frames, len, result = [];
            try {
                frames = win.frames;
            } catch (err) {
                frames = win;
            }
            try {
                len = frames.length;
            } catch (err) {}
            if (0 === len) return result;
            if (len) {
                for (var i = 0; i < len; i++) {
                    var frame = void 0;
                    try {
                        frame = frames[i];
                    } catch (err) {
                        continue;
                    }
                    result.push(frame);
                }
                return result;
            }
            for (var _i = 0; _i < 100; _i++) {
                var _frame = void 0;
                try {
                    _frame = frames[_i];
                } catch (err) {
                    return result;
                }
                if (!_frame) return result;
                result.push(_frame);
            }
            return result;
        }
        function getAllChildFrames(win) {
            for (var result = [], _i3 = 0, _getFrames2 = getFrames(win); _i3 < _getFrames2.length; _i3++) {
                var frame = _getFrames2[_i3];
                result.push(frame);
                for (var _i5 = 0, _getAllChildFrames2 = getAllChildFrames(frame); _i5 < _getAllChildFrames2.length; _i5++) result.push(_getAllChildFrames2[_i5]);
            }
            return result;
        }
        function getTop(win) {
            if (win) {
                try {
                    if (win.top) return win.top;
                } catch (err) {}
                if (getParent(win) === win) return win;
                try {
                    if (isAncestorParent(window, win) && window.top) return window.top;
                } catch (err) {}
                try {
                    if (isAncestorParent(win, window) && window.top) return window.top;
                } catch (err) {}
                for (var _i7 = 0, _getAllChildFrames4 = getAllChildFrames(win); _i7 < _getAllChildFrames4.length; _i7++) {
                    var frame = _getAllChildFrames4[_i7];
                    try {
                        if (frame.top) return frame.top;
                    } catch (err) {}
                    if (getParent(frame) === frame) return frame;
                }
            }
        }
        function getAllFramesInWindow(win) {
            var top = getTop(win);
            if (!top) throw new Error("Can not determine top window");
            return [].concat(getAllChildFrames(top), [ top ]);
        }
        function isTop(win) {
            return win === getTop(win);
        }
        var iframeWindows = [], iframeFrames = [];
        function isWindowClosed(win, allowMock) {
            void 0 === allowMock && (allowMock = !0);
            try {
                if (win === window) return !1;
            } catch (err) {
                return !0;
            }
            try {
                if (!win) return !0;
            } catch (err) {
                return !0;
            }
            try {
                if (win.closed) return !0;
            } catch (err) {
                return !err || err.message !== IE_WIN_ACCESS_ERROR;
            }
            if (allowMock && isSameDomain(win)) try {
                if (win.mockclosed) return !0;
            } catch (err) {}
            try {
                if (!win.parent || !win.top) return !0;
            } catch (err) {}
            var iframeIndex = function(collection, item) {
                for (var i = 0; i < collection.length; i++) try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }(iframeWindows, win);
            if (-1 !== iframeIndex) {
                var frame = iframeFrames[iframeIndex];
                if (frame && function(frame) {
                    if (!frame.contentWindow) return !0;
                    if (!frame.parentNode) return !0;
                    var doc = frame.ownerDocument;
                    return !(!doc || !doc.documentElement || doc.documentElement.contains(frame));
                }(frame)) return !0;
            }
            return !1;
        }
        function linkFrameWindow(frame) {
            if (function() {
                for (var i = 0; i < iframeWindows.length; i++) {
                    var closed = !1;
                    try {
                        closed = iframeWindows[i].closed;
                    } catch (err) {}
                    closed && (iframeFrames.splice(i, 1), iframeWindows.splice(i, 1));
                }
            }(), frame && frame.contentWindow) try {
                iframeWindows.push(frame.contentWindow), iframeFrames.push(frame);
            } catch (err) {}
        }
        function getUserAgent(win) {
            return (win = win || window).navigator.mockUserAgent || win.navigator.userAgent;
        }
        function getFrameByName(win, name) {
            for (var winFrames = getFrames(win), _i9 = 0; _i9 < winFrames.length; _i9++) {
                var childFrame = winFrames[_i9];
                try {
                    if (isSameDomain(childFrame) && childFrame.name === name && -1 !== winFrames.indexOf(childFrame)) return childFrame;
                } catch (err) {}
            }
            try {
                if (-1 !== winFrames.indexOf(win.frames[name])) return win.frames[name];
            } catch (err) {}
            try {
                if (-1 !== winFrames.indexOf(win[name])) return win[name];
            } catch (err) {}
        }
        function findFrameByName(win, name) {
            var frame;
            return (frame = getFrameByName(win, name)) ? frame : function findChildFrameByName(win, name) {
                var frame = getFrameByName(win, name);
                if (frame) return frame;
                for (var _i11 = 0, _getFrames4 = getFrames(win); _i11 < _getFrames4.length; _i11++) {
                    var namedFrame = findChildFrameByName(_getFrames4[_i11], name);
                    if (namedFrame) return namedFrame;
                }
            }(getTop(win) || win, name);
        }
        function isOpener(parent, child) {
            return parent === getOpener(child);
        }
        function getAncestor(win) {
            return void 0 === win && (win = window), getOpener(win = win || window) || getParent(win) || void 0;
        }
        function isAncestor(parent, child) {
            var actualParent = getAncestor(child);
            if (actualParent) return actualParent === parent;
            if (child === parent) return !1;
            if (getTop(child) === child) return !1;
            for (var _i15 = 0, _getFrames8 = getFrames(parent); _i15 < _getFrames8.length; _i15++) if (_getFrames8[_i15] === child) return !0;
            return !1;
        }
        function isPopup() {
            return Boolean(getOpener(window));
        }
        function isIframe() {
            return Boolean(getParent(window));
        }
        function anyMatch(collection1, collection2) {
            for (var _i17 = 0; _i17 < collection1.length; _i17++) for (var item1 = collection1[_i17], _i19 = 0; _i19 < collection2.length; _i19++) if (item1 === collection2[_i19]) return !0;
            return !1;
        }
        function getDistanceFromTop(win) {
            void 0 === win && (win = window);
            for (var distance = 0, parent = win; parent; ) (parent = getParent(parent)) && (distance += 1);
            return distance;
        }
        function getNthParentFromTop(win, n) {
            return void 0 === n && (n = 1), function(win, n) {
                void 0 === n && (n = 1);
                for (var parent = win, i = 0; i < n; i++) {
                    if (!parent) return;
                    parent = getParent(parent);
                }
                return parent;
            }(win, getDistanceFromTop(win) - n);
        }
        function isSameTopWindow(win1, win2) {
            var top1 = getTop(win1) || win1, top2 = getTop(win2) || win2;
            try {
                if (top1 && top2) return top1 === top2;
            } catch (err) {}
            var allFrames1 = getAllFramesInWindow(win1), allFrames2 = getAllFramesInWindow(win2);
            if (anyMatch(allFrames1, allFrames2)) return !0;
            var opener1 = getOpener(top1), opener2 = getOpener(top2);
            return !(opener1 && anyMatch(getAllFramesInWindow(opener1), allFrames2) || (opener2 && anyMatch(getAllFramesInWindow(opener2), allFrames1), 
            1));
        }
        function matchDomain(pattern, origin) {
            if ("string" == typeof pattern) {
                if ("string" == typeof origin) return pattern === WILDCARD || origin === pattern;
                if (isRegex(origin)) return !1;
                if (Array.isArray(origin)) return !1;
            }
            return isRegex(pattern) ? isRegex(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !isRegex(origin) && pattern.some(function(subpattern) {
                return matchDomain(subpattern, origin);
            }));
        }
        function stringifyDomainPattern(pattern) {
            return Array.isArray(pattern) ? "(" + pattern.join(" | ") + ")" : isRegex(pattern) ? "RegExp(" + pattern.toString() : pattern.toString();
        }
        function getDomainFromUrl(url) {
            return url.match(/^(https?|mock|file):\/\//) ? url.split("/").slice(0, 3).join("/") : getDomain();
        }
        function onCloseWindow(win, callback, delay, maxtime) {
            var timeout;
            return void 0 === delay && (delay = 1e3), void 0 === maxtime && (maxtime = 1 / 0), 
            function check() {
                if (isWindowClosed(win)) return timeout && clearTimeout(timeout), callback();
                maxtime <= 0 ? clearTimeout(timeout) : (maxtime -= delay, timeout = setTimeout(check, delay));
            }(), {
                cancel: function() {
                    timeout && clearTimeout(timeout);
                }
            };
        }
        function isWindow(obj) {
            try {
                if (obj === window) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if ("[object Window]" === {}.toString.call(obj)) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (window.Window && obj instanceof window.Window) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.self === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.parent === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.top === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
            } catch (err) {
                return !0;
            }
            return !1;
        }
        __webpack_require__.d(__webpack_exports__, "m", function() {
            return getParent;
        }), __webpack_require__.d(__webpack_exports__, "l", function() {
            return getOpener;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return getActualDomain;
        }), __webpack_require__.d(__webpack_exports__, "g", function() {
            return getDomain;
        }), __webpack_require__.d(__webpack_exports__, "p", function() {
            return isActuallySameDomain;
        }), __webpack_require__.d(__webpack_exports__, "u", function() {
            return isSameDomain;
        }), __webpack_require__.d(__webpack_exports__, "j", function() {
            return getFrames;
        }), __webpack_require__.d(__webpack_exports__, "n", function() {
            return getTop;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return getAllFramesInWindow;
        }), __webpack_require__.d(__webpack_exports__, "w", function() {
            return isTop;
        }), __webpack_require__.d(__webpack_exports__, "y", function() {
            return isWindowClosed;
        }), __webpack_require__.d(__webpack_exports__, "z", function() {
            return linkFrameWindow;
        }), __webpack_require__.d(__webpack_exports__, "o", function() {
            return getUserAgent;
        }), __webpack_require__.d(__webpack_exports__, "i", function() {
            return getFrameByName;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return findFrameByName;
        }), __webpack_require__.d(__webpack_exports__, "s", function() {
            return isOpener;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return getAncestor;
        }), __webpack_require__.d(__webpack_exports__, "q", function() {
            return isAncestor;
        }), __webpack_require__.d(__webpack_exports__, "t", function() {
            return isPopup;
        }), __webpack_require__.d(__webpack_exports__, "r", function() {
            return isIframe;
        }), __webpack_require__.d(__webpack_exports__, "f", function() {
            return getDistanceFromTop;
        }), __webpack_require__.d(__webpack_exports__, "k", function() {
            return getNthParentFromTop;
        }), __webpack_require__.d(__webpack_exports__, "v", function() {
            return isSameTopWindow;
        }), __webpack_require__.d(__webpack_exports__, "A", function() {
            return matchDomain;
        }), __webpack_require__.d(__webpack_exports__, "C", function() {
            return stringifyDomainPattern;
        }), __webpack_require__.d(__webpack_exports__, "h", function() {
            return getDomainFromUrl;
        }), __webpack_require__.d(__webpack_exports__, "B", function() {
            return onCloseWindow;
        }), __webpack_require__.d(__webpack_exports__, "x", function() {
            return isWindow;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return PROTOCOL;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "ZOID", function() {
            return ZOID;
        }), __webpack_require__.d(__webpack_exports__, "__ZOID__", function() {
            return __ZOID__;
        }), __webpack_require__.d(__webpack_exports__, "POST_MESSAGE", function() {
            return POST_MESSAGE;
        }), __webpack_require__.d(__webpack_exports__, "PROP_TYPES", function() {
            return PROP_TYPES;
        }), __webpack_require__.d(__webpack_exports__, "INITIAL_PROPS", function() {
            return INITIAL_PROPS;
        }), __webpack_require__.d(__webpack_exports__, "WINDOW_REFERENCES", function() {
            return WINDOW_REFERENCES;
        }), __webpack_require__.d(__webpack_exports__, "PROP_TYPES_LIST", function() {
            return PROP_TYPES_LIST;
        }), __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES", function() {
            return CONTEXT_TYPES;
        }), __webpack_require__.d(__webpack_exports__, "CLASS_NAMES", function() {
            return CLASS_NAMES;
        }), __webpack_require__.d(__webpack_exports__, "EVENTS", function() {
            return EVENTS;
        }), __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", function() {
            return ATTRIBUTES;
        }), __webpack_require__.d(__webpack_exports__, "ANIMATION_NAMES", function() {
            return ANIMATION_NAMES;
        }), __webpack_require__.d(__webpack_exports__, "EVENT_NAMES", function() {
            return EVENT_NAMES;
        }), __webpack_require__.d(__webpack_exports__, "CLOSE_REASONS", function() {
            return CLOSE_REASONS;
        }), __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES_LIST", function() {
            return CONTEXT_TYPES_LIST;
        }), __webpack_require__.d(__webpack_exports__, "DELEGATE", function() {
            return DELEGATE;
        }), __webpack_require__.d(__webpack_exports__, "WILDCARD", function() {
            return WILDCARD;
        }), __webpack_require__.d(__webpack_exports__, "DEFAULT_DIMENSIONS", function() {
            return DEFAULT_DIMENSIONS;
        });
        var ZOID = "zoid", __ZOID__ = "__" + ZOID + "__", POST_MESSAGE = {
            INIT: ZOID + "_init",
            PROPS: ZOID + "_props",
            PROP_CALLBACK: ZOID + "_prop_callback",
            CLOSE: ZOID + "_close",
            CHECK_CLOSE: ZOID + "_check_close",
            REDIRECT: ZOID + "_redirect",
            RESIZE: ZOID + "_resize",
            DELEGATE: ZOID + "_delegate",
            ALLOW_DELEGATE: ZOID + "_allow_delegate",
            ERROR: ZOID + "_error",
            HIDE: ZOID + "_hide",
            SHOW: ZOID + "_show"
        }, PROP_TYPES = {
            STRING: "string",
            OBJECT: "object",
            FUNCTION: "function",
            BOOLEAN: "boolean",
            NUMBER: "number"
        }, INITIAL_PROPS = {
            RAW: "raw",
            UID: "uid"
        }, WINDOW_REFERENCES = {
            OPENER: "opener",
            TOP: "top",
            PARENT: "parent",
            GLOBAL: "global"
        }, PROP_TYPES_LIST = Object.keys(PROP_TYPES).map(function(key) {
            return PROP_TYPES[key];
        }), CONTEXT_TYPES = {
            IFRAME: "iframe",
            POPUP: "popup"
        }, CLASS_NAMES = {
            ZOID: "" + ZOID,
            OUTLET: ZOID + "-outlet",
            COMPONENT_FRAME: ZOID + "-component-frame",
            PRERENDER_FRAME: ZOID + "-prerender-frame",
            VISIBLE: ZOID + "-visible",
            INVISIBLE: ZOID + "-invisible"
        }, EVENTS = {
            CLOSE: ZOID + "-close"
        }, ATTRIBUTES = {
            IFRAME_PLACEHOLDER: "data-zoid-" + ZOID + "-placeholder"
        }, ANIMATION_NAMES = {
            SHOW_CONTAINER: ZOID + "-show-container",
            SHOW_COMPONENT: ZOID + "-show-component",
            HIDE_CONTAINER: ZOID + "-hide-container",
            HIDE_COMPONENT: ZOID + "-hide-component"
        }, EVENT_NAMES = {
            CLICK: "click"
        }, CLOSE_REASONS = {
            PARENT_CALL: "parent_call",
            CHILD_CALL: "child_call",
            CLOSE_DETECTED: "close_detected",
            USER_CLOSED: "user_closed",
            PARENT_CLOSE_DETECTED: "parent_close_detected"
        }, CONTEXT_TYPES_LIST = Object.keys(CONTEXT_TYPES).map(function(key) {
            return CONTEXT_TYPES[key];
        }), DELEGATE = {
            CALL_ORIGINAL: "call_original",
            CALL_DELEGATE: "call_delegate"
        }, WILDCARD = "*", DEFAULT_DIMENSIONS = {
            WIDTH: 300,
            HEIGHT: 150
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return global;
        });
        var _conf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10), global = window[_conf__WEBPACK_IMPORTED_MODULE_0__.b.WINDOW_PROPS.POSTROBOT] = window[_conf__WEBPACK_IMPORTED_MODULE_0__.b.WINDOW_PROPS.POSTROBOT] || {};
        global.registerSelf = function() {};
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var _ALLOWED_POST_MESSAGE, CONSTANTS = {
            POST_MESSAGE_TYPE: {
                REQUEST: "postrobot_message_request",
                RESPONSE: "postrobot_message_response",
                ACK: "postrobot_message_ack"
            },
            POST_MESSAGE_ACK: {
                SUCCESS: "success",
                ERROR: "error"
            },
            POST_MESSAGE_NAMES: {
                METHOD: "postrobot_method",
                HELLO: "postrobot_ready",
                OPEN_TUNNEL: "postrobot_open_tunnel"
            },
            WINDOW_TYPES: {
                FULLPAGE: "fullpage",
                POPUP: "popup",
                IFRAME: "iframe"
            },
            WINDOW_PROPS: {
                POSTROBOT: "__postRobot__"
            },
            SERIALIZATION_TYPES: {
                METHOD: "postrobot_method",
                ERROR: "postrobot_error",
                PROMISE: "postrobot_promise",
                ZALGO_PROMISE: "postrobot_zalgo_promise",
                REGEX: "regex"
            },
            SEND_STRATEGIES: {
                POST_MESSAGE: "postrobot_post_message",
                BRIDGE: "postrobot_bridge",
                GLOBAL: "postrobot_global"
            },
            MOCK_PROTOCOL: "mock:",
            FILE_PROTOCOL: "file:",
            BRIDGE_NAME_PREFIX: "__postrobot_bridge__",
            POSTROBOT_PROXY: "__postrobot_proxy__",
            WILDCARD: "*"
        }, POST_MESSAGE_NAMES = {
            METHOD: "postrobot_method",
            HELLO: "postrobot_hello",
            OPEN_TUNNEL: "postrobot_open_tunnel"
        }, CONFIG = (Object.keys(POST_MESSAGE_NAMES).map(function(key) {
            return POST_MESSAGE_NAMES[key];
        }), {
            ALLOW_POSTMESSAGE_POPUP: !("__ALLOW_POSTMESSAGE_POPUP__" in window) || window.__ALLOW_POSTMESSAGE_POPUP__,
            BRIDGE_TIMEOUT: 5e3,
            CHILD_WINDOW_TIMEOUT: 5e3,
            ACK_TIMEOUT: -1 !== window.navigator.userAgent.match(/MSIE/i) ? 1e4 : 2e3,
            RES_TIMEOUT: -1,
            ALLOWED_POST_MESSAGE_METHODS: (_ALLOWED_POST_MESSAGE = {}, _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.POST_MESSAGE] = !0, 
            _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.BRIDGE] = !0, _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.GLOBAL] = !0, 
            _ALLOWED_POST_MESSAGE),
            ALLOW_SAME_ORIGIN: !1
        });
        0 === window.location.href.indexOf(CONSTANTS.FILE_PROTOCOL) && (CONFIG.ALLOW_POSTMESSAGE_POPUP = !0), 
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return CONFIG;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return CONSTANTS;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function _extends() {
            return (_extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) ({}).hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }).apply(this, arguments);
        }
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return _extends;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "i", function() {
            return memoize;
        }), __webpack_require__.d(__webpack_exports__, "g", function() {
            return match;
        }), __webpack_require__.d(__webpack_exports__, "o", function() {
            return safeJSON;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return eventEmitter;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return awaitKey;
        }), __webpack_require__.d(__webpack_exports__, "q", function() {
            return stringifyError;
        }), __webpack_require__.d(__webpack_exports__, "r", function() {
            return stringifyErrorMessage;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return domainMatches;
        }), __webpack_require__.d(__webpack_exports__, "l", function() {
            return patchMethod;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return extend;
        }), __webpack_require__.d(__webpack_exports__, "p", function() {
            return sortBy;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return identity;
        }), __webpack_require__.d(__webpack_exports__, "t", function() {
            return values;
        }), __webpack_require__.d(__webpack_exports__, "m", function() {
            return perc;
        }), __webpack_require__.d(__webpack_exports__, "h", function() {
            return max;
        }), __webpack_require__.d(__webpack_exports__, "n", function() {
            return regexMap;
        });
        var zalgo_promise_src__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1), belter_src__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16);
        __webpack_require__.d(__webpack_exports__, "j", function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.d;
        }), __webpack_require__.d(__webpack_exports__, "k", function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.f;
        }), __webpack_require__.d(__webpack_exports__, "s", function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.g;
        }), __webpack_require__.d(__webpack_exports__, "f", function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.c;
        });
        var moduleGlobal = {};
        function getGlobal() {
            return "undefined" != typeof window ? window : "undefined" != typeof window ? window : moduleGlobal;
        }
        function memoize(method, options) {
            void 0 === options && (options = {});
            var cache = {};
            return function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                var key;
                try {
                    key = JSON.stringify([].slice.call(arguments));
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
                var time = options.time;
                cache[key] && time && Date.now() - cache[key].time < time && delete cache[key];
                var glob = getGlobal();
                return glob.__CACHE_START_TIME__ && cache[key] && cache[key].time < glob.__CACHE_START_TIME__ && delete cache[key], 
                cache[key] ? cache[key].value : (cache[key] = {
                    time: Date.now(),
                    value: method.apply(this, arguments)
                }, cache[key].value);
            };
        }
        function match(str, pattern) {
            var regmatch = str.match(pattern);
            if (regmatch) return regmatch[1];
        }
        function safeJSON(item) {
            return JSON.stringify(item, function(key, val) {
                if ("function" == typeof val) return "<" + typeof val + ">";
                try {
                    JSON.stringify(val);
                } catch (err) {
                    return "<" + typeof val + ">";
                }
                return val;
            });
        }
        function eventEmitter() {
            var listeners = [];
            return {
                listen: function(method) {
                    return listeners.push(method), {
                        cancel: function() {
                            listeners.splice(listeners.indexOf(method), 1);
                        }
                    };
                },
                once: function(method) {
                    var listener = this.listen(function() {
                        method.apply(null, arguments), listener.cancel();
                    });
                },
                trigger: function() {
                    for (var _i2 = 0; _i2 < listeners.length; _i2++) {
                        var listener = listeners[_i2];
                        listener.apply(void 0, arguments);
                    }
                }
            };
        }
        function awaitKey(obj, key) {
            return new zalgo_promise_src__WEBPACK_IMPORTED_MODULE_0__.a(function(resolve) {
                var value = obj[key];
                if (value) return resolve(value);
                delete obj[key], Object.defineProperty(obj, key, {
                    configurable: !0,
                    set: function(item) {
                        (value = item) && resolve(value);
                    },
                    get: function() {
                        return value;
                    }
                });
            });
        }
        function stringifyError(err, level) {
            if (void 0 === level && (level = 1), level >= 3) return "stringifyError stack overflow";
            try {
                if (!err) return "<unknown error: " + {}.toString.call(err) + ">";
                if ("string" == typeof err) return err;
                if (err instanceof Error) {
                    var stack = err && err.stack, message = err && err.message;
                    if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                    if (stack) return stack;
                    if (message) return message;
                }
                return "function" == typeof err.toString ? err.toString() : {}.toString.call(err);
            } catch (newErr) {
                return "Error while stringifying error: " + stringifyError(newErr, level + 1);
            }
        }
        function stringifyErrorMessage(err) {
            var defaultMessage = "<unknown error: " + {}.toString.call(err) + ">";
            return err ? err instanceof Error ? err.message || defaultMessage : "string" == typeof err.message && err.message || defaultMessage : defaultMessage;
        }
        function domainMatches(hostname, domain) {
            var index = (hostname = hostname.split("://")[1]).indexOf(domain);
            return -1 !== index && hostname.slice(index) === domain;
        }
        function patchMethod(obj, name, handler) {
            var original = obj[name];
            obj[name] = function() {
                var _this = this, _arguments = arguments;
                return handler({
                    context: this,
                    args: [].slice.call(arguments),
                    original: original,
                    callOriginal: function() {
                        return original.apply(_this, _arguments);
                    }
                });
            };
        }
        function extend(obj, source) {
            if (!source) return obj;
            if (Object.assign) return Object.assign(obj, source);
            for (var _key2 in source) source.hasOwnProperty(_key2) && (obj[_key2] = source[_key2]);
            return obj;
        }
        function sortBy(arr, order) {
            return arr.sort(function(a, b) {
                return order.indexOf(a) - order.indexOf(b);
            });
        }
        function identity(item) {
            return item;
        }
        function values(obj) {
            var result = [];
            for (var _key6 in obj) obj.hasOwnProperty(_key6) && result.push(obj[_key6]);
            return result;
        }
        function perc(pixels, percentage) {
            return Math.round(pixels * percentage / 100);
        }
        function max() {
            return Math.max.apply(Math, arguments);
        }
        function regexMap(str, regex, handler) {
            var results = [];
            return str.replace(regex, function() {
                results.push(handler.apply(null, arguments));
            }), results;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject), __webpack_require__.d(interface_namespaceObject, "cleanUpWindow", function() {
            return cleanUpWindow;
        }), __webpack_require__.d(interface_namespaceObject, "Promise", function() {
            return zalgo_promise_src.a;
        }), __webpack_require__.d(interface_namespaceObject, "bridge", function() {
            return bridge;
        }), __webpack_require__.d(interface_namespaceObject, "init", function() {
            return init;
        }), __webpack_require__.d(interface_namespaceObject, "parent", function() {
            return public_parent;
        }), __webpack_require__.d(interface_namespaceObject, "request", function() {
            return request;
        }), __webpack_require__.d(interface_namespaceObject, "send", function() {
            return _send;
        }), __webpack_require__.d(interface_namespaceObject, "sendToParent", function() {
            return sendToParent;
        }), __webpack_require__.d(interface_namespaceObject, "client", function() {
            return client;
        }), __webpack_require__.d(interface_namespaceObject, "listen", function() {
            return listen;
        }), __webpack_require__.d(interface_namespaceObject, "on", function() {
            return _on;
        }), __webpack_require__.d(interface_namespaceObject, "once", function() {
            return once;
        }), __webpack_require__.d(interface_namespaceObject, "listener", function() {
            return server_listener;
        }), __webpack_require__.d(interface_namespaceObject, "CONFIG", function() {
            return conf.a;
        }), __webpack_require__.d(interface_namespaceObject, "CONSTANTS", function() {
            return conf.b;
        }), __webpack_require__.d(interface_namespaceObject, "disable", function() {
            return disable;
        });
        var lib = __webpack_require__(14), src = __webpack_require__(7), conf = __webpack_require__(10), global = __webpack_require__(9), esm_extends = __webpack_require__(11), zalgo_promise_src = __webpack_require__(1), SEND_MESSAGE_STRATEGIES = {};
        SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.POST_MESSAGE] = function(win, serializedMessage, domain) {
            try {
                __webpack_require__(37).emulateIERestrictions(window, win);
            } catch (err) {
                return;
            }
            (Array.isArray(domain) ? domain : "string" == typeof domain ? [ domain ] : [ conf.b.WILDCARD ]).map(function(dom) {
                if (0 === dom.indexOf(conf.b.MOCK_PROTOCOL)) {
                    if (window.location.protocol === conf.b.FILE_PROTOCOL) return conf.b.WILDCARD;
                    if (!Object(src.p)(win)) throw new Error("Attempting to send messsage to mock domain " + dom + ", but window is actually cross-domain");
                    return Object(src.c)(win);
                }
                return 0 === dom.indexOf(conf.b.FILE_PROTOCOL) ? conf.b.WILDCARD : dom;
            }).forEach(function(dom) {
                return win.postMessage(serializedMessage, dom);
            });
        };
        var _require = __webpack_require__(21), sendBridgeMessage = _require.sendBridgeMessage, needsBridgeForBrowser = _require.needsBridgeForBrowser, isBridge = _require.isBridge;
        function sendMessage(win, message, domain) {
            return zalgo_promise_src.a.try(function() {
                var _jsonStringify;
                if (message = function(win, message, options) {
                    void 0 === options && (options = {});
                    var id = Object(lib.q)(), type = Object(lib.c)(), sourceDomain = Object(src.g)(window);
                    return Object(esm_extends.a)({}, message, {}, options, {
                        sourceDomain: sourceDomain,
                        id: message.id || id,
                        windowType: type
                    });
                }(0, message, {
                    data: Object(lib.o)(win, domain, message.data),
                    domain: domain
                }), win === window && !conf.a.ALLOW_SAME_ORIGIN) throw new Error("Attemping to send message to self");
                if (Object(src.y)(win)) throw new Error("Window is closed");
                var messages = [], serializedMessage = Object(lib.g)(((_jsonStringify = {})[conf.b.WINDOW_PROPS.POSTROBOT] = message, 
                _jsonStringify), null, 2);
                return zalgo_promise_src.a.map(Object.keys(SEND_MESSAGE_STRATEGIES), function(strategyName) {
                    return zalgo_promise_src.a.try(function() {
                        if (!conf.a.ALLOWED_POST_MESSAGE_METHODS[strategyName]) throw new Error("Strategy disallowed: " + strategyName);
                        return SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                    }).then(function() {
                        return messages.push(strategyName + ": success"), !0;
                    }, function(err) {
                        return messages.push(strategyName + ": " + Object(lib.p)(err) + "\n"), !1;
                    });
                }).then(function(results) {
                    var success = results.some(Boolean), status = message.type + " " + message.name + " " + (success ? "success" : "error") + ":\n  - " + messages.join("\n  - ") + "\n";
                    if (!success) throw new Error(status);
                });
            });
        }
        SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.BRIDGE] = function(win, serializedMessage, domain) {
            if (needsBridgeForBrowser() || isBridge()) {
                if (Object(src.u)(win)) throw new Error("Post message through bridge disabled between same domain windows");
                if (!1 !== Object(src.v)(window, win)) throw new Error("Can only use bridge to communicate between two different windows, not between frames");
                return sendBridgeMessage(win, serializedMessage, domain);
            }
        }, SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.GLOBAL] = function(win, serializedMessage) {
            if (Object(lib.i)()) {
                if (!Object(src.u)(win)) throw new Error("Post message through global disabled between different domain windows");
                if (!1 !== Object(src.v)(window, win)) throw new Error("Can only use global to communicate between two different windows, not between frames");
                var foreignGlobal = win[conf.b.WINDOW_PROPS.POSTROBOT];
                if (!foreignGlobal) throw new Error("Can not find postRobot global on foreign window");
                return foreignGlobal.receiveMessage({
                    source: window,
                    origin: Object(src.g)(),
                    data: serializedMessage
                });
            }
        };
        var cross_domain_safe_weakmap_src = __webpack_require__(17);
        global.a.responseListeners = global.a.responseListeners || {}, global.a.requestListeners = global.a.requestListeners || {}, 
        global.a.WINDOW_WILDCARD = global.a.WINDOW_WILDCARD || new function() {}(), global.a.erroredResponseListeners = global.a.erroredResponseListeners || {};
        var _RECEIVE_MESSAGE_TYPE, __DOMAIN_REGEX__ = "__domain_regex__";
        function getResponseListener(hash) {
            return global.a.responseListeners[hash];
        }
        function deleteResponseListener(hash) {
            delete global.a.responseListeners[hash];
        }
        function isResponseListenerErrored(hash) {
            return Boolean(global.a.erroredResponseListeners[hash]);
        }
        function getRequestListener(_ref) {
            var name = _ref.name, win = _ref.win, domain = _ref.domain;
            if (win === conf.b.WILDCARD && (win = null), domain === conf.b.WILDCARD && (domain = null), 
            !name) throw new Error("Name required to get request listener");
            var nameListeners = global.a.requestListeners[name];
            if (nameListeners) for (var _i2 = 0, _ref3 = [ win, global.a.WINDOW_WILDCARD ]; _i2 < _ref3.length; _i2++) {
                var winQualifier = _ref3[_i2], winListeners = winQualifier && nameListeners.get(winQualifier);
                if (winListeners) {
                    if (domain && "string" == typeof domain) {
                        if (winListeners[domain]) return winListeners[domain];
                        if (winListeners[__DOMAIN_REGEX__]) for (var _i4 = 0, _winListeners$__DOMAI2 = winListeners[__DOMAIN_REGEX__]; _i4 < _winListeners$__DOMAI2.length; _i4++) {
                            var _winListeners$__DOMAI3 = _winListeners$__DOMAI2[_i4], regex = _winListeners$__DOMAI3.regex, listener = _winListeners$__DOMAI3.listener;
                            if (Object(src.A)(regex, domain)) return listener;
                        }
                    }
                    if (winListeners[conf.b.WILDCARD]) return winListeners[conf.b.WILDCARD];
                }
            }
        }
        var RECEIVE_MESSAGE_TYPES = ((_RECEIVE_MESSAGE_TYPE = {})[conf.b.POST_MESSAGE_TYPE.ACK] = function(source, origin, message) {
            if (!isResponseListenerErrored(message.hash)) {
                var options = getResponseListener(message.hash);
                if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.A)(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                options.ack = !0;
            }
        }, _RECEIVE_MESSAGE_TYPE[conf.b.POST_MESSAGE_TYPE.REQUEST] = function(source, origin, message) {
            var options = getRequestListener({
                name: message.name,
                win: source,
                domain: origin
            });
            function respond(data) {
                return message.fireAndForget || Object(src.y)(source) ? zalgo_promise_src.a.resolve() : sendMessage(source, Object(esm_extends.a)({
                    target: message.originalSource,
                    hash: message.hash,
                    name: message.name
                }, data), origin);
            }
            return zalgo_promise_src.a.all([ respond({
                type: conf.b.POST_MESSAGE_TYPE.ACK
            }), zalgo_promise_src.a.try(function() {
                if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.A)(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                return options.handler({
                    source: source,
                    origin: origin,
                    data: message.data
                });
            }).then(function(data) {
                return respond({
                    type: conf.b.POST_MESSAGE_TYPE.RESPONSE,
                    ack: conf.b.POST_MESSAGE_ACK.SUCCESS,
                    data: data
                });
            }, function(err) {
                var error = Object(lib.p)(err).replace(/^Error: /, "");
                return respond({
                    type: conf.b.POST_MESSAGE_TYPE.RESPONSE,
                    ack: conf.b.POST_MESSAGE_ACK.ERROR,
                    error: error,
                    code: err.code
                });
            }) ]).then(lib.j).catch(function(err) {
                if (options && options.handleError) return options.handleError(err);
                throw err;
            });
        }, _RECEIVE_MESSAGE_TYPE[conf.b.POST_MESSAGE_TYPE.RESPONSE] = function(source, origin, message) {
            if (!isResponseListenerErrored(message.hash)) {
                var options = getResponseListener(message.hash);
                if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.A)(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + Object(src.C)(options.domain));
                if (deleteResponseListener(message.hash), message.ack === conf.b.POST_MESSAGE_ACK.ERROR) {
                    var err = new Error(message.error);
                    return message.code && (err.code = message.code), options.respond(err, null);
                }
                return message.ack === conf.b.POST_MESSAGE_ACK.SUCCESS ? options.respond(null, {
                    source: source,
                    origin: origin,
                    data: message.data || message.response
                }) : void 0;
            }
        }, _RECEIVE_MESSAGE_TYPE);
        function receiveMessage(event) {
            if (!window || window.closed) throw new Error("Message recieved in closed window");
            try {
                if (!event.source) return;
            } catch (err) {
                return;
            }
            var source = event.source, origin = event.origin, message = function(message) {
                var parsedMessage;
                try {
                    parsedMessage = Object(lib.f)(message);
                } catch (err) {
                    return;
                }
                if (parsedMessage && "object" == typeof parsedMessage && null !== parsedMessage && (parsedMessage = parsedMessage[conf.b.WINDOW_PROPS.POSTROBOT]) && "object" == typeof parsedMessage && null !== parsedMessage && parsedMessage.type && "string" == typeof parsedMessage.type && RECEIVE_MESSAGE_TYPES[parsedMessage.type]) return parsedMessage;
            }(event.data);
            if (message) {
                if (!message.sourceDomain || "string" != typeof message.sourceDomain) throw new Error("Expected message to have sourceDomain");
                0 !== message.sourceDomain.indexOf(conf.b.MOCK_PROTOCOL) && 0 !== message.sourceDomain.indexOf(conf.b.FILE_PROTOCOL) || (origin = message.sourceDomain), 
                -1 === global.a.receivedMessages.indexOf(message.id) && (global.a.receivedMessages.push(message.id), 
                Object(src.y)(source) && !message.fireAndForget || (message.data && (message.data = Object(lib.b)(source, origin, message.data)), 
                RECEIVE_MESSAGE_TYPES[message.type](source, origin, message)));
            }
        }
        function messageListener(event) {
            try {
                Object(lib.j)(event.source);
            } catch (err) {
                return;
            }
            var messageEvent = {
                source: event.source || event.sourceElement,
                origin: event.origin || event.originalEvent && event.originalEvent.origin,
                data: event.data
            };
            try {
                __webpack_require__(37).emulateIERestrictions(messageEvent.source, window);
            } catch (err) {
                return;
            }
            receiveMessage(messageEvent);
        }
        function request(options) {
            return zalgo_promise_src.a.try(function() {
                if (!options.name) throw new Error("Expected options.name");
                var targetWindow, domain, name = options.name;
                if ("string" == typeof options.window) {
                    var el = document.getElementById(options.window);
                    if (!el) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be a valid element id");
                    if ("iframe" !== el.tagName.toLowerCase()) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be an iframe");
                    if (!el.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                    targetWindow = el.contentWindow;
                } else if (options.window instanceof HTMLIFrameElement) {
                    if ("iframe" !== options.window.tagName.toLowerCase()) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be an iframe");
                    if (options.window && !options.window.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                    options.window && options.window.contentWindow && (targetWindow = options.window.contentWindow);
                } else targetWindow = options.window;
                if (!targetWindow) throw new Error("Expected options.window to be a window object, iframe, or iframe element id.");
                var win = targetWindow;
                domain = options.domain || conf.b.WILDCARD;
                var hash = options.name + "_" + Object(lib.q)();
                if (Object(src.y)(win)) throw new Error("Target window is closed");
                var hasResult = !1, requestPromises = global.a.requestPromises.get(win);
                requestPromises || global.a.requestPromises.set(win, requestPromises = []);
                var requestPromise = zalgo_promise_src.a.try(function() {
                    if (Object(src.q)(window, win)) return Object(lib.k)(win, options.timeout || conf.a.CHILD_WINDOW_TIMEOUT);
                }).then(function(_temp) {
                    var origin = (void 0 === _temp ? {} : _temp).origin;
                    if (Object(lib.e)(domain) && !origin) return Object(lib.n)(win);
                }).then(function(_temp2) {
                    var origin = (void 0 === _temp2 ? {} : _temp2).origin;
                    if (Object(lib.e)(domain)) {
                        if (!Object(src.A)(domain, origin)) throw new Error("Remote window domain " + origin + " does not match regex: " + domain.toString());
                        domain = origin;
                    }
                    if ("string" != typeof domain && !Array.isArray(domain)) throw new TypeError("Expected domain to be a string or array");
                    var actualDomain = domain;
                    return new zalgo_promise_src.a(function(resolve, reject) {
                        var responseListener;
                        if (options.fireAndForget || function(hash, listener) {
                            global.a.responseListeners[hash] = listener;
                        }(hash, responseListener = {
                            name: name,
                            window: win,
                            domain: actualDomain,
                            respond: function(err, result) {
                                err || (hasResult = !0, requestPromises.splice(requestPromises.indexOf(requestPromise, 1))), 
                                err ? reject(err) : resolve(result);
                            }
                        }), sendMessage(win, {
                            type: conf.b.POST_MESSAGE_TYPE.REQUEST,
                            hash: hash,
                            name: name,
                            data: options.data,
                            fireAndForget: options.fireAndForget
                        }, actualDomain).catch(reject), options.fireAndForget) return resolve();
                        var ackTimeout = conf.a.ACK_TIMEOUT, resTimeout = options.timeout || conf.a.RES_TIMEOUT, cycleTime = 100;
                        setTimeout(function cycle() {
                            if (!hasResult) {
                                if (Object(src.y)(win)) return reject(responseListener.ack ? new Error("Window closed for " + name + " before response") : new Error("Window closed for " + name + " before ack"));
                                if (ackTimeout = Math.max(ackTimeout - cycleTime, 0), -1 !== resTimeout && (resTimeout = Math.max(resTimeout - cycleTime, 0)), 
                                responseListener.ack) {
                                    if (-1 === resTimeout) return;
                                    cycleTime = Math.min(resTimeout, 2e3);
                                } else {
                                    if (0 === ackTimeout) return reject(new Error("No ack for postMessage " + name + " in " + Object(src.g)() + " in " + conf.a.ACK_TIMEOUT + "ms"));
                                    if (0 === resTimeout) return reject(new Error("No response for postMessage " + name + " in " + Object(src.g)() + " in " + (options.timeout || conf.a.RES_TIMEOUT) + "ms"));
                                }
                                setTimeout(cycle, cycleTime);
                            }
                        }, cycleTime);
                    });
                });
                return requestPromise.catch(function() {
                    !function(hash) {
                        global.a.erroredResponseListeners[hash] = !0;
                    }(hash), deleteResponseListener(hash);
                }), requestPromises.push(requestPromise), requestPromise;
            });
        }
        function _send(window, name, data, options) {
            return (options = options || {}).window = window, options.name = name, options.data = data, 
            request(options);
        }
        function sendToParent(name, data, options) {
            var win = Object(src.e)();
            return win ? _send(win, name, data, options) : new zalgo_promise_src.a(function(resolve, reject) {
                return reject(new Error("Window does not have a parent"));
            });
        }
        function client(options) {
            if (void 0 === options && (options = {}), !options.window) throw new Error("Expected options.window");
            var win = options.window;
            return {
                send: function(name, data) {
                    return _send(win, name, data, options);
                }
            };
        }
        function listen(options) {
            if (!options.name) throw new Error("Expected options.name");
            if (!options.handler) throw new Error("Expected options.handler");
            var name = options.name, win = options.window, domain = options.domain, listenerOptions = {
                handler: options.handler,
                handleError: options.errorHandler || function(err) {
                    throw err;
                },
                window: win,
                domain: domain || conf.b.WILDCARD,
                name: name
            }, requestListener = function addRequestListener(_ref4, listener) {
                var name = _ref4.name, win = _ref4.win, domain = _ref4.domain;
                if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                if (Array.isArray(win)) {
                    for (var listenersCollection = [], _i6 = 0, _win2 = win; _i6 < _win2.length; _i6++) listenersCollection.push(addRequestListener({
                        name: name,
                        domain: domain,
                        win: _win2[_i6]
                    }, listener));
                    return {
                        cancel: function() {
                            for (var _i8 = 0; _i8 < listenersCollection.length; _i8++) listenersCollection[_i8].cancel();
                        }
                    };
                }
                if (Array.isArray(domain)) {
                    for (var _listenersCollection = [], _i10 = 0, _domain2 = domain; _i10 < _domain2.length; _i10++) _listenersCollection.push(addRequestListener({
                        name: name,
                        win: win,
                        domain: _domain2[_i10]
                    }, listener));
                    return {
                        cancel: function() {
                            for (var _i12 = 0; _i12 < _listenersCollection.length; _i12++) _listenersCollection[_i12].cancel();
                        }
                    };
                }
                var existingListener = getRequestListener({
                    name: name,
                    win: win,
                    domain: domain
                });
                if (win && win !== conf.b.WILDCARD || (win = global.a.WINDOW_WILDCARD), domain = domain || conf.b.WILDCARD, 
                existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === global.a.WINDOW_WILDCARD ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === global.a.WINDOW_WILDCARD ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                var requestListeners = global.a.requestListeners, nameListeners = requestListeners[name];
                nameListeners || (nameListeners = new cross_domain_safe_weakmap_src.a(), requestListeners[name] = nameListeners);
                var winListeners = nameListeners.get(win);
                winListeners || nameListeners.set(win, winListeners = {});
                var regexListener, strDomain = domain.toString(), regexListeners = winListeners[__DOMAIN_REGEX__];
                return Object(lib.e)(domain) ? (regexListeners || (winListeners[__DOMAIN_REGEX__] = regexListeners = []), 
                regexListeners.push(regexListener = {
                    regex: domain,
                    listener: listener
                })) : winListeners[strDomain] = listener, {
                    cancel: function() {
                        winListeners && (delete winListeners[strDomain], win && 0 === Object.keys(winListeners).length && nameListeners.delete(win), 
                        regexListener && regexListeners.splice(regexListeners.indexOf(regexListener, 1)));
                    }
                };
            }({
                name: name,
                win: win,
                domain: domain
            }, listenerOptions);
            if (options.once) {
                var _handler = listenerOptions.handler;
                listenerOptions.handler = Object(lib.l)(function() {
                    return requestListener.cancel(), _handler.apply(this, arguments);
                });
            }
            if (listenerOptions.window && options.errorOnClose) var interval = Object(lib.m)(function() {
                win && "object" == typeof win && Object(src.y)(win) && (interval.cancel(), listenerOptions.handleError(new Error("Post message target window is closed")));
            }, 50);
            return {
                cancel: function() {
                    requestListener.cancel();
                }
            };
        }
        function _on(name, options, handler) {
            return "function" == typeof options && (handler = options, options = {}), (options = options || {}).name = name, 
            options.handler = handler || options.handler, listen(options);
        }
        function once(name, options, handler) {
            void 0 === options && (options = {}), "function" == typeof options && (handler = options, 
            options = {}), options = options || {}, handler = handler || options.handler;
            var errorHandler = options.errorHandler, promise = new zalgo_promise_src.a(function(resolve, reject) {
                (options = options || {}).name = name, options.once = !0, options.handler = function(event) {
                    if (resolve(event), handler) return handler(event);
                }, options.errorHandler = function(err) {
                    if (reject(err), errorHandler) return errorHandler(err);
                };
            }), onceListener = listen(options);
            return promise.cancel = onceListener.cancel, promise;
        }
        function server_listener(options) {
            return void 0 === options && (options = {}), {
                on: function(name, handler) {
                    return _on(name, options, handler);
                }
            };
        }
        function disable() {
            delete window[conf.b.WINDOW_PROPS.POSTROBOT], window.removeEventListener("message", messageListener);
        }
        global.a.receivedMessages = global.a.receivedMessages || [], global.a.receiveMessage = receiveMessage, 
        global.a.requestPromises = global.a.requestPromises || new cross_domain_safe_weakmap_src.a(), 
        global.a.send = _send, global.a.on = _on;
        var public_parent = Object(src.e)();
        function cleanUpWindow(win) {
            var requestPromises = global.a.requestPromises.get(win);
            if (requestPromises) for (var _i2 = 0; _i2 < requestPromises.length; _i2++) requestPromises[_i2].reject(new Error("No response from window - cleaned up"));
            global.a.popupWindowsByWin && global.a.popupWindowsByWin.delete(win), global.a.remoteWindows && global.a.remoteWindows.delete(win), 
            global.a.requestPromises.delete(win), global.a.methods.delete(win), global.a.readyPromises.delete(win);
        }
        var bridge = __webpack_require__(55);
        function init() {
            global.a.initialized || (Object(lib.a)(window, "message", messageListener), __webpack_require__(21).openTunnelToOpener(), 
            Object(lib.d)(), Object(lib.h)({
                on: _on,
                send: _send
            })), global.a.initialized = !0;
        }
        init(), __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() {
            return cleanUpWindow;
        }), __webpack_require__.d(__webpack_exports__, "Promise", function() {
            return zalgo_promise_src.a;
        }), __webpack_require__.d(__webpack_exports__, "bridge", function() {
            return bridge;
        }), __webpack_require__.d(__webpack_exports__, "init", function() {
            return init;
        }), __webpack_require__.d(__webpack_exports__, "parent", function() {
            return public_parent;
        }), __webpack_require__.d(__webpack_exports__, "request", function() {
            return request;
        }), __webpack_require__.d(__webpack_exports__, "send", function() {
            return _send;
        }), __webpack_require__.d(__webpack_exports__, "sendToParent", function() {
            return sendToParent;
        }), __webpack_require__.d(__webpack_exports__, "client", function() {
            return client;
        }), __webpack_require__.d(__webpack_exports__, "listen", function() {
            return listen;
        }), __webpack_require__.d(__webpack_exports__, "on", function() {
            return _on;
        }), __webpack_require__.d(__webpack_exports__, "once", function() {
            return once;
        }), __webpack_require__.d(__webpack_exports__, "listener", function() {
            return server_listener;
        }), __webpack_require__.d(__webpack_exports__, "CONFIG", function() {
            return conf.a;
        }), __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() {
            return conf.b;
        }), __webpack_require__.d(__webpack_exports__, "disable", function() {
            return disable;
        }), __webpack_exports__.default = interface_namespaceObject;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var src = __webpack_require__(17), cross_domain_utils_src = __webpack_require__(7), conf = __webpack_require__(10);
        function stringifyError(err, level) {
            if (void 0 === level && (level = 1), level >= 3) return "stringifyError stack overflow";
            try {
                if (!err) return "<unknown error: " + {}.toString.call(err) + ">";
                if ("string" == typeof err) return err;
                if (err instanceof Error) {
                    var stack = err && err.stack, message = err && err.message;
                    if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                    if (stack) return stack;
                    if (message) return message;
                }
                return "function" == typeof err.toString ? err.toString() : {}.toString.call(err);
            } catch (newErr) {
                return "Error while stringifying error: " + stringifyError(newErr, level + 1);
            }
        }
        var once = function(method) {
            if (!method) return method;
            var called = !1;
            return function() {
                if (!called) return called = !0, method.apply(this, arguments);
            };
        };
        function noop() {}
        function addEventListener(obj, event, handler) {
            return obj.addEventListener ? obj.addEventListener(event, handler) : obj.attachEvent("on" + event, handler), 
            {
                cancel: function() {
                    obj.removeEventListener ? obj.removeEventListener(event, handler) : obj.detachEvent("on" + event, handler);
                }
            };
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            });
        }
        function replaceObject(item, callback, depth) {
            if (void 0 === depth && (depth = 1), depth >= 100) throw new Error("Self-referential object passed, or object contained too many layers");
            var newobj;
            if ("object" != typeof item || null === item || Array.isArray(item)) {
                if (!Array.isArray(item)) throw new TypeError("Invalid type: " + typeof item);
                newobj = [];
            } else newobj = {};
            return function(item, callback) {
                Array.isArray(item) ? function(item, callback) {
                    for (var i = 0; i < item.length; i++) callback(item[i], i);
                }(item, callback) : "object" == typeof item && null !== item && function(item, callback) {
                    for (var _key in item) item.hasOwnProperty(_key) && callback(item[_key], _key);
                }(item, callback);
            }(item, function(childItem, key) {
                var result = callback(childItem, key);
                newobj[key] = void 0 !== result ? result : "object" == typeof childItem && null !== childItem ? replaceObject(childItem, callback, depth + 1) : childItem;
            }), newobj;
        }
        function safeInterval(method, time) {
            var timeout;
            return timeout = setTimeout(function runInterval() {
                timeout = setTimeout(runInterval, time), method.call();
            }, time), {
                cancel: function() {
                    clearTimeout(timeout);
                }
            };
        }
        function isRegex(item) {
            return "[object RegExp]" === {}.toString.call(item);
        }
        var util_weakMapMemoize = function(method) {
            var weakmap = new src.a();
            return function(arg) {
                var result = weakmap.get(arg);
                return void 0 !== result ? result : (void 0 !== (result = method.call(this, arg)) && weakmap.set(arg, result), 
                result);
            };
        };
        function getWindowType() {
            return Object(cross_domain_utils_src.t)() ? conf.b.WINDOW_TYPES.POPUP : Object(cross_domain_utils_src.r)() ? conf.b.WINDOW_TYPES.IFRAME : conf.b.WINDOW_TYPES.FULLPAGE;
        }
        function jsonStringify(obj, replacer, indent) {
            var objectToJSON, arrayToJSON;
            try {
                if ("{}" !== JSON.stringify({}) && (objectToJSON = {}.toJSON, delete Object.prototype.toJSON), 
                "{}" !== JSON.stringify({})) throw new Error("Can not correctly serialize JSON objects");
                if ("[]" !== JSON.stringify([]) && (arrayToJSON = [].toJSON, delete Array.prototype.toJSON), 
                "[]" !== JSON.stringify([])) throw new Error("Can not correctly serialize JSON objects");
            } catch (err) {
                throw new Error("Can not repair JSON.stringify: " + err.message);
            }
            var result = JSON.stringify.call(this, obj, replacer, indent);
            try {
                objectToJSON && (Object.prototype.toJSON = objectToJSON), arrayToJSON && (Array.prototype.toJSON = arrayToJSON);
            } catch (err) {
                throw new Error("Can not repair JSON.stringify: " + err.message);
            }
            return result;
        }
        function jsonParse(item) {
            return JSON.parse(item);
        }
        function needsGlobalMessagingForBrowser() {
            return !!Object(cross_domain_utils_src.o)(window).match(/MSIE|trident|edge\/12|edge\/13/i) || !conf.a.ALLOW_POSTMESSAGE_POPUP;
        }
        var zalgo_promise_src = __webpack_require__(1), global = __webpack_require__(9);
        global.a.methods = global.a.methods || new src.a();
        var listenForMethods = once(function() {
            global.a.on(conf.b.POST_MESSAGE_NAMES.METHOD, {
                origin: conf.b.WILDCARD
            }, function(_ref) {
                var source = _ref.source, origin = _ref.origin, data = _ref.data, methods = global.a.methods.get(source);
                if (!methods) throw new Error("Could not find any methods this window has privileges to call");
                var meth = methods[data.id];
                if (!meth) throw new Error("Could not find method with id: " + data.id);
                if (!Object(cross_domain_utils_src.A)(meth.domain, origin)) throw new Error("Method domain " + meth.domain + " does not match origin " + origin);
                return zalgo_promise_src.a.try(function() {
                    return meth.method.apply({
                        source: source,
                        origin: origin,
                        data: data
                    }, data.args);
                }).then(function(result) {
                    return {
                        result: result,
                        id: data.id,
                        name: data.name
                    };
                });
            });
        });
        function isSerialized(item, type) {
            return "object" == typeof item && null !== item && item.__type__ === type;
        }
        function serializeMethod(destination, domain, method, name) {
            var id = uniqueID(), methods = global.a.methods.get(destination);
            return methods || global.a.methods.set(destination, methods = {}), methods[id] = {
                domain: domain,
                method: method
            }, {
                __type__: conf.b.SERIALIZATION_TYPES.METHOD,
                __id__: id,
                __name__: name
            };
        }
        function serializeMethods(destination, domain, obj) {
            return replaceObject({
                obj: obj
            }, function(item, key) {
                return "function" == typeof item ? serializeMethod(destination, domain, item, key.toString()) : item instanceof Error ? {
                    __type__: conf.b.SERIALIZATION_TYPES.ERROR,
                    __message__: stringifyError(err = item),
                    __code__: err.code
                } : window.Promise && item instanceof window.Promise ? function(destination, domain, promise, name) {
                    return {
                        __type__: conf.b.SERIALIZATION_TYPES.PROMISE,
                        __then__: serializeMethod(destination, domain, function(resolve, reject) {
                            return promise.then(resolve, reject);
                        }, name + ".then")
                    };
                }(destination, domain, item, key.toString()) : zalgo_promise_src.a.isPromise(item) ? function(destination, domain, promise, name) {
                    return {
                        __type__: conf.b.SERIALIZATION_TYPES.ZALGO_PROMISE,
                        __then__: serializeMethod(destination, domain, function(resolve, reject) {
                            return promise.then(resolve, reject);
                        }, name + ".then")
                    };
                }(destination, domain, item, key.toString()) : isRegex(item) ? {
                    __type__: conf.b.SERIALIZATION_TYPES.REGEX,
                    __source__: item.source
                } : void 0;
                var err;
            }).obj;
        }
        function deserializeMethod(source, origin, obj) {
            function wrapper() {
                var args = [].slice.call(arguments);
                return global.a.send(source, conf.b.POST_MESSAGE_NAMES.METHOD, {
                    id: obj.__id__,
                    name: obj.__name__,
                    args: args
                }, {
                    domain: origin,
                    timeout: -1
                }).then(function(_ref2) {
                    return _ref2.data.result;
                }, function(err) {
                    throw err;
                });
            }
            return wrapper.__name__ = obj.__name__, wrapper.__xdomain__ = !0, wrapper.source = source, 
            wrapper.origin = origin, wrapper;
        }
        function deserializeZalgoPromise(source, origin, prom) {
            return new zalgo_promise_src.a(function(resolve, reject) {
                return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
            });
        }
        function deserializeMethods(source, origin, obj) {
            return replaceObject({
                obj: obj
            }, function(item) {
                if ("object" == typeof item && null !== item) return isSerialized(item, conf.b.SERIALIZATION_TYPES.METHOD) ? deserializeMethod(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.ERROR) ? function(source, origin, obj) {
                    var err = new Error(obj.__message__);
                    return obj.__code__ && (err.code = obj.__code__), err;
                }(0, 0, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.PROMISE) ? function(source, origin, prom) {
                    return window.Promise ? new window.Promise(function(resolve, reject) {
                        return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
                    }) : deserializeZalgoPromise(source, origin, prom);
                }(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.ZALGO_PROMISE) ? deserializeZalgoPromise(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.REGEX) ? function(source, origin, item) {
                    return new RegExp(item.__source__);
                }(0, 0, item) : void 0;
            }).obj;
        }
        function sayHello(win) {
            return global.a.send(win, conf.b.POST_MESSAGE_NAMES.HELLO, {}, {
                domain: conf.b.WILDCARD,
                timeout: -1
            }).then(function(_ref2) {
                return {
                    origin: _ref2.origin
                };
            });
        }
        function initOnReady() {
            var handler;
            handler = function(_ref3) {
                var source = _ref3.source, origin = _ref3.origin, promise = global.a.readyPromises.get(source) || new zalgo_promise_src.a();
                promise.resolve({
                    origin: origin
                }), global.a.readyPromises.set(source, promise);
            }, global.a.on(conf.b.POST_MESSAGE_NAMES.HELLO, {
                domain: conf.b.WILDCARD
            }, function(_ref) {
                return handler({
                    source: _ref.source,
                    origin: _ref.origin
                });
            });
            var parent = Object(cross_domain_utils_src.e)();
            parent && sayHello(parent).catch(noop);
        }
        function onChildWindowReady(win, timeout, name) {
            void 0 === timeout && (timeout = 5e3), void 0 === name && (name = "Window");
            var promise = global.a.readyPromises.get(win);
            return promise || (promise = new zalgo_promise_src.a(), global.a.readyPromises.set(win, promise), 
            -1 !== timeout && setTimeout(function() {
                return promise.reject(new Error(name + " did not load after " + timeout + "ms"));
            }, timeout), promise);
        }
        global.a.readyPromises = global.a.readyPromises || new src.a(), __webpack_require__.d(__webpack_exports__, "p", function() {
            return stringifyError;
        }), __webpack_require__.d(__webpack_exports__, "l", function() {
            return once;
        }), __webpack_require__.d(__webpack_exports__, "j", function() {
            return noop;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return addEventListener;
        }), __webpack_require__.d(__webpack_exports__, "q", function() {
            return uniqueID;
        }), __webpack_require__.d(__webpack_exports__, "m", function() {
            return safeInterval;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return isRegex;
        }), __webpack_require__.d(__webpack_exports__, "r", function() {
            return util_weakMapMemoize;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return getWindowType;
        }), __webpack_require__.d(__webpack_exports__, "g", function() {
            return jsonStringify;
        }), __webpack_require__.d(__webpack_exports__, "f", function() {
            return jsonParse;
        }), __webpack_require__.d(__webpack_exports__, "i", function() {
            return needsGlobalMessagingForBrowser;
        }), __webpack_require__.d(__webpack_exports__, "h", function() {
            return listenForMethods;
        }), __webpack_require__.d(__webpack_exports__, "o", function() {
            return serializeMethods;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return deserializeMethods;
        }), __webpack_require__.d(__webpack_exports__, "n", function() {
            return sayHello;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return initOnReady;
        }), __webpack_require__.d(__webpack_exports__, "k", function() {
            return onChildWindowReady;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var onAuthorize, esm_extends = __webpack_require__(11), src = __webpack_require__(1), beaver_logger_client = __webpack_require__(4), zoid_src = __webpack_require__(19), belter_src = __webpack_require__(16), lib = __webpack_require__(2), config = __webpack_require__(3), constants = __webpack_require__(0), post_robot_src = __webpack_require__(13);
        function match(str, pattern) {
            var regmatch = str.match(pattern);
            if (regmatch) return regmatch[1];
        }
        function onLegacyPaymentAuthorize(method) {
            return onAuthorize = method, src.a.try(function() {
                if (post_robot_src.bridge && !Object(lib.G)()) return post_robot_src.bridge.openBridge(Object(lib.g)(config.a.postBridgeUrl, {
                    version: Object(lib.u)()
                }), config.a.postBridgeDomain).then(function(postBridge) {
                    return Object(post_robot_src.send)(postBridge, "onLegacyPaymentAuthorize", {
                        method: method
                    }, {
                        domain: config.a.paypalDomain
                    }).then(lib.J);
                });
            });
        }
        Object(lib.G)() && Object(post_robot_src.on)("onLegacyPaymentAuthorize", {
            window: window.parent
        }, function(_ref) {
            onAuthorize = _ref.data.method;
        }), window.onLegacyPaymentAuthorize = onLegacyPaymentAuthorize, window.watchForLegacyFallback = function(win) {
            var interval = setInterval(function() {
                try {
                    if (-1 === win.document.body.innerHTML.indexOf("merchantpaymentweb") && -1 === win.document.body.innerHTML.indexOf("wapapp") || win.ppxoWatching || win.closed) return;
                    win.ppxoWatching = !0;
                    var XMLHttpRequestsend = win.XMLHttpRequest.prototype.send;
                    win.XMLHttpRequest.prototype.send = function() {
                        if (this._patched) return XMLHttpRequestsend.apply(this, arguments);
                        this._patched = !0;
                        var self = this, onload = this.onload;
                        function listener() {
                            if (self.readyState === self.DONE && 200 === self.status && self.responseText) try {
                                var response = JSON.parse(self.responseText.replace("while (1);", ""));
                                if ("redirect" === response.type && response.url && onAuthorize) {
                                    var url = response.url;
                                    clearInterval(interval), win.close(), onAuthorize({
                                        returnUrl: url,
                                        paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
                                        billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
                                        payerID: match(url, /PayerID=([A-Z0-9]+)/),
                                        paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/)
                                    }), onAuthorize = null, win.PAYPAL && win.PAYPAL.Checkout && win.PAYPAL.Checkout.XhrResponse && win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES && Object.defineProperty(win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES, "Redirect", {
                                        value: Math.random().toString()
                                    }), win.mob && win.mob.Xhr && win.mob.Xhr.prototype._xhrOnReady && (win.mob.Xhr.prototype._xhrOnReady = lib.J);
                                }
                            } catch (err) {
                                return;
                            }
                            if (onload) return onload.apply(this, arguments);
                        }
                        if (this.onload !== listener) try {
                            delete this.onload, this.addEventListener("load", listener), Object.defineProperty(this, "onload", {
                                get: function() {
                                    return listener;
                                },
                                set: function(handler) {
                                    onload = handler;
                                }
                            });
                        } catch (err) {}
                        return XMLHttpRequestsend.apply(this, arguments);
                    };
                } catch (err) {}
            }, 100);
        }, window.onLegacyFallback = window.watchForLegacyFallback;
        var integrations = __webpack_require__(23), template = __webpack_require__(25), Checkout = Object(zoid_src.c)({
            tag: "paypal-checkout",
            name: "ppcheckout",
            scrolling: !0,
            buildUrl: function(props) {
                var env = props.env || config.a.env;
                if (!props.payment) throw new Error("Can not build url without payment prop");
                return props.payment().then(function(token) {
                    if (!token) throw new Error("Expected payment id or token to be passed, got " + token);
                    return Object(integrations.c)(env, props.fundingSource, token);
                });
            },
            get unsafeRenderTo() {
                return config.a.env === constants.t.LOCAL;
            },
            get domain() {
                return Object(esm_extends.a)({}, config.a.paypalDomains);
            },
            get bridgeUrl() {
                return config.a.metaFrameUrls;
            },
            get bridgeDomain() {
                return config.a.paypalDomains;
            },
            contexts: {
                iframe: !Object(lib.W)(),
                popup: !0
            },
            get version() {
                return Object(lib.u)();
            },
            validate: function() {
                Object(lib.B)() || Object(beaver_logger_client.q)("checkout_render_ineligible");
            },
            prerenderTemplate: template.a,
            containerTemplate: template.b,
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.v)();
                    },
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.j)();
                    },
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                meta: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return window.xprops && window.xprops.meta || {};
                    }
                },
                stage: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stage;
                    }
                },
                stageUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stageUrl;
                    }
                },
                authCode: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return config.a.authCode;
                    },
                    queryParam: "code"
                },
                localhostUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        if ((props.env || config.a.env) === constants.t.LOCAL) return config.a.localhostUrl;
                    }
                },
                checkoutUri: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.checkoutUri;
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                client: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    },
                    sendToChild: !1,
                    validate: function(client, props) {
                        var env = props.env || config.a.env;
                        if (!client[env]) throw new Error("Client ID not found for env: " + env);
                        if (client[env].match(/^(.)\1+$/)) throw new Error("Invalid client ID: " + client[env]);
                    }
                },
                payment: {
                    type: "function",
                    required: !1,
                    memoize: !0,
                    promisify: !0,
                    queryParam: function(payment) {
                        return payment().then(function(token) {
                            return Object(integrations.b)(token);
                        });
                    },
                    queryValue: function(payment) {
                        return payment();
                    },
                    childDecorate: function(payment) {
                        var token = Object(lib.q)("token");
                        return token ? Object(lib.I)(function() {
                            return src.a.resolve(token);
                        }) : payment;
                    },
                    validate: function(payment, props) {
                        if (!payment && !props.url) throw new Error("Expected either props.payment or props.url to be passed");
                    },
                    alias: "billingAgreement"
                },
                style: {
                    type: "object",
                    required: !1,
                    allowDelegate: !0,
                    def: function() {
                        return {};
                    },
                    validate: function(style) {
                        if (style.overlayColor && style.overlayColor !== constants.q.BLACK && style.overlayColor !== constants.q.WHITE) throw new Error("Invalid background color: " + style.overlayColor);
                    }
                },
                commit: {
                    type: "boolean",
                    required: !1
                },
                experience: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    }
                },
                fundingSource: {
                    type: "string",
                    required: !1,
                    queryParam: !0
                },
                fundingOffered: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return [].slice.call(document.querySelectorAll("[" + constants.c.FUNDING_SOURCE + "]")).map(function(el) {
                            return el.getAttribute(constants.c.FUNDING_SOURCE);
                        });
                    },
                    queryValue: function(val) {
                        return val.join(",");
                    }
                },
                onAuthorize: {
                    type: "function",
                    required: !0,
                    once: !0,
                    decorate: function(original) {
                        if (original) return function(data, actions) {
                            var _this = this;
                            void 0 === actions && (actions = {}), data && !data.intent && Object(beaver_logger_client.q)("checkout_authorize_no_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken
                            });
                            var close = function() {
                                return src.a.try(function() {
                                    if (actions.close) return actions.close();
                                }).then(function() {
                                    return _this.closeComponent();
                                });
                            }, redirect = function(win, url) {
                                return src.a.all([ Object(lib.P)(win || window.top, url || data.returnUrl), close() ]);
                            };
                            return src.a.try(function() {
                                try {
                                    var isButton = -1 !== window.location.href.indexOf("/webapps/hermes/button"), isGuest = -1 !== _this.window.location.href.indexOf("/webapps/xoonboarding");
                                    if (isButton && isGuest) return Object(lib.R)({
                                        win: _this.window,
                                        method: "get",
                                        url: "/webapps/xoonboarding/api/auth"
                                    }).then(function(result) {
                                        result && result.data && result.data.access_token && window.$Api && window.$Api.addHeader && window.$Api.addHeader("x-paypal-internal-euat", result.data.access_token);
                                    }).catch(function() {});
                                } catch (err) {}
                            }).then(function() {
                                return original.call(_this, data, Object(esm_extends.a)({}, actions, {
                                    close: close,
                                    redirect: redirect
                                }));
                            }).catch(function(err) {
                                return _this.error(err);
                            }).finally(function() {
                                return _this.close();
                            });
                        };
                    }
                },
                onShippingChange: {
                    type: "function",
                    required: !1
                },
                onAuth: {
                    type: "function",
                    required: !1,
                    sameDomain: !0,
                    childDecorate: function(original) {
                        if (original) return function(data) {
                            return "string" == typeof data && (data = {
                                accessToken: data
                            }), original(data);
                        };
                    }
                },
                accessToken: {
                    type: "function",
                    required: !1
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _this2 = this;
                            void 0 === actions && (actions = {});
                            var close = function() {
                                return src.a.try(function() {
                                    if (actions.close) return actions.close();
                                }).then(function() {
                                    return _this2.closeComponent();
                                });
                            }, redirect = function(win, url) {
                                return src.a.all([ Object(lib.P)(win || window.top, url || data.cancelUrl), close() ]);
                            };
                            return src.a.try(function() {
                                return original.call(_this2, data, Object(esm_extends.a)({}, actions, {
                                    close: close,
                                    redirect: redirect
                                }));
                            }).finally(function() {
                                _this2.close();
                            });
                        };
                    }
                },
                init: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(data) {
                            var _track;
                            return Object(beaver_logger_client.k)("checkout_init"), Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_INIT, _track[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[constants.B.EC_TOKEN], 
                            _track[constants.u.KEY.TOKEN] = data.paymentToken, _track[constants.u.KEY.SELLER_ID] = data.merchantID, 
                            _track[constants.u.KEY.CONTEXT_ID] = data.paymentToken, _track)), Object(beaver_logger_client.h)(), 
                            this.paymentToken = data.paymentToken, this.cancelUrl = data.cancelUrl, original.apply(this, arguments);
                        };
                    }
                },
                onClose: {
                    type: "function",
                    required: !1,
                    once: !0,
                    promisify: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(reason) {
                            var onClose = original.apply(this, arguments), CLOSE_REASONS = zoid_src.a.CLOSE_REASONS, shouldCancel = this.props.onCancel && -1 !== [ CLOSE_REASONS.CLOSE_DETECTED, CLOSE_REASONS.USER_CLOSED ].indexOf(reason);
                            return shouldCancel ? (Object(beaver_logger_client.k)("close_trigger_cancel"), this.props.onCancel({
                                paymentToken: this.paymentToken,
                                cancelUrl: this.cancelUrl
                            }).then(function() {
                                return onClose;
                            })) : onClose;
                        };
                    }
                },
                onError: {
                    type: "function",
                    required: !1,
                    promisify: !0,
                    noop: !0,
                    once: !0
                },
                fallback: {
                    type: "function",
                    required: !1,
                    once: !0,
                    def: function() {
                        return function(url) {
                            return Object(beaver_logger_client.q)("fallback", {
                                url: url
                            }), Object(lib.m)("allow_full_page_fallback") ? (window.top.location = url, this.close()) : onLegacyPaymentAuthorize(this.props.onAuthorize);
                        };
                    }
                },
                logLevel: {
                    type: "string",
                    required: !1,
                    get value() {
                        return config.a.logLevel;
                    }
                },
                test: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return window.__test__ || {
                            action: "checkout"
                        };
                    }
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                }
            },
            get dimensions() {
                return Object(lib.z)() ? {
                    width: "100%",
                    height: "535px"
                } : {
                    width: "450px",
                    height: "535px"
                };
            }
        });
        Checkout.isChild() && Checkout.xchild && Checkout.xprops && (Checkout.xprops && Checkout.xprops.logLevel && Object(lib.T)(Checkout.xprops.logLevel), 
        Checkout.xchild.onProps(function(xprops) {
            Object(lib.N)(xprops, "onAuthorize", function(_ref) {
                var callOriginal = _ref.callOriginal, data = _ref.args[0];
                if (data && !data.intent) {
                    Object(beaver_logger_client.q)("hermes_authorize_no_intent", {
                        paymentID: data.paymentID,
                        token: data.paymentToken
                    });
                    try {
                        var intent = window.injector.get("$CheckoutCartModel").instance(data.paymentToken).payment_action;
                        Object(beaver_logger_client.q)("hermes_intent", {
                            paymentID: data.paymentID,
                            token: data.paymentToken,
                            intent: intent
                        });
                    } catch (err) {}
                    Object(beaver_logger_client.j)();
                }
                return callOriginal();
            });
        })), Object(lib.N)(Checkout, "init", function(_ref2) {
            var _ref2$args = _ref2.args;
            return _ref2.original.call(_ref2.context, _ref2$args[0], _ref2$args[1], "body");
        }), Object(lib.N)(Checkout, "render", function(_ref3) {
            return _ref3.original.call(_ref3.context, _ref3.args[0], "body");
        }), Object(lib.N)(Checkout, "renderTo", function(_ref4) {
            var _ref4$args = _ref4.args, win = _ref4$args[0], props = _ref4$args[1], original = _ref4.original, context = _ref4.context, payment = props.payment();
            return props.payment = function() {
                return payment;
            }, original.call(context, win, props, "body").catch(function(err) {
                if (err instanceof zoid_src.b && Object(lib.G)()) return Checkout.contexts.iframe = !0, 
                original.call(context, win, props, "body");
                throw err;
            });
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return Checkout;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__(11), __webpack_require__(1), __webpack_require__(7);
        var objectIDs, cross_domain_safe_weakmap_src = __webpack_require__(17);
        function base64encode(str) {
            if ("function" == typeof btoa) return btoa(str);
            if ("undefined" != typeof Buffer) return Buffer.from(str, "utf8").toString("base64");
            throw new Error("Can not find window.btoa or Buffer");
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            }) + "_" + base64encode(new Date().toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        }
        function noop() {}
        function once(method) {
            var called = !1;
            return function() {
                if (!called) return called = !0, method.apply(this, arguments);
            };
        }
        function isLocalStorageEnabled() {
            return function(method, logic, args) {
                void 0 === args && (args = []);
                var cache = method.__inline_memoize_cache__ = method.__inline_memoize_cache__ || {}, key = function(args) {
                    try {
                        return JSON.stringify([].slice.call(args), function(subkey, val) {
                            return "function" == typeof val ? "memoize[" + function(obj) {
                                if (objectIDs = objectIDs || new cross_domain_safe_weakmap_src.a(), null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
                                var uid = objectIDs.get(obj);
                                return uid || (uid = typeof obj + ":" + uniqueID(), objectIDs.set(obj, uid)), uid;
                            }(val) + "]" : val;
                        });
                    } catch (err) {
                        throw new Error("Arguments not serializable -- can not be used to memoize");
                    }
                }(args);
                return cache.hasOwnProperty(key) ? cache[key] : cache[key] = logic.apply(void 0, args);
            }(isLocalStorageEnabled, function() {
                try {
                    if ("undefined" == typeof window) return !1;
                    if (window.localStorage) {
                        var value = Math.random().toString();
                        window.localStorage.setItem("__test__localStorage__", value);
                        var result = window.localStorage.getItem("__test__localStorage__");
                        if (window.localStorage.removeItem("__test__localStorage__"), value === result) return !0;
                    }
                } catch (err) {}
                return !1;
            });
        }
        function getElementSafe(id, doc) {
            return void 0 === doc && (doc = document), (element = id) instanceof window.Element || null !== element && "object" == typeof element && 1 === element.nodeType && "object" == typeof element.style && "object" == typeof element.ownerDocument ? id : "string" == typeof id ? doc.querySelector(id) : void 0;
            var element;
        }
        function onResize(el, handler, _temp) {
            var _ref2 = void 0 === _temp ? {} : _temp, _ref2$width = _ref2.width, width = void 0 === _ref2$width || _ref2$width, _ref2$height = _ref2.height, height = void 0 === _ref2$height || _ref2$height, _ref2$interval = _ref2.interval, interval = void 0 === _ref2$interval ? 100 : _ref2$interval, _ref2$win = _ref2.win, win = void 0 === _ref2$win ? window : _ref2$win, currentWidth = el.offsetWidth, currentHeight = el.offsetHeight;
            handler({
                width: currentWidth,
                height: currentHeight
            });
            var observer, timeout, check = function() {
                var newWidth = el.offsetWidth, newHeight = el.offsetHeight;
                (width && newWidth !== currentWidth || height && newHeight !== currentHeight) && handler({
                    width: newWidth,
                    height: newHeight
                }), currentWidth = newWidth, currentHeight = newHeight;
            };
            return void 0 !== win.ResizeObserver ? (observer = new win.ResizeObserver(check)).observe(el) : void 0 !== win.MutationObserver ? ((observer = new win.MutationObserver(check)).observe(el, {
                attributes: !0,
                childList: !0,
                subtree: !0,
                characterData: !1
            }), win.addEventListener("resize", check)) : function loop() {
                check(), timeout = setTimeout(loop, interval);
            }(), {
                cancel: function() {
                    observer.disconnect(), window.removeEventListener("resize", check), clearTimeout(timeout);
                }
            };
        }
        Object.create(Error.prototype), __webpack_require__.d(__webpack_exports__, "c", function() {
            return isLocalStorageEnabled;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return getElementSafe;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return onResize;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return base64encode;
        }), __webpack_require__.d(__webpack_exports__, "g", function() {
            return uniqueID;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return noop;
        }), __webpack_require__.d(__webpack_exports__, "f", function() {
            return once;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject), __webpack_require__.d(interface_namespaceObject, "WeakMap", function() {
            return weakmap_CrossDomainSafeWeakMap;
        });
        var src = __webpack_require__(7);
        function safeIndexOf(collection, item) {
            for (var i = 0; i < collection.length; i++) try {
                if (collection[i] === item) return i;
            } catch (err) {}
            return -1;
        }
        var defineProperty = Object.defineProperty, counter = Date.now() % 1e9, weakmap_CrossDomainSafeWeakMap = function() {
            function CrossDomainSafeWeakMap() {
                if (this.name = void 0, this.weakmap = void 0, this.keys = void 0, this.values = void 0, 
                counter += 1, this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__" + counter, 
                function() {
                    if ("undefined" == typeof WeakMap) return !1;
                    if (void 0 === Object.freeze) return !1;
                    try {
                        var testWeakMap = new WeakMap(), testKey = {};
                        return Object.freeze(testKey), testWeakMap.set(testKey, "__testvalue__"), "__testvalue__" === testWeakMap.get(testKey);
                    } catch (err) {
                        return !1;
                    }
                }()) try {
                    this.weakmap = new WeakMap();
                } catch (err) {}
                this.keys = [], this.values = [];
            }
            var _proto = CrossDomainSafeWeakMap.prototype;
            return _proto._cleanupClosedWindows = function() {
                for (var weakmap = this.weakmap, keys = this.keys, i = 0; i < keys.length; i++) {
                    var value = keys[i];
                    if (Object(src.x)(value) && Object(src.y)(value)) {
                        if (weakmap) try {
                            weakmap.delete(value);
                        } catch (err) {}
                        keys.splice(i, 1), this.values.splice(i, 1), i -= 1;
                    }
                }
            }, _proto.isSafeToReadWrite = function(key) {
                return !Object(src.x)(key);
            }, _proto.set = function(key, value) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    weakmap.set(key, value);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var name = this.name, entry = key[name];
                    return void (entry && entry[0] === key ? entry[1] = value : defineProperty(key, name, {
                        value: [ key, value ],
                        writable: !0
                    }));
                } catch (err) {}
                this._cleanupClosedWindows();
                var keys = this.keys, values = this.values, index = safeIndexOf(keys, key);
                -1 === index ? (keys.push(key), values.push(value)) : values[index] = value;
            }, _proto.get = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    if (weakmap.has(key)) return weakmap.get(key);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    return entry && entry[0] === key ? entry[1] : void 0;
                } catch (err) {}
                this._cleanupClosedWindows();
                var index = safeIndexOf(this.keys, key);
                if (-1 !== index) return this.values[index];
            }, _proto.delete = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    weakmap.delete(key);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                } catch (err) {}
                this._cleanupClosedWindows();
                var keys = this.keys, index = safeIndexOf(keys, key);
                -1 !== index && (keys.splice(index, 1), this.values.splice(index, 1));
            }, _proto.has = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    if (weakmap.has(key)) return !0;
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    return !(!entry || entry[0] !== key);
                } catch (err) {}
                return this._cleanupClosedWindows(), -1 !== safeIndexOf(this.keys, key);
            }, _proto.getOrSet = function(key, getter) {
                if (this.has(key)) return this.get(key);
                var value = getter();
                return this.set(key, value), value;
            }, CrossDomainSafeWeakMap;
        }();
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return weakmap_CrossDomainSafeWeakMap;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var _ZIMPLER_LOGO_COLORS, _P24_LOGO_COLORS, _SOFORT_LOGO_COLORS, _IDEAL_LOGO_COLORS, _GIROPAY_LOGO_COLORS, _EPS_LOGO_COLORS, _MYBANK_LOGO_COLORS, _BANCONTACT_LOGO_COLO, _PAYPAL_LOGO_COLORS, _CREDIT_LOGO_COLORS, _BUTTON_LOGO$PP, _BUTTON_LOGO$VENMO, _BUTTON_LOGO$ITAU, _BUTTON_LOGO$ELV, _fundingLogos, _cardLogos, constants = __webpack_require__(0), jsx = __webpack_require__(6), ZIMPLER_LOGO_COLORS = ((_ZIMPLER_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff"
        }, _ZIMPLER_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#00A599"
        }, _ZIMPLER_LOGO_COLORS[constants.i.ANY] = {
            primary: "#00A599"
        }, _ZIMPLER_LOGO_COLORS), P24_LOGO_COLORS = ((_P24_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _P24_LOGO_COLORS[constants.i.ANY] = {
            primary: "#d03238",
            secondary: "#b3b1b1"
        }, _P24_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#d03238",
            secondary: "#b3b1b1"
        }, _P24_LOGO_COLORS), SOFORT_LOGO_COLORS = ((_SOFORT_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#2C2E2F",
            secondary: "#ffffff"
        }, _SOFORT_LOGO_COLORS[constants.i.ANY] = {
            primary: "#EB6F93",
            secondary: "#FFFFFF"
        }, _SOFORT_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#EB6F93",
            secondary: "#FFFFFF"
        }, _SOFORT_LOGO_COLORS), IDEAL_LOGO_COLORS = ((_IDEAL_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#2C2E2F"
        }, _IDEAL_LOGO_COLORS[constants.i.ANY] = {
            primary: "#000000",
            secondary: "#FFFFFF",
            tertiary: "#CD0067"
        }, _IDEAL_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#000000",
            secondary: "#FFFFFF",
            tertiary: "#CD0067"
        }, _IDEAL_LOGO_COLORS), GIROPAY_LOGO_COLORS = ((_GIROPAY_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#000000",
            tertiary: "#2C2E2F"
        }, _GIROPAY_LOGO_COLORS[constants.i.ANY] = {
            primary: "#FFFFFF",
            secondary: "#003A7D",
            tertiary: "#ED1C24"
        }, _GIROPAY_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#FFFFFF",
            secondary: "#003A7D",
            tertiary: "#ED1C24"
        }, _GIROPAY_LOGO_COLORS), EPS_LOGO_COLORS = ((_EPS_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#ffffff"
        }, _EPS_LOGO_COLORS[constants.i.ANY] = {
            primary: "#71706F",
            secondary: "#FFFFFF",
            tertiary: "#C8036F"
        }, _EPS_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#71706F",
            secondary: "#FFFFFF",
            tertiary: "#C8036F"
        }, _EPS_LOGO_COLORS), MYBANK_LOGO_COLORS = ((_MYBANK_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#ffffff"
        }, _MYBANK_LOGO_COLORS[constants.i.ANY] = {
            primary: "#1A4B67",
            secondary: "#00C0EE",
            tertiary: "#FFFFFF"
        }, _MYBANK_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#1A4B67",
            secondary: "#00C0EE",
            tertiary: "#FFFFFF"
        }, _MYBANK_LOGO_COLORS), BANCONTACT_LOGO_COLORS = ((_BANCONTACT_LOGO_COLO = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _BANCONTACT_LOGO_COLO[constants.i.ANY] = {
            primary: "#1A4B67",
            secondary: "#00C0EE"
        }, _BANCONTACT_LOGO_COLO[constants.i.BLACK] = {
            primary: "#005498",
            secondary: "#FFD800"
        }, _BANCONTACT_LOGO_COLO), pp_white = __webpack_require__(38), pp_white_default = __webpack_require__.n(pp_white), pp_blue = __webpack_require__(39), pp_blue_default = __webpack_require__.n(pp_blue), pp_black = __webpack_require__(40), pp_black_default = __webpack_require__.n(pp_black), PAYPAL_LOGO_COLORS = ((_PAYPAL_LOGO_COLORS = {})[constants.i.BLUE] = {
            primary: "#003087",
            secondary: "#009cde"
        }, _PAYPAL_LOGO_COLORS[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _PAYPAL_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#333030",
            secondary: "#636363"
        }, _PAYPAL_LOGO_COLORS), CREDIT_LOGO_COLORS = ((_CREDIT_LOGO_COLORS = {})[constants.i.BLUE] = {
            primary: "#003087",
            secondary: "#009cde"
        }, _CREDIT_LOGO_COLORS[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _CREDIT_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#333030",
            secondary: "#636363"
        }, _CREDIT_LOGO_COLORS), venmo_white = __webpack_require__(41), venmo_white_default = __webpack_require__.n(venmo_white), itau = __webpack_require__(42), itau_default = __webpack_require__.n(itau), venmo_blue = __webpack_require__(43), venmo_blue_default = __webpack_require__.n(venmo_blue), elv = __webpack_require__(44), elv_default = __webpack_require__.n(elv), elv_white = __webpack_require__(45), elv_white_default = __webpack_require__.n(elv_white), fundingLogos = ((_fundingLogos = {})[constants.h.PP] = ((_BUTTON_LOGO$PP = {})[constants.i.WHITE] = pp_white_default.a, 
        _BUTTON_LOGO$PP[constants.i.BLUE] = pp_blue_default.a, _BUTTON_LOGO$PP[constants.i.BLACK] = pp_black_default.a, 
        _BUTTON_LOGO$PP), _fundingLogos[constants.h.PAYPAL] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!PAYPAL_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " paypal logo available");
            var _PAYPAL_LOGO_COLORS$l = PAYPAL_LOGO_COLORS[logoColor], primary = _PAYPAL_LOGO_COLORS$l.primary, secondary = _PAYPAL_LOGO_COLORS$l.secondary;
            return Object(jsx.b)("svg", {
                width: "100",
                height: "32",
                viewBox: "0 0 100 32",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMinYMin meet"
            }, Object(jsx.b)("path", {
                fill: primary,
                d: "M 12 4.917 L 4.2 4.917 C 3.7 4.917 3.2 5.317 3.1 5.817 L 0 25.817 C -0.1 26.217 0.2 26.517 0.6 26.517 L 4.3 26.517 C 4.8 26.517 5.3 26.117 5.4 25.617 L 6.2 20.217 C 6.3 19.717 6.7 19.317 7.3 19.317 L 9.8 19.317 C 14.9 19.317 17.9 16.817 18.7 11.917 C 19 9.817 18.7 8.117 17.7 6.917 C 16.6 5.617 14.6 4.917 12 4.917 Z M 12.9 12.217 C 12.5 15.017 10.3 15.017 8.3 15.017 L 7.1 15.017 L 7.9 9.817 C 7.9 9.517 8.2 9.317 8.5 9.317 L 9 9.317 C 10.4 9.317 11.7 9.317 12.4 10.117 C 12.9 10.517 13.1 11.217 12.9 12.217 Z"
            }), Object(jsx.b)("path", {
                fill: primary,
                d: "M 35.2 12.117 L 31.5 12.117 C 31.2 12.117 30.9 12.317 30.9 12.617 L 30.7 13.617 L 30.4 13.217 C 29.6 12.017 27.8 11.617 26 11.617 C 21.9 11.617 18.4 14.717 17.7 19.117 C 17.3 21.317 17.8 23.417 19.1 24.817 C 20.2 26.117 21.9 26.717 23.8 26.717 C 27.1 26.717 29 24.617 29 24.617 L 28.8 25.617 C 28.7 26.017 29 26.417 29.4 26.417 L 32.8 26.417 C 33.3 26.417 33.8 26.017 33.9 25.517 L 35.9 12.717 C 36 12.517 35.6 12.117 35.2 12.117 Z M 30.1 19.317 C 29.7 21.417 28.1 22.917 25.9 22.917 C 24.8 22.917 24 22.617 23.4 21.917 C 22.8 21.217 22.6 20.317 22.8 19.317 C 23.1 17.217 24.9 15.717 27 15.717 C 28.1 15.717 28.9 16.117 29.5 16.717 C 30 17.417 30.2 18.317 30.1 19.317 Z"
            }), Object(jsx.b)("path", {
                fill: primary,
                d: "M 55.1 12.117 L 51.4 12.117 C 51 12.117 50.7 12.317 50.5 12.617 L 45.3 20.217 L 43.1 12.917 C 43 12.417 42.5 12.117 42.1 12.117 L 38.4 12.117 C 38 12.117 37.6 12.517 37.8 13.017 L 41.9 25.117 L 38 30.517 C 37.7 30.917 38 31.517 38.5 31.517 L 42.2 31.517 C 42.6 31.517 42.9 31.317 43.1 31.017 L 55.6 13.017 C 55.9 12.717 55.6 12.117 55.1 12.117 Z"
            }), Object(jsx.b)("path", {
                fill: secondary,
                d: "M 67.5 4.917 L 59.7 4.917 C 59.2 4.917 58.7 5.317 58.6 5.817 L 55.5 25.717 C 55.4 26.117 55.7 26.417 56.1 26.417 L 60.1 26.417 C 60.5 26.417 60.8 26.117 60.8 25.817 L 61.7 20.117 C 61.8 19.617 62.2 19.217 62.8 19.217 L 65.3 19.217 C 70.4 19.217 73.4 16.717 74.2 11.817 C 74.5 9.717 74.2 8.017 73.2 6.817 C 72 5.617 70.1 4.917 67.5 4.917 Z M 68.4 12.217 C 68 15.017 65.8 15.017 63.8 15.017 L 62.6 15.017 L 63.4 9.817 C 63.4 9.517 63.7 9.317 64 9.317 L 64.5 9.317 C 65.9 9.317 67.2 9.317 67.9 10.117 C 68.4 10.517 68.5 11.217 68.4 12.217 Z"
            }), Object(jsx.b)("path", {
                fill: secondary,
                d: "M 90.7 12.117 L 87 12.117 C 86.7 12.117 86.4 12.317 86.4 12.617 L 86.2 13.617 L 85.9 13.217 C 85.1 12.017 83.3 11.617 81.5 11.617 C 77.4 11.617 73.9 14.717 73.2 19.117 C 72.8 21.317 73.3 23.417 74.6 24.817 C 75.7 26.117 77.4 26.717 79.3 26.717 C 82.6 26.717 84.5 24.617 84.5 24.617 L 84.3 25.617 C 84.2 26.017 84.5 26.417 84.9 26.417 L 88.3 26.417 C 88.8 26.417 89.3 26.017 89.4 25.517 L 91.4 12.717 C 91.4 12.517 91.1 12.117 90.7 12.117 Z M 85.5 19.317 C 85.1 21.417 83.5 22.917 81.3 22.917 C 80.2 22.917 79.4 22.617 78.8 21.917 C 78.2 21.217 78 20.317 78.2 19.317 C 78.5 17.217 80.3 15.717 82.4 15.717 C 83.5 15.717 84.3 16.117 84.9 16.717 C 85.5 17.417 85.7 18.317 85.5 19.317 Z"
            }), Object(jsx.b)("path", {
                fill: secondary,
                d: "M 95.1 5.417 L 91.9 25.717 C 91.8 26.117 92.1 26.417 92.5 26.417 L 95.7 26.417 C 96.2 26.417 96.7 26.017 96.8 25.517 L 100 5.617 C 100.1 5.217 99.8 4.917 99.4 4.917 L 95.8 4.917 C 95.4 4.917 95.2 5.117 95.1 5.417 Z"
            }));
        }, _fundingLogos[constants.h.CREDIT] = function(_ref) {
            var logoColor = _ref.logoColor, locale = _ref.locale;
            if (!CREDIT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " credit logo available");
            var primary = CREDIT_LOGO_COLORS[logoColor].primary;
            switch ((locale || {}).country) {
              case constants.r.DE:
                return Object(jsx.b)("svg", {
                    width: "135",
                    height: "32",
                    viewBox: "0 0 135 32",
                    preserveAspectRatio: "xMinYMin meet",
                    xmlns: "http://www.w3.org/2000/svg"
                }, Object(jsx.b)("g", {
                    transform: "matrix(1.3333333,0,0,-1.3333333,10,40)",
                    fill: primary
                }, Object(jsx.b)("g", {
                    transform: "matrix(0.17016911,0,0,0.17819595,39.327112,22.053803)"
                }, Object(jsx.b)("path", {
                    d: "m 0,0 -1.35,-8.619 c -0.146,-0.929 -0.946,-1.613 -1.886,-1.613 h -40.935 c -0.922,0 -1.445,1.057 -0.884,1.79 l 29.853,39.007 h -19.237 c -0.683,0 -1.205,0.611 -1.099,1.286 l 1.35,8.619 c 0.145,0.929 0.945,1.613 1.885,1.613 H 7.112 c 0.922,0 1.444,-1.055 0.886,-1.788 L -21.724,1.286 H -1.1 C -0.416,1.286 0.106,0.675 0,0 m 203.3312,42.0833 c 0.684,0 1.206,-0.611 1.1,-1.287 l -4.446,-28.132 c -1.041,-6.73 -2.359,-13.391 -8.395,-18.456 -5.065,-4.302 -12.143,-5.828 -18.248,-5.828 -6.106,0 -12.767,1.526 -16.444,5.828 -4.371,5.065 -3.608,11.726 -2.567,18.456 l 4.394,27.808 c 0.146,0.928 0.946,1.611 1.885,1.611 h 10.668 c 0.683,0 1.205,-0.61 1.1,-1.285 l -4.101,-26.261 c -1.11,-6.799 -1.804,-14.223 6.938,-14.223 8.743,0 10.408,7.424 11.518,14.223 l 4.05,25.932 c 0.145,0.929 0.945,1.614 1.885,1.614 z m -361.2517,-52.3157 h -10.665 c -0.685,0 -1.207,0.611 -1.1,1.287 l 6.249,39.511 h -9.939 c -0.684,0 -1.206,0.61 -1.1,1.285 l 1.35,8.619 c 0.146,0.929 0.946,1.614 1.886,1.614 h 33.145 c 0.684,0 1.206,-0.611 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -9.608 l -6.198,-39.188 c -0.147,-0.927 -0.946,-1.61 -1.885,-1.61 m -98.5277,28.8638 h 1.318 c 4.441,0 9.549,0.837 10.477,6.522 0.929,5.688 -2.034,6.505 -6.779,6.522 h -1.927 c -0.58,0 -1.075,-0.422 -1.166,-0.995 z m 23.345,-28.864 h -13.977 c -0.594,0 -1.136,0.341 -1.393,0.878 l -9.224,19.244 h -0.139 l -2.985,-18.819 c -0.119,-0.75 -0.766,-1.303 -1.526,-1.303 h -10.977 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.848,49.725 c 0.119,0.751 0.766,1.304 1.526,1.304 h 19.009 c 10.339,0 17.416,-4.926 15.681,-16.097 -1.179,-7.216 -6.175,-13.461 -13.807,-14.779 l 12.015,-19.748 c 0.451,-0.742 -0.083,-1.692 -0.951,-1.692 m 445.918,52.3159 h 11.349 c 0.385,0 0.743,-0.199 0.946,-0.526 l 19.517,-31.46 h 0.139 l 4.81,30.376 c 0.147,0.927 0.946,1.61 1.885,1.61 h 10.667 c 0.684,0 1.206,-0.611 1.099,-1.287 l -7.799,-49.418 c -0.147,-0.927 -0.946,-1.611 -1.886,-1.611 h -11.347 c -0.386,0 -0.744,0.2 -0.947,0.528 l -19.517,31.528 h -0.139 l -4.811,-30.445 c -0.146,-0.928 -0.946,-1.611 -1.885,-1.611 h -10.666 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.8,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 m -304.5422,0 h 11.349 c 0.385,0 0.743,-0.199 0.946,-0.526 l 19.517,-31.46 h 0.139 l 4.81,30.376 c 0.147,0.927 0.946,1.61 1.885,1.61 h 10.667 c 0.684,0 1.206,-0.611 1.099,-1.287 l -7.799,-49.418 c -0.147,-0.927 -0.946,-1.611 -1.886,-1.611 h -11.347 c -0.386,0 -0.744,0.2 -0.947,0.528 l -19.517,31.528 h -0.139 l -4.811,-30.445 c -0.146,-0.928 -0.946,-1.611 -1.885,-1.611 h -10.666 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.8,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 M 131.156,1.2855 h 15.004 c 0.684,0 1.206,-0.61 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.928 -0.945,-1.613 -1.885,-1.613 h -26.969 c -0.685,0 -1.207,0.611 -1.1,1.287 l 7.799,49.418 c 0.147,0.927 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.612 1.099,-1.287 z m -33.5321,20.607 2.937,18.58 c 0.147,0.928 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.611 1.1,-1.287 l -7.8,-49.418 c -0.146,-0.927 -0.946,-1.611 -1.885,-1.611 h -10.664 c -0.685,0 -1.207,0.612 -1.1,1.288 l 3.196,20.152 h -19.636 l -3.145,-19.83 c -0.147,-0.927 -0.946,-1.61 -1.885,-1.61 h -10.666 c -0.685,0 -1.207,0.611 -1.1,1.287 l 7.799,49.418 c 0.147,0.928 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.611 1.099,-1.287 l -2.988,-18.904 z m 221.8207,-2.9142 c 0.699,0 1.224,-0.638 1.094,-1.325 -1.342,-7.069 -3.07,-13.21 -8.427,-19.351 -6.245,-7.147 -14.432,-10.269 -23.175,-10.269 -16.444,0 -26.088,11.171 -23.521,27.615 2.706,16.999 15.958,28.17 32.819,28.17 10.373,0 17.776,-4.519 20.966,-13.617 0.198,-0.566 -0.087,-1.189 -0.644,-1.409 l -11.599,-4.569 c -0.598,-0.236 -1.275,0.081 -1.466,0.694 -1.354,4.349 -4.637,7.175 -9.686,7.175 -8.95,0 -14.987,-8.535 -16.236,-16.514 -1.318,-8.118 2.29,-16.374 11.24,-16.374 5.898,0 10.894,3.053 12.351,9.089 h -9.793 c -0.686,0 -1.209,0.614 -1.099,1.292 l 1.373,8.458 c 0.088,0.539 0.553,0.935 1.099,0.935 z m -438.1464,9.9777 -1.132,-7.133 h 14.032 c 0.684,0 1.206,-0.61 1.1,-1.285 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -12.076 c -0.937,0 -1.735,-0.68 -1.884,-1.605 l -1.198,-7.415 h 14.865 c 0.684,0 1.206,-0.611 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -26.831 c -0.684,0 -1.206,0.611 -1.099,1.286 l 7.799,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 h 26.834 c 0.683,0 1.206,-0.61 1.1,-1.285 l -1.35,-8.619 c -0.146,-0.929 -0.946,-1.614 -1.886,-1.614 h -12.904 c -0.939,0 -1.738,-0.682 -1.885,-1.609 M 34.135,25.9168 H 33.996 L 25.739,9.2648 h 11.31 z m -13.807,-27.06 -4.747,-8.518 c -0.197,-0.353 -0.569,-0.571 -0.973,-0.571 H 2.701 c -0.844,0 -1.381,0.902 -0.979,1.644 l 27.171,50.089 c 0.194,0.359 0.57,0.583 0.978,0.583 h 13.29 c 0.523,0 0.976,-0.365 1.088,-0.876 L 55.21,-8.8812 c 0.152,-0.694 -0.377,-1.351 -1.088,-1.351 H 41.905 c -0.525,0 -0.979,0.367 -1.089,0.88 l -1.755,8.209 z m -216.5493,27.06 h -0.139 l -8.257,-16.652 h 11.31 z m -13.807,-27.06 -4.747,-8.518 c -0.197,-0.353 -0.569,-0.571 -0.973,-0.571 h -11.907 c -0.844,0 -1.381,0.902 -0.979,1.644 l 27.171,50.089 c 0.194,0.359 0.57,0.583 0.978,0.583 h 13.29 c 0.523,0 0.976,-0.365 1.088,-0.876 l 10.961,-50.089 c 0.152,-0.694 -0.377,-1.351 -1.088,-1.351 h -12.217 c -0.525,0 -0.979,0.367 -1.089,0.88 l -1.755,8.209 z m 517.9793,-39.4791 -6.146,-39.098 c -0.119,-0.757 0.467,-1.442 1.233,-1.442 h 6.181 c 1.024,0 1.896,0.745 2.055,1.756 l 6.06,38.396 c 0.119,0.757 -0.466,1.442 -1.233,1.442 h -6.917 c -0.614,0 -1.138,-0.447 -1.233,-1.054 m -77.0618,-12.7966 h -7.207 c -0.689,0 -1.334,-0.342 -1.721,-0.912 l -9.942,-14.642 -4.213,14.07 c -0.263,0.88 -1.073,1.484 -1.993,1.484 h -7.084 c -0.856,0 -1.457,-0.842 -1.182,-1.651 l 7.936,-23.294 -7.464,-10.531 c -0.586,-0.827 0.005,-1.97 1.018,-1.97 h 7.2 c 0.683,0 1.322,0.334 1.71,0.895 l 23.968,34.591 c 0.574,0.828 -0.019,1.96 -1.026,1.96 m 58.6183,-13.956 c -0.693,-4.097 -3.945,-6.847 -8.093,-6.847 -2.08,0 -3.744,0.669 -4.815,1.935 -1.06,1.256 -1.46,3.045 -1.123,5.037 0.645,4.06 3.95,6.899 8.035,6.899 2.036,0 3.689,-0.675 4.78,-1.954 1.099,-1.287 1.53,-3.088 1.216,-5.07 m 9.992,13.956 h -7.169 c -0.615,0 -1.138,-0.447 -1.234,-1.054 l -0.315,-2.004 -0.501,0.726 c -1.553,2.254 -5.014,3.007 -8.469,3.007 -7.922,0 -14.689,-6.003 -16.006,-14.422 -0.685,-4.201 0.288,-8.215 2.669,-11.016 2.189,-2.574 5.311,-3.646 9.031,-3.646 6.385,0 9.927,4.102 9.927,4.102 l -0.321,-1.993 c -0.12,-0.758 0.466,-1.443 1.233,-1.443 h 6.457 c 1.024,0 1.896,0.744 2.055,1.756 l 3.876,24.545 c 0.12,0.757 -0.466,1.442 -1.233,1.442 m -116.7913,-13.956 c -0.693,-4.097 -3.945,-6.847 -8.093,-6.847 -2.08,0 -3.744,0.669 -4.815,1.935 -1.06,1.256 -1.46,3.045 -1.123,5.037 0.645,4.06 3.95,6.899 8.035,6.899 2.036,0 3.689,-0.675 4.78,-1.954 1.099,-1.287 1.531,-3.088 1.216,-5.07 m 9.992,13.956 h -7.169 c -0.615,0 -1.138,-0.447 -1.233,-1.054 l -0.316,-2.004 -0.501,0.726 c -1.553,2.254 -5.014,3.007 -8.469,3.007 -7.921,0 -14.689,-6.003 -16.006,-14.422 -0.685,-4.201 0.288,-8.215 2.669,-11.016 2.189,-2.574 5.311,-3.646 9.031,-3.646 6.385,0 9.927,4.102 9.927,4.102 l -0.321,-1.993 c -0.12,-0.758 0.466,-1.443 1.233,-1.443 h 6.457 c 1.024,0 1.896,0.744 2.055,1.756 l 3.876,24.545 c 0.12,0.757 -0.466,1.442 -1.233,1.442 m -43.0269,-0.172 c -0.818,-5.375 -4.924,-5.375 -8.894,-5.375 h -2.259 l 1.585,10.035 c 0.096,0.607 0.618,1.054 1.233,1.054 h 1.035 c 2.703,0 5.256,0 6.572,-1.54 0.787,-0.922 1.026,-2.287 0.728,-4.174 m -1.728,14.023 h -14.974 c -1.024,0 -1.896,-0.745 -2.055,-1.756 l -6.055,-38.396 c -0.119,-0.757 0.466,-1.442 1.233,-1.442 h 7.149 c 1.024,0 1.896,0.745 2.055,1.756 l 1.634,10.358 c 0.16,1.012 1.031,1.757 2.055,1.757 h 4.739 c 9.863,0 15.555,4.773 17.043,14.233 0.669,4.138 0.027,7.389 -1.911,9.665 -2.129,2.502 -5.904,3.825 -10.913,3.825 m 108.5272,-14.023 c -0.818,-5.375 -4.923,-5.375 -8.894,-5.375 h -2.259 l 1.585,10.035 c 0.096,0.607 0.619,1.054 1.233,1.054 h 1.035 c 2.703,0 5.256,0 6.572,-1.54 0.787,-0.922 1.026,-2.287 0.728,-4.174 m -1.728,14.023 h -14.974 c -1.024,0 -1.896,-0.745 -2.055,-1.756 l -6.055,-38.396 c -0.119,-0.757 0.466,-1.442 1.233,-1.442 h 7.683 c 0.717,0 1.327,0.521 1.438,1.229 l 1.717,10.885 c 0.16,1.012 1.031,1.757 2.055,1.757 h 4.739 c 9.863,0 15.555,4.773 17.043,14.233 0.669,4.138 0.027,7.389 -1.911,9.665 -2.129,2.502 -5.903,3.825 -10.913,3.825 m -161.6161,-40.475 -4.55,18.557 h 3.561 l 3.442,-14.442 7.914,14.442 h 3.798 l -15.748,-27.656 h -3.758 z M 82.525,-65.6994 c -0.989,1.121 -2.328,1.681 -4.016,1.681 -1.319,0 -2.546,-0.356 -3.679,-1.068 -1.135,-0.712 -2.045,-1.701 -2.731,-2.967 -0.686,-1.267 -1.028,-2.691 -1.028,-4.274 0,-1.767 0.5,-3.205 1.503,-4.313 1.002,-1.107 2.242,-1.661 3.719,-1.661 1.346,0 2.612,0.369 3.799,1.108 1.187,0.738 2.136,1.746 2.848,3.026 0.713,1.28 1.069,2.672 1.069,4.175 0,1.74 -0.495,3.171 -1.484,4.293 m -8.527,12.206 -1.661,-10.604 c 0.791,0.976 1.806,1.761 3.047,2.354 1.239,0.594 2.65,0.891 4.233,0.891 1.529,0 2.908,-0.376 4.135,-1.128 1.226,-0.752 2.182,-1.787 2.868,-3.106 0.686,-1.319 1.029,-2.809 1.029,-4.472 0,-2.162 -0.515,-4.153 -1.543,-5.974 -1.029,-1.819 -2.388,-3.264 -4.075,-4.332 -1.689,-1.068 -3.469,-1.602 -5.342,-1.602 -1.635,0 -2.981,0.329 -4.036,0.988 -1.055,0.659 -1.912,1.623 -2.571,2.889 l -0.515,-3.205 h -3.403 l 4.313,27.301 z M 39.4576,-76.5416 c 0.976,-1.121 2.308,-1.681 3.996,-1.681 1.319,0 2.552,0.356 3.699,1.069 1.148,0.712 2.064,1.701 2.751,2.967 0.685,1.266 1.028,2.691 1.028,4.273 0,1.767 -0.501,3.198 -1.503,4.293 -1.003,1.095 -2.256,1.642 -3.759,1.642 -1.32,0 -2.572,-0.37 -3.759,-1.108 -1.187,-0.738 -2.136,-1.741 -2.849,-3.007 -0.712,-1.266 -1.068,-2.651 -1.068,-4.155 0,-1.741 0.488,-3.171 1.464,-4.293 m 9.892,-4.253 0.474,2.968 c -0.844,-1.108 -1.899,-1.986 -3.165,-2.631 -1.266,-0.647 -2.704,-0.969 -4.313,-0.969 -1.53,0 -2.902,0.369 -4.115,1.107 -1.214,0.738 -2.163,1.767 -2.848,3.086 -0.687,1.319 -1.029,2.823 -1.029,4.51 0,2.111 0.507,4.083 1.523,5.916 1.016,1.833 2.347,3.29 3.996,4.372 1.648,1.081 3.357,1.622 5.124,1.622 3.297,0 5.553,-1.279 6.766,-3.837 l 1.781,11.157 h 3.521 l -4.313,-27.301 z m -28.8284,15.3321 c -1.253,-1.094 -2.104,-2.421 -2.552,-3.976 h 11.474 c 0.026,0.21 0.04,0.501 0.04,0.87 0,1.478 -0.395,2.638 -1.187,3.482 -0.792,0.844 -1.913,1.266 -3.363,1.266 -1.688,0 -3.159,-0.548 -4.412,-1.642 m 10.406,2.454 c 1.306,-1.439 1.958,-3.305 1.958,-5.6 0,-0.764 -0.039,-1.397 -0.118,-1.899 -0.079,-0.501 -0.212,-1.095 -0.396,-1.78 h -14.877 c -0.079,-1.979 0.435,-3.502 1.543,-4.57 1.108,-1.068 2.612,-1.602 4.511,-1.602 1.319,0 2.519,0.164 3.601,0.494 1.081,0.33 2.149,0.824 3.205,1.484 l -0.476,-2.968 c -2.031,-1.371 -4.431,-2.057 -7.201,-2.057 -1.82,0 -3.396,0.39 -4.728,1.167 -1.332,0.777 -2.348,1.854 -3.046,3.225 -0.699,1.371 -1.049,2.914 -1.049,4.629 0,1.688 0.422,3.435 1.266,5.243 0.845,1.806 2.124,3.323 3.839,4.55 1.714,1.226 3.824,1.84 6.33,1.84 2.453,0 4.333,-0.719 5.638,-2.156 m -18.0138,-1.4448 c -1.556,0 -2.875,-0.561 -3.956,-1.681 -1.082,-1.122 -1.794,-2.751 -2.137,-4.888 l -1.543,-9.772 h -3.522 l 3.047,19.308 h 3.403 l -0.515,-3.283 c 1.583,2.268 3.483,3.402 5.698,3.402 0.554,0 1.068,-0.039 1.543,-0.119 l -0.475,-3.086 c -0.474,0.079 -0.989,0.119 -1.543,0.119 m -24.5657,-1.0092 c -1.253,-1.094 -2.104,-2.421 -2.552,-3.976 h 11.474 c 0.026,0.21 0.04,0.501 0.04,0.87 0,1.478 -0.396,2.638 -1.187,3.482 -0.792,0.844 -1.913,1.266 -3.363,1.266 -1.689,0 -3.159,-0.548 -4.412,-1.642 m 10.406,2.454 c 1.305,-1.439 1.958,-3.305 1.958,-5.6 0,-0.764 -0.039,-1.397 -0.118,-1.899 -0.079,-0.501 -0.212,-1.095 -0.396,-1.78 h -14.877 c -0.079,-1.979 0.435,-3.502 1.543,-4.57 1.108,-1.068 2.612,-1.602 4.511,-1.602 1.319,0 2.519,0.164 3.601,0.494 1.081,0.33 2.149,0.824 3.204,1.484 l -0.475,-2.968 c -2.031,-1.371 -4.431,-2.057 -7.201,-2.057 -1.82,0 -3.396,0.39 -4.728,1.167 -1.332,0.777 -2.348,1.854 -3.046,3.225 -0.699,1.371 -1.049,2.914 -1.049,4.629 0,1.688 0.422,3.435 1.266,5.243 0.844,1.806 2.124,3.323 3.838,4.55 1.715,1.226 3.824,1.84 6.331,1.84 2.453,0 4.333,-0.719 5.638,-2.156 m -24.4869,-17.7856 h -3.561 l -2.057,14.837 -6.766,-14.837 h -3.522 l -2.77,19.308 h 3.522 l 1.741,-15.193 6.805,15.193 h 3.324 l 2.017,-15.154 6.529,15.154 h 3.6 z M -59.063,-65.225 c -1.201,-0.778 -2.124,-1.807 -2.77,-3.086 -0.647,-1.28 -0.969,-2.619 -0.969,-4.017 0,-1.741 0.494,-3.171 1.484,-4.292 0.988,-1.122 2.261,-1.682 3.817,-1.682 1.53,0 2.889,0.402 4.076,1.207 1.187,0.805 2.11,1.852 2.769,3.146 0.659,1.292 0.99,2.637 0.99,4.035 0,1.715 -0.495,3.12 -1.484,4.215 -0.989,1.093 -2.262,1.641 -3.818,1.641 -1.53,0 -2.896,-0.389 -4.095,-1.167 M -50.28,-62 c 1.332,-0.766 2.368,-1.827 3.106,-3.185 0.738,-1.359 1.108,-2.896 1.108,-4.61 0,-1.952 -0.482,-3.825 -1.444,-5.618 -0.963,-1.794 -2.321,-3.251 -4.075,-4.372 -1.755,-1.122 -3.766,-1.682 -6.034,-1.682 -1.688,0 -3.199,0.383 -4.531,1.148 -1.331,0.764 -2.374,1.833 -3.125,3.205 -0.752,1.37 -1.128,2.914 -1.128,4.628 0,1.979 0.481,3.859 1.444,5.639 0.963,1.781 2.321,3.224 4.076,4.332 1.753,1.108 3.764,1.663 6.033,1.663 1.715,0 3.238,-0.383 4.57,-1.148 m -20.7559,4.1545 c -0.897,0.87 -2.255,1.305 -4.075,1.305 h -4.471 l -1.82,-11.513 h 4.668 c 2.401,0 4.175,0.639 5.322,1.919 1.148,1.279 1.721,2.894 1.721,4.847 0,1.424 -0.448,2.571 -1.345,3.442 m 3.027,2.373 c 1.464,-1.318 2.196,-3.112 2.196,-5.38 0,-3.113 -0.944,-5.599 -2.829,-7.459 -1.887,-1.859 -4.715,-2.789 -8.487,-2.789 h -4.748 l -1.543,-9.694 h -3.759 l 4.313,27.301 h 8.309 c 2.901,0 5.084,-0.66 6.548,-1.979"
                }))));

              default:
                return Object(jsx.b)("svg", {
                    width: "100",
                    height: "32",
                    viewBox: "0 0 95 32",
                    preserveAspectRatio: "xMinYMin meet",
                    xmlns: "http://www.w3.org/2000/svg"
                }, Object(jsx.b)("path", {
                    fill: primary,
                    d: "M 52.732 6.347 C 52.83 5.963 53.122 5.675 53.512 5.675 L 60.626 5.675 C 66.571 5.675 70.664 10.187 69.69 15.851 C 68.813 21.515 63.16 25.931 57.313 25.931 L 50.004 25.931 C 49.711 25.931 49.516 25.739 49.614 25.451 L 52.732 6.347 Z M 55.753 21.515 L 57.02 21.515 C 60.236 21.515 63.355 19.787 64.037 15.851 C 64.622 12.203 62.478 10.187 58.97 10.187 L 57.995 10.187 C 57.8 10.187 57.605 10.283 57.605 10.475 L 55.753 21.515 Z"
                }), Object(jsx.b)("path", {
                    fill: primary,
                    d: "M 43.571 10.763 L 43.084 13.547 L 48.737 13.547 C 49.029 13.547 49.224 13.739 49.224 14.027 L 48.639 17.387 C 48.542 17.771 48.249 17.963 47.859 17.963 L 42.987 17.963 C 42.597 17.963 42.304 18.251 42.207 18.635 L 41.72 21.515 L 47.762 21.515 C 48.054 21.515 48.249 21.707 48.152 21.995 L 47.665 25.355 C 47.567 25.643 47.275 25.931 46.885 25.931 L 36.067 25.931 C 35.775 25.931 35.58 25.643 35.58 25.451 L 38.699 6.347 C 38.796 5.963 39.186 5.675 39.478 5.675 L 50.393 5.675 C 50.588 5.675 50.881 5.963 50.783 6.155 L 50.296 9.515 C 50.198 9.899 49.906 10.091 49.516 10.091 L 44.254 10.091 C 43.864 10.187 43.571 10.379 43.571 10.763 Z"
                }), Object(jsx.b)("path", {
                    fill: primary,
                    d: "M 74.563 25.931 L 70.274 25.931 C 69.982 25.931 69.787 25.739 69.787 25.451 L 73.003 6.347 C 73.003 5.963 73.393 5.675 73.685 5.675 L 78.071 5.675 C 78.266 5.675 78.558 5.963 78.461 6.251 L 75.342 25.355 C 75.245 25.643 74.952 25.931 74.563 25.931 Z"
                }), Object(jsx.b)("path", {
                    fill: primary,
                    d: "M 34.118 25.931 L 28.466 25.931 C 28.173 25.931 27.978 25.835 27.881 25.643 L 24.178 18.155 L 24.08 18.155 L 22.911 25.451 C 22.813 25.739 22.618 25.931 22.326 25.931 L 17.843 25.931 C 17.551 25.931 17.356 25.739 17.453 25.451 L 20.572 6.251 C 20.669 5.963 20.864 5.675 21.156 5.675 L 28.855 5.675 C 33.046 5.675 35.97 7.595 35.288 11.915 C 34.8 14.699 32.754 17.195 29.635 17.675 L 34.508 25.355 C 34.703 25.547 34.411 25.931 34.118 25.931 Z M 24.665 14.795 L 25.152 14.795 C 27.004 14.795 29.05 14.411 29.44 12.203 C 29.83 10.091 28.661 9.707 26.711 9.707 L 25.932 9.707 C 25.639 9.707 25.445 9.899 25.445 10.091 L 24.665 14.795 Z"
                }), Object(jsx.b)("path", {
                    fill: primary,
                    d: "M 86.16 25.931 L 81.872 25.931 C 81.579 25.931 81.384 25.739 81.482 25.451 L 83.918 10.187 L 79.923 10.187 C 79.63 10.187 79.435 9.899 79.533 9.611 L 80.02 6.347 C 80.118 5.963 80.41 5.675 80.8 5.675 L 94.249 5.675 C 94.444 5.675 94.736 5.963 94.639 6.251 L 94.054 9.515 C 94.054 9.899 93.761 10.187 93.372 10.187 L 89.473 10.187 L 86.939 25.355 C 86.939 25.643 86.647 25.931 86.16 25.931 Z"
                }), Object(jsx.b)("path", {
                    fill: primary,
                    d: "M 17.648 11.435 C 17.648 11.819 17.161 12.011 16.868 11.723 C 15.894 10.763 14.529 10.283 13.068 10.283 C 9.657 10.283 7.025 12.779 6.441 15.851 C 5.953 19.019 7.902 21.323 11.313 21.323 C 12.678 21.323 14.237 20.843 15.407 19.979 C 15.796 19.787 16.284 20.075 16.186 20.459 L 15.407 25.067 C 15.309 25.355 15.114 25.547 14.822 25.643 C 13.165 26.123 11.898 26.507 10.339 26.507 C 1.178 26.507 -0.284 19.019 0.203 15.851 C 1.47 6.923 9.072 4.907 13.652 5.195 C 15.114 5.195 16.479 5.387 17.745 5.867 C 18.233 6.059 18.428 6.443 18.33 6.923 L 17.648 11.435 Z"
                }));
            }
        }, _fundingLogos[constants.h.VENMO] = ((_BUTTON_LOGO$VENMO = {})[constants.i.WHITE] = venmo_white_default.a, 
        _BUTTON_LOGO$VENMO[constants.i.BLUE] = venmo_blue_default.a, _BUTTON_LOGO$VENMO), 
        _fundingLogos[constants.h.ITAU] = ((_BUTTON_LOGO$ITAU = {})[constants.i.BLUE] = itau_default.a, 
        _BUTTON_LOGO$ITAU), _fundingLogos[constants.h.IDEAL] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!IDEAL_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " ideal logo available");
            var _IDEAL_LOGO_COLORS$lo = IDEAL_LOGO_COLORS[logoColor], primary = _IDEAL_LOGO_COLORS$lo.primary, secondary = _IDEAL_LOGO_COLORS$lo.secondary, tertiary = _IDEAL_LOGO_COLORS$lo.tertiary;
            return Object(jsx.b)("svg", {
                width: "38",
                height: "32",
                viewBox: "0 0 38 32",
                preserveAspectRatio: "xMinYMin meet",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.b)("polygon", {
                fill: primary,
                points: "4.47 27.632 10.452 27.632 10.452 17.982 4.47 17.982"
            }), Object(jsx.b)("g", {
                transform: "matrix(0.952642, 0, 0, 0.930979, 0.31993, 0.181113)"
            }, Object(jsx.b)("path", {
                d: "M11.1102604,13.937999 C11.1102604,15.8893766 9.51859887,17.4723289 7.55546104,17.4723289 C5.59238806,17.4723289 4.00066169,15.8893766 4.00066169,13.937999 C4.00066169,11.9865569 5.59238806,10.4043136 7.55546104,10.4043136 C9.51859887,10.4043136 11.1102604,11.9865569 11.1102604,13.937999",
                fill: primary
            }), Object(jsx.b)("g", null, Object(jsx.b)("mask", {
                fill: secondary
            }, Object(jsx.b)("polygon", {
                points: "39.1898554 33.9678282 0 33.9678282 0 0.001572704 39.1898554 0.001572704",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.b)("g", null), Object(jsx.b)("path", {
                d: "M22.1049929,2.25750057 C26.4717361,2.25750057 30.1110886,3.433548 32.6296578,5.65853743 C35.476843,8.17370364 36.9204068,11.9843525 36.9204068,16.9847134 C36.9204068,26.8945533 32.0742264,31.7119261 22.1049929,31.7119261 L2.26942909,31.7119261 L2.26942909,2.25750057 L22.1049929,2.25750057 Z M22.531325,0.001572704 L-1.9452416e-05,0.001572704 L-1.9452416e-05,33.967854 L22.531325,33.967854 L22.531325,33.9614085 C27.4529808,33.8947619 31.3518934,32.6793969 34.1187402,30.3394196 C37.4837488,27.4935988 39.1898554,23.0003706 39.1898554,16.9847134 C39.1898554,14.1090499 38.7410881,11.5297509 37.8560681,9.31836144 C37.0093692,7.2028812 35.758125,5.40419768 34.13722,3.97219912 C31.2823834,1.45020067 27.2749912,0.0865245021 22.531325,0.00904949351 L22.531325,0.001572704 Z",
                fill: primary
            })), Object(jsx.b)("path", {
                d: "M21.4851352,29.4975138 L13.5194356,29.4975138 L13.5194356,5.00387361 L21.4851352,5.00387361 L21.1636516,5.00387361 C27.8067813,5.00387361 34.8779291,7.60998594 34.8779291,17.282889 C34.8779291,27.5088167 27.8067813,29.4975138 21.1636516,29.4975138 L21.4851352,29.4975138 Z",
                fill: tertiary
            })), Object(jsx.b)("g", {
                transform: "matrix(0.952642, 0, 0, 0.930979, 11.685725, 10.562208)",
                fill: secondary
            }, Object(jsx.b)("path", {
                d: "M1.41115607,1.17495169 L1.41115607,5.07048794 L2.30681015,5.07048794 C2.64178075,5.07048794 2.88357428,5.05173151 3.03219074,5.0142831 C3.2267149,4.96613516 3.38810511,4.88459948 3.51649106,4.76961161 C3.64474732,4.65455929 3.749531,4.46538363 3.83058274,4.20189125 C3.91163447,3.93846333 3.95216034,3.57944852 3.95216034,3.12471792 C3.95216034,2.67005177 3.91163447,2.3210275 3.83058274,2.07764511 C3.749531,1.83426272 3.63605858,1.64437805 3.49016546,1.5079911 C3.34420749,1.37160414 3.15915018,1.27930447 2.93492866,1.23109207 C2.76737852,1.19370812 2.43915142,1.17495169 1.95018252,1.17495169 L1.41115607,1.17495169 Z M0.215675421,0.175897919 L2.40271056,0.175897919 C2.89589415,0.175897919 3.27190935,0.213410777 3.53069132,0.288436492 C3.878306,0.390275522 4.17612249,0.571265392 4.42407595,0.831212737 C4.67202941,1.09116008 4.86065301,1.40950373 4.99001157,1.78598587 C5.11937014,2.16253246 5.18408185,2.62686687 5.18408185,3.1789891 C5.18408185,3.66407805 5.12345515,4.08213371 5.00220176,4.433285 C4.85397434,4.86210466 4.6423969,5.20919527 4.36753426,5.47449239 C4.15997698,5.67552779 3.87966767,5.832347 3.52660632,5.94488558 C3.26244251,6.02796818 2.90938115,6.06954171 2.46742226,6.06954171 L0.215675421,6.06954171 L0.215675421,0.175897919 Z"
            }), Object(jsx.b)("path", {
                d: "M2.40271056,0.337035624 C2.87825729,0.337035624 3.24247136,0.372743739 3.48523751,0.443128689 C3.80302515,0.536201827 4.07944398,0.704171771 4.30645367,0.942075479 C4.53702965,1.18384649 4.7154083,1.48530291 4.83666169,1.83813003 C4.95966581,2.19611355 5.02197838,2.64723467 5.02197838,3.1789891 C5.02197838,3.64390361 4.96375081,4.04829479 4.84885188,4.38094747 C4.70970226,4.78359837 4.50973142,5.11264156 4.25458057,5.35892443 C4.06589213,5.54165459 3.80438682,5.68712971 3.47713234,5.79148248 C3.23060538,5.86895749 2.89070683,5.908404 2.46742226,5.908404 L0.377778888,5.908404 L0.377778888,0.337035624 L2.40271056,0.337035624 Z M0.0535719538,0.0147602138 L0.0535719538,6.23067941 L2.46742226,6.23067941 C2.92390562,6.23067941 3.2967436,6.18614095 3.57549672,6.09848204 C3.95157676,5.97866004 4.25594223,5.80759625 4.48061764,5.58993144 C4.77246872,5.30819828 4.9996081,4.93661473 5.15548679,4.48562252 C5.28205718,4.11919538 5.34618531,3.67954727 5.34618531,3.1789891 C5.34618531,2.61178438 5.27797217,2.12559969 5.1434263,1.73390616 C5.00706486,1.33699177 4.80456521,0.995959927 4.54169823,0.720349996 C4.27494076,0.440679396 3.9502151,0.243317935 3.57646934,0.133873205 C3.29992083,0.0536910833 2.91612466,0.0147602138 2.40271056,0.0147602138 L0.0535719538,0.0147602138 Z"
            }), Object(jsx.b)("path", {
                d: "M1.9501501,1.33608939 C2.54124418,1.33608939 2.79263424,1.36451409 2.899428,1.38836247 C3.09466542,1.43032272 3.25566658,1.50998921 3.37905974,1.6253638 C3.50439814,1.74254314 3.60457808,1.91180219 3.6766817,2.12824235 C3.75189771,2.35415741 3.79002445,2.68945275 3.79002445,3.12471792 C3.79002445,3.56127219 3.75150867,3.90784717 3.67551456,4.15477459 C3.60360546,4.38861762 3.51354078,4.55523401 3.40791416,4.64991853 C3.30014777,4.74647224 3.16054427,4.81647046 2.99299412,4.85797953 C2.85754047,4.89207627 2.62683481,4.90935023 2.30677773,4.90935023 L1.57329196,4.90935023 L1.57329196,1.33608939 L1.9501501,1.33608939 Z M1.24902018,1.01381398 L1.24902018,5.23162564 L2.30677773,5.23162564 C2.65860709,5.23162564 2.90889484,5.21158011 3.07203577,5.17052222 C3.29100514,5.1163155 3.47729444,5.02163098 3.62500312,4.88924025 C3.77699133,4.7529822 3.89493781,4.54356764 3.98558607,4.24900792 C4.07214932,3.96766148 4.11423138,3.59988078 4.11423138,3.12471792 C4.11423138,2.64833041 4.07176027,2.2893156 3.98441893,2.02698342 C3.89519718,1.75904364 3.76622766,1.54492386 3.60120633,1.39061839 C3.43423976,1.23450819 3.22162485,1.12789948 2.96919733,1.0736283 C2.78932733,1.03347278 2.45558871,1.01381398 1.9501501,1.01381398 L1.24902018,1.01381398 Z"
            }), Object(jsx.b)("polygon", {
                points: "6.53678989 6.06950948 6.53678989 0.175865691 10.9257088 0.175865691 10.9257088 1.17491946 7.73227054 1.17491946 7.73227054 2.48013487 10.702849 2.48013487 10.702849 3.47918864 7.73227054 3.47918864 7.73227054 5.07045571 11.0391813 5.07045571 11.0391813 6.06950948"
            }), Object(jsx.b)("path", {
                d: "M10.7636378,0.337035624 L10.7636378,1.01381398 L7.57019949,1.01381398 L7.57019949,2.64130481 L10.5407779,2.64130481 L10.5407779,3.31808317 L7.57019949,3.31808317 L7.57019949,5.23162564 L10.8771102,5.23162564 L10.8771102,5.908404 L6.69892578,5.908404 L6.69892578,0.337035624 L10.7636378,0.337035624 Z M6.37471884,0.0147602138 L6.37471884,6.23067941 L11.2013172,6.23067941 L11.2013172,4.90935023 L7.89440643,4.90935023 L7.89440643,3.64035858 L10.8649849,3.64035858 L10.8649849,2.3190294 L7.89440643,2.3190294 L7.89440643,1.33608939 L11.0878447,1.33608939 L11.0878447,0.0147602138 L6.37471884,0.0147602138 Z"
            }), Object(jsx.b)("path", {
                d: "M15.5303032,3.73301276 L14.7130424,1.54959685 L13.9121864,3.73301276 L15.5303032,3.73301276 Z M17.7341971,6.06950948 L16.431793,6.06950948 L15.9144884,4.73206653 L13.5458326,4.73206653 L13.055113,6.06950948 L11.7849999,6.06950948 L14.0890089,0.175865691 L15.363207,0.175865691 L17.7341971,6.06950948 Z"
            }), Object(jsx.b)("path", {
                d: "M15.2534629,0.337035624 C15.3291976,0.525244463 17.332991,5.50626875 17.4947703,5.908404 L16.5431581,5.908404 C16.4751395,5.73244163 16.0257887,4.57096105 16.0257887,4.57096105 L13.4323926,4.57096105 C13.4323926,4.57096105 13.0075518,5.72876769 12.9417378,5.908404 L12.0218979,5.908404 C12.1781008,5.50884695 14.1252876,0.527951577 14.1999201,0.337035624 L15.2534629,0.337035624 Z M13.9780328,0.0147602138 L11.5481019,6.23067941 L13.168553,6.23067941 C13.168553,6.23067941 13.5933289,5.07280832 13.6592077,4.89323646 L15.8031882,4.89323646 C15.871142,5.06913438 16.3204928,6.23067941 16.3204928,6.23067941 L17.9736239,6.23067941 L15.472951,0.0147602138 L13.9780328,0.0147602138 Z"
            }), Object(jsx.b)("path", {
                d: "M14.7145337,2.01579402 C14.8921991,2.49044124 15.1926093,3.29290701 15.2970039,3.57186861 L14.1437998,3.57186861 C14.2457305,3.2940672 14.5401752,2.49134361 14.7145337,2.01579402 L14.7145337,2.01579402 Z M13.680573,3.89414402 L15.7636025,3.89414402 L14.7114862,1.0833868 L13.680573,3.89414402 Z"
            }), Object(jsx.b)("polygon", {
                points: "18.7343171 6.06950948 18.7343171 0.224207003 19.9297978 0.224207003 19.9297978 5.07045571 22.9084814 5.07045571 22.9084814 6.06950948"
            }), Object(jsx.b)("path", {
                d: "M19.7677267,0.385376935 L19.7677267,5.23162564 L22.7464104,5.23162564 L22.7464104,5.908404 L18.8963882,5.908404 L18.8963882,0.385376935 L19.7677267,0.385376935 Z M18.5722461,0.0631015253 L18.5722461,6.23067941 L23.0706173,6.23067941 L23.0706173,4.90935023 L20.0919337,4.90935023 L20.0919337,0.0631015253 L18.5722461,0.0631015253 Z"
            })));
        }, _fundingLogos[constants.h.ELV] = ((_BUTTON_LOGO$ELV = {})[constants.i.ANY] = elv_default.a, 
        _BUTTON_LOGO$ELV[constants.i.WHITE] = elv_white_default.a, _BUTTON_LOGO$ELV), _fundingLogos[constants.h.BANCONTACT] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!BANCONTACT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " bancontact logo available");
            var _BANCONTACT_LOGO_COLO2 = BANCONTACT_LOGO_COLORS[logoColor], primary = _BANCONTACT_LOGO_COLO2.primary, secondary = _BANCONTACT_LOGO_COLO2.secondary;
            return Object(jsx.b)("svg", {
                version: "1.1",
                id: "Layer_1",
                x: "0px",
                y: "0px",
                width: "226px",
                height: "32px",
                viewBox: "36.09922790527344 36.68461608886719 226 32",
                style: "enable-background:new 0 0 476.9 123.4;",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.b)("g", {
                transform: "matrix(0.557769, 0, 0, 0.557769, 15.684875, 18.15871)"
            }, Object(jsx.b)("g", null, Object(jsx.b)("path", {
                fill: primary,
                d: "M147.6,50.2h-5.8h-26.9h-5.8l-3.9,4.4L92.5,68.9l0,0l-3.9,4.4h-6H56.2h-5.8l3.9-4.5l1.8-2.1l3.9-4.5h-5.8h-7.6 h-4.2c-3.2,0-5.8,2.7-5.8,6l0,0v11.5v1.1c0,3.3,2.6,6,5.8,6H44h61.1h4.4c3.2,0,7.6-2,9.7-4.4l10.2-11.6L147.6,50.2z"
            }), Object(jsx.b)("path", {
                fill: secondary,
                d: "M155.3,36.8c3.2,0,5.8,2.7,5.8,6v12.6c0,3.3-2.6,6-5.8,6h-3.2h-8.5h-5.8l3.9-4.4l0,0l1.9-2.2l3.9-4.4h-38.6 L88.3,73.6H50l27.5-31.1l1-1.2c2.2-2.4,6.5-4.4,9.7-4.4h1.4h65.7V36.8z"
            })), Object(jsx.b)("path", {
                fill: primary,
                d: "M 440.7 85.6 L 440.7 81.8 C 440.7 81.3 440.4 81 439.7 81 L 437.3 81 C 436.6 81 436.1 80.9 436 80.6 C 435.8 80.3 435.8 79.7 435.8 78.7 L 435.8 64.7 L 439.7 64.7 C 440 64.7 440.2 64.6 440.4 64.4 C 440.6 64.2 440.7 64 440.7 63.7 L 440.7 59.8 C 440.7 59.5 440.6 59.3 440.4 59.1 C 440.2 58.9 440 58.8 439.7 58.8 L 435.8 58.8 L 435.8 53.8 C 435.8 53.5 435.7 53.3 435.6 53.2 C 435.4 53.1 435.2 53 435 53 L 434.9 53 L 429.1 54 C 428.8 54.1 428.6 54.2 428.4 54.3 C 428.2 54.5 428.1 54.7 428.1 54.9 L 428.1 58.8 L 424.2 58.8 C 423.9 58.8 423.7 58.9 423.5 59.1 C 423.3 59.3 423.2 59.5 423.2 59.8 L 423.2 63 C 423.2 63.3 423.3 63.5 423.5 63.6 C 423.7 63.8 423.9 63.9 424.2 64 L 428.1 64.6 L 428.1 78.6 C 428.1 80.3 428.3 81.7 428.6 82.8 C 429 83.9 429.5 84.7 430.1 85.3 C 430.8 85.9 431.6 86.3 432.6 86.5 C 433.6 86.7 434.8 86.8 436.1 86.8 C 436.8 86.8 437.4 86.8 438 86.7 C 438.5 86.6 439.2 86.5 439.9 86.4 C 440.4 86.4 440.7 86.1 440.7 85.6 M 419.9 85.1 L 419.9 80.8 C 419.9 80.5 419.8 80.3 419.6 80.2 C 419.4 80.1 419.2 80 418.9 80 L 418.8 80 C 417.9 80.1 417 80.2 416.2 80.2 C 415.4 80.3 414.3 80.3 412.9 80.3 C 412.4 80.3 411.8 80.2 411.4 80 C 410.9 79.8 410.5 79.5 410.1 79.1 C 409.7 78.7 409.5 78.1 409.3 77.4 C 409.1 76.7 409 75.8 409 74.7 L 409 70.7 C 409 69.6 409.1 68.7 409.3 68 C 409.5 67.3 409.8 66.7 410.1 66.3 C 410.5 65.9 410.9 65.6 411.4 65.4 C 411.9 65.2 412.4 65.1 412.9 65.1 C 414.3 65.1 415.4 65.1 416.2 65.2 C 417 65.3 417.9 65.3 418.8 65.4 L 418.9 65.4 C 419.2 65.4 419.4 65.3 419.6 65.2 C 419.8 65.1 419.9 64.9 419.9 64.6 L 419.9 60.3 C 419.9 59.9 419.8 59.7 419.7 59.6 C 419.5 59.5 419.3 59.3 418.9 59.2 C 418.2 59 417.3 58.9 416.3 58.7 C 415.2 58.5 414 58.5 412.5 58.5 C 409.1 58.5 406.4 59.5 404.3 61.6 C 402.3 63.7 401.2 66.7 401.2 70.7 L 401.2 74.7 C 401.2 78.6 402.2 81.7 404.3 83.8 C 406.3 85.9 409.1 86.9 412.5 86.9 C 413.9 86.9 415.2 86.8 416.3 86.7 C 417.4 86.5 418.3 86.4 418.9 86.2 C 419.3 86.1 419.5 86 419.7 85.8 C 419.8 85.7 419.9 85.4 419.9 85.1 M 388.6 80 C 388 80.3 387.4 80.5 386.7 80.7 C 386 80.9 385.3 81 384.6 81 C 383.6 81 382.8 80.9 382.3 80.6 C 381.8 80.3 381.6 79.7 381.6 78.6 L 381.6 78.2 C 381.6 77.6 381.7 77.1 381.8 76.7 C 381.9 76.3 382.2 75.9 382.5 75.6 C 382.8 75.3 383.3 75.1 383.8 74.9 C 384.3 74.8 385 74.7 385.9 74.7 L 388.6 74.7 L 388.6 80 L 388.6 80 Z M 396.2 68.3 C 396.2 66.5 395.9 65 395.4 63.8 C 394.9 62.6 394.1 61.6 393.2 60.8 C 392.2 60 391.1 59.4 389.7 59.1 C 388.3 58.7 386.7 58.5 385 58.5 C 383.4 58.5 381.8 58.6 380.3 58.8 C 378.8 59 377.6 59.2 376.7 59.5 C 376.1 59.7 375.8 60 375.8 60.6 L 375.8 64.5 C 375.8 64.8 375.9 65 376 65.2 C 376.2 65.3 376.4 65.4 376.6 65.4 L 376.8 65.4 C 377.2 65.4 377.7 65.3 378.2 65.3 C 378.8 65.3 379.4 65.2 380.2 65.2 C 380.9 65.2 381.7 65.1 382.5 65.1 C 383.3 65.1 384.1 65.1 384.8 65.1 C 385.9 65.1 386.8 65.3 387.4 65.7 C 388 66.1 388.4 67 388.4 68.4 L 388.4 70.1 L 385.8 70.1 C 381.7 70.1 378.6 70.7 376.8 72 C 375 73.3 374 75.4 374 78.2 L 374 78.6 C 374 80.2 374.2 81.5 374.7 82.5 C 375.2 83.6 375.8 84.4 376.6 85.1 C 377.4 85.7 378.2 86.2 379.2 86.5 C 380.2 86.8 381.2 86.9 382.3 86.9 C 383.7 86.9 385 86.7 386 86.3 C 387 85.9 388 85.4 389 84.7 L 389 85.5 C 389 85.8 389.1 86 389.3 86.2 C 389.5 86.4 389.7 86.5 390 86.5 L 395.4 86.5 C 395.7 86.5 395.9 86.4 396.1 86.2 C 396.3 86 396.4 85.8 396.4 85.5 L 396.4 68.3 L 396.2 68.3 Z M 370.5 85.6 L 370.5 81.8 C 370.5 81.3 370.2 81 369.5 81 L 367.1 81 C 366.4 81 365.9 80.9 365.8 80.6 C 365.6 80.3 365.6 79.7 365.6 78.7 L 365.6 64.7 L 369.5 64.7 C 369.8 64.7 370 64.6 370.2 64.4 C 370.4 64.2 370.5 64 370.5 63.7 L 370.5 59.8 C 370.5 59.5 370.4 59.3 370.2 59.1 C 370 58.9 369.8 58.8 369.5 58.8 L 365.6 58.8 L 365.6 53.8 C 365.6 53.5 365.5 53.3 365.4 53.2 C 365.2 53.1 365 53 364.8 53 L 364.7 53 L 358.9 54 C 358.6 54.1 358.4 54.2 358.2 54.3 C 358 54.5 357.9 54.7 357.9 54.9 L 357.9 58.8 L 354 58.8 C 353.7 58.8 353.5 58.9 353.3 59.1 C 353.1 59.3 353 59.5 353 59.8 L 353 63 C 353 63.3 353.1 63.5 353.3 63.6 C 353.5 63.8 353.7 63.9 354 64 L 357.9 64.6 L 357.9 78.6 C 357.9 80.3 358.1 81.7 358.4 82.8 C 358.8 83.9 359.3 84.7 359.9 85.3 C 360.6 85.9 361.4 86.3 362.4 86.5 C 363.4 86.7 364.6 86.8 365.9 86.8 C 366.6 86.8 367.2 86.8 367.8 86.7 C 368.3 86.6 369 86.5 369.7 86.4 C 370.2 86.4 370.5 86.1 370.5 85.6 M 349.5 85.5 L 349.5 69.5 C 349.5 68 349.4 66.6 349.1 65.2 C 348.9 63.9 348.4 62.7 347.8 61.7 C 347.2 60.7 346.3 59.9 345.2 59.4 C 344.1 58.8 342.7 58.5 340.9 58.5 C 339.4 58.5 338 58.7 336.8 59.1 C 335.6 59.5 334.4 60.1 333 61.1 L 333 59.8 C 333 59.5 332.9 59.3 332.7 59.1 C 332.5 58.9 332.3 58.8 332 58.8 L 326.6 58.8 C 326.3 58.8 326.1 58.9 325.9 59.1 C 325.7 59.3 325.6 59.5 325.6 59.8 L 325.6 85.4 C 325.6 85.7 325.7 85.9 325.9 86.1 C 326.1 86.3 326.3 86.4 326.6 86.4 L 332.4 86.4 C 332.7 86.4 332.9 86.3 333.1 86.1 C 333.3 85.9 333.4 85.7 333.4 85.4 L 333.4 66.5 C 334.2 66.1 335 65.7 335.8 65.4 C 336.5 65.1 337.3 65 338 65 C 338.7 65 339.3 65.1 339.8 65.2 C 340.3 65.3 340.6 65.6 340.9 65.9 C 341.2 66.3 341.3 66.7 341.4 67.3 C 341.5 67.9 341.5 68.6 341.5 69.4 L 341.5 85.4 C 341.5 85.7 341.6 85.9 341.8 86.1 C 342 86.3 342.2 86.4 342.5 86.4 L 348.3 86.4 C 348.6 86.4 348.8 86.3 349 86.1 C 349.4 85.9 349.5 85.7 349.5 85.5 M 313.1 74.4 C 313.1 78.3 311.7 80.3 308.8 80.3 C 307.4 80.3 306.3 79.8 305.6 78.8 C 304.9 77.8 304.5 76.3 304.5 74.4 L 304.5 71 C 304.5 69 304.9 67.6 305.6 66.6 C 306.3 65.6 307.4 65.1 308.8 65.1 C 311.6 65.1 313.1 67.1 313.1 71 L 313.1 74.4 Z M 320.9 71 C 320.9 69.1 320.6 67.3 320.1 65.8 C 319.6 64.3 318.8 63 317.8 61.9 C 316.8 60.8 315.5 60 314 59.4 C 312.5 58.8 310.8 58.5 308.8 58.5 C 306.8 58.5 305.1 58.8 303.6 59.4 C 302.1 60 300.8 60.8 299.8 61.9 C 298.8 63 298 64.3 297.5 65.8 C 297 67.3 296.7 69.1 296.7 71 L 296.7 74.4 C 296.7 76.3 297 78.1 297.5 79.6 C 298 81.1 298.8 82.4 299.8 83.5 C 300.8 84.6 302.1 85.4 303.6 86 C 305.1 86.6 306.8 86.9 308.8 86.9 C 310.8 86.9 312.5 86.6 314 86 C 315.5 85.4 316.8 84.6 317.8 83.5 C 318.8 82.4 319.6 81.1 320.1 79.6 C 320.6 78.1 320.9 76.3 320.9 74.4 L 320.9 71 Z M 294.1 85.1 L 294.1 80.8 C 294.1 80.5 294 80.3 293.8 80.2 C 293.6 80.1 293.4 80 293.1 80 L 293 80 C 292.1 80.1 291.2 80.2 290.4 80.2 C 289.6 80.2 288.5 80.3 287.1 80.3 C 286.6 80.3 286 80.2 285.6 80 C 285.1 79.8 284.7 79.5 284.3 79.1 C 283.9 78.7 283.7 78.1 283.5 77.4 C 283.3 76.7 283.2 75.8 283.2 74.7 L 283.2 70.7 C 283.2 69.6 283.3 68.7 283.5 68 C 283.7 67.3 284 66.7 284.3 66.3 C 284.7 65.9 285.1 65.6 285.6 65.4 C 286.1 65.2 286.6 65.1 287.1 65.1 C 288.5 65.1 289.6 65.1 290.4 65.2 C 291.2 65.3 292.1 65.3 293 65.4 L 293.1 65.4 C 293.4 65.4 293.6 65.3 293.8 65.2 C 294 65.1 294.1 64.9 294.1 64.6 L 294.1 60.3 C 294.1 59.9 294 59.7 293.9 59.6 C 293.7 59.5 293.5 59.3 293.1 59.2 C 292.4 59 291.6 58.9 290.5 58.7 C 289.4 58.5 288.2 58.5 286.7 58.5 C 283.3 58.5 280.6 59.5 278.5 61.6 C 276.5 63.7 275.4 66.7 275.4 70.7 L 275.4 74.7 C 275.4 78.6 276.4 81.7 278.5 83.8 C 280.5 85.9 283.3 86.9 286.7 86.9 C 288.1 86.9 289.4 86.8 290.5 86.7 C 291.6 86.5 292.4 86.4 293.1 86.2 C 293.5 86.1 293.7 86 293.9 85.8 C 294 85.7 294.1 85.4 294.1 85.1 M 270.4 85.5 L 270.4 69.5 C 270.4 68 270.3 66.6 270 65.2 C 269.7 63.8 269.3 62.7 268.7 61.7 C 268.1 60.7 267.2 59.9 266.1 59.4 C 265 58.8 263.6 58.5 261.8 58.5 C 260.3 58.5 258.9 58.7 257.7 59.1 C 256.5 59.5 255.3 60.1 253.9 61.1 L 253.9 59.8 C 253.9 59.5 253.8 59.3 253.6 59.1 C 253.4 58.9 253.2 58.8 252.9 58.8 L 247.5 58.8 C 247.2 58.8 247 58.9 246.8 59.1 C 246.6 59.3 246.5 59.5 246.5 59.8 L 246.5 85.4 C 246.5 85.7 246.6 85.9 246.8 86.1 C 247 86.3 247.2 86.4 247.5 86.4 L 253.3 86.4 C 253.6 86.4 253.8 86.3 254 86.1 C 254.2 85.9 254.3 85.7 254.3 85.4 L 254.3 66.5 C 255.1 66.1 255.9 65.7 256.7 65.4 C 257.4 65.1 258.2 65 258.9 65 C 259.6 65 260.2 65.1 260.7 65.2 C 261.2 65.3 261.5 65.6 261.8 65.9 C 262.1 66.3 262.2 66.7 262.3 67.3 C 262.4 67.9 262.4 68.6 262.4 69.4 L 262.4 85.4 C 262.4 85.7 262.5 85.9 262.7 86.1 C 262.9 86.3 263.1 86.4 263.4 86.4 L 269.2 86.4 C 269.5 86.4 269.7 86.3 269.9 86.1 C 270.3 85.9 270.4 85.7 270.4 85.5 M 233.3 80 C 232.7 80.3 232.1 80.5 231.4 80.7 C 230.7 80.9 230 81 229.3 81 C 228.3 81 227.5 80.9 227 80.6 C 226.5 80.3 226.3 79.7 226.3 78.6 L 226.3 78.2 C 226.3 77.6 226.4 77.1 226.5 76.7 C 226.6 76.3 226.9 75.9 227.2 75.6 C 227.5 75.3 228 75.1 228.5 74.9 C 229 74.8 229.7 74.7 230.6 74.7 L 233.3 74.7 L 233.3 80 L 233.3 80 Z M 241 68.3 C 241 66.5 240.7 65 240.2 63.8 C 239.7 62.6 238.9 61.6 238 60.8 C 237 60 235.9 59.4 234.5 59.1 C 233.1 58.7 231.5 58.5 229.8 58.5 C 228.2 58.5 226.6 58.6 225.1 58.8 C 223.6 59 222.4 59.2 221.5 59.5 C 220.9 59.7 220.6 60 220.6 60.6 L 220.6 64.5 C 220.6 64.8 220.7 65 220.8 65.2 C 221 65.3 221.2 65.4 221.4 65.4 L 221.6 65.4 C 222 65.4 222.5 65.3 223 65.3 C 223.6 65.3 224.2 65.2 225 65.2 C 225.7 65.2 226.5 65.1 227.3 65.1 C 228.1 65.1 228.9 65.1 229.6 65.1 C 230.7 65.1 231.6 65.3 232.2 65.7 C 232.8 66.1 233.2 67 233.2 68.4 L 233.2 70.1 L 230.6 70.1 C 226.5 70.1 223.4 70.7 221.6 72 C 219.8 73.3 218.8 75.4 218.8 78.2 L 218.8 78.6 C 218.8 80.2 219 81.5 219.5 82.5 C 220 83.6 220.6 84.4 221.4 85.1 C 222.2 85.7 223 86.2 224 86.5 C 225 86.8 226 86.9 227.1 86.9 C 228.5 86.9 229.8 86.7 230.8 86.3 C 231.8 85.9 232.8 85.4 233.8 84.7 L 233.8 85.5 C 233.8 85.8 233.9 86 234.1 86.2 C 234.3 86.4 234.5 86.5 234.8 86.5 L 240.2 86.5 C 240.5 86.5 240.7 86.4 240.9 86.2 C 241.1 86 241.2 85.8 241.2 85.5 L 241.2 68.3 L 241 68.3 Z M 206.6 75.9 C 206.6 77.2 206.1 78.3 205.2 79 C 204.3 79.7 202.5 80.1 200.1 80.1 L 199.3 80.1 C 198.9 80.1 198.5 80.1 198.1 80.1 C 197.7 80.1 197.3 80.1 196.9 80.1 L 196.1 80.1 L 196.1 71.1 L 201.5 71.1 C 203.4 71.1 204.8 71.5 205.5 72.4 C 206.2 73.3 206.6 74.3 206.6 75.4 L 206.6 75.9 Z M 206.4 61.6 C 206.4 62.1 206.3 62.6 206.2 63.1 C 206 63.6 205.8 64 205.4 64.3 C 205 64.6 204.5 64.9 203.9 65.1 C 203.3 65.3 202.5 65.4 201.5 65.4 L 196.1 65.4 L 196.1 57.1 C 196.3 57.1 196.5 57.1 196.8 57.1 C 197.1 57.1 197.5 57.1 197.9 57.1 L 199 57.1 L 199.8 57.1 C 202.3 57.1 204 57.4 205 58 C 206 58.6 206.5 59.6 206.5 60.9 L 206.5 61.6 L 206.4 61.6 Z M 214.6 75.4 C 214.6 73.7 214.2 72.3 213.4 71.1 C 212.6 69.9 211.6 68.9 210.3 68.3 C 211.6 67.7 212.6 66.7 213.3 65.5 C 214 64.2 214.4 62.8 214.4 61.3 L 214.4 60.4 C 214.4 58.5 214 56.9 213.3 55.6 C 212.6 54.3 211.5 53.3 210.2 52.5 C 208.9 51.7 207.3 51.2 205.4 50.8 C 203.5 50.5 201.5 50.3 199.2 50.3 C 198.4 50.3 197.6 50.3 196.8 50.3 C 196 50.3 195.2 50.4 194.4 50.4 C 193.6 50.4 192.9 50.5 192.2 50.6 C 191.5 50.7 191 50.7 190.6 50.8 C 189.7 51 189 51.3 188.6 51.7 C 188.2 52.1 188 52.9 188 54 L 188 83.3 C 188 84.4 188.2 85.1 188.6 85.6 C 189 86 189.7 86.3 190.6 86.5 C 191.1 86.6 191.7 86.7 192.3 86.7 C 193 86.8 193.7 86.8 194.5 86.9 C 195.3 86.9 196.1 87 196.9 87 C 197.7 87 198.6 87 199.4 87 C 201.5 87 203.5 86.8 205.3 86.5 C 207.1 86.2 208.7 85.6 210.1 84.8 C 211.5 84 212.5 82.9 213.4 81.5 C 214.2 80.1 214.6 78.3 214.6 76.2 L 214.6 75.4 L 214.6 75.4 Z"
            })));
        }, _fundingLogos[constants.h.GIROPAY] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!GIROPAY_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " giropay logo available");
            var _GIROPAY_LOGO_COLORS$ = GIROPAY_LOGO_COLORS[logoColor], primary = _GIROPAY_LOGO_COLORS$.primary, secondary = _GIROPAY_LOGO_COLORS$.secondary, tertiary = _GIROPAY_LOGO_COLORS$.tertiary;
            return Object(jsx.b)("svg", {
                width: "75px",
                height: "32px",
                viewBox: "0 0 75 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.b)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.614571, 0, 0, 1.614571, -161.457123, -256.816772)"
            }, Object(jsx.b)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.b)("g", {
                transform: "translate(0.000000, 0.144715)"
            }, Object(jsx.b)("mask", {
                fill: primary
            }, Object(jsx.b)("polygon", {
                points: "0 0.017902439 46.0918699 0.017902439 46.0918699 19.8373984 0 19.8373984",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.b)("path", {
                d: "M0,3.5735122 C0,1.60977236 1.5998374,0.017902439 3.57349593,0.017902439 L42.5182114,0.017902439 C44.4918699,0.017902439 46.0918699,1.60977236 46.0918699,3.5735122 L46.0918699,16.2818049 C46.0918699,18.2455447 44.4918699,19.8374146 42.5182114,19.8374146 L3.57349593,19.8374146 C1.5998374,19.8374146 0,18.2455447 0,16.2818049 L0,3.5735122 Z",
                fill: secondary
            })), Object(jsx.b)("path", {
                d: "M1.46738211,3.84021138 L1.46738211,16.3065528 C1.46738211,17.5338699 2.46738211,18.5288293 3.70087805,18.5288293 L24.1036423,18.5288293 L24.1036423,1.61793496 L3.70087805,1.61793496 C2.46738211,1.61793496 1.46738211,2.61289431 1.46738211,3.84021138",
                fill: primary
            }), Object(jsx.b)("path", {
                d: "M5.67102439,10.0205528 C5.67102439,9.34152846 6.00582114,8.77730081 6.64663415,8.77730081 C7.42126829,8.77730081 7.74630894,9.39892683 7.74630894,9.95356098 C7.74630894,10.7187642 7.25866667,11.235187 6.64663415,11.235187 C6.13004878,11.235187 5.67102439,10.795187 5.67102439,10.0205528 Z M9.41053659,7.57226016 L7.8515122,7.57226016 L7.8515122,8.47112195 L7.8324878,8.47112195 C7.46907317,7.85908943 6.87606504,7.45746341 6.13964228,7.45746341 C4.59021138,7.45746341 3.8921626,8.56689431 3.8921626,10.0491707 C3.8921626,11.5221789 4.74321951,12.5550244 6.11102439,12.5550244 C6.79964228,12.5550244 7.37346341,12.2872195 7.78468293,11.7038049 L7.80370732,11.7038049 L7.80370732,11.9716098 C7.80370732,12.9472195 7.26826016,13.4158374 6.27362602,13.4158374 C5.55622764,13.4158374 5.11622764,13.2628293 4.59021138,13.0046179 L4.50419512,14.3626667 C4.90582114,14.5060813 5.58500813,14.6782764 6.40744715,14.6782764 C8.41590244,14.6782764 9.41053659,14.0182764 9.41053659,11.9716098 L9.41053659,7.57226016 Z",
                fill: tertiary
            }), Object(jsx.b)("mask", {
                fill: primary
            }, Object(jsx.b)("polygon", {
                points: "0 19.9821138 46.0918699 19.9821138 46.0918699 0.162601626 0 0.162601626",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.b)("path", {
                d: "M10.5985366,6.75918699 L12.32,6.75918699 L12.32,5.49674797 L10.5985366,5.49674797 L10.5985366,6.75918699 Z M10.598374,12.5549593 L12.3198374,12.5549593 L12.3198374,7.57219512 L10.598374,7.57219512 L10.598374,12.5549593 Z",
                id: "Fill-8",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M17.1133333,7.51479675 C16.9411382,7.48617886 16.7307317,7.45739837 16.5299187,7.45739837 C15.7839024,7.45739837 15.3534959,7.85918699 15.0570732,8.4904065 L15.0380488,8.4904065 L15.0380488,7.57219512 L13.4694309,7.57219512 L13.4694309,12.5549593 L15.1910569,12.5549593 L15.1910569,10.4508943 C15.1910569,9.47544715 15.6404878,8.89203252 16.4439024,8.89203252 C16.6447154,8.89203252 16.835935,8.89203252 17.0273171,8.94943089 L17.1133333,7.51479675 Z",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M20.0773496,11.4647154 C19.2835285,11.4647154 18.9583252,10.804878 18.9583252,10.0682927 C18.9583252,9.32243902 19.2835285,8.66243902 20.0773496,8.66243902 C20.8711707,8.66243902 21.196374,9.32243902 21.196374,10.0682927 C21.196374,10.804878 20.8711707,11.4647154 20.0773496,11.4647154 M20.0773496,12.6697561 C21.7223902,12.6697561 22.9752358,11.7133333 22.9752358,10.0682927 C22.9752358,8.41382114 21.7223902,7.45739837 20.0773496,7.45739837 C18.4323089,7.45739837 17.1794634,8.41382114 17.1794634,10.0682927 C17.1794634,11.7133333 18.4323089,12.6697561 20.0773496,12.6697561",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M29.3757073,10.0110244 C29.3757073,10.8048455 28.9836748,11.3500488 28.3332683,11.3500488 C27.7594472,11.3500488 27.2812358,10.8048455 27.2812358,10.0780163 C27.2812358,9.332 27.7020488,8.77720325 28.3332683,8.77720325 C29.0026992,8.77720325 29.3757073,9.35102439 29.3757073,10.0110244 Z M25.5597724,14.5633821 L27.2812358,14.5633821 L27.2812358,11.856878 L27.3002602,11.856878 C27.6254634,12.4498862 28.2758699,12.6697236 28.8783089,12.6697236 C30.360748,12.6697236 31.1545691,11.4456585 31.1545691,9.97265041 C31.1545691,8.76777236 30.399122,7.45736585 29.0218862,7.45736585 C28.2376585,7.45736585 27.5106667,7.77297561 27.166439,8.47118699 L27.147252,8.47118699 L27.147252,7.5721626 L25.5597724,7.5721626 L25.5597724,14.5633821 Z",
                id: "Fill-12",
                fill: primary,
                mask: "url(#mask-4)"
            }), Object(jsx.b)("path", {
                d: "M33.505252,10.9769919 C33.505252,10.4987805 33.9642764,10.3169919 34.5476911,10.3169919 C34.8059024,10.3169919 35.0546829,10.3361789 35.2745203,10.3457724 C35.2745203,10.929187 34.8633008,11.5221951 34.2128943,11.5221951 C33.8112683,11.5221951 33.505252,11.3212195 33.505252,10.9769919 Z M36.9769593,12.5550407 C36.900374,12.1628455 36.8813496,11.770813 36.8813496,11.3786179 L36.8813496,9.52317073 C36.8813496,8.00252033 35.7815122,7.45747967 34.5094797,7.45747967 C33.7730569,7.45747967 33.1322439,7.56268293 32.5202114,7.81130081 L32.5488293,8.97813008 C33.0270407,8.7103252 33.5816748,8.60512195 34.1364715,8.60512195 C34.7580976,8.60512195 35.2650894,8.78674797 35.2745203,9.46577236 C35.0546829,9.42756098 34.7485041,9.39894309 34.4711057,9.39894309 C33.5530569,9.39894309 31.8984228,9.58056911 31.8984228,11.1013821 C31.8984228,12.1820325 32.7784228,12.6698374 33.7634634,12.6698374 C34.4711057,12.6698374 34.9493171,12.392439 35.3415122,11.770813 L35.3606992,11.770813 C35.3606992,12.0290244 35.3893171,12.2872358 35.3989106,12.5550407 L36.9769593,12.5550407 Z",
                fill: primary
            }), Object(jsx.b)("path", {
                d: "M37.750748,14.5634634 C38.1045691,14.6398862 38.4583902,14.6782602 38.8218049,14.6782602 C40.3998537,14.6782602 40.7728618,13.463626 41.2606667,12.2107805 L43.0873333,7.5722439 L41.3658699,7.5722439 L40.3426179,10.8239512 L40.3234309,10.8239512 L39.2522114,7.5722439 L37.3967642,7.5722439 L39.414813,12.6698049 C39.2904228,13.1098049 38.9653821,13.3584228 38.5445691,13.3584228 C38.3053821,13.3584228 38.0949756,13.3296423 37.8655447,13.2532195 L37.750748,14.5634634 Z",
                fill: primary
            }))));
        }, _fundingLogos[constants.h.SOFORT] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!SOFORT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " sofort logo available");
            var _SOFORT_LOGO_COLORS$l = SOFORT_LOGO_COLORS[logoColor], primary = _SOFORT_LOGO_COLORS$l.primary, secondary = _SOFORT_LOGO_COLORS$l.secondary;
            return Object(jsx.b)("svg", {
                width: "138px",
                height: "32px",
                viewBox: "0 0 138 44",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.b)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.b)("g", {
                transform: "translate(-24.000000, -436.000000)"
            }, Object(jsx.b)("g", {
                transform: "translate(24.000000, 436.000000)"
            }, Object(jsx.b)("g", {
                "stroke-width": "1"
            }, Object(jsx.b)("g", {
                mask: "url(#mask-2)",
                "fill-rule": "evenodd",
                fill: primary
            }, Object(jsx.b)("rect", {
                x: "0",
                y: "0",
                width: "138",
                height: "44"
            })), Object(jsx.b)("g", {
                transform: "translate(16.000000, 5.000000)",
                "fill-rule": "nonzero",
                fill: secondary
            }, Object(jsx.b)("path", {
                d: "M8.55107133,24.0386247 C9.22879411,24.6861671 9.24327745,25.7425763 8.58354713,26.4073957 L8.45110904,26.5423627 C7.79086355,27.1983175 6.69897696,27.2144066 6.01224032,26.5722566 L2.17289107,22.8768054 C1.11590922,21.8458618 0.96410333,20.5754632 1.63678914,19.9042365 L1.77159366,19.7668966 C2.32598975,19.2126062 3.22970309,19.1541252 3.86016464,19.6360673 C4.15990129,19.8651943 4.59424066,19.8150784 4.83028878,19.5241303 C5.0663369,19.2331822 5.01470714,18.8115781 4.7149705,18.5824512 C3.5284497,17.675442 1.82767241,17.7855026 0.775688111,18.8373698 L0.64137931,18.9742146 C-0.604692328,20.2175294 -0.354282964,22.3130983 1.19683948,23.8259789 L5.04656839,27.5313427 C6.28726435,28.6915831 8.24857838,28.6626828 9.44549924,27.4733999 L9.58132339,27.3350447 C10.7636633,26.1435999 10.7376475,24.2460125 9.52028002,23.0828568 C9.24837962,22.8230647 8.81099605,22.8264175 8.54335646,23.0903455 C8.27571687,23.3542735 8.27917094,23.7788325 8.55107133,24.0386247 Z"
            }), Object(jsx.b)("path", {
                d: "M6.25316137,4.00463901 L7.82450265,16.5582851 C7.87051944,16.9259191 8.21485204,17.1877352 8.59359104,17.1430676 C8.97233003,17.0984001 9.24205468,16.7641637 9.19603789,16.3965297 L7.61982167,3.8039371 L7.60423898,3.7221812 C7.33535457,2.67817937 8.00377183,1.50751858 8.89431251,1.32322405 C9.39350944,1.21977105 9.9143927,1.3151232 10.3403167,1.58785163 C10.7662406,1.86058007 11.0615522,2.28785533 11.1600097,2.7738347 L13.8959914,14.1304918 C13.9828807,14.4910975 14.3544774,14.7150537 14.7259757,14.6307121 C15.097474,14.5463704 15.3281952,14.1856693 15.2413059,13.8250637 L12.5104951,2.49173037 C12.3457557,1.67638792 11.8361294,0.939028727 11.1011021,0.468374716 C10.3660749,-0.00227929421 9.46717414,-0.16683078 8.60603358,0.0116310396 C6.93120471,0.358231477 5.83076908,2.26447015 6.25316137,4.00463901 Z"
            }), Object(jsx.b)("path", {
                d: "M20.6946385,18.7562157 L23.8016655,3.70806757 C24.1627527,2.08823591 23.171098,0.461930237 21.5243733,-0.0131380565 C19.6806639,-0.465927398 17.8331452,0.588982967 17.3518411,2.34622562 L13.9119445,13.7963592 C13.8051409,14.1518899 14.01548,14.5241472 14.3817501,14.6278193 C14.7480201,14.7314913 15.1315221,14.5273196 15.2383257,14.1717889 L18.6826501,2.70623335 C18.9740354,1.64312835 20.0755418,1.01418179 21.1583367,1.27975309 C22.0849843,1.54768368 22.6596154,2.49007404 22.4491321,3.43451398 L19.3399561,18.4926732 C19.2649826,18.8557898 19.5074605,19.20915 19.8815457,19.2819253 C20.2556309,19.3547006 20.6196649,19.1193324 20.6946385,18.7562157 Z"
            }), Object(jsx.b)("path", {
                d: "M12.8691892,33.2538889 C7.94394615,33.2538889 3.83027027,29.7443025 3.83027027,24.757037 C3.83027027,24.3866994 3.52098374,24.0864815 3.13945946,24.0864815 C2.75793518,24.0864815 2.44864865,24.3866994 2.44864865,24.757037 C2.44864865,30.5262551 7.21772847,34.595 12.8691892,34.595 C13.2507135,34.595 13.56,34.2947821 13.56,33.9244444 C13.56,33.5541068 13.2507135,33.2538889 12.8691892,33.2538889 Z"
            }), Object(jsx.b)("path", {
                d: "M10.432735,21.523985 C10.32527,21.8997898 10.0848456,22.2268322 9.75367873,22.4476857 L9.6059963,22.5431752 C8.81135162,23.0620226 7.73737824,22.860771 7.20041193,22.0943828 L4.18000129,17.7280455 C3.35596459,16.5133712 3.46371228,15.2353866 4.25688098,14.7069262 L4.40481451,14.6112693 C5.42222949,14.0388226 6.28666557,14.4731364 7.17531296,15.7298428 L9.70102318,19.3822431 C9.91366027,19.6897297 10.3428334,19.7716746 10.6596081,19.5652723 C10.9763829,19.3588699 11.0608031,18.9422806 10.848166,18.634794 L8.31843628,14.9766458 C7.06906995,13.2097547 5.52101546,12.4319743 3.67452351,13.4735669 L3.48275305,13.5961381 C1.99799965,14.5853027 1.82065576,16.6887608 3.02954142,18.4706511 L6.05567438,22.8452879 C7.02249844,24.2252138 8.95163568,24.5867144 10.3747579,23.6575027 L10.5280578,23.5583063 C11.1349164,23.1536749 11.5696876,22.5622681 11.7640218,21.8826817 C11.8660652,21.5258361 11.650769,21.1562586 11.2831443,21.0572072 C10.9155196,20.9581559 10.5347784,21.1671394 10.432735,21.523985 Z"
            }), Object(jsx.b)("path", {
                d: "M15.0071132,23.7451482 C13.5716937,24.5235597 12.6792061,25.9892512 12.5683793,28.2063913 C12.5498892,28.5762937 12.8438232,28.8907086 13.2248991,28.9086565 C13.6059751,28.9266044 13.9298874,28.6412889 13.9483774,28.2713865 C14.048744,26.2635083 14.8525076,25.179561 16.152515,24.704555 C16.8482268,24.4503509 17.6046979,24.3996276 18.2711038,24.4684707 C18.3606758,24.477724 18.4201821,24.4863334 18.4442402,24.4906858 C19.3337661,24.6516105 19.6045203,23.3685934 18.7214531,23.1770635 L13.4090206,22.0248413 C10.9225036,21.3638621 10.5472361,20.4704561 11.0076227,18.9808309 C11.2064187,18.3317669 11.6147718,17.9986147 12.2306776,17.865687 C12.6373189,17.7779238 13.0941226,17.7888366 13.5282841,17.8626882 C13.6538003,17.8840387 13.7420731,17.9043308 13.7811352,17.9152244 L21.8451208,19.7433694 C21.8985237,19.7533496 21.9361525,19.763479 22.0020154,19.7924494 C22.1354002,19.8511201 22.2742678,19.9453829 22.4097247,20.0858789 C22.9502905,20.6465543 23.2485509,21.7041959 23.09758,23.4414127 C22.571614,29.5314735 19.6483005,33.3130406 12.7195863,33.2539148 C12.3380768,33.2506592 12.0260833,33.5482264 12.0227294,33.9185497 C12.0193755,34.288873 12.3259312,34.5917185 12.7074407,34.5949741 C20.4944029,34.6614237 23.8949457,30.262518 24.474342,23.5537955 C24.6558214,21.4655214 24.2521788,20.0341915 23.4184922,19.1694909 C22.9588119,18.69271 22.4737204,18.4793376 22.1015974,18.4267977 L14.1289333,16.6177417 C14.0788208,16.6028791 13.9434651,16.5717637 13.7667652,16.5417067 C13.169132,16.4400483 12.5401983,16.4250234 11.9308051,16.5565455 C10.8493625,16.7899475 10.0333579,17.4556796 9.68377867,18.5970598 C9.0191343,20.7475737 9.72889785,22.4373206 13.0761134,23.3260543 L15.0071132,23.7451482 Z"
            }))), Object(jsx.b)("path", {
                d: "M60.72,30.286 C63.712,30.286 66,28.284 66,25.336 C66,22.608 64.064,21.42 61.688,20.716 C60.17,20.276 59.224,19.946 59.224,18.868 C59.224,17.966 59.884,17.262 60.918,17.262 C61.798,17.262 62.458,17.768 62.92,18.538 L65.406,16.976 C64.636,15.26 62.898,14.38 61.006,14.38 C58.014,14.38 56.122,16.536 56.122,19.022 C56.122,21.002 57.31,22.542 60.258,23.4 C61.864,23.862 62.876,24.17 62.876,25.446 C62.876,26.634 62.018,27.382 60.764,27.382 C59.422,27.382 58.41,26.524 57.794,25.732 L55.726,27.822 C56.826,29.318 58.63,30.286 60.72,30.286 Z M73.546,30.286 C70.378,30.286 67.804,27.756 67.804,24.676 C67.804,21.596 70.378,19.066 73.546,19.066 C76.714,19.066 79.288,21.596 79.288,24.676 C79.288,27.756 76.714,30.286 73.546,30.286 Z M73.546,27.47 C75.086,27.47 76.296,26.26 76.296,24.676 C76.296,23.092 75.086,21.882 73.546,21.882 C72.006,21.882 70.796,23.092 70.796,24.676 C70.796,26.26 72.006,27.47 73.546,27.47 Z M87.428,17.416 L87.428,14.6 L86.988,14.6 C83.336,14.6 81.554,17.02 81.554,19.88 L81.554,30 L84.546,30 L84.546,25.556 C84.546,24.082 85.69,23.026 87.34,22.982 L87.34,20.122 C86.152,20.122 85.206,20.474 84.546,21.178 L84.546,20.034 C84.546,18.186 85.756,17.35 87.428,17.416 Z M95.018,30.286 C91.85,30.286 89.276,27.756 89.276,24.676 C89.276,21.596 91.85,19.066 95.018,19.066 C98.186,19.066 100.76,21.596 100.76,24.676 C100.76,27.756 98.186,30.286 95.018,30.286 Z M95.018,27.47 C96.558,27.47 97.768,26.26 97.768,24.676 C97.768,23.092 96.558,21.882 95.018,21.882 C93.478,21.882 92.268,23.092 92.268,24.676 C92.268,26.26 93.478,27.47 95.018,27.47 Z M106.018,20.562 L106.018,19.352 L103.114,19.352 L103.114,30 L106.106,30 L106.106,25.138 C106.106,23.378 107.14,22.388 108.944,22.388 L108.944,19.176 C107.58,19.132 106.612,19.594 106.018,20.562 Z M114.378,24.566 L114.378,21.97 C115.038,22.674 115.984,23.026 117.172,23.026 L117.172,20.166 C115.544,20.122 114.378,19.044 114.378,17.592 L114.378,15.92 L111.386,15.92 L111.386,24.72 C111.386,27.58 113.168,30 116.82,30 L117.26,30 L117.26,27.184 C115.588,27.25 114.378,26.414 114.378,24.566 Z M121.572,30.176 C122.672,30.176 123.574,29.274 123.574,28.174 C123.574,27.074 122.672,26.172 121.572,26.172 C120.472,26.172 119.57,27.074 119.57,28.174 C119.57,29.274 120.472,30.176 121.572,30.176 Z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.EPS] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!EPS_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " eps logo available");
            var _EPS_LOGO_COLORS$logo = EPS_LOGO_COLORS[logoColor], primary = _EPS_LOGO_COLORS$logo.primary, secondary = _EPS_LOGO_COLORS$logo.secondary, tertiary = _EPS_LOGO_COLORS$logo.tertiary;
            return Object(jsx.b)("svg", {
                width: "52px",
                height: "32px",
                viewBox: "0 0 52 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.b)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.333759, 0, 0, 1.333759, 0.000008, -0.000005)"
            }, Object(jsx.b)("g", {
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.b)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.b)("path", {
                d: "M30.5812744,12.0000152 L27.4748661,12.0000152 C27.129394,12.0000152 26.8482796,11.7245987 26.8482796,11.3798207 C26.8482796,11.0350427 27.129394,10.7315163 27.4748661,10.7315163 L32.2041612,10.7315163 L32.2041612,8.39747822 L27.4748661,8.39747822 C25.824238,8.39747822 24.4812484,9.74381226 24.4812484,11.3911357 C24.4812484,13.0384592 25.824238,14.3847932 27.4748661,14.3847932 L30.5390793,14.3847932 C30.8846021,14.3847932 31.1657165,14.6590934 31.1657165,15.0038715 C31.1657165,15.3486495 30.8846021,15.6025522 30.5390793,15.6025522 L23.9683147,15.6025522 C23.4104473,16.6680913 22.8679974,17.5814106 21.7668179,18.0380702 L30.5812744,18.0380702 C32.2041612,18.0146791 33.5316827,16.6405903 33.5316827,15.0078292 C33.5316827,13.3751696 32.2041612,12.0234063 30.5812744,12.0000152",
                fill: primary
            }), Object(jsx.b)("path", {
                d: "M18.6731848,15.6025522 L16.2795788,15.6025522 L16.2795788,13.1992034 C16.2795788,11.8562182 17.3483005,10.7635839 18.6731848,10.7635839 C19.9980691,10.7635839 21.0759195,11.8562182 21.0759195,13.1992034 C21.0759195,14.5422393 19.9980691,15.6025522 18.6731848,15.6025522 M18.6731848,8.39747822 C16.0403551,8.39747822 13.8959637,10.5557023 13.8959637,13.2076262 L13.8959637,13.3091061 L13.8959637,23.2135459 L16.2795788,23.2135459 L16.2795788,18.0380702 L18.6682147,18.0380702 C21.3010951,18.0380702 23.4379299,15.8511273 23.4379299,13.1992034 C23.4379299,10.5472795 21.3060651,8.39747822 18.6731848,8.39747822",
                fill: primary
            }), Object(jsx.b)("g", {
                transform: "translate(0.000000, 6.842233)"
            }, Object(jsx.b)("mask", {
                fill: secondary
            }, Object(jsx.b)("polygon", {
                points: "0 0.0330469345 12.6787834 0.0330469345 12.6787834 12.7180364 0 12.7180364",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.b)("path", {
                d: "M6.34967672,11.1958376 C4.09589259,11.1958376 2.20112146,9.58905539 1.68833992,7.48994334 C1.68833992,7.48994334 1.54020078,6.7959222 1.54020078,6.3389074 C1.54020078,5.8818926 1.68042835,5.18071712 1.68042835,5.18071712 C2.19686138,3.08678055 4.08935033,1.52754165 6.33943225,1.52754165 C8.98580286,1.52754165 11.1573269,3.67982918 11.1573269,6.32744017 L11.1573269,7.49182072 L4.12642315,7.49182072 C4.54162861,8.30366004 5.38137113,8.76031966 6.34967672,8.76031966 L12.6701111,8.76031966 L12.6787834,1.89423932 C12.6787834,0.870560677 11.8417287,0.0330469345 10.8185493,0.0330469345 L1.86031521,0.0330469345 C0.837135761,0.0330469345 -2.02860858e-05,0.845190698 -2.02860858e-05,1.86886934 L-2.02860858e-05,10.831474 C-2.02860858e-05,11.8551526 0.837135761,12.7180364 1.86031521,12.7180364 L10.8185493,12.7180364 C11.7367482,12.7180364 12.5027001,12.0584169 12.6506871,11.1958376 L6.34967672,11.1958376 Z",
                fill: tertiary
            })), Object(jsx.b)("path", {
                d: "M6.33943732,10.6481099 C5.37483394,10.6481099 4.53595358,11.238926 4.11907451,12.0000254 L8.55990156,12.0000254 C8.1430225,11.238926 7.30419285,10.6481099 6.33943732,10.6481099",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M10.396619,3.96072558 C10.396619,1.77327526 8.57959428,1.52219873e-05 6.33823537,1.52219873e-05 C4.134,1.52219873e-05 2.34126788,1.71527949 2.28238752,3.85259873 C2.28142393,3.86163044 2.28218466,3.87040846 2.28218466,3.87969387 L2.28218466,5.0699518 C2.28218466,5.21232812 2.39806892,5.35308076 2.54392588,5.35308076 L4.03703251,5.35308076 C4.18288947,5.35308076 4.31079324,5.21232812 4.31079324,5.0699518 L4.31079324,3.96072558 C4.31079324,2.86839577 5.22011704,1.97968541 6.33940182,1.97968541 C7.45868661,1.97968541 8.3680104,2.86839577 8.3680104,3.96072558 L8.3680104,5.0699518 C8.3680104,5.21232812 8.486329,5.35308076 8.63218596,5.35308076 L10.1253433,5.35308076 C10.2712003,5.35308076 10.396619,5.21232812 10.396619,5.0699518 L10.396619,3.96072558 Z",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M20.7598572,20.7474063 C20.7598572,20.8523366 20.8407987,20.9002858 20.9277753,20.9002858 C21.0206856,20.9002858 21.1436192,20.8253429 21.1436192,20.687381 C21.1436192,20.5884888 21.0716036,20.5345015 20.9907129,20.5345015 C20.8827909,20.5345015 20.7598572,20.6034063 20.7598572,20.7474063 Z M20.0403098,20.7504 C20.0403098,20.8523366 20.1183098,20.9002858 20.2022434,20.9002858 C20.3071732,20.9002858 20.4211303,20.8253429 20.4211303,20.6843873 C20.4211303,20.5854444 20.3550991,20.5345015 20.2681732,20.5345015 C20.160302,20.5345015 20.0403098,20.6034063 20.0403098,20.7504 Z M21.3474437,21.133233 L21.1315997,22.3559645 C21.0236778,22.9739772 20.6189196,23.2570047 20.0702824,23.2570047 C19.6056296,23.2570047 19.2458559,22.9539856 19.3508364,22.3569793 L19.5666296,21.133233 L19.8994736,21.133233 L19.6835282,22.3559645 C19.6175984,22.7370723 19.7885087,22.9540364 20.1122746,22.9540364 C20.4450679,22.9540364 20.7298845,22.7559983 20.7988065,22.3569793 L21.0146505,21.133233 L21.3474437,21.133233 Z",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M21.9179189,22.5590867 C21.9059501,22.8050233 22.0647901,22.9639915 22.2956458,22.9639915 C22.5864468,22.9639915 22.8682205,22.7389598 22.8862244,22.3971247 C22.898244,22.1481438 22.736361,22.0011501 22.511439,22.0011501 C22.2236302,22.0011501 21.9358213,22.2321691 21.9179189,22.5590867 Z M22.1517667,21.1331924 L22.0018525,21.9781142 C22.1307199,21.8042283 22.388556,21.7122368 22.5684429,21.7122368 C22.9401854,21.7122368 23.1980216,21.9302156 23.1980216,22.3350698 C23.1980216,22.9079746 22.7992479,23.2524989 22.2896614,23.2524989 C22.0917706,23.2524989 21.9238525,23.178926 21.8219657,22.9930148 L21.7650125,23.2135307 L21.4741607,23.2135307 L21.8429111,21.1331924 L22.1517667,21.1331924 Z",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M24.7516112,22.3509666 C24.7755995,22.0972668 24.6256853,21.994011 24.3768257,21.994011 C24.1520559,21.994011 23.9451886,22.0972668 23.8551691,22.3509666 L24.7516112,22.3509666 Z M23.804251,22.6046664 C23.7922315,22.8076262 23.9511222,22.9733429 24.2209779,22.9733429 C24.3708921,22.9733429 24.5686814,22.9146875 24.6766034,22.812751 L24.8445215,23.006882 C24.6616931,23.1747298 24.3918375,23.2582985 24.1640247,23.2582985 C23.7383212,23.2582985 23.4894616,23.0032288 23.4894616,22.6132922 C23.4894616,22.0943746 23.8971612,21.7076854 24.4188179,21.7076854 C24.895541,21.7076854 25.1653459,21.9957869 25.0034629,22.6046664 L23.804251,22.6046664 Z",
                id: "Fill-16",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M25.8283814,21.7420871 L25.8133697,21.9376896 C25.9573502,21.7485311 26.131202,21.7099687 26.290042,21.7099687 C26.4339718,21.7099687 26.5628391,21.7610638 26.6318118,21.8360068 L26.4459913,22.1059941 C26.3800108,22.0461717 26.314081,22.0161844 26.2001239,22.0161844 C25.9872215,22.0161844 25.7774633,22.1438968 25.729436,22.4168778 L25.5885999,23.2135459 L25.2797442,23.2135459 L25.5405726,21.7420871 L25.8283814,21.7420871 Z",
                fill: tertiary
            }), Object(jsx.b)("polygon", {
                fill: tertiary,
                points: "28.1192941 21.7420871 28.275142 22.9057573 28.8387909 21.7420871 29.1835529 21.7420871 28.4100952 23.2135459 28.0473293 23.2135459 27.900458 22.2428397 27.6635672 22.7250723 27.4057818 23.2135459 27.0460081 23.2135459 26.7851797 21.7420871 27.1329847 21.7420871 27.285891 22.9057573 27.8524307 21.7420871"
            }), Object(jsx.b)("path", {
                d: "M30.5274503,22.3509666 C30.5513879,22.0972668 30.4015244,21.994011 30.1526649,21.994011 C29.9278951,21.994011 29.7210277,22.0972668 29.6310082,22.3509666 L30.5274503,22.3509666 Z M29.5800901,22.6046664 C29.5680706,22.8076262 29.7269614,22.9733429 29.996817,22.9733429 C30.1467312,22.9733429 30.3445205,22.9146875 30.4524425,22.812751 L30.6203606,23.006882 C30.4375322,23.1747298 30.1676766,23.2582985 29.9398638,23.2582985 C29.5141603,23.2582985 29.2653008,23.0032288 29.2653008,22.6132922 C29.2653008,22.0943746 29.6730004,21.7076854 30.1946571,21.7076854 C30.6713801,21.7076854 30.941185,21.9957869 30.7793021,22.6046664 L29.5800901,22.6046664 Z",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M31.3524449,21.3412364 C31.3524449,21.4461666 31.4304449,21.5003569 31.5144293,21.5003569 C31.63432,21.5003569 31.7452342,21.4222173 31.7452342,21.2753759 C31.7452342,21.1762808 31.6702264,21.119249 31.5892849,21.119249 C31.4783707,21.119249 31.3524449,21.1913505 31.3524449,21.3412364 Z M31.625242,21.742082 L31.3645151,23.2135408 L31.0556594,23.2135408 L31.3164878,21.742082 L31.625242,21.742082 Z",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M32.9955925,22.1060753 C32.8996393,21.9981006 32.7767563,21.9681133 32.629885,21.9681133 C32.4259085,21.9681133 32.2820801,22.0371704 32.2820801,22.1661006 C32.2820801,22.2740753 32.398928,22.3191831 32.5728811,22.3341006 C32.8426861,22.3580499 33.1874481,22.4481133 33.1154832,22.8290182 C33.0645651,23.1049421 32.7887251,23.266904 32.4049631,23.266904 C32.1651815,23.266904 31.9342752,23.2129167 31.7784273,22.9939738 L31.9792596,22.7750309 C32.0901737,22.9279104 32.2850723,22.9909801 32.4589241,22.9939738 C32.6057953,22.9939738 32.7797485,22.9399865 32.806729,22.8020245 C32.8337095,22.6700499 32.7167602,22.619107 32.5009163,22.5979992 C32.2490645,22.5739992 31.9733259,22.481145 31.9733259,22.202126 C31.9733259,21.833145 32.3719475,21.7042148 32.6718265,21.7042148 C32.8996393,21.7042148 33.0675573,21.7551577 33.2055027,21.9022021 L32.9955925,22.1060753 Z",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M33.9703034,21.7420871 L33.8294672,22.534493 C33.7844828,22.7865184 33.8984399,22.9606579 34.1562254,22.9606579 C34.3990498,22.9606579 34.6059172,22.7593725 34.6478079,22.5134359 L34.7827104,21.7420871 L35.0915153,21.7420871 L34.8307884,23.2135459 L34.5519562,23.2135459 L34.5729016,23.0003366 C34.3990498,23.1652922 34.2280888,23.2430765 34.0213229,23.2430765 C33.658557,23.2430765 33.442713,22.982882 33.5206116,22.5361167 L33.6615492,21.7420871 L33.9703034,21.7420871 Z",
                fill: tertiary
            }), Object(jsx.b)("path", {
                d: "M36.4472345,23.2135459 L36.588172,22.4259603 C36.633055,22.1709412 36.5462813,22.0020279 36.2644061,22.0020279 C36.0185895,22.0020279 35.8116207,22.199863 35.7697299,22.4428059 L35.6348274,23.2135459 L35.3260225,23.2135459 L35.5869016,21.7420871 L35.8686246,21.7420871 L35.8476792,21.957123 C36.0185895,21.7981548 36.1953827,21.7197615 36.3872384,21.7197615 C36.7470121,21.7197615 36.9809614,21.9701632 36.9000199,22.4231696 L36.7590823,23.2135459 L36.4472345,23.2135459 Z",
                fill: tertiary
            }), Object(jsx.b)("g", {
                transform: "translate(37.174252, 21.709040)"
            }, Object(jsx.b)("mask", {
                fill: secondary
            }, Object(jsx.b)("polygon", {
                points: "0.0103575649 0.00128879493 1.81575683 0.00128879493 1.81575683 2.2832981 0.0103575649 2.2832981",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.b)("path", {
                d: "M0.406639662,0.85909852 C0.406639662,1.11092093 0.571514824,1.26400338 0.808507022,1.26400338 C1.44691014,1.26400338 1.61787113,0.2832 0.979214434,0.2832 C0.676444603,0.2832 0.406639662,0.508028753 0.406639662,0.85909852 Z M0.319663069,1.70747061 C0.298717685,1.91043044 0.45456554,1.9925277 0.715495319,1.9925277 C0.943358778,1.9925277 1.18922614,1.86522114 1.24617932,1.54134799 L1.291113,1.288663 C1.15621053,1.4776186 0.910343173,1.55220634 0.72756554,1.55220634 C0.349686476,1.55220634 0.085916645,1.32717463 0.085916645,0.91912389 C0.085916645,0.337339535 0.517553836,0.00128879493 1.00619493,0.00128879493 C1.21316372,0.00128879493 1.39903498,0.099572093 1.46501547,0.267572093 L1.51598427,0.0330520085 L1.8157619,0.0330520085 L1.55787503,1.54824863 C1.46202328,2.1092296 1.04524564,2.28331839 0.664526528,2.28331839 C0.208748895,2.28331839 -0.0429507152,2.06265032 0.0198854356,1.70747061 L0.319663069,1.70747061 Z",
                fill: tertiary
            }))))));
        }, _fundingLogos[constants.h.MYBANK] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!MYBANK_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " mybank logo available");
            var _MYBANK_LOGO_COLORS$l = MYBANK_LOGO_COLORS[logoColor], primary = _MYBANK_LOGO_COLORS$l.primary, secondary = _MYBANK_LOGO_COLORS$l.secondary, tertiary = _MYBANK_LOGO_COLORS$l.tertiary;
            return Object(jsx.b)("svg", {
                width: "58px",
                height: "32px",
                viewBox: "0 0 58 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.b)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.333867, 0, 0, 1.333867, -0.00001, -0.00321)"
            }, Object(jsx.b)("g", {
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.b)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.b)("path", {
                d: "M29.010016,14.6206556 C29.010016,14.6206556 27.947442,14.8389924 27.9585564,14.0777038 C27.9698571,13.3164773 29.8942008,13.3619719 30.0914038,13.4236258 C30.0914038,13.4236258 30.1519432,14.2874637 29.010016,14.6206556 M29.3297879,9.81836571 C27.677716,9.80301439 26.9053582,10.753926 26.9053582,10.753926 C26.4037199,11.2864986 26.7253546,12.0076376 27.2173686,12.0597202 C27.924406,12.1345501 27.9170171,11.5413802 29.0022546,11.2784811 C29.9542434,11.0477763 29.9954723,11.9305703 29.9954723,11.9305703 C25.9352386,11.8295126 26.1290887,15.239929 27.5113104,15.9642377 C28.8367183,16.658714 30.0756326,15.7825701 30.0756326,15.7825701 C30.0756326,15.7825701 30.1222013,16.2545455 30.777951,16.2545455 C31.5283904,16.2545455 31.5272727,15.5049412 31.5272727,15.5049412 L31.5242302,12.1853897 C31.4748674,9.75671183 29.3297879,9.81836571 29.3297879,9.81836571",
                id: "Fill-1",
                fill: primary
            }), Object(jsx.b)("path", {
                d: "M42.4169651,14.9132636 L40.766254,12.4266353 L41.9794586,11.2784792 C41.9794586,11.2784792 42.5394372,10.7597112 42.0797024,10.2455911 C41.5701862,9.67606803 40.9629029,10.2382165 40.9629029,10.2382165 L39.4383789,11.6556411 L39.4383789,8.81056644 C39.4383789,8.40291433 39.1083605,8.07272727 38.7011934,8.07272727 C38.2936547,8.07272727 37.9636364,8.40291433 37.9636364,8.81056644 L37.9636364,15.5050966 C37.9636364,15.9126248 38.2936547,16.2429358 38.7011934,16.2429358 C39.1083605,16.2429358 39.4383789,15.9126248 39.4383789,15.5050966 L39.4383789,13.7227806 L39.7172538,13.4440304 L41.2106953,15.7865117 C41.2106953,15.7865117 41.697426,16.5998328 42.4143027,16.0821803 C42.9532914,15.6931198 42.4169651,14.9132636 42.4169651,14.9132636",
                fill: primary
            }), Object(jsx.b)("path", {
                d: "M37.0887651,12.0920353 C37.0887651,9.6760941 35.0962232,9.33568291 33.7411943,10.1020724 C33.7401529,10.1029393 33.7389278,10.1056016 33.7382539,10.1063446 C33.6363205,9.81249385 33.362313,9.6 33.0365425,9.6 C32.6248269,9.6 32.2909091,9.93768691 32.2909091,10.3541303 L32.2909091,15.3913243 C32.2909091,15.8078915 32.6248269,16.1454545 33.0365425,16.1454545 C33.4485644,16.1454545 33.7826048,15.8078915 33.7826048,15.3913243 L33.7723134,11.9929705 C33.7723134,11.9929705 33.9532086,11.7752139 34.2436332,11.5669922 C34.9412403,11.0671487 35.6063806,11.2374162 35.6063806,12.0917257 L35.6234716,15.4035835 C35.6234716,15.8135877 35.9518762,16.1454545 36.3573435,16.1454545 C36.7625045,16.1454545 37.0909091,15.8135877 37.0909091,15.4035835 L37.0887651,12.0920353 Z",
                fill: primary
            }), Object(jsx.b)("path", {
                d: "M15.5613016,16.2862697 C15.7330634,15.9971851 15.762994,15.7935853 15.762994,15.7935853 L14.0695172,11.3349218 C14.0695172,11.3349218 13.7622674,10.4721348 14.4393994,10.2166114 C15.1567468,9.94557914 15.4157136,10.6357839 15.4696009,10.7805123 C15.5234881,10.9252407 16.5395249,13.6504516 16.5395249,13.6504516 L17.5177483,10.7867779 C17.5177483,10.7867779 17.7979621,9.89638514 18.5815138,10.2138818 C19.2290232,10.4764773 18.8964002,11.3498103 18.8964002,11.3498103 C18.8964002,11.3498103 17.8952671,14.3335844 17.0561037,16.4983684 C16.5548597,17.7916804 16.1267792,17.9191009 15.6376676,18.0403799 C14.9830758,18.2027884 13.7454545,18.1223286 13.7454545,17.30247 C13.7454545,16.655814 14.4027561,16.615491 14.6992284,16.6251065 C14.7151175,16.6254167 15.3279543,16.6788911 15.5613016,16.2862697",
                fill: secondary
            }), Object(jsx.b)("path", {
                d: "M11.5669215,8.85710249 L10.0137262,13.1590392 L8.3203761,8.88327934 C8.3203761,8.88327934 8.06948196,8.07272727 7.36345596,8.07272727 C6.54545455,8.07272727 6.57202708,8.72317872 6.55361169,8.88327934 C6.53525811,9.04350403 6.55361169,15.569481 6.55361169,15.569481 C6.55361169,15.569481 6.54545455,16.2545455 7.29591229,16.2545455 C8.06280792,16.2545455 8.02603896,15.56334 8.03209502,15.56334 C8.03821288,15.56334 8.03209502,12.1182301 8.03209502,12.1182301 L9.27754342,15.56334 C9.27754342,15.56334 9.46151186,16.2407127 10.0381976,16.2283686 C10.6148833,16.2161486 10.7804982,15.56334 10.7804982,15.56334 L11.823501,12.1244331 L11.823501,15.56334 C11.823501,15.56334 11.823501,16.2545455 12.5780991,16.2545455 C13.3081022,16.2545455 13.3081022,15.56334 13.3081022,15.56334 L13.3090909,8.88948239 C13.3090909,8.88948239 13.3090909,8.07272727 12.5166733,8.07663519 C11.8595284,8.07973672 11.609932,8.71207526 11.5669215,8.85710249 C11.5619778,8.8740368 11.5596913,8.88327934 11.5596913,8.88327934",
                fill: secondary
            }), Object(jsx.b)("g", null, Object(jsx.b)("mask", {
                fill: tertiary
            }, Object(jsx.b)("polygon", {
                points: "3.086436e-05 0.00960615385 42.6159033 0.00960615385 42.6159033 24 3.086436e-05 24",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.b)("g", null), Object(jsx.b)("path", {
                d: "M42.6159341,18.6971754 L29.5208652,18.6971754 L19.9057529,18.6956369 L19.9124196,18.7062215 C18.0119775,20.9263446 15.1892466,22.3382831 12.0318843,22.3382831 C6.30740974,22.3382831 1.66682976,17.7116369 1.66682976,12.0048677 C1.66682976,6.29803692 6.30740974,1.67182154 12.0318843,1.67182154 C15.2027652,1.67182154 18.0390147,3.09182154 19.9398272,5.32819077 L22.0210727,5.32819077 C19.8613082,2.12277538 16.1963507,0.00960615385 12.0318843,0.00960615385 C5.38703452,0.00960615385 3.086436e-05,5.38012923 3.086436e-05,12.0048677 C3.086436e-05,18.6296062 5.38703452,24.0000062 12.0318843,24.0000062 C15.5178286,24.0000062 18.6504994,22.5164985 20.846622,20.1542215 L41.6296327,20.1336062 L42.6159341,18.6971754 Z",
                fill: secondary
            })), Object(jsx.b)("path", {
                d: "M23.5642714,14.6942333 L21.476941,14.6942333 L21.476941,12.703212 L23.5642714,12.703212 C24.0691167,12.729228 24.5593003,12.986305 24.5593003,13.698846 C24.5593003,14.4306215 24.1135333,14.6942333 23.5642714,14.6942333 Z M21.476941,9.5856756 L23.4225205,9.5856756 C23.8122278,9.59572442 24.2213404,9.80372869 24.2213404,10.3852036 C24.2213404,10.9910915 23.8636056,11.1846082 23.4225205,11.1846082 L21.476941,11.1846082 L21.476941,9.5856756 Z M25.2086687,11.7878453 C25.2484033,11.7332241 25.7477042,11.3284357 25.7082776,10.252103 C25.6287468,8.0729285 23.7375637,8.09777311 23.3189641,8.08507338 C22.644646,8.06479081 22.2387368,8.0729285 21.0010496,8.08507338 C19.9559983,8.09543044 19.9636372,9.0459372 19.9636372,9.0459372 L19.9636364,16.1454545 L23.4862807,16.1454545 C25.3714882,16.1454545 26.0727273,15.1069128 26.0727273,13.6549518 C26.0727273,12.1940516 25.2086687,11.7878453 25.2086687,11.7878453 Z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.P24] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!P24_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " p24 logo available");
            var _P24_LOGO_COLORS$logo = P24_LOGO_COLORS[logoColor], primary = _P24_LOGO_COLORS$logo.primary, secondary = _P24_LOGO_COLORS$logo.secondary;
            return Object(jsx.b)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                version: "1.1",
                viewBox: "0 0 100 32",
                height: "32",
                width: "100",
                preserveAspectRatio: "xMinYMin meet"
            }, Object(jsx.b)("g", {
                transform: "matrix(1.2953205,0,0,1.4482638,-127.73674,-229.48747)"
            }, Object(jsx.b)("g", {
                transform: "translate(99,159)"
            }, Object(jsx.b)("path", {
                transform: "matrix(0.77200971,0,0,0.69048194,-0.38599675,-0.54304623)",
                d: "M 34.123047 14.666016 L 32.416016 14.667969 L 30.496094 27.771484 L 32.208984 27.773438 L 34.123047 14.666016 z M 2.4082031 14.669922 L 0.5 27.771484 L 2.2753906 27.773438 L 2.9785156 22.916016 L 6.421875 22.933594 C 6.421875 22.933594 7.7610468 22.994689 8.7128906 22.419922 C 9.6646511 21.844634 9.9179688 20.537109 9.9179688 20.537109 C 9.9179688 20.537109 10.021944 20.051453 10.107422 19.458984 C 10.201364 18.808401 10.297704 18.027313 10.347656 17.611328 C 10.369589 17.428799 10.382812 17.316406 10.382812 17.316406 C 10.382812 17.316406 10.406035 17.181738 10.408203 16.972656 C 10.411247 16.680039 10.373345 16.24144 10.173828 15.824219 C 10.107822 15.686199 10.023752 15.551336 9.9179688 15.423828 C 9.7749921 15.251532 9.573657 15.118146 9.3457031 15.015625 C 9.1093266 14.909344 8.8444066 14.836083 8.5878906 14.785156 C 8.2611582 14.720236 7.9481918 14.691729 7.7226562 14.679688 C 7.5151753 14.668598 7.3808594 14.669922 7.3808594 14.669922 L 4.5292969 14.669922 L 2.4082031 14.669922 z M 3.9023438 16.636719 L 6.5097656 16.644531 C 6.5097656 16.644531 6.6871684 16.640189 6.9335938 16.644531 C 7.2136679 16.6496 7.5842469 16.667097 7.8886719 16.712891 C 8.149399 16.752066 8.3620627 16.811675 8.4277344 16.90625 C 8.5143382 17.03109 8.5484972 17.190294 8.5605469 17.335938 C 8.5776425 17.542977 8.5477921 17.723762 8.546875 17.736328 C 8.5451652 17.758038 8.3882592 18.81021 8.1777344 20.056641 C 8.0971356 20.533644 7.7783765 20.790093 7.4101562 20.878906 C 6.8022654 21.025453 6.1484375 21 6.1484375 21 L 3.2695312 20.990234 L 3.9023438 16.636719 z M 27.246094 18.195312 C 26.565902 18.205016 26.253806 18.2403 26 18.302734 C 26 18.302734 24.790129 18.501565 24.103516 19.472656 C 23.416902 20.4437 23.212891 22.568359 23.212891 22.568359 C 23.212891 22.568359 22.804576 24.916796 22.923828 25.699219 C 23.042829 26.481642 23.256401 27.206424 24.033203 27.546875 C 24.810173 27.88723 25.46875 27.873047 25.46875 27.873047 C 25.46875 27.873047 26.853325 27.996517 27.896484 27.714844 C 28.939685 27.433792 29.490234 26.595703 29.490234 26.595703 C 29.490234 26.595703 29.735609 26.235379 29.912109 25.804688 C 30.088777 25.374043 30.140682 25.073949 30.148438 25.037109 L 30.257812 24.53125 L 28.484375 24.533203 C 28.484375 24.533203 28.385914 25.868868 27.429688 25.992188 C 26.473716 26.115218 25.960314 26.068498 25.775391 26.060547 C 25.593178 26.052871 24.567122 26.102566 24.650391 25.125 C 24.650808 25.111821 24.651179 25.091912 24.652344 25.064453 C 24.69996 23.94948 24.808594 23.660156 24.808594 23.660156 L 30.375 23.642578 L 30.613281 22.072266 C 30.883598 20.286624 30.683916 18.929319 29.257812 18.398438 C 28.779056 18.220288 27.947801 18.185366 27.246094 18.195312 z M 37.748047 18.197266 C 37.067855 18.206824 36.755758 18.242238 36.501953 18.304688 C 36.501953 18.304688 35.292082 18.503803 34.605469 19.474609 C 33.918854 20.445938 33.714844 22.570313 33.714844 22.570312 C 33.714844 22.570312 33.306572 24.918749 33.425781 25.701172 C 33.545028 26.483643 33.758145 27.207998 34.535156 27.548828 C 35.311959 27.889232 35.970703 27.875 35.970703 27.875 C 35.970703 27.875 37.355488 27.998135 38.398438 27.716797 C 39.441597 27.435412 39.992187 26.597656 39.992188 26.597656 C 39.992188 26.597656 40.237604 26.237189 40.414062 25.806641 C 40.590771 25.376138 40.642384 25.077855 40.650391 25.041016 L 40.759766 24.533203 L 38.986328 24.535156 C 38.986328 24.535156 38.887867 25.871106 37.931641 25.994141 C 36.975669 26.117315 36.462059 26.072303 36.277344 26.064453 C 36.095172 26.056777 35.06916 26.104467 35.152344 25.126953 C 35.152802 25.113774 35.153175 25.093967 35.154297 25.066406 C 35.201874 23.951433 35.310547 23.662109 35.310547 23.662109 L 40.876953 23.644531 L 41.115234 22.076172 C 41.385759 20.290531 41.185607 18.931462 39.759766 18.400391 C 39.280716 18.222193 38.449796 18.187223 37.748047 18.197266 z M 46.277344 18.304688 L 43.757812 24.96875 L 43.179688 18.316406 L 41.541016 18.318359 L 42.371094 27.773438 L 44.355469 27.765625 L 46.90625 21.148438 L 47.486328 27.765625 L 49.505859 27.765625 L 53.117188 18.316406 L 51.417969 18.318359 L 48.898438 24.996094 L 48.300781 18.3125 L 46.277344 18.304688 z M 11.253906 18.310547 L 9.7929688 27.720703 L 11.617188 27.720703 L 12.427734 22.507812 C 12.596271 21.449811 13.285209 20.144531 14.638672 20.144531 L 15.582031 20.140625 L 15.865234 18.310547 L 14.873047 18.310547 C 14.184891 18.310547 13.533952 18.621542 12.978516 18.96875 L 13.076172 18.310547 L 11.253906 18.310547 z M 23.574219 18.310547 L 17.048828 18.320312 L 16.789062 20.167969 L 20.960938 20.167969 L 15.732422 25.884766 L 15.451172 27.771484 L 22.191406 27.769531 L 22.457031 25.939453 L 17.880859 25.951172 L 23.335938 20.005859 L 23.574219 18.310547 z M 59.283203 18.3125 L 56.183594 25.228516 L 55.087891 18.320312 L 53.347656 18.316406 L 54.962891 27.882812 L 54.755859 28.283203 C 54.755859 28.283203 54.42297 29.081956 54.011719 29.267578 C 53.600426 29.452827 52.910156 29.304688 52.910156 29.304688 L 52.650391 31.068359 L 53.066406 31.152344 C 53.459811 31.231491 53.623329 31.198848 54.033203 31.152344 C 54.443329 31.10608 54.748768 30.903232 55.25 30.449219 C 55.751441 29.99568 56.560547 28.207031 56.560547 28.207031 L 61.027344 18.330078 L 59.283203 18.3125 z M 37.816406 20.023438 C 38.153219 20.022293 38.536406 20.045829 38.880859 20.126953 C 39.109271 20.180351 39.326106 20.327316 39.382812 20.544922 C 39.516491 21.058003 39.375 21.841797 39.375 21.841797 L 35.558594 21.835938 L 35.710938 21.144531 C 35.710938 21.144531 35.842858 20.605552 36.107422 20.375 C 36.372026 20.144305 36.710486 20.103629 37.029297 20.068359 C 37.188702 20.050872 37.479594 20.024582 37.816406 20.023438 z M 27.330078 20.027344 C 27.666911 20.026207 28.050203 20.04988 28.394531 20.130859 C 28.623194 20.184445 28.839945 20.329507 28.896484 20.546875 C 29.030121 21.059954 28.886719 21.84375 28.886719 21.84375 L 25.072266 21.839844 L 25.224609 21.148438 C 25.224609 21.148438 25.35653 20.607886 25.621094 20.376953 C 25.885906 20.146258 26.224367 20.107486 26.542969 20.072266 C 26.702373 20.054561 26.993245 20.028481 27.330078 20.027344 z ",
                fill: primary
            }), Object(jsx.b)("path", {
                d: "m 18.656138,16.774358 c -0.0046,0.0239 -0.0083,0.04735 -0.01154,0.07058 -0.0065,0.118231 0.01306,-0.07708 0.01154,-0.07058",
                fill: primary
            }), Object(jsx.b)("path", {
                d: "m 26.763669,16.775893 c -0.0046,0.02391 -0.0083,0.04743 -0.01154,0.07066 -0.0065,0.118089 0.01306,-0.07731 0.01154,-0.07066",
                fill: primary
            }), Object(jsx.b)("path", {
                transform: "matrix(0.77200971,0,0,0.69048194,-0.38599675,-0.54304623)",
                d: "M 51.226562 0.78710938 C 50.728893 0.78574323 50.439453 0.79296875 50.439453 0.79296875 L 48.318359 5.6542969 C 48.318359 5.6542969 49.531198 5.9719517 51.199219 6.5273438 C 54.144731 7.5791572 56.515625 9.2929688 56.515625 9.2929688 L 66.666016 3.234375 C 66.745656 3.1868271 63.084253 2.0998969 59.082031 1.3945312 C 56.08052 0.86568549 52.71957 0.7912078 51.226562 0.78710938 z M 47.589844 0.90820312 C 47.589844 0.90820313 43.781742 1.1966088 40.910156 1.8066406 C 38.038322 2.4166724 34.904297 3.3691406 34.904297 3.3691406 L 35.34375 6.2011719 C 35.34375 6.2011719 37.385444 5.5830734 39.835938 5.25 C 42.979007 4.7627651 46.330078 5.2851562 46.330078 5.2851562 L 47.589844 0.90820312 z M 32.949219 4.0429688 C 32.949219 4.0429687 31.321834 4.6211203 28.267578 6.0117188 C 25.213321 7.4021267 22.914062 8.8925781 22.914062 8.8925781 L 25.453125 10.84375 C 25.453125 10.84375 27.099522 9.6851386 28.839844 8.8378906 C 30.525001 7.9290065 33.464844 6.8066406 33.464844 6.8066406 L 32.949219 4.0429688 z M 71.046875 5.0175781 L 58.333984 10.615234 L 60.566406 12.546875 L 78.900391 12.546875 C 78.900391 12.546875 78.861436 11.867776 78.373047 10.908203 C 78.067288 10.306786 77.515959 9.6724399 76.935547 9.0117188 C 76.724772 8.771647 75.878829 8.0196942 75.248047 7.5527344 C 73.629269 6.3552786 72.725403 5.8908131 71.046875 5.0175781 z M 20.621094 10.361328 C 20.621094 10.361328 18.007768 12.208509 16.898438 13.080078 C 15.819753 13.883157 13.6875 15.744141 13.6875 15.744141 L 19.160156 15.744141 C 19.160156 15.744141 20.387652 14.611026 21.257812 13.884766 C 22.127974 13.158363 23.712891 12.011719 23.712891 12.011719 L 20.621094 10.361328 z M 66.779297 14.519531 C 65.231195 14.543948 64.467235 14.626145 63.683594 14.955078 C 62.899953 15.283726 62.446574 15.882838 62.158203 16.728516 C 61.840059 17.527168 61.65625 19.259766 61.65625 19.259766 L 63.453125 19.261719 L 63.560547 18.464844 C 63.560547 18.464844 63.753461 17.029388 64.181641 16.751953 C 64.31878 16.663088 64.538495 16.579747 64.792969 16.529297 C 65.262594 16.436347 65.860733 16.425312 66.345703 16.445312 C 67.093861 16.476103 67.374266 16.483376 68.134766 16.582031 C 68.895557 16.68089 68.701172 17.517578 68.701172 17.517578 L 68.552734 18.767578 C 68.552734 18.767578 68.488006 19.327955 68.3125 19.677734 C 68.157306 19.987057 67.733373 20.195678 67.488281 20.287109 C 66.896194 20.507571 64.871094 21.095703 64.871094 21.095703 L 63.275391 21.619141 C 63.275391 21.619141 62.297563 21.944394 61.748047 22.636719 C 61.19878 23.329281 60.983257 24.116118 60.908203 24.527344 C 60.833113 24.938283 60.412109 27.769531 60.412109 27.769531 L 69.009766 27.773438 L 69.296875 25.810547 L 62.496094 25.820312 L 62.619141 25.021484 C 62.619141 25.021484 62.697988 24.196554 62.990234 23.927734 C 63.082461 23.842591 63.127078 23.730658 63.669922 23.509766 C 63.993778 23.377829 65.103516 23.039062 65.103516 23.039062 L 67.669922 22.240234 C 67.669922 22.240234 69.069743 21.828553 69.621094 20.957031 C 70.172403 20.085747 70.384766 18.416016 70.384766 18.416016 C 70.384766 18.416016 70.533003 16.793571 70.419922 16.285156 C 70.307099 15.776804 69.886071 15.166455 69.375 14.90625 C 68.863719 14.646045 68.327565 14.495353 66.779297 14.519531 z ",
                fill: secondary
            }), Object(jsx.b)("g", {
                transform: "translate(53.596306,9.56338)"
            }, Object(jsx.b)("path", {
                d: "M 4.7408782,5.7106164 1.839113,5.7061141 5.3711256,1.8647573 Z M 6.112171,5.7095319 7.0417209,0.01876197 5.3948175,0.01774319 0.26289873,5.6444944 0.02981113,7.0693723 4.5178982,7.0688465 4.1894639,9.0682502 l 1.376733,0.00181 0.3251187,-2.001047 1.2714396,0.00269 0.2297076,-1.3639812 z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.ZIMPLER] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!ZIMPLER_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " zimpler logo available");
            var primary = ZIMPLER_LOGO_COLORS[logoColor].primary;
            return Object(jsx.b)("svg", {
                width: "127",
                height: "32",
                viewBox: "0 0 127 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMinYMin meet"
            }, Object(jsx.b)("g", {
                transform: "matrix(2.2546708,0,0,2.0580615,0.70028058,1.3242473)",
                fill: primary
            }, Object(jsx.b)("path", {
                d: "m 44.363387,6.5973104 c 0.2184,-1.0706901 1.091377,-1.9895312 2.0692,-1.9895312 0.550355,0 0.9492,0.4072031 0.806711,0.8621302 L 44.211564,7.544662 c 0.05693,-0.5305417 0.151823,-0.9473516 0.151823,-0.9473516 z m -14.0476,2.5296797 0.474755,-2.719026 c 0.208756,-0.6442735 0.968178,-1.5064037 1.755911,-1.5538178 0.303645,-0.018904 0.664534,-0.00961 1.006134,0.2652709 0.294311,0.3315885 0.446133,0.8243229 0.446133,1.4400859 0,1.9421172 -0.9492,3.287375 -2.2876,3.287375 -0.664222,-0.0093 -1.186267,-0.3504922 -1.395333,-0.719888 z M 55.857698,2.8454016 c -1.138978,-0.056711 -2.6292,1.3359609 -2.6292,1.3359609 l -0.474756,-1.184112 h -1.300133 l -0.626578,3.543349 c -0.04729,0.2460573 -0.1708,0.4642239 -0.370222,0.615763 l -1.717956,1.3452578 c 0,0 -0.702177,0.5401484 -1.68,1.1652083 -0.445822,0.2181667 -0.806711,0.3126849 -1.176933,0.3126849 -0.787733,0 -1.281156,-0.3030781 -1.508889,-0.8243229 -0.03827,-0.094518 -0.06658,-0.1989531 -0.0952,-0.2934713 l 4.404089,-2.975 C 49.317831,5.441399 49.308498,4.8352427 49.222942,4.5318547 48.938276,3.5845031 48.083964,2.873912 46.669964,2.873912 c -2.638844,0 -4.451688,2.2455052 -4.451688,5.438362 0,0.2178567 0.0096,0.4261067 0.03795,0.6250599 l -1.252844,0.8813437 c -0.246711,0.1515391 -0.597956,0.2841744 -0.816356,0.2841744 -0.379555,0 -0.541022,-0.2937812 -0.417511,-0.9284478 L 41.40192,0.04115417 39.361342,0.02225052 38.544987,4.5699719 c -0.03796,0.1893463 -0.1232,0.3693958 -0.256045,0.5113281 l -2.249644,2.3685338 c 0.05693,-0.3882994 0.08555,-0.8051093 0.08555,-1.2408229 0,-1.9235234 -0.892266,-3.3443958 -2.391822,-3.3443958 -1.452267,0 -2.534311,1.2219193 -2.534311,1.2219193 L 30.629076,2.9972505 H 29.34792 L 28.645431,7.0048234 C 28.616809,7.184563 28.540898,7.3457088 28.417698,7.4783443 L 27.10792,9.0225552 C 26.747031,9.4111646 26.367476,9.8942922 26.177698,9.903899 25.835787,9.96061 25.683964,9.837581 25.797831,9.2026047 l 0.522045,-2.8990755 c 0.408177,-2.2926094 -0.294,-3.4485209 -2.268312,-3.4485209 -1.176933,0 -2.562622,1.3170573 -2.562622,1.3170573 -0.294311,-0.8624401 -1.015778,-1.3170573 -2.107155,-1.3170573 -1.195911,0 -2.487023,1.3926719 -2.487023,1.3926719 L 16.363387,3.0065474 H 15.062942 L 14.39872,6.7962635 C 14.370098,6.976313 14.294187,7.1374588 14.170987,7.2700943 L 12.680764,9.032162 c -0.360888,0.3886094 -0.740444,0.871737 -0.930222,0.8810338 -0.3416,0.057021 -0.493733,-0.066318 -0.379555,-0.7009843 L 12.50032,3.0065474 h -2.059556 l -0.332266,1.8286953 c -0.0476,0.2367604 -0.1518224,0.464224 -0.3132891,0.6439635 L 6.7864533,8.9469406 C 6.0080533,9.7805604 5.0305422,9.903899 4.83112,9.9131958 H 2.7049867 L 7.5362311,4.4562401 7.7829422,2.978037 H 1.5756533 L 1.2813422,4.6362896 H 4.8880533 L 0.22792,10.093245 -1.2444444e-4,11.637456 c 0,0 4.36613334444,0.01921 4.44204444444,0 1.2814667,0 2.4204444,-1.127401 2.8759111,-1.591625 L 9.6433867,7.3079016 9.2258756,9.6101177 c -0.266,1.4967973 0.3129777,2.2073883 1.5471554,2.1791873 0.759111,-0.01921 1.281156,-0.521245 1.8032,-1.04218 l 1.404667,-1.6390385 -0.465111,2.6431015 h 2.059866 l 0.9016,-5.182388 c 0.113867,-0.6442734 0.939556,-1.7335573 1.803511,-1.7335573 0.911245,0 1.347734,0.4450104 1.138978,1.6672396 l -0.920889,5.2394087 h 2.040889 l 0.987156,-5.5709973 c 0.05693,-0.3693958 0.721155,-1.4115755 1.642044,-1.4115755 0.958534,0 1.271822,0.5209349 1.063067,1.7431641 l -0.569645,3.0980286 c -0.265688,1.4971071 0.313289,2.2076981 1.547156,2.1791871 0.759422,-0.0189 1.281467,-0.520934 1.803511,-1.042179 l 1.214889,-1.4211825 -0.427156,2.4348515 -0.493733,2.813854 h 2.059867 l 0.664222,-3.827523 c 0.284667,0.360099 0.683511,0.65388 1.176933,0.805419 0.113867,0.03781 0.227734,0.06632 0.351245,0.08522 1.328755,0.06632 2.515333,-0.577955 3.568755,-1.676846 l 0.0096,-0.00961 2.989778,-3.0887317 -0.484089,2.7004323 c -0.265689,1.4967974 0.303644,2.1788774 1.547155,2.1884844 0.806711,0 1.556489,-0.397906 2.344222,-0.928448 l 1.044089,-0.748708 c 0.01898,0.03812 0.03796,0.08553 0.05693,0.123338 0.474755,0.918842 1.348044,1.525308 2.638844,1.534915 h 0.0093 c 1.357378,0 2.686134,-1.279251 3.454889,-1.8190892 0.199423,-0.1422422 0.939867,-0.7391016 1.736934,-1.383375 L 49.906371,11.73228 h 2.059556 L 52.86792,6.5498963 c 0.113867,-0.6442734 0.939556,-1.7338671 1.8032,-1.7338671 0.332267,0 0.597956,0.057021 0.797378,0.1896562 z"
            }), Object(jsx.b)("g", {
                transform: "translate(10.577778,-0.309896)"
            }, Object(jsx.b)("path", {
                d: "m 1.0778133,2.4638268 c 0.6835111,0 1.3287556,-0.5401484 1.4332889,-1.2033255 C 2.6153244,0.59732422 2.1502133,0.05748568 1.4670133,0.04787891 c -0.68351108,0 -1.32875552,0.54014843 -1.43328886,1.20332549 -0.11386666,0.672474 0.35124445,1.2126224 1.04408886,1.2126224"
            }))));
        }, _fundingLogos), visa = __webpack_require__(46), visa_default = __webpack_require__.n(visa), amex = __webpack_require__(47), amex_default = __webpack_require__.n(amex), mastercard = __webpack_require__(48), mastercard_default = __webpack_require__.n(mastercard), maestro = __webpack_require__(49), maestro_default = __webpack_require__.n(maestro), discover = __webpack_require__(50), discover_default = __webpack_require__.n(discover), hiper = __webpack_require__(51), hiper_default = __webpack_require__.n(hiper), elo = __webpack_require__(52), elo_default = __webpack_require__.n(elo), jcb = __webpack_require__(53), jcb_default = __webpack_require__.n(jcb), cup = __webpack_require__(54), cup_default = __webpack_require__.n(cup), cardLogos = ((_cardLogos = {})[constants.o.VISA] = visa_default.a, 
        _cardLogos[constants.o.AMEX] = amex_default.a, _cardLogos[constants.o.MASTERCARD] = mastercard_default.a, 
        _cardLogos[constants.o.MAESTRO] = maestro_default.a, _cardLogos[constants.o.DISCOVER] = discover_default.a, 
        _cardLogos[constants.o.HIPER] = hiper_default.a, _cardLogos[constants.o.ELO] = elo_default.a, 
        _cardLogos[constants.o.JCB] = jcb_default.a, _cardLogos[constants.o.CUP] = cup_default.a, 
        _cardLogos);
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return fundingLogos;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return cardLogos;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject), __webpack_require__.d(interface_namespaceObject, "create", function() {
            return create;
        }), __webpack_require__.d(interface_namespaceObject, "getByTag", function() {
            return getByTag;
        }), __webpack_require__.d(interface_namespaceObject, "getCurrentScriptDir", function() {
            return lib.t;
        }), __webpack_require__.d(interface_namespaceObject, "destroyAll", function() {
            return interface_destroyAll;
        }), __webpack_require__.d(interface_namespaceObject, "postRobot", function() {
            return postRobot;
        }), __webpack_require__.d(interface_namespaceObject, "CONSTANTS", function() {
            return CONSTANTS;
        }), __webpack_require__.d(interface_namespaceObject, "PopupOpenError", function() {
            return src_error.b;
        }), __webpack_require__.d(interface_namespaceObject, "IntegrationError", function() {
            return src_error.a;
        }), __webpack_require__.d(interface_namespaceObject, "RenderError", function() {
            return src_error.c;
        });
        var src = __webpack_require__(13);
        function _assertThisInitialized(self) {
            if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self;
        }
        var inheritsLoose = __webpack_require__(20);
        function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
            var desc = {};
            return Object.keys(descriptor).forEach(function(key) {
                desc[key] = descriptor[key];
            }), desc.enumerable = !!desc.enumerable, desc.configurable = !!desc.configurable, 
            ("value" in desc || desc.initializer) && (desc.writable = !0), desc = decorators.slice().reverse().reduce(function(desc, decorator) {
                return decorator(target, property, desc) || desc;
            }, desc), context && void 0 !== desc.initializer && (desc.value = desc.initializer ? desc.initializer.call(context) : void 0, 
            desc.initializer = void 0), void 0 === desc.initializer && (Object.defineProperty(target, property, desc), 
            desc = null), desc;
        }
        var zalgo_promise_src = __webpack_require__(1), cross_domain_utils_src = __webpack_require__(7), lib = __webpack_require__(5), base_BaseComponent = function() {
            function BaseComponent() {
                var obj, tasks, cleaned;
                this.clean = void 0, this.event = void 0, this.component = void 0, this.clean = (obj = this, 
                tasks = [], cleaned = !1, {
                    set: function(name, item) {
                        return cleaned ? item : (obj[name] = item, this.register(function() {
                            delete obj[name];
                        }), item);
                    },
                    register: function(name, method) {
                        if ("function" == typeof name && (method = name, name = "<anonymous-cleanup-handler>"), 
                        "function" != typeof method) throw new TypeError("Expected to be passed function to clean.register");
                        cleaned ? method() : tasks.push({
                            complete: !1,
                            name: name,
                            run: function() {
                                this.complete || (this.complete = !0, method && method());
                            }
                        });
                    },
                    hasTasks: function() {
                        return Boolean(tasks.filter(function(item) {
                            return !item.complete;
                        }).length);
                    },
                    all: function() {
                        var results = [];
                        for (cleaned = !0; tasks.length; ) results.push(tasks.pop().run());
                        return zalgo_promise_src.a.all(results).then(function() {});
                    },
                    run: function(name) {
                        for (var results = [], _i2 = 0; _i2 < tasks.length; _i2++) {
                            var item = tasks[_i2];
                            item.name === name && results.push(item.run());
                        }
                        return zalgo_promise_src.a.all(results).then(lib.F);
                    }
                }), this.event = Object(lib.p)();
            }
            var _proto = BaseComponent.prototype;
            return _proto.addProp = function(options, name, def) {
                Object(lib.g)(options, this, name, def);
            }, _proto.on = function(eventName, handler) {
                return this.event.on(eventName, handler);
            }, _proto.listeners = function() {
                throw new Error("Expected listeners to be implemented");
            }, _proto.error = function(err) {
                throw new Error("Expected error to be implemented - got " + Object(lib.S)(err));
            }, _proto.listen = function(win, domain) {
                var _this = this;
                if (!win) throw this.component.createError("window to listen to not set");
                if (!domain) throw new Error("Must pass domain to listen to");
                if (this.listeners) for (var listeners = this.listeners(), _loop = function(_i4, _Object$keys2) {
                    var listenerName = _Object$keys2[_i4], name = listenerName.replace(/^zoid_/, ""), errorHandler = function(err) {
                        _this.error(err);
                    }, listener = Object(src.on)(listenerName, {
                        window: win,
                        domain: domain,
                        errorHandler: errorHandler
                    }, function(_ref) {
                        var source = _ref.source, data = _ref.data;
                        return _this.component.log("listener_" + name), listeners[listenerName].call(_this, source, data);
                    }), errorListener = Object(src.on)(listenerName, {
                        window: win,
                        errorHandler: errorHandler
                    }, function(_ref2) {
                        var origin = _ref2.origin;
                        _this.component.logError("unexpected_listener_" + name, {
                            origin: origin,
                            domain: domain.toString()
                        }), _this.error(new Error("Unexpected " + name + " message from domain " + origin + " -- expected message from " + domain.toString()));
                    });
                    _this.clean.register(function() {
                        listener.cancel(), errorListener.cancel();
                    });
                }, _i4 = 0, _Object$keys2 = Object.keys(listeners); _i4 < _Object$keys2.length; _i4++) _loop(_i4, _Object$keys2);
            }, BaseComponent;
        }(), esm_extends = __webpack_require__(11), client = __webpack_require__(4), belter_src = __webpack_require__(16), base32 = __webpack_require__(28), base32_default = __webpack_require__.n(base32), constants = __webpack_require__(8);
        function normalize(str) {
            return str.replace(/^[^a-z0-9A-Z]+|[^a-z0-9A-Z]+$/g, "").replace(/[^a-z0-9A-Z]+/g, "_");
        }
        var isZoidComponentWindow = Object(lib.D)(function() {
            return !!window.name && "xcomponent" === window.name.split("__")[0];
        }), getComponentMeta = Object(lib.D)(function() {
            if (!window.name) throw new Error("Can not get component meta without window name");
            var componentMeta, _window$name$split2 = window.name.split("__"), zoidcomp = _window$name$split2[0], name = _window$name$split2[1], version = _window$name$split2[2], encodedOptions = _window$name$split2[3];
            if ("xcomponent" !== zoidcomp) throw new Error("Window not rendered by zoid - got " + zoidcomp);
            try {
                componentMeta = JSON.parse(base32_default.a.decode(encodedOptions.toUpperCase()));
            } catch (err) {
                throw new Error("Can not decode component-meta: " + encodedOptions + " " + Object(lib.S)(err));
            }
            return componentMeta.name = name, componentMeta.version = version.replace(/_/g, "."), 
            componentMeta;
        });
        function window_getParentDomain() {
            return getComponentMeta().domain;
        }
        function getWindowByRef(_ref) {
            var result, ref = _ref.ref, uid = _ref.uid, distance = _ref.distance;
            if (ref === constants.WINDOW_REFERENCES.OPENER ? result = Object(cross_domain_utils_src.l)(window) : ref === constants.WINDOW_REFERENCES.TOP ? result = Object(cross_domain_utils_src.n)(window) : ref === constants.WINDOW_REFERENCES.PARENT && (result = distance ? Object(cross_domain_utils_src.k)(window, distance) : Object(cross_domain_utils_src.m)(window)), 
            ref === constants.WINDOW_REFERENCES.GLOBAL) {
                var ancestor = Object(cross_domain_utils_src.e)(window);
                if (ancestor) for (var _i2 = 0, _getAllFramesInWindow2 = Object(cross_domain_utils_src.d)(ancestor); _i2 < _getAllFramesInWindow2.length; _i2++) {
                    var frame = _getAllFramesInWindow2[_i2], global = Object(lib.w)(frame);
                    if (global && global.windows && global.windows[uid]) {
                        result = global.windows[uid];
                        break;
                    }
                }
            }
            if (!result) throw new Error("Unable to find window by ref");
            return result;
        }
        var window_getParentComponentWindow = Object(lib.D)(function() {
            var componentMeta = getComponentMeta();
            if (!componentMeta) throw new Error("Can not get parent component window - window not rendered by zoid");
            return getWindowByRef(componentMeta.componentParent);
        }), window_getParentRenderWindow = Object(lib.D)(function() {
            var componentMeta = getComponentMeta();
            if (!componentMeta) throw new Error("Can not get parent component window - window not rendered by zoid");
            return getWindowByRef(componentMeta.renderParent);
        }), src_error = __webpack_require__(22);
        function normalizeChildProp(component, props, key, value) {
            var prop = component.getProp(key);
            return prop ? "function" == typeof prop.childDecorate ? prop.childDecorate(value) : value : component.looseProps ? value : void 0;
        }
        var child_ChildComponent = function(_BaseComponent) {
            function ChildComponent(component) {
                var _this;
                if ((_this = _BaseComponent.call(this) || this).component = void 0, _this.props = void 0, 
                _this.context = void 0, _this.onPropHandlers = void 0, _this.onInit = void 0, _this.watchingForResize = void 0, 
                _this.autoResize = void 0, _this.component = component, !_this.hasValidParentDomain()) return _this.error(new src_error.c("Can not be rendered by domain: " + _this.getParentDomain())), 
                _assertThisInitialized(_this);
                _this.component.log("construct_child"), _this.onPropHandlers = [];
                for (var _loop = function(_i2, _ref2) {
                    for (var item = _ref2[_i2], _loop2 = function(_i4, _ref4) {
                        var _ref4$_i = _ref4[_i4], name = _ref4$_i[0], getter = _ref4$_i[1];
                        Object.defineProperty(item, name, {
                            configurable: !0,
                            get: function() {
                                return _this.props || _this.setProps(_this.getInitialProps(), window_getParentDomain()), 
                                delete item[name], item[name] = getter(), item[name];
                            }
                        });
                    }, _i4 = 0, _ref4 = [ [ "xchild", function() {
                        return _assertThisInitialized(_this);
                    } ], [ "xprops", function() {
                        return _this.props;
                    } ] ]; _i4 < _ref4.length; _i4++) _loop2(_i4, _ref4);
                }, _i2 = 0, _ref2 = [ _this.component, window ]; _i2 < _ref2.length; _i2++) _loop(_i2, _ref2);
                return _this.component.log("init_child"), _this.setWindows(), _this.onInit = _this.sendToParent(constants.POST_MESSAGE.INIT, {
                    exports: _this.exports()
                }).then(function(_ref5) {
                    var origin = _ref5.origin, data = _ref5.data;
                    return _this.context = data.context, _this.setProps(data.props, origin), _this.watchForResize(), 
                    _assertThisInitialized(_this);
                }).catch(function(err) {
                    throw _this.error(err), err;
                }), _this;
            }
            Object(inheritsLoose.a)(ChildComponent, _BaseComponent);
            var _proto = ChildComponent.prototype;
            return _proto.hasValidParentDomain = function() {
                return Object(cross_domain_utils_src.A)(this.component.allowedParentDomains, this.getParentDomain());
            }, _proto.init = function() {
                return this.onInit;
            }, _proto.getParentDomain = function() {
                return window_getParentDomain();
            }, _proto.onProps = function(handler) {
                this.onPropHandlers.push(handler);
            }, _proto.getParentComponentWindow = function() {
                return window_getParentComponentWindow();
            }, _proto.getParentRenderWindow = function() {
                return window_getParentRenderWindow();
            }, _proto.getInitialProps = function() {
                var _this2 = this, componentMeta = getComponentMeta(), props = componentMeta.props;
                if (props.type === constants.INITIAL_PROPS.RAW) props = props.value; else {
                    if (props.type !== constants.INITIAL_PROPS.UID) throw new Error("Unrecognized props type: " + props.type);
                    var parentComponentWindow = window_getParentComponentWindow();
                    if (!Object(cross_domain_utils_src.u)(parentComponentWindow)) {
                        if ("file:" === window.location.protocol) throw new Error("Can not get props from file:// domain");
                        throw new Error("Parent component window is on a different domain - expected " + Object(cross_domain_utils_src.g)() + " - can not retrieve props");
                    }
                    var global = Object(lib.w)(parentComponentWindow);
                    if (!global) throw new Error("Can not find global for parent component - can not retrieve props");
                    props = JSON.parse(global.props[componentMeta.uid]);
                }
                if (!props) throw new Error("Initial props not found");
                return Object(lib.k)(props, function(_ref6) {
                    var fullKey = _ref6.fullKey, self = _ref6.self, args = _ref6.args;
                    return _this2.onInit.then(function() {
                        var func = Object(lib.s)(_this2.props, fullKey);
                        if ("function" != typeof func) throw new TypeError("Expected " + fullKey + " to be function, got " + typeof func);
                        return func.apply(self, args);
                    });
                });
            }, _proto.setProps = function(props, origin, required) {
                void 0 === required && (required = !0), this.props = this.props || {};
                var normalizedProps = function(component, props, origin, required) {
                    void 0 === required && (required = !0);
                    for (var result = {}, _i2 = 0, _Object$keys2 = Object.keys(props); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2], prop = component.getProp(key), value = props[key];
                        prop && prop.sameDomain && origin !== Object(cross_domain_utils_src.g)(window) || (result[key] = normalizeChildProp(component, 0, key, value), 
                        prop && prop.alias && !result[prop.alias] && (result[prop.alias] = value));
                    }
                    if (required) for (var _i4 = 0, _component$getPropNam2 = component.getPropNames(); _i4 < _component$getPropNam2.length; _i4++) {
                        var _key = _component$getPropNam2[_i4];
                        props.hasOwnProperty(_key) || (result[_key] = normalizeChildProp(component, 0, _key, props[_key]));
                    }
                    return result;
                }(this.component, props, origin, required);
                Object(lib.q)(this.props, normalizedProps), this.props.logLevel && Object(lib.O)(this.props.logLevel);
                for (var _i6 = 0, _this$onPropHandlers2 = this.onPropHandlers; _i6 < _this$onPropHandlers2.length; _i6++) _this$onPropHandlers2[_i6].call(this, this.props);
            }, _proto.sendToParent = function(name, data, options) {
                void 0 === data && (data = {}), void 0 === options && (options = {});
                var parentWindow = window_getParentComponentWindow();
                if (!parentWindow) throw new Error("Can not find parent component window to message");
                return this.component.log("send_to_parent_" + name), Object(src.send)(parentWindow, name, data, Object(esm_extends.a)({
                    domain: window_getParentDomain()
                }, options));
            }, _proto.setWindows = function() {
                if (window.__activeZoidComponent__) throw this.component.createError("Can not attach multiple components to the same window");
                if (window.__activeZoidComponent__ = this, !window_getParentComponentWindow()) throw this.component.createError("Can not find parent window");
                var componentMeta = getComponentMeta();
                if (componentMeta.tag !== this.component.tag) throw this.component.createError("Parent is " + componentMeta.tag + " - can not attach " + this.component.tag);
                this.watchForClose();
            }, _proto.watchForClose = function() {
                var _this3 = this;
                window.addEventListener("unload", function() {
                    return _this3.checkClose();
                });
            }, _proto.enableAutoResize = function(_temp) {
                var _ref7 = void 0 === _temp ? {} : _temp, _ref7$width = _ref7.width, _ref7$height = _ref7.height;
                this.autoResize = {
                    width: void 0 === _ref7$width || _ref7$width,
                    height: void 0 === _ref7$height || _ref7$height
                }, this.watchForResize();
            }, _proto.getAutoResize = function() {
                var width = !1, height = !1, autoResize = this.autoResize || this.component.autoResize;
                return "object" == typeof autoResize ? (width = Boolean(autoResize.width), height = Boolean(autoResize.height)) : autoResize && (width = !0, 
                height = !0), {
                    width: width,
                    height: height,
                    element: autoResize.element ? Object(lib.u)(autoResize.element) : document.body
                };
            }, _proto.watchForResize = function() {
                var _this4 = this, _this$getAutoResize = this.getAutoResize(), width = _this$getAutoResize.width, height = _this$getAutoResize.height, element = _this$getAutoResize.element;
                (width || height) && this.context !== constants.CONTEXT_TYPES.POPUP && (this.watchingForResize || (this.watchingForResize = !0, 
                Object(belter_src.e)(element, function(_ref8) {
                    _this4.resize(width ? _ref8.width : void 0, height ? _ref8.height : void 0);
                }, {
                    width: width,
                    height: height
                })));
            }, _proto.exports = function() {
                var self = this;
                return {
                    updateProps: function(props) {
                        var _this5 = this;
                        return zalgo_promise_src.a.try(function() {
                            return self.setProps(props, _this5.origin, !1);
                        });
                    },
                    close: function() {
                        return zalgo_promise_src.a.try(function() {
                            return self.destroy();
                        });
                    }
                };
            }, _proto.resize = function(width, height) {
                var _this6 = this;
                return zalgo_promise_src.a.resolve().then(function() {
                    if (_this6.component.log("resize", {
                        width: Object(lib.R)(width),
                        height: Object(lib.R)(height)
                    }), _this6.context !== constants.CONTEXT_TYPES.POPUP) return _this6.sendToParent(constants.POST_MESSAGE.RESIZE, {
                        width: width,
                        height: height
                    }).then(lib.F);
                });
            }, _proto.hide = function() {
                return this.sendToParent(constants.POST_MESSAGE.HIDE).then(lib.F);
            }, _proto.show = function() {
                return this.sendToParent(constants.POST_MESSAGE.SHOW).then(lib.F);
            }, _proto.userClose = function() {
                return this.close(constants.CLOSE_REASONS.USER_CLOSED);
            }, _proto.close = function(reason) {
                void 0 === reason && (reason = constants.CLOSE_REASONS.CHILD_CALL), this.component.log("close_child"), 
                this.sendToParent(constants.POST_MESSAGE.CLOSE, {
                    reason: reason
                });
            }, _proto.checkClose = function() {
                this.sendToParent(constants.POST_MESSAGE.CHECK_CLOSE, {}, {
                    fireAndForget: !0
                });
            }, _proto.destroy = function() {
                return Object(client.h)().then(function() {
                    window.close();
                });
            }, _proto.focus = function() {
                this.component.log("focus"), window.focus();
            }, _proto.error = function(err) {
                var stringifiedError = Object(lib.S)(err);
                return this.component.logError("error", {
                    error: stringifiedError
                }), this.sendToParent(constants.POST_MESSAGE.ERROR, {
                    error: stringifiedError
                }).then(lib.F);
            }, ChildComponent;
        }(base_BaseComponent);
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), 
            Constructor;
        }
        var _class, _class2, _temp, RENDER_DRIVERS = {};
        function validateProp(prop, key, value, props, required) {
            if (void 0 === required && (required = !0), null != value && "" !== value) {
                if (!value || "function" != typeof value.then || !prop.promise) {
                    if ("function" === prop.type) {
                        if ("function" != typeof value) throw new TypeError("Prop is not of type function: " + key);
                    } else if ("string" === prop.type) {
                        if ("string" != typeof value) throw new TypeError("Prop is not of type string: " + key);
                    } else if ("object" === prop.type) try {
                        JSON.stringify(value);
                    } catch (err) {
                        throw new Error("Unable to serialize prop: " + key);
                    } else if ("number" === prop.type && isNaN(parseInt(value, 10))) throw new TypeError("Prop is not a number: " + key);
                    "function" == typeof prop.validate && value && prop.validate(value, props);
                }
            } else if (required && !1 !== prop.required && !prop.hasOwnProperty("def")) throw new Error("Prop is required: " + key);
        }
        function normalizeProp(component, instance, props, key, value) {
            var resultValue, prop = component.getProp(key);
            !(resultValue = prop.value ? prop.value : !prop.def || props.hasOwnProperty(key) && function(value) {
                return null != value && "" !== value;
            }(value) ? value : prop.def.call(component, props)) && prop.alias && props[prop.alias] && (resultValue = props[prop.alias]);
            var decorated = !1;
            prop.decorate && null != resultValue && (resultValue = prop.decorate.call(instance, resultValue, props), 
            decorated = !0);
            var type = prop.type;
            if ("boolean" === type) resultValue = Boolean(resultValue); else if ("function" === type) {
                if (!resultValue && prop.noop && (resultValue = lib.F, !decorated && prop.decorate && (resultValue = prop.decorate.call(instance, lib.F, props))), 
                resultValue && "function" == typeof resultValue) {
                    resultValue = resultValue.bind(instance), prop.denodeify && (resultValue = Object(lib.j)(resultValue)), 
                    prop.promisify && (resultValue = Object(lib.K)(resultValue));
                    var original = resultValue;
                    resultValue = function() {
                        return component.log("call_prop_" + key), original.apply(this, arguments);
                    }, prop.once && (resultValue = Object(lib.H)(resultValue)), prop.memoize && (resultValue = Object(lib.D)(resultValue));
                }
            } else "string" === type || "object" === type || "number" === type && void 0 !== resultValue && (resultValue = parseInt(resultValue, 10));
            return resultValue;
        }
        function getQueryParam(prop, key, value) {
            return zalgo_promise_src.a.try(function() {
                return "function" == typeof prop.queryParam ? prop.queryParam(value) : "string" == typeof prop.queryParam ? prop.queryParam : key;
            });
        }
        function getQueryValue(prop, key, value) {
            return zalgo_promise_src.a.try(function() {
                return "function" == typeof prop.queryValue ? prop.queryValue(value) : value;
            });
        }
        RENDER_DRIVERS[constants.CONTEXT_TYPES.IFRAME] = {
            focusable: !1,
            renderedIntoContainerTemplate: !0,
            allowResize: !0,
            openOnClick: !1,
            needsBridge: !1,
            open: function(url) {
                var _this = this, attributes = this.component.attributes.iframe || {};
                return this.iframe = Object(lib.y)({
                    url: url,
                    attributes: Object(esm_extends.a)({
                        name: this.childWindowName,
                        title: this.component.name,
                        scrolling: this.component.scrolling ? "yes" : "no"
                    }, attributes),
                    class: [ constants.CLASS_NAMES.COMPONENT_FRAME, constants.CLASS_NAMES.INVISIBLE ]
                }, this.element), Object(lib.f)(this.iframe).then(function(frameWindow) {
                    _this.window = frameWindow;
                    var detectClose = function() {
                        return zalgo_promise_src.a.try(function() {
                            return _this.props.onClose(constants.CLOSE_REASONS.CLOSE_DETECTED);
                        }).finally(function() {
                            return _this.destroy();
                        });
                    }, iframeWatcher = Object(lib.W)(_this.iframe, detectClose), elementWatcher = Object(lib.W)(_this.element, detectClose);
                    _this.clean.register("destroyWindow", function() {
                        iframeWatcher.cancel(), elementWatcher.cancel(), Object(src.cleanUpWindow)(_this.window), 
                        delete _this.window, _this.iframe && (Object(lib.l)(_this.iframe), delete _this.iframe);
                    });
                });
            },
            openPrerender: function() {
                var _this2 = this, attributes = this.component.attributes.iframe || {};
                return this.prerenderIframe = Object(lib.y)({
                    attributes: Object(esm_extends.a)({
                        name: "__prerender__" + this.childWindowName,
                        scrolling: this.component.scrolling ? "yes" : "no"
                    }, attributes),
                    class: [ constants.CLASS_NAMES.PRERENDER_FRAME, constants.CLASS_NAMES.VISIBLE ]
                }, this.element), Object(lib.f)(this.prerenderIframe).then(function(prerenderFrameWindow) {
                    _this2.prerenderWindow = prerenderFrameWindow, _this2.clean.register("destroyPrerender", function() {
                        _this2.prerenderIframe && (Object(lib.l)(_this2.prerenderIframe), delete _this2.prerenderIframe);
                    });
                });
            },
            switchPrerender: function() {
                var _this3 = this;
                Object(lib.a)(this.prerenderIframe, constants.CLASS_NAMES.INVISIBLE), Object(lib.L)(this.prerenderIframe, constants.CLASS_NAMES.VISIBLE), 
                Object(lib.a)(this.iframe, constants.CLASS_NAMES.VISIBLE), Object(lib.L)(this.iframe, constants.CLASS_NAMES.INVISIBLE), 
                setTimeout(function() {
                    _this3.prerenderIframe && Object(lib.l)(_this3.prerenderIframe);
                }, 1e3);
            },
            delegateOverrides: {
                openContainer: constants.DELEGATE.CALL_DELEGATE,
                destroyComponent: constants.DELEGATE.CALL_DELEGATE,
                destroyContainer: constants.DELEGATE.CALL_DELEGATE,
                cancelContainerEvents: constants.DELEGATE.CALL_DELEGATE,
                createPrerenderTemplate: constants.DELEGATE.CALL_DELEGATE,
                elementReady: constants.DELEGATE.CALL_DELEGATE,
                showContainer: constants.DELEGATE.CALL_DELEGATE,
                showComponent: constants.DELEGATE.CALL_DELEGATE,
                hideContainer: constants.DELEGATE.CALL_DELEGATE,
                hideComponent: constants.DELEGATE.CALL_DELEGATE,
                hide: constants.DELEGATE.CALL_DELEGATE,
                show: constants.DELEGATE.CALL_DELEGATE,
                resize: constants.DELEGATE.CALL_DELEGATE,
                loadUrl: constants.DELEGATE.CALL_DELEGATE,
                hijackSubmit: constants.DELEGATE.CALL_DELEGATE,
                openPrerender: constants.DELEGATE.CALL_DELEGATE,
                switchPrerender: constants.DELEGATE.CALL_DELEGATE,
                renderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                openContainerFrame: constants.DELEGATE.CALL_ORIGINAL,
                getOutlet: constants.DELEGATE.CALL_ORIGINAL,
                open: function(original, override) {
                    return function() {
                        var _this4 = this;
                        return override.apply(this, arguments).then(function() {
                            if (_this4.clean.set("window", Object(cross_domain_utils_src.b)(window_getParentComponentWindow(), _this4.childWindowName)), 
                            !_this4.window) throw new Error("Unable to find parent component iframe window");
                        });
                    };
                }
            },
            resize: function(width, height) {
                width && (this.container.style.width = Object(lib.T)(width), this.element.style.width = Object(lib.T)(width)), 
                height && (this.container.style.height = Object(lib.T)(height), this.element.style.height = Object(lib.T)(height));
            },
            show: function() {
                Object(lib.Q)(this.element);
            },
            hide: function() {
                Object(lib.x)(this.element);
            },
            loadUrl: function(url) {
                this.iframe.setAttribute("src", url);
            }
        }, RENDER_DRIVERS[constants.CONTEXT_TYPES.POPUP] = {
            focusable: !0,
            renderedIntoContainerTemplate: !1,
            allowResize: !1,
            openOnClick: !0,
            needsBridge: !0,
            open: function(url) {
                var _this5 = this;
                return void 0 === url && (url = ""), zalgo_promise_src.a.try(function() {
                    var _ref = _this5.component.dimensions || {}, _ref$width = _ref.width, width = void 0 === _ref$width ? constants.DEFAULT_DIMENSIONS.WIDTH : _ref$width, _ref$height = _ref.height, height = void 0 === _ref$height ? constants.DEFAULT_DIMENSIONS.HEIGHT : _ref$height, _getPosition = function(_ref2) {
                        var width = _ref2.width, height = _ref2.height, x = 0, y = 0;
                        return width && (window.outerWidth ? x = Math.round((window.outerWidth - width) / 2) + window.screenX : window.screen.width && (x = Math.round((window.screen.width - width) / 2))), 
                        height && (window.outerHeight ? y = Math.round((window.outerHeight - height) / 2) + window.screenY : window.screen.height && (y = Math.round((window.screen.height - height) / 2))), 
                        {
                            x: x,
                            y: y
                        };
                    }({
                        width: width = Object(lib.G)(width, window.outerWidth),
                        height: height = Object(lib.G)(height, window.outerWidth)
                    }), x = _getPosition.x, y = _getPosition.y, attributes = _this5.component.attributes.popup || {};
                    _this5.window = Object(lib.I)(url || "", Object(esm_extends.a)({
                        name: _this5.childWindowName,
                        width: width,
                        height: height,
                        top: y,
                        left: x,
                        status: 1,
                        toolbar: 0,
                        menubar: 0,
                        resizable: 1,
                        scrollbars: 1
                    }, attributes)), _this5.prerenderWindow = _this5.window, _this5.clean.register("destroyWindow", function() {
                        _this5.window && (_this5.window.close(), Object(src.cleanUpWindow)(_this5.window), 
                        delete _this5.window, delete _this5.prerenderWindow);
                    }), _this5.resize(width, height);
                });
            },
            openPrerender: function() {
                return zalgo_promise_src.a.try(lib.F);
            },
            resize: function() {},
            hide: function() {
                throw new Error("Can not hide popup");
            },
            show: function() {
                throw new Error("Can not show popup");
            },
            delegateOverrides: {
                openContainer: constants.DELEGATE.CALL_DELEGATE,
                destroyContainer: constants.DELEGATE.CALL_DELEGATE,
                elementReady: constants.DELEGATE.CALL_DELEGATE,
                showContainer: constants.DELEGATE.CALL_DELEGATE,
                showComponent: constants.DELEGATE.CALL_DELEGATE,
                hideContainer: constants.DELEGATE.CALL_DELEGATE,
                hideComponent: constants.DELEGATE.CALL_DELEGATE,
                hide: constants.DELEGATE.CALL_DELEGATE,
                show: constants.DELEGATE.CALL_DELEGATE,
                cancelContainerEvents: constants.DELEGATE.CALL_DELEGATE,
                open: constants.DELEGATE.CALL_ORIGINAL,
                loadUrl: constants.DELEGATE.CALL_ORIGINAL,
                createPrerenderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                destroyComponent: constants.DELEGATE.CALL_ORIGINAL,
                resize: constants.DELEGATE.CALL_ORIGINAL,
                renderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                openContainerFrame: constants.DELEGATE.CALL_ORIGINAL,
                getOutlet: constants.DELEGATE.CALL_ORIGINAL
            },
            loadUrl: function(url) {
                if (Object(cross_domain_utils_src.u)(this.window)) try {
                    if (this.window.location && this.window.location.replace) return void this.window.location.replace(url);
                } catch (err) {}
                this.window.location = url;
            }
        }, lib.v.props = lib.v.props || {}, lib.v.windows = lib.v.windows || {};
        var component_class, component_class2, component_temp, parent_ParentComponent = (_temp = _class2 = function(_BaseComponent) {
            function ParentComponent(component, context, _ref) {
                var _this, props = _ref.props;
                (_this = _BaseComponent.call(this) || this).html = void 0, _this.context = void 0, 
                _this.props = void 0, _this.childWindowName = void 0, _this.onInit = void 0, _this.window = void 0, 
                _this.handledErrors = void 0, _this.container = void 0, _this.element = void 0, 
                _this.outlet = void 0, _this.iframe = void 0, _this.prerenderIframe = void 0, _this.prerenderWindow = void 0, 
                _this.childExports = void 0, _this.timeout = void 0, _this.component = component, 
                _this.validateParentDomain(), _this.context = context;
                try {
                    _this.setProps(props);
                } catch (err) {
                    throw props.onError && props.onError(err), err;
                }
                return _this.props.logLevel && Object(lib.O)(_this.props.logLevel), _this.childWindowName = _this.buildChildWindowName({
                    renderTo: window
                }), _this.registerActiveComponent(), _this.component.log("construct_parent"), _this.watchForUnload(), 
                _this.onInit = new zalgo_promise_src.a(), _this.onInit.catch(function(err) {
                    return _this.error(err);
                }), _this;
            }
            Object(inheritsLoose.a)(ParentComponent, _BaseComponent);
            var _proto = ParentComponent.prototype;
            return _proto.render = function(element, loadUrl) {
                var _this2 = this;
                return void 0 === loadUrl && (loadUrl = !0), this.tryInit(function() {
                    _this2.component.log("render_" + _this2.context, {
                        context: _this2.context,
                        element: element,
                        loadUrl: Object(lib.R)(loadUrl)
                    });
                    var tasks = {};
                    return tasks.onRender = _this2.props.onRender(), tasks.getDomain = _this2.getDomain(), 
                    tasks.elementReady = zalgo_promise_src.a.try(function() {
                        if (element) return _this2.elementReady(element);
                    }), tasks.openContainer = tasks.elementReady.then(function() {
                        return _this2.openContainer(element);
                    }), tasks.showContainer = tasks.openContainer.then(function() {
                        return _this2.showContainer();
                    }), tasks.openPrerender = tasks.openContainer.then(function() {
                        return _this2.openPrerender();
                    }), tasks.switchPrerender = zalgo_promise_src.a.all([ tasks.openPrerender, _this2.onInit ]).then(function() {
                        return _this2.switchPrerender();
                    }), tasks.open = _this2.driver.openOnClick ? _this2.open() : tasks.openContainer.then(function() {
                        return _this2.open();
                    }), tasks.listen = zalgo_promise_src.a.hash({
                        domain: tasks.getDomain,
                        open: tasks.open
                    }).then(function(_ref2) {
                        _this2.listen(_this2.window, _ref2.domain);
                    }), tasks.watchForClose = tasks.open.then(function() {
                        return _this2.watchForClose();
                    }), tasks.linkDomain = zalgo_promise_src.a.all([ tasks.getDomain, tasks.open ]).then(function(_ref3) {
                        var domain = _ref3[0];
                        if (src.bridge && "string" == typeof domain) return src.bridge.linkUrl(_this2.window, domain);
                    }), _this2.html || (tasks.createPrerenderTemplate = tasks.openPrerender.then(function() {
                        return _this2.createPrerenderTemplate();
                    }), tasks.showComponent = tasks.createPrerenderTemplate.then(function() {
                        return _this2.showComponent();
                    })), tasks.openBridge = zalgo_promise_src.a.all([ tasks.getDomain, tasks.open ]).then(function(_ref4) {
                        var domain = _ref4[0];
                        return _this2.openBridge("string" == typeof domain ? domain : null);
                    }), _this2.html ? tasks.loadHTML = tasks.open.then(function() {
                        return _this2.loadHTML();
                    }) : loadUrl && (tasks.buildUrl = _this2.buildUrl(), tasks.loadUrl = zalgo_promise_src.a.all([ tasks.buildUrl, tasks.open, tasks.linkDomain, tasks.listen, tasks.open, tasks.openBridge, tasks.createPrerenderTemplate ]).then(function(_ref5) {
                        return _this2.loadUrl(_ref5[0]);
                    }), tasks.runTimeout = tasks.loadUrl.then(function() {
                        return _this2.runTimeout();
                    })), zalgo_promise_src.a.hash(tasks);
                }).then(function() {
                    return _this2.props.onEnter();
                }).then(function() {
                    return _this2;
                });
            }, _proto.getOutlet = function() {
                var outlet = document.createElement("div");
                return Object(lib.a)(outlet, constants.CLASS_NAMES.OUTLET), outlet;
            }, _proto.validateParentDomain = function() {
                var domain = Object(cross_domain_utils_src.g)();
                if (!Object(cross_domain_utils_src.A)(this.component.allowedParentDomains, domain)) throw new src_error.c("Can not be rendered by domain: " + domain);
            }, _proto.renderTo = function(win, element) {
                var _this3 = this;
                return this.tryInit(function() {
                    if (win === window) return _this3.render(element);
                    if (!Object(cross_domain_utils_src.v)(window, win)) throw new Error("Can only renderTo an adjacent frame");
                    if (element && "string" != typeof element) throw new Error("Element passed to renderTo must be a string selector, got " + typeof element + " " + element);
                    return _this3.checkAllowRenderTo(win), _this3.component.log("render_" + _this3.context + "_to_win", {
                        element: Object(lib.R)(element),
                        context: _this3.context
                    }), _this3.childWindowName = _this3.buildChildWindowName({
                        renderTo: win
                    }), _this3.delegate(win), _this3.render(element);
                });
            }, _proto.prefetch = function() {
                var _this4 = this;
                return zalgo_promise_src.a.try(function() {
                    _this4.html = _this4.buildUrl().then(function(url) {
                        return Object(lib.J)(url).then(function(html) {
                            return '\n                        <base href="' + url.split("/").slice(0, 3).join("/") + '">\n\n                        ' + html + "\n\n                        <script>\n                            if (window.history && window.history.pushState) {\n                                window.history.pushState({}, '', '/" + url.split("/").slice(3).join("/") + "');\n                            }\n                        <\/script>\n                    ";
                        });
                    });
                });
            }, _proto.loadHTML = function() {
                var _this5 = this;
                return zalgo_promise_src.a.try(function() {
                    if (!_this5.html) throw new Error("Html not prefetched");
                    return _this5.html.then(function(html) {
                        return Object(lib.Y)(_this5.window, html);
                    });
                });
            }, _proto.checkAllowRenderTo = function(win) {
                if (!win) throw this.component.createError("Must pass window to renderTo");
                if (!Object(cross_domain_utils_src.u)(win)) {
                    var origin = Object(cross_domain_utils_src.g)(), domain = this.component.getDomain(null, this.props.env);
                    if (!domain) throw new Error("Could not determine domain to allow remote render");
                    if (!Object(cross_domain_utils_src.A)(domain, origin)) throw new Error("Can not render remotely to " + domain.toString() + " - can only render to " + origin);
                }
            }, _proto.registerActiveComponent = function() {
                var _this6 = this;
                ParentComponent.activeComponents.push(this), this.clean.register(function() {
                    ParentComponent.activeComponents.splice(ParentComponent.activeComponents.indexOf(_this6), 1);
                });
            }, _proto.getComponentParentRef = function() {
                if (this.component.getDomain(null, this.props.env) === Object(cross_domain_utils_src.g)(window)) {
                    var uid = Object(lib.U)();
                    return lib.v.windows = lib.v.windows || {}, lib.v.windows[uid] = window, this.clean.register(function() {
                        delete lib.v.windows[uid];
                    }), {
                        ref: constants.WINDOW_REFERENCES.GLOBAL,
                        uid: uid
                    };
                }
                return this.context === constants.CONTEXT_TYPES.POPUP ? {
                    ref: constants.WINDOW_REFERENCES.OPENER
                } : Object(cross_domain_utils_src.w)(window) ? {
                    ref: constants.WINDOW_REFERENCES.TOP
                } : {
                    ref: constants.WINDOW_REFERENCES.PARENT,
                    distance: Object(cross_domain_utils_src.f)(window)
                };
            }, _proto.getRenderParentRef = function(renderToWindow) {
                if (void 0 === renderToWindow && (renderToWindow = window), renderToWindow === window) return this.getComponentParentRef();
                var uid = Object(lib.U)();
                return lib.v.windows[uid] = renderToWindow, this.clean.register(function() {
                    delete lib.v.windows[uid];
                }), {
                    ref: constants.WINDOW_REFERENCES.GLOBAL,
                    uid: uid
                };
            }, _proto.buildChildWindowName = function(_temp2) {
                var _ref6$renderTo = (void 0 === _temp2 ? {} : _temp2).renderTo, renderTo = void 0 === _ref6$renderTo ? window : _ref6$renderTo, childDomain = this.component.getDomain(null, this.props.env), sameDomain = Object(cross_domain_utils_src.u)(renderTo), uid = Object(lib.U)(), tag = this.component.tag, sProps = Object(lib.N)(this.getPropsForChild()), componentParent = this.getComponentParentRef(), renderParent = this.getRenderParentRef(renderTo), props = sameDomain || this.component.unsafeRenderTo ? {
                    type: constants.INITIAL_PROPS.RAW,
                    value: sProps
                } : {
                    type: constants.INITIAL_PROPS.UID,
                    uid: uid
                };
                return props.type === constants.INITIAL_PROPS.UID && (lib.v.props[uid] = JSON.stringify(sProps), 
                this.clean.register(function() {
                    delete lib.v.props[uid];
                })), function(name, version, options) {
                    void 0 === options && (options = {}), options.id = Object(lib.U)(), options.domain = Object(cross_domain_utils_src.g)(window);
                    var str, encodedName = normalize(name), encodedVersion = normalize(version), encodedOptions = (str = JSON.stringify(options), 
                    base32_default.a.encode(str).replace(/\=/g, "").toLowerCase());
                    if (!encodedName) throw new Error("Invalid name: " + name + " - must contain alphanumeric characters");
                    if (!encodedVersion) throw new Error("Invalid version: " + version + " - must contain alphanumeric characters");
                    return [ "xcomponent", encodedName, encodedVersion, encodedOptions, "" ].join("__");
                }(this.component.name, this.component.version, {
                    uid: uid,
                    tag: tag,
                    componentParent: componentParent,
                    renderParent: renderParent,
                    props: props,
                    childDomain: childDomain
                });
            }, _proto.sendToParent = function(name, data) {
                if (!window_getParentComponentWindow()) throw new Error("Can not find parent component window to message");
                return this.component.log("send_to_parent_" + name), Object(src.send)(window_getParentComponentWindow(), name, data, {
                    domain: window_getParentDomain()
                });
            }, _proto.setProps = function(props, required) {
                void 0 === required && (required = !0), function(component, props, required) {
                    if (void 0 === required && (required = !0), (props = props || {}).env && "object" == typeof component.url && !component.url[props.env]) throw new Error("Invalid env: " + props.env);
                    for (var _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) {
                        var key = _component$getPropNam2[_i2], prop = component.getProp(key);
                        if (prop.alias && props.hasOwnProperty(prop.alias)) {
                            var value = props[prop.alias];
                            delete props[prop.alias], props[key] || (props[key] = value);
                        }
                    }
                    for (var _i4 = 0, _Object$keys2 = Object.keys(props); _i4 < _Object$keys2.length; _i4++) {
                        var _key = _Object$keys2[_i4], _prop = component.getProp(_key);
                        _prop && validateProp(_prop, _key, props[_key], props, required);
                    }
                    for (var _i6 = 0, _component$getPropNam4 = component.getPropNames(); _i6 < _component$getPropNam4.length; _i6++) {
                        var _key2 = _component$getPropNam4[_i6], _prop2 = component.getProp(_key2), _value2 = props[_key2];
                        _prop2 && !props.hasOwnProperty(_key2) && validateProp(_prop2, _key2, _value2, props, required);
                    }
                }(this.component, props, required), this.component.validate && this.component.validate(this.component, props), 
                this.props = this.props || {}, Object(lib.q)(this.props, function(component, instance, props) {
                    var result = {};
                    props = props || {};
                    for (var _i2 = 0, _Object$keys2 = Object.keys(props); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2];
                        result[key] = -1 !== component.getPropNames().indexOf(key) ? normalizeProp(component, instance, props, key, props[key]) : props[key];
                    }
                    for (var _i4 = 0, _component$getPropNam2 = component.getPropNames(); _i4 < _component$getPropNam2.length; _i4++) {
                        var _key = _component$getPropNam2[_i4];
                        if (!(props.hasOwnProperty(_key) || instance.props && instance.props.hasOwnProperty(_key))) {
                            var normalizedProp = normalizeProp(component, instance, props, _key, props[_key]);
                            void 0 !== normalizedProp && (result[_key] = normalizedProp);
                        }
                    }
                    return result;
                }(this.component, this, props));
            }, _proto.buildUrl = function() {
                var propsDef, props, params, _this7 = this;
                return zalgo_promise_src.a.all([ this.props.url, (propsDef = Object(esm_extends.a)({}, this.component.props, {}, this.component.builtinProps), 
                props = this.props, params = {}, zalgo_promise_src.a.all(Object.keys(props).map(function(key) {
                    var prop = propsDef[key];
                    if (prop) return zalgo_promise_src.a.resolve().then(function() {
                        var value = props[key];
                        if (value && prop.queryParam) return value;
                    }).then(function(value) {
                        if (value) return zalgo_promise_src.a.all([ getQueryParam(prop, key, value), getQueryValue(prop, 0, value) ]).then(function(_ref) {
                            var result, queryParam = _ref[0], queryValue = _ref[1];
                            if ("boolean" == typeof queryValue) result = "1"; else if ("string" == typeof queryValue) result = queryValue.toString(); else {
                                if ("function" == typeof queryValue) return;
                                if ("object" == typeof queryValue && null !== queryValue) {
                                    if ("json" !== prop.serialization) {
                                        result = Object(lib.m)(queryValue, key);
                                        for (var _i6 = 0, _Object$keys4 = Object.keys(result); _i6 < _Object$keys4.length; _i6++) {
                                            var dotkey = _Object$keys4[_i6];
                                            params[dotkey] = result[dotkey];
                                        }
                                        return;
                                    }
                                    result = JSON.stringify(queryValue);
                                } else "number" == typeof queryValue && (result = queryValue.toString());
                            }
                            params[queryParam] = result;
                        });
                    });
                })).then(function() {
                    return Object.keys(params).forEach(function(key) {
                        params[key] = escape(params[key]);
                    }), params;
                })) ]).then(function(_ref7) {
                    var url = _ref7[0], query = _ref7[1];
                    return url && !_this7.component.getValidDomain(url) ? url : zalgo_promise_src.a.try(function() {
                        return url || _this7.component.getUrl(_this7.props.env, _this7.props);
                    }).then(function(finalUrl) {
                        return query.xcomponent = "1", Object(lib.r)(finalUrl, {
                            query: query
                        });
                    });
                });
            }, _proto.getDomain = function() {
                var _this8 = this;
                return zalgo_promise_src.a.try(function() {
                    return _this8.props.url;
                }).then(function(url) {
                    return _this8.component.getDomain(url, _this8.props.env) || (_this8.component.buildUrl ? zalgo_promise_src.a.try(function() {
                        return _this8.component.buildUrl(_this8.props);
                    }).then(function(builtUrl) {
                        return _this8.component.getDomain(builtUrl, _this8.props.env);
                    }) : void 0);
                }).then(function(domain) {
                    if (!domain) throw new Error("Could not determine domain");
                    return domain;
                });
            }, _proto.getPropsForChild = function() {
                for (var result = {}, _i2 = 0, _Object$keys2 = Object.keys(this.props); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2], prop = this.component.getProp(key);
                    prop && !1 === prop.sendToChild || (result[key] = this.props[key]);
                }
                return result;
            }, _proto.updateProps = function(props) {
                var _this9 = this;
                return this.setProps(props, !1), this.onInit.then(function() {
                    if (_this9.childExports) return _this9.childExports.updateProps(_this9.getPropsForChild());
                    throw new Error("Child exports were not available");
                });
            }, _proto.openBridge = function(domain) {
                var _this10 = this;
                return zalgo_promise_src.a.try(function() {
                    if (src.bridge && _this10.driver.needsBridge) {
                        var needsBridgeParams = {
                            win: _this10.window
                        };
                        domain && (needsBridgeParams.domain = domain);
                        var needsBridge = src.bridge.needsBridge(needsBridgeParams), bridgeUrl = _this10.component.getBridgeUrl(_this10.props.env);
                        if (bridgeUrl) {
                            bridgeUrl = Object(lib.r)(bridgeUrl, {
                                query: {
                                    version: _this10.component.version
                                }
                            });
                            var bridgeDomain = _this10.component.getBridgeDomain(_this10.props.env);
                            if (!bridgeDomain) throw new Error("Can not determine domain for bridge");
                            return needsBridge ? src.bridge.openBridge(bridgeUrl, bridgeDomain).then(function(result) {
                                if (result) return result;
                            }) : void 0;
                        }
                        if (needsBridge && domain && !src.bridge.hasBridge(domain, domain)) throw new Error("Bridge url needed to render " + _this10.context);
                    }
                });
            }, _proto.open = function() {
                var _this11 = this;
                return zalgo_promise_src.a.try(function() {
                    return _this11.component.log("open_" + _this11.context, {
                        windowName: _this11.childWindowName
                    }), _this11.driver.open.call(_this11);
                });
            }, _proto.openPrerender = function() {
                var _this12 = this;
                return zalgo_promise_src.a.try(function() {
                    if (_this12.component.prerenderTemplate) return _this12.driver.openPrerender.call(_this12);
                });
            }, _proto.switchPrerender = function() {
                var _this13 = this;
                return zalgo_promise_src.a.try(function() {
                    if (_this13.prerenderWindow && _this13.driver.switchPrerender) return _this13.driver.switchPrerender.call(_this13);
                });
            }, _proto.elementReady = function(element) {
                return Object(lib.n)(element).then(lib.F);
            }, _proto.delegate = function(win) {
                var _this14 = this;
                this.component.log("delegate_" + this.context);
                for (var props = {
                    uid: this.props.uid,
                    dimensions: this.props.dimensions,
                    onClose: this.props.onClose,
                    onDisplay: this.props.onDisplay
                }, _i4 = 0, _this$component$getPr2 = this.component.getPropNames(); _i4 < _this$component$getPr2.length; _i4++) {
                    var propName = _this$component$getPr2[_i4];
                    this.component.getProp(propName).allowDelegate && (props[propName] = this.props[propName]);
                }
                for (var delegate = Object(src.send)(win, constants.POST_MESSAGE.DELEGATE + "_" + this.component.name, {
                    context: this.context,
                    env: this.props.env,
                    options: {
                        context: this.context,
                        childWindowName: this.childWindowName,
                        isWindowClosed: function() {
                            return Object(cross_domain_utils_src.y)(_this14.window);
                        },
                        props: props,
                        overrides: {
                            focus: function() {
                                return _this14.focus();
                            },
                            userClose: function() {
                                return _this14.userClose();
                            },
                            getDomain: function() {
                                return _this14.getDomain();
                            },
                            error: function(err) {
                                return _this14.error(err);
                            },
                            on: function(eventName, handler) {
                                return _this14.on(eventName, handler);
                            }
                        }
                    }
                }).then(function(_ref8) {
                    var data = _ref8.data;
                    return _this14.clean.register(data.destroy), data;
                }).catch(function(err) {
                    throw new Error("Unable to delegate rendering. Possibly the component is not loaded in the target window.\n\n" + Object(lib.S)(err));
                }), overrides = this.driver.delegateOverrides, _loop = function(_i6, _Object$keys4) {
                    var key = _Object$keys4[_i6], val = overrides[key];
                    if (val === constants.DELEGATE.CALL_ORIGINAL) return "continue";
                    var original = _this14[key];
                    _this14[key] = function() {
                        var _this15 = this, _arguments = arguments;
                        return delegate.then(function(data) {
                            var override = data.overrides[key];
                            if (val === constants.DELEGATE.CALL_DELEGATE) return override.apply(_this15, _arguments);
                            if ("function" == typeof val) return val(original, override).apply(_this15, _arguments);
                            throw new Error("Expected delgate to be CALL_ORIGINAL, CALL_DELEGATE, or factory method");
                        });
                    };
                }, _i6 = 0, _Object$keys4 = Object.keys(overrides); _i6 < _Object$keys4.length; _i6++) _loop(_i6, _Object$keys4);
            }, _proto.watchForClose = function() {
                var _this16 = this, closeWindowListener = Object(cross_domain_utils_src.B)(this.window, function() {
                    return _this16.component.log("detect_close_child"), zalgo_promise_src.a.try(function() {
                        return _this16.props.onClose(constants.CLOSE_REASONS.CLOSE_DETECTED);
                    }).finally(function() {
                        return _this16.destroy();
                    });
                }, 3e3);
                this.clean.register("destroyCloseWindowListener", closeWindowListener.cancel);
            }, _proto.watchForUnload = function() {
                var _this17 = this, onunload = Object(lib.H)(function() {
                    _this17.component.log("navigate_away"), Object(client.h)(), _this17.destroyComponent();
                }), unloadWindowListener = Object(lib.b)(window, "unload", onunload);
                this.clean.register("destroyUnloadWindowListener", unloadWindowListener.cancel);
            }, _proto.loadUrl = function(url) {
                var _this18 = this;
                return zalgo_promise_src.a.try(function() {
                    var _query;
                    return _this18.component.log("load_url"), window.location.href.split("#")[0] === url.split("#")[0] && (url = Object(lib.r)(url, {
                        query: (_query = {}, _query[Object(lib.U)()] = "1", _query)
                    })), _this18.driver.loadUrl.call(_this18, url);
                });
            }, _proto.hijack = function(targetElement) {
                targetElement.target = this.childWindowName;
            }, _proto.runTimeout = function() {
                var _this19 = this, timeout = this.props.timeout;
                if (timeout) {
                    var id = this.timeout = setTimeout(function() {
                        _this19.component.log("timed_out", {
                            timeout: timeout.toString()
                        });
                        var error = _this19.component.createError("Loading component timed out after " + timeout + " milliseconds");
                        _this19.onInit.reject(error), _this19.props.onTimeout(error);
                    }, timeout);
                    this.clean.register(function() {
                        clearTimeout(id), delete _this19.timeout;
                    });
                }
            }, _proto.listeners = function() {
                var _ref9;
                return (_ref9 = {})[constants.POST_MESSAGE.INIT] = function(source, data) {
                    return this.childExports = data.exports, this.onInit.resolve(this), this.timeout && clearTimeout(this.timeout), 
                    {
                        props: this.getPropsForChild(),
                        context: this.context
                    };
                }, _ref9[constants.POST_MESSAGE.CLOSE] = function(source, data) {
                    this.close(data.reason);
                }, _ref9[constants.POST_MESSAGE.CHECK_CLOSE] = function() {
                    this.checkClose();
                }, _ref9[constants.POST_MESSAGE.RESIZE] = function(source, data) {
                    var _this20 = this;
                    return zalgo_promise_src.a.try(function() {
                        if (_this20.driver.allowResize) return _this20.resize(data.width, data.height);
                    });
                }, _ref9[constants.POST_MESSAGE.HIDE] = function() {
                    this.hide();
                }, _ref9[constants.POST_MESSAGE.SHOW] = function() {
                    this.show();
                }, _ref9[constants.POST_MESSAGE.ERROR] = function(source, data) {
                    this.error(new Error(data.error));
                }, _ref9;
            }, _proto.resize = function(width, height) {
                var _this21 = this;
                return zalgo_promise_src.a.try(function() {
                    _this21.component.log("resize", {
                        height: Object(lib.R)(height),
                        width: Object(lib.R)(width)
                    }), _this21.driver.resize.call(_this21, width, height), _this21.props.onResize && _this21.props.onResize();
                });
            }, _proto.hide = function() {
                return this.container && Object(lib.x)(this.container), this.driver.hide.call(this);
            }, _proto.show = function() {
                return this.container && Object(lib.Q)(this.container), this.driver.show.call(this);
            }, _proto.checkClose = function() {
                var _this22 = this, closeWindowListener = Object(cross_domain_utils_src.B)(this.window, function() {
                    _this22.userClose();
                }, 50, 500);
                this.clean.register(closeWindowListener.cancel);
            }, _proto.userClose = function() {
                return this.close(constants.CLOSE_REASONS.USER_CLOSED);
            }, _proto.close = function(reason) {
                var _this23 = this;
                return void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL), zalgo_promise_src.a.try(function() {
                    return _this23.component.log("close", {
                        reason: reason
                    }), _this23.event.triggerOnce(constants.EVENTS.CLOSE), _this23.props.onClose(reason);
                }).then(function() {
                    return zalgo_promise_src.a.all([ _this23.closeComponent(), _this23.closeContainer() ]);
                }).then(function() {
                    return _this23.destroy();
                });
            }, _proto.closeContainer = function(reason) {
                var _this24 = this;
                return void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL), zalgo_promise_src.a.try(function() {
                    return _this24.event.triggerOnce(constants.EVENTS.CLOSE), _this24.props.onClose(reason);
                }).then(function() {
                    return zalgo_promise_src.a.all([ _this24.closeComponent(reason), _this24.hideContainer() ]);
                }).then(function() {
                    return _this24.destroyContainer();
                });
            }, _proto.destroyContainer = function() {
                var _this25 = this;
                return zalgo_promise_src.a.try(function() {
                    _this25.clean.run("destroyContainerEvents"), _this25.clean.run("destroyContainerTemplate");
                });
            }, _proto.closeComponent = function(reason) {
                var _this26 = this;
                void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL);
                var win = this.window;
                return zalgo_promise_src.a.try(function() {
                    return _this26.cancelContainerEvents();
                }).then(function() {
                    return _this26.event.triggerOnce(constants.EVENTS.CLOSE), _this26.props.onClose(reason);
                }).then(function() {
                    return _this26.hideComponent();
                }).then(function() {
                    return _this26.destroyComponent();
                }).then(function() {
                    _this26.childExports && _this26.context === constants.CONTEXT_TYPES.POPUP && !Object(cross_domain_utils_src.y)(win) && _this26.childExports.close().catch(lib.F);
                });
            }, _proto.destroyComponent = function() {
                this.clean.run("destroyUnloadWindowListener"), this.clean.run("destroyCloseWindowListener"), 
                this.clean.run("destroyContainerEvents"), this.clean.run("destroyWindow");
            }, _proto.showContainer = function() {
                var _this27 = this;
                return zalgo_promise_src.a.try(function() {
                    if (_this27.props.onDisplay) return _this27.props.onDisplay();
                }).then(function() {
                    if (_this27.container) return Object(lib.P)(_this27.container, constants.ANIMATION_NAMES.SHOW_CONTAINER, _this27.clean.register);
                });
            }, _proto.showComponent = function() {
                var _this28 = this;
                return zalgo_promise_src.a.try(function() {
                    if (_this28.props.onDisplay) return _this28.props.onDisplay();
                }).then(function() {
                    if (_this28.element) return Object(lib.P)(_this28.element, constants.ANIMATION_NAMES.SHOW_COMPONENT, _this28.clean.register);
                });
            }, _proto.hideContainer = function() {
                var _this29 = this;
                return zalgo_promise_src.a.try(function() {
                    return _this29.container ? Object(lib.c)(_this29.container, constants.ANIMATION_NAMES.HIDE_CONTAINER, _this29.clean.register) : zalgo_promise_src.a.resolve();
                });
            }, _proto.hideComponent = function() {
                var _this30 = this;
                return zalgo_promise_src.a.try(function() {
                    return _this30.element ? Object(lib.c)(_this30.element, constants.ANIMATION_NAMES.HIDE_COMPONENT, _this30.clean.register) : zalgo_promise_src.a.resolve();
                });
            }, _proto.focus = function() {
                if (!this.window || Object(cross_domain_utils_src.y)(this.window)) throw new Error("No window to focus");
                this.component.log("focus"), this.window.focus();
            }, _proto.createPrerenderTemplate = function() {
                var _this31 = this;
                return zalgo_promise_src.a.try(function() {
                    return _this31.component.prerenderTemplate ? zalgo_promise_src.a.try(function() {
                        return _this31.prerenderIframe ? Object(lib.e)(_this31.prerenderIframe).then(function() {
                            return _this31.prerenderWindow;
                        }) : _this31.prerenderWindow;
                    }).then(function(win) {
                        var doc, el;
                        try {
                            doc = win.document;
                        } catch (err) {
                            return;
                        }
                        try {
                            el = _this31.renderTemplate(_this31.component.prerenderTemplate, {
                                jsxDom: lib.C.bind(doc),
                                document: doc
                            });
                        } catch (err) {
                            return _this31.component.logError("preprender_error", {
                                err: err.stack ? err.stack : err.toString()
                            }), void console.error(err.stack ? err.stack : err);
                        }
                        try {
                            Object(lib.X)(win, el);
                        } catch (err) {
                            _this31.component.logError("preprender_error", {
                                err: err.stack ? err.stack : err.toString()
                            }), console.error(err.stack ? err.stack : err);
                        }
                        var _ref10 = "object" == typeof _this31.component.autoResize && null !== _this31.component.autoResize ? _this31.component.autoResize : {}, _ref10$width = _ref10.width, width = void 0 !== _ref10$width && _ref10$width, _ref10$height = _ref10.height, height = void 0 !== _ref10$height && _ref10$height, _ref10$element = _ref10.element, element = void 0 === _ref10$element ? "body" : _ref10$element;
                        (element = Object(belter_src.b)(element, doc)) && (width || height) && Object(belter_src.e)(element, function(_ref11) {
                            _this31.resize(width ? _ref11.width : void 0, height ? _ref11.height : void 0);
                        }, {
                            width: width,
                            height: height,
                            win: win
                        });
                    }) : zalgo_promise_src.a.resolve();
                });
            }, _proto.renderTemplate = function(renderer, options) {
                var _this32 = this;
                void 0 === options && (options = {});
                var _ref12 = this.component.dimensions || {}, _ref12$width = _ref12.width, width = void 0 === _ref12$width ? constants.DEFAULT_DIMENSIONS.WIDTH + "px" : _ref12$width, _ref12$height = _ref12.height, height = void 0 === _ref12$height ? constants.DEFAULT_DIMENSIONS.HEIGHT + "px" : _ref12$height;
                return renderer.call(this, Object(esm_extends.a)({
                    id: constants.CLASS_NAMES.ZOID + "-" + this.component.tag + "-" + this.props.uid,
                    props: renderer.__xdomain__ ? null : this.props,
                    tag: this.component.tag,
                    context: this.context,
                    outlet: this.getOutlet(),
                    CLASS: constants.CLASS_NAMES,
                    ANIMATION: constants.ANIMATION_NAMES,
                    CONTEXT: constants.CONTEXT_TYPES,
                    EVENT: constants.EVENTS,
                    actions: {
                        close: function() {
                            return _this32.userClose();
                        },
                        focus: function() {
                            return _this32.focus();
                        }
                    },
                    on: function(eventName, handler) {
                        return _this32.on(eventName, handler);
                    },
                    jsxDom: lib.C,
                    document: document,
                    dimensions: {
                        width: width,
                        height: height
                    }
                }, options));
            }, _proto.openContainer = function(element) {
                var _this33 = this;
                return zalgo_promise_src.a.try(function() {
                    var el;
                    if (!(el = element ? Object(lib.u)(element) : document.body)) throw new Error("Could not find element to open container into");
                    if (_this33.component.containerTemplate) {
                        var container = _this33.renderTemplate(_this33.component.containerTemplate, {
                            container: el
                        });
                        if (_this33.container = container, Object(lib.x)(_this33.container), Object(lib.d)(el, _this33.container), 
                        _this33.driver.renderedIntoContainerTemplate) {
                            if (_this33.element = _this33.getOutlet(), Object(lib.x)(_this33.element), !_this33.element) throw new Error("Could not find element to render component into");
                            Object(lib.x)(_this33.element);
                        }
                        _this33.clean.register("destroyContainerTemplate", function() {
                            _this33.container && _this33.container.parentNode && _this33.container.parentNode.removeChild(_this33.container), 
                            delete _this33.container;
                        });
                    } else if (_this33.driver.renderedIntoContainerTemplate) throw new Error("containerTemplate needed to render " + _this33.context);
                });
            }, _proto.cancelContainerEvents = function() {
                this.clean.run("destroyContainerEvents");
            }, _proto.destroy = function() {
                var _this34 = this;
                return zalgo_promise_src.a.try(function() {
                    if (_this34.clean.hasTasks()) return _this34.component.log("destroy"), Object(client.h)(), 
                    _this34.clean.all();
                });
            }, _proto.tryInit = function(method) {
                var _this35 = this;
                return zalgo_promise_src.a.try(method).catch(function(err) {
                    _this35.onInit.reject(err);
                }).then(function() {
                    return _this35.onInit;
                });
            }, _proto.error = function(err) {
                var _this36 = this;
                return zalgo_promise_src.a.try(function() {
                    if (_this36.handledErrors = _this36.handledErrors || [], -1 === _this36.handledErrors.indexOf(err)) return _this36.handledErrors.push(err), 
                    _this36.onInit.reject(err), _this36.destroy();
                }).then(function() {
                    if (_this36.props.onError) return _this36.props.onError(err);
                }).catch(function(errErr) {
                    throw new Error("An error was encountered while handling error:\n\n " + Object(lib.S)(err) + "\n\n" + Object(lib.S)(errErr));
                }).then(function() {
                    if (!_this36.props.onError) throw err;
                });
            }, ParentComponent.destroyAll = function() {
                for (var results = []; ParentComponent.activeComponents.length; ) results.push(ParentComponent.activeComponents[0].destroy());
                return zalgo_promise_src.a.all(results).then(lib.F);
            }, _createClass(ParentComponent, [ {
                key: "driver",
                get: function() {
                    if (!this.context) throw new Error("Context not set");
                    return RENDER_DRIVERS[this.context];
                }
            } ]), ParentComponent;
        }(base_BaseComponent), _class2.activeComponents = [], _applyDecoratedDescriptor((_class = _temp).prototype, "getOutlet", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "getOutlet"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "prefetch", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "prefetch"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "loadHTML", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "loadHTML"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "buildUrl", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "buildUrl"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "open", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "openPrerender", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "openPrerender"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "switchPrerender", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "switchPrerender"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "close", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "closeContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "closeContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "destroyContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "destroyContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "closeComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "closeComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "showContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "showContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "showComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "showComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "hideContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "hideContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "hideComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "hideComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "createPrerenderTemplate", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "createPrerenderTemplate"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "openContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "openContainer"), _class.prototype), 
        _class), delegate_DelegateComponent = function(_BaseComponent) {
            function DelegateComponent(component, source, options) {
                var _this;
                (_this = _BaseComponent.call(this) || this).source = void 0, _this.context = void 0, 
                _this.props = void 0, _this.focus = void 0, _this.userClose = void 0, _this.getDomain = void 0, 
                _this.error = void 0, _this.on = void 0, _this.childWindowName = void 0, _this.isWindowClosed = void 0, 
                _this.component = component, _this.clean.set("source", source), _this.context = options.context, 
                _this.props = {
                    uid: options.props.uid,
                    dimensions: options.props.dimensions,
                    onClose: options.props.onClose,
                    onDisplay: options.props.onDisplay
                };
                for (var _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) {
                    var propName = _component$getPropNam2[_i2];
                    _this.component.getProp(propName).allowDelegate && (_this.props[propName] = options.props[propName]);
                }
                _this.focus = function() {
                    return zalgo_promise_src.a.all([ _this.isWindowClosed().then(function(closed) {
                        closed || window.open("", _this.childWindowName);
                    }), options.overrides.focus.call(_assertThisInitialized(_this)) ]).then(lib.F);
                }, _this.clean.register("destroyFocusOverride", function() {
                    _this.focus = lib.F;
                }), _this.userClose = options.overrides.userClose, _this.getDomain = options.overrides.getDomain, 
                _this.error = options.overrides.error, _this.on = options.overrides.on;
                for (var _i4 = 0, _Object$keys2 = Object.keys(RENDER_DRIVERS[options.context].delegateOverrides); _i4 < _Object$keys2.length; _i4++) {
                    var key = _Object$keys2[_i4];
                    _this[key] = parent_ParentComponent.prototype[key];
                }
                return _this.childWindowName = options.childWindowName, _this.isWindowClosed = options.isWindowClosed, 
                parent_ParentComponent.prototype.registerActiveComponent.call(_assertThisInitialized(_this)), 
                _this.watchForClose(), _this;
            }
            Object(inheritsLoose.a)(DelegateComponent, _BaseComponent);
            var _proto = DelegateComponent.prototype;
            return _proto.watchForClose = function() {
                var _this2 = this, closeWindowListener = Object(cross_domain_utils_src.B)(this.source, function() {
                    return _this2.destroy();
                }, 3e3);
                this.clean.register("destroyCloseWindowListener", closeWindowListener.cancel);
            }, _proto.getOverrides = function(context) {
                for (var overrides = {}, self = this, _loop = function(_i6, _Object$keys4) {
                    var key = _Object$keys4[_i6];
                    overrides[key] = function() {
                        return parent_ParentComponent.prototype[key].apply(self, arguments);
                    };
                }, _i6 = 0, _Object$keys4 = Object.keys(RENDER_DRIVERS[context].delegateOverrides); _i6 < _Object$keys4.length; _i6++) _loop(_i6, _Object$keys4);
                return overrides;
            }, _proto.destroy = function() {
                return this.clean.all();
            }, _createClass(DelegateComponent, [ {
                key: "driver",
                get: function() {
                    if (!this.context) throw new Error("Context not set");
                    return RENDER_DRIVERS[this.context];
                }
            } ]), DelegateComponent;
        }(base_BaseComponent), drivers = __webpack_require__(24);
        function defaultContainerTemplate(_ref) {
            var id = _ref.id, CLASS = _ref.CLASS, outlet = _ref.outlet, jsxDom = _ref.jsxDom, _ref$dimensions = _ref.dimensions;
            return jsxDom("div", {
                id: id,
                class: CLASS.ZOID + " " + CLASS.ZOID + "-tag-" + _ref.tag + " " + CLASS.ZOID + "-context-" + _ref.context
            }, jsxDom("style", null, "\n                    #" + id + ", #" + id + " > ." + CLASS.OUTLET + " {\n                        width: " + _ref$dimensions.width + ";\n                        height: " + _ref$dimensions.height + ";\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        display: inline-block;\n                        position: relative;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe {\n                        height: 100%;\n                        width: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        transition: opacity .2s ease-in-out;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n                        opacity: 1;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n                        opacity: 0;\n                    }\n                "), outlet);
        }
        function defaultPrerenderTemplate(_ref) {
            var jsxDom = _ref.jsxDom;
            return jsxDom("html", null, jsxDom("head", null, jsxDom("style", null, "\n                        html, body {\n                            width: 100%;\n                            height: 100%;\n                            overflow: hidden;\n                            top: 0;\n                            left: 0;\n                            margin: 0;\n                            text-align: center;\n                        }\n\n                        .spinner {\n                            position: absolute;\n                            max-height: 60vmin;\n                            max-width: 60vmin;\n                            height: 40px;\n                            width: 40px;\n                            top: 50%;\n                            left: 50%;\n                            transform: translateX(-50%) translateY(-50%);\n                            z-index: 10;\n                        }\n\n                        .spinner .loader {\n                            height: 100%;\n                            width: 100%;\n                            box-sizing: border-box;\n                            border: 3px solid rgba(0, 0, 0, .2);\n                            border-top-color: rgba(33, 128, 192, 0.8);\n                            border-radius: 100%;\n                            animation: rotation .7s infinite linear;\n\n                        }\n\n                        @keyframes rotation {\n                            from {\n                                transform: rotate(0deg)\n                            }\n                            to {\n                                transform: rotate(359deg)\n                            }\n                        }\n                    ")), jsxDom("body", null, jsxDom("div", {
                class: "spinner"
            }, jsxDom("div", {
                id: "loader",
                class: "loader"
            }))));
        }
        var component_drivers = {
            angular: drivers.angular,
            angular2: drivers.angular2,
            glimmer: drivers.glimmer,
            react: drivers.react,
            vue: drivers.vue,
            script: drivers.script
        }, component_Component = (component_temp = component_class2 = function(_BaseComponent) {
            function Component(options) {
                var _this;
                if ((_this = _BaseComponent.call(this) || this).name = void 0, _this.looseProps = void 0, 
                _this.tag = void 0, _this.url = void 0, _this.domain = void 0, _this.bridgeUrl = void 0, 
                _this.bridgeDomain = void 0, _this.props = void 0, _this.builtinProps = void 0, 
                _this.dimensions = void 0, _this.scrolling = void 0, _this.autoResize = void 0, 
                _this.listenForResize = void 0, _this.defaultLogLevel = void 0, _this.allowedParentDomains = void 0, 
                _this.version = void 0, _this.defaultEnv = void 0, _this.buildUrl = void 0, _this.contexts = void 0, 
                _this.defaultContext = void 0, _this.containerTemplate = void 0, _this.prerenderTemplate = void 0, 
                _this.validate = void 0, _this.unsafeRenderTo = void 0, _this.driverCache = void 0, 
                _this.xchild = void 0, _this.xprops = void 0, function(options) {
                    if (!options) throw new Error("Expecred options to be passed");
                    if (!options.tag || !options.tag.match(/^[a-z0-9-]+$/)) throw new Error("Invalid options.tag: " + options.tag);
                    if (function(options) {
                        if (options.props && "object" != typeof options.props) throw new Error("Expected options.props to be an object");
                        if (options.props) for (var _i2 = 0, _Object$keys2 = Object.keys(options.props); _i2 < _Object$keys2.length; _i2++) {
                            var key = _Object$keys2[_i2], prop = options.props[key];
                            if (!prop || "object" != typeof prop) throw new Error("Expected options.props." + key + " to be an object");
                            if (!prop.type) throw new Error("Expected prop.type");
                            if (-1 === constants.PROP_TYPES_LIST.indexOf(prop.type)) throw new Error("Expected prop.type to be one of " + constants.PROP_TYPES_LIST.join(", "));
                            if (prop.required && prop.def) throw new Error("Required prop can not have a default value");
                        }
                    }(options), options.dimensions) {
                        if (options.dimensions && !Object(lib.B)(options.dimensions.width) && !Object(lib.A)(options.dimensions.width)) throw new Error("Expected options.dimensions.width to be a px or % string value");
                        if (options.dimensions && !Object(lib.B)(options.dimensions.height) && !Object(lib.A)(options.dimensions.height)) throw new Error("Expected options.dimensions.height to be a px or % string value");
                    }
                    if (options.contexts) {
                        for (var anyEnabled = !1, _i4 = 0, _Object$keys4 = Object.keys(options.contexts); _i4 < _Object$keys4.length; _i4++) {
                            var context = _Object$keys4[_i4];
                            if (-1 === constants.CONTEXT_TYPES_LIST.indexOf(context)) throw new Error("Unsupported context type: " + context);
                            (options.contexts && options.contexts[context] || options.contexts && void 0 === options.contexts[context]) && (anyEnabled = !0);
                        }
                        if (!anyEnabled) throw new Error("No context type is enabled");
                    }
                    if (options.defaultContext) {
                        if (-1 === constants.CONTEXT_TYPES_LIST.indexOf(options.defaultContext)) throw new Error("Unsupported context type: " + (options.defaultContext || "unknown"));
                        if (options.contexts && options.defaultContext && !options.contexts[options.defaultContext]) throw new Error("Disallowed default context type: " + (options.defaultContext || "unknown"));
                    }
                    if (options.url && options.buildUrl) throw new Error("Can not pass both options.url and options.buildUrl");
                    if (options.defaultEnv) {
                        if ("string" != typeof options.defaultEnv) throw new TypeError("Expected options.defaultEnv to be a string");
                        if (!options.buildUrl && "object" != typeof options.url) throw new Error("Expected options.url to be an object mapping env->url");
                        if (options.url && "object" == typeof options.url && !options.url[options.defaultEnv]) throw new Error("No url found for default env: " + options.defaultEnv);
                    }
                    if (options.url && "object" == typeof options.url) {
                        if (!options.defaultEnv) throw new Error("Must pass options.defaultEnv with env->url mapping");
                        for (var _i6 = 0, _Object$keys6 = Object.keys(options.url); _i6 < _Object$keys6.length; _i6++) {
                            var env = _Object$keys6[_i6];
                            if (!options.url[env]) throw new Error("No url specified for env: " + env);
                        }
                    }
                    if (options.prerenderTemplate && "function" != typeof options.prerenderTemplate) throw new Error("Expected options.prerenderTemplate to be a function");
                    if (options.containerTemplate && "function" != typeof options.containerTemplate) throw new Error("Expected options.containerTemplate to be a function");
                }(options), _this.addProp(options, "tag"), _this.addProp(options, "defaultLogLevel", "info"), 
                _this.addProp(options, "allowedParentDomains", constants.WILDCARD), Object(lib.O)(_this.defaultLogLevel), 
                Component.components[_this.tag]) throw new Error("Can not register multiple components with the same tag");
                return _this.addProp(options, "name", _this.tag.replace(/-/g, "_")), _this.builtinProps = {
                    env: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.defaultEnv;
                        }
                    },
                    uid: {
                        type: "string",
                        def: function() {
                            return Object(lib.U)();
                        },
                        queryParam: !0
                    },
                    logLevel: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.defaultLogLevel;
                        }
                    },
                    url: {
                        type: "string",
                        required: !1,
                        promise: !0,
                        sendToChild: !1
                    },
                    dimensions: {
                        type: "object",
                        required: !1
                    },
                    version: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.version;
                        }
                    },
                    timeout: {
                        type: "number",
                        required: !1,
                        sendToChild: !1
                    },
                    onDisplay: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        memoize: !0,
                        sendToChild: !1
                    },
                    onEnter: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onRender: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onClose: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        once: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onResize: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        sendToChild: !1
                    },
                    onTimeout: {
                        type: "function",
                        required: !1,
                        memoize: !0,
                        promisify: !0,
                        sendToChild: !1,
                        def: function() {
                            return function(err) {
                                if (this.props.onError) return this.props.onError(err);
                                throw err;
                            };
                        }
                    },
                    onError: {
                        type: "function",
                        required: !1,
                        promisify: !0,
                        sendToChild: !0,
                        once: !0,
                        def: function() {
                            return function(err) {
                                setTimeout(function() {
                                    throw err;
                                });
                            };
                        }
                    }
                }, _this.props = options.props || {}, options.props || (_this.looseProps = !0), 
                _this.addProp(options, "dimensions"), _this.addProp(options, "scrolling"), _this.addProp(options, "listenForResize"), 
                _this.addProp(options, "version", "latest"), _this.addProp(options, "defaultEnv"), 
                _this.addProp(options, "buildUrl"), _this.addProp(options, "url"), _this.addProp(options, "domain"), 
                _this.addProp(options, "bridgeUrl"), _this.addProp(options, "bridgeDomain"), _this.addProp(options, "attributes", {}), 
                _this.addProp(options, "contexts", {
                    iframe: !0,
                    popup: !1
                }), _this.addProp(options, "defaultContext"), _this.addProp(options, "autoResize", !1), 
                _this.addProp(options, "containerTemplate", defaultContainerTemplate), _this.addProp(options, "prerenderTemplate", defaultPrerenderTemplate), 
                _this.addProp(options, "validate"), _this.addProp(options, "unsafeRenderTo", !1), 
                Component.components[_this.tag] = _assertThisInitialized(_this), _this.registerDrivers(), 
                _this.registerChild(), _this.listenDelegate(), _this;
            }
            Object(inheritsLoose.a)(Component, _BaseComponent);
            var _proto = Component.prototype;
            return _proto.getPropNames = function() {
                for (var props = Object.keys(this.props), _i2 = 0, _Object$keys2 = Object.keys(this.builtinProps); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    -1 === props.indexOf(key) && props.push(key);
                }
                return props;
            }, _proto.getProp = function(name) {
                return this.props[name] || this.builtinProps[name];
            }, _proto.registerDrivers = function() {
                this.driverCache = {};
                for (var _i4 = 0, _Object$keys4 = Object.keys(component_drivers); _i4 < _Object$keys4.length; _i4++) {
                    var driverName = _Object$keys4[_i4];
                    if (0 !== driverName.indexOf("_")) {
                        var glob = component_drivers[driverName].global();
                        glob && this.driver(driverName, glob);
                    }
                }
            }, _proto.driver = function(name, dep) {
                if (!component_drivers[name]) throw new Error("Could not find driver for framework: " + name);
                return this.driverCache[name] || (this.driverCache[name] = component_drivers[name].register(this, dep)), 
                this.driverCache[name];
            }, _proto.registerChild = function() {
                var _this2 = this;
                return zalgo_promise_src.a.try(function() {
                    if (_this2.isChild()) return new child_ChildComponent(_this2);
                });
            }, _proto.listenDelegate = function() {
                var _this3 = this;
                Object(src.on)(constants.POST_MESSAGE.ALLOW_DELEGATE + "_" + this.name, function() {
                    return !0;
                }), Object(src.on)(constants.POST_MESSAGE.DELEGATE + "_" + this.name, function(_ref) {
                    var source = _ref.source, origin = _ref.origin, data = _ref.data, domain = _this3.getDomain(null, data.env || _this3.defaultEnv);
                    if (!domain) throw new Error("Could not determine domain to allow remote render");
                    if (!Object(cross_domain_utils_src.A)(domain, origin)) throw new Error("Can not render from " + origin + " - expected " + domain.toString());
                    var delegate = _this3.delegate(source, data.options);
                    return {
                        overrides: delegate.getOverrides(data.context),
                        destroy: function() {
                            return delegate.destroy();
                        }
                    };
                });
            }, _proto.canRenderTo = function(win) {
                return Object(src.send)(win, constants.POST_MESSAGE.ALLOW_DELEGATE + "_" + this.name).then(function(_ref2) {
                    return _ref2.data;
                }).catch(function() {
                    return !1;
                });
            }, _proto.getValidDomain = function(url) {
                if (url) {
                    var domain = Object(cross_domain_utils_src.h)(url);
                    if ("string" == typeof this.domain && domain === this.domain) return domain;
                    var domains = this.domain;
                    if (domains && "object" == typeof domains && !(domains instanceof RegExp)) for (var _i6 = 0, _Object$keys6 = Object.keys(domains); _i6 < _Object$keys6.length; _i6++) {
                        var env = _Object$keys6[_i6];
                        if ("test" !== env && domain === domains[env]) return domain;
                    }
                }
            }, _proto.getDomain = function(url, env) {
                var domain = this.getForEnv(this.domain, env);
                if (domain) return domain;
                if (domain = this.getValidDomain(url)) return domain;
                var envUrl = this.getForEnv(this.url, env);
                return envUrl ? Object(cross_domain_utils_src.h)(envUrl) : url ? Object(cross_domain_utils_src.h)(url) : void 0;
            }, _proto.getBridgeUrl = function(env) {
                return this.getForEnv(this.bridgeUrl, env);
            }, _proto.getForEnv = function(item, env) {
                if (item) {
                    if ("string" == typeof item || item instanceof RegExp) return item;
                    if (env || (env = this.defaultEnv), env) return env && "object" == typeof item && item[env] ? item[env] : void 0;
                }
            }, _proto.getBridgeDomain = function(env) {
                var bridgeDomain = this.getForEnv(this.bridgeDomain, env);
                if (bridgeDomain) return bridgeDomain;
                var bridgeUrl = this.getBridgeUrl(env);
                return bridgeUrl ? Object(cross_domain_utils_src.h)(bridgeUrl) : void 0;
            }, _proto.getUrl = function(env, props) {
                var url = this.getForEnv(this.url, env);
                if (url) return url;
                if (this.buildUrl) return this.buildUrl(props);
                throw new Error("Unable to get url");
            }, _proto.isZoidComponent = function() {
                return isZoidComponentWindow();
            }, _proto.isChild = function() {
                if (!isZoidComponentWindow()) return !1;
                var _getComponentMeta = getComponentMeta(), tag = _getComponentMeta.tag, childDomain = _getComponentMeta.childDomain;
                return (!childDomain || childDomain === Object(cross_domain_utils_src.g)()) && tag === this.tag;
            }, _proto.createError = function(message, tag) {
                return new Error("[" + (tag || this.tag) + "] " + message);
            }, _proto.init = function(props, context, element) {
                return new parent_ParentComponent(this, this.getRenderContext(context, element), {
                    props: props
                });
            }, _proto.delegate = function(source, options) {
                return new delegate_DelegateComponent(this, source, options);
            }, _proto.validateRenderContext = function(context, element) {
                if (context && !this.contexts[context]) throw new Error("[" + this.tag + "] Can not render to " + context);
                if (!element && context === constants.CONTEXT_TYPES.IFRAME) throw new Error("[" + this.tag + "] Context type " + constants.CONTEXT_TYPES.IFRAME + " requires an element selector");
            }, _proto.getDefaultContext = function() {
                if (this.defaultContext) return this.defaultContext;
                if (this.contexts[constants.CONTEXT_TYPES.IFRAME]) return constants.CONTEXT_TYPES.IFRAME;
                if (this.contexts[constants.CONTEXT_TYPES.POPUP]) return constants.CONTEXT_TYPES.POPUP;
                throw new Error("Can not determine default context");
            }, _proto.getRenderContext = function(context, element) {
                return context = context || this.getDefaultContext(), this.validateRenderContext(context, element), 
                context;
            }, _proto.render = function(props, element) {
                var _this4 = this;
                return zalgo_promise_src.a.try(function() {
                    return new parent_ParentComponent(_this4, _this4.getRenderContext(null, element), {
                        props: props
                    }).render(element);
                });
            }, _proto.renderIframe = function(props, element) {
                var _this5 = this;
                return zalgo_promise_src.a.try(function() {
                    return new parent_ParentComponent(_this5, _this5.getRenderContext(constants.CONTEXT_TYPES.IFRAME, element), {
                        props: props
                    }).render(element);
                });
            }, _proto.renderPopup = function(props) {
                var _this6 = this;
                return zalgo_promise_src.a.try(function() {
                    return new parent_ParentComponent(_this6, _this6.getRenderContext(constants.CONTEXT_TYPES.POPUP), {
                        props: props
                    }).render();
                });
            }, _proto.renderTo = function(win, props, element) {
                var _this7 = this;
                return zalgo_promise_src.a.try(function() {
                    return new parent_ParentComponent(_this7, _this7.getRenderContext(null, element), {
                        props: props
                    }).renderTo(win, element);
                });
            }, _proto.renderIframeTo = function(win, props, element) {
                var _this8 = this;
                return zalgo_promise_src.a.try(function() {
                    return new parent_ParentComponent(_this8, _this8.getRenderContext(constants.CONTEXT_TYPES.IFRAME, element), {
                        props: props
                    }).renderTo(win, element);
                });
            }, _proto.renderPopupTo = function(win, props) {
                var _this9 = this;
                return zalgo_promise_src.a.try(function() {
                    return new parent_ParentComponent(_this9, _this9.getRenderContext(constants.CONTEXT_TYPES.POPUP), {
                        props: props
                    }).renderTo(win);
                });
            }, _proto.prerender = function(props, element) {
                var instance = new parent_ParentComponent(this, this.getRenderContext(null, element), {
                    props: props
                });
                return instance.prefetch(), {
                    render: function(innerProps, innerElement) {
                        return innerProps && instance.updateProps(innerProps), instance.render(innerElement);
                    },
                    renderTo: function(win, innerProps, innerElement) {
                        return innerProps && instance.updateProps(innerProps), instance.renderTo(win, innerElement);
                    },
                    get html() {
                        return instance.html;
                    },
                    set html(value) {
                        instance.html = value;
                    }
                };
            }, _proto.log = function(event, payload) {
                void 0 === payload && (payload = {}), Object(lib.z)(this.name, event, payload);
            }, _proto.logWarning = function(event, payload) {
                Object(lib.V)(this.name, event, payload);
            }, _proto.logError = function(event, payload) {
                Object(lib.o)(this.name, event, payload);
            }, Component.getByTag = function(tag) {
                return Component.components[tag];
            }, Component;
        }(base_BaseComponent), component_class2.components = {}, _applyDecoratedDescriptor((component_class = component_temp).prototype, "getPropNames", [ lib.D ], Object.getOwnPropertyDescriptor(component_class.prototype, "getPropNames"), component_class.prototype), 
        component_class);
        function create(options) {
            return new component_Component(options);
        }
        function getByTag(tag) {
            return component_Component.getByTag(tag);
        }
        function interface_destroyAll() {
            return parent_ParentComponent.destroyAll();
        }
        var postRobot = src, CONSTANTS = constants;
        __webpack_require__.d(__webpack_exports__, "c", function() {
            return create;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return interface_destroyAll;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return CONSTANTS;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return src_error.b;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype), subClass.prototype.constructor = subClass, 
            subClass.__proto__ = superClass;
        }
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return _inheritsLoose;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var src = __webpack_require__(7), conf = __webpack_require__(10), lib = __webpack_require__(14), global = __webpack_require__(9);
        function deleteTunnelWindow(id) {
            try {
                global.a.tunnelWindows[id] && delete global.a.tunnelWindows[id].source;
            } catch (err) {}
            delete global.a.tunnelWindows[id];
        }
        function getTunnelWindow(id) {
            return global.a.tunnelWindows[id];
        }
        global.a.tunnelWindows = global.a.tunnelWindows || {}, global.a.tunnelWindowId = 0, 
        global.a.openTunnelToParent = function(_ref2) {
            var name = _ref2.name, source = _ref2.source, canary = _ref2.canary, sendMessage = _ref2.sendMessage, parentWindow = Object(src.m)(window);
            if (!parentWindow) throw new Error("No parent window found to open tunnel to");
            var id = function(_ref) {
                var name = _ref.name, source = _ref.source, canary = _ref.canary, sendMessage = _ref.sendMessage;
                return function() {
                    for (var tunnelWindows = global.a.tunnelWindows, _i2 = 0, _Object$keys2 = Object.keys(tunnelWindows); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2], tunnelWindow = tunnelWindows[key];
                        try {
                            Object(lib.j)(tunnelWindow.source);
                        } catch (err) {
                            deleteTunnelWindow(key);
                            continue;
                        }
                        Object(src.y)(tunnelWindow.source) && deleteTunnelWindow(key);
                    }
                }(), global.a.tunnelWindowId += 1, global.a.tunnelWindows[global.a.tunnelWindowId] = {
                    name: name,
                    source: source,
                    canary: canary,
                    sendMessage: sendMessage
                }, global.a.tunnelWindowId;
            }({
                name: name,
                source: source,
                canary: canary,
                sendMessage: sendMessage
            });
            return global.a.send(parentWindow, conf.b.POST_MESSAGE_NAMES.OPEN_TUNNEL, {
                name: name,
                sendMessage: function() {
                    var tunnelWindow = getTunnelWindow(id);
                    try {
                        Object(lib.j)(tunnelWindow && tunnelWindow.source);
                    } catch (err) {
                        return void deleteTunnelWindow(id);
                    }
                    if (tunnelWindow && tunnelWindow.source && !Object(src.y)(tunnelWindow.source)) {
                        try {
                            tunnelWindow.canary();
                        } catch (err) {
                            return;
                        }
                        tunnelWindow.sendMessage.apply(this, arguments);
                    }
                }
            }, {
                domain: conf.b.WILDCARD
            });
        };
        var zalgo_promise_src = __webpack_require__(1), cross_domain_safe_weakmap_src = __webpack_require__(17);
        function needsBridgeForBrowser() {
            return !!Object(src.o)(window).match(/MSIE|trident|edge\/12|edge\/13/i) || !conf.a.ALLOW_POSTMESSAGE_POPUP;
        }
        function needsBridgeForWin(win) {
            return !Object(src.v)(window, win);
        }
        function needsBridgeForDomain(domain, win) {
            if (domain) {
                if (Object(src.g)() !== Object(src.h)(domain)) return !0;
            } else if (win && !Object(src.u)(win)) return !0;
            return !1;
        }
        function needsBridge(_ref) {
            var win = _ref.win, domain = _ref.domain;
            return !(!needsBridgeForBrowser() || domain && !needsBridgeForDomain(domain, win) || win && !needsBridgeForWin(win));
        }
        function getBridgeName(domain) {
            var sanitizedDomain = (domain = domain || Object(src.h)(domain)).replace(/[^a-zA-Z0-9]+/g, "_");
            return conf.b.BRIDGE_NAME_PREFIX + "_" + sanitizedDomain;
        }
        function isBridge() {
            return Boolean(window.name && window.name === getBridgeName(Object(src.g)()));
        }
        var documentBodyReady = new zalgo_promise_src.a(function(resolve) {
            if (window.document && window.document.body) return resolve(window.document.body);
            var interval = setInterval(function() {
                if (window.document && window.document.body) return clearInterval(interval), resolve(window.document.body);
            }, 10);
        });
        function registerRemoteWindow(win) {
            global.a.remoteWindows.set(win, {
                sendMessagePromise: new zalgo_promise_src.a()
            });
        }
        function findRemoteWindow(win) {
            return global.a.remoteWindows.get(win);
        }
        function registerRemoteSendMessage(win, domain, sendMessage) {
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found to register sendMessage to");
            var sendMessageWrapper = function(remoteWin, message, remoteDomain) {
                if (remoteWin !== win) throw new Error("Remote window does not match window");
                if (!Object(src.A)(remoteDomain, domain)) throw new Error("Remote domain " + remoteDomain + " does not match domain " + domain);
                sendMessage(message);
            };
            remoteWindow.sendMessagePromise.resolve(sendMessageWrapper), remoteWindow.sendMessagePromise = zalgo_promise_src.a.resolve(sendMessageWrapper);
        }
        function rejectRemoteSendMessage(win, err) {
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found on which to reject sendMessage");
            remoteWindow.sendMessagePromise.asyncReject(err);
        }
        function sendBridgeMessage(win, message, domain) {
            var messagingChild = Object(src.s)(window, win), messagingParent = Object(src.s)(win, window);
            if (!messagingChild && !messagingParent) throw new Error("Can only send messages to and from parent and popup windows");
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found to send message to");
            return remoteWindow.sendMessagePromise.then(function(sendMessage) {
                return sendMessage(win, message, domain);
            });
        }
        global.a.remoteWindows = global.a.remoteWindows || new cross_domain_safe_weakmap_src.a();
        var awaitRemoteBridgeForWindow = Object(lib.r)(function(win) {
            return zalgo_promise_src.a.try(function() {
                for (var _i2 = 0, _getFrames2 = Object(src.j)(win); _i2 < _getFrames2.length; _i2++) {
                    var frame = _getFrames2[_i2];
                    try {
                        if (frame && frame !== window && Object(src.u)(frame) && frame[conf.b.WINDOW_PROPS.POSTROBOT]) return frame;
                    } catch (err) {
                        continue;
                    }
                }
                try {
                    var _frame = Object(src.i)(win, getBridgeName(Object(src.g)()));
                    if (!_frame) return;
                    return Object(src.u)(_frame) && _frame[conf.b.WINDOW_PROPS.POSTROBOT] ? _frame : new zalgo_promise_src.a(function(resolve) {
                        var interval, timeout;
                        interval = setInterval(function() {
                            if (_frame && Object(src.u)(_frame) && _frame[conf.b.WINDOW_PROPS.POSTROBOT]) return clearInterval(interval), 
                            clearTimeout(timeout), resolve(_frame);
                        }, 100), timeout = setTimeout(function() {
                            return clearInterval(interval), resolve();
                        }, 2e3);
                    });
                } catch (err) {}
            });
        });
        function openTunnelToOpener() {
            return zalgo_promise_src.a.try(function() {
                var opener = Object(src.l)(window);
                if (opener && needsBridge({
                    win: opener
                })) return registerRemoteWindow(opener), awaitRemoteBridgeForWindow(opener).then(function(bridge) {
                    return bridge ? window.name ? bridge[conf.b.WINDOW_PROPS.POSTROBOT].openTunnelToParent({
                        name: window.name,
                        source: window,
                        canary: function() {},
                        sendMessage: function(message) {
                            try {
                                Object(lib.j)(window);
                            } catch (err) {
                                return;
                            }
                            if (window && !window.closed) try {
                                global.a.receiveMessage({
                                    data: message,
                                    origin: this.origin,
                                    source: this.source
                                });
                            } catch (err) {
                                zalgo_promise_src.a.reject(err);
                            }
                        }
                    }).then(function(_ref) {
                        var source = _ref.source, origin = _ref.origin, data = _ref.data;
                        if (source !== opener) throw new Error("Source does not match opener");
                        registerRemoteSendMessage(source, origin, data.sendMessage);
                    }).catch(function(err) {
                        throw rejectRemoteSendMessage(opener, err), err;
                    }) : rejectRemoteSendMessage(opener, new Error("Can not register with opener: window does not have a name")) : rejectRemoteSendMessage(opener, new Error("Can not register with opener: no bridge found in opener"));
                });
            });
        }
        function hasBridge(url, domain) {
            return domain = domain || Object(src.h)(url), Boolean(global.a.bridges[domain]);
        }
        function openBridge(url, domain) {
            return domain = domain || Object(src.h)(url), global.a.bridges[domain] ? global.a.bridges[domain] : (global.a.bridges[domain] = zalgo_promise_src.a.try(function() {
                if (Object(src.g)() === domain) throw new Error("Can not open bridge on the same domain as current domain: " + domain);
                var name = getBridgeName(domain);
                if (Object(src.i)(window, name)) throw new Error("Frame with name " + name + " already exists on page");
                var iframe = function(name, url) {
                    var iframe = document.createElement("iframe");
                    return iframe.setAttribute("name", name), iframe.setAttribute("id", name), iframe.setAttribute("style", "display: none; margin: 0; padding: 0; border: 0px none; overflow: hidden;"), 
                    iframe.setAttribute("frameborder", "0"), iframe.setAttribute("border", "0"), iframe.setAttribute("scrolling", "no"), 
                    iframe.setAttribute("allowTransparency", "true"), iframe.setAttribute("tabindex", "-1"), 
                    iframe.setAttribute("hidden", "true"), iframe.setAttribute("title", ""), iframe.setAttribute("role", "presentation"), 
                    iframe.src = url, iframe;
                }(name, url);
                return global.a.bridgeFrames[domain] = iframe, documentBodyReady.then(function(body) {
                    body.appendChild(iframe);
                    var bridge = iframe.contentWindow;
                    return function(source, domain) {
                        global.a.on(conf.b.POST_MESSAGE_NAMES.OPEN_TUNNEL, {
                            window: bridge,
                            domain: domain
                        }, function(_ref) {
                            var origin = _ref.origin, data = _ref.data;
                            if (origin !== domain) throw new Error("Domain " + domain + " does not match origin " + origin);
                            if (!data.name) throw new Error("Register window expected to be passed window name");
                            if (!data.sendMessage) throw new Error("Register window expected to be passed sendMessage method");
                            if (!global.a.popupWindowsByName[data.name]) throw new Error("Window with name " + data.name + " does not exist, or was not opened by this window");
                            if (!global.a.popupWindowsByName[data.name].domain) throw new Error("We do not have a registered domain for window " + data.name);
                            if (global.a.popupWindowsByName[data.name].domain !== origin) throw new Error("Message origin " + origin + " does not matched registered window origin " + global.a.popupWindowsByName[data.name].domain);
                            return registerRemoteSendMessage(global.a.popupWindowsByName[data.name].win, domain, data.sendMessage), 
                            {
                                sendMessage: function(message) {
                                    if (window && !window.closed) {
                                        var winDetails = global.a.popupWindowsByName[data.name];
                                        if (winDetails) try {
                                            global.a.receiveMessage({
                                                data: message,
                                                origin: winDetails.domain,
                                                source: winDetails.win
                                            });
                                        } catch (err) {
                                            zalgo_promise_src.a.reject(err);
                                        }
                                    }
                                }
                            };
                        });
                    }(0, domain), new zalgo_promise_src.a(function(resolve, reject) {
                        iframe.onload = resolve, iframe.onerror = reject;
                    }).then(function() {
                        return Object(lib.k)(bridge, conf.a.BRIDGE_TIMEOUT, "Bridge " + url);
                    }).then(function() {
                        return bridge;
                    });
                });
            }), global.a.bridges[domain]);
        }
        global.a.bridges = global.a.bridges || {}, global.a.bridgeFrames = global.a.bridgeFrames || {}, 
        global.a.popupWindowsByWin = global.a.popupWindowsByWin || new cross_domain_safe_weakmap_src.a(), 
        global.a.popupWindowsByName = global.a.popupWindowsByName || {};
        var windowOpen = window.open;
        function linkUrl(win, url) {
            var winOptions = global.a.popupWindowsByWin.get(win);
            winOptions && (winOptions.domain = Object(src.h)(url), registerRemoteWindow(win));
        }
        function destroyBridges() {
            for (var _i4 = 0, _Object$keys4 = Object.keys(global.a.bridgeFrames); _i4 < _Object$keys4.length; _i4++) {
                var frame = global.a.bridgeFrames[_Object$keys4[_i4]];
                frame.parentNode && frame.parentNode.removeChild(frame);
            }
            global.a.bridgeFrames = {}, global.a.bridges = {};
        }
        window.open = function(url, name, options, last) {
            var domain = url;
            if (url && 0 === url.indexOf(conf.b.MOCK_PROTOCOL)) {
                var _url$split = url.split("|");
                domain = _url$split[0], url = _url$split[1];
            }
            domain && (domain = Object(src.h)(domain));
            var win = windowOpen.call(this, url, name, options, last);
            if (!win) return win;
            url && registerRemoteWindow(win);
            for (var _i2 = 0, _Object$keys2 = Object.keys(global.a.popupWindowsByName); _i2 < _Object$keys2.length; _i2++) {
                var winName = _Object$keys2[_i2];
                Object(src.y)(global.a.popupWindowsByName[winName].win) && delete global.a.popupWindowsByName[winName];
            }
            if (name && win) {
                var winOptions = global.a.popupWindowsByWin.get(win) || global.a.popupWindowsByName[name] || {};
                winOptions.name = winOptions.name || name, winOptions.win = winOptions.win || win, 
                winOptions.domain = winOptions.domain || domain, global.a.popupWindowsByWin.set(win, winOptions), 
                global.a.popupWindowsByName[name] = winOptions;
            }
            return win;
        }, __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", function() {
            return openTunnelToOpener;
        }), __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", function() {
            return needsBridgeForBrowser;
        }), __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", function() {
            return needsBridgeForWin;
        }), __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", function() {
            return needsBridgeForDomain;
        }), __webpack_require__.d(__webpack_exports__, "needsBridge", function() {
            return needsBridge;
        }), __webpack_require__.d(__webpack_exports__, "getBridgeName", function() {
            return getBridgeName;
        }), __webpack_require__.d(__webpack_exports__, "isBridge", function() {
            return isBridge;
        }), __webpack_require__.d(__webpack_exports__, "documentBodyReady", function() {
            return documentBodyReady;
        }), __webpack_require__.d(__webpack_exports__, "registerRemoteWindow", function() {
            return registerRemoteWindow;
        }), __webpack_require__.d(__webpack_exports__, "findRemoteWindow", function() {
            return findRemoteWindow;
        }), __webpack_require__.d(__webpack_exports__, "registerRemoteSendMessage", function() {
            return registerRemoteSendMessage;
        }), __webpack_require__.d(__webpack_exports__, "rejectRemoteSendMessage", function() {
            return rejectRemoteSendMessage;
        }), __webpack_require__.d(__webpack_exports__, "sendBridgeMessage", function() {
            return sendBridgeMessage;
        }), __webpack_require__.d(__webpack_exports__, "hasBridge", function() {
            return hasBridge;
        }), __webpack_require__.d(__webpack_exports__, "openBridge", function() {
            return openBridge;
        }), __webpack_require__.d(__webpack_exports__, "linkUrl", function() {
            return linkUrl;
        }), __webpack_require__.d(__webpack_exports__, "destroyBridges", function() {
            return destroyBridges;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function PopupOpenError(message) {
            this.message = message;
        }
        function IntegrationError(message) {
            this.message = message;
        }
        function RenderError(message) {
            this.message = message;
        }
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return PopupOpenError;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return IntegrationError;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return RenderError;
        }), PopupOpenError.prototype = Object.create(Error.prototype), IntegrationError.prototype = Object.create(Error.prototype), 
        RenderError.prototype = Object.create(Error.prototype);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var checkout = __webpack_require__(26), src = __webpack_require__(1);
        function awaitBraintreeClient(braintree, auth) {
            return src.a.resolve(auth).then(function(authorization) {
                return braintree.client.create({
                    authorization: authorization
                });
            }).then(function(client) {
                return braintree.paypalCheckout.create({
                    client: client
                });
            });
        }
        var SUPPORTED_REST_FIELDS = {
            intent: 1,
            transactions: [ {
                amount: {
                    total: 1,
                    currency: 1
                }
            } ],
            payer: {
                external_selected_funding_instrument_type: 1,
                shipping_address: {
                    line1: 1,
                    line2: 1,
                    city: 1,
                    state: 1,
                    postal_code: 1,
                    country_code: 1,
                    phone: 1,
                    recipient_name: 1
                }
            },
            application_context: {
                brand_name: 1,
                shipping_preference: 1,
                landing_page: 1
            }
        };
        function mapPaymentToBraintree(payment) {
            !function validate(obj, supported, name) {
                for (var supportedKeys = Object.keys(supported), _i2 = 0, _Object$keys2 = Object.keys(obj); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    if (-1 === supportedKeys.indexOf(key)) throw new Error("Unsupported REST key for Braintree: " + name + "." + key);
                    "object" == typeof obj[key] && validate(obj[key], supported[key], name + "." + key);
                }
            }(payment, SUPPORTED_REST_FIELDS, "payment");
            var btPayment = {};
            return btPayment.intent = payment.intent || "sale", btPayment.flow = "checkout", 
            btPayment.amount = payment.transactions[0].amount.total, btPayment.currency = payment.transactions[0].amount.currency, 
            payment.payer && ("CREDIT" === payment.payer.external_selected_funding_instrument_type && (btPayment.offerCredit = !0), 
            payment.payer.shipping_address && (btPayment.shippingAddressOverride = {
                line1: payment.payer.shipping_address.line1,
                line2: payment.payer.shipping_address.line2,
                city: payment.payer.shipping_address.city,
                state: payment.payer.shipping_address.state,
                postalCode: payment.payer.shipping_address.postal_code,
                countryCode: payment.payer.shipping_address.country_code,
                phone: payment.payer.shipping_address.phone,
                recipientName: payment.payer.shipping_address.recipient_name
            })), payment.application_context && (btPayment.displayName = payment.application_context.brand_name, 
            btPayment.landingPageType = payment.application_context.landing_page, payment.application_context && ("NO_SHIPPING" === payment.application_context.shipping_preference ? btPayment.enableShippingAddress = !1 : "GET_FROM_FILE" === payment.application_context.shipping_preference ? (btPayment.enableShippingAddress = !0, 
            btPayment.shippingAddressEditable = !0) : "SET_PROVIDED_ADDRESS" === payment.application_context.shipping_preference && (btPayment.enableShippingAddress = !0, 
            btPayment.shippingAddressEditable = !1))), btPayment;
        }
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return checkout.a;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return checkout.c;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return checkout.b;
        }), __webpack_require__.d(__webpack_exports__, "a", function() {
            return awaitBraintreeClient;
        }), __webpack_require__.d(__webpack_exports__, "e", function() {
            return mapPaymentToBraintree;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var _script__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29);
        __webpack_require__.d(__webpack_exports__, "script", function() {
            return _script__WEBPACK_IMPORTED_MODULE_0__.a;
        });
        var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30);
        __webpack_require__.d(__webpack_exports__, "react", function() {
            return _react__WEBPACK_IMPORTED_MODULE_1__.a;
        });
        var _vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31);
        __webpack_require__.d(__webpack_exports__, "vue", function() {
            return _vue__WEBPACK_IMPORTED_MODULE_2__.a;
        });
        var _angular__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32);
        __webpack_require__.d(__webpack_exports__, "angular", function() {
            return _angular__WEBPACK_IMPORTED_MODULE_3__.a;
        });
        var _ember__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33);
        __webpack_require__.o(_ember__WEBPACK_IMPORTED_MODULE_4__, "angular2") && __webpack_require__.d(__webpack_exports__, "angular2", function() {
            return _ember__WEBPACK_IMPORTED_MODULE_4__.angular2;
        }), __webpack_require__.o(_ember__WEBPACK_IMPORTED_MODULE_4__, "glimmer") && __webpack_require__.d(__webpack_exports__, "glimmer", function() {
            return _ember__WEBPACK_IMPORTED_MODULE_4__.glimmer;
        });
        var _glimmer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34);
        __webpack_require__.d(__webpack_exports__, "glimmer", function() {
            return _glimmer__WEBPACK_IMPORTED_MODULE_5__.a;
        });
        var _angular2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35);
        __webpack_require__.d(__webpack_exports__, "angular2", function() {
            return _angular2__WEBPACK_IMPORTED_MODULE_6__.a;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var checkoutComponentStyle = "\n\n    body {\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n        position: fixed;\n        top: 0;\n        left: 0;\n        margin: 0;\n    }\n\n    .spinner {\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        z-index: 10\n    }\n\n    .spinner .spinWrap {\n        width: 200px;\n        height: 100px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin-left: -100px;\n        margin-top: -50px\n    }\n\n    .spinner .loader,\n    .spinner .spinnerImage {\n        height: 100px;\n        width: 100px;\n        position: absolute;\n        top: 0;\n        left: 50%;\n        opacity: 1;\n        filter: alpha(opacity=100)\n    }\n\n    .spinner .spinnerImage {\n        margin: 28px 0 0 -25px;\n        background: url(https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png) no-repeat\n    }\n\n    .spinner .loader {\n        margin: 0 0 0 -55px;\n        background-color: transparent;\n        -webkit-animation: rotation .7s infinite linear;\n        -moz-animation: rotation .7s infinite linear;\n        -o-animation: rotation .7s infinite linear;\n        animation: rotation .7s infinite linear;\n        border-left: 5px solid #cbcbca;\n        border-right: 5px solid #cbcbca;\n        border-bottom: 5px solid #cbcbca;\n        border-top: 5px solid #2380be;\n        border-radius: 100%\n    }\n\n    @-webkit-keyframes rotation {\n        from {\n            -webkit-transform: rotate(0deg)\n        }\n        to {\n            -webkit-transform: rotate(359deg)\n        }\n    }\n    @-moz-keyframes rotation {\n        from {\n            -moz-transform: rotate(0deg)\n        }\n        to {\n            -moz-transform: rotate(359deg)\n        }\n    }\n    @-o-keyframes rotation {\n        from {\n            -o-transform: rotate(0deg)\n        }\n        to {\n            -o-transform: rotate(359deg)\n        }\n    }\n    @keyframes rotation {\n        from {\n            transform: rotate(0deg)\n        }\n        to {\n            transform: rotate(359deg)\n        }\n    }\n";
        function componentTemplate(_ref) {
            var jsxDom = _ref.jsxDom;
            return jsxDom("html", null, jsxDom("head", null, jsxDom("title", null, "PayPal"), jsxDom("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            })), jsxDom("body", null, jsxDom("div", {
                class: "preloader spinner"
            }, jsxDom("style", null, checkoutComponentStyle), jsxDom("div", {
                class: "spinWrap"
            }, jsxDom("p", {
                class: "spinnerImage"
            }), jsxDom("p", {
                class: "loader"
            })))));
        }
        var _LOGO_COLOR, src = __webpack_require__(16), zalgo_promise_src = __webpack_require__(1), resources = __webpack_require__(18), constants = __webpack_require__(0), lib = __webpack_require__(2), containerContent = __webpack_require__(27);
        function getContainerStyle(_ref) {
            var id = _ref.id, tag = _ref.tag, CONTEXT = _ref.CONTEXT, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION;
            return "\n        #" + id + " {\n            position: absolute;\n            z-index: 2147483647;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n\n            -webkit-transform: translate3d(0, 0, 0);\n            -moz-transform: translate3d(0, 0, 0);\n            -ms-transform: translate3d(0, 0, 0);\n            -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " {\n            background-color: black;\n            background-color: rgba(0, 0, 0, 0.75);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n\n            color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " {\n            background-color: white;\n            background-color: rgba(255, 255, 255, 0.4);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n\n            color: #333;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " a {\n            color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " a {\n            color: #333;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " .paypal-checkout-close:before,\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " .paypal-checkout-close:after {\n            background-color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " .paypal-checkout-close:before,\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " .paypal-checkout-close:after {\n            background-color: #111;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.POPUP + " {\n            cursor: pointer;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.POPUP + " {\n            cursor: pointer;\n        }\n\n        #" + id + " a {\n            text-decoration: none;\n        }\n\n        #" + id + ' .paypal-checkout-modal {\n            font-family: "HelveticaNeue", "HelveticaNeue-Light", "Helvetica Neue Light", helvetica, arial, sans-serif;\n            font-size: 14px;\n            text-align: center;\n\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            -ms-box-sizing: border-box;\n            box-sizing: border-box;\n            max-width: 350px;\n            top: 50%;\n            left: 50%;\n            position: absolute;\n            transform: translateX(-50%) translateY(-50%);\n            -webkit-transform: translateX(-50%) translateY(-50%);\n            -moz-transform: translateX(-50%) translateY(-50%);\n            -o-transform: translateX(-50%) translateY(-50%);\n            -ms-transform: translateX(-50%) translateY(-50%);\n            cursor: pointer;\n            text-align: center;\n        }\n\n        #' + id + "." + tag + "-loading .paypal-checkout-message, #" + id + "." + tag + "-loading .paypal-checkout-continue {\n            display: none;\n        }\n\n        .paypal-checkout-loader {\n            display: none;\n        }\n\n        #" + id + "." + tag + "-loading .paypal-checkout-loader {\n            display: block;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo {\n            cursor: pointer;\n            margin-bottom: 30px;\n            display: inline-block;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo img {\n            height: 36px;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo img.paypal-checkout-logo-pp {\n            margin-right: 10px;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-message {\n            font-size: 15px;\n            line-height: 1.5;\n            padding: 10px 0;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-message, #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-continue {\n            display: none;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-continue {\n            font-size: 15px;\n            line-height: 1.35;\n            padding: 10px 0;\n            font-weight: bold;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-continue a {\n            border-bottom: 1px solid currentColor;\n        }\n\n        #" + id + " .paypal-checkout-close {\n            position: absolute;\n            right: 16px;\n            top: 16px;\n            width: 16px;\n            height: 16px;\n            opacity: 0.6;\n        }\n\n        #" + id + "." + tag + "-loading .paypal-checkout-close {\n            display: none;\n        }\n\n        #" + id + " .paypal-checkout-close:hover {\n            opacity: 1;\n        }\n\n        #" + id + " .paypal-checkout-close:before, .paypal-checkout-close:after {\n            position: absolute;\n            left: 8px;\n            content: ' ';\n            height: 16px;\n            width: 2px;\n        }\n\n        #" + id + " .paypal-checkout-close:before {\n            transform: rotate(45deg);\n            -webkit-transform: rotate(45deg);\n            -moz-transform: rotate(45deg);\n            -o-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n        }\n\n        #" + id + " .paypal-checkout-close:after {\n            transform: rotate(-45deg);\n            -webkit-transform: rotate(-45deg);\n            -moz-transform: rotate(-45deg);\n            -o-transform: rotate(-45deg);\n            -ms-transform: rotate(-45deg);\n        }\n\n        #" + id + " .paypal-checkout-iframe-container {\n            display: none;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container > ." + CLASS.OUTLET + ",\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container > ." + CLASS.OUTLET + " > iframe {\n            max-height: calc(95vh - 60px);\n            max-width: 95vw;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container {\n\n            display: block;\n\n            position: absolute;\n\n            top: 50%;\n            left: 50%;\n\n            min-width: 450px;\n\n            transform: translate(-50%, -50%);\n            -webkit-transform: translate(-50%, -50%);\n            -moz-transform: translate(-50%, -50%);\n            -o-transform: translate(-50%, -50%);\n            -ms-transform: translate(-50%, -50%);\n\n            transform: translate3d(-50%, -50%, 0);\n            -webkit-transform: translate3d(-50%, -50%, 0);\n            -moz-transform: translate3d(-50%, -50%, 0);\n            -o-transform: translate3d(-50%, -50%, 0);\n            -ms-transform: translate3d(-50%, -50%, 0);\n\n            border-radius: 10px;\n            overflow: hidden;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n\n            position: relative;\n\n            -webkit-transition: all 0.3s ease;\n            -moz-transition: all 0.3s ease;\n            -ms-transition: all 0.3s ease;\n            -o-transition: all 0.3 ease;\n            transition: all 0.3s ease;\n\n            -webkit-animation-duration: 0.3s;\n            animation-duration: 0.3s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n\n            min-width: 450px;\n            max-width: 450px;\n            width: 450px;\n            height: 535px;\n\n            background-color: white;\n\n            overflow: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe {\n            position: absolute;\n            top: 0;\n            left: 0;\n            transition: opacity .4s ease-in-out;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.COMPONENT_FRAME + " {\n            z-index: 100;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.PRERENDER_FRAME + " {\n            z-index: 200;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n            opacity: 1;\n            z-index: 200;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n            opacity: 0;\n            z-index: 100;\n        }\n\n        @media screen and (-ms-high-contrast: active) {\n            #" + id + " .paypal-checkout-close {\n                opacity: 1;\n            }\n\n            #" + id + " .paypal-checkout-close:before , .paypal-checkout-close:after {\n                background-color: currentColor;\n            }\n        }\n\n        @media screen and (max-width: 470px) {\n\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n                min-width: 100%;\n                min-width: calc(100% - 20px);\n                min-width: -webkit-calc(100% - 20px);\n                min-width: -moz-calc(100% - 20px);\n                min-width: -o-calc(100% - 20px);\n                min-width: -ms-calc(100% - 20px);\n\n                max-width: 100%;\n                max-width: calc(100% - 20px);\n                max-width: -webkit-calc(100% - 20px);\n                max-width: -moz-calc(100% - 20px);\n                max-width: -o-calc(100% - 20px);\n                max-width: -ms-calc(100% - 20px);\n            }\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " iframe {\n            width: 1px;\n            min-width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes " + ANIMATION.SHOW_COMPONENT + " {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @keyframes " + ANIMATION.SHOW_COMPONENT + " {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @-webkit-keyframes " + ANIMATION.HIDE_COMPONENT + " {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        @keyframes " + ANIMATION.HIDE_COMPONENT + " {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        .paypal-spinner {\n            height: 30px;\n            width: 30px;\n            display: inline-block;\n            box-sizing: content-box;\n            opacity: 1;\n            filter: alpha(opacity=100);\n            -webkit-animation: rotation .7s infinite linear;\n            -moz-animation: rotation .7s infinite linear;\n            -o-animation: rotation .7s infinite linear;\n            animation: rotation .7s infinite linear;\n            border-left: 8px solid rgba(0, 0, 0, .2);\n            border-right: 8px solid rgba(0, 0, 0, .2);\n            border-bottom: 8px solid rgba(0, 0, 0, .2);\n            border-top: 8px solid #fff;\n            border-radius: 100%\n        }\n\n        @-webkit-keyframes rotation {\n            from {\n                -webkit-transform: rotate(0deg)\n            }\n            to {\n                -webkit-transform: rotate(359deg)\n            }\n        }\n        @-moz-keyframes rotation {\n            from {\n                -moz-transform: rotate(0deg)\n            }\n            to {\n                -moz-transform: rotate(359deg)\n            }\n        }\n        @-o-keyframes rotation {\n            from {\n                -o-transform: rotate(0deg)\n            }\n            to {\n                -o-transform: rotate(359deg)\n            }\n        }\n        @keyframes rotation {\n            from {\n                transform: rotate(0deg)\n            }\n            to {\n                transform: rotate(359deg)\n            }\n        }\n    ";
        }
        function getSandboxStyle(_ref) {
            var id = _ref.id, ANIMATION = _ref.ANIMATION;
            return "\n        #" + id + ".paypal-checkout-sandbox {\n            display: block;\n            position: fixed;\n            top: 0;\n            left: 0;\n\n            width: 100%;\n            height: 100%;\n            width: 100vw;\n            height: 100vh;\n            max-width: 100%;\n            max-height: 100%;\n            min-width: 100%;\n            min-height: 100%;\n\n            z-index: 2147483647;\n\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n\n            animation-fill-mode:forwards;\n            animation-iteration-count: 1;\n\n            -webkit-animation-fill-mode:forwards;\n            -webkit-animation-iteration-count: 1;\n        }\n\n        #" + id + ".paypal-checkout-sandbox .paypal-checkout-sandbox-iframe {\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes " + ANIMATION.SHOW_CONTAINER + " {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @keyframes " + ANIMATION.SHOW_CONTAINER + " {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @-webkit-keyframes " + ANIMATION.HIDE_CONTAINER + " {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n\n        @keyframes " + ANIMATION.HIDE_CONTAINER + " {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n    ";
        }
        var LOGO_COLOR = ((_LOGO_COLOR = {})[constants.q.BLACK] = constants.i.WHITE, _LOGO_COLOR[constants.q.WHITE] = constants.i.BLACK, 
        _LOGO_COLOR);
        function containerTemplate(_ref) {
            var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION, CONTEXT = _ref.CONTEXT, EVENT = _ref.EVENT, on = _ref.on, tag = _ref.tag, context = _ref.context, actions = _ref.actions, outlet = _ref.outlet, jsxDom = _ref.jsxDom, _props$locale$split = props.locale.split("_"), content = containerContent.a[_props$locale$split[1]][_props$locale$split[0]];
            function focus(event) {
                event.preventDefault(), event.stopPropagation(), Object(lib.F)() ? window.alert("Please switch tabs to reactivate the PayPal window") : zalgo_promise_src.a.try(actions.focus).catch(actions.close);
            }
            var overlayColor = (props.style || {}).overlayColor || constants.q.BLACK, logoColor = LOGO_COLOR[overlayColor], ppLogo = "function" == typeof resources.b.pp ? resources.b.pp({
                logoColor: logoColor
            }) : resources.b.pp[logoColor], paypalLogo = "function" == typeof resources.b.paypal ? resources.b.paypal({
                logoColor: logoColor
            }) : resources.b.paypal[logoColor], el = jsxDom("div", {
                id: id,
                onClick: focus,
                class: tag + "-context-" + context + " paypal-checkout-overlay " + tag + "-background-color-" + overlayColor + " " + tag + "-logo-color-" + logoColor
            }, jsxDom("a", {
                href: "#",
                class: "paypal-checkout-close",
                onClick: function(event) {
                    event.preventDefault(), event.stopPropagation(), actions.close();
                },
                "aria-label": "close",
                role: "button"
            }), jsxDom("div", {
                class: "paypal-checkout-modal"
            }, jsxDom("div", {
                class: "paypal-checkout-logo"
            }, jsxDom("img", {
                class: "paypal-checkout-logo-pp",
                alt: "pp",
                src: "data:image/svg+xml;base64," + Object(src.a)(ppLogo.toString())
            }), jsxDom("img", {
                class: "paypal-checkout-logo-paypal",
                alt: "paypal",
                src: "data:image/svg+xml;base64," + Object(src.a)(paypalLogo.toString())
            })), jsxDom("div", {
                class: "paypal-checkout-message"
            }, content.windowMessage), jsxDom("div", {
                class: "paypal-checkout-continue"
            }, jsxDom("a", {
                onClick: focus,
                href: "#"
            }, content.continue)), jsxDom("div", {
                class: "paypal-checkout-loader"
            }, jsxDom("div", {
                class: "paypal-spinner"
            }))), jsxDom("div", {
                class: "paypal-checkout-iframe-container"
            }, outlet), jsxDom("style", null, getContainerStyle({
                id: id,
                tag: tag,
                CONTEXT: CONTEXT,
                CLASS: CLASS,
                ANIMATION: ANIMATION
            }))), container = jsxDom("html", null, jsxDom("body", null, el));
            return on(EVENT.CLOSE, function() {
                el.className += " " + tag + "-loading";
            }), jsxDom("div", {
                id: id,
                class: "paypal-checkout-sandbox"
            }, jsxDom("style", null, getSandboxStyle({
                id: id,
                ANIMATION: ANIMATION
            })), jsxDom("iframe", {
                title: "PayPal Checkout Overlay",
                name: "__paypal_checkout_sandbox_" + id + "__",
                scrolling: "no",
                class: "paypal-checkout-sandbox-iframe"
            }, container));
        }
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return componentTemplate;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return getContainerStyle;
        }), __webpack_require__.d(__webpack_exports__, "d", function() {
            return getSandboxStyle;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return containerTemplate;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return determineParameterFromToken;
        }), __webpack_require__.d(__webpack_exports__, "c", function() {
            return getPaymentType;
        }), __webpack_require__.d(__webpack_exports__, "b", function() {
            return determineUrl;
        });
        var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3), _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
        function determineParameterFromToken(token) {
            return token && 0 === token.indexOf("BA-") ? "ba_token" : "token";
        }
        function getPaymentType(payment) {
            return 0 === payment.indexOf("BA-") ? _constants__WEBPACK_IMPORTED_MODULE_1__.B.BA_TOKEN : 0 === payment.indexOf("PAY-") || 0 === payment.indexOf("PAYID-") ? _constants__WEBPACK_IMPORTED_MODULE_1__.B.PAY_ID : (payment.indexOf("EC-"), 
            _constants__WEBPACK_IMPORTED_MODULE_1__.B.EC_TOKEN);
        }
        function determineUrl(env, fundingSource, payment) {
            return getPaymentType(payment) === _constants__WEBPACK_IMPORTED_MODULE_1__.B.BA_TOKEN ? _config__WEBPACK_IMPORTED_MODULE_0__.a.billingUrls[env] : fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.CARD || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.ELV ? _config__WEBPACK_IMPORTED_MODULE_0__.a.guestUrls[env] : fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.IDEAL || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.BANCONTACT || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.GIROPAY || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.SOFORT || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.EPS || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.MYBANK || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.P24 || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.ZIMPLER ? _config__WEBPACK_IMPORTED_MODULE_0__.a.altpayUrls[env] : _config__WEBPACK_IMPORTED_MODULE_0__.a.checkoutUrls[env];
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return containerContent;
        });
        var containerContent = {
            AT: {
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZW: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            YT: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            YE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            WS: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            WF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            VU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            VG: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            VE: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            VC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            VA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            UY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            UG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TT: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            TO: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            TM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            TD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            TC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            SZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SV: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            ST: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SR: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            SO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            SM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SL: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SC: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            SB: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            RW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            RS: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            RE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            QA: {
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PY: {
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            PW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PE: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            PA: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            OM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            NU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NR: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NP: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NI: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            NG: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            NC: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MV: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MT: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MS: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            MR: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MQ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ML: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            MK: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ME: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MD: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MC: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            MA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            LS: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LK: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            LA: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            KW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            KN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            KM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            KI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KH: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            JO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            JM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            IS: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HR: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            GY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            GW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GT: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            GP: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            GM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GL: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            GI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GD: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            GA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            FO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            FM: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FK: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            FJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ET: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ER: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            EG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            EC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            DZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            DO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            DM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            DJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CY: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CR: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CM: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CL: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CK: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CI: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BZ: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            BY: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BT: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BS: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            BN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            BG: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BB: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BA: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AW: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AL: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AI: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AG: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AE: {
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                }
            },
            GB: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AR: {
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            US: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Click to Continue"
                }
            },
            VN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            UA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TW: {
                zh: {
                    windowMessage: "看不到安全連線的 PayPal 瀏覽器？我們將會重新啟動視窗以完成付款。  ",
                    continue: "繼續"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            TR: {
                tr: {
                    windowMessage: "Güvenli PayPal tarayıcısını görmüyor musunuz? Alışverişinizi tamamlamak için pencereyi yeniden başlatmanıza yardımcı olacağız.  ",
                    continue: "Devam"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TH: {
                th: {
                    windowMessage: "ถ้าคุณไม่เห็นเบราว์เซอร์ที่มีระบบความปลอดภัยของ PayPal เราจะช่วยคุณเปิดหน้าต่างอีกครั้งเพื่อชำระเงินให้เรียบร้อย ",
                    continue: "ดำเนินการต่อ"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            SK: {
                sk: {
                    windowMessage: "Nezobrazuje sa vám zabezpečený prehliadač PayPal? Pomôžeme vám znova otvoriť okno, aby ste mohli nákup dokončiť.  ",
                    continue: "Pokračovať"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SG: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            SE: {
                sv: {
                    windowMessage: "Ser du inte den säkra PayPal-webbläsaren? Vi hjälper dig att starta om fönstret för att slutföra ditt köp. ",
                    continue: "Fortsätt"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            RU: {
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.",
                    continue: "Продолжить"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            RO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PT: {
                pt: {
                    windowMessage: "Não vê a indicação de sessão segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PL: {
                pl: {
                    windowMessage: "Nie widzisz bezpiecznej przeglądarki PayPal? Pomożemy Ci ponownie uruchomić to okno w celu dokonania zakupu.  ",
                    continue: "Kontynuuj"
                },
                en: {
                    windowMessage: "You don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PH: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            NZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à relancer la fenêtre pour effectuer votre paiement.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar su pago.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            NO: {
                no: {
                    windowMessage: "Ser du ikke den sikre PayPal-nettleseren? Vi hjelper deg med å starte vinduet på nytt så du kan fullføre kjøpet.  ",
                    continue: "Fortsett"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NL: {
                nl: {
                    windowMessage: "Ziet u geen beveiligde PayPal-browser? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.  ",
                    continue: "Doorgaan"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MY: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            MX: {
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Das PayPal-Fenster wird nicht angezeigt? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            LT: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KR: {
                ko: {
                    windowMessage: "보안 PayPal 브라우저가 보이지 않으신가요? 창을 다시 실행하여 결제를 완료할 수 있도록 도와드리겠습니다.  ",
                    continue: "계속"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            JP: {
                ja: {
                    windowMessage: "セキュアなブラウザが表示されない場合は、ウィンドウを再起動して、支払いを完了できるようお手伝いいたします。",
                    continue: "続行"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            IT: {
                it: {
                    windowMessage: "Non vedi la pagina sicura di PayPal? Ti aiuteremo a riaprire la finestra per completare l'acquisto.  ",
                    continue: "Continua"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IL: {
                he: {
                    windowMessage: "לא רואה את דפדפן PayPal המאובטח? נעזור לך לפתוח מחדש את החלון כדי להשלים את הקנייה שלך.  ",
                    continue: "המשך"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HU: {
                hu: {
                    windowMessage: "Nem látja a biztonságos PayPal-böngészőt? Segítünk újra betölteni az ablakot, hogy befejezhesse a vásárlást.  ",
                    continue: "Folytatás"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ID: {
                id: {
                    windowMessage: "Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembayaran Anda.  ",
                    continue: "Lanjutkan"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            HK: {
                zh: {
                    windowMessage: "看不到安全的 PayPal 瀏覽器視窗？我們會助你重新開啟視窗，以完成付款。",
                    continue: "繼續"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            "GROUP-LATAM": {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            "GROUP-EMEA": {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                pt: {
                    windowMessage: "Não vê a indicação de sessão segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            "GROUP-APAC": {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                ko: {
                    windowMessage: "보안 PayPal 브라우저가 보이지 않으신가요? 창을 다시 실행하여 구매를 완료할 수 있도록 도와드리겠습니다. ",
                    continue: "계속"
                },
                id: {
                    windowMessage: "Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembelian Anda. ",
                    continue: "Lanjutkan"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GR: {
                el: {
                    windowMessage: "Δεν βλέπετε το ασφαλές πρόγραμμα περιήγησης PayPal; Θα σας βοηθήσουμε να επανεκκινήσετε το παράθυρο για να ολοκληρώσετε την αγορά σας.  ",
                    continue: "Συνέχεια"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FR: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ES: {
                es: {
                    windowMessage: "¿No ve el símbolo de navegación segura de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar la compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FI: {
                fi: {
                    windowMessage: "Eikö suojattua PayPal-selainta näy? Autamme avaamaan ikkunan uudelleen oston viimeistelyä varten.  ",
                    continue: "Jatka"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            EE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            DK: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            CZ: {
                cs: {
                    windowMessage: "Nezobrazuje se vám bezpečný prohlížeč PayPal? Pomůžeme vám okno znovu otevřít, abyste mohli nákup dokončit.",
                    continue: "Pokračovat"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            DE: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            CH: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            CA: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé de PayPal ? Nous vous aiderons à relancer la fenêtre afin d'effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you relaunch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            C2: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            BE: {
                nl: {
                    windowMessage: "Ziet u de beveiligde PayPal-browser niet? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.  ",
                    continue: "Doorgaan"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BR: {
                pt: {
                    windowMessage: "Não está vendo o navegador seguro do PayPal? Ajudaremos você a reabrir a janela para concluir a compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AU: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_RESULT__;
        !function() {
            "use strict";
            var root = "object" == typeof window ? window : {};
            !root.HI_BASE32_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node && (root = window);
            var COMMON_JS = !root.HI_BASE32_NO_COMMON_JS && "object" == typeof module && module.exports, AMD = __webpack_require__(56), BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""), BASE32_DECODE_CHAR = {
                A: 0,
                B: 1,
                C: 2,
                D: 3,
                E: 4,
                F: 5,
                G: 6,
                H: 7,
                I: 8,
                J: 9,
                K: 10,
                L: 11,
                M: 12,
                N: 13,
                O: 14,
                P: 15,
                Q: 16,
                R: 17,
                S: 18,
                T: 19,
                U: 20,
                V: 21,
                W: 22,
                X: 23,
                Y: 24,
                Z: 25,
                2: 26,
                3: 27,
                4: 28,
                5: 29,
                6: 30,
                7: 31
            }, blocks = [ 0, 0, 0, 0, 0, 0, 0, 0 ], throwInvalidUtf8 = function(position, partial) {
                partial.length > 10 && (partial = "..." + partial.substr(-10));
                var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position + " bytes: " + partial + " <-");
                throw err.position = position, err;
            }, decodeAsBytes = function(base32Str) {
                if (!/^[A-Z2-7=]+$/.test(base32Str)) throw new Error("Invalid base32 characters");
                for (var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index = 0, length = (base32Str = base32Str.replace(/=/g, "")).length, i = 0, count = length >> 3 << 3; i < count; ) v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], bytes[index++] = 255 & (v1 << 3 | v2 >>> 2), 
                bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4), bytes[index++] = 255 & (v4 << 4 | v5 >>> 1), 
                bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3), bytes[index++] = 255 & (v7 << 5 | v8);
                var remain = length - count;
                return 2 === remain ? (v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                bytes[index++] = 255 & (v1 << 3 | v2 >>> 2)) : 4 === remain ? (v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], bytes[index++] = 255 & (v1 << 3 | v2 >>> 2), 
                bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) : 5 === remain ? (v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                bytes[index++] = 255 & (v1 << 3 | v2 >>> 2), bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4), 
                bytes[index++] = 255 & (v4 << 4 | v5 >>> 1)) : 7 === remain && (v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                bytes[index++] = 255 & (v1 << 3 | v2 >>> 2), bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4), 
                bytes[index++] = 255 & (v4 << 4 | v5 >>> 1), bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3)), 
                bytes;
            }, decode = function(base32Str, asciiOnly) {
                if (!asciiOnly) return function(bytes) {
                    for (var b, c, str = "", length = bytes.length, i = 0, followingChars = 0; i < length; ) if ((b = bytes[i++]) <= 127) str += String.fromCharCode(b); else {
                        b > 191 && b <= 223 ? (c = 31 & b, followingChars = 1) : b <= 239 ? (c = 15 & b, 
                        followingChars = 2) : b <= 247 ? (c = 7 & b, followingChars = 3) : throwInvalidUtf8(i, str);
                        for (var j = 0; j < followingChars; ++j) ((b = bytes[i++]) < 128 || b > 191) && throwInvalidUtf8(i, str), 
                        c <<= 6, c += 63 & b;
                        c >= 55296 && c <= 57343 && throwInvalidUtf8(i, str), c > 1114111 && throwInvalidUtf8(i, str), 
                        c <= 65535 ? str += String.fromCharCode(c) : (c -= 65536, str += String.fromCharCode(55296 + (c >> 10)), 
                        str += String.fromCharCode(56320 + (1023 & c)));
                    }
                    return str;
                }(decodeAsBytes(base32Str));
                if (!/^[A-Z2-7=]+$/.test(base32Str)) throw new Error("Invalid base32 characters");
                var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
                -1 === length && (length = base32Str.length);
                for (var i = 0, count = length >> 3 << 3; i < count; ) v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3)) + String.fromCharCode(255 & (v7 << 5 | v8));
                var remain = length - count;
                return 2 === remain ? (v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2))) : 4 === remain ? (v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4))) : 5 === remain ? (v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1))) : 7 === remain && (v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)], 
                str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3))), 
                str;
            }, exports = {
                encode: function(input, asciiOnly) {
                    var notString = "string" != typeof input;
                    return notString && input.constructor === ArrayBuffer && (input = new Uint8Array(input)), 
                    notString ? function(bytes) {
                        for (var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length, i = 0, count = 5 * parseInt(length / 5); i < count; ) v1 = bytes[i++], 
                        v2 = bytes[i++], v3 = bytes[i++], v4 = bytes[i++], v5 = bytes[i++], base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        var remain = length - count;
                        return 1 === remain ? base32Str += BASE32_ENCODE_CHAR[(v1 = bytes[i]) >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======" : 2 === remain ? (v1 = bytes[i++], 
                        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = bytes[i]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====") : 3 === remain ? (v1 = bytes[i++], 
                        v2 = bytes[i++], base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = bytes[i]) >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===") : 4 === remain && (v1 = bytes[i++], 
                        v2 = bytes[i++], v3 = bytes[i++], base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = bytes[i]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "="), 
                        base32Str;
                    }(input) : asciiOnly ? function(str) {
                        for (var v1, v2, v3, v4, v5, base32Str = "", length = str.length, i = 0, count = 5 * parseInt(length / 5); i < count; ) v1 = str.charCodeAt(i++), 
                        v2 = str.charCodeAt(i++), v3 = str.charCodeAt(i++), v4 = str.charCodeAt(i++), v5 = str.charCodeAt(i++), 
                        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        var remain = length - count;
                        return 1 === remain ? (v1 = str.charCodeAt(i), base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======") : 2 === remain ? (v1 = str.charCodeAt(i++), 
                        v2 = str.charCodeAt(i), base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====") : 3 === remain ? (v1 = str.charCodeAt(i++), 
                        v2 = str.charCodeAt(i++), v3 = str.charCodeAt(i), base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===") : 4 === remain && (v1 = str.charCodeAt(i++), 
                        v2 = str.charCodeAt(i++), v3 = str.charCodeAt(i++), v4 = str.charCodeAt(i), base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "="), 
                        base32Str;
                    }(input) : function(str) {
                        var v1, v2, v3, v4, v5, code, i, end = !1, base32Str = "", index = 0, start = 0, length = str.length;
                        do {
                            for (blocks[0] = blocks[5], blocks[1] = blocks[6], blocks[2] = blocks[7], i = start; index < length && i < 5; ++index) (code = str.charCodeAt(index)) < 128 ? blocks[i++] = code : code < 2048 ? (blocks[i++] = 192 | code >> 6, 
                            blocks[i++] = 128 | 63 & code) : code < 55296 || code >= 57344 ? (blocks[i++] = 224 | code >> 12, 
                            blocks[i++] = 128 | code >> 6 & 63, blocks[i++] = 128 | 63 & code) : (code = 65536 + ((1023 & code) << 10 | 1023 & str.charCodeAt(++index)), 
                            blocks[i++] = 240 | code >> 18, blocks[i++] = 128 | code >> 12 & 63, blocks[i++] = 128 | code >> 6 & 63, 
                            blocks[i++] = 128 | 63 & code);
                            start = i - 5, index === length && ++index, index > length && i < 6 && (end = !0), 
                            v1 = blocks[0], base32Str += i > 4 ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = blocks[3]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | (v5 = blocks[4]) >>> 5)] + BASE32_ENCODE_CHAR[31 & v5] : 1 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======" : 2 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====" : 3 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===" : BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = blocks[3]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        } while (!end);
                        return base32Str;
                    }(input);
                },
                decode: decode
            };
            decode.asBytes = decodeAsBytes, COMMON_JS ? module.exports = exports : (root.base32 = exports, 
            AMD && (void 0 === (__WEBPACK_AMD_DEFINE_RESULT__ = function() {
                return exports;
            }.call(exports, __webpack_require__, exports, module)) || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)));
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return script;
        });
        var script = {
            global: function() {
                return window.document;
            },
            register: function register(component, document) {
                function render(element) {
                    if (element && element.tagName && "script" === element.tagName.toLowerCase() && element.attributes.type && "application/x-component" === element.attributes.type.value && element.parentNode) {
                        var tag = element.getAttribute("data-component");
                        if (tag && tag === component.tag) {
                            component.log("instantiate_script_component");
                            var props = element.innerText ? eval("(" + element.innerText + ")") : {}, container = document.createElement("div");
                            if (!element.parentNode) throw new Error("Element has no parent");
                            element.parentNode.replaceChild(container, element), component.render(props, container);
                        }
                    }
                }
                function scan() {
                    for (var scriptTags = [].slice.call(document.getElementsByTagName("script")), _i2 = 0; _i2 < scriptTags.length; _i2++) render(scriptTags[_i2]);
                }
                scan(), document.addEventListener("DOMContentLoaded", scan), window.addEventListener("load", scan), 
                document.addEventListener("DOMNodeInserted", function(event) {
                    render(event.target);
                });
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return react;
        });
        var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20), _lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5), react = {
            global: function() {
                if (window.React && window.ReactDOM) return {
                    React: window.React,
                    ReactDOM: window.ReactDOM
                };
            },
            register: function(component, _ref) {
                var React = _ref.React, ReactDOM = _ref.ReactDOM;
                return component.react = React.createClass ? React.createClass({
                    displayName: "react",
                    render: function() {
                        return React.createElement("div", null);
                    },
                    componentDidMount: function() {
                        component.log("instantiate_react_component");
                        var el = ReactDOM.findDOMNode(this), parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props), null, el);
                        this.setState({
                            parent: parent
                        }), parent.render(el);
                    },
                    componentDidUpdate: function() {
                        this.state && this.state.parent && this.state.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props));
                    },
                    componentWillUnmount: function() {
                        this.state && this.state.parent && this.state.parent.destroy();
                    }
                }) : function(_React$Component) {
                    function _class() {
                        return _React$Component.apply(this, arguments) || this;
                    }
                    Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__.a)(_class, _React$Component);
                    var _proto = _class.prototype;
                    return _proto.render = function() {
                        return React.createElement("div", null);
                    }, _proto.componentDidMount = function() {
                        component.log("instantiate_react_component");
                        var el = ReactDOM.findDOMNode(this), parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props), null, el);
                        this.setState({
                            parent: parent
                        }), parent.render(el);
                    }, _proto.componentDidUpdate = function() {
                        this.state && this.state.parent && this.state.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props));
                    }, _proto.componentWillUnmount = function() {
                        this.state && this.state.parent && this.state.parent.destroy();
                    }, _class;
                }(React.Component), component.react;
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return vue;
        });
        var _lib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5), vue = {
            global: function() {},
            register: function(component) {
                return {
                    render: function(createElement) {
                        return createElement("div");
                    },
                    inheritAttrs: !1,
                    mounted: function() {
                        var el = this.$el;
                        this.parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.q)({}, this.$attrs), null, el), 
                        this.parent.render(el);
                    },
                    beforeUpdate: function() {
                        this.parent && this.$attrs && this.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.q)({}, this.$attrs));
                    }
                };
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return angular;
        });
        var _lib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5), angular = {
            global: function() {
                return window.angular;
            },
            register: function(component, ng) {
                return ng.module(component.tag, []).directive(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.h)(component.tag), function() {
                    for (var scope = {}, _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) scope[_component$getPropNam2[_i2]] = "=";
                    return component.looseProps && (scope.props = "="), {
                        scope: scope,
                        restrict: "E",
                        controller: [ "$scope", "$element", function($scope, $element) {
                            if (component.looseProps && !$scope.props) throw new Error("For angular bindings to work, prop definitions must be passed to zoid.create");
                            function safeApply() {
                                if ("$apply" !== $scope.$root.$$phase && "$digest" !== $scope.$root.$$phase) try {
                                    $scope.$apply();
                                } catch (err) {}
                            }
                            component.log("instantiate_angular_component");
                            var getProps = function() {
                                var scopeProps;
                                if ($scope.props) scopeProps = $scope.props; else {
                                    scopeProps = {};
                                    for (var _i4 = 0, _Object$keys2 = Object.keys(scope); _i4 < _Object$keys2.length; _i4++) {
                                        var _key = _Object$keys2[_i4];
                                        void 0 !== $scope[_key] && (scopeProps[_key] = $scope[_key]);
                                    }
                                }
                                return Object(_lib__WEBPACK_IMPORTED_MODULE_0__.M)(scopeProps, {
                                    function: function(value) {
                                        return function() {
                                            var result = value.apply(this, arguments);
                                            return safeApply(), result;
                                        };
                                    }
                                });
                            }, parent = component.init(getProps(), null, $element[0]);
                            parent.render($element[0]), $scope.$watch(function() {
                                parent.updateProps(getProps());
                            });
                        } ]
                    };
                });
            }
        };
    }, function(module, exports) {}, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return glimmer;
        });
        var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11), _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20), glimmer = {
            global: function() {},
            register: function(component, GlimmerComponent) {
                return function(_GlimmerComponent) {
                    function _class() {
                        return _GlimmerComponent.apply(this, arguments) || this;
                    }
                    return Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__.a)(_class, _GlimmerComponent), 
                    _class.prototype.didInsertElement = function() {
                        component.render(Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__.a)({}, this.args), this.element);
                    }, _class;
                }(GlimmerComponent);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return angular2;
        });
        var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11), _lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5), angular2 = {
            global: function() {},
            register: function(zoid, _ref) {
                var AngularComponent = _ref.Component, NgModule = _ref.NgModule, ElementRef = _ref.ElementRef, NgZone = _ref.NgZone;
                zoid.log("initializing angular2 component");
                var getProps = function(component) {
                    return Object(_lib__WEBPACK_IMPORTED_MODULE_1__.M)(Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__.a)({}, component.internalProps, {}, component.props), {
                        function: function(value) {
                            if ("function" == typeof value) return function() {
                                var _this = this, _arguments = arguments;
                                return component.zone.run(function() {
                                    return value.apply(_this, _arguments);
                                });
                            };
                        }
                    });
                }, ComponentInstance = AngularComponent({
                    selector: zoid.tag,
                    template: "<div></div>",
                    inputs: [ "props" ]
                }).Class({
                    constructor: [ ElementRef, NgZone, function(elementRef, zone) {
                        this.elementRef = elementRef, this.zone = zone;
                    } ],
                    ngOnInit: function() {
                        var targetElement = this.elementRef.nativeElement, parent = zoid.init(getProps(this), null, targetElement);
                        parent.render(targetElement), this.parent = parent;
                    },
                    ngOnChanges: function() {
                        this.parent && this.parent.updateProps(getProps(this));
                    }
                });
                return NgModule({
                    declarations: [ ComponentInstance ],
                    exports: [ ComponentInstance ]
                }).Class({
                    constructor: function() {}
                });
            }
        };
    }, function(module, exports, __webpack_require__) {
        !function(e, t, n) {
            module.exports ? module.exports = n() : __webpack_require__(57)("bowser", n);
        }(0, 0, function() {
            function t(t) {
                function n(e) {
                    var n = t.match(e);
                    return n && n.length > 1 && n[1] || "";
                }
                function r(e) {
                    var n = t.match(e);
                    return n && n.length > 1 && n[2] || "";
                }
                var N, i = n(/(ipod|iphone|ipad)/i).toLowerCase(), u = !/like android/i.test(t) && /android/i.test(t), a = /nexus\s*[0-6]\s*/i.test(t), f = !a && /nexus\s*[0-9]+/i.test(t), l = /CrOS/.test(t), c = /silk/i.test(t), h = /sailfish/i.test(t), p = /tizen/i.test(t), d = /(web|hpw)(o|0)s/i.test(t), v = /windows phone/i.test(t), g = (/SamsungBrowser/i.test(t), 
                !v && /windows/i.test(t)), y = !i && !c && /macintosh/i.test(t), b = !u && !h && !p && !d && /linux/i.test(t), w = r(/edg([ea]|ios)\/(\d+(\.\d+)?)/i), E = n(/version\/(\d+(\.\d+)?)/i), S = /tablet/i.test(t) && !/tablet pc/i.test(t), x = !S && /[^-]mobi/i.test(t), T = /xbox/i.test(t);
                /opera/i.test(t) ? N = {
                    name: "Opera",
                    opera: e,
                    version: E || n(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
                } : /opr\/|opios/i.test(t) ? N = {
                    name: "Opera",
                    opera: e,
                    version: n(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || E
                } : /SamsungBrowser/i.test(t) ? N = {
                    name: "Samsung Internet for Android",
                    samsungBrowser: e,
                    version: E || n(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
                } : /Whale/i.test(t) ? N = {
                    name: "NAVER Whale browser",
                    whale: e,
                    version: n(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
                } : /MZBrowser/i.test(t) ? N = {
                    name: "MZ Browser",
                    mzbrowser: e,
                    version: n(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
                } : /coast/i.test(t) ? N = {
                    name: "Opera Coast",
                    coast: e,
                    version: E || n(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
                } : /focus/i.test(t) ? N = {
                    name: "Focus",
                    focus: e,
                    version: n(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
                } : /yabrowser/i.test(t) ? N = {
                    name: "Yandex Browser",
                    yandexbrowser: e,
                    version: E || n(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
                } : /ucbrowser/i.test(t) ? N = {
                    name: "UC Browser",
                    ucbrowser: e,
                    version: n(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
                } : /mxios/i.test(t) ? N = {
                    name: "Maxthon",
                    maxthon: e,
                    version: n(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
                } : /epiphany/i.test(t) ? N = {
                    name: "Epiphany",
                    epiphany: e,
                    version: n(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
                } : /puffin/i.test(t) ? N = {
                    name: "Puffin",
                    puffin: e,
                    version: n(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
                } : /sleipnir/i.test(t) ? N = {
                    name: "Sleipnir",
                    sleipnir: e,
                    version: n(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
                } : /k-meleon/i.test(t) ? N = {
                    name: "K-Meleon",
                    kMeleon: e,
                    version: n(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
                } : v ? (N = {
                    name: "Windows Phone",
                    osname: "Windows Phone",
                    windowsphone: e
                }, w ? (N.msedge = e, N.version = w) : (N.msie = e, N.version = n(/iemobile\/(\d+(\.\d+)?)/i))) : /msie|trident/i.test(t) ? N = {
                    name: "Internet Explorer",
                    msie: e,
                    version: n(/(?:msie |rv:)(\d+(\.\d+)?)/i)
                } : l ? N = {
                    name: "Chrome",
                    osname: "Chrome OS",
                    chromeos: e,
                    chromeBook: e,
                    chrome: e,
                    version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                } : /edg([ea]|ios)/i.test(t) ? N = {
                    name: "Microsoft Edge",
                    msedge: e,
                    version: w
                } : /vivaldi/i.test(t) ? N = {
                    name: "Vivaldi",
                    vivaldi: e,
                    version: n(/vivaldi\/(\d+(\.\d+)?)/i) || E
                } : h ? N = {
                    name: "Sailfish",
                    osname: "Sailfish OS",
                    sailfish: e,
                    version: n(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
                } : /seamonkey\//i.test(t) ? N = {
                    name: "SeaMonkey",
                    seamonkey: e,
                    version: n(/seamonkey\/(\d+(\.\d+)?)/i)
                } : /firefox|iceweasel|fxios/i.test(t) ? (N = {
                    name: "Firefox",
                    firefox: e,
                    version: n(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
                }, /\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(t) && (N.firefoxos = e, N.osname = "Firefox OS")) : c ? N = {
                    name: "Amazon Silk",
                    silk: e,
                    version: n(/silk\/(\d+(\.\d+)?)/i)
                } : /phantom/i.test(t) ? N = {
                    name: "PhantomJS",
                    phantom: e,
                    version: n(/phantomjs\/(\d+(\.\d+)?)/i)
                } : /slimerjs/i.test(t) ? N = {
                    name: "SlimerJS",
                    slimer: e,
                    version: n(/slimerjs\/(\d+(\.\d+)?)/i)
                } : /blackberry|\bbb\d+/i.test(t) || /rim\stablet/i.test(t) ? N = {
                    name: "BlackBerry",
                    osname: "BlackBerry OS",
                    blackberry: e,
                    version: E || n(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
                } : d ? (N = {
                    name: "WebOS",
                    osname: "WebOS",
                    webos: e,
                    version: E || n(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
                }, /touchpad\//i.test(t) && (N.touchpad = e)) : /bada/i.test(t) ? N = {
                    name: "Bada",
                    osname: "Bada",
                    bada: e,
                    version: n(/dolfin\/(\d+(\.\d+)?)/i)
                } : p ? N = {
                    name: "Tizen",
                    osname: "Tizen",
                    tizen: e,
                    version: n(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || E
                } : /qupzilla/i.test(t) ? N = {
                    name: "QupZilla",
                    qupzilla: e,
                    version: n(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || E
                } : /chromium/i.test(t) ? N = {
                    name: "Chromium",
                    chromium: e,
                    version: n(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || E
                } : /chrome|crios|crmo/i.test(t) ? N = {
                    name: "Chrome",
                    chrome: e,
                    version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                } : u ? N = {
                    name: "Android",
                    version: E
                } : /safari|applewebkit/i.test(t) ? (N = {
                    name: "Safari",
                    safari: e
                }, E && (N.version = E)) : i ? (N = {
                    name: "iphone" == i ? "iPhone" : "ipad" == i ? "iPad" : "iPod"
                }, E && (N.version = E)) : N = /googlebot/i.test(t) ? {
                    name: "Googlebot",
                    googlebot: e,
                    version: n(/googlebot\/(\d+(\.\d+))/i) || E
                } : {
                    name: n(/^(.*)\/(.*) /),
                    version: r(/^(.*)\/(.*) /)
                }, !N.msedge && /(apple)?webkit/i.test(t) ? (/(apple)?webkit\/537\.36/i.test(t) ? (N.name = N.name || "Blink", 
                N.blink = e) : (N.name = N.name || "Webkit", N.webkit = e), !N.version && E && (N.version = E)) : !N.opera && /gecko\//i.test(t) && (N.name = N.name || "Gecko", 
                N.gecko = e, N.version = N.version || n(/gecko\/(\d+(\.\d+)?)/i)), N.windowsphone || !u && !N.silk ? !N.windowsphone && i ? (N[i] = e, 
                N.ios = e, N.osname = "iOS") : y ? (N.mac = e, N.osname = "macOS") : T ? (N.xbox = e, 
                N.osname = "Xbox") : g ? (N.windows = e, N.osname = "Windows") : b && (N.linux = e, 
                N.osname = "Linux") : (N.android = e, N.osname = "Android");
                var k = "";
                N.windows ? k = function(e) {
                    switch (n(/Windows ((NT|XP)( \d\d?.\d)?)/i)) {
                      case "NT":
                        return "NT";

                      case "XP":
                        return "XP";

                      case "NT 5.0":
                        return "2000";

                      case "NT 5.1":
                        return "XP";

                      case "NT 5.2":
                        return "2003";

                      case "NT 6.0":
                        return "Vista";

                      case "NT 6.1":
                        return "7";

                      case "NT 6.2":
                        return "8";

                      case "NT 6.3":
                        return "8.1";

                      case "NT 10.0":
                        return "10";

                      default:
                        return;
                    }
                }() : N.windowsphone ? k = n(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i) : N.mac ? k = (k = n(/Mac OS X (\d+([_\.\s]\d+)*)/i)).replace(/[_\s]/g, ".") : i ? k = (k = n(/os (\d+([_\s]\d+)*) like mac os x/i)).replace(/[_\s]/g, ".") : u ? k = n(/android[ \/-](\d+(\.\d+)*)/i) : N.webos ? k = n(/(?:web|hpw)os\/(\d+(\.\d+)*)/i) : N.blackberry ? k = n(/rim\stablet\sos\s(\d+(\.\d+)*)/i) : N.bada ? k = n(/bada\/(\d+(\.\d+)*)/i) : N.tizen && (k = n(/tizen[\/\s](\d+(\.\d+)*)/i)), 
                k && (N.osversion = k);
                var L = !N.windows && k.split(".")[0];
                return S || f || "ipad" == i || u && (3 == L || L >= 4 && !x) || N.silk ? N.tablet = e : (x || "iphone" == i || "ipod" == i || u || a || N.blackberry || N.webos || N.bada) && (N.mobile = e), 
                N.msedge || N.msie && N.version >= 10 || N.yandexbrowser && N.version >= 15 || N.vivaldi && N.version >= 1 || N.chrome && N.version >= 20 || N.samsungBrowser && N.version >= 4 || N.whale && 1 === s([ N.version, "1.0" ]) || N.mzbrowser && 1 === s([ N.version, "6.0" ]) || N.focus && 1 === s([ N.version, "1.0" ]) || N.firefox && N.version >= 20 || N.safari && N.version >= 6 || N.opera && N.version >= 10 || N.ios && N.osversion && N.osversion.split(".")[0] >= 6 || N.blackberry && N.version >= 10.1 || N.chromium && N.version >= 20 ? N.a = e : N.msie && N.version < 10 || N.chrome && N.version < 20 || N.firefox && N.version < 20 || N.safari && N.version < 6 || N.opera && N.version < 10 || N.ios && N.osversion && N.osversion.split(".")[0] < 6 || N.chromium && N.version < 20 ? N.c = e : N.x = e, 
                N;
            }
            function r(e) {
                return e.split(".").length;
            }
            function i(e, t) {
                var r, n = [];
                if ([].map) return [].map.call(e, t);
                for (r = 0; r < e.length; r++) n.push(t(e[r]));
                return n;
            }
            function s(e) {
                for (var t = Math.max(r(e[0]), r(e[1])), n = i(e, function(e) {
                    var n = t - r(e);
                    return i((e += new Array(n + 1).join(".0")).split("."), function(e) {
                        return new Array(20 - e.length).join("0") + e;
                    }).reverse();
                }); --t >= 0; ) {
                    if (n[0][t] > n[1][t]) return 1;
                    if (n[0][t] !== n[1][t]) return -1;
                    if (0 === t) return 0;
                }
            }
            function o(e, r, i) {
                var o = n;
                "string" == typeof r && (i = r, r = void 0), void 0 === r && (r = !1), i && (o = t(i));
                var u = "" + o.version;
                for (var a in e) if (e.hasOwnProperty(a) && o[a]) {
                    if ("string" != typeof e[a]) throw new Error("Browser version in the minVersion map should be a string: " + a + ": " + String(e));
                    return s([ u, e[a] ]) < 0;
                }
                return r;
            }
            var e = !0, n = t("undefined" != typeof navigator && navigator.userAgent || "");
            return n.test = function(e) {
                for (var t = 0; t < e.length; ++t) {
                    var r = e[t];
                    if ("string" == typeof r && r in n) return !0;
                }
                return !1;
            }, n.isUnsupportedBrowser = o, n.compareVersions = s, n.check = function(e, t, n) {
                return !o(e, t, n);
            }, n._detect = t, n.detect = t, n;
        });
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var src = __webpack_require__(7), conf = __webpack_require__(10);
        function emulateIERestrictions(sourceWindow, targetWindow) {
            if (!conf.a.ALLOW_POSTMESSAGE_POPUP && !1 === Object(src.v)(sourceWindow, targetWindow)) throw new Error("Can not send and receive post messages between two different windows (disabled to emulate IE)");
        }
        __webpack_require__.d(__webpack_exports__, "emulateIERestrictions", function() {
            return emulateIERestrictions;
        });
    }, function(module, exports) {
        module.exports = '<svg width="24" height="32" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#ffffff" opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446"></path>\n    <path fill="#ffffff" opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446"></path>\n    <path fill="#ffffff" d="M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z"></path>\n    <g transform="matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)" opacity="0.2">\n        <path fill="#231f20" d="M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z"></path>\n        <path fill="#231f20" d="M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z"></path>\n        <path fill="#231f20" d="M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z"></path>\n    </g>\n</svg>\n';
    }, function(module, exports) {
        module.exports = '<svg width="24" height="32" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#009cde" d="M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 6.675 28.9 C 6.581 29.3 6.862 29.6 7.236 29.6 L 11.356 29.6 C 11.825 29.6 12.292 29.3 12.386 28.8 L 12.386 28.5 L 13.228 23.3 L 13.228 23.1 C 13.322 22.6 13.79 22.2 14.258 22.2 L 14.821 22.2 C 18.845 22.2 21.935 20.5 22.871 15.5 C 23.339 13.4 23.153 11.7 22.029 10.5 C 21.748 10.1 21.279 9.8 20.905 9.5 L 20.905 9.5"></path>\n    <path fill="#012169" d="M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 8.173 18.7 C 8.267 18.1 8.735 17.7 9.296 17.7 L 11.636 17.7 C 16.224 17.7 19.782 15.7 20.905 10.1 C 20.812 9.8 20.905 9.7 20.905 9.5"></path>\n    <path fill="#003087" d="M 9.485 9.5 C 9.577 9.2 9.765 8.9 10.046 8.7 C 10.232 8.7 10.326 8.6 10.513 8.6 L 16.692 8.6 C 17.442 8.6 18.189 8.7 18.753 8.8 C 18.939 8.8 19.127 8.8 19.314 8.9 C 19.501 9 19.688 9 19.782 9.1 C 19.875 9.1 19.968 9.1 20.063 9.1 C 20.343 9.2 20.624 9.4 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.6 C 18.658 3.2 16.506 2.6 13.79 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 9.485 9.5 Z"></path>\n</svg>\n';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="24" height="32" viewBox="0 0 24 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446" style="fill: rgb(99, 99, 99);"/>\n  <path opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446"/>\n  <path d="M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z" style="fill: rgb(51, 48, 48);"/>\n  <g transform="matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)" opacity="0.2">\n    <path fill="#231f20" d="M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z"/>\n    <path fill="#231f20" d="M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z"/>\n    <path fill="#231f20" d="M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z"/>\n  </g>\n</svg>';
    }, function(module, exports) {
        module.exports = '<svg width="101" height="32" viewBox="0 0 101 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="White" fill="#FFFFFF">\n            <g id="Logo" transform="translate(0.000000, 6.000000)">\n                <path d="M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n';
    }, function(module, exports) {
        module.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 105">\n    <title>Asset 3</title>\n    <g id="Layer_2" >\n        <g id="Layer_1-2">\n            <rect width="750" height="105" rx="11" fill="#004995"/>\n            <rect x="452.24" y="19.99" width="55" height="54.14" rx="8.98"\n                  transform="translate(2.52 115.09) rotate(-13.72)" fill="#ff7900"/>\n            <rect x="467.2" y="26.15" width="33.66" height="34.11" rx="5.84" fill="#004995"/>\n            <path d="M394.93,60.57a9.34,9.34,0,0,0-2.36-5.72,12.06,12.06,0,0,0-9.52-4.1c-3.32.08-8.05.62-11,2.78l1.8,5.38s2.69-2.24,8.07-2.24c2.33,0,4.49,1.34,4.94,2.69v.45c-2.87,0-11.88.58-15.26,5.84-4,6.28,2.25,12.11,6.28,12.11,3.2,0,6.57.2,9.43-2.69l.45,2.25h7.18V62.07a3.52,3.52,0,0,1,0-.46Zm-16.16,8.67c.34-3.74,5.56-4.13,8.08-4.11v4.51C384.22,73.24,378.44,72.89,378.77,69.24Z"\n                  fill="#fff"/>\n            <path d="M368,52.63s-15.77-4.29-20.65,6.28c-2.69,5.84-1.35,11.94,1.8,15.26a12.77,12.77,0,0,0,5.38,3.15c4,1.34,11.23.89,13.47-.45L367.1,71s-7.18,2.25-10.77-1.35c-4.72-4.71-.45-12.11,4.49-12.11s6.28.89,6.28.89Z"\n                  fill="#fff"/>\n            <rect x="258.48" y="43.2" width="8.08" height="34.11" fill="#fff"/>\n            <path d="M286.31,58V51.73h-4.49V43.2h-8.08v8.53h-4V58h4V71A6.29,6.29,0,0,0,280,77.32h6.29V71h-2.26a2.23,2.23,0,0,1-2.23-2.23V58Z"\n                  fill="#fff"/>\n            <path d="M313.69,60.57a9.46,9.46,0,0,0-2.36-5.72,12.08,12.08,0,0,0-9.52-4.1c-3.32.08-8.05.62-11,2.78l1.79,5.38s2.7-2.24,8.08-2.24c2.33,0,4.49,1.34,4.94,2.69v.45c-2.87,0-11.89.58-15.26,5.84-4,6.28,2.24,12.11,6.28,12.11,3.2,0,6.57.2,9.43-2.69l.45,2.25h7.18V62.07a3.52,3.52,0,0,1,0-.46Zm-16.16,8.67c.34-3.74,5.56-4.13,8.08-4.11v4.51C303,73.24,297.2,72.89,297.53,69.24Z"\n                  fill="#fff"/>\n            <path d="M334.78,51.73v15a2.81,2.81,0,0,1-.45,1.57c-1,1.53-2.33,2.7-4,2.7A4.38,4.38,0,0,1,326,68.25a2.72,2.72,0,0,1-.23-1.13V51.73h-8.08V69.24c0,4.46,3.62,8.52,8.08,8.52,8.08.45,9.42-3.59,9.42-3.59l0-.1.88,3.25h6.73V51.73Z"\n                  fill="#fff"/>\n            <rect x="469.89" y="43.2" width="2.71" height="11.43" fill="#fff100"/>\n            <path d="M479.22,48.17V46.06h-1.51V43.2H475v2.86h-1.35v2.11H475v4.36a2.11,2.11,0,0,0,2.11,2.1h2.11v-2.1h-.76a.76.76,0,0,1-.75-.75V48.17Z"\n                  fill="#fff100"/>\n            <path d="M488.39,49a3.14,3.14,0,0,0-.79-1.91,4,4,0,0,0-3.19-1.38,7,7,0,0,0-3.69.93l.6,1.81a4.42,4.42,0,0,1,2.71-.75,1.79,1.79,0,0,1,1.65.9v.15c-1,0-4,.19-5.11,1.95-1.35,2.11.75,4.06,2.1,4.06a3.89,3.89,0,0,0,3.16-.9l.15.75h2.41V49ZM483,51.93c.11-1.26,1.86-1.39,2.7-1.38v1.51C484.8,53.27,482.86,53.15,483,51.93Z"\n                  fill="#fff100"/>\n            <path d="M495.46,46.06v5.31a1.88,1.88,0,0,1-1.5,1.16,1.51,1.51,0,0,1-1.51-1.13V46.06h-2.71v5.87a2.84,2.84,0,0,0,2.71,2.85c2.71.15,3.16-1.2,3.16-1.2v0l.3,1.08h2.26V46.06Z"\n                  fill="#fff100"/>\n            <path d="M406.08,56.2l-.38-4.47H399V77.32h8.08V62.94c.71-1.85,2.54-4.48,7.18-4.48V50.83A9.48,9.48,0,0,0,406.08,56.2Z"\n                  fill="#fff"/>\n            <path d="M436.23,40.51V53.84c-1.24-1.44-3.52-3-7.63-3C421,50.83,416,57.57,416,65.2a12.44,12.44,0,0,0,12.12,12.56,16.68,16.68,0,0,0,8.69-3L438,77.32h6.28V40.51Zm-5.62,30.75c-4.93,0-5.83-4-5.83-7.19s1.35-6.73,5.83-6.73c2.66,0,4.53,2,5.62,3.71v6.19C435,69.23,433.12,71.26,430.61,71.26Z"\n                  fill="#fff"/>\n            <polygon points="495.02 45.45 492.78 45.45 494.58 43.2 497.27 43.2 495.02 45.45" fill="#fff100"/>\n        </g>\n    </g>\n</svg>\n';
    }, function(module, exports) {
        module.exports = '<svg width="101" height="32" viewBox="0 0 101 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Blue" fill="#3D93CE">\n            <g id="Logo" transform="translate(0.000000, 6.000000)">\n                <path d="M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path fill="#005DA0" d="M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z"/>\n  <path fill="#005DA0" d="M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z"/>\n  <path fill="#005DA0" d="M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z"/>\n  <path fill="#005DA0" d="M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z"/>\n  <path fill="#005DA0" d="M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z"/>\n  <path fill="#005DA0" d="M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z"/>\n  <path fill="#005DA0" d="M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z"/>\n  <path fill="#005DA0" d="M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z"/>\n  <path fill="#005DA0" d="M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z"/>\n  <path fill="#005DA0" d="M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z"/>\n  <path fill="#005DA0" d="M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z"/>\n  <path fill="#005DA0" d="M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z"/>\n  <path fill="#005DA0" d="M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z"/>\n  <path fill="#005DA0" d="M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z"/>\n  <path fill="#005DA0" d="M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z"/>\n  <path fill="#AEB1BC" d="M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z"/>\n  <g transform="matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)">\n    <path fill="#005DA0" d="M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z"/>\n    <path fill="#005DA0" d="M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z"/>\n    <polygon fill="#005DA0" points="161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;"/>\n  </g>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z" style="fill: rgb(255, 255, 255);"/>\n  <g transform="matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)">\n    <path d="M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z" style="fill: rgb(255, 255, 255);"/>\n    <polygon points="161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;" style="fill: rgb(255, 255, 255);"/>\n  </g>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(33, 86, 154);"/>\n  <path d="M19.596 7.885l-2.11 9.478H14.93l2.11-9.478h2.554zm10.743 6.12l1.343-3.56.773 3.56H30.34zm2.85 3.358h2.36l-2.063-9.478H31.31c-.492 0-.905.274-1.088.695l-3.832 8.783h2.682l.532-1.415h3.276l.31 1.415zm-6.667-3.094c.01-2.502-3.6-2.64-3.577-3.76.008-.338.345-.7 1.083-.793.365-.045 1.373-.08 2.517.425l.448-2.01c-.615-.214-1.405-.42-2.39-.42-2.523 0-4.3 1.288-4.313 3.133-.016 1.364 1.268 2.125 2.234 2.58.996.464 1.33.762 1.325 1.177-.006.636-.793.918-1.526.928-1.285.02-2.03-.333-2.623-.6l-.462 2.08c.598.262 1.7.49 2.84.502 2.682 0 4.437-1.273 4.445-3.243zM15.948 7.884l-4.138 9.478h-2.7L7.076 9.8c-.123-.466-.23-.637-.606-.834-.615-.32-1.63-.62-2.52-.806l.06-.275h4.345c.554 0 1.052.354 1.178.966l1.076 5.486 2.655-6.45h2.683z" style="fill: rgb(255, 255, 255);"/>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(20, 119, 190);"/>\n  <path d="M6.26 12.32h2.313L7.415 9.66M27.353 9.977h-3.738v1.23h3.666v1.384h-3.675v1.385h3.821v1.005c.623-.77 1.33-1.466 2.025-2.235l.707-.77c-.934-1.004-1.87-2.08-2.804-3.075v1.077z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M38.25 7h-5.605l-1.328 1.4L30.072 7H16.984l-1.017 2.416L14.877 7h-9.58L1.25 16.5h4.826l.623-1.556h1.4l.623 1.556H29.99l1.327-1.483 1.328 1.483h5.605l-4.36-4.667L38.25 7zm-17.685 8.1h-1.557V9.883L16.673 15.1h-1.33L13.01 9.883l-.084 5.217H9.73l-.623-1.556h-3.27L5.132 15.1H3.42l2.884-6.772h2.42l2.645 6.233V8.33h2.646l2.107 4.51 1.868-4.51h2.575V15.1zm14.727 0h-2.024l-2.024-2.26-2.023 2.26H22.06V8.328H29.53l1.795 2.177 2.024-2.177h2.025L32.26 11.75l3.032 3.35z" style="fill: rgb(255, 255, 255);"/>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(62, 57, 57);"/>\n  <path style="fill: rgb(255, 95, 0);" d="M 22.205 3.901 L 15.688 3.901 L 15.688 15.589 L 22.205 15.589"/>\n  <path d="M 16.1 9.747 C 16.1 7.371 17.218 5.265 18.935 3.901 C 17.67 2.912 16.078 2.312 14.342 2.312 C 10.223 2.312 6.892 5.636 6.892 9.746 C 6.892 13.853 10.223 17.178 14.342 17.178 C 16.078 17.178 17.67 16.58 18.935 15.588 C 17.216 14.246 16.099 12.119 16.099 9.745 Z" style="fill: rgb(235, 0, 27);"/>\n  <path d="M 30.996 9.747 C 30.996 13.854 27.663 17.179 23.547 17.179 C 21.81 17.179 20.216 16.581 18.954 15.589 C 20.691 14.227 21.788 12.12 21.788 9.746 C 21.788 7.37 20.671 5.264 18.954 3.9 C 20.216 2.911 21.81 2.311 23.547 2.311 C 27.663 2.311 30.996 5.657 30.996 9.745 Z" style="fill: rgb(247, 158, 27);"/>\n  <path d="M 7.167 22.481 L 7.167 20.43 C 7.167 19.641 6.685 19.127 5.857 19.127 C 5.443 19.127 4.993 19.262 4.683 19.71 C 4.44 19.332 4.096 19.127 3.579 19.127 C 3.233 19.127 2.888 19.23 2.612 19.607 L 2.612 19.197 L 1.886 19.197 L 1.886 22.481 L 2.612 22.481 L 2.612 20.668 C 2.612 20.086 2.921 19.812 3.406 19.812 C 3.888 19.812 4.131 20.121 4.131 20.669 L 4.131 22.481 L 4.856 22.481 L 4.856 20.668 C 4.856 20.086 5.204 19.812 5.651 19.812 C 6.137 19.812 6.377 20.121 6.377 20.669 L 6.377 22.481 L 7.171 22.481 Z M 17.909 19.197 L 16.734 19.197 L 16.734 18.204 L 16.007 18.204 L 16.007 19.197 L 15.352 19.197 L 15.352 19.845 L 16.007 19.845 L 16.007 21.351 C 16.007 22.106 16.319 22.551 17.146 22.551 C 17.459 22.551 17.804 22.449 18.044 22.309 L 17.839 21.695 C 17.632 21.831 17.389 21.867 17.216 21.867 C 16.872 21.867 16.734 21.66 16.734 21.319 L 16.734 19.847 L 17.909 19.847 L 17.909 19.198 Z M 24.053 19.127 C 23.639 19.127 23.364 19.332 23.191 19.607 L 23.191 19.197 L 22.465 19.197 L 22.465 22.481 L 23.191 22.481 L 23.191 20.633 C 23.191 20.086 23.434 19.777 23.882 19.777 C 24.018 19.777 24.192 19.812 24.33 19.847 L 24.538 19.162 C 24.401 19.127 24.192 19.127 24.052 19.127 Z M 14.765 19.469 C 14.42 19.229 13.937 19.127 13.418 19.127 C 12.588 19.127 12.036 19.538 12.036 20.188 C 12.036 20.736 12.453 21.044 13.175 21.146 L 13.524 21.181 C 13.903 21.249 14.108 21.351 14.108 21.523 C 14.108 21.765 13.832 21.934 13.35 21.934 C 12.864 21.934 12.484 21.764 12.244 21.592 L 11.898 22.139 C 12.278 22.411 12.794 22.549 13.313 22.549 C 14.28 22.549 14.831 22.105 14.831 21.488 C 14.831 20.908 14.383 20.599 13.692 20.496 L 13.348 20.462 C 13.037 20.428 12.795 20.36 12.795 20.155 C 12.795 19.914 13.038 19.777 13.418 19.777 C 13.83 19.777 14.245 19.949 14.453 20.052 L 14.764 19.469 Z M 34.033 19.127 C 33.618 19.127 33.342 19.332 33.171 19.607 L 33.171 19.197 L 32.445 19.197 L 32.445 22.481 L 33.171 22.481 L 33.171 20.633 C 33.171 20.086 33.414 19.777 33.862 19.777 C 33.998 19.777 34.17 19.812 34.307 19.847 L 34.515 19.162 C 34.38 19.127 34.172 19.127 34.033 19.127 Z M 24.779 20.838 C 24.779 21.834 25.47 22.551 26.54 22.551 C 27.025 22.551 27.369 22.449 27.715 22.173 L 27.369 21.593 C 27.092 21.798 26.816 21.901 26.504 21.901 C 25.919 21.901 25.505 21.49 25.505 20.84 C 25.505 20.226 25.919 19.813 26.507 19.78 C 26.816 19.78 27.092 19.883 27.369 20.089 L 27.715 19.507 C 27.369 19.233 27.024 19.13 26.54 19.13 C 25.47 19.13 24.779 19.85 24.779 20.841 Z M 31.478 20.838 L 31.478 19.198 L 30.75 19.198 L 30.75 19.608 C 30.51 19.3 30.165 19.128 29.717 19.128 C 28.784 19.128 28.058 19.848 28.058 20.84 C 28.058 21.835 28.784 22.552 29.716 22.552 C 30.197 22.552 30.543 22.382 30.748 22.074 L 30.748 22.484 L 31.477 22.484 L 31.477 20.84 Z M 28.818 20.838 C 28.818 20.259 29.196 19.779 29.819 19.779 C 30.406 19.779 30.821 20.224 30.821 20.84 C 30.821 21.424 30.406 21.902 29.819 21.902 C 29.196 21.869 28.818 21.424 28.818 20.841 Z M 20.148 19.128 C 19.183 19.128 18.494 19.813 18.494 20.84 C 18.494 21.869 19.183 22.552 20.185 22.552 C 20.671 22.552 21.154 22.417 21.533 22.108 L 21.188 21.595 C 20.914 21.799 20.565 21.937 20.222 21.937 C 19.772 21.937 19.323 21.732 19.219 21.149 L 21.671 21.149 L 21.671 20.878 C 21.705 19.815 21.083 19.13 20.15 19.13 Z M 20.148 19.748 C 20.6 19.748 20.911 20.019 20.98 20.532 L 19.253 20.532 C 19.321 20.087 19.633 19.748 20.148 19.748 Z M 38.141 20.84 L 38.141 17.898 L 37.412 17.898 L 37.412 19.61 C 37.173 19.302 36.828 19.13 36.38 19.13 C 35.446 19.13 34.721 19.85 34.721 20.841 C 34.721 21.837 35.446 22.554 36.379 22.554 C 36.861 22.554 37.206 22.383 37.41 22.076 L 37.41 22.486 L 38.14 22.486 L 38.14 20.841 Z M 35.481 20.84 C 35.481 20.261 35.861 19.78 36.484 19.78 C 37.069 19.78 37.486 20.226 37.486 20.841 C 37.486 21.426 37.069 21.904 36.484 21.904 C 35.861 21.87 35.481 21.426 35.481 20.843 Z M 11.237 20.84 L 11.237 19.2 L 10.515 19.2 L 10.515 19.61 C 10.272 19.302 9.928 19.13 9.478 19.13 C 8.545 19.13 7.82 19.85 7.82 20.841 C 7.82 21.837 8.545 22.554 9.477 22.554 C 9.96 22.554 10.304 22.383 10.512 22.076 L 10.512 22.486 L 11.236 22.486 L 11.236 20.841 Z M 8.546 20.84 C 8.546 20.261 8.926 19.78 9.548 19.78 C 10.134 19.78 10.55 20.226 10.55 20.841 C 10.55 21.426 10.134 21.904 9.548 21.904 C 8.926 21.87 8.546 21.426 8.546 20.843 Z" style="fill: rgb(255, 255, 255);"/>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 23.999999" width="40" height="24" preserveAspectRatio="xMinYMin meet" version="1.1">\n    <path d="M 0,1.927 C 0,0.86299997 0.892,0 1.992,0 H 38.008 C 39.108,0 40,0.86299997 40,1.927 V 22.073 C 40,23.137 39.108,24 38.008,24 H 1.992 C 0.892,24 0,23.137 0,22.073 Z" style="fill:#3e3939" />\n    <path d="m 23.74623,18.221667 v 0.929759 h -0.621716 v 0.609196 h 0.621716 v 1.394324 c 0,0.71165 0.275786,1.135118 1.064369,1.135118 a 1.564348,1.564348 0 0 0 0.833339,-0.237293 l -0.192215,-0.571003 a 1.2309624,1.2309624 0 0 1 -0.589785,0.17343 c -0.333383,0 -0.442649,-0.192213 -0.442649,-0.512774 v -1.388065 h 1.086908 V 19.151426 H 24.419289 V 18.221667 Z M 10.802242,19.066278 A 1.1860835,1.1860835 0 0 0 9.8436827,19.612862 1.1251765,1.1251765 0 0 0 8.830654,19.068153 1.0129794,1.0129794 0 0 0 7.9328276,19.523328 V 19.145165 H 7.2660325 v 3.061001 H 7.939089 v -1.704869 a 0.71485573,0.71485573 0 0 1 0.7500683,-0.814556 c 0.4423764,0 0.6667964,0.288356 0.6667964,0.807671 v 1.702363 h 0.6736813 v -1.695478 a 0.72126699,0.72126699 0 0 1 0.750068,-0.814556 c 0.4552,0 0.673058,0.288356 0.673058,0.807671 v 1.702363 l 0.669926,0.0094 v -1.923369 a 1.1379991,1.1379991 0 0 0 -1.202112,-1.214633 1.1860835,1.1860835 0 0 0 -0.118329,-0.002 z m 10.549158,0.002 c -0.782176,0 -1.282253,0.372027 -1.282253,0.981097 0,0.50008 0.372102,0.80792 1.058106,0.904089 l 0.320567,0.04445 c 0.365439,0.05128 0.538444,0.147461 0.538444,0.320563 0,0.237218 -0.243528,0.371902 -0.69873,0.371902 a 1.6316662,1.6316662 0 0 1 -1.019289,-0.320606 l -0.320562,0.519663 a 2.2086798,2.2086798 0 0 0 1.323576,0.396946 c 0.881546,0 1.394948,-0.461335 1.394948,-0.999881 0,-0.538545 -0.403858,-0.820441 -1.07063,-0.916612 l -0.320563,-0.04509 c -0.288506,-0.03848 -0.519662,-0.07675 -0.519662,-0.301152 0,-0.224394 0.218082,-0.359382 0.583526,-0.359382 a 1.9714631,1.9714631 0 0 1 0.961688,0.262961 l 0.298023,-0.538445 A 2.2888207,2.2888207 0 0 0 21.3514,19.06818 Z m 6.45947,0 0.0132,0.01254 a 0.90398792,0.90398792 0 0 0 -0.80829,0.448915 v -0.371917 h -0.659908 v 3.061628 h 0.666794 v -1.714927 c 0,-0.506487 0.205162,-0.788884 0.641127,-0.788884 a 1.0835034,1.0835034 0 0 1 0.416355,0.07701 l 0.205363,-0.641127 a 1.4200945,1.4200945 0 0 0 -0.474583,-0.08326 z m 2.301544,0 a 1.7246296,1.7246296 0 0 0 -0.656779,0.13148 1.5835818,1.5835818 0 0 0 -0.519661,0.339973 1.564348,1.564348 0 0 0 -0.343103,0.509644 1.7021902,1.7021902 0 0 0 0,1.282252 1.564348,1.564348 0 0 0 0.343103,0.509647 1.5835818,1.5835818 0 0 0 0.519661,0.339972 1.8143872,1.8143872 0 0 0 1.314183,0 1.6028157,1.6028157 0 0 0 0.522793,-0.339972 1.5483199,1.5483199 0 0 0 0.345606,-0.509647 1.6989845,1.6989845 0 0 0 0,-1.282252 1.5515252,1.5515252 0 0 0 -0.345606,-0.509644 1.6028157,1.6028157 0 0 0 -0.532186,-0.343105 1.7246296,1.7246296 0 0 0 -0.641125,-0.122092 z m -15.816534,0.0025 a 1.1604384,1.1604384 0 0 0 -0.05759,6.27e-4 1.602816,1.602816 0 0 0 0,3.205632 1.1604384,1.1604384 0 0 0 0.961689,-0.448915 v 0.371903 h 0.666796 l 0.0062,-1.522675 v -1.528937 h -0.673017 v 0.371902 a 1.1604384,1.1604384 0 0 0 -0.904087,-0.449539 z m 3.747834,0.0039 a 1.6029727,1.6029727 0 0 0 0.04446,3.205629 1.859266,1.859266 0 0 0 1.253452,-0.429506 l -0.320573,-0.493394 a 1.458562,1.458562 0 0 1 -0.89094,0.320563 0.84949219,0.84949219 0 0 1 -0.917235,-0.750067 h 2.273368 c 0.0096,-0.07692 0.0094,-0.160682 0.0094,-0.250439 0,-0.961691 -0.596025,-1.602816 -1.451926,-1.602816 z m -0.05135,0.589784 a 0.78858528,0.78858528 0 0 1 0.03819,0 0.75973457,0.75973457 0 0 1 0.775738,0.743808 h -1.589666 a 0.78858528,0.78858528 0 0 1 0.775738,-0.743808 z m 12.120042,0.03256 a 0.99374563,0.99374563 0 0 1 0.385051,0.08952 0.91681058,0.91681058 0 0 1 0.320563,0.201604 0.92963292,0.92963292 0 0 1 0.201606,0.320564 1.1123539,1.1123539 0 0 1 0,0.795147 0.92642727,0.92642727 0 0 1 -0.201606,0.320562 0.91681058,0.91681058 0 0 1 -0.320563,0.202231 1.0418302,1.0418302 0 0 1 -0.760083,0 0.89757672,0.89757672 0 0 1 -0.304286,-0.202231 0.9360443,0.9360443 0 0 1 -0.202231,-0.320562 1.1123539,1.1123539 0 0 1 0,-0.795147 0.93924994,0.93924994 0 0 1 0.202231,-0.320564 0.90078228,0.90078228 0 0 1 0.304286,-0.201604 0.99374563,0.99374563 0 0 1 0.381918,-0.07073 z M 14.309018,19.80595 a 0.92642727,0.92642727 0 1 1 0.01565,1.852627 0.91681058,0.91681058 0 0 1 -0.936018,-0.981097 h 0.0069 a 0.92642727,0.92642727 0 0 1 0.913439,-0.871499 z m 18.111818,1.952179 -0.01629,0.0031 a 0.3205631,0.3205631 0 0 0 -0.10581,0.0194 0.3205631,0.3205631 0 0 0 -0.09955,0.06386 0.3205631,0.3205631 0 0 0 -0.067,0.09641 0.30132932,0.30132932 0 0 0 0,0.236665 0.3205631,0.3205631 0 0 0 0.288631,0.185952 0.30132932,0.30132932 0 0 0 0.12147,-0.02567 0.3205631,0.3205631 0 0 0 0.09956,-0.06384 0.3205631,0.3205631 0 0 0 0.06763,-0.09642 0.2981237,0.2981237 0 0 0 0,-0.236664 0.3205631,0.3205631 0 0 0 -0.06763,-0.09641 0.3205631,0.3205631 0 0 0 -0.09956,-0.06387 0.3205631,0.3205631 0 0 0 -0.12147,-0.02255 z m 0,0.067 a 0.23080544,0.23080544 0 0 1 0.09266,0.01941 0.2372167,0.2372167 0 0 1 0.07387,0.384424 0.24042232,0.24042232 0 0 1 -0.07387,0.05135 0.2275998,0.2275998 0 0 1 -0.09266,0.01941 v -0.01321 a 0.2372167,0.2372167 0 0 1 -0.170301,-0.07014 0.2372167,0.2372167 0 0 1 0,-0.320564 0.23401105,0.23401105 0 0 1 0.07701,-0.05134 0.24042232,0.24042232 0 0 1 0.09329,-0.0194 z m 0.01878,0.09329 -0.134612,0.0031 v 0.281748 h 0.06134 v -0.105802 h 0.0288 l 0.08639,0.105811 h 0.07388 l -0.09329,-0.105811 a 0.11219709,0.11219709 0 0 0 0.06761,-0.02879 0.07693513,0.07693513 0 0 0 0.02255,-0.05761 0.08014078,0.08014078 0 0 0 -0.0288,-0.067 0.12822525,0.12822525 0 0 0 -0.08391,-0.02567 z m -0.07014,0.05448 0.07014,0.01878 a 0.06731826,0.06731826 0 0 1 0.03881,0 0.03205633,0.03205633 0 0 1 0,0.02943 0.03205633,0.03205633 0 0 1 0,0.0288 0.06731826,0.06731826 0 0 1 -0.03881,0 h -0.07014 z" style="fill:#ffffff;stroke-width:0.77356213" />\n    <g transform="matrix(0.21220782,0,0,0.21220782,2.1400282,0.14227739)">\n        <rect x="68.410004" y="15.14" width="31.5" height="56.610001" style="fill:#7673c0" />\n        <path d="m 382.25,296.22 a 35.94,35.94 0 0 1 13.75,-28.3 36,36 0 1 0 0,56.61 35.94,35.94 0 0 1 -13.75,-28.31 z" transform="translate(-311.84,-252.78)" id="path8" style="fill:#eb001b" />\n        <path d="m 450.81,318.53 v -1.16 h 0.47 v -0.24 h -1.19 v 0.24 h 0.47 v 1.16 z m 2.31,0 v -1.4 h -0.36 l -0.42,1 -0.42,-1 h -0.36 v 1.4 h 0.26 v -1.05 l 0.39,0.91 h 0.27 l 0.39,-0.91 v 1.06 z" transform="translate(-311.84,-252.78)" style="fill:#00a1df" />\n        <path d="m 454.25,296.22 a 36,36 0 0 1 -58.25,28.3 36,36 0 0 0 0,-56.61 36,36 0 0 1 58.25,28.3 z" transform="translate(-311.84,-252.78)" style="fill:#00a1df" />\n    </g>\n</svg>\n';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(17, 49, 82);"/>\n  <path d="M 5.498 13.349 C 5.16 13.654 4.722 13.787 4.028 13.787 L 3.738 13.787 L 3.738 10.141 L 4.028 10.141 C 4.722 10.141 5.143 10.265 5.498 10.587 C 5.868 10.917 6.093 11.431 6.093 11.959 C 6.093 12.489 5.869 13.019 5.498 13.349 Z M 4.243 9.206 L 2.666 9.206 L 2.666 14.721 L 4.236 14.721 C 5.069 14.721 5.671 14.524 6.199 14.084 C 6.829 13.564 7.199 12.779 7.199 11.968 C 7.199 10.34 5.985 9.206 4.243 9.206 Z M 7.696 14.721 L 8.77 14.721 L 8.77 9.207 L 7.696 9.207 M 11.393 11.323 C 10.748 11.083 10.559 10.926 10.559 10.628 C 10.559 10.281 10.897 10.018 11.359 10.018 C 11.681 10.018 11.946 10.15 12.226 10.464 L 12.788 9.727 C 12.326 9.322 11.773 9.115 11.17 9.115 C 10.195 9.115 9.452 9.793 9.452 10.695 C 9.452 11.455 9.798 11.845 10.807 12.208 C 11.227 12.356 11.442 12.455 11.55 12.522 C 11.765 12.662 11.872 12.862 11.872 13.092 C 11.872 13.54 11.518 13.872 11.038 13.872 C 10.528 13.872 10.114 13.614 9.868 13.136 L 9.173 13.806 C 9.668 14.532 10.263 14.856 11.08 14.856 C 12.196 14.856 12.98 14.111 12.98 13.044 C 12.98 12.168 12.617 11.771 11.395 11.324 Z M 13.316 11.968 C 13.316 13.588 14.586 14.845 16.223 14.845 C 16.685 14.845 17.081 14.755 17.57 14.525 L 17.57 13.258 C 17.14 13.688 16.76 13.862 16.273 13.862 C 15.191 13.862 14.423 13.077 14.423 11.962 C 14.423 10.902 15.215 10.067 16.223 10.067 C 16.735 10.067 17.123 10.25 17.57 10.687 L 17.57 9.421 C 17.098 9.181 16.71 9.081 16.248 9.081 C 14.621 9.081 13.316 10.364 13.316 11.968 Z M 26.088 12.911 L 24.62 9.206 L 23.446 9.206 L 25.783 14.862 L 26.361 14.862 L 28.741 9.207 L 27.576 9.207 M 29.226 14.721 L 32.272 14.721 L 32.272 13.787 L 30.299 13.787 L 30.299 12.299 L 32.199 12.299 L 32.199 11.365 L 30.299 11.365 L 30.299 10.141 L 32.272 10.141 L 32.272 9.206 L 29.226 9.206 M 34.373 11.745 L 34.059 11.745 L 34.059 10.075 L 34.389 10.075 C 35.059 10.075 35.423 10.355 35.423 10.893 C 35.423 11.447 35.059 11.745 34.373 11.745 Z M 36.528 10.835 C 36.528 9.802 35.818 9.207 34.578 9.207 L 32.986 9.207 L 32.986 14.721 L 34.059 14.721 L 34.059 12.506 L 34.199 12.506 L 35.686 14.721 L 37.006 14.721 L 35.273 12.398 C 36.083 12.233 36.528 11.678 36.528 10.835 Z" style="fill: rgb(255, 255, 255);"/>\n  <g id="MarkingBase_1_" transform="matrix(0.089776, 0, 0, 0.089776, 2.192296, 5.72498)">\n    <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="224.3917" y1="44.1731" x2="201.33" y2="80.2807" gradientTransform="matrix(1 0 0 -1 0 141.7323)">\n      <stop offset="0" style="stop-color:#F89F21"/>\n      <stop offset="0.2502" style="stop-color:#F79A23"/>\n      <stop offset="0.5331" style="stop-color:#F78E22"/>\n      <stop offset="0.6196" style="stop-color:#F68721"/>\n      <stop offset="0.7232" style="stop-color:#F48220"/>\n      <stop offset="1" style="stop-color:#F27623"/>\n    </linearGradient>\n    <circle fill="url(#SVGID_1_)" cx="207.343" cy="70.866" r="33.307"/>\n    <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="220.7487" y1="44.664" x2="187.0436" y2="110.5426" gradientTransform="matrix(1 0 0 -1 0 141.7323)">\n      <stop offset="0" style="stop-color:#F68721;stop-opacity:0"/>\n      <stop offset="0.3587" style="stop-color:#E27027;stop-opacity:0.2704"/>\n      <stop offset="0.703" style="stop-color:#D4612C;stop-opacity:0.5299"/>\n      <stop offset="0.9816" style="stop-color:#D15D2D;stop-opacity:0.74"/>\n    </linearGradient>\n    <circle opacity="0.65" fill="url(#SVGID_2_)" cx="207.343" cy="70.866" r="33.307"/>\n  </g>\n  <g id="Orange_1_" enable-background="new    " transform="matrix(0.469224, 0, 0, 0.469224, 13.785085, 6.199149)">\n    <g id="Orange">\n      <g>\n        <path d="M13,38c20.1,0,40,0,40,0c1.7,0,3-1.3,3-3V18C56,18,51.2,31.8,13,38z" style="fill: rgb(255, 129, 38);"/>\n      </g>\n    </g>\n  </g>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(243, 97, 24);"/>\n  <path id="path16" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 3.206 6.45 L 3.206 16.929 L 5.586 16.929 L 5.586 12.545 L 9.489 12.545 L 9.489 16.929 L 11.853 16.929 L 11.853 6.45 L 9.489 6.45 L 9.489 10.477 L 5.586 10.477 L 5.586 6.45 L 3.206 6.45"/>\n  <path id="path18" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 32.319 13.882 C 32.351 13.71 32.397 13.353 32.397 12.949 C 32.397 11.068 31.464 9.155 29.008 9.155 C 26.364 9.155 25.167 11.285 25.167 13.213 C 25.167 15.592 26.644 17.085 29.225 17.085 C 30.251 17.085 31.2 16.929 31.977 16.618 L 31.666 15.017 C 31.029 15.219 30.376 15.328 29.567 15.328 C 28.463 15.328 27.499 14.861 27.422 13.882 Z M 27.406 12.265 C 27.468 11.628 27.873 10.725 28.868 10.725 C 29.956 10.725 30.205 11.689 30.205 12.265 L 27.406 12.265"/>\n  <path id="path20" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 33.155 16.929 L 35.519 16.929 L 35.519 13.073 C 35.519 12.887 35.533 12.7 35.565 12.545 C 35.72 11.814 36.31 11.348 37.182 11.348 C 37.446 11.348 37.648 11.378 37.819 11.41 L 37.819 9.186 C 37.648 9.155 37.539 9.155 37.321 9.155 C 36.591 9.155 35.658 9.621 35.269 10.725 L 35.207 10.725 L 35.129 9.326 L 33.092 9.326 C 33.123 9.979 33.155 10.709 33.155 11.829 L 33.155 16.929"/>\n  <path id="path22" style="fill: rgb(254, 234, 1); fill-opacity: 1; fill-rule: evenodd; stroke: none;" d="M 14.256 6.028 C 14.927 6.028 15.472 6.572 15.472 7.243 C 15.472 7.914 14.927 8.458 14.256 8.458 C 13.585 8.458 13.041 7.914 13.041 7.243 C 13.041 6.572 13.585 6.028 14.256 6.028"/>\n  <path id="path24" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: evenodd; stroke: none;" d="M 19.247 15.159 L 20.433 15.159 C 21.624 15.159 22.163 14.395 22.163 13.6 C 22.163 12.805 22.106 11.006 20.633 11.006 C 18.943 11.006 19.218 13.238 19.224 14.408 C 19.226 14.658 19.24 14.908 19.247 15.159 Z M 13.041 9.315 L 15.472 9.315 L 15.472 13.6 C 15.472 14.395 15.912 15.157 16.887 15.159 C 16.894 13.229 16.886 11.243 16.822 9.315 L 18.852 9.315 C 18.896 9.687 18.936 10.059 18.973 10.432 C 19.932 8.514 22.954 8.937 23.971 10.555 C 25.022 12.228 25.379 17.017 20.433 17.017 L 19.282 17.017 C 19.293 17.988 19.295 18.963 19.295 19.936 L 16.865 19.936 C 16.865 19.001 16.871 18.022 16.878 17.016 C 14.252 17.007 13.041 15.339 13.041 13.6 L 13.041 9.315"/>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(21, 21, 21);"/>\n  <path class="st0" d="M 9.229 8.55 C 9.592 8.431 9.977 8.365 10.382 8.365 C 12.14 8.365 13.602 9.613 13.939 11.268 L 16.427 10.762 C 15.855 7.946 13.365 5.824 10.379 5.824 C 9.693 5.824 9.037 5.935 8.42 6.142 L 9.229 8.55 Z" style="fill: rgb(255, 205, 5);"/>\n  <path class="st1" d="M 6.292 16.616 L 7.973 14.716 C 7.221 14.052 6.749 13.08 6.749 11.999 C 6.749 10.917 7.221 9.945 7.973 9.279 L 6.292 7.38 C 5.015 8.51 4.209 10.16 4.209 11.999 C 4.209 13.836 5.019 15.488 6.292 16.616" style="fill: rgb(0, 164, 224);"/>\n  <path class="st2" d="M 13.939 12.723 C 13.602 14.379 12.136 15.626 10.382 15.626 C 9.977 15.626 9.592 15.562 9.229 15.442 L 8.422 17.849 C 9.039 18.055 9.698 18.167 10.382 18.167 C 13.365 18.167 15.855 16.05 16.427 13.235 L 13.939 12.723 Z" style="fill: rgb(239, 66, 35);"/>\n  <path d="M 18.603 14.794 C 18.521 14.663 18.412 14.453 18.343 14.296 C 17.948 13.381 17.932 12.434 18.264 11.526 C 18.631 10.527 19.33 9.765 20.233 9.378 C 21.366 8.889 22.626 8.986 23.713 9.632 C 24.406 10.028 24.897 10.641 25.269 11.506 C 25.319 11.615 25.358 11.737 25.398 11.835 L 18.603 14.794 Z M 20.87 10.845 C 20.066 11.194 19.65 11.949 19.734 12.834 L 23.151 11.363 C 22.565 10.675 21.802 10.444 20.87 10.845 Z M 23.578 14.044 C 23.578 14.044 23.578 14.044 23.578 14.044 L 23.508 13.998 C 23.302 14.331 22.985 14.595 22.584 14.768 C 21.82 15.1 21.113 15.014 20.602 14.569 L 20.559 14.643 C 20.559 14.643 20.559 14.643 20.559 14.643 L 19.688 15.936 C 19.905 16.088 20.134 16.213 20.376 16.315 C 21.333 16.712 22.311 16.693 23.279 16.273 C 23.978 15.971 24.527 15.509 24.9 14.924 L 23.578 14.044 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 27.77 7.466 L 27.77 14.673 L 28.891 15.13 L 28.254 16.614 L 27.018 16.1 C 26.742 15.979 26.552 15.797 26.409 15.588 C 26.272 15.377 26.171 15.085 26.171 14.698 L 26.171 7.466 L 27.77 7.466 Z" style="fill: rgb(255, 255, 255);"/>\n  <g transform="matrix(0.037801, 0, 0, 0.037801, 1.0913, 0.089785)">\n    <path d="M782.7,337.2c0-16.2,7.2-30.8,18.5-40.7l-30.4-33.9c-20.6,18.2-33.6,44.9-33.6,74.6c0,29.7,12.9,56.4,33.6,74.7l30.4-34&#10;&#9;&#9;C789.8,367.9,782.6,353.4,782.7,337.2z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M836.7,391.4c-6,0-11.8-1-17.1-2.8L805,431.7c9.9,3.3,20.6,5.1,31.6,5.2c48.2,0,88.4-34.1,97.7-79.6l-44.7-9.1&#10;&#9;&#9;C884.6,372.9,862.8,391.4,836.7,391.4z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M836.8,237.6c-11,0-21.7,1.8-31.6,5.1l14.4,43.2c5.4-1.8,11.2-2.8,17.1-2.8c26.2,0,48,18.6,53,43.3l44.7-9.1&#10;&#9;&#9;C925.2,272,885,237.7,836.8,237.6z" style="fill: rgb(255, 255, 255);"/>\n  </g>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <pattern id="pattern-0" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" viewBox="0 0 100 100">\n      <path d="M 0 0 L 50 0 L 50 100 L 0 100 Z" style="fill: black;"/>\n    </pattern>\n  </defs>\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(255, 255, 255); stroke: rgb(233, 234, 231);"/>\n  <g transform="matrix(0.100306, 0, 0, 0.100306, 4.733743, 10.105099)" id="g6321">\n    <g transform="matrix(1.8215159,0,0,1.8215159,-8.5437653,-109.83667)" id="g6323">\n      <path style="fill:#ffffff" id="path6325" d="m 174,108.3 c 0,14 -11.4,25.4 -25.4,25.4 l -138.2,0 0,-100.6 c 0,-14 11.4,-25.4 25.4,-25.4 l 138.2,0 0,100.6 z" class="st0"/>\n      <g id="g6327">\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="81.398598" x2="157.3299" y1="81.398598" x1="117.3856" gradientUnits="userSpaceOnUse" id="SVGID_1_">\n          <stop id="stop6330" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6332" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6334" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6336" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_1_)" id="path6338" d="m 129,82.5 10.5,0 c 0.3,0 1,-0.1 1.3,-0.1 2,-0.4 3.7,-2.2 3.7,-4.7 0,-2.4 -1.7,-4.2 -3.7,-4.7 -0.3,-0.1 -0.9,-0.1 -1.3,-0.1 l -10.5,0 0,9.6 z" class="st1"/>\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="157.3318" y1="75.171402" x1="117.3844" gradientUnits="userSpaceOnUse" id="SVGID_2_">\n          <stop id="stop6341" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6343" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6345" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6347" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_2_)" id="path6349" d="m 138.3,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,18.9 25.7,0 c 0.6,0 1.3,0 1.8,0.1 5.8,0.3 10.1,3.3 10.1,8.5 0,4.1 -2.9,7.6 -8.3,8.3 l 0,0.2 c 5.9,0.4 10.4,3.7 10.4,8.8 0,5.5 -5,9.1 -11.6,9.1 l -28.2,0 0,37 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.9 -26.6,0 z" class="st2"/>\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="68.399101" x2="157.33051" y1="68.399101" x1="117.3846" gradientUnits="userSpaceOnUse" id="SVGID_3_">\n          <stop id="stop6352" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6354" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6356" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6358" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_3_)" id="path6360" d="m 143.2,63.1 c 0,-2.4 -1.7,-4 -3.7,-4.3 -0.2,0 -0.7,-0.1 -1,-0.1 l -9.5,0 0,8.8 9.5,0 c 0.3,0 0.9,0 1,-0.1 2,-0.3 3.7,-1.9 3.7,-4.3 z" class="st3"/>\n      </g>\n      <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="68.522102" y1="75.171402" x1="27.9594" gradientUnits="userSpaceOnUse" id="SVGID_4_">\n        <stop id="stop6363" style="stop-color:#1F286F" offset="0"/>\n        <stop id="stop6365" style="stop-color:#004E94" offset="0.4751"/>\n        <stop id="stop6367" style="stop-color:#0066B1" offset="0.8261"/>\n        <stop id="stop6369" style="stop-color:#006FBC" offset="1"/>\n      </linearGradient>\n      <path style="fill:url(#SVGID_4_)" id="path6371" d="m 37.7,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,44.9 c 5.1,2.5 10.4,4.1 15.7,4.1 6.3,0 9.7,-3.8 9.7,-9 l 0,-21.2 15.6,0 0,21.1 c 0,8.2 -5.1,14.9 -22.4,14.9 -10.5,0 -18.7,-2.3 -18.7,-2.3 l 0,38.3 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.8 -26.6,0 z" class="st4"/>\n      <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="111.8553" y1="75.171402" x1="72.459503" gradientUnits="userSpaceOnUse" id="SVGID_5_">\n        <stop id="stop6374" style="stop-color:#6C2C2F" offset="0"/>\n        <stop id="stop6376" style="stop-color:#882730" offset="0.1735"/>\n        <stop id="stop6378" style="stop-color:#BE1833" offset="0.5731"/>\n        <stop id="stop6380" style="stop-color:#DC0436" offset="0.8585"/>\n        <stop id="stop6382" style="stop-color:#E60039" offset="1"/>\n      </linearGradient>\n      <path style="fill:url(#SVGID_5_)" id="path6384" d="m 88,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,23.8 c 4.6,-3.9 12.6,-6.4 25.5,-5.8 6.9,0.3 14.3,2.2 14.3,2.2 l 0,7.7 c -3.7,-1.9 -8.1,-3.6 -13.8,-4 -9.8,-0.7 -15.7,4.1 -15.7,12.5 0,8.5 5.9,13.3 15.7,12.5 5.7,-0.4 10.1,-2.2 13.8,-4 l 0,7.7 c 0,0 -7.3,1.9 -14.3,2.2 -12.9,0.6 -20.9,-1.9 -25.5,-5.8 l 0,42 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-91 -26.7,0 z" class="st5"/>\n    </g>\n    <g id="g6386"/>\n  </g>\n</svg>';
    }, function(module, exports) {
        module.exports = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="40px" height="24px" viewBox="0 0 40 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    \x3c!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch --\x3e\n    <title>unionpay</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id="unionpay" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g>\n            <path d="M38,24 L2,24 C0.9,24 0,23.1 0,22 L0,2 C0,0.9 0.9,0 2,0 L38,0 C39.1,0 40,0.9 40,2 L40,22 C40,23.1 39.1,24 38,24" id="Fill-1" fill="#FFFFFF"></path>\n            <path d="M38,0 L2,0 C0.9,0 0,0.9 0,2 L0,22 C0,23.1 0.9,24 2,24 L38,24 C39.1,24 40,23.1 40,22 L40,2 C40,0.9 39.1,0 38,0 M38,1 C38.551,1 39,1.449 39,2 L39,22 C39,22.551 38.551,23 38,23 L2,23 C1.449,23 1,22.551 1,22 L1,2 C1,1.449 1.449,1 2,1 L38,1" id="Fill-3" fill="#C8C8C8"></path>\n            <path d="M11.6294,3.3945 L18.4974,3.3945 C19.4564,3.3945 20.0524,4.1755 19.8284,5.1375 L16.6294,18.8655 C16.4054,19.8245 15.4474,20.6055 14.4904,20.6055 L7.6204,20.6055 C6.6624,20.6055 6.0664,19.8245 6.2894,18.8655 L9.4894,5.1375 C9.7124,4.1755 10.6694,3.3945 11.6294,3.3945" id="Fill-5" fill="#D80029"></path>\n            <path d="M17.9287,3.3945 L24.7967,3.3945 C25.7537,3.3945 26.3547,4.1755 26.1257,5.1375 L22.9297,18.8655 C22.7037,19.8245 21.7437,20.6055 20.7837,20.6055 L13.9177,20.6055 C12.9587,20.6055 12.3627,19.8245 12.5877,18.8655 L15.7837,5.1375 C16.0077,4.1755 16.9697,3.3945 17.9287,3.3945" id="Fill-7" fill="#0E2E62"></path>\n            <path d="M25.5161,3.3945 L32.3771,3.3945 C33.3361,3.3945 33.9351,4.1755 33.7091,5.1375 L30.5121,18.8655 C30.2891,19.8245 29.3291,20.6055 28.3711,20.6055 L21.5001,20.6055 C20.5421,20.6055 19.9431,19.8245 20.1691,18.8655 L23.3661,5.1375 C23.5901,4.1755 24.5511,3.3945 25.5161,3.3945" id="Fill-9" fill="#0C606C"></path>\n            <path d="M24.4546,16.3071 L25.1006,16.3071 L25.2466,15.6821 L24.5976,15.6821 L24.4546,16.3071 Z M24.8526,14.5921 L24.6816,15.3221 C24.6816,15.3221 24.9176,15.1981 25.0506,15.1611 C25.1796,15.1271 25.3786,15.1051 25.3786,15.1051 L25.5006,14.5921 L24.8526,14.5921 Z M25.1026,13.5291 L24.9406,14.2371 C24.9406,14.2371 25.1706,14.1281 25.3006,14.0941 C25.4316,14.0581 25.6296,14.0401 25.6296,14.0401 L25.7516,13.5291 L25.1026,13.5291 Z M26.5356,13.5291 L25.8886,16.2961 L26.1126,16.2961 L25.9756,16.8721 L25.7516,16.8721 L25.7106,17.0491 L24.9126,17.0491 L24.9556,16.8721 L23.3366,16.8721 L23.4636,16.3421 L23.6286,16.3401 L24.2886,13.5291 L24.4186,12.9631 L25.2336,12.9631 L25.1686,13.2481 C25.1686,13.2481 25.3736,13.0911 25.5716,13.0391 C25.7756,12.9841 26.9526,12.9641 26.9526,12.9641 L26.8176,13.5291 L26.5356,13.5291 Z" id="Fill-11" fill="#FFFFFF"></path>\n            <path d="M26.9966,12.9678 L27.8616,12.9678 L27.8726,13.2878 C27.8666,13.3418 27.9146,13.3668 28.0136,13.3688 L28.1616,13.3688 L28.0306,13.9018 L27.5596,13.9018 C27.1566,13.9318 27.0016,13.7578 27.0136,13.5618 L26.9966,12.9678" id="Fill-13" fill="#FFFFFF"></path>\n            <path d="M27.1436,15.4956 L26.3166,15.4956 L26.4276,15.0226 L27.3706,15.0226 L27.4736,14.5886 L26.5416,14.5886 L26.6686,14.0536 L29.2616,14.0536 L29.1336,14.5886 L28.2656,14.5886 L28.1616,15.0226 L29.0326,15.0226 L28.9216,15.4956 L27.9786,15.4956 L27.8216,15.6976 L28.2056,15.6976 L28.3396,16.2966 C28.3516,16.3536 28.3596,16.3926 28.3786,16.4196 C28.3956,16.4386 28.5126,16.4486 28.5806,16.4486 L28.6976,16.4486 L28.5596,17.0356 L28.2656,17.0356 C28.2206,17.0356 28.1526,17.0346 28.0576,17.0246 C27.9706,17.0176 27.9036,16.9636 27.8406,16.9376 C27.7836,16.9106 27.6996,16.8476 27.6706,16.7326 L27.5386,16.1376 L27.1546,16.7246 C27.0266,16.9106 26.8526,17.0496 26.5396,17.0496 L25.9386,17.0496 L26.0596,16.5326 L26.2906,16.5326 C26.3556,16.5326 26.4156,16.5056 26.4546,16.4836 C26.4986,16.4646 26.5356,16.4426 26.5796,16.3806 L27.1436,15.4956" id="Fill-15" fill="#FFFFFF"></path>\n            <path d="M18.0044,14.1973 L20.1934,14.1973 L20.0684,14.7183 L19.1874,14.7183 L19.0834,15.1663 L19.9734,15.1663 L19.8434,15.7033 L18.9514,15.7033 L18.7794,16.4263 C18.7584,16.5053 18.9974,16.5203 19.0834,16.5203 L19.5254,16.4583 L19.3824,17.0503 L18.3764,17.0503 C18.2934,17.0503 18.2344,17.0433 18.1454,17.0223 C18.0594,17.0003 18.0184,16.9613 17.9734,16.9053 C17.9374,16.8493 17.8764,16.7963 17.9074,16.6723 L18.1364,15.7123 L17.6394,15.7123 L17.7704,15.1663 L18.2714,15.1663 L18.3764,14.7183 L17.8784,14.7183 L18.0044,14.1973" id="Fill-17" fill="#FFFFFF"></path>\n            <path d="M19.4194,13.2588 L20.3174,13.2588 L20.1894,13.8018 L18.9614,13.8018 L18.8354,13.9198 C18.7844,13.9738 18.7614,13.9518 18.6914,13.9888 C18.6234,14.0278 18.4814,14.0938 18.2914,14.0938 L17.9004,14.0938 L18.0264,13.5718 L18.1414,13.5718 C18.2444,13.5718 18.3104,13.5588 18.3434,13.5378 C18.3804,13.5158 18.4214,13.4598 18.4644,13.3688 L18.6664,12.9618 L19.5584,12.9618 L19.4194,13.2588" id="Fill-19" fill="#FFFFFF"></path>\n            <path d="M21.1973,14.1572 C21.1973,14.1572 21.4273,13.9322 21.8443,13.8582 C21.9383,13.8422 22.5393,13.8462 22.5393,13.8462 L22.6063,13.5452 L21.3453,13.5452 L21.1973,14.1572 Z M22.3963,14.3842 L21.1463,14.3842 L21.0853,14.6352 L22.1703,14.6352 C22.2953,14.6232 22.3233,14.6392 22.3313,14.6342 L22.3963,14.3842 Z M20.6843,12.9632 L21.4543,12.9632 L21.3633,13.3512 C21.3633,13.3512 21.5903,13.1552 21.7603,13.0912 C21.9223,13.0252 22.3023,12.9702 22.3023,12.9702 L23.5393,12.9632 L23.2033,14.3672 C23.1463,14.6112 23.0763,14.7642 23.0263,14.8342 C22.9833,14.9052 22.9343,14.9662 22.8283,15.0262 C22.7283,15.0832 22.6333,15.1142 22.5453,15.1222 C22.4663,15.1322 22.3403,15.1322 22.1653,15.1332 L20.9773,15.1332 L20.7093,16.2452 C20.6813,16.3562 20.6723,16.4072 20.6943,16.4382 C20.7123,16.4622 20.7553,16.4932 20.8113,16.4932 L21.3323,16.4422 L21.1933,17.0552 L20.6003,17.0552 C20.4153,17.0552 20.2773,17.0502 20.1853,17.0422 C20.0933,17.0352 19.9953,17.0422 19.9293,16.9922 C19.8733,16.9412 19.7873,16.8822 19.7843,16.8172 C19.7873,16.7572 19.8063,16.6562 19.8333,16.5212 L20.6843,12.9632 Z" id="Fill-21" fill="#FFFFFF"></path>\n            <path d="M23.0562,15.2319 L23.0082,15.5689 C22.9802,15.6729 22.9602,15.7539 22.8882,15.8259 C22.8062,15.8939 22.7132,15.9679 22.4822,15.9679 L22.0622,15.9839 L22.0792,16.3649 C22.0832,16.4769 22.1092,16.4639 22.1282,16.4819 C22.1512,16.5019 22.1652,16.5079 22.1862,16.5139 L22.3222,16.5079 L22.7222,16.4829 L22.5922,17.0439 L22.1282,17.0439 C21.8022,17.0439 21.5562,17.0339 21.4752,16.9709 C21.3932,16.9189 21.3802,16.8579 21.3752,16.7559 L21.3112,15.2649 L22.0562,15.2649 L22.0642,15.5689 L22.2422,15.5689 C22.3052,15.5689 22.3442,15.5649 22.3702,15.5479 C22.3892,15.5289 22.4032,15.5069 22.4162,15.4709 L22.4692,15.2319 L23.0562,15.2319" id="Fill-23" fill="#FFFFFF"></path>\n            <path d="M12.4448,7.7773 C12.4168,7.9033 11.9418,10.0983 11.9398,10.1003 C11.8368,10.5433 11.7588,10.8603 11.5118,11.0673 C11.3628,11.1853 11.1948,11.2413 11.0048,11.2413 C10.6918,11.2413 10.5078,11.0883 10.4738,10.7923 L10.4658,10.6903 C10.4658,10.6903 10.5628,10.0983 10.5628,10.0963 C10.5628,10.0963 11.0648,8.0893 11.1558,7.8233 C11.1578,7.8083 11.1608,7.7983 11.1638,7.7903 C10.1898,7.8023 10.0168,7.7953 10.0048,7.7773 C9.9988,7.7983 9.9738,7.9253 9.9738,7.9253 L9.4628,10.1823 L9.4148,10.3743 L9.3348,10.9983 C9.3348,11.1853 9.3698,11.3383 9.4428,11.4663 C9.6748,11.8713 10.3408,11.9313 10.7158,11.9313 C11.1998,11.9313 11.6508,11.8263 11.9588,11.6443 C12.4908,11.3253 12.6318,10.8333 12.7528,10.3993 L12.8108,10.1743 C12.8108,10.1743 13.3288,8.0923 13.4158,7.8233 C13.4178,7.8083 13.4218,7.7983 13.4238,7.7903 C12.7188,7.8013 12.5118,7.7953 12.4448,7.7773" id="Fill-25" fill="#FFFFFF"></path>\n            <path d="M15.2935,11.9106 C14.9485,11.9056 14.8275,11.9056 14.4245,11.9246 L14.4055,11.8966 C14.4425,11.7416 14.4815,11.5876 14.5165,11.4346 L14.5645,11.2266 C14.6395,10.8986 14.7155,10.5206 14.7195,10.4026 C14.7285,10.3336 14.7505,10.1606 14.5525,10.1606 C14.4695,10.1606 14.3815,10.1996 14.2925,10.2416 C14.2475,10.4136 14.1445,10.9026 14.0985,11.1246 C14.0005,11.5956 13.9905,11.6496 13.9475,11.8796 L13.9185,11.9106 C13.5605,11.9056 13.4395,11.9056 13.0315,11.9246 L13.0135,11.8926 C13.0795,11.6086 13.1485,11.3326 13.2115,11.0526 C13.3855,10.2976 13.4265,10.0106 13.4725,9.6276 L13.5045,9.6006 C13.9065,9.5466 14.0015,9.5326 14.4355,9.4436 L14.4695,9.4836 L14.4035,9.7266 C14.4785,9.6846 14.5505,9.6406 14.6255,9.6006 C14.8275,9.5026 15.0535,9.4706 15.1805,9.4706 C15.3675,9.4706 15.5725,9.5256 15.6605,9.7426 C15.7475,9.9376 15.6885,10.1786 15.5805,10.6526 L15.5275,10.8916 C15.4135,11.4216 15.3975,11.5196 15.3345,11.8796 L15.2935,11.9106" id="Fill-27" fill="#FFFFFF"></path>\n            <path d="M16.6963,11.9106 C16.4873,11.9056 16.3543,11.9056 16.2243,11.9106 C16.0943,11.9106 15.9663,11.9146 15.7733,11.9246 L15.7623,11.9056 L15.7513,11.8926 C15.8033,11.6936 15.8313,11.6216 15.8583,11.5526 C15.8843,11.4806 15.9093,11.4106 15.9553,11.2066 C16.0143,10.9436 16.0533,10.7546 16.0783,10.5966 C16.1083,10.4366 16.1223,10.3066 16.1423,10.1526 L16.1613,10.1396 L16.1743,10.1236 C16.3833,10.0986 16.5133,10.0776 16.6503,10.0546 C16.7823,10.0356 16.9213,10.0106 17.1363,9.9716 L17.1423,9.9866 L17.1523,10.0046 C17.1083,10.1696 17.0713,10.3336 17.0303,10.4996 C16.9913,10.6646 16.9533,10.8296 16.9173,10.9926 C16.8353,11.3386 16.8083,11.4716 16.7883,11.5626 C16.7723,11.6526 16.7673,11.6976 16.7363,11.8796 L16.7173,11.8966 L16.6963,11.9106" id="Fill-29" fill="#FFFFFF"></path>\n            <path d="M18.8965,10.6846 C18.8765,10.7706 18.7985,11.1066 18.6915,11.2486 C18.6185,11.3496 18.5295,11.4126 18.4375,11.4126 C18.4085,11.4126 18.2365,11.4126 18.2325,11.1616 C18.2325,11.0356 18.2545,10.9076 18.2875,10.7676 C18.3775,10.3706 18.4865,10.0316 18.7585,10.0316 C18.9745,10.0316 18.9875,10.2766 18.8965,10.6846 M19.7975,10.7226 C19.9195,10.1886 19.8285,9.9396 19.7085,9.7916 C19.5255,9.5596 19.2115,9.4836 18.8795,9.4836 C18.6825,9.4836 18.2135,9.5056 17.8445,9.8486 C17.5825,10.0906 17.4525,10.4256 17.3825,10.7426 C17.3075,11.0676 17.2205,11.6586 17.7575,11.8716 C17.9245,11.9426 18.1635,11.9656 18.3155,11.9656 C18.7125,11.9656 19.1165,11.8536 19.4175,11.5286 C19.6555,11.2726 19.7605,10.8806 19.7975,10.7226" id="Fill-31" fill="#FFFFFF"></path>\n            <path d="M28.7817,9.5107 C28.3477,9.5897 28.2337,9.6107 27.8217,9.6667 L27.7857,9.6907 C27.7837,9.7247 27.7777,9.7567 27.7717,9.7927 C27.7097,9.6877 27.6207,9.5947 27.4737,9.5377 C27.2867,9.4687 26.8547,9.5587 26.4857,9.9007 C26.2207,10.1417 26.0987,10.4697 26.0217,10.7907 C25.9497,11.1087 25.8627,11.6977 26.3987,11.9057 C26.5687,11.9777 26.7237,11.9987 26.8767,11.9907 C27.0457,11.9847 27.1937,11.8967 27.3367,11.7747 C27.3217,11.8257 27.3107,11.8767 27.2967,11.9287 L27.3217,11.9577 C27.7077,11.9427 27.8277,11.9427 28.2447,11.9477 L28.2827,11.9147 C28.3417,11.5587 28.4027,11.2087 28.5587,10.5227 C28.6347,10.1967 28.7127,9.8717 28.7937,9.5467 L28.7817,9.5107 M27.4107,11.2907 C27.3417,11.3917 27.1717,11.4537 27.0787,11.4537 C27.0507,11.4537 26.8807,11.4537 26.8767,11.2057 C26.8747,11.0787 26.8977,10.9507 26.9297,10.8127 C27.0187,10.4157 27.1277,10.0797 27.4047,10.0797 C27.5797,10.0797 27.6667,10.2537 27.6427,10.5387 C27.6267,10.6017 27.6187,10.6597 27.6017,10.7337 C27.5717,10.8587 27.5367,10.9807 27.5067,11.1027 C27.4797,11.1767 27.4487,11.2457 27.4107,11.2907" id="Fill-33" fill="#FFFFFF"></path>\n            <path d="M22.1577,11.9106 C21.8087,11.9056 21.6947,11.9056 21.2867,11.9246 L21.2717,11.8966 C21.3087,11.7416 21.3477,11.5876 21.3827,11.4346 L21.4317,11.2266 C21.5037,10.8986 21.5797,10.5206 21.5897,10.4026 C21.5927,10.3336 21.6147,10.1606 21.4167,10.1606 C21.3367,10.1606 21.2457,10.1996 21.1567,10.2416 C21.1117,10.4136 21.0117,10.9026 20.9637,11.1246 C20.8677,11.5956 20.8597,11.6496 20.8157,11.8796 L20.7837,11.9106 C20.4287,11.9056 20.3077,11.9056 19.8967,11.9246 L19.8777,11.8926 C19.9477,11.6086 20.0137,11.3326 20.0777,11.0526 C20.2507,10.2976 20.2907,10.0106 20.3407,9.6276 L20.3727,9.6006 C20.7727,9.5466 20.8677,9.5326 21.3027,9.4436 L21.3367,9.4836 L21.2717,9.7266 C21.3407,9.6846 21.4147,9.6406 21.4887,9.6006 C21.6927,9.5026 21.9187,9.4706 22.0427,9.4706 C22.2317,9.4706 22.4397,9.5256 22.5257,9.7426 C22.6087,9.9376 22.5547,10.1786 22.4457,10.6526 L22.3907,10.8916 C22.2787,11.4216 22.2607,11.5196 22.1987,11.8796 L22.1577,11.9106" id="Fill-35" fill="#FFFFFF"></path>\n            <path d="M25.1504,7.7729 L24.8644,7.7789 C24.1174,7.7889 23.8204,7.7859 23.6934,7.7679 C23.6834,7.8229 23.6634,7.9199 23.6634,7.9199 L23.3994,9.1629 C23.3994,9.1629 22.7584,11.7979 22.7284,11.9239 C23.3774,11.9119 23.6474,11.9119 23.7574,11.9259 C23.7834,11.8019 23.9354,11.0669 23.9374,11.0629 C23.9374,11.0629 24.0654,10.5229 24.0744,10.5089 C24.0744,10.5089 24.1104,10.4499 24.1544,10.4269 L24.2154,10.4269 C24.7754,10.4269 25.4114,10.4269 25.9104,10.0589 C26.2474,9.8139 26.4764,9.4389 26.5834,8.9909 C26.6084,8.8799 26.6294,8.7489 26.6294,8.6159 C26.6294,8.4449 26.5944,8.2749 26.4944,8.1349 C26.2434,7.7809 25.7364,7.7789 25.1504,7.7729 M25.5254,9.0659 C25.4634,9.3409 25.2884,9.5699 25.0564,9.6849 C24.8664,9.7799 24.6384,9.7869 24.3974,9.7869 L24.2404,9.7869 L24.2554,9.7249 C24.2554,9.7249 24.5394,8.4899 24.5394,8.4919 L24.5454,8.4289 L24.5514,8.3809 L24.6664,8.3889 C24.6664,8.3889 25.2534,8.4409 25.2664,8.4449 C25.4964,8.5349 25.5934,8.7639 25.5254,9.0659" id="Fill-37" fill="#FFFFFF"></path>\n            <path d="M17.0757,9.7915 C17.3027,9.6335 17.3337,9.4145 17.1407,9.2965 C16.9457,9.1865 16.6047,9.2195 16.3747,9.3795 C16.1427,9.5355 16.1177,9.7565 16.3117,9.8725 C16.5047,9.9865 16.8457,9.9485 17.0757,9.7915" id="Fill-39" fill="#FFFFFF"></path>\n            <path d="M31.6587,9.5098 L31.6217,9.4688 C31.1967,9.5568 31.1197,9.5698 30.7267,9.6218 L30.6967,9.6478 C30.6967,9.6548 30.6967,9.6628 30.6957,9.6688 L30.6927,9.6628 C30.3997,10.3378 30.4117,10.1908 30.1737,10.7218 C30.1707,10.6958 30.1707,10.6768 30.1707,10.6558 L30.1107,9.5098 L30.0747,9.4688 C29.6287,9.5568 29.6167,9.5698 29.2057,9.6218 L29.1727,9.6478 C29.1687,9.6668 29.1667,9.6788 29.1637,9.6958 L29.1687,9.7008 C29.2187,9.9658 29.2067,9.9058 29.2597,10.3208 C29.2817,10.5228 29.3147,10.7308 29.3377,10.9338 C29.3807,11.2698 29.4037,11.4368 29.4507,11.9478 C29.1727,12.4128 29.1077,12.5858 28.8417,12.9888 L28.6527,13.2908 C28.6307,13.3238 28.6117,13.3418 28.5827,13.3548 C28.5547,13.3668 28.5127,13.3738 28.4587,13.3738 L28.3167,13.3738 L28.1927,13.9118 L28.7297,13.9018 C29.0437,13.9018 29.2417,13.7458 29.3477,13.5498 L29.6807,12.9768 L31.6587,9.5098" id="Fill-41" fill="#FFFFFF"></path>\n        </g>\n    </g>\n</svg>';
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
        __webpack_require__.d(__webpack_exports__, "openBridge", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.openBridge;
        }), __webpack_require__.d(__webpack_exports__, "linkUrl", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.linkUrl;
        }), __webpack_require__.d(__webpack_exports__, "isBridge", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.isBridge;
        }), __webpack_require__.d(__webpack_exports__, "needsBridge", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridge;
        }), __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForBrowser;
        }), __webpack_require__.d(__webpack_exports__, "hasBridge", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.hasBridge;
        }), __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForWin;
        }), __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForDomain;
        }), __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.openTunnelToOpener;
        }), __webpack_require__.d(__webpack_exports__, "destroyBridges", function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.destroyBridges;
        });
    }, function(module, exports) {
        (function(__webpack_amd_options__) {
            module.exports = __webpack_amd_options__;
        }).call(this, {});
    }, function(module, exports) {
        module.exports = function() {
            throw new Error("define cannot be used indirect");
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject), __webpack_require__.d(interface_namespaceObject, "postRobot", function() {
            return postRobot;
        }), __webpack_require__.d(interface_namespaceObject, "Promise", function() {
            return zalgo_promise_src.a;
        }), __webpack_require__.d(interface_namespaceObject, "PopupOpenError", function() {
            return src.b;
        }), __webpack_require__.d(interface_namespaceObject, "rest", function() {
            return rest;
        }), __webpack_require__.d(interface_namespaceObject, "Button", function() {
            return component_Button;
        }), __webpack_require__.d(interface_namespaceObject, "Card", function() {
            return Card;
        }), __webpack_require__.d(interface_namespaceObject, "setup", function() {
            return setup;
        }), __webpack_require__.d(interface_namespaceObject, "config", function() {
            return config.a;
        }), __webpack_require__.d(interface_namespaceObject, "ENV", function() {
            return constants.t;
        }), __webpack_require__.d(interface_namespaceObject, "USERS", function() {
            return constants.F;
        }), __webpack_require__.d(interface_namespaceObject, "SOURCE", function() {
            return constants.E;
        }), __webpack_require__.d(interface_namespaceObject, "FUNDING", function() {
            return constants.v;
        }), __webpack_require__.d(interface_namespaceObject, "CARD", function() {
            return constants.o;
        }), __webpack_require__.d(interface_namespaceObject, "request", function() {
            return lib.R;
        }), __webpack_require__.d(interface_namespaceObject, "isEligible", function() {
            return lib.B;
        }), __webpack_require__.d(interface_namespaceObject, "isFundingRemembered", function() {
            return lib.C;
        }), __webpack_require__.d(interface_namespaceObject, "forceIframe", function() {
            return lib.a;
        }), __webpack_require__.d(interface_namespaceObject, "isWebView", function() {
            return lib.a;
        }), __webpack_require__.d(interface_namespaceObject, "allowIframe", function() {
            return lib.a;
        }), __webpack_require__.d(interface_namespaceObject, "logExperimentTreatment", function() {
            return logExperimentTreatment;
        }), __webpack_require__.d(interface_namespaceObject, "logFundingEligibility", function() {
            return logFundingEligibility;
        }), __webpack_require__.d(interface_namespaceObject, "onPossiblyUnhandledException", function() {
            return onPossiblyUnhandledException;
        }), __webpack_require__.d(interface_namespaceObject, "version", function() {
            return interface_version;
        }), __webpack_require__.d(interface_namespaceObject, "checkout", function() {
            return interface_checkout;
        }), __webpack_require__.d(interface_namespaceObject, "apps", function() {
            return apps;
        }), __webpack_require__.d(interface_namespaceObject, "Checkout", function() {
            return interface_Checkout;
        }), __webpack_require__.d(interface_namespaceObject, "BillingPage", function() {
            return interface_BillingPage;
        }), __webpack_require__.d(interface_namespaceObject, "PayPalCheckout", function() {
            return PayPalCheckout;
        }), __webpack_require__.d(interface_namespaceObject, "destroyAll", function() {
            return destroyAll;
        }), __webpack_require__.d(interface_namespaceObject, "enableCheckoutIframe", function() {
            return enableCheckoutIframe;
        }), __webpack_require__.d(interface_namespaceObject, "logger", function() {
            return logger;
        }), __webpack_require__.d(interface_namespaceObject, "ThreeDomainSecure", function() {
            return interface_ThreeDomainSecure;
        });
        var _LOGO_COLOR, beaver_logger_client = __webpack_require__(4), src = __webpack_require__(19), zalgo_promise_src = __webpack_require__(1), post_robot_src = __webpack_require__(13), lib = __webpack_require__(2), src_checkout = __webpack_require__(15), esm_extends = __webpack_require__(11), belter_src = __webpack_require__(16), constants = __webpack_require__(0), config = __webpack_require__(3), resources = __webpack_require__(18), containerContent = __webpack_require__(27), checkout_template = __webpack_require__(25), LOGO_COLOR = ((_LOGO_COLOR = {})[constants.q.BLACK] = constants.i.WHITE, 
        _LOGO_COLOR[constants.q.WHITE] = constants.i.BLACK, _LOGO_COLOR);
        function containerTemplate(_ref) {
            var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION, CONTEXT = _ref.CONTEXT, EVENT = _ref.EVENT, on = _ref.on, tag = _ref.tag, context = _ref.context, actions = _ref.actions, outlet = _ref.outlet, jsxDom = _ref.jsxDom, _props$locale$split = props.locale.split("_"), lang = _props$locale$split[0], country = _props$locale$split[1], containerStyle = "\n        " + Object(checkout_template.c)({
                id: id,
                tag: tag,
                CONTEXT: CONTEXT,
                CLASS: CLASS,
                ANIMATION: ANIMATION
            }) + "\n        @media screen and (max-width: 470px) {\n            #" + id + " .paypal-checkout-close {\n                position: absolute;\n                right: 20px;\n                width: 40px;\n                height: 40px;\n                opacity: 0.6;\n                top: 20px;\n                opacity: 0.6;\n                z-index: 2;\n            }\n\n            #" + id + " .paypal-checkout-close:before, .paypal-checkout-close:after {\n                position: absolute;\n                left: 20px;\n                content: ' ';\n                height: 40px;\n                width: 1px;\n                background-color: #111 !important;\n            }\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n                height: 100%;\n                min-height: 100%;\n                max-height: 100%;\n                min-width: 100%;\n                max-width: 100%;\n                border-radius: 0px;\n            }\n            #" + id + " ." + CLASS.OUTLET + " {\n                height: 100%;\n            }\n        }\n    ", content = containerContent.a[country][lang];
            function focus(event) {
                event.preventDefault(), event.stopPropagation(), Object(lib.F)() ? window.alert("Please switch tabs to reactivate the PayPal window") : actions.focus();
            }
            var overlayColor = (props.style || {}).overlayColor || constants.q.BLACK, logoColor = LOGO_COLOR[overlayColor], ppLogo = "function" == typeof resources.b.pp ? resources.b.pp({
                logoColor: logoColor
            }) : resources.b.pp[logoColor], paypalLogo = "function" == typeof resources.b.paypal ? resources.b.paypal({
                logoColor: logoColor
            }) : resources.b.paypal[logoColor], el = jsxDom("div", {
                id: id,
                onClick: focus,
                class: tag + "-context-" + context + " paypal-checkout-overlay " + tag + "-background-color-" + overlayColor + " " + tag + "-logo-color-" + logoColor,
                role: "dialog",
                "aria-modal": "true",
                "aria-label": "PayPal Checkout Overlay"
            }, jsxDom("a", {
                href: "#",
                class: "paypal-checkout-close",
                onClick: function(event) {
                    event.preventDefault(), event.stopPropagation(), props.onCancel && props.onCancel(), 
                    actions.close();
                },
                "aria-label": "close",
                role: "button"
            }), jsxDom("div", {
                class: "paypal-checkout-modal"
            }, jsxDom("div", {
                class: "paypal-checkout-logo"
            }, jsxDom("img", {
                class: "paypal-checkout-logo-pp",
                alt: "pp",
                src: "data:image/svg+xml;base64," + Object(belter_src.a)(ppLogo.toString())
            }), jsxDom("img", {
                class: "paypal-checkout-logo-paypal",
                alt: "paypal",
                src: "data:image/svg+xml;base64," + Object(belter_src.a)(paypalLogo.toString())
            })), jsxDom("div", {
                class: "paypal-checkout-message"
            }, content.windowMessage), jsxDom("div", {
                class: "paypal-checkout-continue"
            }, jsxDom("a", {
                onClick: focus,
                href: "#"
            }, content.continue)), jsxDom("div", {
                class: "paypal-checkout-loader"
            }, jsxDom("div", {
                class: "paypal-spinner"
            }))), jsxDom("div", {
                class: "paypal-checkout-iframe-container"
            }, outlet), jsxDom("style", null, containerStyle)), container = jsxDom("html", null, jsxDom("body", null, el));
            return on(EVENT.CLOSE, function() {
                el.className += " " + tag + "-loading";
            }), jsxDom("div", {
                id: id,
                class: "paypal-checkout-sandbox"
            }, jsxDom("style", null, Object(checkout_template.d)({
                id: id,
                ANIMATION: ANIMATION
            })), jsxDom("iframe", {
                title: "PayPal Checkout Overlay",
                name: "__paypal_checkout_sandbox_" + id + "__",
                scrolling: "no",
                class: "paypal-checkout-sandbox-iframe"
            }, container));
        }
        var listener, noContentFoundInContainer, callback, obj, BillingPage = Object(src.c)({
            tag: "billing-page",
            name: "billing-page",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env] + "/billing";
            },
            get domain() {
                var _extends2;
                return Object(esm_extends.a)({}, config.a.paypalDomains, ((_extends2 = {})[constants.t.LOCAL] = /^http:\/\/localhost.paypal.com:\d+$/, 
                _extends2));
            },
            scrolling: !0,
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.v)();
                    },
                    queryParam: !0
                },
                token: {
                    type: "string",
                    required: !0,
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.j)();
                    },
                    queryParam: !0
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                cardType: {
                    type: "string",
                    required: !1
                },
                prefilledZipCode: {
                    type: "string",
                    required: !1
                },
                onEvent: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                dispatch: {
                    type: "object",
                    required: !1,
                    sameDomain: !0
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                }
            },
            containerTemplate: containerTemplate
        }), ThreeDomainSecure = Object(src.c)({
            tag: "paypal-3ds",
            name: "3ds",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env] + "/init3ds";
            },
            get domain() {
                return Object(esm_extends.a)({}, config.a.paypalDomains);
            },
            scrolling: !0,
            props: {
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                challengeUrl: {
                    type: "string"
                },
                threeDomainSecureToken: {
                    type: "string"
                },
                method: {
                    type: "string"
                },
                onSuccess: {
                    type: "function",
                    required: !1
                },
                onError: {
                    type: "function",
                    required: !1
                },
                onCancel: {
                    type: "function",
                    required: !0,
                    allowDelegate: !0
                }
            },
            containerTemplate: containerTemplate
        }), cross_domain_utils_src = __webpack_require__(7), src_lib = __webpack_require__(5), pptm = (noContentFoundInContainer = !1, 
        callback = "__pptmLoadedWithNoContent", obj = {
            reloadPptmScript: function(clientId) {
                !function tryCreatePptmScript() {
                    obj.shouldReloadPptmScript(clientId) ? (obj.removePptm(), obj.createPptmScript(clientId)) : listener = tryCreatePptmScript;
                }();
            },
            listenForLoadWithNoContent: function() {
                window[callback] = function() {
                    noContentFoundInContainer = !0, listener && (listener(), listener = void 0);
                };
            },
            listenForButtonRender: function() {
                window.paypalDDL = window.paypalDDL || [], 0 === window.paypalDDL.filter(function(e) {
                    return "paypalButtonRender" === e.event;
                }).length && window.paypalDDL.push({
                    event: "paypalButtonRender"
                });
            },
            get callback() {
                return callback;
            },
            get noContentFoundInContainer() {
                return noContentFoundInContainer;
            },
            createPptmScript: function(clientId) {
                var _track;
                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.PPTM, 
                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.PPTM_LOAD, _track));
                var params = {
                    t: "xo",
                    id: window.location.hostname,
                    mrid: config.a.merchantID,
                    client_id: "",
                    v: config.a.version,
                    source: "checkoutjs"
                };
                clientId ? params.client_id = clientId : delete params.client_id;
                var fullUrl = Object(lib.g)(config.a.pptmUrl, params);
                Object(lib.H)(fullUrl, 0, {
                    async: !0,
                    id: constants.D
                }).then(function() {
                    var _track2;
                    window.paypalDDL && window.paypalDDL[0] && "snippetRun" === window.paypalDDL[0].event || window[callback](), 
                    Object(beaver_logger_client.p)(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.PPTM, 
                    _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.PPTM_LOADED, _track2));
                }).catch(function(err) {
                    Object(beaver_logger_client.k)("pptm_script_error", {
                        error: Object(lib.U)(err)
                    });
                });
            },
            shouldCreateInitialPptmScript: function() {
                if (!window.location.hostname) return !1;
                if (Object(lib.G)()) return !1;
                var existingScript = Object(lib.n)(constants.D);
                return !Boolean(existingScript) || (Object(beaver_logger_client.k)("pptm_tried_loading_twice"), 
                !1);
            },
            shouldReloadPptmScript: function(clientId) {
                return !1 !== noContentFoundInContainer && !Object(lib.G)() && !config.a.merchantID && !!clientId;
            },
            removePptm: function() {
                var script = Object(lib.n)(constants.D);
                script && script.parentNode.removeChild(script);
            }
        }), proxyRest = {}, createAccessToken = Object(lib.I)(function(env, client) {
            Object(beaver_logger_client.k)("rest_api_create_access_token");
            var clientID = client[env = env || config.a.env];
            if (!clientID) throw new Error("Client ID not found for env: " + env);
            if (proxyRest.createAccessToken && !proxyRest.createAccessToken.source.closed) return proxyRest.createAccessToken(env, client);
            var basicAuth = Object(belter_src.a)(clientID + ":");
            return Object(lib.R)({
                method: "post",
                url: config.a.authApiUrls[env],
                headers: {
                    Authorization: "Basic " + basicAuth
                },
                data: {
                    grant_type: "client_credentials"
                }
            }).then(function(res) {
                if (res && "invalid_client" === res.error) throw new Error("Auth Api invalid " + env + " client id: " + clientID + ":\n\n" + JSON.stringify(res, null, 4));
                if (!res || !res.access_token) throw new Error("Auth Api response error:\n\n" + JSON.stringify(res, null, 4));
                return res.access_token;
            });
        }, {
            time: 6e5
        }), createExperienceProfile = Object(lib.I)(function(env, client, experienceDetails) {
            if (void 0 === experienceDetails && (experienceDetails = {}), Object(beaver_logger_client.k)("rest_api_create_experience_profile"), 
            !client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            return proxyRest.createExperienceProfile && !proxyRest.createExperienceProfile.source.closed ? proxyRest.createExperienceProfile(env, client, experienceDetails) : (experienceDetails.temporary = !0, 
            experienceDetails.name = experienceDetails.name ? experienceDetails.name + "_" + Math.random().toString() : Math.random().toString(), 
            createAccessToken(env, client).then(function(accessToken) {
                return Object(lib.R)({
                    method: "post",
                    url: config.a.experienceApiUrls[env],
                    headers: {
                        Authorization: "Bearer " + accessToken
                    },
                    json: experienceDetails
                });
            }).then(function(res) {
                if (res && res.error) throw new Error(res.error);
                if (!res.id) throw new Error("No id in experience profile response:\n\n" + JSON.stringify(res, null, 4));
                return res.id;
            }));
        }, {
            time: 6e5
        });
        function logPaymentResponse(res) {
            var _track;
            if (res) {
                var paymentToken, paymentID;
                if (res.id && (paymentID = res.id), res.links && res.links.length) for (var i = 0; i < res.links.length; i++) if ("REDIRECT" === res.links[i].method && "approval_url" === res.links[i].rel) {
                    var match = res.links[i].href.match(/token=((EC-)?[A-Z0-9]{17})/);
                    match && (paymentToken = match[1]);
                }
                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CREATE_PAYMENT, _track[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[constants.B.PAY_ID], 
                _track[constants.u.KEY.PAY_ID] = paymentID, _track[constants.u.KEY.TOKEN] = paymentToken, 
                _track[constants.u.KEY.CONTEXT_ID] = paymentID, _track));
            }
        }
        function createPayment(env, client, paymentDetails) {
            if (Object(beaver_logger_client.k)("rest_api_create_checkout_token"), !client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            var payment = paymentDetails.payment, experience = paymentDetails.experience, meta = paymentDetails.meta, tracking = paymentDetails.tracking;
            if (!payment) throw new Error("Expected payment details to be passed");
            return proxyRest.createPayment && !proxyRest.createPayment.source.closed ? proxyRest.createPayment(env, client, {
                payment: payment,
                experience: experience,
                meta: meta,
                tracking: tracking
            }) : ((payment = Object(esm_extends.a)({}, payment)).intent = payment.intent || "sale", 
            payment.redirect_urls = payment.redirect_urls || {}, payment.redirect_urls.return_url = payment.redirect_urls.return_url || "https://www.paypal.com/checkoutnow/error", 
            payment.redirect_urls.cancel_url = payment.redirect_urls.cancel_url || "https://www.paypal.com/checkoutnow/error", 
            payment.payer = payment.payer || {}, payment.payer.payment_method = payment.payer.payment_method || "paypal", 
            createAccessToken(env, client).then(function(accessToken) {
                return zalgo_promise_src.a.try(function() {
                    if (experience) return zalgo_promise_src.a.resolve(createExperienceProfile(env, client, experience));
                }).then(function(experienceID) {
                    return zalgo_promise_src.a.try(function() {
                        if (tracking) return zalgo_promise_src.a.resolve(function(env, client, merchantID, trackingData) {
                            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
                            var trackingID = Object(lib.X)();
                            return createAccessToken(env, client).then(function(accessToken) {
                                var headers = {
                                    Authorization: "Bearer " + accessToken
                                };
                                return Object(lib.R)({
                                    method: "put",
                                    url: config.a.trackingApiUrls[env] + "/" + merchantID + "/" + trackingID,
                                    headers: headers,
                                    json: {
                                        tracking_id: trackingID,
                                        additional_data: trackingData
                                    }
                                });
                            }).then(function() {
                                return trackingID;
                            });
                        }(env, client, tracking.id, tracking.data));
                    }).then(function(trackingID) {
                        experienceID && (payment.experience_profile_id = experienceID);
                        var headers = {
                            Authorization: "Bearer " + accessToken
                        };
                        return trackingID && (headers["Paypal-Client-Metadata-Id"] = trackingID), meta && meta.partner_attribution_id && (headers["PayPal-Partner-Attribution-Id"] = meta.partner_attribution_id), 
                        Object(lib.R)({
                            method: "post",
                            url: config.a.paymentApiUrls[env],
                            headers: headers,
                            json: payment
                        });
                    });
                });
            }).then(function(res) {
                if (logPaymentResponse(res), res && res.id) return res.id;
                throw new Error("Payment Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        function createOrder(env, client, paymentDetails) {
            if (Object(beaver_logger_client.k)("rest_api_create_order_token"), !client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            var order = paymentDetails.order, meta = paymentDetails.meta;
            if (!order) throw new Error("Expected order details to be passed");
            return proxyRest.createOrder && !proxyRest.createOrder.source.closed ? proxyRest.createOrder(env, client, {
                order: order,
                meta: meta
            }) : ((order = Object(esm_extends.a)({}, order)).intent = order.intent || "CAPTURE", 
            order.application_context = order.application_context || {}, order.application_context.return_url = order.application_context.return_url || "https://www.paypal.com/checkoutnow/error", 
            order.application_context.cancel_url = order.application_context.cancel_url || "https://www.paypal.com/checkoutnow/error", 
            order.purchase_units = order.purchase_units || [], order.purchase_units[0] = order.purchase_units[0] || {}, 
            order.purchase_units.forEach(function(unit) {
                unit.reference_id = unit.reference_id || Math.random().toString();
            }), createAccessToken(env, client).then(function(accessToken) {
                var headers = {
                    Authorization: "Bearer " + accessToken
                };
                return meta && meta.partner_attribution_id && (headers["PayPal-Partner-Attribution-Id"] = meta.partner_attribution_id), 
                Object(lib.R)({
                    method: "post",
                    url: config.a.orderApiUrls[env],
                    headers: headers,
                    json: order
                });
            }).then(function(res) {
                if (logPaymentResponse(res), res && res.id) return res.id;
                throw new Error("Payment Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        function createBillingAgreement(env, client, billingDetails, experienceDetails) {
            if (Object(beaver_logger_client.k)("rest_api_create_billing_token"), !client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            return proxyRest.createBillingAgreement && !proxyRest.createBillingAgreement.source.closed ? proxyRest.createBillingAgreement(env, client, billingDetails, experienceDetails) : ((billingDetails = Object(esm_extends.a)({}, billingDetails)).plan = billingDetails.plan || {}, 
            billingDetails.plan.merchant_preferences = billingDetails.plan.merchant_preferences || {}, 
            billingDetails.plan.merchant_preferences.return_url = billingDetails.plan.merchant_preferences.return_url || "https://www.paypal.com/checkoutnow/error", 
            billingDetails.plan.merchant_preferences.cancel_url = billingDetails.plan.merchant_preferences.cancel_url || "https://www.paypal.com/checkoutnow/error", 
            billingDetails.payer = billingDetails.payer || {}, billingDetails.payer.payment_method = billingDetails.payer.payment_method || "paypal", 
            createAccessToken(env, client).then(function(accessToken) {
                return zalgo_promise_src.a.try(function() {
                    if (experienceDetails) return zalgo_promise_src.a.resolve(createExperienceProfile(env, client, experienceDetails));
                }).then(function(experienceID) {
                    return experienceID && (billingDetails.experience_profile_id = experienceID), Object(lib.R)({
                        method: "post",
                        url: config.a.billingApiUrls[env],
                        headers: {
                            Authorization: "Bearer " + accessToken
                        },
                        json: billingDetails
                    });
                });
            }).then(function(res) {
                if (res && res.token_id) return res.token_id;
                throw new Error("Billing Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        var rest = {
            payment: {
                create: createPayment
            },
            order: {
                create: createOrder
            },
            billingAgreement: {
                create: createBillingAgreement
            },
            experience: {
                create: createExperienceProfile
            }
        }, parentWin = Object(cross_domain_utils_src.e)();
        Object(post_robot_src.on)("proxy_rest", {
            domain: config.a.paypal_domain_regex
        }, function(_ref) {
            proxyRest = _ref.data;
        }), parentWin && Object(lib.G)() && !Object(cross_domain_utils_src.u)(parentWin) && Object(post_robot_src.send)(parentWin, "proxy_rest", {
            createAccessToken: createAccessToken,
            createExperienceProfile: createExperienceProfile,
            createPayment: createPayment,
            createBillingAgreement: createBillingAgreement,
            createOrder: createOrder
        }).catch(function() {});
        var onAuthorizeListener = Object(lib.e)();
        function log(experiment, treatment, token, state) {
            Object(lib.w)(function(session) {
                var event = experiment + "_" + treatment + "_" + state, loggedEvents = session.loggedExperimentEvents = session.loggedExperimentEvents || [];
                if (-1 !== loggedEvents.indexOf(event)) Object(beaver_logger_client.k)("duplicate_" + event); else {
                    var _track;
                    Object(beaver_logger_client.k)(event), loggedEvents.push(event);
                    var edge = window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/Edge\/[0-9]{2}/);
                    edge && (event = Object(beaver_logger_client.k)(edge[0].toLowerCase().replace("/", "_") + "_" + event)), 
                    Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                    _track[constants.u.KEY.TRANSITION] = state, _track[constants.u.KEY.EXPERIMENT_NAME] = experiment, 
                    _track[constants.u.KEY.TREATMENT_NAME] = treatment, _track[constants.u.KEY.TOKEN] = token, 
                    _track[constants.u.KEY.CONTEXT_ID] = token, _track[constants.u.KEY.CONTEXT_TYPE] = token ? constants.u.CONTEXT_TYPE[constants.B.EC_TOKEN] : constants.u.CONTEXT_TYPE.BUTTON_SESSION_ID, 
                    _track)), Object(beaver_logger_client.j)();
                }
            });
        }
        function logExperimentTreatment(_ref) {
            var experiment = _ref.experiment, treatment = _ref.treatment, state = _ref.state, token = _ref.token;
            experiment && treatment && (Object(lib.w)(function(session) {
                session.externalExperiment = experiment, session.externalExperimentTreatment = treatment, 
                token && (session.externalExperimentToken = token);
            }), log(experiment, treatment, token, state));
        }
        function logReturn(token) {
            var _getSessionState = Object(lib.w)(function(session) {
                return session;
            }), externalExperiment = _getSessionState.externalExperiment, externalExperimentTreatment = _getSessionState.externalExperimentTreatment, externalExperimentToken = _getSessionState.externalExperimentToken;
            externalExperiment && externalExperimentTreatment && externalExperimentToken === token ? log(externalExperiment, externalExperimentTreatment, token, "complete") : Object(beaver_logger_client.k)("experiment_mismatch", {
                token: token,
                externalExperiment: externalExperiment,
                externalExperimentTreatment: externalExperimentTreatment,
                externalExperimentToken: externalExperimentToken
            });
        }
        if (Object(lib.m)("log_authorize")) {
            onAuthorizeListener.once(function(_ref2) {
                var paymentToken = _ref2.paymentToken;
                setTimeout(function() {
                    logReturn(paymentToken);
                }, 1);
            });
            var returnToken = Object(lib.t)();
            returnToken && setTimeout(function() {
                returnToken && logReturn(returnToken);
            }, 1);
        }
        var _FUNDING_CONFIG, _CARD_CONFIG, integrations = __webpack_require__(23), integrations_checkout = __webpack_require__(26), OPTYPE = {
            PAYMENT: "payment",
            CANCEL: "cancel"
        }, CONTINGENCY = {
            PAYMENT_CANCELLED: "PAYMENT_CANCELLED"
        };
        function normalizeCheckoutProps(props) {
            return {
                env: props.env = props.env || config.a.env,
                payment: props.payment,
                onAuthorize: Object(src_lib.H)(props.onAuthorize),
                onCancel: Object(src_lib.H)(props.onCancel || src_lib.F)
            };
        }
        function awaitPopupBridge(Button) {
            return Button.xprops && Button.xprops.awaitPopupBridge ? Button.xprops.awaitPopupBridge() : Object(lib.b)(window, "popupBridge").then(function(popupBridge) {
                return function(popupBridge) {
                    return {
                        open: function(url) {
                            return new zalgo_promise_src.a(function(resolve, reject) {
                                popupBridge.onComplete = function(err, result) {
                                    return result ? err ? reject(err) : resolve(result) : reject(new Error("No payload passed in popupBridge.onComplete"));
                                }, popupBridge.onCancel = function() {
                                    var err = new Error(CONTINGENCY.PAYMENT_CANCELLED);
                                    return err.code = CONTINGENCY.PAYMENT_CANCELLED, reject(err);
                                }, popupBridge.open(Object(lib.g)(url, {
                                    redirect_uri: popupBridge.getReturnUrlPrefix()
                                }));
                            });
                        }
                    };
                }(popupBridge);
            });
        }
        var FUNDING_PRIORITY = [ constants.v.PAYPAL, constants.v.VENMO, constants.v.ITAU, constants.v.CREDIT, constants.v.CARD, constants.v.IDEAL, constants.v.ELV, constants.v.BANCONTACT, constants.v.GIROPAY, constants.v.EPS, constants.v.SOFORT, constants.v.MYBANK, constants.v.P24, constants.v.ZIMPLER ], FUNDING_ORDER = [ constants.v.PAYPAL, constants.v.VENMO, constants.v.ITAU, constants.v.CREDIT, constants.v.IDEAL, constants.v.ELV, constants.v.BANCONTACT, constants.v.GIROPAY, constants.v.EPS, constants.v.SOFORT, constants.v.MYBANK, constants.v.P24, constants.v.ZIMPLER, constants.v.CARD ], FUNDING_CONFIG = ((_FUNDING_CONFIG = {})[constants.s] = {
            enabled: !0,
            allowOptIn: !0,
            allowOptOut: !0,
            allowRemember: !0,
            allowHorizontal: !0,
            allowVertical: !0,
            requireCommitAsTrue: !1
        }, _FUNDING_CONFIG[constants.v.PAYPAL] = {
            default: !0,
            allowOptIn: !1,
            allowOptOut: !1,
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.CARD] = {
            default: "undefined" == typeof __paypal_checkout__ || __paypal_checkout__.serverConfig.paypalMerchantConfiguration.creditCard.isPayPalBranded,
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.VENMO] = {
            allowOptOut: !1,
            allowedCountries: [ constants.r.US ],
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.ITAU] = {
            allowOptOut: !0,
            allowedCountries: [ constants.r.BR ],
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.CREDIT] = {
            allowedCountries: [ constants.r.US, constants.r.GB, constants.r.DE ],
            defaultVerticalCountries: [ constants.r.US ],
            platforms: [ constants.C.MOBILE ],
            allowHorizontal: !0,
            allowVertical: !0,
            allowRemember: !0
        }, _FUNDING_CONFIG[constants.v.IDEAL] = {
            allowedCountries: [ constants.r.NL ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.ELV] = {
            allowedCountries: [ constants.r.DE, constants.r.AT ],
            defaultVerticalCountries: [ constants.r.DE, constants.r.AT ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.BANCONTACT] = {
            allowedCountries: [ constants.r.BE ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.GIROPAY] = {
            allowedCountries: [ constants.r.DE ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.SOFORT] = {
            allowedCountries: [ constants.r.DE, constants.r.AT, constants.r.BE, constants.r.ES, constants.r.IT, constants.r.NL ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.EPS] = {
            allowedCountries: [ constants.r.AT ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.MYBANK] = {
            allowedCountries: [ constants.r.IT ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.P24] = {
            allowedCountries: [ constants.r.PL ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[constants.v.ZIMPLER] = {
            allowedCountries: [ constants.r.FI ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG), CARD_CONFIG = ((_CARD_CONFIG = {})[constants.s] = {
            priority: [ constants.o.VISA, constants.o.MASTERCARD, constants.o.AMEX ]
        }, _CARD_CONFIG[constants.r.GB] = {
            priority: [ constants.o.VISA, constants.o.MASTERCARD, constants.o.AMEX, constants.o.DISCOVER, constants.o.MAESTRO ]
        }, _CARD_CONFIG[constants.r.US] = {
            priority: [ constants.o.VISA, constants.o.MASTERCARD, constants.o.AMEX, constants.o.DISCOVER ]
        }, _CARD_CONFIG[constants.r.BR] = {
            priority: [ constants.o.VISA, constants.o.MASTERCARD, constants.o.AMEX, constants.o.HIPER, constants.o.ELO ]
        }, _CARD_CONFIG[constants.r.JP] = {
            priority: [ constants.o.VISA, constants.o.MASTERCARD, constants.o.AMEX, constants.o.JCB ]
        }, _CARD_CONFIG[constants.r.CN] = {
            priority: [ constants.o.VISA, constants.o.MASTERCARD, constants.o.AMEX, constants.o.CUP ]
        }, _CARD_CONFIG);
        function getConfig(conf, category, key, def) {
            var categoryConfig = conf[category];
            if (categoryConfig && categoryConfig.hasOwnProperty(key)) return categoryConfig[key];
            if (conf[constants.s] && conf[constants.s].hasOwnProperty(key)) return conf[constants.s][key];
            if (arguments.length >= 4) return def;
            throw new Error("No value found for " + category + ":" + key);
        }
        function getFundingConfig(source, key, def) {
            return getConfig(FUNDING_CONFIG, source, key, def);
        }
        var _logoColors, _tagLineColors, _secondaryColors, _logoColors2, _secondaryColors2, _logoColors3, _secondaryColors3, _logoColors4, _secondaryColors4, _logoColors5, _secondaryColors5, _logoColors6, _secondaryColors6, _logoColors7, _secondaryColors7, _logoColors8, _secondaryColors8, _logoColors9, _secondaryColors9, _logoColors10, _secondaryColors10, _logoColors11, _secondaryColors11, _logoColors12, _secondaryColors12, _logoColors13, _secondaryColors13, _logoColors14, _secondaryColors14, _BUTTON_CONFIG, _FUNDING_TO_DEFAULT_L, _LABEL_TO_FUNDING, _BUTTON_STYLE, fundingEligibilityReasons = [];
        function isFundingIneligible(source, _ref) {
            var locale = _ref.locale, funding = _ref.funding, commit = _ref.commit;
            return getFundingConfig(source, _ref.layout === constants.g.VERTICAL ? "allowVertical" : "allowHorizontal") ? -1 !== funding.disallowed.indexOf(source) && getFundingConfig(source, "allowOptOut") ? constants.w.OPT_OUT : -1 !== funding.disallowed.indexOf(source) && source === constants.v.VENMO ? constants.w.OPT_OUT : -1 !== funding.disallowed.indexOf(source) && source === constants.v.ITAU ? constants.w.OPT_OUT : -1 === getFundingConfig(source, "allowedCountries", [ locale.country ]).indexOf(locale.country) ? constants.w.DISALLOWED_COUNTRY : getFundingConfig(source, "requireCommitAsTrue") && !commit ? constants.w.COMMIT_NOT_SET : void 0 : constants.w.SECONDARY_DISALLOWED;
        }
        function isFundingAutoEligible(source, _ref2) {
            var locale = _ref2.locale, funding = _ref2.funding;
            return _ref2.layout === constants.g.VERTICAL && -1 !== getFundingConfig(source, "defaultVerticalCountries", []).indexOf(locale.country) ? constants.w.DEFAULT_COUNTRY : getFundingConfig(source, "default") ? constants.w.DEFAULT : -1 !== funding.allowed.indexOf(source) && getFundingConfig(source, "allowOptIn") ? constants.w.OPT_IN : -1 !== funding.remembered.indexOf(source) && getFundingConfig(source, "allowRemember") ? constants.w.REMEMBERED : void 0;
        }
        function determineEligibleCards(_ref5) {
            var source, funding = _ref5.funding;
            return (source = _ref5.locale.country, getConfig(CARD_CONFIG, source, "priority", void 0)).filter(function(card) {
                return -1 === funding.disallowed.indexOf(card);
            });
        }
        function logFundingEligibility() {
            fundingEligibilityReasons.forEach(function(reasons, i) {
                console.log("\nButton " + (i + 1) + ":\n"), console.table(Object.keys(reasons).map(function(source) {
                    var _reasons$source = reasons[source];
                    return {
                        Funding: source,
                        Reason: _reasons$source.reason,
                        Eligibility: _reasons$source.eligible ? "eligible" : "ineligible",
                        Factors: JSON.stringify(_reasons$source.factors)
                    };
                }));
            });
        }
        var BUTTON_CONFIG = ((_BUTTON_CONFIG = {})[constants.s] = {
            colors: [ constants.e.GOLD, constants.e.BLUE, constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            sizes: [ constants.l.SMALL, constants.l.MEDIUM, constants.l.LARGE, constants.l.RESPONSIVE ],
            shapes: [ constants.k.PILL, constants.k.RECT ],
            layouts: [ constants.g.HORIZONTAL, constants.g.VERTICAL ],
            logoColors: (_logoColors = {}, _logoColors[constants.e.GOLD] = constants.i.BLUE, 
            _logoColors[constants.e.SILVER] = constants.i.BLUE, _logoColors[constants.e.BLUE] = constants.i.WHITE, 
            _logoColors[constants.e.BLACK] = constants.i.WHITE, _logoColors[constants.e.BLACK] = constants.i.WHITE, 
            _logoColors[constants.e.WHITE] = constants.i.BLUE, _logoColors),
            tagLineColors: (_tagLineColors = {}, _tagLineColors[constants.e.GOLD] = constants.n.BLUE, 
            _tagLineColors[constants.e.SILVER] = constants.n.BLUE, _tagLineColors[constants.e.BLUE] = constants.n.BLUE, 
            _tagLineColors[constants.e.BLACK] = constants.n.BLACK, _tagLineColors[constants.e.DARKBLUE] = constants.n.BLUE, 
            _tagLineColors),
            secondaryColors: (_secondaryColors = {}, _secondaryColors[constants.e.GOLD] = constants.e.BLUE, 
            _secondaryColors[constants.e.SILVER] = constants.e.BLUE, _secondaryColors[constants.e.BLUE] = constants.e.SILVER, 
            _secondaryColors[constants.e.BLACK] = constants.e.BLACK, _secondaryColors[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors[constants.e.WHITE] = constants.e.WHITE, _secondaryColors),
            tag: "{ content: safer_tag }",
            dualTag: "{ content: dual_tag|safer_tag }",
            defaultLocale: "en_US",
            defaultLabel: constants.f.CHECKOUT,
            defaultVerticalLabel: constants.f.PAYPAL,
            defaultColor: constants.e.GOLD,
            defaultSize: constants.l.SMALL,
            defaultVerticalSize: constants.l.MEDIUM,
            defaultShape: constants.k.PILL,
            defaultLayout: constants.g.HORIZONTAL,
            defaultBranding: !0,
            defaultVerticalBranding: !0,
            defaultFundingIcons: !1,
            defaultTagline: !0,
            defaultDual: "",
            minimumSize: constants.l.TINY,
            minimumVerticalSize: constants.l.MEDIUM,
            maximumSize: constants.l.HUGE,
            maximumVerticalSize: constants.l.HUGE,
            minHorizontalButtons: 1,
            minVerticalButtons: 1,
            maxHorizontalButtons: 2,
            maxVerticalButtons: 6,
            allowUnbranded: !1,
            allowFundingIcons: !0,
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.PAYPAL] = {
            label: "{ logo: " + constants.h.PP + " } { logo: " + constants.h.PAYPAL + " }",
            logoLabel: "{ logo: " + constants.h.PP + " } { logo: " + constants.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[constants.f.CHECKOUT] = {
            label: "{ content: checkout }",
            logoLabel: "{ logo: " + constants.h.PP + " } { logo: " + constants.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[constants.f.PAY] = {
            label: "{ content: pay }",
            logoLabel: "{ logo: " + constants.h.PP + " } { logo: " + constants.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[constants.f.BUYNOW] = {
            label: "{ content: buynow }",
            logoLabel: "{ logo: " + constants.h.PP + " } { logo: " + constants.h.PAYPAL + " }",
            defaultBranding: void 0,
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0,
            allowUnbranded: !0
        }, _BUTTON_CONFIG[constants.f.INSTALLMENT] = {
            label: function(style) {
                return "{ content: " + (style.installmentperiod ? "installment_period" : "installment") + " }";
            },
            logoLabel: "{ logo: " + constants.h.PP + " } { logo: " + constants.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0,
            allowSecondaryVertical: !1,
            allowSecondaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.CREDIT] = {
            label: function(_ref) {
                return _ref.locale.country === constants.r.DE ? "{ logo: " + constants.h.CREDIT + " }" : "{ logo: " + constants.h.PP + " } { logo: " + constants.h.PAYPAL + " } { logo: " + constants.h.CREDIT + " }";
            },
            logoLabel: function(_ref2) {
                return _ref2.locale.country === constants.r.DE ? "{ logo: " + constants.h.CREDIT + " }" : "{ logo: " + constants.h.PP + " } { logo: " + constants.h.PAYPAL + " } { logo: " + constants.h.CREDIT + " }";
            },
            tag: "{ content: later_tag }",
            colors: [ constants.e.DARKBLUE, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors2 = {}, _logoColors2[constants.e.BLACK] = constants.i.WHITE, 
            _logoColors2[constants.e.DARKBLUE] = constants.i.WHITE, _logoColors2[constants.e.WHITE] = constants.i.BLUE, 
            _logoColors2),
            secondaryColors: (_secondaryColors2 = {}, _secondaryColors2[constants.e.GOLD] = constants.e.DARKBLUE, 
            _secondaryColors2[constants.e.BLUE] = constants.e.DARKBLUE, _secondaryColors2[constants.e.SILVER] = constants.e.DARKBLUE, 
            _secondaryColors2[constants.e.BLACK] = constants.e.BLACK, _secondaryColors2[constants.e.WHITE] = constants.e.WHITE, 
            _secondaryColors2),
            defaultColor: constants.e.DARKBLUE,
            allowPrimary: !0,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1,
            allowFundingIcons: !1
        }, _BUTTON_CONFIG[constants.f.VENMO] = {
            label: "{ logo: " + constants.h.VENMO + " }",
            logoLabel: "{ logo: " + constants.h.VENMO + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.BLUE, constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors3 = {}, _logoColors3[constants.e.BLUE] = constants.i.WHITE, 
            _logoColors3[constants.e.SILVER] = constants.i.BLUE, _logoColors3[constants.e.BLACK] = constants.i.WHITE, 
            _logoColors3[constants.e.WHITE] = constants.i.BLUE, _logoColors3),
            secondaryColors: (_secondaryColors3 = {}, _secondaryColors3[constants.e.GOLD] = constants.e.BLUE, 
            _secondaryColors3[constants.e.BLUE] = constants.e.SILVER, _secondaryColors3[constants.e.SILVER] = constants.e.BLUE, 
            _secondaryColors3[constants.e.BLACK] = constants.e.BLACK, _secondaryColors3[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors3[constants.e.WHITE] = constants.e.WHITE, _secondaryColors3),
            allowPrimary: !0,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[constants.f.ITAU] = {
            label: "{ logo: " + constants.h.ITAU + " }",
            logoLabel: "{ logo: " + constants.h.ITAU + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.BLUE, constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors4 = {}, _logoColors4[constants.e.BLUE] = constants.i.BLUE, 
            _logoColors4[constants.e.SILVER] = constants.i.BLUE, _logoColors4[constants.e.BLACK] = constants.i.BLUE, 
            _logoColors4[constants.e.WHITE] = constants.i.BLUE, _logoColors4),
            secondaryColors: (_secondaryColors4 = {}, _secondaryColors4[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors4[constants.e.BLUE] = constants.e.SILVER, _secondaryColors4[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors4[constants.e.BLACK] = constants.e.BLACK, _secondaryColors4[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors4[constants.e.WHITE] = constants.e.WHITE, _secondaryColors4),
            allowPrimary: !0,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[constants.f.IDEAL] = {
            label: "{ logo: " + constants.h.IDEAL + " } Online betalen",
            logoLabel: "{ logo: " + constants.h.IDEAL + " } Online betalen",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors5 = {}, _logoColors5[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors5[constants.e.BLACK] = constants.i.WHITE, _logoColors5[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors5),
            secondaryColors: (_secondaryColors5 = {}, _secondaryColors5[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors5[constants.e.BLUE] = constants.e.SILVER, _secondaryColors5[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors5[constants.e.BLACK] = constants.e.BLACK, _secondaryColors5[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors5[constants.e.WHITE] = constants.e.WHITE, _secondaryColors5),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.ELV] = {
            label: "{ logo: " + constants.h.ELV + " }",
            logoLabel: "{ logo: " + constants.h.ELV + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors6 = {}, _logoColors6[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors6[constants.e.BLACK] = constants.i.WHITE, _logoColors6[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors6),
            secondaryColors: (_secondaryColors6 = {}, _secondaryColors6[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors6[constants.e.BLUE] = constants.e.SILVER, _secondaryColors6[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors6[constants.e.BLACK] = constants.e.BLACK, _secondaryColors6[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors6[constants.e.WHITE] = constants.e.WHITE, _secondaryColors6),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.BANCONTACT] = {
            label: "{ logo: " + constants.h.BANCONTACT + " }",
            logoLabel: "{ logo: " + constants.h.BANCONTACT + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors7 = {}, _logoColors7[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors7[constants.e.BLACK] = constants.i.WHITE, _logoColors7[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors7),
            secondaryColors: (_secondaryColors7 = {}, _secondaryColors7[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors7[constants.e.BLUE] = constants.e.SILVER, _secondaryColors7[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors7[constants.e.BLACK] = constants.e.BLACK, _secondaryColors7[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors7[constants.e.WHITE] = constants.e.WHITE, _secondaryColors7),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.GIROPAY] = {
            label: "{ logo: " + constants.h.GIROPAY + " }",
            logoLabel: "{ logo: " + constants.h.GIROPAY + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors8 = {}, _logoColors8[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors8[constants.e.BLACK] = constants.i.WHITE, _logoColors8[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors8),
            secondaryColors: (_secondaryColors8 = {}, _secondaryColors8[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors8[constants.e.BLUE] = constants.e.SILVER, _secondaryColors8[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors8[constants.e.BLACK] = constants.e.BLACK, _secondaryColors8[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors8[constants.e.WHITE] = constants.e.WHITE, _secondaryColors8),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.SOFORT] = {
            label: "{ logo: " + constants.h.SOFORT + " }",
            logoLabel: "{ logo: " + constants.h.SOFORT + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors9 = {}, _logoColors9[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors9[constants.e.BLACK] = constants.i.WHITE, _logoColors9[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors9),
            secondaryColors: (_secondaryColors9 = {}, _secondaryColors9[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors9[constants.e.BLUE] = constants.e.SILVER, _secondaryColors9[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors9[constants.e.BLACK] = constants.e.BLACK, _secondaryColors9[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors9[constants.e.WHITE] = constants.e.WHITE, _secondaryColors9),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.EPS] = {
            label: "{ logo: " + constants.h.EPS + " }",
            logoLabel: "{ logo: " + constants.h.EPS + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors10 = {}, _logoColors10[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors10[constants.e.BLACK] = constants.i.WHITE, _logoColors10[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors10),
            secondaryColors: (_secondaryColors10 = {}, _secondaryColors10[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors10[constants.e.BLUE] = constants.e.SILVER, _secondaryColors10[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors10[constants.e.BLACK] = constants.e.BLACK, _secondaryColors10[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors10[constants.e.WHITE] = constants.e.WHITE, _secondaryColors10),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.MYBANK] = {
            label: "{ logo: " + constants.h.MYBANK + " }",
            logoLabel: "{ logo: " + constants.h.MYBANK + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors11 = {}, _logoColors11[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors11[constants.e.BLACK] = constants.i.WHITE, _logoColors11[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors11),
            secondaryColors: (_secondaryColors11 = {}, _secondaryColors11[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors11[constants.e.BLUE] = constants.e.SILVER, _secondaryColors11[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors11[constants.e.BLACK] = constants.e.BLACK, _secondaryColors11[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors11[constants.e.WHITE] = constants.e.WHITE, _secondaryColors11),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.P24] = {
            label: "{ logo: " + constants.h.P24 + " }",
            logoLabel: "{ logo: " + constants.h.P24 + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors12 = {}, _logoColors12[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors12[constants.e.BLACK] = constants.i.WHITE, _logoColors12[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors12),
            secondaryColors: (_secondaryColors12 = {}, _secondaryColors12[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors12[constants.e.BLUE] = constants.e.SILVER, _secondaryColors12[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors12[constants.e.BLACK] = constants.e.BLACK, _secondaryColors12[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors12[constants.e.WHITE] = constants.e.WHITE, _secondaryColors12),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.ZIMPLER] = {
            label: "{ logo: " + constants.h.ZIMPLER + " }",
            logoLabel: "{ logo: " + constants.h.ZIMPLER + " }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.SILVER, constants.e.BLACK, constants.e.WHITE ],
            logoColors: (_logoColors13 = {}, _logoColors13[constants.e.SILVER] = constants.i.BLACK, 
            _logoColors13[constants.e.BLACK] = constants.i.WHITE, _logoColors13[constants.e.WHITE] = constants.i.BLACK, 
            _logoColors13),
            secondaryColors: (_secondaryColors13 = {}, _secondaryColors13[constants.e.GOLD] = constants.e.SILVER, 
            _secondaryColors13[constants.e.BLUE] = constants.e.SILVER, _secondaryColors13[constants.e.SILVER] = constants.e.SILVER, 
            _secondaryColors13[constants.e.BLACK] = constants.e.BLACK, _secondaryColors13[constants.e.DARKBLUE] = constants.e.SILVER, 
            _secondaryColors13[constants.e.WHITE] = constants.e.WHITE, _secondaryColors13),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[constants.f.CARD] = {
            label: "{ cards }",
            logoLabel: "{ cards }",
            defaultColor: constants.e.SILVER,
            colors: [ constants.e.TRANSPARENT ],
            logoColors: (_logoColors14 = {}, _logoColors14[constants.e.TRANSPARENT] = constants.i.BLACK, 
            _logoColors14),
            secondaryColors: (_secondaryColors14 = {}, _secondaryColors14[constants.e.GOLD] = constants.e.TRANSPARENT, 
            _secondaryColors14[constants.e.BLUE] = constants.e.TRANSPARENT, _secondaryColors14[constants.e.SILVER] = constants.e.TRANSPARENT, 
            _secondaryColors14[constants.e.BLACK] = constants.e.TRANSPARENT, _secondaryColors14[constants.e.DARKBLUE] = constants.e.TRANSPARENT, 
            _secondaryColors14[constants.e.WHITE] = constants.e.TRANSPARENT, _secondaryColors14),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG), FUNDING_TO_DEFAULT_LABEL = ((_FUNDING_TO_DEFAULT_L = {})[constants.v.PAYPAL] = constants.f.PAYPAL, 
        _FUNDING_TO_DEFAULT_L[constants.v.VENMO] = constants.f.VENMO, _FUNDING_TO_DEFAULT_L[constants.v.ITAU] = constants.f.ITAU, 
        _FUNDING_TO_DEFAULT_L[constants.v.CARD] = constants.f.CARD, _FUNDING_TO_DEFAULT_L[constants.v.CREDIT] = constants.f.CREDIT, 
        _FUNDING_TO_DEFAULT_L[constants.v.IDEAL] = constants.f.IDEAL, _FUNDING_TO_DEFAULT_L[constants.v.ELV] = constants.f.ELV, 
        _FUNDING_TO_DEFAULT_L[constants.v.BANCONTACT] = constants.f.BANCONTACT, _FUNDING_TO_DEFAULT_L[constants.v.GIROPAY] = constants.f.GIROPAY, 
        _FUNDING_TO_DEFAULT_L[constants.v.SOFORT] = constants.f.SOFORT, _FUNDING_TO_DEFAULT_L[constants.v.EPS] = constants.f.EPS, 
        _FUNDING_TO_DEFAULT_L[constants.v.P24] = constants.f.P24, _FUNDING_TO_DEFAULT_L[constants.v.ZIMPLER] = constants.f.ZIMPLER, 
        _FUNDING_TO_DEFAULT_L[constants.v.MYBANK] = constants.f.MYBANK, _FUNDING_TO_DEFAULT_L), LABEL_TO_FUNDING = ((_LABEL_TO_FUNDING = {})[constants.f.PAYPAL] = constants.v.PAYPAL, 
        _LABEL_TO_FUNDING[constants.f.CHECKOUT] = constants.v.PAYPAL, _LABEL_TO_FUNDING[constants.f.PAY] = constants.v.PAYPAL, 
        _LABEL_TO_FUNDING[constants.f.BUYNOW] = constants.v.PAYPAL, _LABEL_TO_FUNDING[constants.f.INSTALLMENT] = constants.v.PAYPAL, 
        _LABEL_TO_FUNDING[constants.f.CARD] = constants.v.CARD, _LABEL_TO_FUNDING[constants.f.CREDIT] = constants.v.CREDIT, 
        _LABEL_TO_FUNDING[constants.f.VENMO] = constants.v.VENMO, _LABEL_TO_FUNDING[constants.f.ITAU] = constants.v.ITAU, 
        _LABEL_TO_FUNDING[constants.f.IDEAL] = constants.v.IDEAL, _LABEL_TO_FUNDING[constants.f.BANCONTACT] = constants.v.BANCONTACT, 
        _LABEL_TO_FUNDING[constants.f.GIROPAY] = constants.v.GIROPAY, _LABEL_TO_FUNDING[constants.f.GIROPAY] = constants.v.EPS, 
        _LABEL_TO_FUNDING[constants.f.SOFORT] = constants.v.SOFORT, _LABEL_TO_FUNDING[constants.f.P24] = constants.v.P24, 
        _LABEL_TO_FUNDING[constants.f.ZIMPLER] = constants.v.ZIMPLER, _LABEL_TO_FUNDING[constants.f.MYBANK] = constants.v.MYBANK, 
        _LABEL_TO_FUNDING), BUTTON_RELATIVE_STYLE = {
            FUNDINGICONS: 100,
            TAGLINE: 50,
            VERTICAL_MARGIN: 30
        }, BUTTON_STYLE = ((_BUTTON_STYLE = {})[constants.l.TINY] = {
            defaultWidth: 75,
            defaultHeight: 25,
            minWidth: 75,
            maxWidth: 150,
            minHeight: 25,
            maxHeight: 30,
            allowFunding: !0,
            allowTagline: !1,
            byPayPalHeight: 0
        }, _BUTTON_STYLE[constants.l.SMALL] = {
            defaultWidth: 150,
            defaultHeight: 25,
            minWidth: 150,
            maxWidth: 200,
            minHeight: 25,
            maxHeight: 55,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 0
        }, _BUTTON_STYLE[constants.l.MEDIUM] = {
            defaultWidth: 250,
            defaultHeight: 35,
            minWidth: 200,
            maxWidth: 300,
            minHeight: 35,
            maxHeight: 55,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE[constants.l.LARGE] = {
            defaultWidth: 350,
            defaultHeight: 45,
            minWidth: 300,
            maxWidth: 500,
            minHeight: 30,
            maxHeight: 55,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE[constants.l.HUGE] = {
            defaultWidth: 500,
            defaultHeight: 55,
            minWidth: 500,
            maxWidth: 750,
            minHeight: 40,
            maxHeight: 55,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE);
        function labelToFunding(label) {
            return label ? LABEL_TO_FUNDING[label] : constants.v.PAYPAL;
        }
        function getButtonConfig(label, key, def) {
            return function(conf, category, key, def) {
                var categoryConfig = conf[category];
                if (categoryConfig && categoryConfig.hasOwnProperty(key)) return categoryConfig[key];
                if (conf[constants.s] && conf[constants.s].hasOwnProperty(key)) return conf[constants.s][key];
                if (arguments.length >= 4) return def;
                throw new Error("No value found for " + category + ":" + key);
            }(BUTTON_CONFIG, label, key, def);
        }
        var util = __webpack_require__(12), normalizeProps = Object(util.i)(function(props, defs) {
            void 0 === defs && (defs = {});
            var env = props.env, locale = props.locale, _props$style = props.style, style = void 0 === _props$style ? {} : _props$style, funding = props.funding, commit = props.commit;
            locale = locale ? function(locale) {
                var _locale$split = locale.split("_");
                return {
                    country: _locale$split[1],
                    lang: _locale$split[0]
                };
            }(locale) : defs.locale || getButtonConfig("DEFAULT", "defaultLocale"), (funding = funding || {}).allowed = funding.allowed || [], 
            funding.disallowed = funding.disallowed || [], funding.remembered = funding.remembered || [];
            var label = style[constants.m.LABEL] || getButtonConfig("DEFAULT", style.layout === constants.g.VERTICAL ? "defaultVerticalLabel" : "defaultLabel"), layout = style[constants.m.LAYOUT] || getButtonConfig(label, "defaultLayout"), _style$BUTTON_STYLE_O = style[constants.m.SIZE], size = void 0 === _style$BUTTON_STYLE_O ? getButtonConfig(label, layout === constants.g.VERTICAL ? "defaultVerticalSize" : "defaultSize") : _style$BUTTON_STYLE_O, _style$BUTTON_STYLE_O2 = style[constants.m.COLOR], color = void 0 === _style$BUTTON_STYLE_O2 ? getButtonConfig(label, "defaultColor") : _style$BUTTON_STYLE_O2, _style$BUTTON_STYLE_O3 = style[constants.m.SHAPE], shape = void 0 === _style$BUTTON_STYLE_O3 ? getButtonConfig(label, "defaultShape") : _style$BUTTON_STYLE_O3, _style$BUTTON_STYLE_O4 = style[constants.m.BRANDING], branding = void 0 === _style$BUTTON_STYLE_O4 ? getButtonConfig(label, layout === constants.g.VERTICAL ? "defaultVerticalBranding" : "defaultBranding") : _style$BUTTON_STYLE_O4, _style$BUTTON_STYLE_O5 = style[constants.m.FUNDINGICONS], fundingicons = void 0 === _style$BUTTON_STYLE_O5 ? getButtonConfig(label, "defaultFundingIcons") : _style$BUTTON_STYLE_O5, _style$BUTTON_STYLE_O6 = style[constants.m.TAGLINE], tagline = void 0 === _style$BUTTON_STYLE_O6 ? getButtonConfig(label, "defaultTagline") : _style$BUTTON_STYLE_O6, max = style[constants.m.MAXBUTTONS], height = style[constants.m.HEIGHT], installmentperiod = style[constants.m.INSTALLMENTPERIOD];
            max = function(_ref) {
                var label = _ref.label, layout = _ref.layout, max = _ref.max;
                if (!getButtonConfig(label, layout === constants.g.HORIZONTAL ? "allowPrimaryHorizontal" : "allowPrimaryVertical")) return 1;
                var configMax = getButtonConfig(label, layout === constants.g.HORIZONTAL ? "maxHorizontalButtons" : "maxVerticalButtons");
                return max ? Math.min(configMax, max) : configMax;
            }({
                label: label,
                layout: layout,
                max: max
            });
            var _ref2, sources = function(_ref4) {
                var funding = _ref4.funding, selected = _ref4.selected, locale = _ref4.locale, env = _ref4.env, layout = _ref4.layout, commit = _ref4.commit, reasons = {}, eligibleFunding = FUNDING_PRIORITY.filter(function(source) {
                    var _isFundingEligible = function(source, _ref3) {
                        var locale = _ref3.locale, funding = _ref3.funding, env = _ref3.env, layout = _ref3.layout, selected = _ref3.selected, commit = _ref3.commit;
                        if (selected && source === selected) return {
                            eligible: !0,
                            reason: constants.w.PRIMARY
                        };
                        if (!(getFundingConfig(source, "enabled") || env === constants.t.TEST && getFundingConfig(source, "test"))) return {
                            eligible: !1,
                            reason: constants.w.NOT_ENABLED
                        };
                        var ineligibleReason = isFundingIneligible(source, {
                            locale: locale,
                            funding: funding,
                            layout: layout,
                            commit: commit
                        });
                        if (ineligibleReason) return {
                            eligible: !1,
                            reason: ineligibleReason
                        };
                        var autoEligibleReason = isFundingAutoEligible(source, {
                            locale: locale,
                            funding: funding,
                            layout: layout
                        });
                        return autoEligibleReason ? {
                            eligible: !0,
                            reason: autoEligibleReason
                        } : {
                            eligible: !1,
                            reason: constants.w.NEED_OPT_IN
                        };
                    }(source, {
                        selected: selected,
                        locale: locale,
                        funding: funding,
                        env: env,
                        layout: layout,
                        commit: commit
                    }), eligible = _isFundingEligible.eligible;
                    return reasons[source] = {
                        eligible: eligible,
                        reason: _isFundingEligible.reason,
                        factors: {
                            env: env,
                            locale: locale,
                            layout: layout
                        }
                    }, eligible;
                });
                return fundingEligibilityReasons.push(reasons), eligibleFunding.splice(eligibleFunding.indexOf(selected), 1), 
                eligibleFunding.unshift(selected), eligibleFunding;
            }({
                funding: funding,
                selected: labelToFunding(label),
                locale: locale,
                env: env,
                layout: layout,
                commit: commit
            }), multiple = (sources = Object(util.p)(sources.slice(0, max), FUNDING_ORDER)).length > 1;
            return multiple && (branding = !0), _ref2 = {
                tagline: tagline,
                branding: branding,
                fundingicons: fundingicons,
                layout: layout
            }, {
                size: size,
                label: label,
                locale: locale,
                color: color,
                shape: shape,
                branding: branding,
                fundingicons: fundingicons,
                tagline: tagline = Boolean(_ref2.tagline && _ref2.branding && !_ref2.fundingicons && _ref2.layout === constants.g.HORIZONTAL),
                funding: funding,
                layout: layout,
                sources: sources,
                max: max,
                multiple: multiple,
                env: env,
                height: height,
                cards: determineEligibleCards({
                    funding: funding,
                    locale: locale
                }),
                installmentperiod: installmentperiod
            };
        }), jsx = __webpack_require__(6);
        function validateButtonLocale(locale) {
            if (!locale) throw new Error("Expected props.locale to be set");
            if (!locale.match(/^[a-z]{2}[_][A-Z][A-Z0-9]$/)) throw new Error("Expected props.locale to be valid, got " + locale);
            var _locale$split = locale.split("_"), country = _locale$split[1];
            if (!constants.z[country] || -1 === constants.z[country].indexOf(_locale$split[0])) throw new Error("Expected props.locale to be valid");
        }
        function validateButtonStyle(style, props) {
            if (void 0 === style && (style = {}), !style) throw new Error("Expected props.style to be set");
            var label = style[constants.m.LABEL] || getButtonConfig("DEFAULT", style[constants.m.LAYOUT] === constants.g.VERTICAL ? "defaultVerticalLabel" : "defaultLabel");
            if (!BUTTON_CONFIG[label]) throw new Error("Invalid button label: " + label + ", expected: " + Object.keys(BUTTON_CONFIG[label]).join(", "));
            var color = style[constants.m.COLOR], shape = style[constants.m.SHAPE], size = style[constants.m.SIZE], branding = style[constants.m.BRANDING], fundingicons = style[constants.m.FUNDINGICONS], tagline = style[constants.m.TAGLINE], layout = style[constants.m.LAYOUT], maxbuttons = style[constants.m.MAXBUTTONS], height = style[constants.m.HEIGHT];
            if (color && -1 === getButtonConfig(label, "colors").indexOf(color)) throw new Error("Unexpected style." + constants.m.COLOR + " for " + label + " button: " + color + ", expected " + getButtonConfig(label, "colors").join(", "));
            if (shape && -1 === getButtonConfig(label, "shapes").indexOf(shape)) throw new Error("Unexpected style." + constants.m.SHAPE + " for " + label + " button: " + shape + ", expected " + getButtonConfig(label, "shapes").join(", "));
            if (size && -1 === getButtonConfig(label, "sizes").indexOf(size)) throw new Error("Unexpected style." + constants.m.SIZE + " for " + label + " button: " + size + ", expected " + getButtonConfig(label, "sizes").join(", "));
            if (!1 === branding) throw new Error("style." + constants.m.BRANDING + ":false is not allowed");
            if (fundingicons && !getButtonConfig(label, "allowFundingIcons")) throw new Error("style." + constants.m.FUNDINGICONS + ":true is not allowed for " + label + " button");
            if (layout && -1 === getButtonConfig(label, "layouts").indexOf(layout)) throw new Error("Unexpected style." + constants.m.LAYOUT + " for " + label + " button: " + layout + ", expected " + getButtonConfig(label, "layouts").join(", "));
            if (void 0 !== maxbuttons) {
                if ("number" != typeof maxbuttons) throw new TypeError("Expected style." + constants.m.MAXBUTTONS + " to be a number, got: " + maxbuttons);
                if (maxbuttons < 1) throw new Error("Expected style." + constants.m.MAXBUTTONS + " to be a at least 1, got: " + maxbuttons);
                var minButtons = getButtonConfig(label, layout === constants.g.VERTICAL ? "minVerticalButtons" : "minHorizontalButtons");
                if (maxbuttons < minButtons) throw new Error("Expected style." + constants.m.MAXBUTTONS + " to be no fewer than " + minButtons + ", got " + maxbuttons);
            }
            if (void 0 !== height) {
                if ("number" != typeof height) throw new TypeError("Expected style." + constants.m.HEIGHT + " to be a number, got: " + maxbuttons);
                var buttonSize = size || getButtonConfig(label, style.layout === constants.g.VERTICAL ? "defaultVerticalSize" : "defaultSize"), _ref = size === constants.l.RESPONSIVE ? {
                    minHeight: BUTTON_STYLE[constants.l.SMALL].minHeight,
                    maxHeight: BUTTON_STYLE[constants.l.HUGE].maxHeight
                } : BUTTON_STYLE[buttonSize], minHeight = _ref.minHeight, maxHeight = _ref.maxHeight;
                if (height < minHeight || height > maxHeight) throw new Error("Expected style." + constants.m.HEIGHT + " to be between " + minHeight + "px and " + maxHeight + "px - got " + height + "px");
            }
            if (!getButtonConfig(label, "allowPrimary")) throw new Error(label + " can not be used as primary button label");
            if (layout === constants.g.VERTICAL) {
                if (size && -1 === [ constants.l.MEDIUM, constants.l.LARGE, constants.l.RESPONSIVE ].indexOf(size)) throw new Error("Button must be at least " + constants.l.MEDIUM + " size for " + constants.g.VERTICAL + " layout");
                if (!getButtonConfig(label, "allowPrimaryVertical")) throw new Error("style." + constants.m.LABEL + " option is not allowed for " + constants.g.VERTICAL + " layout - got " + label);
                if (fundingicons) throw new Error("style." + constants.m.FUNDINGICONS + " not allowed for " + constants.g.VERTICAL + " layout - got " + fundingicons);
                if (tagline) throw new Error("style." + constants.m.TAGLINE + " is not allowed for " + constants.g.VERTICAL + " layout - got " + tagline);
            }
            !function(style, locale) {
                void 0 === style && (style = {}), void 0 === locale && (locale = "en_US");
                var country = locale.split("_")[1], isInstallmentAllowedCountry = -1 !== constants.a.indexOf(country);
                if (!isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT) throw new Error("Unexpected label: style." + style.label + " for country: " + country);
                if (!isInstallmentAllowedCountry && style[constants.m.INSTALLMENTPERIOD]) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is invalid for country: " + country);
                if (isInstallmentAllowedCountry && style[constants.m.INSTALLMENTPERIOD] && style.label !== constants.f.INSTALLMENT) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is invalid for label: style." + style.label);
                if (isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT && style[constants.m.INSTALLMENTPERIOD] && "number" != typeof style[constants.m.INSTALLMENTPERIOD]) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is expected to be a number");
                if (isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT && style[constants.m.INSTALLMENTPERIOD] && -1 === constants.b[country].indexOf(style[constants.m.INSTALLMENTPERIOD])) throw new Error("style." + constants.m.INSTALLMENTPERIOD + ": " + style[constants.m.INSTALLMENTPERIOD] + " is not a valid installment number for " + style.label);
            }(style, props.locale);
        }
        var pageStyle = "\n    html, body {\n        padding: 0;\n        margin: 0;\n        width: 100%;\n        overflow: hidden;\n        text-align: center;\n    }\n\n    body {\n        display: inline-block;\n        vertical-align: top;\n    }\n\n    * {\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        cursor: default;\n    }\n", class_CLASS = {
            SHOULD_FOCUS: "paypal-should-focus",
            CONTAINER: "paypal-button-container",
            BUTTON: "paypal-button",
            LABEL: "paypal-button-label",
            COLOR: "paypal-button-color",
            LOGO_COLOR: "paypal-button-logo-color",
            SHAPE: "paypal-button-shape",
            BRANDING: "paypal-button-branding",
            LAYOUT: "paypal-button-layout",
            NUMBER: "paypal-button-number",
            ENV: "paypal-button-env",
            TAGLINE: "paypal-button-tagline",
            TAGLINE_COLOR: "paypal-button-tagline-color",
            FUNDINGICONS: "paypal-button-fundingicons",
            TEXT: "paypal-button-text",
            LOGO: "paypal-button-logo",
            CARD: "paypal-button-card",
            SEPARATOR: "paypal-separator"
        }, buttonStyle = "\n\n    ." + class_CLASS.CONTAINER + ' {\n        display: block;\n        white-space: nowrap;\n        margin: 0;\n        background: 0;\n        border: 0;\n        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n        text-transform: none;\n        font-weight: 500;R\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        z-index: 0;\n        font-size: 0;\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .' + class_CLASS.BUTTON + ":not(." + class_CLASS.CARD + ") {\n        border: 1px solid transparent;\n        border-radius: 0 3px 3px 0;\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        border: none;\n        vertical-align: top;\n        cursor: pointer;\n        outline: none;\n        overflow: hidden;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + " {\n        cursor: auto;\n    }\n\n    ." + class_CLASS.BUTTON + " * {\n        cursor: pointer;\n    }\n\n    ." + class_CLASS.CONTAINER + "." + class_CLASS.ENV + "-" + constants.t.TEST + " ." + class_CLASS.TEXT + " {\n        font-family: Arial !important;\n        background: rgba(0, 0, 0, 0.5) !important;\n        color: transparent  !important;\n        text-shadow: none  !important;\n    }\n\n    ." + class_CLASS.BUTTON + ":hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.GOLD + ":hover,\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.SILVER + ":hover {\n        box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.05);\n    }\n\n    ." + class_CLASS.CARD + ", ." + class_CLASS.CARD + " * {\n        cursor: pointer;\n    }\n\n    ." + class_CLASS.CARD + ":hover {\n        filter: brightness(1.2);\n    }\n\n    ." + class_CLASS.BUTTON + ":focus, ." + class_CLASS.CARD + ":focus {\n        outline: none;\n    }\n\n    ." + class_CLASS.SHOULD_FOCUS + " ." + class_CLASS.BUTTON + ":focus,\n    ." + class_CLASS.SHOULD_FOCUS + " ." + class_CLASS.CARD + ":focus {\n        outline: solid 2px Highlight;\n        outline: auto 5px -webkit-focus-ring-color;\n        outline-offset: -3px;\n    }\n\n    ." + class_CLASS.BUTTON + ":focus {\n        box-shadow: -1px -1px 18px 1px rgba(0, 0, 0, 0.25) inset;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + ":focus {\n        box-shadow: none;\n        outline: none;\n    }\n\n    ." + class_CLASS.LOGO + " {\n        padding: 0;\n        display: inline-block;\n        background: none;\n        border: none;\n        width: auto;\n    }\n\n    ." + class_CLASS.TEXT + " {\n        display: inline-block;\n        white-space: pre-wrap;\n    }\n\n    ." + class_CLASS.BUTTON + " ." + class_CLASS.LOGO + ",\n    ." + class_CLASS.BUTTON + " ." + class_CLASS.TEXT + " {\n        vertical-align: top;\n        position: relative;\n        top: 50%;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(-50%);\n        -moz-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        -o-transform: translateY(-50%);\n        text-align: left;\n    }\n\n    ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " {\n        border-radius: 4px;\n    }\n\n    ." + class_CLASS.BUTTON + " ." + class_CLASS.TEXT + " {\n        visibility: hidden;\n    }\n\n    .powered-by-paypal > ." + class_CLASS.TEXT + " {\n        vertical-align: top;\n        line-height: 18px;\n    } \n\n    .powered-by-paypal > ." + class_CLASS.LOGO + " {\n        height: 16px;\n        min-height: 16px;\n    } \n\n    ." + class_CLASS.TAGLINE + " {\n        max-width: 100%;\n        font-weight: normal;\n        display: block;\n        text-align: center;\n        width: auto;\n        visibility: hidden;\n    }\n\n    ." + class_CLASS.SEPARATOR + " {\n        height: 80%;\n        border-left: 1px solid rgba(0, 0, 0, 0.15);\n        margin: 0 8px;\n        display: inline-block;\n        position: relative;\n        top: 10%;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLACK + " ." + class_CLASS.SEPARATOR + " {\n        border-color: rgba(255, 255, 255, 0.45);\n    }\n", layoutStyle = "\n\n    ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.VERTICAL + " ." + class_CLASS.TAGLINE + " {\n        display: none;\n    }\n", brandingStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + "  {\n        min-width: 60%;\n        width: auto;\n        font-weight: 900;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + " ." + class_CLASS.LOGO + " {\n        display: none;\n    }\n", labelStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CARD + " {\n        border-radius: 0 !important;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.TEXT + " {\n        display: none !important;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n        display: none;\n    }\n\n    @media only screen and (max-width : " + BUTTON_STYLE[constants.l.SMALL].minWidth + "px) {\n\n        ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n            display: none;\n        }\n    }\n\n    @media only screen and (min-width : " + BUTTON_STYLE[constants.l.SMALL].minWidth + "px) {\n\n        ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n            display: inline-block;\n        }\n    }\n", DUAL_BUTTON_MIN_RATIO = 2.8, buttonColorStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.GOLD + " {\n        background: #ffc439;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLUE + " {\n        background: #009cde;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.SILVER + " {\n        background: #eee;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLACK + " {\n        background: #2C2E2F;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.DARKBLUE + " {\n        background: #003087;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + " {\n        background: transparent;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.WHITE + " {\n        background: #fff;\n        color: #2C2E2F;\n        border: 1px solid #2C2E2F;\n    }\n", componentContent = {
            AD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                }
            },
            AG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AL: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AR: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AT: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AU: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BB: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BE: {
                en: {
                    checkout: "Pay with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                nl: {
                    checkout: "Betalen met {logo:pp} {logo:paypal}",
                    safer_tag: "De veiligere en snellere manier om te betalen.",
                    later_tag: "Koop nu. Betaal later.",
                    pay: "Betalen met {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Nu kopen",
                    poweredBy: "Mogelijk gemaakt door {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Le réflexe sécurité pour payer",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                }
            },
            BF: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BH: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BI: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BJ: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BR: {
                pt: {
                    checkout: "{logo:pp} {logo:paypal} Finalizar",
                    safer_tag: "A maneira fácil e segura de pagar.",
                    later_tag: "Compre agora e pague depois.",
                    pay: "Pague com {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar agora",
                    installment: "{logo:pp} {logo:paypal}  Pagamentos<br>  parcelados",
                    installment_period: "{logo:pp} {logo:paypal}  Pague em até<br>  [installmentperiod]x sem juros",
                    poweredBy: "Com tecnologia {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    installment: "{logo:pp} {logo:paypal}  Interest free<br>  payments",
                    installment_period: "{logo:pp} {logo:paypal}  Pay up to [installmentperiod]x<br>  without interest",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BT: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            C2: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式。",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CA: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer",
                    later_tag: "Acheter. Payer plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                }
            },
            CD: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CH: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Le réflexe sécurité pour payer",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CI: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CL: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CM: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CN: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CR: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CZ: {
                cs: {
                    checkout: "Zaplatit přes {logo:pp} {logo:paypal}",
                    safer_tag: "Jednodušší a bezpečnější způsob placení",
                    later_tag: "Nakupujte nyní, plaťte později.",
                    pay: "Zaplatit přes {logo: paypal}",
                    buynow: "Koupit ihned přes {logo:pp} {logo:paypal}",
                    poweredBy: "Využívá službu {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DE: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Überall schnell und sicher bezahlen.",
                    later_tag: "Jetzt bei uns bequem in Raten zahlen.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            DJ: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DK: {
                da: {
                    checkout: "{logo:pp} {logo:paypal} Betal",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            DM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DZ: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EC: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EG: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ER: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ES: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Tecnología de {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ET: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FI: {
                fi: {
                    checkout: "{logo:pp} {logo:paypal}-maksu",
                    safer_tag: "Turvallisempi ja helpompi maksutapa",
                    later_tag: "Osta nyt. Maksa vähitellen.",
                    pay: "{logo:paypal}-maksu",
                    buynow: "{logo:pp} {logo:paypal} Osta nyt",
                    poweredBy: "Palvelun tarjoaa {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FM: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            FO: {
                da: {
                    checkout: "Betal med {logo:pp} {logo:paypal}",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FR: {
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Pay",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            GA: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GB: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            GD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GL: {
                da: {
                    checkout: "Betal med {logo:pp} {logo:paypal}",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GN: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GP: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GR: {
                el: {
                    checkout: "Ολοκλήρωση αγοράς μέσω {logo:pp} {logo:paypal}",
                    safer_tag: "Ο ασφαλέστερος και ευκολότερος τρόπος πληρωμής",
                    later_tag: "Αγοράστε τώρα.  Πληρώστε σε δόσεις.",
                    pay: "Πληρωμή μέσω {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Αγορά τώρα",
                    poweredBy: "Με την υποστήριξη του {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GT: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            HK: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal} 結帳",
                    safer_tag: "更安全、更方便的付款方式",
                    later_tag: "先購買，後付款。",
                    pay: "使用 {logo:paypal} 付款",
                    buynow: "{logo:pp} {logo:paypal} 立即買",
                    poweredBy: "支援方： {logo:paypal}"
                }
            },
            HN: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            HR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            HU: {
                hu: {
                    checkout: "{logo:pp} {logo:paypal}-fizetés",
                    safer_tag: "Biztonságosabb, könnyebb fizetési mód.",
                    later_tag: "Vásároljon most. Fizessen később.",
                    pay: "{logo:paypal}-fizetés",
                    buynow: "{logo:pp} {logo:paypal} Vásárlás",
                    poweredBy: "Üzemeltető: {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ID: {
                id: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "Cara yang lebih mudah dan aman untuk membayar.",
                    later_tag: "Beli Sekarang. Bayar dalam Jangka Waktu Tertentu.",
                    pay: "Bayar dengan {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Beli Sekarang",
                    poweredBy: "Ditunjang teknologi {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            IL: {
                he: {
                    checkout: "{logo:pp} {logo:paypal} שלם",
                    safer_tag: ".הדרך הקלה והבטוחה יותר לשלם",
                    later_tag: "קנה עכשיו. שלם לאורך זמן.",
                    pay: "שלם באמצעות {logo:paypal}‏",
                    buynow: "{logo:pp} {logo:paypal} קנה עכשיו",
                    poweredBy: "{logo:paypal} מופעל על-ידי"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IT: {
                it: {
                    checkout: "{logo:pp} {logo:paypal} Paga adesso",
                    safer_tag: "Il modo rapido e sicuro per pagare",
                    later_tag: "Acquista ora. Paga più tardi.",
                    pay: "Paga con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Paga adesso",
                    poweredBy: "Con tecnologia {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            JM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            JO: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            JP: {
                ja: {
                    checkout: "{logo:pp} {logo:paypal}で支払う",
                    safer_tag: "より安全・簡単にお支払い",
                    later_tag: "今すぐ購入して、分割してお支払い。",
                    pay: "{logo:paypal}で支払う",
                    buynow: "{logo:pp} {logo:paypal} 購入",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KH: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KM: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KR: {
                ko: {
                    checkout: "{logo:pp} {logo:paypal} 체크 아웃",
                    safer_tag: "더 안전하고 빠른 결제 방법",
                    later_tag: "지금 구매하고 천천히 결제하세요.",
                    pay: "{logo:paypal}로 지불하기",
                    buynow: "{logo:pp} {logo:paypal} 바로 구매",
                    poweredBy: "제공: {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KW: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LA: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            LC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LK: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            LS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MA: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MC: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ME: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MH: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ML: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MQ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MV: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MX: {
                es: {
                    checkout: "Pagar con {logo:pp} {logo:paypal}",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    installment: "{logo:pp} {logo:paypal}  Pagos en<br>  mensualidades",
                    installment_period: "{logo:pp} {logo:paypal}  Pague hasta en<br>  [installmentperiod] mensualidades",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    installment: "{logo:pp} {logo:paypal}  Interest free<br>  payments",
                    installment_period: "{logo:pp} {logo:paypal}  Pay up to [installmentperiod]x<br>  without interest",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MY: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NE: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NI: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NL: {
                nl: {
                    checkout: "{logo:pp} {logo:paypal} Betalen",
                    safer_tag: "Een veilige en makkelijke manier om te betalen.",
                    later_tag: "Koop nu. Betaal later.",
                    pay: "Betalen met {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Nu kopen",
                    poweredBy: "Mogelijk gemaakt door {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NO: {
                no: {
                    checkout: "{logo:pp} {logo:paypal} Betal",
                    safer_tag: "En trygg og enkel betalingsmetode",
                    later_tag: "Kjøp nå, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kjøp nå",
                    poweredBy: "Leveres av {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NP: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NZ: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Un réflexe sécurité.",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar.",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式。",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            OM: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PA: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PE: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PH: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PL: {
                pl: {
                    checkout: "{logo:pp} {logo:paypal} Do kasy",
                    safer_tag: "Płać wygodnie i bezpiecznie",
                    later_tag: "Kup teraz. Płać w ratach",
                    pay: "Zapłać z {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kup teraz",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PT: {
                pt: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A forma rápida e segura de pagar",
                    later_tag: "Compre agora. Vá pagando.",
                    pay: "Pagar com {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar agora",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PY: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            QA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                }
            },
            RE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RU: {
                ru: {
                    checkout: "{logo:pp} {logo:paypal} Оформить покупку",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            RW: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SA: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SB: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SC: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SE: {
                sv: {
                    checkout: "{logo:pp} {logo:paypal} Betala",
                    safer_tag: "Ett tryggt och smidigt sätt att betala",
                    later_tag: "Köp nu, betala senare",
                    pay: "Betala med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Köp nu",
                    poweredBy: "Tillhandahålls av {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            SG: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            SH: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SK: {
                sk: {
                    checkout: "Zaplatiť cez {logo:pp} {logo:paypal}",
                    safer_tag: "Jednoduchší a bezpečnejší spôsob platby",
                    later_tag: "Nakúpte teraz, zaplaťte postupne",
                    pay: "Zaplatiť cez {logo: paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kúpiť",
                    poweredBy: "Používa technológiu {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SL: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SN: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ST: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SV: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TD: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TG: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TH: {
                th: {
                    checkout: "{logo:pp} {logo:paypal} ชำระเงิน",
                    safer_tag: "วิธีชำระเงินที่ปลอดภัยและง่ายกว่า",
                    later_tag: "ซื้อวันนี้ แล้วค่อยๆ จ่ายทีหลัง",
                    pay: "ชำระเงินด้วย {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} ซื้อทันที",
                    poweredBy: "ให้บริการโดย {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TN: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TO: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TR: {
                tr: {
                    checkout: "{logo:pp} {logo:paypal} ile Satın Alın",
                    safer_tag: "Ödeme yapmanın daha güvenli ve kolay yolu",
                    later_tag: "Şimdi Alın. Daha Sonra Ödeyin.",
                    pay: "{logo:paypal} ile Öde",
                    buynow: "{logo:pp} {logo:paypal} Hemen Satın Alın",
                    poweredBy: "Çalıştıran {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TW: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal} 結帳",
                    safer_tag: "更安全、更方便的付款方式",
                    later_tag: "先購買，後付款。",
                    pay: "使用 {logo:paypal} 付款",
                    buynow: "{logo:pp} {logo:paypal} 立即購",
                    poweredBy: "服務提供者： {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            US: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    dual_tag: "Two easy ways to pay",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "Pagar con {logo:pp} {logo:paypal}",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "使用{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UY: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VE: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            VU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            WF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            WS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            YE: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            YT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            }
        };
        function getCommonButtonClasses(_ref) {
            return [ class_CLASS.LAYOUT + "-" + _ref.layout, class_CLASS.SHAPE + "-" + _ref.shape, class_CLASS.BRANDING + "-" + (_ref.branding ? constants.d.BRANDED : constants.d.UNBRANDED), class_CLASS.NUMBER + "-" + (_ref.multiple ? constants.j.MULTIPLE : constants.j.SINGLE), class_CLASS.ENV + "-" + _ref.env, "" + class_CLASS.SHOULD_FOCUS ].join(" ");
        }
        function determineLabel(_ref3) {
            var label = _ref3.label, source = _ref3.source, multiple = _ref3.multiple, layout = _ref3.layout, defaultLabel = FUNDING_TO_DEFAULT_LABEL[source];
            return labelToFunding(label) === source ? multiple && layout === constants.g.HORIZONTAL ? defaultLabel : label : defaultLabel;
        }
        function renderCards(_ref5) {
            var button = _ref5.button, layout = _ref5.layout, size = _ref5.size;
            return _ref5.cards.map(function(name) {
                var _ref6, _ref7, _ref8, logo = resources.a[name];
                return Object(jsx.b)("div", Object(esm_extends.a)({}, ((_ref6 = {})[constants.c.LAYOUT] = layout || "", 
                _ref6), ((_ref7 = {})[constants.c.SIZE] = size || "", _ref7), ((_ref8 = {})[constants.c.BUTTON] = button || !1, 
                _ref8[constants.c.FUNDING_SOURCE] = "" + constants.v.CARD, _ref8[constants.c.CARD] = "" + name, 
                _ref8), {
                    class: (button ? class_CLASS.BUTTON : "") + " " + class_CLASS.CARD + " " + class_CLASS.CARD + "-" + name,
                    tabindex: "0"
                }), Object(jsx.b)("img", {
                    style: " display: block; ",
                    src: "data:image/svg+xml;base64," + Object(belter_src.a)(logo.toString()),
                    alt: name
                }));
            });
        }
        function renderContent(text, _ref10) {
            var label = _ref10.label, locale = _ref10.locale, color = _ref10.color, branding = _ref10.branding, logoColor = _ref10.logoColor, funding = _ref10.funding, env = _ref10.env, _cards = _ref10.cards, dynamicContent = _ref10.dynamicContent, layout = _ref10.layout, size = _ref10.size, _content = function(locale) {
                return componentContent[locale.country][locale.lang];
            }(locale);
            return Object(jsx.a)(text, {
                text: function(value) {
                    var className = "" + class_CLASS.TEXT;
                    return Object(jsx.b)("span", {
                        class: className
                    }, value);
                },
                logo: function(name) {
                    if (branding) {
                        if (!logoColor) throw new Error("Can not determine logo without logo color");
                        var logo = "function" == typeof resources.b[name] ? resources.b[name]({
                            label: label,
                            locale: locale,
                            color: color,
                            branding: branding,
                            logoColor: logoColor,
                            funding: funding,
                            env: env,
                            cards: _cards
                        }) : resources.b[name][logoColor] || resources.b[name][constants.i.ANY];
                        return Object(jsx.b)("img", {
                            class: class_CLASS.LOGO + " " + class_CLASS.LOGO + "-" + name + " " + class_CLASS.LOGO + "-" + color,
                            src: "data:image/svg+xml;base64," + Object(belter_src.a)(logo.toString()),
                            alt: name
                        });
                    }
                },
                content: function(name) {
                    for (var contentString, _i2 = 0, _name$split2 = name.split("|"); _i2 < _name$split2.length; _i2++) {
                        var key = _name$split2[_i2];
                        if (_content[key]) {
                            contentString = _content[key];
                            break;
                        }
                    }
                    if (!(contentString = contentString && contentString.replace(/\[([a-z]+)\]/g, function(match, contentVariable) {
                        if (match && contentVariable) return dynamicContent && dynamicContent[contentVariable];
                    })) && env === constants.t.TEST) throw new Error("Could not find content " + name + " for " + locale.lang + "_" + locale.country);
                    return renderContent(contentString || "", {
                        label: label,
                        locale: locale,
                        color: color,
                        branding: branding,
                        logoColor: logoColor,
                        funding: funding,
                        env: env,
                        cards: _cards
                    });
                },
                cards: function() {
                    if (!funding) throw new Error("Can not determine card types without funding");
                    return renderCards({
                        cards: _cards,
                        button: !1,
                        layout: layout,
                        size: size
                    });
                },
                separator: function() {
                    return Object(jsx.b)("span", {
                        class: class_CLASS.SEPARATOR
                    });
                },
                break: function(value) {
                    var className = "" + class_CLASS.TEXT;
                    return Object(jsx.b)("span", {
                        class: className
                    }, value.split("<br>")[0], Object(jsx.b)("br", null), value.split("<br>")[1]);
                }
            });
        }
        function componentTemplate(_ref17) {
            var _ref18, props = _ref17.props;
            if (props && props.style) {
                var style = props.style;
                "generic" === style.label && (style.label = "paypal"), "creditblue" === style.color && delete style.color, 
                1 !== style.maxbuttons || !1 !== style.tagline || "responsive" !== style.size || "horizontal" !== style.layout || style.height || (style.height = 44);
            }
            !function(props) {
                if (!props) throw new Error("Expected props");
                var style = props.style;
                validateButtonLocale(props.locale), validateButtonStyle(style, props);
            }(props);
            var script, _normalizeProps = normalizeProps(props), label = _normalizeProps.label, locale = _normalizeProps.locale, color = _normalizeProps.color, shape = _normalizeProps.shape, branding = _normalizeProps.branding, tagline = _normalizeProps.tagline, funding = _normalizeProps.funding, layout = _normalizeProps.layout, multiple = _normalizeProps.multiple, env = _normalizeProps.env, height = _normalizeProps.height, cards = _normalizeProps.cards, installmentperiod = _normalizeProps.installmentperiod, fundingicons = _normalizeProps.fundingicons, size = _normalizeProps.size, buttonNodes = function(_ref4) {
                var label = _ref4.label, color = _ref4.color, multiple = _ref4.multiple, layout = _ref4.layout;
                return _ref4.sources.map(function(source, i) {
                    var buttonLabel = determineLabel({
                        label: label,
                        source: source,
                        multiple: multiple,
                        layout: layout
                    });
                    return {
                        source: source,
                        label: buttonLabel,
                        color: multiple && i > 0 ? getButtonConfig(buttonLabel, "secondaryColors")[color] : color
                    };
                });
            }({
                label: label,
                color: color,
                sources: _normalizeProps.sources,
                multiple: multiple,
                layout: layout
            }).map(function(button, i) {
                return function(_ref11) {
                    var _ref12, _ref13, _ref14, size = _ref11.size, label = _ref11.label, color = _ref11.color, locale = _ref11.locale, branding = _ref11.branding, multiple = _ref11.multiple, layout = _ref11.layout, shape = _ref11.shape, source = _ref11.source, funding = _ref11.funding, i = _ref11.i, env = _ref11.env, cards = _ref11.cards, installmentperiod = _ref11.installmentperiod, logoColor = getButtonConfig(label, "logoColors")[color], contentText = getButtonConfig(label, determineLabel({
                        label: label,
                        source: source,
                        multiple: multiple,
                        layout: layout
                    }) === label ? "label" : "logoLabel"), dynamicContent = {
                        installmentperiod: installmentperiod,
                        locale: locale
                    };
                    contentText = renderContent(contentText = "function" == typeof contentText ? contentText(dynamicContent) : contentText, {
                        label: label,
                        locale: locale,
                        color: color,
                        branding: branding,
                        logoColor: logoColor,
                        funding: funding,
                        env: env,
                        cards: cards,
                        dynamicContent: dynamicContent,
                        layout: layout,
                        size: size
                    });
                    var _ref2, hasTabIndex = -1 === [ constants.v.CARD ].indexOf(source);
                    return Object(jsx.b)("div", Object(esm_extends.a)({}, ((_ref12 = {})[constants.c.LAYOUT] = layout || "", 
                    _ref12), ((_ref13 = {})[constants.c.SIZE] = size || "", _ref13), ((_ref14 = {})[constants.c.FUNDING_SOURCE] = source, 
                    _ref14[constants.c.BUTTON] = !0, _ref14), {
                        class: class_CLASS.BUTTON + " " + class_CLASS.NUMBER + "-" + i + " " + getCommonButtonClasses({
                            layout: layout,
                            shape: shape,
                            branding: branding,
                            multiple: multiple,
                            env: env
                        }) + " " + (_ref2 = {
                            label: label,
                            color: color,
                            logoColor: logoColor
                        }, [ class_CLASS.LABEL + "-" + _ref2.label, class_CLASS.COLOR + "-" + _ref2.color, class_CLASS.LOGO_COLOR + "-" + _ref2.logoColor ].join(" ")),
                        role: "button",
                        "aria-label": source,
                        tabindex: hasTabIndex && 0
                    }), contentText);
                }({
                    label: button.label,
                    color: button.color,
                    source: button.source,
                    env: env,
                    i: i,
                    funding: funding,
                    multiple: multiple,
                    locale: locale,
                    branding: branding,
                    layout: layout,
                    shape: shape,
                    cards: cards,
                    installmentperiod: installmentperiod,
                    size: size
                });
            }), taglineNode = function(_ref15) {
                var label = _ref15.label, color = _ref15.color, locale = _ref15.locale, env = _ref15.env, cards = _ref15.cards;
                if (_ref15.tagline) {
                    var text = renderContent(_ref15.multiple && getButtonConfig(label, "dualTag") || getButtonConfig(label, "tag"), {
                        locale: locale,
                        color: color,
                        env: env,
                        cards: cards
                    });
                    if (text) {
                        var tagColor = getButtonConfig(label, "tagLineColors")[color];
                        return Object(jsx.b)("div", {
                            class: class_CLASS.TAGLINE + " " + class_CLASS.TAGLINE_COLOR + "-" + tagColor
                        }, text);
                    }
                }
            }({
                label: label,
                tagline: tagline,
                color: color,
                locale: locale,
                multiple: multiple,
                env: env,
                cards: cards
            }), fundingiconNode = function(_ref9) {
                var cards = _ref9.cards, size = _ref9.size, layout = _ref9.layout;
                if (_ref9.fundingicons) return Object(jsx.b)("div", {
                    class: "" + class_CLASS.FUNDINGICONS
                }, renderCards({
                    cards: cards,
                    button: !0,
                    size: size,
                    layout: layout
                }));
            }({
                cards: cards,
                fundingicons: fundingicons,
                size: size,
                layout: layout
            }), styleNode = function(_ref16) {
                var _ref, height = _ref16.height, cardNumber = _ref16.cardNumber;
                return Object(jsx.b)("style", {
                    innerHTML: (_ref = {
                        height: height,
                        cardNumber: cardNumber
                    }, "\n        " + pageStyle + "\n        " + buttonStyle + "\n        " + buttonColorStyle + "\n        " + layoutStyle + "\n        " + brandingStyle + "\n        " + labelStyle + "\n        " + function(_ref) {
                        var height = _ref.height, _ref$cardNumber = _ref.cardNumber, cardNumber = void 0 === _ref$cardNumber ? 4 : _ref$cardNumber;
                        return Object.keys(BUTTON_STYLE).map(function(size) {
                            var style = BUTTON_STYLE[size], buttonHeight = height || style.defaultHeight, minDualWidth = Math.round(buttonHeight * DUAL_BUTTON_MIN_RATIO * 2);
                            return "\n\n            @media only screen and (min-width: " + style.minWidth + "px) {\n\n                ." + class_CLASS.CONTAINER + " {\n                    min-width: " + style.minWidth + "px;\n                    max-width: " + style.maxWidth + "px;\n                    font-size: " + Object(util.h)(Object(util.m)(buttonHeight, 32), 10) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + ":not(." + class_CLASS.CARD + ") {\n                    height: " + buttonHeight + "px;\n                    min-height: " + (height || style.minHeight) + "px;\n                    max-height: " + (height || style.maxHeight) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + " {\n                    font-size: " + Object(util.h)(Object(util.m)(buttonHeight, 45), 10) + "px;\n                }\n\n                ." + class_CLASS.LOGO + " {\n                    height: " + (Object(util.m)(buttonHeight, 35) + 5) + "px;\n                    max-height: " + Object(util.m)(buttonHeight, 60) + "px;\n                    min-height: " + Object(util.m)(buttonHeight, 40) + "px;\n                }\n                \n                ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.f.EPS + ",\n                ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.f.MYBANK + " {\n                    height: " + (Object(util.m)(buttonHeight, 50) + 5) + "px;\n                    max-height: " + Object(util.m)(buttonHeight, 70) + "px;\n                    min-height: " + Object(util.m)(buttonHeight, 40) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.SHAPE + "-" + constants.k.PILL + " {\n                    border-radius: " + Math.ceil(buttonHeight / 2) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.SHAPE + "-" + constants.k.RECT + " {\n                    border-radius: 4px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.VERTICAL + " {\n                    margin-bottom: " + Object(util.m)(buttonHeight, BUTTON_RELATIVE_STYLE.VERTICAL_MARGIN) + "px;\n                }\n\n                ." + class_CLASS.SEPARATOR + " {\n                    margin: 0 " + Object(util.m)(buttonHeight, 5) + "px;\n                }\n\n                ." + class_CLASS.TAGLINE + " {\n                    display: " + (style.allowTagline ? "block" : "none") + ";\n                    height: " + Object(util.m)(buttonHeight, BUTTON_RELATIVE_STYLE.TAGLINE) + "px;\n                    line-height: " + Object(util.m)(buttonHeight, BUTTON_RELATIVE_STYLE.TAGLINE) + "px;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " {\n                    display: " + (style.allowFunding ? "block" : "none") + ";\n                    height: " + Object(util.m)(buttonHeight, BUTTON_RELATIVE_STYLE.FUNDINGICONS) + "px;\n                }\n\n                ." + class_CLASS.CARD + " {\n                    display: inline-block;\n                }\n\n                ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " {\n                    width: " + (90 / cardNumber).toFixed(2) + "%;\n                    max-width: " + Object(util.m)(buttonHeight, 160) + "px;\n                    margin-top: 0;\n                    margin-left: " + (5 / cardNumber).toFixed(2) + "%;\n                    margin-right: " + (5 / cardNumber).toFixed(2) + "%;\n                }\n\n                ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " img {\n                    width: 100%;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " ." + class_CLASS.CARD + " {\n                    height: " + Object(util.m)(buttonHeight, 70) + "px;\n                    margin-top: " + Object(util.m)(buttonHeight, 15) + "px;\n                    margin-left: " + Object(util.m)(buttonHeight, 7) + "px;\n                    margin-right: " + Object(util.m)(buttonHeight, 7) + "px;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " ." + class_CLASS.CARD + " img {\n                    height: 100%;\n                }\n            }\n\n            @media only screen and (min-width: " + style.minWidth + "px) and (max-width: " + minDualWidth + "px) {\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-0 {\n                    width: 100%;\n                    margin-right: 0;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-1 {\n                    display: none;\n                }\n\n                ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + " ." + class_CLASS.TAGLINE + " {\n                    display: none;\n                }\n            }\n\n            @media only screen and (min-width: " + Object(util.h)(style.minWidth, minDualWidth) + "px) {\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-0 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                    margin-right: 4px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-1 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                }\n\n                ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + " ." + class_CLASS.TAGLINE + " {\n                    display: block;\n                }\n            }\n        ";
                        }).join("\n");
                    }({
                        height: _ref.height,
                        cardNumber: _ref.cardNumber
                    }) + "\n    ")
                });
            }({
                height: height,
                cardNumber: cards.length
            }), scriptNode = (script = (script = function() {
                var STYLE = {
                    BLOCK: "block",
                    INLINE_BLOCK: "inline-block",
                    NONE: "none",
                    VISIBLE: "visible",
                    HIDDEN: "hidden"
                };
                function getElements(selector, parent) {
                    return parent = parent || document, [].slice.call(parent.querySelectorAll(selector));
                }
                function showElement(el, displayType) {
                    void 0 === displayType && (displayType = STYLE.INLINE_BLOCK), el.style.display = displayType;
                }
                function hideElement(el) {
                    el.style.display = STYLE.NONE;
                }
                function makeElementVisible(el) {
                    el.style.visibility = STYLE.VISIBLE;
                }
                function makeElementInvisible(el) {
                    el.style.visibility = STYLE.HIDDEN;
                }
                function displayedElementsHaveDimensions(elements) {
                    return elements.every(function(el) {
                        return function(el) {
                            var rect = el.getBoundingClientRect();
                            return Boolean(rect.height && rect.width);
                        }(el) || function(el) {
                            var computedStyle = window.getComputedStyle(el);
                            return !computedStyle || computedStyle.display === STYLE.NONE;
                        }(el);
                    });
                }
                function isOverflowing(el) {
                    if (el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight) return !0;
                    var parent = el.parentNode;
                    if (!parent) return !1;
                    var e = el.getBoundingClientRect(), p = parent.getBoundingClientRect();
                    return e.top < p.top || e.left < p.left || e.right > p.right || e.bottom > p.bottom || e.left < 0 || e.top < 0 || e.left + e.width > window.innerWidth || e.top + e.height > window.innerHeight;
                }
                var images = getElements(".{ CLASS.BUTTON } .{ CLASS.LOGO }"), text = getElements(".{ CLASS.BUTTON } .{ CLASS.TEXT }"), tagline = getElements(".{ CLASS.TAGLINE }"), cards = getElements(".{ CLASS.FUNDINGICONS } .{ CLASS.CARD }"), optionals = getElements(".{ CLASS.BUTTON }-label-credit .{ CLASS.BUTTON }-logo-paypal");
                function toggleOptionals() {
                    tagline.some(isOverflowing) ? tagline.forEach(makeElementInvisible) : tagline.forEach(makeElementVisible), 
                    cards.forEach(function(el) {
                        return showElement(el);
                    }), cards.filter(isOverflowing).forEach(hideElement), text.forEach(function(el) {
                        return showElement(el);
                    }), optionals.forEach(function(el) {
                        return showElement(el);
                    }), images.some(isOverflowing) || text.some(isOverflowing) ? (text.forEach(hideElement), 
                    optionals.forEach(hideElement)) : (text.forEach(makeElementVisible), optionals.forEach(function(el) {
                        return showElement(el);
                    }));
                }
                toggleOptionals(), function() {
                    var buttonsContainer = document.getElementsByClassName("{ CLASS.CONTAINER }")[0], tabKeyCode = 9;
                    function handleMouseDownOnce() {
                        buttonsContainer.classList.remove("{ CLASS.SHOULD_FOCUS }"), window.removeEventListener("mousedown", handleMouseDownOnce), 
                        window.addEventListener("keydown", handleFirstTab);
                    }
                    function handleFirstTab(e) {
                        e.keyCode === tabKeyCode && (buttonsContainer.classList.add("{ CLASS.SHOULD_FOCUS }"), 
                        window.removeEventListener("keydown", handleFirstTab), window.addEventListener("mousedown", handleMouseDownOnce));
                    }
                    buttonsContainer.classList.add("{ CLASS.SHOULD_FOCUS }"), window.addEventListener("keydown", handleFirstTab);
                }(), function(elements, method) {
                    if (displayedElementsHaveDimensions(elements)) method(); else var interval = setInterval(function() {
                        displayedElementsHaveDimensions(elements) && (clearInterval(interval), method());
                    }, 5);
                }(images, function() {
                    images.forEach(makeElementVisible), toggleOptionals(), document.addEventListener("DOMContentLoaded", toggleOptionals), 
                    window.addEventListener("load", toggleOptionals), window.addEventListener("resize", toggleOptionals), 
                    function loop(method, delay, instances) {
                        setTimeout(function() {
                            method(), (instances -= 1) && loop(method, delay, instances);
                        }, delay);
                    }(toggleOptionals, 10, 10);
                });
            }.toString()).replace(/\{\s*CLASS\.([A-Z0-9_]+)\s*\}/g, function(match, name) {
                return class_CLASS[name];
            }), Object(jsx.b)("script", {
                innerHTML: "(" + script + ")();"
            })), labelPowerByPayPal = cards.length > 0 ? function(props) {
                if (!props) return null;
                var _props$sources = props.sources;
                return props.layout !== constants.g.VERTICAL ? null : -1 === (void 0 === _props$sources ? [] : _props$sources).indexOf(constants.v.CARD) ? null : Object(jsx.b)("div", {
                    class: "powered-by-paypal",
                    style: "\n                text-align: center;\n                margin: 10px auto;\n                height: 14px;\n                font-family: PayPal-Sans, HelveticaNeue, sans-serif;\n                font-size: 11px;\n                font-weight: normal;\n                font-style: italic;\n                font-stretch: normal;\n                color: #7b8388;\n                position: relative;\n                margin-right: 3px;\n                bottom: 3px;\n            "
                }, renderContent("{ content: poweredBy }", Object(esm_extends.a)({}, props, {
                    logoColor: "blue"
                })));
            }(normalizeProps(props)) : null;
            return Object(jsx.b)("div", Object(esm_extends.a)({}, (_ref18 = {}, _ref18[constants.c.VERSION] = "4.0.282", 
            _ref18), {
                class: class_CLASS.CONTAINER + " " + getCommonButtonClasses({
                    layout: layout,
                    shape: shape,
                    branding: branding,
                    multiple: multiple,
                    env: env
                })
            }), styleNode, buttonNodes, taglineNode || fundingiconNode, labelPowerByPayPal, scriptNode).toString();
        }
        pptm.listenForLoadWithNoContent();
        var creditThrottle, isDomainAllowed = Object(lib.I)(function() {
            var domain = Object(cross_domain_utils_src.g)().replace(/^https?:\/\//, "").replace(/^www\./, "");
            return !!config.a.apmTestDomains.some(function(allowDomain) {
                var regex = new RegExp("[^a-zA-Z\\d\\-]*" + allowDomain.replace(/\./g, "\\.") + "$");
                return null !== domain.match(regex);
            });
        }), component_Button = Object(src.c)({
            tag: "paypal-button",
            name: "ppbutton",
            buildUrl: function(props) {
                return config.a.buttonUrls[props.env || config.a.env];
            },
            contexts: {
                iframe: !0,
                popup: !1
            },
            scrolling: !1,
            listenForResize: !0,
            containerTemplate: function(_ref) {
                var id = _ref.id, CLASS = _ref.CLASS, tag = _ref.tag, context = _ref.context, outlet = _ref.outlet, jsxDom = _ref.jsxDom, _normalizeProps = normalizeProps(_ref.props), size = _normalizeProps.size, label = _normalizeProps.label, layout = _normalizeProps.layout, buttonHeight = _normalizeProps.height, minimumSize = getButtonConfig(label, layout === constants.g.VERTICAL ? "minimumVerticalSize" : "minimumSize"), maximumSize = getButtonConfig(label, layout === constants.g.VERTICAL ? "maximumVerticalSize" : "maximumSize");
                if (buttonHeight) {
                    var possibleSizes = Object(util.t)(constants.l).filter(function(possibleSize) {
                        return BUTTON_STYLE[possibleSize] && buttonHeight && BUTTON_STYLE[possibleSize].minHeight <= buttonHeight && BUTTON_STYLE[possibleSize].maxHeight >= buttonHeight;
                    });
                    possibleSizes.sort(function(sizeA, sizeB) {
                        return BUTTON_STYLE[sizeA].defaultWidth - BUTTON_STYLE[sizeB].defaultWidth;
                    }), minimumSize = possibleSizes[0], maximumSize = possibleSizes[possibleSizes.length - 1];
                }
                var _ref2 = BUTTON_STYLE[size] || BUTTON_STYLE[constants.l.SMALL], defaultWidth = _ref2.defaultWidth, defaultHeight = _ref2.defaultHeight;
                return setTimeout(function() {
                    outlet.style.transition = "all 0.5s ease-in-out 0.3s";
                }, 3e3), jsxDom("div", {
                    id: id,
                    class: tag + " " + tag + "-context-" + context + " " + tag + "-label-" + label + " " + tag + "-size-" + size + " " + tag + "-layout-" + layout
                }, jsxDom("style", null, "\n                    #" + id + " {\n                        font-size: 0;\n                        width: 100%;\n                        overflow: hidden;\n                        min-width: " + BUTTON_STYLE[minimumSize].minWidth + "px;\n                    }\n\n                    #" + id + "." + tag + "-size-" + constants.l.RESPONSIVE + " {\n                        text-align: center;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        display: inline-block;\n                        min-width: " + BUTTON_STYLE[minimumSize].minWidth + "px;\n                        max-width: " + BUTTON_STYLE[maximumSize].maxWidth + "px;\n                        position: relative;\n                    }\n\n                    #" + id + "." + tag + "-layout-" + constants.g.VERTICAL + " > ." + CLASS.OUTLET + " {\n                        min-width: " + BUTTON_STYLE[minimumSize].minWidth + "px;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        width:  " + defaultWidth + "px;\n                        height: " + defaultHeight + "px;\n                    }\n\n                     #" + id + "." + tag + "-size-" + constants.l.RESPONSIVE + " > ." + CLASS.OUTLET + " {\n                        width: 100%;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe {\n                        min-width: 100%;\n                        max-width: 100%;\n                        width: " + BUTTON_STYLE[minimumSize].minWidth + "px;\n                        height: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.COMPONENT_FRAME + " {\n                        z-index: 100;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.PRERENDER_FRAME + " {\n                        transition: opacity .2s linear;\n                        z-index: 200;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n                        opacity: 1;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n                        opacity: 0;\n                        pointer-events: none;\n                    }\n                "), outlet);
            },
            autoResize: {
                height: !0,
                width: !1
            },
            prerenderTemplate: function(_ref) {
                var _this = this, jsxDom = _ref.jsxDom, template = jsxDom("div", {
                    innerHTML: componentTemplate({
                        props: _ref.props
                    })
                });
                return template.addEventListener("click", function() {
                    var _track;
                    Object(beaver_logger_client.q)("button_pre_template_click"), Object(lib.E)() && (Object(beaver_logger_client.q)("button_pre_template_click_intranet_mode"), 
                    Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                    _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK_INTRANET_MODE, 
                    _track[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, _track[constants.u.KEY.BUTTON_SESSION_UID] = _this.props.buttonSessionID, 
                    _track)), Object(beaver_logger_client.h)(), alert("IE Intranet mode is not supported by PayPal. Please disable intranet mode, or continue in an alternate browser.")), 
                    Object(lib.m)("allow_full_page_fallback") && (Object(beaver_logger_client.k)("pre_template_force_full_page"), 
                    _this.props.payment().then(function(token) {
                        window.top.location = Object(lib.g)(config.a.checkoutUrl, {
                            token: token
                        });
                    }));
                }), jsxDom("html", null, jsxDom("body", null, template));
            },
            get version() {
                return Object(lib.u)();
            },
            get domain() {
                return config.a.paypalDomains;
            },
            attributes: {
                iframe: {
                    allowpaymentrequest: "allowpaymentrequest"
                }
            },
            validate: function() {
                Object(lib.B)() || Object(beaver_logger_client.q)("button_render_ineligible");
            },
            props: {
                domain: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return window.location.host;
                    },
                    queryParam: !0
                },
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.v)();
                    },
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.X)();
                    },
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (env && !config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                meta: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    }
                },
                client: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    },
                    sendToChild: !1,
                    validate: function(client, props) {
                        var env = props.env || config.a.env;
                        if (!client[env]) throw new Error("Client ID not found for env: " + env);
                        if ("string" == typeof client[env]) {
                            if (client[env].match(/^(.)\1+$/)) throw new Error("Invalid client ID: " + client[env]);
                        } else if (!zalgo_promise_src.a.isPromise(client[env])) throw new Error("Expected client token to be either a string or a promise");
                    },
                    decorate: function(client) {
                        return client && "demo_sandbox_client_id" === client.sandbox && (client.sandbox = "AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R"), 
                        client;
                    }
                },
                source: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return constants.E.MANUAL;
                    }
                },
                prefetchLogin: {
                    type: "boolean",
                    required: !1
                },
                stage: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stage;
                    }
                },
                updateClientConfiguration: {
                    type: "boolean",
                    required: !1,
                    def: function() {
                        return !0;
                    }
                },
                stageUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stageUrl;
                    }
                },
                localhostUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        if ((props.env || config.a.env) === constants.t.LOCAL) return config.a.localhostUrl;
                    }
                },
                checkoutUri: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.checkoutUri;
                    }
                },
                braintree: {
                    type: "object",
                    required: !1,
                    validate: function(braintree, props) {
                        if (!braintree.paypalCheckout) throw new Error("Expected Braintree paypal-checkout component to be loaded");
                        if (!props.client) throw new Error("Expected client prop to be passed with Braintree authorization keys");
                    },
                    decorate: function(braintree, props) {
                        var env = props.env || config.a.env;
                        return zalgo_promise_src.a.hash(props.client).then(function(client) {
                            return Object(integrations.a)(braintree, client[env]);
                        });
                    }
                },
                payment: {
                    type: "function",
                    required: !0,
                    memoize: !1,
                    timeout: 1e4,
                    alias: "billingAgreement",
                    decorate: function(original) {
                        return function() {
                            var _this2 = this, actions = {
                                request: lib.R,
                                payment: {
                                    create: function(options) {
                                        return _this2.props.braintree ? _this2.props.braintree.then(function(client) {
                                            return client.createPayment(Object(integrations.e)(options.payment || options));
                                        }) : zalgo_promise_src.a.hash(_this2.props.client).then(function(client) {
                                            return rest.payment.create(_this2.props.env, client, options);
                                        });
                                    }
                                },
                                order: {
                                    create: function(options) {
                                        return zalgo_promise_src.a.hash(_this2.props.client).then(function(client) {
                                            return rest.order.create(_this2.props.env, client, options);
                                        });
                                    }
                                },
                                braintree: {
                                    create: function(options) {
                                        if (!_this2.props.braintree) throw new Error("Can not create using Braintree - no braintree client provided");
                                        return _this2.props.braintree.then(function(client) {
                                            return client.createPayment(options);
                                        });
                                    }
                                }
                            };
                            return Object(lib.m)("memoize_payment") && this.memoizedToken ? this.memoizedToken : (this.memoizedToken = zalgo_promise_src.a.try(original, this, [ {}, actions ]), 
                            this.memoizedToken = this.memoizedToken.then(function(token) {
                                var _track2;
                                if (!token) throw Object(beaver_logger_client.g)("no_token_passed_to_payment"), 
                                new Error("No value passed to payment");
                                return Object(beaver_logger_client.p)(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                                _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.RECIEVE_PAYMENT, _track2[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[Object(integrations.d)(token)], 
                                _track2[constants.u.KEY.CONTEXT_ID] = token, _track2[constants.u.KEY.BUTTON_SESSION_UID] = _this2.props.buttonSessionID, 
                                _track2)), Object(beaver_logger_client.h)(), token;
                            }), this.memoizedToken);
                        };
                    }
                },
                authCode: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return config.a.authCode;
                    }
                },
                funding: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    validate: function(_temp) {
                        var _ref2 = void 0 === _temp ? {} : _temp, _ref2$allowed = _ref2.allowed, _ref2$disallowed = _ref2.disallowed;
                        !function(funding) {
                            if (void 0 === funding && (funding = {
                                allowed: [],
                                disallowed: [],
                                remembered: []
                            }), funding.allowed) for (var _i2 = 0, _funding$allowed2 = funding.allowed; _i2 < _funding$allowed2.length; _i2++) {
                                var source = _funding$allowed2[_i2];
                                if (-1 === constants.p.indexOf(source)) {
                                    if (!FUNDING_CONFIG.hasOwnProperty(source)) throw new Error("Invalid funding source: " + source);
                                    if (!getFundingConfig(source, "allowOptIn")) throw new Error("Can not allow funding source: " + source);
                                    if (funding.disallowed && -1 !== funding.disallowed.indexOf(source)) throw new Error("Can not allow and disallow funding source: " + source);
                                }
                            }
                            if (funding.disallowed) for (var _i4 = 0, _funding$disallowed2 = funding.disallowed; _i4 < _funding$disallowed2.length; _i4++) {
                                var _source = _funding$disallowed2[_i4];
                                if (-1 === constants.p.indexOf(_source)) {
                                    if (!FUNDING_CONFIG.hasOwnProperty(_source)) throw new Error("Invalid funding source: " + _source);
                                    if (!getFundingConfig(_source, "allowOptOut")) throw new Error("Can not disallow funding source: " + _source);
                                }
                            }
                        }({
                            allowed: void 0 === _ref2$allowed ? [] : _ref2$allowed,
                            disallowed: void 0 === _ref2$disallowed ? [] : _ref2$disallowed,
                            remembered: []
                        });
                    },
                    def: function() {
                        return {};
                    },
                    decorate: function(_temp2, props) {
                        var _ref3 = void 0 === _temp2 ? {} : _temp2, _ref3$allowed = _ref3.allowed, allowed = void 0 === _ref3$allowed ? [] : _ref3$allowed, _ref3$disallowed = _ref3.disallowed, disallowed = void 0 === _ref3$disallowed ? [] : _ref3$disallowed;
                        allowed = Array.isArray(allowed) ? allowed : [], disallowed = Array.isArray(disallowed) ? disallowed : [], 
                        allowed && -1 !== allowed.indexOf(constants.v.VENMO) && (allowed = allowed.filter(function(source) {
                            return source !== constants.v.VENMO;
                        })), allowed && -1 !== allowed.indexOf(constants.v.ITAU) && (allowed = allowed.filter(function(source) {
                            return source !== constants.v.ITAU;
                        })), function(props) {
                            var _normalizeProps = normalizeProps(props, {
                                locale: Object(lib.i)()
                            }), label = _normalizeProps.label, funding = _normalizeProps.funding, layout = _normalizeProps.layout, locale = _normalizeProps.locale, max = _normalizeProps.max, sources = _normalizeProps.sources, allowed = funding.allowed, country = locale.country;
                            if (allowed && -1 !== allowed.indexOf(constants.v.CREDIT)) return !1;
                            if (layout !== constants.g.HORIZONTAL) return !1;
                            if (1 === max) return !1;
                            if (label === constants.f.CREDIT) return !1;
                            if (country !== constants.r.US) return !1;
                            if (isFundingIneligible(constants.v.CREDIT, {
                                funding: funding,
                                locale: locale,
                                layout: layout
                            })) return !1;
                            if (isFundingAutoEligible(constants.v.CREDIT, {
                                funding: funding,
                                locale: locale,
                                layout: layout
                            })) return !1;
                            if (-1 !== sources.indexOf(constants.v.CREDIT)) return !1;
                            var domain = Object(cross_domain_utils_src.g)().replace(/^https?:\/\//, "").replace(/^www\./, "");
                            return -1 !== config.a.creditTestDomains.indexOf(domain);
                        }(props) && (creditThrottle = Object(lib.x)("dual_credit_automatic", 50)).isEnabled() && (allowed = [].concat(allowed, [ constants.v.CREDIT ]));
                        var apmFunding = [ constants.v.IDEAL, constants.v.SOFORT, constants.v.GIROPAY, constants.v.BANCONTACT, constants.v.P24, constants.v.MYBANK, constants.v.ZIMPLER, constants.v.EPS ].filter(function(source) {
                            return function(source, props) {
                                var locale = normalizeProps(props, {
                                    locale: Object(lib.i)()
                                }).locale;
                                return -1 !== getFundingConfig(source, "allowedCountries", [ locale.country ]).indexOf(locale.country) && isDomainAllowed();
                            }(source, props);
                        });
                        allowed = allowed.concat(apmFunding);
                        var remembered = Object(lib.r)(function(sources) {
                            return sources;
                        });
                        return Object(lib.z)() && !Object(lib.m)("disable_venmo") || (remembered && -1 !== remembered.indexOf(constants.v.VENMO) && (remembered = remembered.filter(function(source) {
                            return source !== constants.v.VENMO;
                        })), disallowed && -1 === disallowed.indexOf(constants.v.VENMO) && (disallowed = [].concat(disallowed, [ constants.v.VENMO ]))), 
                        {
                            allowed: allowed,
                            disallowed: disallowed,
                            remembered: remembered,
                            remember: function(sources) {
                                Object(lib.Q)(sources);
                            }
                        };
                    }
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0,
                    queryValue: function(val) {
                        return val ? "true" : "false";
                    }
                },
                onRender: {
                    type: "function",
                    promisify: !0,
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function() {
                            var _track3, _getBrowser = Object(lib.h)(), _getBrowser$browser = _getBrowser.browser, browser = void 0 === _getBrowser$browser ? "unrecognized" : _getBrowser$browser, _getBrowser$version = _getBrowser.version, version = void 0 === _getBrowser$version ? "unrecognized" : _getBrowser$version;
                            Object(beaver_logger_client.k)("button_render_browser_" + browser + "_" + (Object(lib.z)() ? "mobile" : "desktop") + "_" + version);
                            var _track4, _creditThrottle$logSt, style = this.props.style || {};
                            return Object(beaver_logger_client.k)("button_render"), Object(beaver_logger_client.k)("button_render_color_" + (style.color || "default")), 
                            Object(beaver_logger_client.k)("button_render_shape_" + (style.shape || "default")), 
                            Object(beaver_logger_client.k)("button_render_size_" + (style.size || "default")), 
                            Object(beaver_logger_client.k)("button_render_label_" + (style.label || "default")), 
                            Object(beaver_logger_client.k)("button_render_branding_" + (style.branding || "default")), 
                            Object(beaver_logger_client.k)("button_render_fundingicons_" + (style.fundingicons || "default")), 
                            Object(beaver_logger_client.k)("button_render_tagline_" + (style.tagline || "default")), 
                            pptm.listenForButtonRender(), pptm.reloadPptmScript(this.props.client[this.props.env]), 
                            Object(beaver_logger_client.p)(((_track3 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
                            _track3[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_RENDER, _track3[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                            _track3[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track3[constants.u.KEY.BUTTON_SOURCE] = this.props.source, 
                            _track3)), Object(lib.E)() && (Object(beaver_logger_client.q)("button_render_intranet_mode"), 
                            Object(beaver_logger_client.p)(((_track4 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
                            _track4[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_RENDER_INTRANET_MODE, 
                            _track4[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, _track4[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _track4[constants.u.KEY.BUTTON_SOURCE] = this.props.source, _track4))), creditThrottle && creditThrottle.logStart(((_creditThrottle$logSt = {})[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _creditThrottle$logSt)), Object(beaver_logger_client.h)(), original.apply(this, arguments);
                        };
                    }
                },
                onAuthorize: {
                    type: "function",
                    required: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _track5, _this3 = this;
                            data && !data.intent && Object(beaver_logger_client.q)("button_authorize_no_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken
                            }), Object(beaver_logger_client.k)("button_authorize"), Object(beaver_logger_client.p)(((_track5 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track5[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_AUTHORIZE, 
                            _track5[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track5)), 
                            Object(lib.E)() && Object(beaver_logger_client.q)("button_authorize_intranet_mode"), 
                            Object(lib.B)() || Object(beaver_logger_client.k)("button_authorize_ineligible"), 
                            Object(lib.d)("authorize"), Object(beaver_logger_client.h)();
                            var restart = actions.restart;
                            actions.restart = function() {
                                return restart().then(function() {
                                    return new zalgo_promise_src.a();
                                });
                            }, actions.redirect = function(win, url) {
                                return zalgo_promise_src.a.try(function() {
                                    if (actions.close) return actions.close();
                                }).then(function() {
                                    return Object(lib.P)(win || window.top, url || data.returnUrl);
                                });
                            }, actions.payment.tokenize = Object(lib.I)(function() {
                                if (!_this3.props.braintree) throw new Error("Must pass in Braintree client to tokenize payment");
                                return _this3.props.braintree.then(function(client) {
                                    return client.tokenizePayment(data);
                                });
                            });
                            var execute = actions.payment.execute;
                            actions.payment.execute = function() {
                                return execute().then(function(result) {
                                    return result && result.id && result.intent && result.state ? result : (Object(beaver_logger_client.q)("execute_result_missing_data"), 
                                    new zalgo_promise_src.a());
                                });
                            };
                            var _creditThrottle$logCo, get = actions.payment.get;
                            return actions.payment.get = function() {
                                return get().then(function(result) {
                                    return result && result.id && result.intent && result.state ? result : (Object(beaver_logger_client.q)("get_result_missing_data"), 
                                    new zalgo_promise_src.a());
                                });
                            }, actions.request = lib.R, onAuthorizeListener.trigger({
                                paymentToken: data.paymentToken
                            }), creditThrottle && creditThrottle.logComplete(((_creditThrottle$logCo = {})[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _creditThrottle$logCo)), zalgo_promise_src.a.try(function() {
                                if (_this3.props.braintree) return actions.payment.tokenize().then(function(_ref4) {
                                    var nonce = _ref4.nonce;
                                    Object.defineProperty(data, "nonce", {
                                        get: function() {
                                            return Object(beaver_logger_client.k)("nonce_getter"), Object(beaver_logger_client.h)(), 
                                            nonce;
                                        }
                                    });
                                });
                            }).then(function() {
                                return original.call(_this3, data, actions);
                            }).catch(function(err) {
                                if (_this3.props.onError) return _this3.props.onError(err);
                                throw err;
                            });
                        };
                    }
                },
                onShippingChange: {
                    type: "function",
                    required: !1,
                    decorate: function(original) {
                        if (original) return function(data, actions) {
                            var _track6, _this4 = this;
                            Object(beaver_logger_client.k)("button_shipping_change"), Object(beaver_logger_client.p)(((_track6 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track6[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_SHIPPING_CHANGE, 
                            _track6[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track6)), 
                            Object(beaver_logger_client.h)();
                            var patch = actions.payment.patch;
                            actions.payment.patch = function(patchObject) {
                                return zalgo_promise_src.a.try(function() {
                                    return patch(patchObject);
                                });
                            };
                            var resolve = function() {
                                return zalgo_promise_src.a.resolve();
                            }, reject = actions.reject || function() {
                                throw new Error("Missing reject action callback");
                            };
                            return zalgo_promise_src.a.try(function() {
                                return original.call(_this4, data, Object(esm_extends.a)({}, actions, {
                                    resolve: resolve,
                                    reject: reject
                                }));
                            }).timeout(1e4, new Error("Timed out waiting 10000ms for payment")).catch(function(err) {
                                throw _this4.props.onError && _this4.props.onError(err), err;
                            });
                        };
                    }
                },
                onError: {
                    type: "function",
                    required: !1,
                    promisify: !0,
                    sendToChild: !0,
                    once: !0,
                    def: function() {
                        return function(err) {
                            Object(lib.E)() && (Object(beaver_logger_client.q)("button_error_intranet_mode"), 
                            Object(beaver_logger_client.h)(), alert("IE Intranet mode is not supported by PayPal. Please disable intranet mode, or continue in an alternate browser.")), 
                            setTimeout(function() {
                                throw err;
                            });
                        };
                    }
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _track7;
                            return Object(beaver_logger_client.k)("button_cancel"), Object(beaver_logger_client.p)(((_track7 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track7[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_CANCEL, _track7[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _track7)), Object(beaver_logger_client.h)(), original.call(this, data, Object(esm_extends.a)({}, actions, {
                                redirect: function(win, url) {
                                    return zalgo_promise_src.a.all([ Object(lib.P)(win || window.top, url || data.cancelUrl), actions.close() ]);
                                }
                            }));
                        };
                    }
                },
                onClick: {
                    type: "function",
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function(data) {
                            var _track8, _track9, _creditThrottle$log;
                            Object(beaver_logger_client.k)("button_click"), Object(beaver_logger_client.p)(((_track8 = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                            _track8[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, _track8[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                            _track8[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track8[constants.u.KEY.CHOSEN_FUNDING] = data && (data.card || data.fundingSource), 
                            _track8)), Object(lib.E)() && (Object(beaver_logger_client.q)("button_click_intranet_mode"), 
                            Object(beaver_logger_client.p)(((_track9 = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                            _track9[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK_INTRANET_MODE, 
                            _track9[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, _track9[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _track9[constants.u.KEY.CHOSEN_FUNDING] = data && (data.card || data.fundingSource), 
                            _track9))), creditThrottle && creditThrottle.log("click", ((_creditThrottle$log = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                            _creditThrottle$log[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, 
                            _creditThrottle$log[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _creditThrottle$log));
                            var _ref5 = this.props.style || {}, _ref5$color = _ref5.color, color = void 0 === _ref5$color ? "default" : _ref5$color;
                            return Object(beaver_logger_client.k)("button_click_color_" + color), Object(beaver_logger_client.h)(), 
                            original.apply(this, arguments);
                        };
                    }
                },
                onResize: {
                    type: "function",
                    required: !1,
                    get value() {
                        var initialHeight, logInlineGuestOutOfViewPortOnlyOnce = Object(src_lib.H)(function(data) {
                            Object(beaver_logger_client.k)("buttons_expansion_outside_viewport", data), Object(beaver_logger_client.j)();
                        });
                        return function() {
                            var container = this.container;
                            initialHeight || (initialHeight = container.offsetHeight);
                            var isContainerExpanded = container && container.offsetHeight > initialHeight, isExpansionInViewport = function() {
                                try {
                                    var scrollOffsetY = window.pageYOffset ? window.pageYOffset : document.documentElement ? document.documentElement.scrollTop : 0, windowHeight = window.innerHeight, containerOffsetY = container.getBoundingClientRect().top;
                                    return scrollOffsetY + windowHeight > initialHeight + containerOffsetY + 200;
                                } catch (err) {
                                    return Object(beaver_logger_client.k)("cannot_get_the_viewport_information"), !1;
                                }
                            }();
                            isContainerExpanded && !isExpansionInViewport && logInlineGuestOutOfViewPortOnlyOnce({
                                height: container.offsetHeight,
                                window: {
                                    width: window.innerWidth,
                                    height: window.innerHeight
                                }
                            });
                        };
                    },
                    decorate: function(original) {
                        return Object(src_lib.i)(original);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    },
                    validate: validateButtonLocale
                },
                style: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    alias: "buttonStyle",
                    def: function() {
                        return {
                            color: constants.e.GOLD,
                            shape: constants.k.PILL,
                            size: constants.l.SMALL,
                            label: constants.f.CHECKOUT,
                            fundingicons: !1
                        };
                    },
                    validate: function(style, props) {
                        void 0 === style && (style = {}), validateButtonStyle(style, props), Object(beaver_logger_client.h)();
                    }
                },
                validate: {
                    type: "function",
                    required: !1,
                    decorate: function(validate) {
                        return function(actions) {
                            if (!this.validateCalled) return this.validateCalled = !0, validate(actions);
                        };
                    }
                },
                logLevel: {
                    type: "string",
                    required: !1,
                    get value() {
                        return config.a.logLevel;
                    }
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                },
                awaitPopupBridge: {
                    type: "object",
                    required: !1,
                    value: function() {
                        return awaitPopupBridge(component_Button);
                    }
                },
                test: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {
                            action: "checkout"
                        };
                    }
                }
            }
        });
        component_Button.isChild() && function(ButtonComponent) {
            !function(Checkout, Button) {
                var popupBridge;
                function doRender(props, original) {
                    return popupBridge ? function(props, popupBridge) {
                        return zalgo_promise_src.a.try(function() {
                            !function(props) {
                                if (!props.payment) throw new Error("Expected props.payment to be passed");
                                if (!props.onAuthorize) throw new Error("Expected props.onAuthorize to be passed");
                                if (props.env && !config.a.checkoutUrls[props.env]) throw new Error("Invalid props.env: " + props.env);
                            }(props);
                        }).then(function() {
                            return function(props) {
                                var _normalizeCheckoutPro = normalizeCheckoutProps(props), env = _normalizeCheckoutPro.env;
                                return zalgo_promise_src.a.try(_normalizeCheckoutPro.payment, {
                                    props: props
                                }).then(function(token) {
                                    var _extendUrl;
                                    if (!token) throw new Error("Expected props.payment to return a payment id or token");
                                    return Object(lib.g)(Object(integrations_checkout.b)(env, constants.v.PAYPAL, token), ((_extendUrl = {})[Object(integrations_checkout.a)(token)] = token, 
                                    _extendUrl.useraction = props.commit ? "commit" : "", _extendUrl.native_xo = "1", 
                                    _extendUrl));
                                });
                            }(props);
                        }).then(function(url) {
                            return popupBridge.open(url);
                        }).then(function(payload) {
                            var opType = payload.queryItems.opType, _normalizeCheckoutPro2 = normalizeCheckoutProps(props), onAuthorize = _normalizeCheckoutPro2.onAuthorize, onCancel = _normalizeCheckoutPro2.onCancel, data = function(query) {
                                var data = {
                                    paymentToken: query.token,
                                    billingToken: query.ba_token,
                                    paymentID: query.paymentId,
                                    payerID: query.PayerID,
                                    intent: query.intent
                                }, opType = query.opType, cancel_uri = query.cancel_uri;
                                return opType === OPTYPE.PAYMENT ? data.returnUrl = query.return_uri : opType === OPTYPE.CANCEL && (data.cancelUrl = cancel_uri), 
                                data;
                            }(payload.queryItems), actions = function(query) {
                                var actions = {
                                    close: src_lib.F,
                                    closeComponent: src_lib.F
                                }, opType = query.opType, return_uri = query.return_uri, cancel_uri = query.cancel_uri;
                                return opType === OPTYPE.PAYMENT ? actions.redirect = function(win, redirectUrl) {
                                    return void 0 === win && (win = window), void 0 === redirectUrl && (redirectUrl = return_uri), 
                                    Object(lib.P)(win, redirectUrl);
                                } : opType === OPTYPE.CANCEL && (actions.redirect = function(win, redirectUrl) {
                                    return void 0 === win && (win = window), void 0 === redirectUrl && (redirectUrl = cancel_uri), 
                                    Object(lib.P)(win, redirectUrl);
                                }), actions;
                            }(payload.queryItems);
                            if (opType === OPTYPE.PAYMENT) return onAuthorize(data, actions);
                            if (opType === OPTYPE.CANCEL) return onCancel(data, actions);
                            throw new Error("Invalid opType: " + opType);
                        }).catch(function(err) {
                            if (err && err.code === CONTINGENCY.PAYMENT_CANCELLED) return (0, normalizeCheckoutProps(props).onCancel)({}, {});
                            throw err;
                        });
                    }(props, popupBridge).catch(function(err) {
                        return Object(beaver_logger_client.g)("popup_bridge_error", {
                            err: Object(lib.U)(err)
                        }), original();
                    }) : original();
                }
                awaitPopupBridge(ButtonComponent).then(function(bridge) {
                    popupBridge = bridge;
                });
                var render = Checkout.render;
                Checkout.render = function(props) {
                    var _this = this, _arguments = arguments;
                    return doRender(props, function() {
                        return render.apply(_this, _arguments);
                    });
                };
                var renderTo = Checkout.renderTo;
                Checkout.renderTo = function(win, props) {
                    var _this2 = this, _arguments2 = arguments;
                    return doRender(props, function() {
                        return renderTo.apply(_this2, _arguments2);
                    });
                };
                var renderPopupTo = Checkout.renderPopupTo;
                Checkout.renderPopupTo = function(win, props) {
                    var _this3 = this, _arguments3 = arguments;
                    return doRender(props, function() {
                        return renderPopupTo.apply(_this3, _arguments3);
                    });
                };
            }(src_checkout.a), Object(lib.p)().then(function(pageRenderTime) {
                var _track, fundingSources = [].slice.call(document.querySelectorAll("[" + constants.c.FUNDING_SOURCE + "]")).map(function(el) {
                    return el.getAttribute(constants.c.CARD) || el.getAttribute(constants.c.FUNDING_SOURCE);
                }).filter(function(source) {
                    return source && source !== constants.v.CARD;
                }), xprops = ButtonComponent.xprops;
                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_LOAD, _track[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                _track[constants.u.KEY.FUNDING_LIST] = fundingSources.join(":"), _track[constants.u.KEY.FUNDING_COUNT] = fundingSources.length, 
                _track[constants.u.KEY.PAGE_LOAD_TIME] = pageRenderTime, _track[constants.u.KEY.BUTTON_LAYOUT] = xprops && xprops.style && xprops.style.layout || constants.g.HORIZONTAL, 
                _track[constants.u.KEY.BUTTON_COLOR] = xprops && xprops.style && xprops.style.color || constants.e.GOLD, 
                _track[constants.u.KEY.BUTTON_SIZE] = xprops && xprops.style && xprops.style.size || constants.l.SMALL, 
                _track[constants.u.KEY.BUTTON_SHAPE] = xprops && xprops.style && xprops.style.shape || constants.k.PILL, 
                _track[constants.u.KEY.BUTTON_LABEL] = xprops && xprops.style && xprops.style.label || constants.f.CHECKOUT, 
                _track[constants.u.KEY.BUTTON_WIDTH] = window.innerWidth, _track[constants.u.KEY.MAX_BUTTONS] = xprops && xprops.style && xprops.style.maxbuttons, 
                _track)), Object(beaver_logger_client.h)();
            });
            var xprops = ButtonComponent.xprops || src_checkout.a.xprops;
            xprops && xprops.logLevel && Object(lib.T)(xprops.logLevel);
            try {
                xprops && xprops.onShippingChange && window.pre && window.pre.inlineGuest && window.pre.inlineGuest.res && window.pre.inlineGuest.res.data && window.pre.inlineGuest.res.data.treatments && (window.pre.inlineGuest.res.data.treatments = []);
            } catch (err) {}
        }(component_Button), Object(lib.D)() && Object(lib.m)("ie_full_page") && (src_checkout.a.renderTo = function(win) {
            Object(beaver_logger_client.k)("force_ie_full_page"), Object(beaver_logger_client.h)();
            var checkout = src_checkout.a.init({
                onAuthorize: lib.J
            });
            checkout.delegate(win), checkout.openContainer().then(function() {
                checkout.event.triggerOnce(src.a.EVENTS.CLOSE), checkout.showContainer();
            }), component_Button.xprops.payment().then(function(token) {
                window.top.location = Object(lib.g)(config.a.checkoutUrl, {
                    token: token
                });
            }).catch(function(err) {
                checkout.error(err);
            });
        });
        var hacks_parent = Object(cross_domain_utils_src.m)(window), hacks_top = Object(cross_domain_utils_src.n)(window);
        if (hacks_top && hacks_parent) {
            var canRenderTop = hacks_top === hacks_parent;
            canRenderTop || (src_checkout.a.canRenderTo(hacks_top).then(function(result) {
                canRenderTop = result;
            }), Object(lib.N)(src_checkout.a, "renderTo", function(_ref) {
                var _ref$args = _ref.args, win = _ref$args[0], props = _ref$args[1], el = _ref$args[2], original = _ref.original, context = _ref.context;
                return canRenderTop || (win = Object(cross_domain_utils_src.m)(window)), original.call(context, win, props, el);
            }));
        }
        Object(lib.N)(src_checkout.a, "renderTo", function(_ref2) {
            var callOriginal = _ref2.callOriginal, props = _ref2.args[1];
            if (Object(lib.m)("allow_full_page_fallback")) {
                var handleError = Object(lib.L)(function(err) {
                    try {
                        console.error(err && err.stack);
                    } catch (err2) {}
                    return component_Button.xprops.payment().then(function(token) {
                        window.top.location = Object(lib.g)(config.a.checkoutUrl, {
                            token: token
                        });
                    });
                });
                return props.onError = handleError, callOriginal().catch(handleError);
            }
            return callOriginal();
        });
        var debounce = !1;
        Object(lib.N)(src_checkout.a, "renderTo", function(_ref3) {
            var callOriginal = _ref3.callOriginal, props = _ref3.args[1];
            if (debounce) return Object(beaver_logger_client.q)("button_mutliple_click_debounce"), 
            new zalgo_promise_src.a(lib.J);
            debounce = !0;
            for (var _loop = function(_i2, _ref5) {
                var methodName = _ref5[_i2], original = props[methodName];
                props[methodName] = function() {
                    if (debounce = !1, original) return original.apply(this, arguments);
                };
            }, _i2 = 0, _ref5 = [ "onAuthorize", "onCancel", "onError", "onClose" ]; _i2 < _ref5.length; _i2++) _loop(_i2, _ref5);
            return callOriginal();
        }), Object(lib.N)(rest.payment, "create", function(_ref6) {
            var _ref6$args = _ref6.args, options = _ref6$args[2];
            return options.payment || (options = {
                payment: options,
                experience: _ref6$args[3]
            }), _ref6.original.call(_ref6.context, _ref6$args[0], _ref6$args[1], options);
        }), Object(lib.N)(component_Button.props.style, "validate", function(_ref7) {
            var callOriginal = _ref7.callOriginal, style = _ref7.args[0];
            return style ? (style && "creditblue" === style.color && (style.color = constants.e.DARKBLUE), 
            style && "generic" === style.label && (style.label = constants.f.PAYPAL), !style || style.label && style.label !== constants.f.CHECKOUT || "tiny" !== style.size || (Object(beaver_logger_client.q)("unsupported_button_size_tiny"), 
            style.size = constants.l.SMALL), callOriginal()) : callOriginal();
        }), Object(lib.N)(component_Button, "render", function(_ref8) {
            var callOriginal = _ref8.callOriginal, props = _ref8.args[0];
            return props.billingAgreement && (props.payment = props.billingAgreement, delete props.billingAgreement), 
            callOriginal();
        }), Object(lib.N)(component_Button.props.payment, "decorate", function(_ref9) {
            var originalPayment = _ref9.args[0];
            return _ref9.original.call(_ref9.context, function(data, actions) {
                var _this = this;
                return new zalgo_promise_src.a(function(resolve, reject) {
                    function resolveData(token) {
                        resolve(token);
                    }
                    function rejectActions(err) {
                        reject(err);
                    }
                    Object(lib.N)(actions.payment, "create", function(_ref10) {
                        var _ref10$args = _ref10.args, options = _ref10$args[0];
                        return options.payment || (options = {
                            payment: options,
                            experience: _ref10$args[1]
                        }), _ref10.original.call(_ref10.context, options);
                    }), Object(lib.f)(resolveData, data), Object(lib.f)(resolveData, actions), Object(lib.f)(rejectActions, actions);
                    var result, ctx = {
                        props: {
                            env: _this.props.env,
                            client: _this.props.client
                        }
                    };
                    try {
                        result = originalPayment.call(ctx, resolveData, rejectActions);
                    } catch (err) {
                        return reject(err);
                    }
                    return result && "function" == typeof result.then ? result.then(resolve, reject) : void 0 !== result ? resolve(result) : void 0;
                });
            });
        }), component_Button.isChild() && (window.Promise || (window.Promise = zalgo_promise_src.a));
        var currentDomainEnv, Card = Object(src.c)({
            tag: "card-fields",
            name: "ppcard",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env];
            },
            contexts: {
                iframe: !0,
                popup: !1
            },
            dimensions: {
                height: "300px",
                width: "100%"
            },
            autoResize: {
                height: !0,
                width: !1
            },
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.v)();
                    },
                    queryParam: !0
                },
                token: {
                    type: "string",
                    required: !0,
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.j)();
                    },
                    queryParam: !0
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                initialFormValues: {
                    type: "object",
                    required: !1
                },
                onAuthorize: {
                    type: "function",
                    required: !0,
                    once: !0
                },
                onAuth: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                onEvent: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                getState: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                dispatch: {
                    type: "object",
                    required: !1,
                    sameDomain: !0
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                },
                style: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return {
                            cardIcons: {
                                display: !1
                            },
                            submitButton: {
                                display: !0
                            },
                            currencyConversion: {
                                display: !0
                            }
                        };
                    }
                }
            }
        });
        (currentDomainEnv = function(domain) {
            for (var _i2 = 0, _Object$keys2 = Object.keys(config.a.paypalUrls); _i2 < _Object$keys2.length; _i2++) {
                var env = _Object$keys2[_i2];
                if (config.a.paypalUrls[env] === domain) return env;
            }
        }(window.location.protocol + "//" + window.location.host)) && "test" !== currentDomainEnv && (config.a.env = currentDomainEnv), 
        zalgo_promise_src.a.onPossiblyUnhandledException(function(err) {
            var _track;
            return Object(beaver_logger_client.g)("unhandled_error", {
                stack: Object(lib.U)(err),
                errtype: {}.toString.call(err)
            }), Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.ERROR_CODE] = "checkoutjs_error", 
            _track[constants.u.KEY.ERROR_DESC] = Object(lib.V)(err), _track)), Object(beaver_logger_client.h)().catch(function(err2) {
                if (window.console) try {
                    window.console.error ? window.console.error("Error flushing:", Object(lib.U)(err2)) : window.console.log && window.console.log("Error flushing:", Object(lib.U)(err2));
                } catch (err3) {
                    setTimeout(function() {
                        throw err3;
                    }, 1);
                }
            });
        });
        var currentScript = Object(lib.k)(), currentProtocol = window.location.protocol.split(":")[0], init = Object(lib.L)(function(_ref2) {
            var precacheRemembered = _ref2.precacheRemembered;
            Object(lib.B)() || Object(beaver_logger_client.q)("ineligible"), Object(lib.c)(), 
            Object(lib.y)(), pptm.shouldCreateInitialPptmScript() && pptm.createPptmScript(), 
            precacheRemembered && Object(lib.O)(), Object(lib.m)("force_bridge") && !Object(lib.G)() && Object(lib.M)(config.a.env), 
            Object(beaver_logger_client.k)("setup_" + config.a.env), Object(beaver_logger_client.f)("current_protocol_" + currentProtocol);
        });
        function setup(options) {
            void 0 === options && (options = {}), function(_temp) {
                var _ref = void 0 === options ? {} : options, env = _ref.env, stage = _ref.stage, stageUrl = _ref.stageUrl, apiStage = _ref.apiStage, localhostUrl = _ref.localhostUrl, checkoutUri = _ref.checkoutUri, state = _ref.state, logLevel = _ref.logLevel, merchantID = _ref.merchantID, authCode = _ref.authCode;
                if (env) {
                    if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    delete config.a.env, config.a.env = env;
                } else component_Button.xprops && component_Button.xprops.env ? (delete config.a.env, 
                config.a.env = component_Button.xprops.env) : src_checkout.a.xprops && src_checkout.a.xprops.env && (delete config.a.env, 
                config.a.env = src_checkout.a.xprops.env);
                stage ? (delete config.a.stage, config.a.stage = stage) : component_Button.xprops && component_Button.xprops.stage ? (delete config.a.stage, 
                config.a.stage = component_Button.xprops.stage) : src_checkout.a.xprops && src_checkout.a.xprops.stage && (delete config.a.stage, 
                config.a.stage = src_checkout.a.xprops.stage), stageUrl ? (delete config.a.stageUrl, 
                config.a.stageUrl = stageUrl) : component_Button.xprops && component_Button.xprops.stageUrl ? (delete config.a.stageUrl, 
                config.a.stageUrl = component_Button.xprops.stageUrl) : src_checkout.a.xprops && src_checkout.a.xprops.stageUrl && (delete config.a.stageUrl, 
                config.a.stageUrl = src_checkout.a.xprops.stageUrl), (authCode = authCode || component_Button.xprops && component_Button.xprops.authCode || src_checkout.a.xprops && src_checkout.a.xprops.authCode) && (delete config.a.authCode, 
                config.a.authCode = authCode), apiStage && (delete config.a.apiStage, config.a.apiStage = apiStage), 
                (localhostUrl = localhostUrl || component_Button.xprops && component_Button.xprops.localhostUrl || src_checkout.a.xprops && src_checkout.a.xprops.localhostUrl) && (config.a.localhostUrl = localhostUrl), 
                (checkoutUri = checkoutUri || component_Button.xprops && component_Button.xprops.checkoutUri || src_checkout.a.xprops && src_checkout.a.xprops.checkoutUri) && (config.a.checkoutUri = checkoutUri), 
                state && (delete config.a.state, config.a.state = state), merchantID && (config.a.merchantID = merchantID), 
                logLevel ? Object(lib.T)(logLevel) : Object(lib.T)(config.a.logLevel);
            }(), init(options);
        }
        if (currentScript ? setup({
            env: currentScript.getAttribute("data-env"),
            stage: currentScript.getAttribute("data-stage"),
            apiStage: currentScript.getAttribute("data-api-stage"),
            stageUrl: currentScript.getAttribute("data-stage-url"),
            localhostUrl: Object(lib.G)() ? currentScript.getAttribute("data-localhost-url") : void 0,
            checkoutUri: Object(lib.G)() ? currentScript.getAttribute("data-checkout-uri") : void 0,
            state: currentScript.getAttribute("data-state"),
            logLevel: currentScript.getAttribute("data-log-level"),
            merchantID: currentScript.getAttribute("data-merchant-id"),
            authCode: currentScript.getAttribute("data-auth-code"),
            precacheRemembered: currentScript.hasAttribute("data-precache-remembered-funding")
        }) : setup(), !Object(lib.G)()) if (currentScript) {
            var setup_track2, scriptProtocol = currentScript.src.split(":")[0], loadTime = Object(lib.s)(currentScript.src);
            Object(beaver_logger_client.f)("current_script_protocol_" + scriptProtocol), Object(beaver_logger_client.f)("current_script_protocol_" + (currentProtocol === scriptProtocol ? "match" : "mismatch")), 
            Object(beaver_logger_client.f)("current_script_version_" + config.a.version.replace(/[^0-9a-zA-Z]+/g, "_")), 
            loadTime && (Object(beaver_logger_client.f)("current_script_time", {
                loadTime: loadTime
            }), Object(beaver_logger_client.f)("current_script_time_" + Math.floor(loadTime / 1e3))), 
            Object(beaver_logger_client.p)(((setup_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
            setup_track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.SCRIPT_LOAD, setup_track2[constants.u.KEY.TRANSITION_TIME] = loadTime, 
            setup_track2[constants.u.KEY.FUNDING_REMEMBERED] = Object(lib.r)().join(","), setup_track2));
            try {
                var applePay = "unavailable", paymentRequest = "unavailable";
                window.ApplePaySession && window.ApplePaySession.canMakePayments && window.ApplePaySession.canMakePayments() && (applePay = "available"), 
                window.PaymentRequest && (paymentRequest = "available"), zalgo_promise_src.a.try(function() {
                    return !!window.PaymentRequest && new window.PaymentRequest([ {
                        supportedMethods: "basic-card"
                    } ], {
                        total: {
                            label: "Total",
                            amount: {
                                currency: "USD",
                                value: "1.00"
                            }
                        }
                    }).canMakePayment();
                }).catch(function() {
                    return !1;
                }).then(function(result) {
                    result && (paymentRequest = "available_with_funding_sources"), Object(beaver_logger_client.p)({
                        apple_pay: applePay,
                        payment_request_api: paymentRequest
                    }), Object(beaver_logger_client.k)("apple_pay_" + applePay), Object(beaver_logger_client.k)("payment_request_" + paymentRequest), 
                    Object(beaver_logger_client.h)();
                }).catch(lib.J);
            } catch (err) {}
        } else {
            var setup_track3;
            Object(beaver_logger_client.f)("no_current_script"), Object(beaver_logger_client.f)("no_current_script_version_" + config.a.version.replace(/[^0-9a-zA-Z]+/g, "_")), 
            document.currentScript && Object(beaver_logger_client.f)("current_script_not_recognized", {
                src: document.currentScript.src
            }), Object(beaver_logger_client.p)(((setup_track3 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
            setup_track3[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.SCRIPT_LOAD, setup_track3));
        }
        var interface_checkout, apps, interface_Checkout, interface_BillingPage, PayPalCheckout, destroyAll, enableCheckoutIframe, logger, interface_ThreeDomainSecure, postRobot = post_robot_src, onPossiblyUnhandledException = zalgo_promise_src.a.onPossiblyUnhandledException, interface_version = "4.0.282", legacy = __webpack_require__(59);
        interface_checkout = legacy.checkout, apps = legacy.apps, Object(lib.G)() && (interface_Checkout = src_checkout.a, 
        interface_BillingPage = BillingPage, interface_ThreeDomainSecure = ThreeDomainSecure, 
        PayPalCheckout = src_checkout.a, enableCheckoutIframe = function() {
            src_checkout.a.contexts.iframe = !0;
        }, destroyAll = src.d, logger = {
            debug: beaver_logger_client.f,
            info: beaver_logger_client.k,
            warn: beaver_logger_client.q,
            error: beaver_logger_client.g,
            track: beaver_logger_client.p,
            flush: beaver_logger_client.h
        }), __webpack_require__.d(__webpack_exports__, "postRobot", function() {
            return postRobot;
        }), __webpack_require__.d(__webpack_exports__, "Promise", function() {
            return zalgo_promise_src.a;
        }), __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() {
            return src.b;
        }), __webpack_require__.d(__webpack_exports__, "rest", function() {
            return rest;
        }), __webpack_require__.d(__webpack_exports__, "Button", function() {
            return component_Button;
        }), __webpack_require__.d(__webpack_exports__, "Card", function() {
            return Card;
        }), __webpack_require__.d(__webpack_exports__, "setup", function() {
            return setup;
        }), __webpack_require__.d(__webpack_exports__, "config", function() {
            return config.a;
        }), __webpack_require__.d(__webpack_exports__, "ENV", function() {
            return constants.t;
        }), __webpack_require__.d(__webpack_exports__, "USERS", function() {
            return constants.F;
        }), __webpack_require__.d(__webpack_exports__, "SOURCE", function() {
            return constants.E;
        }), __webpack_require__.d(__webpack_exports__, "FUNDING", function() {
            return constants.v;
        }), __webpack_require__.d(__webpack_exports__, "CARD", function() {
            return constants.o;
        }), __webpack_require__.d(__webpack_exports__, "request", function() {
            return lib.R;
        }), __webpack_require__.d(__webpack_exports__, "isEligible", function() {
            return lib.B;
        }), __webpack_require__.d(__webpack_exports__, "isFundingRemembered", function() {
            return lib.C;
        }), __webpack_require__.d(__webpack_exports__, "forceIframe", function() {
            return lib.a;
        }), __webpack_require__.d(__webpack_exports__, "isWebView", function() {
            return lib.a;
        }), __webpack_require__.d(__webpack_exports__, "allowIframe", function() {
            return lib.a;
        }), __webpack_require__.d(__webpack_exports__, "logExperimentTreatment", function() {
            return logExperimentTreatment;
        }), __webpack_require__.d(__webpack_exports__, "logFundingEligibility", function() {
            return logFundingEligibility;
        }), __webpack_require__.d(__webpack_exports__, "onPossiblyUnhandledException", function() {
            return onPossiblyUnhandledException;
        }), __webpack_require__.d(__webpack_exports__, "version", function() {
            return interface_version;
        }), __webpack_require__.d(__webpack_exports__, "checkout", function() {
            return interface_checkout;
        }), __webpack_require__.d(__webpack_exports__, "apps", function() {
            return apps;
        }), __webpack_require__.d(__webpack_exports__, "Checkout", function() {
            return interface_Checkout;
        }), __webpack_require__.d(__webpack_exports__, "BillingPage", function() {
            return interface_BillingPage;
        }), __webpack_require__.d(__webpack_exports__, "PayPalCheckout", function() {
            return PayPalCheckout;
        }), __webpack_require__.d(__webpack_exports__, "destroyAll", function() {
            return destroyAll;
        }), __webpack_require__.d(__webpack_exports__, "enableCheckoutIframe", function() {
            return enableCheckoutIframe;
        }), __webpack_require__.d(__webpack_exports__, "logger", function() {
            return logger;
        }), __webpack_require__.d(__webpack_exports__, "ThreeDomainSecure", function() {
            return interface_ThreeDomainSecure;
        }), __webpack_exports__.default = interface_namespaceObject;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var client = __webpack_require__(4), lib = __webpack_require__(2), constants = __webpack_require__(0), LOG_PREFIX = "paypal_legacy", ATTRIBUTES = {
            BUTTON: "data-paypal-button",
            MERCHANT_ID: "data-paypal-id",
            ENV: "data-env",
            SANDBOX: "data-sandbox"
        }, CLASSES = {
            HIDDEN_BUTTON: "paypal-button-hidden"
        }, esm_extends = __webpack_require__(11), src = __webpack_require__(1), checkout = __webpack_require__(15), config = __webpack_require__(3), post_robot_src = __webpack_require__(13);
        function isLegacyEligible() {
            return !!Object(lib.B)() && !!Object(lib.W)() && !Object(lib.z)();
        }
        var warn = Object(client.n)(LOG_PREFIX).warn, DEFAULT_COUNTRY = constants.r.US, DEFAULT_LANG = constants.x.EN;
        function normalizeLocale(locale) {
            var _locale$split = locale.split("_"), lang = _locale$split[0], country = _locale$split[1];
            return country || (constants.z[lang] ? (country = lang, lang = null) : country = DEFAULT_COUNTRY), 
            constants.z[country] || (warn("invalid_user_country", {
                country: country
            }), country = DEFAULT_COUNTRY), lang || (lang = DEFAULT_LANG), -1 === constants.z[country].indexOf(lang) && (warn("invalid_user_lang", {
                lang: lang
            }), lang = -1 !== constants.z[country].indexOf(DEFAULT_LANG) ? DEFAULT_LANG : constants.z[country][0]), 
            {
                country: country,
                lang: lang
            };
        }
        var button_prefix = Object(client.n)(LOG_PREFIX), info = button_prefix.info, debug = button_prefix.debug, error = button_prefix.error, loadButtonJS = Object(lib.I)(function() {
            return debug("buttonjs_load"), Object(lib.H)(config.a.buttonJSUrl).catch(function(err) {
                return info("buttonjs_load_error_retry", {
                    error: Object(lib.U)(err)
                }), Object(lib.H)(config.a.buttonJSUrl);
            }).then(function(result) {
                return debug("buttonjs_load_success"), result;
            }).catch(function(err) {
                throw error("buttonjs_load_error", {
                    error: Object(lib.U)(err)
                }), err;
            });
        });
        function renderButtons(id, buttons) {
            return src.a.map(buttons, function(button) {
                return src.a.try(function() {
                    return button.container ? function(id, _ref) {
                        var container = button.container, locale = button.locale, type = button.type, color = button.color, shape = button.shape, size = button.size;
                        return loadButtonJS().then(function() {
                            if (locale) {
                                var _normalizeLocale = normalizeLocale(locale);
                                locale = _normalizeLocale.lang + "_" + _normalizeLocale.country;
                            }
                            color = color || constants.e.GOLD, shape = shape || constants.k.PILL, size = size || constants.l.SMALL, 
                            type = type || constants.f.CHECKOUT, debug("render_button_lc_" + (locale = locale || config.a.locale.lang + "_" + config.a.locale.country)), 
                            debug("render_button_color_" + color), debug("render_button_shape_" + shape), debug("render_button_size_" + size), 
                            debug("render_button_label_" + type);
                            var el = window.paypal.button.create(id, {
                                lc: locale,
                                color: color,
                                shape: shape,
                                size: size
                            }, {
                                type: "button",
                                label: type
                            }).el;
                            container.appendChild(el);
                            try {
                                info("in_page_button_" + (Object(lib.A)(el) ? "visible" : "not_visible"));
                            } catch (err) {}
                            return el.childNodes[0];
                        });
                    }(id) : button.button;
                }).then(function(element) {
                    var container, type;
                    return button.container ? (container = button.container, type = constants.u.BUTTON_TYPE.HTML) : (container = button.button, 
                    type = constants.u.BUTTON_TYPE.CUSTOM), {
                        container: container,
                        element: element,
                        type: type,
                        condition: button.condition,
                        click: button.click
                    };
                });
            });
        }
        function getHijackTargetElement(button) {
            var form = button.form;
            if (form) return debug("target_element_button_form"), form;
            var tagName = button.tagName && button.tagName.toLowerCase();
            if ("a" === tagName) return debug("target_element_link"), button;
            var parentElement = button.parentElement, parentTagName = parentElement && parentElement.tagName && parentElement.tagName.toLowerCase();
            if (("img" === tagName || "button" === tagName) && "a" === parentTagName) return debug("target_element_parent_link"), 
            parentElement;
            var grandparentElement = parentElement && parentElement.parentElement, grandparentTagName = grandparentElement && grandparentElement.tagName && grandparentElement.tagName.toLowerCase();
            return "button" === tagName && "a" === grandparentTagName ? (debug("target_element_grandparent_link"), 
            button.parentElement && button.parentElement.parentElement) : void 0;
        }
        var util_warn = Object(client.n)(LOG_PREFIX).warn, redirected = !1;
        function logRedirect(location) {
            redirected && util_warn("multiple_redirects"), Object(lib.Y)(location) && (redirected = !0), 
            Object(client.h)();
        }
        function redirect(url) {
            return src.a.try(function() {
                if (!url) throw new Error("Redirect url undefined");
                return config.a.env === constants.t.TEST && Object(lib.Y)(url) ? Object(lib.P)(window, "#fullpageRedirect?url=" + url) : (logRedirect(url), 
                Object(lib.P)(window, url));
            });
        }
        var options_prefix = Object(client.n)(LOG_PREFIX), options_info = options_prefix.info, options_warn = options_prefix.warn, interface_prefix = Object(client.n)(LOG_PREFIX), interface_info = interface_prefix.info, interface_debug = interface_prefix.debug, interface_warn = interface_prefix.warn, interface_error = interface_prefix.error, track = interface_prefix.track, interface_checkout = {}, apps = {
            checkout: interface_checkout,
            Checkout: interface_checkout
        };
        function interface_reset() {
            interface_debug("reset"), interface_checkout.initXO = initXO, interface_checkout.startFlow = startFlow, 
            interface_checkout.closeFlow = closeFlow;
        }
        function matchUrlAndPaymentToken(item) {
            if (!item || !item.trim()) throw interface_error("startflow_no_url_or_token", {
                item: item
            }), new Error("startflow_no_url_or_token");
            var paymentToken = function(token) {
                if (token) {
                    if ((token = decodeURIComponent(decodeURIComponent(token))).match(/^(EC-)?[A-Z0-9]{17}$/)) return token;
                    var match = token.match(/token=((EC-)?[A-Z0-9]{17})/);
                    return match ? match[1] : (match = token.match(/(EC-[A-Z0-9]{17})/)) ? match[1] : void 0;
                }
            }(item), url = paymentToken && paymentToken === item ? "" : item;
            if (url) url.match(/^https?:\/\/|^\//) ? paymentToken ? -1 !== url.indexOf(".paypal.com") ? interface_debug("startflow_paypalurl_with_token", {
                url: url
            }) : interface_debug("startflow_url_with_token", {
                url: url
            }) : interface_debug("startflow_url_no_token", {
                url: url
            }) : (interface_info(paymentToken ? "startflow_relative_url_with_token" : "startflow_relative_url_no_token", {
                url: url
            }), 0 === url.toLowerCase().indexOf("ec-") && paymentToken && (url = "" + config.a.checkoutUrl + url)); else {
                if (!paymentToken) throw interface_error("startflow_no_url_or_token", {
                    url: url
                }), new Error('Could not determine url or token from "' + item + '"');
                url = Object(lib.g)(config.a.checkoutUrl, {
                    token: paymentToken
                }), interface_debug("startflow_with_token", {
                    url: url
                });
            }
            return {
                paymentToken: paymentToken,
                url: url
            };
        }
        function checkUrlAgainstEnv(url) {
            for (var paypalUrls = config.a.paypalUrls, _i2 = 0, _Object$keys2 = Object.keys(paypalUrls); _i2 < _Object$keys2.length; _i2++) {
                var env = _Object$keys2[_i2], paypalUrl = paypalUrls[env];
                if (env !== constants.t.TEST && env !== constants.t.DEMO && env !== config.a.env && (0 === url.indexOf(paypalUrl) || 0 === url.indexOf(paypalUrl.replace("//www.", "//")))) throw interface_warn("mismatched_env_startflow_url", {
                    env: config.a.env,
                    url: url
                }), redirect(url), new Error(url + " is not a " + config.a.env + " url");
            }
        }
        function awaitPaymentTokenAndUrl() {
            var paymentTokenAndUrl = new src.a(function(resolve) {
                interface_checkout.initXO = function() {
                    interface_warn("gettoken_initxo");
                }, interface_checkout.startFlow = Object(lib.L)(function(item) {
                    interface_debug("gettoken_startflow", {
                        item: item
                    });
                    var _matchUrlAndPaymentTo = matchUrlAndPaymentToken(item), url = _matchUrlAndPaymentTo.url, paymentToken = _matchUrlAndPaymentTo.paymentToken;
                    return checkUrlAgainstEnv(url), resolve({
                        url: url,
                        paymentToken: paymentToken
                    });
                });
            });
            return {
                url: paymentTokenAndUrl.then(function(result) {
                    return result.url;
                }),
                paymentToken: paymentTokenAndUrl.then(function(result) {
                    return result.paymentToken;
                })
            };
        }
        interface_checkout.reset = interface_reset, Object.defineProperty(interface_checkout, "urlPrefix", {
            get: function() {
                return config.a.checkoutUrl + (-1 === config.a.checkoutUrl.indexOf("?") ? "?" : "&") + "token=";
            }
        });
        var paypalCheckoutInited = !1, closeFlowCalled = !1;
        function initPayPalCheckout(props) {
            void 0 === props && (props = {}), interface_info("init_checkout"), paypalCheckoutInited && config.a.env !== constants.t.TEST && interface_warn("multiple_init_paypal_checkout"), 
            closeFlowCalled && interface_debug("init_after_closeflow"), paypalCheckoutInited = !0;
            var paypalCheckout = checkout.a.init(Object(esm_extends.a)({
                onAuthorize: function(data, actions) {
                    return interface_info("payment_authorized"), logRedirect(data.returnUrl), actions.redirect(window);
                },
                onCancel: function(data, actions) {
                    if (data.cancelUrl) return interface_info("payment_canceled"), logRedirect(data.cancelUrl), 
                    actions.redirect(window);
                },
                fallback: function(url) {
                    return interface_error("fallback_handler", {
                        url: url
                    }), this.destroy(), redirect(url);
                }
            }, props));
            return interface_checkout.closeFlow = function(closeUrl) {
                if (interface_warn("closeflow"), closeFlowCalled = !0, interface_reset(), paypalCheckout.destroy(), 
                closeUrl) return interface_warn("closeflow_with_url", {
                    closeUrl: closeUrl
                }), redirect(closeUrl);
            }, paypalCheckout;
        }
        function renderPayPalCheckout(props, hijackTarget) {
            void 0 === props && (props = {});
            var paypalCheckout, urlProp = src.a.resolve(props.url), paymentToken = new src.a(function(resolve) {
                props.init = function(data) {
                    resolve(data.paymentToken);
                };
            }), errorHandler = Object(lib.L)(function(err) {
                interface_error("component_error", {
                    error: Object(lib.U)(err)
                }), hijackTarget && (interface_warn("render_error_hijack_revert_target"), hijackTarget.removeAttribute("target")), 
                urlProp.then(function(url) {
                    return interface_warn("render_error_redirect_using_url"), redirect(url);
                }), paymentToken.then(function(token) {
                    return interface_warn("render_error_redirect_using_token"), redirect(Object(lib.g)(config.a.checkoutUrl, {
                        token: token
                    }));
                });
            });
            props.onError = errorHandler, hijackTarget ? (delete props.url, (paypalCheckout = initPayPalCheckout(props)).hijack(hijackTarget), 
            paypalCheckout.runTimeout(), urlProp.then(function(url) {
                interface_warn("hijack_then_url_passed"), paypalCheckout.loadUrl(url);
            })) : paypalCheckout = initPayPalCheckout(props);
            var render = paypalCheckout.render(null, !hijackTarget);
            return interface_checkout.win = paypalCheckout.window, render.catch(errorHandler);
        }
        function instrumentButtonRender(type) {
            var _track;
            interface_info("render_" + type + "_button"), track(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
            _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_RENDER, _track[constants.u.KEY.BUTTON_TYPE] = type, 
            _track)), Object(client.h)();
        }
        var setupCalled = !1;
        function setup(id, options) {
            var env;
            return void 0 === options && (options = {}), interface_info("setup", {
                id: id = id || "merchant",
                env: options.environment,
                options: Object(lib.S)(options)
            }), setupCalled && interface_debug("setup_called_multiple_times"), setupCalled = !0, 
            function(options) {
                if (options.environment && ("live" === options.environment && (options.environment = constants.t.PRODUCTION), 
                config.a.paypalUrls[options.environment] || (options_warn("invalid_env", {
                    badenv: options.environment
                }), options.environment = config.a.env)), options.button && !Array.isArray(options.button) && (options_info("options_button_single_button_passed"), 
                options.button = [ options.button ]), options.buttons && Object(lib.o)(options.buttons).length && (options_info("options_buttons_with_elements_passed"), 
                options.button = options.buttons, delete options.buttons), options.button && 0 === options.button.length && (options_info("options_button_empty"), 
                delete options.button), options.button && options.container && (options_info("options_button_and_container_passed", {
                    button: options.button,
                    container: options.container
                }), options.button = options.button.concat(options.container), delete options.container), 
                options.button) {
                    var button = Object(lib.o)(options.button);
                    button.length ? options.button = button : (options_warn("options_button_element_not_found", {
                        element: JSON.stringify(options.button)
                    }), delete options.button);
                }
                if (options.button) options.buttons = options.button.map(function(button) {
                    return {
                        button: button,
                        click: options.click,
                        condition: options.condition
                    };
                }), delete options.click, delete options.condition, delete options.button; else if (options.buttons && Array.isArray(options.buttons)) {
                    var buttons = [];
                    options.buttons.forEach(function(button) {
                        button && (button.container && button.container !== options.container && options_warn("mismatched_container_and_button_passed", {
                            options: options.container,
                            button: button.container
                        }), Object(lib.o)(button.container || button.button).forEach(function(element) {
                            var _buttons$push;
                            buttons.push(((_buttons$push = {})[button.container ? "container" : "button"] = element, 
                            _buttons$push.click = button.click || options.click, _buttons$push.condition = button.condition || options.condition, 
                            _buttons$push.type = button.type || options.type, _buttons$push.locale = button.locale || options.locale, 
                            _buttons$push.color = button.color || options.color, _buttons$push.shape = button.shape || options.shape, 
                            _buttons$push.size = button.size || options.size, _buttons$push));
                        }));
                    }), delete options.buttons, delete options.click, delete options.condition, delete options.button, 
                    delete options.type, delete options.locale, delete options.color, delete options.shape, 
                    delete options.size, buttons.length && (options.buttons = buttons);
                } else if (options.container && !Array.isArray(options.buttons)) {
                    var _buttons = [];
                    Object(lib.o)(options.container).forEach(function(container, i) {
                        _buttons.push({
                            container: container,
                            click: options.click,
                            condition: options.condition,
                            type: Array.isArray(options.type) ? options.type[i] : options.type,
                            locale: Array.isArray(options.locale) ? options.locale[i] : options.locale,
                            color: Array.isArray(options.color) ? options.color[i] : options.color,
                            shape: Array.isArray(options.shape) ? options.shape[i] : options.shape,
                            size: Array.isArray(options.size) ? options.size[i] : options.size
                        });
                    }), delete options.container, delete options.buttons, delete options.click, delete options.condition, 
                    delete options.button, delete options.type, delete options.locale, delete options.color, 
                    delete options.shape, delete options.size, _buttons.length && (options.buttons = _buttons);
                }
                options.buttons || (options.buttons = []);
            }(options), function(options) {
                options.environment && config.a.paypalUrls[options.environment] && (config.a.env = options.environment), 
                options.locale && (config.a.locale = normalizeLocale(options.locale), config.a.customCountry = !0);
            }(options), env = config.a.env, src.a.try(function() {
                return post_robot_src.bridge && post_robot_src.bridge.needsBridge({
                    domain: config.a.paypalDomains[env]
                }) ? (Object(client.f)("setup_post_bridge", {
                    env: env
                }), Object(lib.M)(env).then(lib.J)) : Object(client.f)("post_bridge_not_required", {
                    env: env
                });
            }), src.a.try(function() {
                return options.buttons.length ? renderButtons(id, options.buttons).then(function(buttons) {
                    buttons.forEach(function(button) {
                        instrumentButtonRender(button.type), function(container, button, clickHandler, condition, tracker) {
                            var element = "a" === container.tagName.toLowerCase() ? container : button, isClick = "function" == typeof clickHandler;
                            if (element.hasAttribute("data-paypal-click-listener")) return interface_warn("button_already_has_paypal_click_listener");
                            element.setAttribute("data-paypal-click-listener", ""), getHijackTargetElement(element) && isClick && interface_info("button_link_or_form"), 
                            element.addEventListener("click", function(event) {
                                tracker();
                                var eligible = isLegacyEligible();
                                if (Object(lib.W)() ? (interface_debug("click_popups_supported"), eligible || interface_debug("click_popups_supported_but_ineligible")) : (interface_debug("click_popups_not_supported"), 
                                eligible && interface_debug("click_popups_not_supported_but_eligible")), !isClick && !eligible) return interface_debug("ineligible_listenclick");
                                if (interface_info("button_click"), "function" == typeof condition) {
                                    if (!condition.call()) return interface_info("button_click_condition_disabled");
                                    interface_info("button_click_condition_enabled");
                                }
                                return isClick ? function(clickHandler, event) {
                                    interface_debug("button_click_handler");
                                    try {
                                        clickHandler(event);
                                    } catch (err) {
                                        interface_error("click_handler_error", {
                                            error: Object(lib.U)(err)
                                        });
                                    }
                                }(clickHandler, event) : function(element) {
                                    var targetElement = getHijackTargetElement(element);
                                    if (!targetElement) return interface_error("target_element_not_found");
                                    interface_info("init_paypal_checkout_hijack");
                                    var token, _awaitPaymentTokenAnd = awaitPaymentTokenAndUrl(), url = _awaitPaymentTokenAnd.url;
                                    _awaitPaymentTokenAnd.paymentToken.then(function(result) {
                                        token = result;
                                    }), renderPayPalCheckout({
                                        url: url,
                                        payment: function() {
                                            return src.a.resolve(token);
                                        }
                                    }, targetElement);
                                }(element);
                            });
                        }(button.container, button.element, button.click, button.condition, function() {
                            var type, _track2;
                            type = button.type, track(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
                            _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, _track2[constants.u.KEY.BUTTON_TYPE] = type, 
                            _track2)), Object(client.h)();
                        });
                    });
                }) : instrumentButtonRender(constants.u.BUTTON_TYPE.CUSTOM);
            });
        }
        function initXO() {
            if (interface_debug("initxo"), !isLegacyEligible()) return interface_debug("ineligible_initxo");
            var _awaitPaymentTokenAnd2 = awaitPaymentTokenAndUrl(), url = _awaitPaymentTokenAnd2.url, paymentToken = _awaitPaymentTokenAnd2.paymentToken;
            interface_info("init_paypal_checkout_initxo"), renderPayPalCheckout({
                url: url,
                payment: function() {
                    return paymentToken;
                }
            });
        }
        function startFlow(item) {
            interface_debug("startflow", {
                item: item
            });
            var _matchUrlAndPaymentTo2 = matchUrlAndPaymentToken(item), paymentToken = _matchUrlAndPaymentTo2.paymentToken, url = _matchUrlAndPaymentTo2.url;
            if (checkUrlAgainstEnv(url), !isLegacyEligible()) return interface_debug("ineligible_startflow_global", {
                url: url
            }), void redirect(url);
            interface_info("init_paypal_checkout_startflow"), renderPayPalCheckout({
                url: url,
                payment: function() {
                    return src.a.resolve(paymentToken);
                }
            });
        }
        function closeFlow(closeUrl) {
            interface_warn("closeflow_not_opened"), closeUrl && (interface_warn("closeflow_with_url", {
                closeUrl: closeUrl
            }), redirect(closeUrl));
        }
        interface_checkout.setup = setup, interface_checkout.initXO = initXO, interface_checkout.startFlow = startFlow, 
        interface_checkout.closeFlow = closeFlow;
        var ready_prefix = Object(client.n)(LOG_PREFIX), ready_error = ready_prefix.error, ready_debug = ready_prefix.debug;
        !function(obj, key, callback) {
            if (obj) {
                var value = obj[key];
                value && (value = callback(value) || value);
                try {
                    delete obj[key], Object.defineProperty(obj, key, {
                        configurable: !0,
                        set: function(item) {
                            (value = item) && (value = callback(value) || value);
                        },
                        get: function() {
                            return value;
                        }
                    });
                } catch (err) {}
            }
        }(window, "paypalCheckoutReady", function(method) {
            if ("function" == typeof method) {
                var oneTimeReady = function() {
                    if (!method.called) return method.called = !0, method.apply(this, arguments);
                };
                return function(method) {
                    Object(lib.K)(function() {
                        ready_debug("paypal_checkout_ready"), setTimeout(function() {
                            window.paypal || ready_error("paypal_checkout_ready_no_window_paypal"), method();
                        }, 1);
                    });
                }(oneTimeReady), oneTimeReady;
            }
        }), Object(lib.K)(function() {
            var buttons = [].slice.call(document.querySelectorAll("[" + ATTRIBUTES.BUTTON + "]"));
            if (buttons && buttons.length) {
                ready_debug("data_paypal_button", {
                    number: buttons.length
                });
                for (var _i2 = 0; _i2 < buttons.length; _i2++) {
                    var button = buttons[_i2], id = button.getAttribute(ATTRIBUTES.MERCHANT_ID), environment = void 0;
                    button.hasAttribute(ATTRIBUTES.ENV) ? environment = button.getAttribute(ATTRIBUTES.ENV) : button.hasAttribute(ATTRIBUTES.SANDBOX) && (environment = constants.t.SANDBOX), 
                    setup(id, {
                        environment: environment,
                        button: button
                    });
                }
            }
            [].slice.call(document.getElementsByClassName(CLASSES.HIDDEN_BUTTON)).forEach(function(el) {
                el.className = el.className.replace(CLASSES.HIDDEN_BUTTON, "");
            });
        }), __webpack_require__.d(__webpack_exports__, "renderButtons", function() {
            return renderButtons;
        }), __webpack_require__.d(__webpack_exports__, "getHijackTargetElement", function() {
            return getHijackTargetElement;
        }), __webpack_require__.d(__webpack_exports__, "LOG_PREFIX", function() {
            return LOG_PREFIX;
        }), __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", function() {
            return ATTRIBUTES;
        }), __webpack_require__.d(__webpack_exports__, "CLASSES", function() {
            return CLASSES;
        }), __webpack_require__.d(__webpack_exports__, "checkout", function() {
            return interface_checkout;
        }), __webpack_require__.d(__webpack_exports__, "apps", function() {
            return apps;
        }), __webpack_require__.d(__webpack_exports__, "reset", function() {
            return interface_reset;
        }), __webpack_require__.d(__webpack_exports__, "setup", function() {
            return setup;
        });
    } ]);
});
//# sourceMappingURL=checkout.lib.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138).Buffer, __webpack_require__(46)))

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

/* @flow */
/* eslint import/no-commonjs: off */

// $FlowFixMe
module.exports = __webpack_require__(193);

module.exports.default = module.exports;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(46)))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(199);


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var generate = __webpack_require__(198);
var alphabet = __webpack_require__(30);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(30);
var random = __webpack_require__(201);
var format = __webpack_require__(192);

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + format(random, alphabet.get(), 1);
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(30);
var build = __webpack_require__(197);
var isValid = __webpack_require__(200);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(203) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(30);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(195);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 228 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = exports.validationMixin = exports.Vuelidate = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vval = __webpack_require__(245);

var _params = __webpack_require__(71);

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isPromise(object) {
  return (typeof object === 'object' || typeof object === 'function') && typeof object.then === 'function';
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');
  for (var i = 0; i < path.length; i++) {
    if (obj && typeof obj === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';
function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true, // pending
      v: false // value
    }
  });

  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });

  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return proxy[nested].$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    if (this.dirty) {
      return true;
    }
    if (this.nestedKeys.length === 0) {
      return false;
    }

    var proxy = this.proxy;
    return this.nestedKeys.every(function (key) {
      return proxy[key].$dirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $pending: function $pending() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (key) {
      return proxy[key].$pending;
    }) || this.ruleKeys.some(function (key) {
      return _this.getRef(key).$pending;
    });
  },
  $params: function $params() {
    var _this2 = this;

    var vals = this.validations;
    return _extends({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    }), buildFromKeys(this.ruleKeys, function (key) {
      return _this2.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];
    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();
        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }
        params = params.concat(childParams);
      } else {
        params.push({ path: [], name: key, params: this.$params[key] });
      }
    }
    return params;
  }
};

var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);

var _cachedComponent = null;
var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
      }
    },

    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};
        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });
        return refs;
      }
    }
  });

  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        model: null,
        parentModel: null,
        rootModel: null
      };
    },

    methods: {
      runRule: function runRule(parent) {
        // Avoid using this.parentModel to not get dependent on it.
        // Passed as an argument for workaround
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, this.model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;

        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;

        return { output: output, params: params };
      }
    },
    computed: {
      run: function run() {
        var _this3 = this;

        var parent = this.parentModel;
        var isArrayDependant = Array.isArray(parent) && parent.__ob__;

        if (isArrayDependant) {
          // force depend on the array
          var arrayDep = parent.__ob__.dep;
          arrayDep.depend();

          var target = arrayDep.constructor.target;

          if (!this._indirectWatcher) {
            var Watcher = target.constructor;
            this._indirectWatcher = new Watcher(this.rootModel, function () {
              return _this3.runRule(parent);
            }, null, { lazy: true });
          }

          // if the update cause is only the array update
          // and value stays the same, don't recalculate
          if (!this._indirectWatcher.dirty && this._lastModel === this.model) {
            this._indirectWatcher.depend();
            return target.value;
          }

          this._lastModel = this.model;
          this._indirectWatcher.evaluate();
          this._indirectWatcher.depend();
        }

        return this._indirectWatcher ? this._indirectWatcher.value : this.runRule(parent);
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;
        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }
        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;
        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }
        return false;
      }
    }
  });

  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        model: null,
        prop: null,
        parentModel: null,
        rootModel: null
      };
    },

    methods: _extends({}, validationMethods, {
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _extends({}, validationGetters, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this4 = this;

        return this.keys.filter(function (k) {
          return !_this4.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this5 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: false,
            get: function get() {
              return _this5.getRef(key).proxy;
            }
          };
        });

        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: false,
            get: function get() {
              return _this5[key];
            }
          };
        });

        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: false,
            get: function get() {
              return _this5[key];
            }
          };
        });

        return Object.defineProperties({}, _extends({}, keyDefs, getterDefs, methodDefs));
      },
      children: function children() {
        var _this6 = this;

        return [].concat(this.nestedKeys.map(function (key) {
          return renderNested(_this6, key);
        }), this.ruleKeys.map(function (key) {
          return renderRule(_this6, key);
        })).filter(Boolean);
      }
    })
  });

  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            // default to invalid
            return vm.validations[key]() || false;
          }
        };
      }
    }
  });

  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        return Object.keys(this.model);
      },
      tracker: function tracker() {
        var _this7 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return '' + getPath(_this7.rootModel, _this7.model[key], trackBy);
        } : function (x) {
          return '' + x;
        };
      },
      children: function children() {
        var _this8 = this;

        var def = this.validations;

        var validations = _extends({}, def);
        delete validations['$trackBy'];

        var usedTracks = {};

        return this.keys.map(function (key) {
          var track = _this8.tracker(key);
          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }
          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            parentModel: _this8.model,
            model: _this8.model[key],
            rootModel: _this8.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        parentModel: vm.parentModel,
        prop: key,
        model: vm.model,
        rootModel: vm.rootModel
      });
    }
    var validations = vm.validations[key];
    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        parentModel: null,
        prop: key,
        model: null,
        rootModel: root
      });
    }
    return (0, _vval.h)(Validation, key, {
      validations: validations,
      parentModel: vm.model,
      prop: key,
      model: vm.model[key],
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      parentModel: vm.parentModel,
      model: vm.model,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = { VBase: VBase, Validation: Validation };
  return _cachedComponent;
};

var _cachedVue = null;
function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;
  /* istanbul ignore next */
  while (Vue.super) {
    Vue = Vue.super;
  }_cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;

        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          parentModel: null,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;
    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }
    return {};
  },
  beforeCreate: function beforeCreate() {
    var _this9 = this;

    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    options.computed.$v = function () {
      return _this9._vuelidate.refs.$v.proxy;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();
      this._vuelidate = null;
    }
  }
};

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

exports.Vuelidate = Vuelidate;
exports.validationMixin = validationMixin;
exports.withParams = _params.withParams;
exports.default = Vuelidate;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'and' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = function (min, max) {
  return (0, _common.withParams)({ type: 'between', min: min, max: max }, function (value) {
    return !(0, _common.req)(value) || !/\s/.test(value) && +min <= +value && +max >= +value;
  });
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

exports.default = (0, _common.regex)('email', emailRegex);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.and = exports.or = exports.url = exports.sameAs = exports.requiredUnless = exports.requiredIf = exports.required = exports.minLength = exports.maxLength = exports.email = exports.between = exports.numeric = exports.alphaNum = exports.alpha = undefined;

var _alpha = __webpack_require__(230);

var _alpha2 = _interopRequireDefault(_alpha);

var _alphaNum = __webpack_require__(231);

var _alphaNum2 = _interopRequireDefault(_alphaNum);

var _numeric = __webpack_require__(238);

var _numeric2 = _interopRequireDefault(_numeric);

var _between = __webpack_require__(233);

var _between2 = _interopRequireDefault(_between);

var _email = __webpack_require__(234);

var _email2 = _interopRequireDefault(_email);

var _maxLength = __webpack_require__(236);

var _maxLength2 = _interopRequireDefault(_maxLength);

var _minLength = __webpack_require__(237);

var _minLength2 = _interopRequireDefault(_minLength);

var _required = __webpack_require__(240);

var _required2 = _interopRequireDefault(_required);

var _requiredIf = __webpack_require__(241);

var _requiredIf2 = _interopRequireDefault(_requiredIf);

var _requiredUnless = __webpack_require__(242);

var _requiredUnless2 = _interopRequireDefault(_requiredUnless);

var _sameAs = __webpack_require__(243);

var _sameAs2 = _interopRequireDefault(_sameAs);

var _url = __webpack_require__(244);

var _url2 = _interopRequireDefault(_url);

var _or = __webpack_require__(239);

var _or2 = _interopRequireDefault(_or);

var _and = __webpack_require__(232);

var _and2 = _interopRequireDefault(_and);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.alpha = _alpha2.default;
exports.alphaNum = _alphaNum2.default;
exports.numeric = _numeric2.default;
exports.between = _between2.default;
exports.email = _email2.default;
exports.maxLength = _maxLength2.default;
exports.minLength = _minLength2.default;
exports.required = _required2.default;
exports.requiredIf = _requiredIf2.default;
exports.requiredUnless = _requiredUnless2.default;
exports.sameAs = _sameAs2.default;
exports.url = _url2.default;
exports.or = _or2.default;
exports.and = _and2.default;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'maxLength', max: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'minLength', min: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.regex)('numeric', /^[0-9]*$/);

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'or' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredIf', prop: prop }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredUnless', prop: prop }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = function (equalTo) {
  return (0, _common.withParams)({ type: 'sameAs', eq: equalTo }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/;

exports.default = (0, _common.regex)('url', urlRegex);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchChildren = patchChildren;
exports.h = h;
// a minimial single-layer implementation
// of virtual-validation patching,
// based on Vue's snabbdom clone

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({ data: vval.args });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);
  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i = void 0,
      key = void 0;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }
  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx = void 0,
      idxInOld = void 0,
      elmToMove = void 0;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx]; // Vval has been moved left
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      // Vval moved right
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      // Vval moved left
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;
      if (isUndef(idxInOld)) {
        // New element
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];
        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          // same key but different element. treat as new element
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }
  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];
    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }
  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return { tag: tag, key: key, args: args };
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
var withParams =  false ? require('./withParamsBrowser').withParams : __webpack_require__(71).withParams;

exports.default = withParams;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Errors = __webpack_require__(72);

var _Errors2 = _interopRequireDefault(_Errors);

var _vuelidate = __webpack_require__(229);

var _messages = __webpack_require__(255);

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultConfig = {
    vuexAction: false,
    ajaxURL: false,
    ajaxMethod: 'POST',
    ajaxTimeout: 10000,
    validations: null,
    defaultMessages: _messages2.default,
    overrideMessages: {},
    validateOnInput: true,
    validateOnBlur: true,
    validateOnFocus: false,
    validateOnLoad: false,
    validateOnSubmit: true,
    touchOnBlur: false,
    touchOnFocus: false,
    inputDebounce: 200
};

var VUEX_FORM = 'VUEX';
var AJAX_FORM = 'AJAX';

var _cachedVue = null;
function getVue(rootVm) {
    if (_cachedVue) return _cachedVue;
    var Vue = rootVm.constructor;

    while (Vue.super) {
        Vue = Vue.super;
    }_cachedVue = Vue;
    return Vue;
}

var Form = function () {
    function Form(vm, data) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var apiHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        _classCallCheck(this, Form);

        var Vue = getVue(vm);

        this.errors = new _Errors2.default();
        this.$bus = new Vue();
        this._config = {};
        this._data = {};
        this._hasValidator = false;
        this._submitter = null;
        this._vuex = false;
        this._ajax = false;
        this._timers = {
            inputDebounce: 0
        };

        this.setConfig(config);
        this.setupData(data);
        this.setupSubmitter(vm, apiHandler);
        this.setupValidator(Vue);

        if (this._hasValidator && this._config.validateOnLoad) {
            this.$v.$touch();
            this.validate();
        }
    }

    _createClass(Form, [{
        key: "setConfig",
        value: function setConfig() {
            var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this._config = {};
            for (var option in defaultConfig) {
                if (defaultConfig.hasOwnProperty(option)) {
                    this._config[option] = typeof config[option] === 'undefined' ? defaultConfig[option] : config[option];
                }
            }
        }
    }, {
        key: "setupData",
        value: function setupData(data) {
            var _this = this;

            this._data = Object.assign({}, { _original: data }, data);

            var _loop = function _loop(field) {
                if (data.hasOwnProperty(field)) {
                    Object.defineProperty(_this, field, {
                        get: function get() {
                            return this._data[field];
                        },
                        set: function set(value) {
                            this._data[field] = value;
                        }
                    });
                }
            };

            for (var field in data) {
                _loop(field);
            }
        }
    }, {
        key: "setupSubmitter",
        value: function setupSubmitter(vm, apiHandler) {
            if (this._config.vuexAction === false && this._config.ajaxURL === false) {
                this._submitter = false;
                return;
            }
            this._submitter = this._config.vuexAction !== false ? VUEX_FORM : AJAX_FORM;

            if (this._submitter === VUEX_FORM) {
                this._vuex = vm.$store;
            } else {
                this._ajax = apiHandler;
            }
        }
    }, {
        key: "setupValidator",
        value: function setupValidator(Vue) {
            var _this2 = this;

            if (this._config.validations !== null) {
                var _validations = this._config.validations;
                this._validations = {};

                this._hasValidator = true;
                this._validator = new Vue({
                    mixins: [_vuelidate.validationMixin],
                    validations: function validations() {
                        return typeof _validations === 'function' ? _validations(this) : _validations;
                    },

                    data: function data() {
                        return _this2._data;
                    }
                });

                Object.defineProperty(this, '$v', {
                    get: function get() {
                        return _this2._validator.$v;
                    }
                });

                this.parseValidations(typeof _validations === 'function' ? _validations(this._validator) : _validations);
            }
        }
    }, {
        key: "parseValidations",
        value: function parseValidations(validations) {
            var previousPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            for (var field in validations) {
                if (validations.hasOwnProperty(field) && _typeof(validations[field]) === 'object') {
                    for (var possibleRule in validations[field]) {
                        if (validations[field].hasOwnProperty(possibleRule)) {
                            if (typeof validations[field][possibleRule] === 'function') {
                                var fieldMap = (previousPath !== null ? previousPath + '.' : '') + field;

                                if (this._validations.hasOwnProperty(fieldMap)) {
                                    this._validations[fieldMap].push(possibleRule);
                                } else {
                                    this._validations[fieldMap] = [possibleRule];
                                }
                            } else {
                                this.parseValidations(validations[field][possibleRule], (previousPath !== null ? previousPath + '.' : '') + field + '.' + possibleRule);
                            }
                        }
                    }
                }
            }
        }
    }, {
        key: "data",
        value: function data() {
            var data = {};
            for (var field in this._data._original) {
                data[field] = this._data[field];
            }

            return data;
        }
    }, {
        key: "reset",
        value: function reset() {
            for (var field in this._data._original) {
                if (this._data.hasOwnProperty(field)) {
                    if (_typeof(this._data[field]) === 'object') {
                        this.resetNestedData(this._data[field]);
                    } else {
                        this._data[field] = this._data._original[field];
                    }
                }
            }

            this.errors.clear();

            if (this.hasValidator()) {
                this.$v.$reset();
            }

            this.$bus.$emit('reset');
        }
    }, {
        key: "resetNestedData",
        value: function resetNestedData(dataObject) {
            for (var field in dataObject) {
                if (dataObject.hasOwnProperty(field)) {
                    if (_typeof(dataObject[field]) === 'object') {
                        this.resetNestedData(dataObject[field]);
                    } else {
                        dataObject[field] = this._data._original[field];
                    }
                }
            }
        }
    }, {
        key: "submit",
        value: function submit() {
            var _this3 = this;

            if (this._hasValidator && this._config.validateOnSubmit) {
                this.$v.$touch();

                var errors = this.validate();
                if (Object.keys(errors).length > 0) return Promise.reject(errors);
            }

            if (this._submitter === false) {
                return false;
            }

            return new Promise(function (resolve, reject) {
                return _this3._vuex.dispatch(_this3._config.vuexAction, _this3.data()).then(function (data) {
                    _this3.errors.clear();
                    resolve(data);
                }).catch(function (errors) {
                    _this3.errors.clear();
                    _this3.errors.record(errors);
                    _this3.$v.$touch();
                    _this3.$bus.$emit('validate');
                    reject(errors);
                });
            });
        }
    }, {
        key: "listen",
        value: function listen(event) {
            var _this4 = this;

            if ((typeof event === "undefined" ? "undefined" : _typeof(event)) !== 'object') return;

            var field = this.hasValidator(event.field) ? event.field.indexOf('.') !== -1 ? event.field.split('.').reduce(function (o, i) {
                return o[i];
            }, this.$v) : this.$v[event.field] : false;

            switch (event.type) {
                case 'input':
                    if (this.hasValidator(event.field)) {
                        field.$touch();
                        if (this._config.validateOnInput) {
                            clearTimeout(this._timers.inputDebounce);
                            this._timers.inputDebounce = setTimeout(function () {
                                return _this4.validate(event.field);
                            }, this._config.inputDebounce);
                        }
                    }
                    this.$bus.$emit('input', event);
                    break;
                case 'blur':
                    if (this.hasValidator(event.field)) {
                        if (this._config.touchOnBlur) field.$touch();
                        if (this._config.validateOnBlur) this.validate(event.field);
                    }
                    this.$bus.$emit('blur', event);
                    break;
                case 'focus':
                    if (this.hasValidator(event.field)) {
                        if (this._config.touchOnFocus) field.$touch();
                        if (this._config.validateOnFocus) this.validate(event.field);
                    }
                    this.$bus.$emit('focus', event);
                    break;
            }
        }
    }, {
        key: "hasValidator",
        value: function hasValidator() {
            var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return field !== null ? this._hasValidator && this._validations.hasOwnProperty(field) : this._hasValidator;
        }
    }, {
        key: "validate",
        value: function validate() {
            var targetField = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (!this._hasValidator || this.$v.$errors === false) return false;

            this.errors.clear(targetField);

            var validations = targetField !== null ? _defineProperty({}, targetField, targetField) : this._validations;

            var errors = {};
            for (var field in validations) {
                var validation = field.indexOf('.') !== -1 ? field.split('.').reduce(function (o, i) {
                    return o[i];
                }, this.$v) : this.$v[field];

                if ((typeof validation === "undefined" ? "undefined" : _typeof(validation)) === 'object' && validation.$error === true) {
                    var messages = [];
                    for (var rule in validation.$params) {
                        if (validation.hasOwnProperty(rule) && validation[rule] === false) {
                            var message = this._config.overrideMessages[field] && this._config.overrideMessages[field][rule] ? this._config.overrideMessages[field][rule] : this._config.defaultMessages[rule] ? this._config.defaultMessages[rule] : 'The :attribute field has an error';

                            var params = Object.assign({}, validation.$params[rule]);

                            if (params !== null && params.type) delete params.type;

                            var fieldName = field.indexOf('.') !== -1 ? field.split('.').reverse()[0] : field;
                            message = message.replace(":attribute", fieldName.replace(/_/g, ' '));

                            for (var param in params) {
                                if (params.hasOwnProperty(param)) {
                                    var replaceWith = JSON.parse(JSON.stringify(params[param]));
                                    if (param === 'array') {
                                        var lastEl = replaceWith[replaceWith.length - 1];
                                        replaceWith.splice(replaceWith.indexOf(lastEl), 1);
                                        replaceWith = replaceWith.join(', ') + ' or ' + lastEl;
                                    }
                                    message = message.replace(":" + param, replaceWith);
                                }
                            }

                            messages.push(message);
                        }
                    }

                    errors[field] = messages;
                }
            }

            this.errors.record(errors);

            this.$bus.$emit('validate');

            return errors;
        }
    }]);

    return Form;
}();

exports.default = Form;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bind: function bind(el, binding, value) {
        var form = binding.value;
        var field = binding.arg;
        var component = value.child;

        if (binding.modifiers) {
            for (var modifier in binding.modifiers) {
                field += '.' + modifier;
            }
        }
        component.value = form[field];
        component.localErrors = form.errors.get(field);

        component.$on('input', function (inputValue) {
            if (field.indexOf('.') !== -1) {
                console.log('still working on nested data for the directive');
            } else {
                component.$set(form, field, inputValue);
            }
        });
        component.$on('event', function (event) {
            form.listen(event);

            setTimeout(function () {
                component.localErrors = form.errors.get(field);
            }, event.type === 'input' ? form._config.inputDebounce + 50 : 0);
        });
        form.$bus.$on('validate', function () {
            component.localErrors = form.errors.get(field);
        });
        form.$bus.$on('reset', function () {
            component.value = form._data._original[field];
            component.localErrors = null;
            if (component.$refs.input) {
                component.$refs.input.value = form._data._original[field];
            }
        });
    },
    unbind: function unbind(el, binding, value) {
        value.child.$off('event');
        value.child.$off('input');
        binding.value.$bus.$off('reset');
        binding.value.$bus.$off('validate');
    }
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuexCheckbox = __webpack_require__(256);

var _vuexCheckbox2 = _interopRequireDefault(_vuexCheckbox);

var _vuexCheckbox3 = __webpack_require__(185);

var _vuexCheckbox4 = _interopRequireDefault(_vuexCheckbox3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'VuexCheckbox',
    template: _vuexCheckbox4.default,
    mixins: [(0, _vuexCheckbox2.default)()]
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuexRadio = __webpack_require__(257);

var _vuexRadio2 = _interopRequireDefault(_vuexRadio);

var _vuexRadio3 = __webpack_require__(186);

var _vuexRadio4 = _interopRequireDefault(_vuexRadio3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'VuexRadio',
    template: _vuexRadio4.default,
    mixins: [(0, _vuexRadio2.default)()]
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuexSelect = __webpack_require__(73);

var _vuexSelect2 = _interopRequireDefault(_vuexSelect);

var _vuexSelect3 = __webpack_require__(187);

var _vuexSelect4 = _interopRequireDefault(_vuexSelect3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'VuexSelect',
    template: _vuexSelect4.default,
    mixins: [(0, _vuexSelect2.default)()]
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuexText = __webpack_require__(74);

var _vuexText2 = _interopRequireDefault(_vuexText);

var _vuexText3 = __webpack_require__(188);

var _vuexText4 = _interopRequireDefault(_vuexText3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'VuexText',
    template: _vuexText4.default,
    mixins: [(0, _vuexText2.default)()]
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _caretPosition = __webpack_require__(254);

var _caretPosition2 = _interopRequireDefault(_caretPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Masker = function () {
    function Masker() {
        _classCallCheck(this, Masker);

        this.caretPosition = 0;
    }

    _createClass(Masker, [{
        key: 'readCaretPosition',
        value: function readCaretPosition(el) {
            this.caretPosition = _caretPosition2.default.get(el);
        }
    }, {
        key: 'updateCaretPosition',
        value: function updateCaretPosition(el, keyCode) {
            var _this = this;

            var movementOffset = keyCode !== 8 && keyCode !== 46 ? 1 : keyCode !== 8 ? 0 : -1;
            setTimeout(function () {
                _caretPosition2.default.set(el, _this.caretPosition + movementOffset);
            }, 0);
        }
    }, {
        key: 'applyMask',
        value: function applyMask(data, mask) {
            data = this.removeMask(data, mask);

            var text = '',
                i = void 0,
                x = void 0,
                currentMaskChar = void 0,
                currentDataChar = void 0;
            for (x = i = 0; x < data.length && i < mask.length; i++) {
                currentMaskChar = mask.charAt(i);
                currentDataChar = data.charAt(x);
                switch (currentMaskChar) {
                    case '#':
                        if (/\d/i.test(currentDataChar)) {
                            text += currentDataChar;
                        }
                        x++;
                        break;
                    case 'A':
                        if (/[a-z]/i.test(currentDataChar)) {
                            text += currentDataChar;
                        }
                        x++;
                        break;
                    case 'N':
                        if (/[a-z0-9]/i.test(currentDataChar)) {
                            text += currentDataChar;
                        }
                        x++;
                        break;
                    case 'X':
                        text += currentDataChar;
                        x++;
                        break;
                    default:
                        text += currentMaskChar;
                        if (this.caretPosition === i) this.caretPosition++;
                        break;
                }
            }

            return text;
        }
    }, {
        key: 'removeMask',
        value: function removeMask(data, mask) {
            var text = '',
                currentMaskChar = void 0,
                currentDataChar = void 0;
            for (var i = 0; i < mask.length; i++) {
                currentMaskChar = mask.charAt(i);
                currentDataChar = data.charAt(i);
                switch (currentMaskChar) {
                    case '#':
                        if (/\d/i.test(currentDataChar)) {
                            text += currentDataChar;
                        }
                        break;
                    case 'A':
                        if (/[a-z]/i.test(currentDataChar)) {
                            text += currentDataChar;
                        }
                        break;
                    case 'N':
                        if (/[a-z0-9]/i.test(currentDataChar)) {
                            text += currentDataChar;
                        }
                        break;
                    case 'X':
                        text += currentDataChar;
                        break;
                    default:
                        if (mask.indexOf(currentDataChar) < 0) {
                            text += currentDataChar;
                        }
                        break;
                }
            }

            return text;
        }
    }]);

    return Masker;
}();

exports.default = Masker;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var caretPosition = {
    get: function get(el) {
        var iCaretPos = 0;

        if (document.selection) {
            el.focus();

            var oSel = document.selection.createRange();

            oSel.moveStart('character', -el.value.length);

            iCaretPos = oSel.text.length;
        } else if (el.selectionStart || el.selectionStart === '0') {
                iCaretPos = el.selectionStart;
            }

        return parseInt(iCaretPos);
    },
    set: function set(el, pos) {
        if (el.createTextRange) {
            var range = el.createTextRange();
            range.move('character', pos);
            range.select();
        } else {
            if (el.selectionStart) {
                el.focus();
                el.setSelectionRange(pos, pos);
            } else {
                el.focus();
            }
        }
    }
};

module.exports = caretPosition;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    accepted: 'The :attribute must be accepted.',
    afterDate: 'The :attribute must be a date after :date.',
    afterDateOrEqual: 'The :attribute must be a date after or equal to :date.',
    alpha: 'The :attribute field can only consist of alphabetic characters.',
    alphaNum: 'The :attribute field can only consist of alphanumeric characters.',
    alphaDash: 'The :attribute field can only consist of letters, numbers, -, and _',
    beforeDate: 'The :attribute must be a date before :date.',
    beforeDateOrEqual: 'The :attribute must be a date before or equal to :date.',
    between: 'The :attribute field must be a number between :min and :max.',
    betweenLength: 'The :attribute field must be between :min and :max characters long.',
    differentFrom: 'The :attribute and :neq cannot match.',
    differentFromCased: 'The :attribute and :neq cannot match.',
    inArray: 'The :attribute field can only be :array.',
    ipAddress: 'The :attribute field must be a valid IP address.',
    ipv4: 'The :attribute field must be a valid IPv4 address.',
    ipv6: 'The :attribute field must be a valid IPv6 address.',
    notInArray: 'The :attribute field can not be :array.',
    email: 'The :attribute field must be a valid email address',
    maxLength: 'The :attribute field cannot be longer than :max characters.',
    minLength: 'The :attribute field must be at least :min characters long.',
    numeric: 'The :attribute field can only consist of numeric characters',
    required: 'The :attribute field is required.',
    requiredIf: 'The :attribute field is required.',
    url: 'The :attribute field must be a valid URL.',
    sameAs: 'The :attribute and :eq must match.'
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _merge = __webpack_require__(29);

var _merge2 = _interopRequireDefault(_merge);

var _vuexField = __webpack_require__(31);

var _vuexField2 = _interopRequireDefault(_vuexField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _merge2.default.recursive(true, _vuexField2.default, {
        props: {
            trueValue: { type: [Number, Boolean, String], default: true },
            falseValue: { type: [Number, Boolean, String], default: false }
        },
        methods: {
            handleCheckbox: function handleCheckbox(event) {
                var newEvent = this.createEvent(event, 'input');
                newEvent.target.value = event.target.checked ? this.trueValue : this.falseValue;
                this.inputEvent(newEvent);
            }
        }
    });
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _merge = __webpack_require__(29);

var _merge2 = _interopRequireDefault(_merge);

var _vuexField = __webpack_require__(31);

var _vuexField2 = _interopRequireDefault(_vuexField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _merge2.default.recursive(true, _vuexField2.default, {
        props: {
            options: { type: [String, Object, Array], default: function _default() {
                    return [];
                } },
            option_name: { type: [String], default: 'id' },
            option_value: { type: [String], default: 'id' }
        },
        methods: {
            handleRadio: function handleRadio(event) {
                this.emitEvent('input', this.createEvent(event, 'input'));
            }
        }
    });
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.withParams)({ type: 'accepted' }, function (value) {
    return value === true || parseInt(value) === 1 || String(value).toLowerCase() === 'yes' || String(value).toLowerCase() === 'on';
});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (date) {
    return (0, _common.withParams)({ type: 'date', date: date }, function (value) {
        if (!(0, _common.req)(value)) return true;
        var targetDate = new Date(date);
        var userDate = new Date(value);
        return userDate > targetDate;
    });
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (date) {
    return (0, _common.withParams)({ type: 'date', date: date }, function (value) {
        if (!(0, _common.req)(value)) return true;
        var targetDate = new Date(date);
        var userDate = new Date(value);
        userDate.setDate(userDate.getDate() + 1);
        return userDate >= targetDate;
    });
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.regex)('alphaDash', /^[a-zA-Z0-9_-]*$/);

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (date) {
    return (0, _common.withParams)({ type: 'date', date: date }, function (value) {
        if (!(0, _common.req)(value)) return true;
        var targetDate = new Date(date);
        var userDate = new Date(value);
        userDate.setDate(userDate.getDate() + 1);
        return userDate < targetDate;
    });
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (date) {
    return (0, _common.withParams)({ type: 'date', date: date }, function (value) {
        if (!(0, _common.req)(value)) return true;
        var targetDate = new Date(date);
        var userDate = new Date(value);
        return userDate <= targetDate;
    });
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (min, max) {
    return (0, _common.withParams)({ type: 'betweenLength', min: min, max: max }, function (value) {
        return (0, _common.req)(value) ? value.length ? value.length >= min && value.length <= max : false : true;
    });
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (notEqualTo) {
    return (0, _common.withParams)({ type: 'differentFrom', neq: notEqualTo }, function (value, parentVm) {
        if (!(0, _common.req)(value)) return true;
        var neqField = (0, _common.ref)(notEqualTo, this, parentVm);
        neqField = neqField.toLowerCase() ? neqField.toLowerCase() : neqField;
        var compare = value.toLowerCase() ? value.toLowerCase() : value;
        return compare !== neqField;
    });
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (notEqualTo) {
    return (0, _common.withParams)({ type: 'differentFromCased', neq: notEqualTo }, function (value, parentVm) {
        return value !== (0, _common.ref)(notEqualTo, this, parentVm);
    });
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (array) {
    return (0, _common.withParams)({ type: 'inArray', array: array }, function (value) {
        if (!(0, _common.req)(value)) return true;
        return array.indexOf(value) !== -1;
    });
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.url = exports.sameAs = exports.requiredUnless = exports.requiredIf = exports.required = exports.or = exports.numeric = exports.notInArray = exports.minLength = exports.maxLength = exports.ipv6 = exports.ipv4 = exports.ipAddress = exports.inArray = exports.email = exports.differentFromCased = exports.differentFrom = exports.betweenLength = exports.between = exports.beforeDateOrEqual = exports.beforeDate = exports.and = exports.alphaNum = exports.alphaDash = exports.alpha = exports.afterDateOrEqual = exports.afterDate = exports.accepted = undefined;

var _validators = __webpack_require__(235);

var _accepted = __webpack_require__(258);

var _accepted2 = _interopRequireDefault(_accepted);

var _afterDate = __webpack_require__(259);

var _afterDate2 = _interopRequireDefault(_afterDate);

var _afterDateOrEqual = __webpack_require__(260);

var _afterDateOrEqual2 = _interopRequireDefault(_afterDateOrEqual);

var _alphaDash = __webpack_require__(261);

var _alphaDash2 = _interopRequireDefault(_alphaDash);

var _beforeDate = __webpack_require__(262);

var _beforeDate2 = _interopRequireDefault(_beforeDate);

var _beforeDateOrEqual = __webpack_require__(263);

var _beforeDateOrEqual2 = _interopRequireDefault(_beforeDateOrEqual);

var _betweenLength = __webpack_require__(264);

var _betweenLength2 = _interopRequireDefault(_betweenLength);

var _differentFrom = __webpack_require__(265);

var _differentFrom2 = _interopRequireDefault(_differentFrom);

var _differentFromCased = __webpack_require__(266);

var _differentFromCased2 = _interopRequireDefault(_differentFromCased);

var _inArray = __webpack_require__(267);

var _inArray2 = _interopRequireDefault(_inArray);

var _ipAddress = __webpack_require__(269);

var _ipAddress2 = _interopRequireDefault(_ipAddress);

var _ipv = __webpack_require__(270);

var _ipv2 = _interopRequireDefault(_ipv);

var _ipv3 = __webpack_require__(271);

var _ipv4 = _interopRequireDefault(_ipv3);

var _notInArray = __webpack_require__(272);

var _notInArray2 = _interopRequireDefault(_notInArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.accepted = _accepted2.default;
exports.afterDate = _afterDate2.default;
exports.afterDateOrEqual = _afterDateOrEqual2.default;
exports.alpha = _validators.alpha;
exports.alphaDash = _alphaDash2.default;
exports.alphaNum = _validators.alphaNum;
exports.and = _validators.and;
exports.beforeDate = _beforeDate2.default;
exports.beforeDateOrEqual = _beforeDateOrEqual2.default;
exports.between = _validators.between;
exports.betweenLength = _betweenLength2.default;
exports.differentFrom = _differentFrom2.default;
exports.differentFromCased = _differentFromCased2.default;
exports.email = _validators.email;
exports.inArray = _inArray2.default;
exports.ipAddress = _ipAddress2.default;
exports.ipv4 = _ipv2.default;
exports.ipv6 = _ipv4.default;
exports.maxLength = _validators.maxLength;
exports.minLength = _validators.minLength;
exports.notInArray = _notInArray2.default;
exports.numeric = _validators.numeric;
exports.or = _validators.or;
exports.required = _validators.required;
exports.requiredIf = _validators.requiredIf;
exports.requiredUnless = _validators.requiredUnless;
exports.sameAs = _validators.sameAs;
exports.url = _validators.url;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.regex)('ipAddress', /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.regex)('ipv4', /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/);

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(0);

exports.default = (0, _common.regex)('ipv6', /^((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*::((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*|((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4})){7}$/);

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = __webpack_require__(0);

exports.default = function (array) {
    return (0, _common.withParams)({ type: 'inArray', array: array }, function (value) {
        if (!(0, _common.req)(value)) return true;
        return array.indexOf(value) === -1;
    });
};

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(228)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.04f394e79c8552f4a9f5.js